(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["hotel_destination"] = factory();
	else
		root["hotel_destination"] = factory();
})(this, function() {
return webpackJsonp_name_([8],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(785);


/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	     if (typeof Object.create !== 'function') {
	         // Fix for IE8 which does not contain Object.create() method. It is
	         // used heavily in widgets.
	         Object.create = function (o)  {
	             function F() { }
	             F.prototype = o;
	             return new F();
	         };
	     }
	     return Object;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["_"] = __webpack_require__(159);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(1),
	    __webpack_require__(3),
	    __webpack_require__(59),
	    __webpack_require__(2),
	    __webpack_require__(157),
	    __webpack_require__(156),
	    __webpack_require__(11)], __WEBPACK_AMD_DEFINE_RESULT__ = function($, _, Binding, Object, SinglePropertyBinding, MultiplePropertiesBinding, EventDispatcher) {
	        /**
	         * Base class for all Widgets
	         *
	         * @param element
	         * @param options
	         * @constructor
	         */
	        var Widget = function (element, options) {
	            EventDispatcher.apply(this, arguments);
	            
	            // Component Instance
	            if(element instanceof $) {
	                this.element = element;
	            } else {
	                this.element = $(element);
	            }
	            
	            /**
	             * Current options for this Widget
	             */
	            var defaultOptions = {
	                enabled: true
	            };
	            this.addOptions(defaultOptions, options);
	            
	            this.value = this._processData(this.element.data("initial-value"));
	            
	            /**
	             * Stack of previous values - for undo functionality
	             */
	            this._valueStack = [];
	
	            //Register events
	            this.registerEvent("change");
	            this.registerEvent("accept");
	            this.registerEvent("cancel");   
	            this.registerEvent("undo");
	            this.registerEvent("validationError");
	        };
	
	        Widget.prototype = {
	           /**
	             * The root element in the DOM
	             */
	            element: null,
	            
	            /**
	             * The internal value
	             * Should always be accessed through getValue, setValue
	             */
	            value: null,
	            
	            /**
	             * A value stack for old values (for history)
	             */
	            _valueStack: [],
	            
	            /**
	             * Internal variable to store configuration values
	             */
	            _options: {},
	            
	            /**
	             * Adds options to the widget. 
	             * The parameter options will overwrite the defaults
	             * @param {object} defaults
	             * @param {object|undefined} options
	             * @returns {undefined}
	             */
	            addOptions: function(defaults, options){
	                this._options = $.extend({}, this.getOptions(), defaults, options || {});
	            },
	            
	            /**
	             * Returns an object of all configuration options of the widget
	             * @returns {undefined|Object}
	             */
	            getOptions: function(){
	                return this._options;
	            },
	            
	            /**
	             * Gets or sets option
	             * @param name
	             * @param value optional
	             */
	            option: function (name, value) {
	                if (!_.isUndefined(value)) {
	                    this._options[name] = value;
	                }
	                return this._options[name];
	            },
	            
	            
	            /**
	             * Triggers event, both on element and if a handler was defined in options
	             * @param eventType
	             * @param data
	             */
	            _triggerEvent: function (eventType, data) {
	                this.element.trigger(eventType, data);
	                if (eventType in this._options && _.isFunction(this._options[eventType])) {
	                    this._options[eventType].apply(this.element, data);
	                }
	            },
	            /**
	             * Bind this Widget to a scope
	             * @param scope Scope
	             * @param binding binding
	             */
	            bindToScope: function (scope, binding) {
	                var self = this;
	                if (typeof binding === "string") {
	                    //shorthand for simple bindings is just scope parameter name
	                    binding = new SinglePropertyBinding(binding);
	                } else if ($.isPlainObject(binding)) {
	                    //shorthand for multiple property bindings is mapping
	                    binding = new MultiplePropertiesBinding(binding);
	                }
	                this._applyBinding(binding, scope);
	
	                var toScopeInProgress = false;
	                var fromScopeInProgress = false;
	                //Widget -> scope changes
	                this.element.on("change", function (e, source, value) {
	                    if(!$(e.target).is(self.element)) {
	                        return;
	                    }
	                    if(!fromScopeInProgress) {
	                        toScopeInProgress = true;
	                        self._applyBinding(binding, scope, value);
	                        toScopeInProgress = false;
	                    }
	                });
	                //scope -> Widget changes
	                scope.paramChange(function (event, name, value) {
	                    fromScopeInProgress = true;
	                    //need to check if scope param change is triggered by Widget -> scope changes and ignore if it is
	                    if (!toScopeInProgress && binding.isValueAffectedBy(name)) {
	                        self.setValue(binding.fromScope(event.scope.getParams()));
	                    }
	                    fromScopeInProgress = false;
	                });
	            },
	            /**
	             * Gets internal value
	             * @returns {*}
	             */
	            getValue: function () {
	                // Defensive copy, so that previous value can be safely modified and be set again -- AG.
	                if (_.isArray(this.value)) {
	                    return this.value.slice();
	                }
	                else if (_.isObject(this.value)){
	                    return $.extend(true, {}, this.value);
	                }
	                else {
	                    return this.value;
	                }
	            },
	            /**
	             * Sets internal value
	             * @param value
	             */
	            setValue: function (value) {
	                if ((_.isObject(value) && !_.isEqual(this.value, value)) || this.value !== value) {
	                    this._valueStack[this._valueStack.length] = this.value;
	                    this.value = value;
	                    this.setValueToUi();
	                    this._triggerEvent("change", [this, this.value]);
	                    this.dispatchEvent("change");
	                }
	            },
	            
	            /**
	             * Undoes the latest value change
	             */
	            undo: function () {
	                if (this._valueStack.length) {
	                    this.value = this._valueStack.pop();
	                    this.setValueToUi();
	                }
	                this.dispatchEvent("undo");
	            },
	            /**
	             * Applies value from UI elements
	             */
	            accept: function () {
	                this.setValue(this.getValueFromUi());
	                this.dispatchEvent("accept");
	            },
	            /**
	             * Cancels editing of the control - restores UI to the state that represents current control value
	             */
	            cancel: function () {
	                this.setValueToUi();
	                this.dispatchEvent("cancel");
	            },
	            /**
	             * Updates UI elements with the currently selected value
	             */
	            setValueToUi: function () {
	                //abstract, should be implemented in descendants
	                throw "not implemented";
	            },
	            /**
	             * Parses values from UI elements into internal value representation
	             */
	            getValueFromUi: function () {
	                //abstract, should be implemented in descendants
	                throw "not implemented";
	            },
	            
	            /**
	             * Return formatted value
	             */
	            formatValue: function () {
	                return null;
	            },
	
	            /**
	             * Validates the data in the widget.
	             * Displaying error messages should be triggered here.
	             *
	             * @return boolean
	             */
	            isValid: function() {
	                return true;
	            },
	
	            /**
	             * Allow sub classes to precise data from initial structure if necessary
	             * as well as to validate initial data.
	             * Usually comes from attribute data-initial-value of DOM-Element
	             */
	            _processData: function (data) {
	                return data;
	            },
	            _applyBinding: function(binding, scope, value) {
	                // fyi: this.getValue() does not use DOM.
	                var val = _.isUndefined(value) ? this.getValue() : value;
	                if (!_.isUndefined(val)) {
	                    scope.setMultipleParams(binding.toScope(val));
	                }
	            },
	            init: function(scope) {
	
	            }
	        };
	        
	        //Add mixins
	        Widget.prototype = $.extend(Object.create(Widget.prototype), Object.create(EventDispatcher.prototype));
	
	        return Widget;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(12);
	var cls = __webpack_require__(43);
	var defaultSettings = __webpack_require__(201);
	var dom = __webpack_require__(24);
	var EventManager = __webpack_require__(198);
	var guid = __webpack_require__(199);
	
	var instances = {};
	
	function Instance(element) {
	  var i = this;
	
	  i.settings = _.clone(defaultSettings);
	  i.containerWidth = null;
	  i.containerHeight = null;
	  i.contentWidth = null;
	  i.contentHeight = null;
	
	  i.isRtl = dom.css(element, 'direction') === "rtl";
	  i.isNegativeScroll = (function () {
	    var originalScrollLeft = element.scrollLeft;
	    var result = null;
	    element.scrollLeft = -1;
	    result = element.scrollLeft < 0;
	    element.scrollLeft = originalScrollLeft;
	    return result;
	  })();
	  i.negativeScrollAdjustment = i.isNegativeScroll ? element.scrollWidth - element.clientWidth : 0;
	  i.event = new EventManager();
	  i.ownerDocument = element.ownerDocument || document;
	
	  function focus() {
	    cls.add(element, 'ps-focus');
	  }
	
	  function blur() {
	    cls.remove(element, 'ps-focus');
	  }
	
	  i.scrollbarXRail = dom.appendTo(dom.e('div', 'ps-scrollbar-x-rail'), element);
	  i.scrollbarX = dom.appendTo(dom.e('div', 'ps-scrollbar-x'), i.scrollbarXRail);
	  i.scrollbarX.setAttribute('tabindex', 0);
	  i.event.bind(i.scrollbarX, 'focus', focus);
	  i.event.bind(i.scrollbarX, 'blur', blur);
	  i.scrollbarXActive = null;
	  i.scrollbarXWidth = null;
	  i.scrollbarXLeft = null;
	  i.scrollbarXBottom = _.toInt(dom.css(i.scrollbarXRail, 'bottom'));
	  i.isScrollbarXUsingBottom = i.scrollbarXBottom === i.scrollbarXBottom; // !isNaN
	  i.scrollbarXTop = i.isScrollbarXUsingBottom ? null : _.toInt(dom.css(i.scrollbarXRail, 'top'));
	  i.railBorderXWidth = _.toInt(dom.css(i.scrollbarXRail, 'borderLeftWidth')) + _.toInt(dom.css(i.scrollbarXRail, 'borderRightWidth'));
	  // Set rail to display:block to calculate margins
	  dom.css(i.scrollbarXRail, 'display', 'block');
	  i.railXMarginWidth = _.toInt(dom.css(i.scrollbarXRail, 'marginLeft')) + _.toInt(dom.css(i.scrollbarXRail, 'marginRight'));
	  dom.css(i.scrollbarXRail, 'display', '');
	  i.railXWidth = null;
	  i.railXRatio = null;
	
	  i.scrollbarYRail = dom.appendTo(dom.e('div', 'ps-scrollbar-y-rail'), element);
	  i.scrollbarY = dom.appendTo(dom.e('div', 'ps-scrollbar-y'), i.scrollbarYRail);
	  i.scrollbarY.setAttribute('tabindex', 0);
	  i.event.bind(i.scrollbarY, 'focus', focus);
	  i.event.bind(i.scrollbarY, 'blur', blur);
	  i.scrollbarYActive = null;
	  i.scrollbarYHeight = null;
	  i.scrollbarYTop = null;
	  i.scrollbarYRight = _.toInt(dom.css(i.scrollbarYRail, 'right'));
	  i.isScrollbarYUsingRight = i.scrollbarYRight === i.scrollbarYRight; // !isNaN
	  i.scrollbarYLeft = i.isScrollbarYUsingRight ? null : _.toInt(dom.css(i.scrollbarYRail, 'left'));
	  i.scrollbarYOuterWidth = i.isRtl ? _.outerWidth(i.scrollbarY) : null;
	  i.railBorderYWidth = _.toInt(dom.css(i.scrollbarYRail, 'borderTopWidth')) + _.toInt(dom.css(i.scrollbarYRail, 'borderBottomWidth'));
	  dom.css(i.scrollbarYRail, 'display', 'block');
	  i.railYMarginHeight = _.toInt(dom.css(i.scrollbarYRail, 'marginTop')) + _.toInt(dom.css(i.scrollbarYRail, 'marginBottom'));
	  dom.css(i.scrollbarYRail, 'display', '');
	  i.railYHeight = null;
	  i.railYRatio = null;
	}
	
	function getId(element) {
	  return element.getAttribute('data-ps-id');
	}
	
	function setId(element, id) {
	  element.setAttribute('data-ps-id', id);
	}
	
	function removeId(element) {
	  element.removeAttribute('data-ps-id');
	}
	
	exports.add = function (element) {
	  var newId = guid();
	  setId(element, newId);
	  instances[newId] = new Instance(element);
	  return instances[newId];
	};
	
	exports.remove = function (element) {
	  delete instances[getId(element)];
	  removeId(element);
	};
	
	exports.get = function (element) {
	  return instances[getId(element)];
	};


/***/ }),
/* 6 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(46)('wks');
	var uid = __webpack_require__(27);
	var Symbol = __webpack_require__(6).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * Created by ivo on 22.05.14.
	 *
	 * Mixin to add options to a component
	 *
	 */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(1),
	    __webpack_require__(3)
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function($, _) {
	        var OptionsMixin = {
	            /**
	             * Internal variable to store configuration values
	             */
	            _options: {},
	
	            /**
	             * Adds options to the widget.
	             * The parameter options will overwrite the defaults
	             * @param {object} defaults
	             * @param {object|undefined} options
	             * @returns {undefined}
	             */
	            addOptions: function(defaults, options){
	                this._options = $.extend({}, this.getOptions(), defaults, options || {});
	            },
	
	            /**
	             * Returns an object of all configuration options of the widget
	             * @returns {undefined|Object}
	             */
	            getOptions: function(){
	                return this._options;
	            },
	
	            /**
	             * Gets or sets option
	             * @param name
	             * @param value optional
	             */
	            option: function (name, value) {
	                if (!_.isUndefined(value)) {
	                    this._options[name] = value;
	                }
	                return this._options[name];
	            }
	        };
	
	        return OptionsMixin;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 *
	 * Event dispatcher base class
	 *
	 * Usage:
	 * 1. Create class that inherits from EventDispatcher
	 *
	 * 2. Register all events from inside the component:
	 *
	 *      this.registerEvent('change');
	 *
	 * 3. Attach listeners from outside the component
	 *
	 *      object.on('change', function(){
	 *          //Callback functionality goes here
	 *      });
	 *
	 * 4. Dispatch events from inside the component
	 *
	 *      this.dispatchEvent('change', [args]);
	 *
	 * 5. To remove an event listener:
	 *
	 *      this.off('change', callbackFunction);
	 *
	 * @returns object EventDispatcher
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(1),
	    __webpack_require__(2)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Object) {
	        var Event = function (name) {
	            this.name = name;
	            this.callbacks = [];
	        };
	
	        Event.prototype.registerCallback = function (callback) {
	            this.callbacks.push(callback);
	        };
	
	        var EventDispatcher = function () {
	            /**
	             * Internal store of all registered events
	             */
	            this._events = [];
	        };
	
	        EventDispatcher.prototype = $.extend({}, {
	            /**
	             * Register an event on the object to be able to listen to it and
	             * dispatch it
	             *
	             * @param {type} eventName
	             * @returns {undefined}
	             */
	            registerEvent: function (eventName) {
	                this._events[eventName] = new Event(eventName);
	            },
	
	            /**
	             * Dispatch an event that has been previously registered on the object
	             *
	             * @param {String} eventName
	             * @param {*} eventArgs Any number of additional arguments to be passed to the callback function
	             * @returns {undefined}
	             */
	            dispatchEvent: function (eventName) {
	                var args = Array.prototype.slice.call(arguments, 1);
	                var self = this;
	                $.each(this._events[eventName].callbacks, function (index, callback) {
	                    callback.apply(self, args);
	                });
	            },
	
	            /**
	             * Add an event listener to the object with a callback function
	             * @param {String} eventName
	             * @param {Function} callback
	             * @returns {undefined}
	             */
	            on: function (eventName, callback) {
	                this._events[eventName].registerCallback(callback);
	            },
	
	            /**
	             * Removes the given event listener on the object
	             *
	             * @param {String} eventName
	             * @param {Function} callback
	             */
	            off: function(eventName, callback) {
	                var self = this;
	                $.each(this._events[eventName].callbacks, function(index, activeCallback){
	                    if (callback === activeCallback){
	                        self._events[eventName].callbacks.splice(index, 1);
	                    }
	                });
	            }
	        });
	
	        return EventDispatcher;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var cls = __webpack_require__(43);
	var dom = __webpack_require__(24);
	
	var toInt = exports.toInt = function (x) {
	  return parseInt(x, 10) || 0;
	};
	
	var clone = exports.clone = function (obj) {
	  if (!obj) {
	    return null;
	  } else if (obj.constructor === Array) {
	    return obj.map(clone);
	  } else if (typeof obj === 'object') {
	    var result = {};
	    for (var key in obj) {
	      result[key] = clone(obj[key]);
	    }
	    return result;
	  } else {
	    return obj;
	  }
	};
	
	exports.extend = function (original, source) {
	  var result = clone(original);
	  for (var key in source) {
	    result[key] = clone(source[key]);
	  }
	  return result;
	};
	
	exports.isEditable = function (el) {
	  return dom.matches(el, "input,[contenteditable]") ||
	         dom.matches(el, "select,[contenteditable]") ||
	         dom.matches(el, "textarea,[contenteditable]") ||
	         dom.matches(el, "button,[contenteditable]");
	};
	
	exports.removePsClasses = function (element) {
	  var clsList = cls.list(element);
	  for (var i = 0; i < clsList.length; i++) {
	    var className = clsList[i];
	    if (className.indexOf('ps-') === 0) {
	      cls.remove(element, className);
	    }
	  }
	};
	
	exports.outerWidth = function (element) {
	  return toInt(dom.css(element, 'width')) +
	         toInt(dom.css(element, 'paddingLeft')) +
	         toInt(dom.css(element, 'paddingRight')) +
	         toInt(dom.css(element, 'borderLeftWidth')) +
	         toInt(dom.css(element, 'borderRightWidth'));
	};
	
	exports.startScrolling = function (element, axis) {
	  cls.add(element, 'ps-in-scrolling');
	  if (typeof axis !== 'undefined') {
	    cls.add(element, 'ps-' + axis);
	  } else {
	    cls.add(element, 'ps-x');
	    cls.add(element, 'ps-y');
	  }
	};
	
	exports.stopScrolling = function (element, axis) {
	  cls.remove(element, 'ps-in-scrolling');
	  if (typeof axis !== 'undefined') {
	    cls.remove(element, 'ps-' + axis);
	  } else {
	    cls.remove(element, 'ps-x');
	    cls.remove(element, 'ps-y');
	  }
	};
	
	exports.env = {
	  isWebKit: 'WebkitAppearance' in document.documentElement.style,
	  supportsTouch: (('ontouchstart' in window) || window.DocumentTouch && document instanceof window.DocumentTouch),
	  supportsIePointer: window.navigator.msMaxTouchPoints !== null
	};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(12);
	var cls = __webpack_require__(43);
	var dom = __webpack_require__(24);
	var instances = __webpack_require__(5);
	var updateScroll = __webpack_require__(16);
	
	function getThumbSize(i, thumbSize) {
	  if (i.settings.minScrollbarLength) {
	    thumbSize = Math.max(thumbSize, i.settings.minScrollbarLength);
	  }
	  if (i.settings.maxScrollbarLength) {
	    thumbSize = Math.min(thumbSize, i.settings.maxScrollbarLength);
	  }
	  return thumbSize;
	}
	
	function updateCss(element, i) {
	  var xRailOffset = {width: i.railXWidth};
	  if (i.isRtl) {
	    xRailOffset.left = i.negativeScrollAdjustment + element.scrollLeft + i.containerWidth - i.contentWidth;
	  } else {
	    xRailOffset.left = element.scrollLeft;
	  }
	  if (i.isScrollbarXUsingBottom) {
	    xRailOffset.bottom = i.scrollbarXBottom - element.scrollTop;
	  } else {
	    xRailOffset.top = i.scrollbarXTop + element.scrollTop;
	  }
	  dom.css(i.scrollbarXRail, xRailOffset);
	
	  var yRailOffset = {top: element.scrollTop, height: i.railYHeight};
	  if (i.isScrollbarYUsingRight) {
	    if (i.isRtl) {
	      yRailOffset.right = i.contentWidth - (i.negativeScrollAdjustment + element.scrollLeft) - i.scrollbarYRight - i.scrollbarYOuterWidth;
	    } else {
	      yRailOffset.right = i.scrollbarYRight - element.scrollLeft;
	    }
	  } else {
	    if (i.isRtl) {
	      yRailOffset.left = i.negativeScrollAdjustment + element.scrollLeft + i.containerWidth * 2 - i.contentWidth - i.scrollbarYLeft - i.scrollbarYOuterWidth;
	    } else {
	      yRailOffset.left = i.scrollbarYLeft + element.scrollLeft;
	    }
	  }
	  dom.css(i.scrollbarYRail, yRailOffset);
	
	  dom.css(i.scrollbarX, {left: i.scrollbarXLeft, width: i.scrollbarXWidth - i.railBorderXWidth});
	  dom.css(i.scrollbarY, {top: i.scrollbarYTop, height: i.scrollbarYHeight - i.railBorderYWidth});
	}
	
	module.exports = function (element) {
	  var i = instances.get(element);
	
	  i.containerWidth = element.clientWidth;
	  i.containerHeight = element.clientHeight;
	  i.contentWidth = element.scrollWidth;
	  i.contentHeight = element.scrollHeight;
	
	  var existingRails;
	  if (!element.contains(i.scrollbarXRail)) {
	    existingRails = dom.queryChildren(element, '.ps-scrollbar-x-rail');
	    if (existingRails.length > 0) {
	      existingRails.forEach(function (rail) {
	        dom.remove(rail);
	      });
	    }
	    dom.appendTo(i.scrollbarXRail, element);
	  }
	  if (!element.contains(i.scrollbarYRail)) {
	    existingRails = dom.queryChildren(element, '.ps-scrollbar-y-rail');
	    if (existingRails.length > 0) {
	      existingRails.forEach(function (rail) {
	        dom.remove(rail);
	      });
	    }
	    dom.appendTo(i.scrollbarYRail, element);
	  }
	
	  if (!i.settings.suppressScrollX && i.containerWidth + i.settings.scrollXMarginOffset < i.contentWidth) {
	    i.scrollbarXActive = true;
	    i.railXWidth = i.containerWidth - i.railXMarginWidth;
	    i.railXRatio = i.containerWidth / i.railXWidth;
	    i.scrollbarXWidth = getThumbSize(i, _.toInt(i.railXWidth * i.containerWidth / i.contentWidth));
	    i.scrollbarXLeft = _.toInt((i.negativeScrollAdjustment + element.scrollLeft) * (i.railXWidth - i.scrollbarXWidth) / (i.contentWidth - i.containerWidth));
	  } else {
	    i.scrollbarXActive = false;
	  }
	
	  if (!i.settings.suppressScrollY && i.containerHeight + i.settings.scrollYMarginOffset < i.contentHeight) {
	    i.scrollbarYActive = true;
	    i.railYHeight = i.containerHeight - i.railYMarginHeight;
	    i.railYRatio = i.containerHeight / i.railYHeight;
	    i.scrollbarYHeight = getThumbSize(i, _.toInt(i.railYHeight * i.containerHeight / i.contentHeight));
	    i.scrollbarYTop = _.toInt(element.scrollTop * (i.railYHeight - i.scrollbarYHeight) / (i.contentHeight - i.containerHeight));
	  } else {
	    i.scrollbarYActive = false;
	  }
	
	  if (i.scrollbarXLeft >= i.railXWidth - i.scrollbarXWidth) {
	    i.scrollbarXLeft = i.railXWidth - i.scrollbarXWidth;
	  }
	  if (i.scrollbarYTop >= i.railYHeight - i.scrollbarYHeight) {
	    i.scrollbarYTop = i.railYHeight - i.scrollbarYHeight;
	  }
	
	  updateCss(element, i);
	
	  if (i.scrollbarXActive) {
	    cls.add(element, 'ps-active-x');
	  } else {
	    cls.remove(element, 'ps-active-x');
	    i.scrollbarXWidth = 0;
	    i.scrollbarXLeft = 0;
	    updateScroll(element, 'left', 0);
	  }
	  if (i.scrollbarYActive) {
	    cls.add(element, 'ps-active-y');
	  } else {
	    cls.remove(element, 'ps-active-y');
	    i.scrollbarYHeight = 0;
	    i.scrollbarYTop = 0;
	    updateScroll(element, 'top', 0);
	  }
	};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function($) {
	        var fallbackLocale = "de";
	
	        var Url = function (href) {
	            if (href === undefined) {
	                href = window.location.href;
	            }
	            
	            // Do not use prototype's objects, they're copyed by reference
	            // (a shallow copy) -- AG.
	            this.query = { };
	            this.hash = { };
	
	            var indexOfProtocol = href.indexOf("://");
	            if (indexOfProtocol >= 0) {
	                this.protocol = href.substring(0, indexOfProtocol);
	                href = href.substring(indexOfProtocol + 3);
	                
	                var indexOfSlash = href.indexOf("/");
	                this.domain = href.substring(0, indexOfSlash);
	                href = href.substring(indexOfSlash);
	            }
	            
	            var indexOfHash = href.indexOf("#");
	            var indexOfQuestion = href.indexOf("?");
	            
	            if (indexOfHash >= 0 && indexOfQuestion >= 0 && indexOfHash < indexOfQuestion) {
	                throw new Error("# sign should be somewhere after ? in a valid URL.");
	            }
	            
	            if (indexOfHash >= 0) {
	                //this.hash = Url.parseQuery(href.substring(indexOfHash + 1));
	                this.hash = href.substring(indexOfHash + 1);
	                href = href.substring(0, indexOfHash);
	            }
	            if (indexOfQuestion >= 0) {
	                this.query = Url.parseQuery(href.substring(indexOfQuestion + 1));
	                href = href.substring(0, indexOfQuestion);
	            }
	
	            this.path = href;
	        };
	        
	        Url.decode = function (encoded) {
	            return decodeURIComponent(encoded.replace(/\+/g, "%20"));
	        };
	        Url.encode = function (decoded) {
	            return encodeURIComponent(decoded.replace(/%20/g, "+"));
	        };
	        
	        Url.parseQuery = function (queryString) {
	            var items = queryString.split("&");
	            
	            var result = { };
	            if (queryString.length > 0) {
	                // This condition is needed for handling URLs like http://abc.com#
	                // Notice an empty hash at the end -- AG.
	                for (var i = 0; i < items.length; i++) {
	                    var pair = items[i].split("=");
	                    var key = Url.decode(pair[0]);
	                    var value = '';
	                    if(pair.length >= 2) {
	                        value = Url.decode(pair[1]);
	                    }
	                    result[key] = value;
	                }
	            }
	            return result;
	        };
	        
	        Url.prototype = {
	            protocol: null,
	            domain: null,
	            path: null,
	            query: { },
	            hash: { },
	            getLocale: function () {
	                // Get global locale (Recommended way)
	                // You need to define var locale in HTML document
	                if (typeof locale !== 'undefined') {
	                    return locale;
	                }
	
	                throw new Error('Locale is not defined!');
	                // DEPRECATED: Determine locale from URL
	                // var match;
	                // return (match = this.path.match(/\/{1}([a-z]{2}(_[a-z]{2})?)\//)) && match[1] || fallbackLocale;
	            },
	            setLocale: function (locale) {
	                if (typeof locale == "string" && locale.length == 2) {
	                    this.path = this.path.replace(/(.+\/{1})([a-z]{2})(\/.+)/, "$1" + locale + "$3");
	                } else {
	                    throw new Error("Locale is malformed. String {2} is expected.");
	                }
	            },
	            getCurrency: function () {
	                return this.query.currency;
	            },
	            setCurrency: function (value) {
	                if (value != null) {
	                    this.query.currency = value;
	                } else {
	                    delete this.query.currency;
	                }
	            },
	            withoutDomain: function () {
	                var result = $.extend(true, {}, this);
	                result.protocol = null;
	                result.domain = null;
	                
	                return result;
	            },
	            getQuery: function() {
	                if (!$.isEmptyObject(this.query)) {
	                    return "?" + $.param(this.query);
	                } else {
	                    return "";
	                }
	            },
	            getHash: function() {
	                if (!$.isEmptyObject(this.hash)) {
	                    return "#" + $.param(this.hash);
	                } else {
	                    return "";
	                }
	            },
	            toString: function () {
	                var result = "";
	                if (this.protocol !== null) {
	                    result += this.protocol + "://";
	                }
	                if (this.domain !== null) {
	                    result += this.domain;
	                }
	                if (this.path != null) {
	                    result += this.path;
	                }
	                result += this.getQuery();
	                result += this.getHash();
	                
	                return result;
	            }
	        };
	        
	        return Url;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(20);
	var createDesc = __webpack_require__(36);
	module.exports = __webpack_require__(18) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var instances = __webpack_require__(5);
	
	var lastTop;
	var lastLeft;
	
	var createDOMEvent = function (name) {
	  var event = document.createEvent("Event");
	  event.initEvent(name, true, true);
	  return event;
	};
	
	module.exports = function (element, axis, value) {
	  if (typeof element === 'undefined') {
	    throw 'You must provide an element to the update-scroll function';
	  }
	
	  if (typeof axis === 'undefined') {
	    throw 'You must provide an axis to the update-scroll function';
	  }
	
	  if (typeof value === 'undefined') {
	    throw 'You must provide a value to the update-scroll function';
	  }
	
	  if (axis === 'top' && value <= 0) {
	    element.scrollTop = value = 0; // don't allow negative scroll
	    element.dispatchEvent(createDOMEvent('ps-y-reach-start'));
	  }
	
	  if (axis === 'left' && value <= 0) {
	    element.scrollLeft = value = 0; // don't allow negative scroll
	    element.dispatchEvent(createDOMEvent('ps-x-reach-start'));
	  }
	
	  var i = instances.get(element);
	
	  if (axis === 'top' && value >= i.contentHeight - i.containerHeight) {
	    // don't allow scroll past container
	    value = i.contentHeight - i.containerHeight;
	    if (value - element.scrollTop <= 1) {
	      // mitigates rounding errors on non-subpixel scroll values
	      value = element.scrollTop;
	    } else {
	      element.scrollTop = value;
	    }
	    element.dispatchEvent(createDOMEvent('ps-y-reach-end'));
	  }
	
	  if (axis === 'left' && value >= i.contentWidth - i.containerWidth) {
	    // don't allow scroll past container
	    value = i.contentWidth - i.containerWidth;
	    if (value - element.scrollLeft <= 1) {
	      // mitigates rounding errors on non-subpixel scroll values
	      value = element.scrollLeft;
	    } else {
	      element.scrollLeft = value;
	    }
	    element.dispatchEvent(createDOMEvent('ps-x-reach-end'));
	  }
	
	  if (!lastTop) {
	    lastTop = element.scrollTop;
	  }
	
	  if (!lastLeft) {
	    lastLeft = element.scrollLeft;
	  }
	
	  if (axis === 'top' && value < lastTop) {
	    element.dispatchEvent(createDOMEvent('ps-scroll-up'));
	  }
	
	  if (axis === 'top' && value > lastTop) {
	    element.dispatchEvent(createDOMEvent('ps-scroll-down'));
	  }
	
	  if (axis === 'left' && value < lastLeft) {
	    element.dispatchEvent(createDOMEvent('ps-scroll-left'));
	  }
	
	  if (axis === 'left' && value > lastLeft) {
	    element.dispatchEvent(createDOMEvent('ps-scroll-right'));
	  }
	
	  if (axis === 'top') {
	    element.scrollTop = lastTop = value;
	    element.dispatchEvent(createDOMEvent('ps-scroll-y'));
	  }
	
	  if (axis === 'left') {
	    element.scrollLeft = lastLeft = value;
	    element.dispatchEvent(createDOMEvent('ps-scroll-x'));
	  }
	
	};


/***/ }),
/* 17 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.5.3' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(32)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 19 */,
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(31);
	var IE8_DOM_DEFINE = __webpack_require__(74);
	var toPrimitive = __webpack_require__(51);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(18) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(99);
	var defined = __webpack_require__(45);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports) {

	'use strict';
	
	var DOM = {};
	
	DOM.e = function (tagName, className) {
	  var element = document.createElement(tagName);
	  element.className = className;
	  return element;
	};
	
	DOM.appendTo = function (child, parent) {
	  parent.appendChild(child);
	  return child;
	};
	
	function cssGet(element, styleName) {
	  return window.getComputedStyle(element)[styleName];
	}
	
	function cssSet(element, styleName, styleValue) {
	  if (typeof styleValue === 'number') {
	    styleValue = styleValue.toString() + 'px';
	  }
	  element.style[styleName] = styleValue;
	  return element;
	}
	
	function cssMultiSet(element, obj) {
	  for (var key in obj) {
	    var val = obj[key];
	    if (typeof val === 'number') {
	      val = val.toString() + 'px';
	    }
	    element.style[key] = val;
	  }
	  return element;
	}
	
	DOM.css = function (element, styleNameOrObject, styleValue) {
	  if (typeof styleNameOrObject === 'object') {
	    // multiple set with object
	    return cssMultiSet(element, styleNameOrObject);
	  } else {
	    if (typeof styleValue === 'undefined') {
	      return cssGet(element, styleNameOrObject);
	    } else {
	      return cssSet(element, styleNameOrObject, styleValue);
	    }
	  }
	};
	
	DOM.matches = function (element, query) {
	  if (typeof element.matches !== 'undefined') {
	    return element.matches(query);
	  } else {
	    if (typeof element.matchesSelector !== 'undefined') {
	      return element.matchesSelector(query);
	    } else if (typeof element.webkitMatchesSelector !== 'undefined') {
	      return element.webkitMatchesSelector(query);
	    } else if (typeof element.mozMatchesSelector !== 'undefined') {
	      return element.mozMatchesSelector(query);
	    } else if (typeof element.msMatchesSelector !== 'undefined') {
	      return element.msMatchesSelector(query);
	    }
	  }
	};
	
	DOM.remove = function (element) {
	  if (typeof element.remove !== 'undefined') {
	    element.remove();
	  } else {
	    if (element.parentNode) {
	      element.parentNode.removeChild(element);
	    }
	  }
	};
	
	DOM.queryChildren = function (element, selector) {
	  return Array.prototype.filter.call(element.childNodes, function (child) {
	    return DOM.matches(child, selector);
	  });
	};
	
	module.exports = DOM;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(2), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Object, OptionsMixin) {
	
	    function GtmBase(options) {
	        this.addOptions(options);
	        this.trackPage();
	    }
	
	    GtmBase.prototype = $.extend(Object.create(OptionsMixin), /** @lends GtmBase.prototype */{
	        trackData: function trackData(data) {
	            data = $.extend({
	                pageType: this.option('pageType'),
	                country: this.option('country')
	            }, data);
	
	            window.dataLayer.push(data);
	        },
	        trackEvent: function trackEvent(data) {
	            window.dataLayer.push(data);
	        },
	        /**
	         * @abstract
	         */
	        trackPage: function trackPage() {}
	    });
	
	    return GtmBase;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 27 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(6);
	var hide = __webpack_require__(15);
	var has = __webpack_require__(10);
	var SRC = __webpack_require__(27)('src');
	var TO_STRING = 'toString';
	var $toString = Function[TO_STRING];
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(17).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ }),
/* 29 */,
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*globals Exception, Utils */
	var Utils = __webpack_require__(67);
	var Exception = __webpack_require__(38)["default"];
	
	var VERSION = "1.1.0";
	exports.VERSION = VERSION;var COMPILER_REVISION = 4;
	exports.COMPILER_REVISION = COMPILER_REVISION;
	var REVISION_CHANGES = {
	  1: '<= 1.0.rc.2', // 1.0.rc.2 is actually rev2 but doesn't report it
	  2: '== 1.0.0-rc.3',
	  3: '== 1.0.0-rc.4',
	  4: '>= 1.0.0'
	};
	exports.REVISION_CHANGES = REVISION_CHANGES;
	var toString = Object.prototype.toString,
	    objectType = '[object Object]';
	
	// Sourced from lodash
	// https://github.com/bestiejs/lodash/blob/master/LICENSE.txt
	var isFunction = function(value) {
	  return typeof value === 'function';
	};
	// fallback for older versions of Chrome and Safari
	if (isFunction(/x/)) {
	  isFunction = function(value) {
	    return typeof value === 'function' && toString.call(value) === '[object Function]';
	  };
	}
	
	function isArray(value) {
	  return (value && typeof value === 'object') ? toString.call(value) === '[object Array]' : false;
	}
	
	function HandlebarsEnvironment(helpers, partials) {
	  this.helpers = helpers || {};
	  this.partials = partials || {};
	
	  registerDefaultHelpers(this);
	}
	
	exports.HandlebarsEnvironment = HandlebarsEnvironment;HandlebarsEnvironment.prototype = {
	  constructor: HandlebarsEnvironment,
	
	  logger: logger,
	  log: log,
	
	  registerHelper: function(name, fn, inverse) {
	    if (toString.call(name) === objectType) {
	      if (inverse || fn) { throw new Exception('Arg not supported with multiple helpers'); }
	      Utils.extend(this.helpers, name);
	    } else {
	      if (inverse) { fn.not = inverse; }
	      this.helpers[name] = fn;
	    }
	  },
	
	  registerPartial: function(name, str) {
	    if (toString.call(name) === objectType) {
	      Utils.extend(this.partials,  name);
	    } else {
	      this.partials[name] = str;
	    }
	  }
	};
	
	function registerDefaultHelpers(instance) {
	  instance.registerHelper('helperMissing', function(arg) {
	    if(arguments.length === 2) {
	      return undefined;
	    } else {
	      throw new Error("Missing helper: '" + arg + "'");
	    }
	  });
	
	  instance.registerHelper('blockHelperMissing', function(context, options) {
	    var inverse = options.inverse || function() {}, fn = options.fn;
	
	    if (isFunction(context)) { context = context.call(this); }
	
	    if(context === true) {
	      return fn(this);
	    } else if(context === false || context == null) {
	      return inverse(this);
	    } else if (isArray(context)) {
	      if(context.length > 0) {
	        return instance.helpers.each(context, options);
	      } else {
	        return inverse(this);
	      }
	    } else {
	      return fn(context);
	    }
	  });
	
	  instance.registerHelper('each', function(context, options) {
	    var fn = options.fn, inverse = options.inverse;
	    var i = 0, ret = "", data;
	
	    if (isFunction(context)) { context = context.call(this); }
	
	    if (options.data) {
	      data = createFrame(options.data);
	    }
	
	    if(context && typeof context === 'object') {
	      if (isArray(context)) {
	        for(var j = context.length; i<j; i++) {
	          if (data) {
	            data.index = i;
	            data.first = (i === 0)
	            data.last  = (i === (context.length-1));
	          }
	          ret = ret + fn(context[i], { data: data });
	        }
	      } else {
	        for(var key in context) {
	          if(context.hasOwnProperty(key)) {
	            if(data) { data.key = key; }
	            ret = ret + fn(context[key], {data: data});
	            i++;
	          }
	        }
	      }
	    }
	
	    if(i === 0){
	      ret = inverse(this);
	    }
	
	    return ret;
	  });
	
	  instance.registerHelper('if', function(conditional, options) {
	    if (isFunction(conditional)) { conditional = conditional.call(this); }
	
	    // Default behavior is to render the positive path if the value is truthy and not empty.
	    // The `includeZero` option may be set to treat the condtional as purely not empty based on the
	    // behavior of isEmpty. Effectively this determines if 0 is handled by the positive path or negative.
	    if ((!options.hash.includeZero && !conditional) || Utils.isEmpty(conditional)) {
	      return options.inverse(this);
	    } else {
	      return options.fn(this);
	    }
	  });
	
	  instance.registerHelper('unless', function(conditional, options) {
	    return instance.helpers['if'].call(this, conditional, {fn: options.inverse, inverse: options.fn, hash: options.hash});
	  });
	
	  instance.registerHelper('with', function(context, options) {
	    if (isFunction(context)) { context = context.call(this); }
	
	    if (!Utils.isEmpty(context)) return options.fn(context);
	  });
	
	  instance.registerHelper('log', function(context, options) {
	    var level = options.data && options.data.level != null ? parseInt(options.data.level, 10) : 1;
	    instance.log(level, context);
	  });
	}
	
	var logger = {
	  methodMap: { 0: 'debug', 1: 'info', 2: 'warn', 3: 'error' },
	
	  // State enum
	  DEBUG: 0,
	  INFO: 1,
	  WARN: 2,
	  ERROR: 3,
	  level: 3,
	
	  // can be overridden in the host environment
	  log: function(level, obj) {
	    if (logger.level <= level) {
	      var method = logger.methodMap[level];
	      if (typeof console !== 'undefined' && console[method]) {
	        console[method].call(console, obj);
	      }
	    }
	  }
	};
	exports.logger = logger;
	function log(level, obj) { logger.log(level, obj); }
	
	exports.log = log;var createFrame = function(object) {
	  var obj = {};
	  Utils.extend(obj, object);
	  return obj;
	};
	exports.createFrame = createFrame;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(26);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 32 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(75);
	var enumBugKeys = __webpack_require__(48);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * This is a simple dropdown component
	 * 
	 * Options: 
	 *      selectedClassName: string (default: is-selected) - The class name of a selected dropdown element
	 *      hideClass: bool (default: is-hidden) - The class name that the dropdown content element has to be hidden
	 *      valueIsObject: bool (default: false) - If set to true, the return value contains an object, initial value must be json encoded
	 *      DEPRECATED: openCallback: (a function to be called when the dropdown opens, use eventDispatcher instead)
	 * 
	 * Events: 
	 *      open: Is triggered when the dropdown opens
	 *      close: Is triggered when the dropdown closes
	 * 
	 * @param {type} $
	 * @param {type} Object
	 * @param {type} Widget
	 * @returns {_L8.Dropdown}
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(1),
	    __webpack_require__(158),
	    __webpack_require__(2),
	    __webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = function($, Hammer, Object, Widget) {
	        
	        var Dropdown = function (element, options) {
	            Widget.apply(this, arguments);
	            
	            // Set default options
	            var defaultOptions = {
	                'selectedClassName': 'is-selected',
	                'hideClass': 'is-hidden',
	                'openClass': 'is-open',
	                'closedClass': 'is-closed',
	                'valueIsObject' : false,
	                'openCallback': null
	            };
	            
	            //Add default options and custom options
	            this.addOptions(defaultOptions, options);
	            
	            this._registerClickEvent();
	            
	            //Register events
	            this.registerEvent('open');
	            this.registerEvent('close');
	            
	        };
	
	        Dropdown.prototype = $.extend(Object.create(Widget.prototype), {
	            
	            /**
	             * Registers click events
	             */
	            _registerClickEvent: function () {
	                var self = this;
	
	                // Click on button
	                $('[data-fcse-role="dropdown--btn"]', this.element).on("click", $.proxy(function (e) {
	                    self.toggleDropdown();
	                    e.preventDefault();
	                }, self));
	
	                var onClickHandler = function(e){
	                    // this is to prevent 'ghost click' on touch surfaces
	                    if (typeof e.gesture != 'undefined') {
	                        e.gesture.srcEvent.preventDefault();
	                    }
	
	                    var $this = $(this);
	
	                    var comparableOptionValue = self._valueToString(self._processData($this.attr('data-value')), self.option('valueIsObject'));
	                    var comparableValue = self._valueToString(self.getValue(), self.option('valueIsObject'));
	                    if (comparableOptionValue !== comparableValue){
	                        if (self.option('valueIsObject')){
	                            self.setValue(self._processData($this.attr('data-value')));
	                        } else {
	                            self.setValue($this.attr('data-value'));
	                        }
	                        if ($('[data-fcse-role="dropdown--label"]', self.element)) {
	                            $('[data-fcse-role="dropdown--label"]', self.element).text($this.text());
	                        }
	                    }
	                    self.closeDropdown();
	                    e.preventDefault();
	                };
	                // we check if we have touch-enabled browser
	                if ('ontouchstart' in document.documentElement) {
	                    // if yes, bind to 'tap' event here
	                    $('[data-value]', this.element).each(function(){
	                        var hammerifiedElement = new Hammer(this);
	                        hammerifiedElement.on('tap', $.proxy(onClickHandler, this));
	                    });
	                } else {
	                    // if no, we bind to the 'click' event
	                    // Click on dropdown option
	                    $('[data-value]', this.element).on('click', onClickHandler);
	                }
	            },
	            
	            _valueToString : function(value, valueIsObject) {
	                if (valueIsObject){
	                    return JSON.stringify(value);
	                } else {
	                    return '' + value;
	                }
	            },
	            
	            _stopEventPropagation: function(e){
	                e.stopPropagation();
	            },
	            
	            /**
	             * Opens the dropdown select
	             */
	            openDropdown: function() {
	                $('[data-fcse-role="dropdown--content"]', this.element).removeClass(this.option('hideClass'));
	                var self = this;
	                $(this.element).trigger('click');
	                $('html').on('click', $.proxy(self.closeDropdown, self));
	                self.element.on('click', self._stopEventPropagation);
	                this.element.removeClass(this.option('closedClass'));
	                this.element.addClass(this.option('openClass'));
	                if(typeof this.option('openCallback') === 'function') {
	                    this.option('openCallback')(this);
	                }
	                this.dispatchEvent('open');
	            },
	            
	            /**
	             * Closes the dropdown select
	             */
	            closeDropdown: function() {
	                $('[data-fcse-role="dropdown--content"]', this.element).addClass(this.option('hideClass'));
	                this.element.off('click', this._stopEventPropagation);
	                this.element.addClass(this.option('closedClass'));
	                this.element.removeClass(this.option('openClass'));
	                $('html').off('click', $.proxy(this.closeDropdown, this));
	                this.dispatchEvent('close');
	            },
	            
	            /**
	             * Toggle open or close the dropdown select
	             */
	            toggleDropdown: function() {
	                if ($('[data-fcse-role="dropdown--content"]', this.element).hasClass(this.option('hideClass'))){
	                    this.openDropdown();
	                } else {
	                    this.closeDropdown();
	                }
	            },
	            
	            /**
	             * Processes initial value
	             * @param {type} data
	             * @returns {unresolved}
	             */
	            _processData: function (data) {
	                if (this.option('valueIsObject')){
	                    if ($.isPlainObject(data)){
	                        return data;
	                    } else {
	                        return $.parseJSON(data);
	                    }
	                } else {
	                    return data;
	                }
	            },
	            
	            /**
	             * Renders value to the UI
	             */
	            setValueToUi: function () {
	                var self = this;
	                $.each($('[data-value]', this.element), function(index, element){
	                    var $this = $(element);
	                    var comparableOptionValue = self._valueToString(self._processData($this.attr('data-value')), self.option('valueIsObject'));
	                    var comparableValue = self._valueToString(self.getValue(), self.option('valueIsObject'));
	                    if (comparableOptionValue === comparableValue){
	                        $(element).addClass(self.option('selectedClassName'));
	                        if ($('[data-fcse-role="dropdown--label"]', self.element)) {
	                            $('[data-fcse-role="dropdown--label"]', self.element).text($this.text());
	                        }
	                    } else {
	                        $(element).removeClass(self.option('selectedClassName'));
	                    }
	                });
	            },
	            
	            /**
	             * Returns the label for the value
	             * @returns string
	             */
	            formatValue : function() {
	                if ($('[data-fcse-role="dropdown--label"]', this.element)){
	                    return $('[data-fcse-role="dropdown--label"]', this.element).text();
	                } else {
	                    return '';
	                }
	            }
	        });
	
	        return Dropdown;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 35 */,
/* 36 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(79);
	
	__webpack_require__(193);
	
	__webpack_require__(195);
	
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	}();

	;

/***/ }),
/* 38 */
/***/ (function(module, exports) {

	"use strict";
	
	var errorProps = ['description', 'fileName', 'lineNumber', 'message', 'name', 'number', 'stack'];
	
	function Exception(/* message */) {
	  var tmp = Error.prototype.constructor.apply(this, arguments);
	
	  // Unfortunately errors are not enumerable in Chrome (at least), so `for prop in tmp` doesn't work.
	  for (var idx = 0; idx < errorProps.length; idx++) {
	    this[errorProps[idx]] = tmp[errorProps[idx]];
	  }
	}
	
	Exception.prototype = new Error();
	
	exports["default"] = Exception;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(6);
	var core = __webpack_require__(17);
	var hide = __webpack_require__(15);
	var redefine = __webpack_require__(28);
	var ctx = __webpack_require__(93);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 43 */
/***/ (function(module, exports) {

	'use strict';
	
	function oldAdd(element, className) {
	  var classes = element.className.split(' ');
	  if (classes.indexOf(className) < 0) {
	    classes.push(className);
	  }
	  element.className = classes.join(' ');
	}
	
	function oldRemove(element, className) {
	  var classes = element.className.split(' ');
	  var idx = classes.indexOf(className);
	  if (idx >= 0) {
	    classes.splice(idx, 1);
	  }
	  element.className = classes.join(' ');
	}
	
	exports.add = function (element, className) {
	  if (element.classList) {
	    element.classList.add(className);
	  } else {
	    oldAdd(element, className);
	  }
	};
	
	exports.remove = function (element, className) {
	  if (element.classList) {
	    element.classList.remove(className);
	  } else {
	    oldRemove(element, className);
	  }
	};
	
	exports.list = function (element) {
	  if (element.classList) {
	    return Array.prototype.slice.apply(element.classList);
	  } else {
	    return element.className.split(' ');
	  }
	};


/***/ }),
/* 44 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 45 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(6);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};


/***/ }),
/* 47 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 48 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 49 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(46)('keys');
	var uid = __webpack_require__(27);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(26);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 52 */
/***/ (function(module, exports) {

	module.exports = false;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(20).f;
	var has = __webpack_require__(10);
	var TAG = __webpack_require__(7)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(31);
	var dPs = __webpack_require__(134);
	var enumBugKeys = __webpack_require__(48);
	var IE_PROTO = __webpack_require__(50)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(70)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(105).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(6);
	var core = __webpack_require__(17);
	var LIBRARY = __webpack_require__(52);
	var wksExt = __webpack_require__(56);
	var defineProperty = __webpack_require__(20).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(7);


/***/ }),
/* 57 */,
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * Created by Ivo Meißner on 21.05.14. (info@overtronic.com)
	 *
	 * General handler for ajax requests
	 *
	 * Available Events:
	 *
	 * 'start': Is triggered when a request is sent to the server
	 * 'success': Is triggered when a successful response comes back from the server
	 * 'error': Is triggered when the request to the server fails or the server returns an error
	 * 'cancel': Is thrown when the request is cancelled
	 *
	 * The callback functions for `start`, `error`, `cancel` take one argument `requestData` which
	 * contains all the necessary data for the request
	 * {
	 *      route: 'the route name',
	 *      routeParams: 'an object of routeParams',
	 *      queryParams: 'an object of queryParams',
	 *      options: 'an object of additional options'
	 *      xhr: 'the jqXHR object, see jQuery Documentation'
	 * }
	 *
	 * The callback function for `success` takes `responseContent` and `requestData` as arguments.
	 *
	 * Example usage:
	 * var requestHandler = new MultiRequestHandler();
	 *
	 * requestHandler.on('success', function(responseContent, requestData){
	 *      // Only trigger certain action on specific route
	 *      if (requestData.route == 'myroute'){
	 *          //Load successful
	 *
	 *      }
	 * });
	 * requestHandler.on('error', function(requestData){
	 *      //Error handling
	 * });
	 *
	 */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [   __webpack_require__(1),
	        __webpack_require__(11),
	        __webpack_require__(86),
	        __webpack_require__(14),
	        __webpack_require__(72),
	        __webpack_require__(68), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, EventDispatcher, Log, Url, Routing, RoutingData, _) {
	        /**
	         * Constructor for general event handler
	         * @constructor
	         */
	        var MultiRequestHandler = function(options){
	            // Extend EventDispatcher
	            EventDispatcher.apply(this, arguments);
	
	            // Determine locale
	            var url = new Url();
	            var locale = url.getLocale();
	
	            // Default options for the request handler
	            var defaultOptions = {
	                method: 'GET',
	                locale: locale,
	                defaultRouteParams: {}
	            };
	            this.addOptions(defaultOptions, options);
	
	            // Initialize object for pending requests
	            this._pendingRequests = {};
	
	            // Register events
	            this.registerEvent('success');
	            this.registerEvent('error');
	            this.registerEvent('start');
	            this.registerEvent('cancel');
	        }
	
	        /**
	         * Extend EventDispatcher prototype
	         * @type {void|*}
	         */
	        MultiRequestHandler.prototype = $.extend(Object.create(EventDispatcher.prototype), {
	            /**
	             * Sends
	             * @param string route The name of the route as defined by Routing
	             * @param object queryParams An object of additional query parameters to be sent to the server
	             * @param object routeParams An object of parameters to configure the route as defined by Routing
	             * @param object options An object of configuration options
	             * @return object The requestData {
	             *      route: 'the route name',
	             *      routeParams: 'an object of routeParams',
	             *      queryParams: 'an object of queryParams',
	             *      options: 'an object of additional options'
	             *      xhr: 'the jqXHR object, see jQuery Documentation'
	             * }
	             */
	            send: function(route, queryParams, routeParams, options){
	                var self = this;
	                routeParams = $.extend(this._getDefaultRouteParams(), routeParams || {});
	
	                // Generate URL for route.
	                var url = Routing.generate(route, routeParams);
	
	                // Create request data object to be stored in request registry
	                var requestData = {
	                    route: route,
	                    routeParams: routeParams,
	                    queryParams: queryParams,
	                    options: options
	                };
	
	                var configOptions = $.extend(Object.create(self.getOptions()), options || {});
	
	                // Send ajax request
	                var xhr = $.ajax(url, {
	                    data: queryParams,
	                    type: configOptions.method
	                })
	                    .done(function(content, textStatus, jqXhr){
	                        self._onAjaxSuccess(content, jqXhr, requestData);
	                    })
	                    .fail(function(jqXhr){
	                        self._onAjaxError(jqXhr, requestData);
	                    });
	
	                // Trigger ajax start
	                self._onAjaxStart(xhr, requestData);
	
	                // Attach XHR object to requestData
	                requestData['xhr'] = xhr;
	
	                // Store pending request in registry
	                this._addPendingRequest(route, requestData);
	
	                // Return the request object
	                return requestData;
	            },
	
	            /**
	             * Cancels all pending requests for the given route
	             * @param route string
	             */
	            cancel: function(route){
	                var self = this;
	                if (this._pendingRequests.hasOwnProperty(route)){
	                    // Cancel all requests for the specified route
	                    $.each(this._pendingRequests[route], function(index, requestData){
	                        requestData.xhr.abort();
	                        self.dispatchEvent('cancel', requestData);
	                    });
	                }
	            },
	
	            /**
	             * Cancels all pending requests
	             */
	            cancelAll: function(){
	                var self = this;
	                $.each(this._pendingRequests, function(key, value){
	                    $.each(self._pendingRequests[key], function(index, requestData){
	                        requestData.xhr.abort();
	                        self.dispatchEvent('cancel', requestData);
	                    });
	                });
	            },
	
	            /**
	             * Returns an object of all pending requests
	             */
	            getPendingRequests: function(){
	                return this._pendingRequests;
	            },
	
	            /**
	             * Saves the request in the pending request registry
	             *
	             * @param route string
	             * @param data object
	             * @private
	             */
	            _addPendingRequest: function(route, data){
	                if (this._pendingRequests.hasOwnProperty(route)){
	                    this._pendingRequests[route].push(data);
	                } else {
	                    this._pendingRequests[route] = [data];
	                }
	            },
	
	            /**
	             * Handler for ajax success
	             * @param content
	             * @param jqXhr
	             * @param requestData
	             * @private
	             */
	            _onAjaxSuccess: function(content, jqXhr, requestData){
	                this._removePendingRequest(requestData.route, jqXhr);
	
	                this.dispatchEvent('success', content, requestData);
	            },
	
	            /**
	             * Handler for ajax error
	             * @param jqXhr
	             * @param requestData
	             * @private
	             */
	            _onAjaxError: function(jqXhr, requestData){
	                this._removePendingRequest(requestData.route, jqXhr);
	
	                var log = new Log();
	                log.error('Route: ' + requestData.route + ' HTTP error occurred. Status: ' + jqXhr.status + ' Text: ' + jqXhr.statusText);
	
	                this.dispatchEvent('error', requestData);
	            },
	
	            /**
	             * Handler for ajax start
	             * @param jqXhr
	             * @param requestData
	             * @private
	             */
	            _onAjaxStart: function(jqXhr, requestData){
	                this.dispatchEvent('start', requestData);
	            },
	
	            /**
	             * Removes a pending request from registry
	             * @param route
	             * @param jqXhr
	             * @private
	             */
	            _removePendingRequest: function(route, jqXhr){
	                var self = this;
	                if (this._pendingRequests.hasOwnProperty(route)){
	                    var indexDelete = -1;
	                    $.each(this._pendingRequests[route], function(index, requestData){
	                        if (requestData.xhr == jqXhr){
	                            indexDelete = index;
	                        }
	                    });
	                    if (indexDelete >= 0){
	                        self._pendingRequests[route].splice(indexDelete, 1);
	
	                        if (self._pendingRequests[route].length === 0){
	                            delete self._pendingRequests[route];
	                        }
	                    }
	                }
	            },
	
	            /**
	             * Returns an object of default route params
	             * @private
	             */
	            _getDefaultRouteParams: function(){
	                // Create params
	                var params = {};
	                params['_locale'] = this.option('locale');
	                if (this.option('defaultRouteParams')) {
	                    params = $.extend({}, this.option('defaultRouteParams'), params);
	                }
	                return params;
	            },
	
	            /**
	             * Internal variable to store configuration values
	             */
	            _options: {},
	
	            /**
	             * Adds options to the MultiRequestHandler.
	             * The parameter options will overwrite the defaults
	             * @param {object} defaults
	             * @param {object|undefined} options
	             * @returns {undefined}
	             */
	            addOptions: function(defaults, options){
	                this._options = $.extend({}, this.getOptions(), defaults, options || {});
	            },
	
	            /**
	             * Returns an object of all configuration options of the MultiRequestHandler
	             * @returns {undefined|Object}
	             */
	            getOptions: function(){
	                return this._options;
	            },
	
	            /**
	             * Gets or sets option
	             * @param name
	             * @param value optional
	             */
	            option: function (name, value) {
	                if (!_.isUndefined(value)) {
	                    this._options[name] = value;
	                }
	                return this._options[name];
	            }
	        });
	
	        return MultiRequestHandler;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    var Binding = function () {
	    };
	    /**
	     * Maps scope params to widget value
	     * @param scopeValues
	     */
	    Binding.prototype.fromScope = function (scopeValues) {
	        throw "not implemented";
	    };
	    /**
	     * Maps widget value to scope params
	     * @param widgetValue
	     */
	    Binding.prototype.toScope = function (widgetValue) {
	        throw "not implemented";
	    };
	    /**
	     * Checks if scope's parameter affects/is bound to widget's value
	     * @param scopeName
	     */
	    Binding.prototype.isValueAffectedBy = function (scopeName) {
	        throw "not implemented";
	    };
	    return Binding;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (jQuery) {
	    /*
	     http://touchpunch.furf.com/
	     */
	    /*!
	     * jQuery UI Touch Punch 0.2.3
	     *
	     * Copyright 2011–2014, Dave Furfero
	     * Dual licensed under the MIT or GPL Version 2 licenses.
	     *
	     * Depends:
	     *  jquery.ui.widget.js
	     *  jquery.ui.mouse.js
	     */
	    (function ($) {
	
	        // Detect touch support
	        $.support.touch = 'ontouchend' in document;
	
	        // Ignore browsers without touch support
	        if (!$.support.touch) {
	            return;
	        }
	
	        var mouseProto = $.ui.mouse.prototype,
	            _mouseInit = mouseProto._mouseInit,
	            _mouseDestroy = mouseProto._mouseDestroy,
	            touchHandled;
	
	        /**
	         * Simulate a mouse event based on a corresponding touch event
	         * @param {Object} event A touch event
	         * @param {String} simulatedType The corresponding mouse event
	         */
	        function simulateMouseEvent(event, simulatedType) {
	
	            // Ignore multi-touch events
	            if (event.originalEvent.touches.length > 1) {
	                return;
	            }
	
	            event.preventDefault();
	
	            var touch = event.originalEvent.changedTouches[0],
	                simulatedEvent = document.createEvent('MouseEvents');
	
	            // Initialize the simulated mouse event using the touch event's coordinates
	            simulatedEvent.initMouseEvent(simulatedType, // type
	            true, // bubbles
	            true, // cancelable
	            window, // view
	            1, // detail
	            touch.screenX, // screenX
	            touch.screenY, // screenY
	            touch.clientX, // clientX
	            touch.clientY, // clientY
	            false, // ctrlKey
	            false, // altKey
	            false, // shiftKey
	            false, // metaKey
	            0, // button
	            null // relatedTarget
	            );
	
	            // Dispatch the simulated event to the target element
	            event.target.dispatchEvent(simulatedEvent);
	        }
	
	        /**
	         * Handle the jQuery UI widget's touchstart events
	         * @param {Object} event The widget element's touchstart event
	         */
	        mouseProto._touchStart = function (event) {
	
	            var self = this;
	
	            // Ignore the event if another widget is already being handled
	            if (touchHandled || !self._mouseCapture(event.originalEvent.changedTouches[0])) {
	                return;
	            }
	
	            // Set the flag to prevent other widgets from inheriting the touch event
	            touchHandled = true;
	
	            // Track movement to determine if interaction was a click
	            self._touchMoved = false;
	
	            // Simulate the mouseover event
	            simulateMouseEvent(event, 'mouseover');
	
	            // Simulate the mousemove event
	            simulateMouseEvent(event, 'mousemove');
	
	            // Simulate the mousedown event
	            simulateMouseEvent(event, 'mousedown');
	        };
	
	        /**
	         * Handle the jQuery UI widget's touchmove events
	         * @param {Object} event The document's touchmove event
	         */
	        mouseProto._touchMove = function (event) {
	
	            // Ignore event if not handled
	            if (!touchHandled) {
	                return;
	            }
	
	            // Interaction was not a click
	            this._touchMoved = true;
	
	            // Simulate the mousemove event
	            simulateMouseEvent(event, 'mousemove');
	        };
	
	        /**
	         * Handle the jQuery UI widget's touchend events
	         * @param {Object} event The document's touchend event
	         */
	        mouseProto._touchEnd = function (event) {
	
	            // Ignore event if not handled
	            if (!touchHandled) {
	                return;
	            }
	
	            // Simulate the mouseup event
	            simulateMouseEvent(event, 'mouseup');
	
	            // Simulate the mouseout event
	            simulateMouseEvent(event, 'mouseout');
	
	            // If the touch interaction did not move, it should trigger a click
	            if (!this._touchMoved) {
	
	                // Simulate the click event
	                simulateMouseEvent(event, 'click');
	            }
	
	            // Unset the flag to allow other widgets to inherit the touch event
	            touchHandled = false;
	        };
	
	        /**
	         * A duck punch of the $.ui.mouse _mouseInit method to support touch events.
	         * This method extends the widget with bound touch event handlers that
	         * translate touch events to mouse events and pass them to the widget's
	         * original mouse event handling methods.
	         */
	        mouseProto._mouseInit = function () {
	
	            var self = this;
	
	            // Delegate the touch handlers to the widget's element
	            self.element.bind({
	                touchstart: $.proxy(self, '_touchStart'),
	                touchmove: $.proxy(self, '_touchMove'),
	                touchend: $.proxy(self, '_touchEnd')
	            });
	
	            // Call the original $.ui.mouse init method
	            _mouseInit.call(self);
	        };
	
	        /**
	         * Remove the touch event handlers
	         */
	        mouseProto._mouseDestroy = function () {
	
	            var self = this;
	
	            // Delegate the touch handlers to the widget's element
	            self.element.unbind({
	                touchstart: $.proxy(self, '_touchStart'),
	                touchmove: $.proxy(self, '_touchMove'),
	                touchend: $.proxy(self, '_touchEnd')
	            });
	
	            // Call the original $.ui.mouse destroy method
	            _mouseDestroy.call(self);
	        };
	    })(jQuery);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * • FCSE Travelsearch Sandbox 2013 •
	 * 
	 * © Copyright 2013, Tom Hülser [freshcells systems engineering GmbH]
	 * 
	 * Supports all features that jQueryUI slider component has.
	 * Supports snapping to the defined values.
	 * Supports snapping for ranges.
	 * Allows to define a custom distribution sequence (uniform distribution is used by default).
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(1),
	    __webpack_require__(37)], __WEBPACK_AMD_DEFINE_RESULT__ = function( $, jQueryUI ) {
	
	        var defaultOptions = {
	            min: 0,
	            max: 100,
	            range: false,
	            // Array with values you want to snap to.
	            snaps: null,
	            // Array with values describing visual distribution for snaps.
	            // If no distribution provided then uniform distribution is used.
	            distribution: null
	        };
	
	        $.widget("ui.xslider", $.ui.slider, {
	
	            options: $.extend({}, $.ui.slider.prototype.options, defaultOptions),
	
	            _processOptions: function(options) {
	                var values = options.values,
	                    snaps = options.snaps;
	                if (values && values.length > 2) {
	                    throw new Error("Slider can handle only 2 values per range.");
	                }
	                if (values && values.length && values[0] >= values[1]) {
	                    throw new Error("Slider's range is malformed: [" + values + "].")
	                }
	                if (values && snaps && (($.inArray(values[0], snaps) == -1) ||
	                    ($.inArray(values[1], snaps) == -1))) {
	                    throw new Error("Slider's snaps and values are not in sync: ["+snaps+"], ["+values+"].")
	                }
	                if (options.value && values && values.length) {
	                    delete options.value;
	                }
	            },
	            _create: function() {
	                this._processOptions(this.options);
	                $.ui.slider.prototype._create.apply(this, arguments);
	
	                var min = this.options.min,
	                    max = this.options.max,
	                    snaps = this.options.snaps,
	                    distribution = this.options.distribution,
	                    uniformStep = 1,
	                    values = this.options.values,
	                    value = this.options.value;
	
	                this._startOptions = null;
	                this._distributionValues = [];
	                this._useSnaps = false;
	
	                if ((this._useSnaps = (snaps && snaps.length))) {
	                    if (distribution && distribution.length) {
	                        this._distributionValues = distribution;
	                    } else {
	                        uniformStep = (max - min) / (snaps.length - 1);
	                        for (var i = 0; i < snaps.length; ++i) {
	                            this._distributionValues.push(i * uniformStep + min);
	                        }
	                    }
	                    if (values && values.length) {
	                        for (var i = 0; i < values.length; i++) {
	                            this.values(i, this._findClosest(this._snapValue(values[i])));
	                        }
	                    } else {
	                        value = !isNaN(value) ? value : this.options.min;
	                        this.value(this._findClosest(this._snapValue(value)));
	                    }
	                }
	            },
	            _start: function(event, index) {
	                this._startOptions = {
	                    index: index,
	                    handle: this.handles[index],
	                    value: this.value()
	                };
	                this._startOptions.value = this.options.values ? this.values(index) : this.value();
	                this._startOptions.values = this.values();
	                this._startOptions.current = this._startOptions.value;
	                var result = $.ui.slider.prototype._start.apply(this, arguments);
	                this.handles.blur();
	                return result;
	            },
	            _slide: function(event, index, newVal) {
	                if(!this._useSnaps) {
	                    return $.ui.slider.prototype._slide.apply(this,arguments);
	                }
	                var allowed,
	                    curValues = this.values(),
	                    startVal = this._startOptions.value,
	                    normValues = this._distributionValues,
	                    closestVal = this._findClosest(newVal),
	                    snapIndex,
	                    snappedVal,
	                    snappedValues,
	                    next = newVal > startVal;
	
	                if (this._startOptions.current == closestVal ||
	                    !(Math.abs(startVal - newVal) >= Math.abs((startVal - closestVal)/2)) ||
	                    (next ? curValues[index + 1] <= closestVal : curValues[index - 1] >= closestVal)) { return; }
	
	                snapIndex = $.inArray(closestVal, normValues);
	                snappedVal = this.options.snaps[snapIndex];
	                snappedValues = curValues;
	                snappedValues[index] = snappedVal;
	
	                allowed = this._trigger("slide", event, {
	                    handle: this.handles[index],
	                    value: snappedVal,
	                    values: snappedValues
	                });
	
	                if (allowed !== false) {
	                    (this.options.values) ? this.values(index, closestVal) : this.value(closestVal);
	                }
	                this._startOptions.current = closestVal;
	            },
	            _trigger: function(type, event, ui) {
	                if (this._useSnaps) {
	                    if (type == "start" || type == "stop") {
	                        ui.value = this._convert(ui.value);
	                        if (ui.values) { ui.values = this._convert(ui.values);}
	                    }
	                }
	                return $.Widget.prototype._trigger.call(this, type, event, ui);
	            },
	            _trimAlignValue: function(val) {
	                return this._findClosest($.ui.slider.prototype._trimAlignValue.apply(this, arguments));
	            },
	            _snapValue: function(value) {
	                if (!this._useSnaps) { return value; }
	
	                var snaps = this.options.snaps,
	                    snapIndex = $.inArray(value, snaps);
	
	                return snapIndex != -1 ? this._distributionValues[snapIndex] : value;
	            },
	            _findClosest: function(value) {
	                if (!this._useSnaps) { return value; }
	
	                var result = value, prev = null, half,
	                    distribution = this._distributionValues;
	
	                if (distribution && $.inArray(value, distribution) == -1) {
	                    for (var i = 0; i < distribution.length; ++i) {
	                        if (prev !== null && value > prev && value < distribution[i]) {
	                            half = (distribution[i] - prev) / 2;
	                            result = (value - prev) > half ? distribution[i] : prev;
	                            break;
	                        }
	                        prev = distribution[i];
	                    }
	                }
	                return result;
	            },
	            _convert: function(value) {
	                if (!this._useSnaps) { return value; }
	
	                var result = [], item, distributionIndex,
	                    values = $.isArray(value) ? value : [value];
	
	                for (var i = 0; i < values.length; ++i) {
	                    item = values[i];
	                    if ((distributionIndex = $.inArray(item, this._distributionValues)) != -1) {
	                        item = this.options.snaps[distributionIndex];
	                    }
	                    result.push(item);
	                }
	                return values === value ? result : result[0];
	            },
	            // Use these public methods below to get not distributed value/values from outside e.g.
	            // var sliderValues = $("#slider").xslider("xvalues");
	            xvalues: function(index, newValue) {
	                if ($.isArray(index) && (this.options.range !== true || !this.options.values)) {
	                    throw new Error("Slider is not in range mode but range given: ["+index+"].");
	                }
	                if (!this._useSnaps) {
	                    return this.values(index, newValue);
	                } else if (arguments.length > 1 || (arguments.length && $.isArray(arguments[0]))) {
	                    this.values.apply(this, arguments);
	                } else if (arguments.length) {
	                    if (this.options.values && this.options.values.length) {
	                        return this._convert(this._values(index));
	                    } else {
	                        return this._convert(this.value());
	                    }
	                } else {
	                    return this._convert(this.options.range ? this._values() : this._value());
	                }
	            },
	            xvalue: function(newValue) {
	                if (!this._useSnaps) {
	                    return this.value(newValue);
	                } else if (arguments.length) {
	                    ($.isArray(newValue)) ? this.xvalues(newValue) :
	                        this.value.apply(this, arguments);
	                } else {
	                    return this._convert(this._value());
	                }
	            }
	        });
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Exception = __webpack_require__(38)["default"];
	
	function ProgramNode(statements, inverseStrip, inverse) {
	  this.type = "program";
	  this.statements = statements;
	  this.strip = {};
	
	  if(inverse) {
	    this.inverse = new ProgramNode(inverse, inverseStrip);
	    this.strip.right = inverseStrip.left;
	  } else if (inverseStrip) {
	    this.strip.left = inverseStrip.right;
	  }
	}
	
	exports.ProgramNode = ProgramNode;function MustacheNode(rawParams, hash, open, strip) {
	  this.type = "mustache";
	  this.hash = hash;
	  this.strip = strip;
	
	  var escapeFlag = open[3] || open[2];
	  this.escaped = escapeFlag !== '{' && escapeFlag !== '&';
	
	  var id = this.id = rawParams[0];
	  var params = this.params = rawParams.slice(1);
	
	  // a mustache is an eligible helper if:
	  // * its id is simple (a single part, not `this` or `..`)
	  var eligibleHelper = this.eligibleHelper = id.isSimple;
	
	  // a mustache is definitely a helper if:
	  // * it is an eligible helper, and
	  // * it has at least one parameter or hash segment
	  this.isHelper = eligibleHelper && (params.length || hash);
	
	  // if a mustache is an eligible helper but not a definite
	  // helper, it is ambiguous, and will be resolved in a later
	  // pass or at runtime.
	}
	
	exports.MustacheNode = MustacheNode;function PartialNode(partialName, context, strip) {
	  this.type         = "partial";
	  this.partialName  = partialName;
	  this.context      = context;
	  this.strip = strip;
	}
	
	exports.PartialNode = PartialNode;function BlockNode(mustache, program, inverse, close) {
	  if(mustache.id.original !== close.path.original) {
	    throw new Exception(mustache.id.original + " doesn't match " + close.path.original);
	  }
	
	  this.type = "block";
	  this.mustache = mustache;
	  this.program  = program;
	  this.inverse  = inverse;
	
	  this.strip = {
	    left: mustache.strip.left,
	    right: close.strip.right
	  };
	
	  (program || inverse).strip.left = mustache.strip.right;
	  (inverse || program).strip.right = close.strip.left;
	
	  if (inverse && !program) {
	    this.isInverse = true;
	  }
	}
	
	exports.BlockNode = BlockNode;function ContentNode(string) {
	  this.type = "content";
	  this.string = string;
	}
	
	exports.ContentNode = ContentNode;function HashNode(pairs) {
	  this.type = "hash";
	  this.pairs = pairs;
	}
	
	exports.HashNode = HashNode;function IdNode(parts) {
	  this.type = "ID";
	
	  var original = "",
	      dig = [],
	      depth = 0;
	
	  for(var i=0,l=parts.length; i<l; i++) {
	    var part = parts[i].part;
	    original += (parts[i].separator || '') + part;
	
	    if (part === ".." || part === "." || part === "this") {
	      if (dig.length > 0) { throw new Exception("Invalid path: " + original); }
	      else if (part === "..") { depth++; }
	      else { this.isScoped = true; }
	    }
	    else { dig.push(part); }
	  }
	
	  this.original = original;
	  this.parts    = dig;
	  this.string   = dig.join('.');
	  this.depth    = depth;
	
	  // an ID is simple if it only has one part, and that part is not
	  // `..` or `this`.
	  this.isSimple = parts.length === 1 && !this.isScoped && depth === 0;
	
	  this.stringModeValue = this.string;
	}
	
	exports.IdNode = IdNode;function PartialNameNode(name) {
	  this.type = "PARTIAL_NAME";
	  this.name = name.original;
	}
	
	exports.PartialNameNode = PartialNameNode;function DataNode(id) {
	  this.type = "DATA";
	  this.id = id;
	}
	
	exports.DataNode = DataNode;function StringNode(string) {
	  this.type = "STRING";
	  this.original =
	    this.string =
	    this.stringModeValue = string;
	}
	
	exports.StringNode = StringNode;function IntegerNode(integer) {
	  this.type = "INTEGER";
	  this.original =
	    this.integer = integer;
	  this.stringModeValue = Number(integer);
	}
	
	exports.IntegerNode = IntegerNode;function BooleanNode(bool) {
	  this.type = "BOOLEAN";
	  this.bool = bool;
	  this.stringModeValue = bool === "true";
	}
	
	exports.BooleanNode = BooleanNode;function CommentNode(comment) {
	  this.type = "comment";
	  this.comment = comment;
	}
	
	exports.CommentNode = CommentNode;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var parser = __webpack_require__(188)["default"];
	var AST = __webpack_require__(64);
	
	exports.parser = parser;
	
	function parse(input) {
	  // Just return if an already-compile AST was passed in.
	  if(input.constructor === AST.ProgramNode) { return input; }
	
	  parser.yy = AST;
	  return parser.parse(input);
	}
	
	exports.parse = parse;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Exception = __webpack_require__(38)["default"];
	var parse = __webpack_require__(65).parse;
	var JavaScriptCompiler = __webpack_require__(88)["default"];
	var AST = __webpack_require__(64);
	
	function Compiler() {}
	
	exports.Compiler = Compiler;// the foundHelper register will disambiguate helper lookup from finding a
	// function in a context. This is necessary for mustache compatibility, which
	// requires that context functions in blocks are evaluated by blockHelperMissing,
	// and then proceed as if the resulting value was provided to blockHelperMissing.
	
	Compiler.prototype = {
	  compiler: Compiler,
	
	  disassemble: function() {
	    var opcodes = this.opcodes, opcode, out = [], params, param;
	
	    for (var i=0, l=opcodes.length; i<l; i++) {
	      opcode = opcodes[i];
	
	      if (opcode.opcode === 'DECLARE') {
	        out.push("DECLARE " + opcode.name + "=" + opcode.value);
	      } else {
	        params = [];
	        for (var j=0; j<opcode.args.length; j++) {
	          param = opcode.args[j];
	          if (typeof param === "string") {
	            param = "\"" + param.replace("\n", "\\n") + "\"";
	          }
	          params.push(param);
	        }
	        out.push(opcode.opcode + " " + params.join(" "));
	      }
	    }
	
	    return out.join("\n");
	  },
	
	  equals: function(other) {
	    var len = this.opcodes.length;
	    if (other.opcodes.length !== len) {
	      return false;
	    }
	
	    for (var i = 0; i < len; i++) {
	      var opcode = this.opcodes[i],
	          otherOpcode = other.opcodes[i];
	      if (opcode.opcode !== otherOpcode.opcode || opcode.args.length !== otherOpcode.args.length) {
	        return false;
	      }
	      for (var j = 0; j < opcode.args.length; j++) {
	        if (opcode.args[j] !== otherOpcode.args[j]) {
	          return false;
	        }
	      }
	    }
	
	    len = this.children.length;
	    if (other.children.length !== len) {
	      return false;
	    }
	    for (i = 0; i < len; i++) {
	      if (!this.children[i].equals(other.children[i])) {
	        return false;
	      }
	    }
	
	    return true;
	  },
	
	  guid: 0,
	
	  compile: function(program, options) {
	    this.opcodes = [];
	    this.children = [];
	    this.depths = {list: []};
	    this.options = options;
	
	    // These changes will propagate to the other compiler components
	    var knownHelpers = this.options.knownHelpers;
	    this.options.knownHelpers = {
	      'helperMissing': true,
	      'blockHelperMissing': true,
	      'each': true,
	      'if': true,
	      'unless': true,
	      'with': true,
	      'log': true
	    };
	    if (knownHelpers) {
	      for (var name in knownHelpers) {
	        this.options.knownHelpers[name] = knownHelpers[name];
	      }
	    }
	
	    return this.accept(program);
	  },
	
	  accept: function(node) {
	    var strip = node.strip || {},
	        ret;
	    if (strip.left) {
	      this.opcode('strip');
	    }
	
	    ret = this[node.type](node);
	
	    if (strip.right) {
	      this.opcode('strip');
	    }
	
	    return ret;
	  },
	
	  program: function(program) {
	    var statements = program.statements;
	
	    for(var i=0, l=statements.length; i<l; i++) {
	      this.accept(statements[i]);
	    }
	    this.isSimple = l === 1;
	
	    this.depths.list = this.depths.list.sort(function(a, b) {
	      return a - b;
	    });
	
	    return this;
	  },
	
	  compileProgram: function(program) {
	    var result = new this.compiler().compile(program, this.options);
	    var guid = this.guid++, depth;
	
	    this.usePartial = this.usePartial || result.usePartial;
	
	    this.children[guid] = result;
	
	    for(var i=0, l=result.depths.list.length; i<l; i++) {
	      depth = result.depths.list[i];
	
	      if(depth < 2) { continue; }
	      else { this.addDepth(depth - 1); }
	    }
	
	    return guid;
	  },
	
	  block: function(block) {
	    var mustache = block.mustache,
	        program = block.program,
	        inverse = block.inverse;
	
	    if (program) {
	      program = this.compileProgram(program);
	    }
	
	    if (inverse) {
	      inverse = this.compileProgram(inverse);
	    }
	
	    var type = this.classifyMustache(mustache);
	
	    if (type === "helper") {
	      this.helperMustache(mustache, program, inverse);
	    } else if (type === "simple") {
	      this.simpleMustache(mustache);
	
	      // now that the simple mustache is resolved, we need to
	      // evaluate it by executing `blockHelperMissing`
	      this.opcode('pushProgram', program);
	      this.opcode('pushProgram', inverse);
	      this.opcode('emptyHash');
	      this.opcode('blockValue');
	    } else {
	      this.ambiguousMustache(mustache, program, inverse);
	
	      // now that the simple mustache is resolved, we need to
	      // evaluate it by executing `blockHelperMissing`
	      this.opcode('pushProgram', program);
	      this.opcode('pushProgram', inverse);
	      this.opcode('emptyHash');
	      this.opcode('ambiguousBlockValue');
	    }
	
	    this.opcode('append');
	  },
	
	  hash: function(hash) {
	    var pairs = hash.pairs, pair, val;
	
	    this.opcode('pushHash');
	
	    for(var i=0, l=pairs.length; i<l; i++) {
	      pair = pairs[i];
	      val  = pair[1];
	
	      if (this.options.stringParams) {
	        if(val.depth) {
	          this.addDepth(val.depth);
	        }
	        this.opcode('getContext', val.depth || 0);
	        this.opcode('pushStringParam', val.stringModeValue, val.type);
	      } else {
	        this.accept(val);
	      }
	
	      this.opcode('assignToHash', pair[0]);
	    }
	    this.opcode('popHash');
	  },
	
	  partial: function(partial) {
	    var partialName = partial.partialName;
	    this.usePartial = true;
	
	    if(partial.context) {
	      this.ID(partial.context);
	    } else {
	      this.opcode('push', 'depth0');
	    }
	
	    this.opcode('invokePartial', partialName.name);
	    this.opcode('append');
	  },
	
	  content: function(content) {
	    this.opcode('appendContent', content.string);
	  },
	
	  mustache: function(mustache) {
	    var options = this.options;
	    var type = this.classifyMustache(mustache);
	
	    if (type === "simple") {
	      this.simpleMustache(mustache);
	    } else if (type === "helper") {
	      this.helperMustache(mustache);
	    } else {
	      this.ambiguousMustache(mustache);
	    }
	
	    if(mustache.escaped && !options.noEscape) {
	      this.opcode('appendEscaped');
	    } else {
	      this.opcode('append');
	    }
	  },
	
	  ambiguousMustache: function(mustache, program, inverse) {
	    var id = mustache.id,
	        name = id.parts[0],
	        isBlock = program != null || inverse != null;
	
	    this.opcode('getContext', id.depth);
	
	    this.opcode('pushProgram', program);
	    this.opcode('pushProgram', inverse);
	
	    this.opcode('invokeAmbiguous', name, isBlock);
	  },
	
	  simpleMustache: function(mustache) {
	    var id = mustache.id;
	
	    if (id.type === 'DATA') {
	      this.DATA(id);
	    } else if (id.parts.length) {
	      this.ID(id);
	    } else {
	      // Simplified ID for `this`
	      this.addDepth(id.depth);
	      this.opcode('getContext', id.depth);
	      this.opcode('pushContext');
	    }
	
	    this.opcode('resolvePossibleLambda');
	  },
	
	  helperMustache: function(mustache, program, inverse) {
	    var params = this.setupFullMustacheParams(mustache, program, inverse),
	        name = mustache.id.parts[0];
	
	    if (this.options.knownHelpers[name]) {
	      this.opcode('invokeKnownHelper', params.length, name);
	    } else if (this.options.knownHelpersOnly) {
	      throw new Error("You specified knownHelpersOnly, but used the unknown helper " + name);
	    } else {
	      this.opcode('invokeHelper', params.length, name);
	    }
	  },
	
	  ID: function(id) {
	    this.addDepth(id.depth);
	    this.opcode('getContext', id.depth);
	
	    var name = id.parts[0];
	    if (!name) {
	      this.opcode('pushContext');
	    } else {
	      this.opcode('lookupOnContext', id.parts[0]);
	    }
	
	    for(var i=1, l=id.parts.length; i<l; i++) {
	      this.opcode('lookup', id.parts[i]);
	    }
	  },
	
	  DATA: function(data) {
	    this.options.data = true;
	    if (data.id.isScoped || data.id.depth) {
	      throw new Exception('Scoped data references are not supported: ' + data.original);
	    }
	
	    this.opcode('lookupData');
	    var parts = data.id.parts;
	    for(var i=0, l=parts.length; i<l; i++) {
	      this.opcode('lookup', parts[i]);
	    }
	  },
	
	  STRING: function(string) {
	    this.opcode('pushString', string.string);
	  },
	
	  INTEGER: function(integer) {
	    this.opcode('pushLiteral', integer.integer);
	  },
	
	  BOOLEAN: function(bool) {
	    this.opcode('pushLiteral', bool.bool);
	  },
	
	  comment: function() {},
	
	  // HELPERS
	  opcode: function(name) {
	    this.opcodes.push({ opcode: name, args: [].slice.call(arguments, 1) });
	  },
	
	  declare: function(name, value) {
	    this.opcodes.push({ opcode: 'DECLARE', name: name, value: value });
	  },
	
	  addDepth: function(depth) {
	    if(isNaN(depth)) { throw new Error("EWOT"); }
	    if(depth === 0) { return; }
	
	    if(!this.depths[depth]) {
	      this.depths[depth] = true;
	      this.depths.list.push(depth);
	    }
	  },
	
	  classifyMustache: function(mustache) {
	    var isHelper   = mustache.isHelper;
	    var isEligible = mustache.eligibleHelper;
	    var options    = this.options;
	
	    // if ambiguous, we can possibly resolve the ambiguity now
	    if (isEligible && !isHelper) {
	      var name = mustache.id.parts[0];
	
	      if (options.knownHelpers[name]) {
	        isHelper = true;
	      } else if (options.knownHelpersOnly) {
	        isEligible = false;
	      }
	    }
	
	    if (isHelper) { return "helper"; }
	    else if (isEligible) { return "ambiguous"; }
	    else { return "simple"; }
	  },
	
	  pushParams: function(params) {
	    var i = params.length, param;
	
	    while(i--) {
	      param = params[i];
	
	      if(this.options.stringParams) {
	        if(param.depth) {
	          this.addDepth(param.depth);
	        }
	
	        this.opcode('getContext', param.depth || 0);
	        this.opcode('pushStringParam', param.stringModeValue, param.type);
	      } else {
	        this[param.type](param);
	      }
	    }
	  },
	
	  setupMustacheParams: function(mustache) {
	    var params = mustache.params;
	    this.pushParams(params);
	
	    if(mustache.hash) {
	      this.hash(mustache.hash);
	    } else {
	      this.opcode('emptyHash');
	    }
	
	    return params;
	  },
	
	  // this will replace setupMustacheParams when we're done
	  setupFullMustacheParams: function(mustache, program, inverse) {
	    var params = mustache.params;
	    this.pushParams(params);
	
	    this.opcode('pushProgram', program);
	    this.opcode('pushProgram', inverse);
	
	    if(mustache.hash) {
	      this.hash(mustache.hash);
	    } else {
	      this.opcode('emptyHash');
	    }
	
	    return params;
	  }
	};
	
	function precompile(input, options) {
	  if (input == null || (typeof input !== 'string' && input.constructor !== AST.ProgramNode)) {
	    throw new Exception("You must pass a string or Handlebars AST to Handlebars.precompile. You passed " + input);
	  }
	
	  options = options || {};
	  if (!('data' in options)) {
	    options.data = true;
	  }
	
	  var ast = parse(input);
	  var environment = new Compiler().compile(ast, options);
	  return new JavaScriptCompiler().compile(environment, options);
	}
	
	exports.precompile = precompile;function compile(input, options, env) {
	  if (input == null || (typeof input !== 'string' && input.constructor !== AST.ProgramNode)) {
	    throw new Exception("You must pass a string or Handlebars AST to Handlebars.compile. You passed " + input);
	  }
	
	  options = options || {};
	
	  if (!('data' in options)) {
	    options.data = true;
	  }
	
	  var compiled;
	
	  function compileInput() {
	    var ast = parse(input);
	    var environment = new Compiler().compile(ast, options);
	    var templateSpec = new JavaScriptCompiler().compile(environment, options, undefined, true);
	    return env.template(templateSpec);
	  }
	
	  // Template is only compiled on first use and cached after that point.
	  return function(context, options) {
	    if (!compiled) {
	      compiled = compileInput();
	    }
	    return compiled.call(this, context, options);
	  };
	}
	
	exports.compile = compile;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var SafeString = __webpack_require__(90)["default"];
	
	var isArray = Array.isArray;
	
	var escape = {
	  "&": "&amp;",
	  "<": "&lt;",
	  ">": "&gt;",
	  '"': "&quot;",
	  "'": "&#x27;",
	  "`": "&#x60;"
	};
	
	var badChars = /[&<>"'`]/g;
	var possible = /[&<>"'`]/;
	
	function escapeChar(chr) {
	  return escape[chr] || "&amp;";
	}
	
	function extend(obj, value) {
	  for(var key in value) {
	    if(value.hasOwnProperty(key)) {
	      obj[key] = value[key];
	    }
	  }
	}
	
	exports.extend = extend;function escapeExpression(string) {
	  // don't escape SafeStrings, since they're already safe
	  if (string instanceof SafeString) {
	    return string.toString();
	  } else if (!string && string !== 0) {
	    return "";
	  }
	
	  // Force a string conversion as this will be done by the append regardless and
	  // the regex test will do this transparently behind the scenes, causing issues if
	  // an object's to string has escaped characters in it.
	  string = "" + string;
	
	  if(!possible.test(string)) { return string; }
	  return string.replace(badChars, escapeChar);
	}
	
	exports.escapeExpression = escapeExpression;function isEmpty(value) {
	  if (!value && value !== 0) {
	    return true;
	  } else if (isArray(value) && value.length === 0) {
	    return true;
	  } else {
	    return false;
	  }
	}
	
	exports.isEmpty = isEmpty;

/***/ }),
/* 68 */
/***/ (function(module, exports) {

	"use strict";
	
	window.fos && window.fos.Router && window.fos.Router.setData({ "base_url": "", "routes": { "allt_old_price_offers.price": { "tokens": [["text", "\/package\/old-price\/offers"]], "defaults": [], "requirements": [], "hosttokens": [] }, "allt_frontend.package.home": { "tokens": [["text", "\/package"]], "defaults": [], "requirements": [], "hosttokens": [] }, "allt_frontend.package.update_count": { "tokens": [["text", "\/package\/updatecount\/"]], "defaults": [], "requirements": [], "hosttokens": [] }, "allt_frontend.package.destination": { "tokens": [["text", "\/package\/destination"]], "defaults": [], "requirements": [], "hosttokens": [] }, "allt_frontend.package.destination.accordion_content": { "tokens": [["text", "\/package\/accordion\/"]], "defaults": [], "requirements": [], "hosttokens": [] }, "allt_frontend.package.destination.accordion_offers": { "tokens": [["text", "\/package\/accordion\/offers\/"]], "defaults": [], "requirements": { "groupId": "\\d+" }, "hosttokens": [] }, "allt_frontend.package.destination.accordion_short_detail": { "tokens": [["variable", "\/", "\\d+", "hotelId"], ["text", "\/package\/accordion\/short\/detail"]], "defaults": [], "requirements": { "hotelId": "\\d+" }, "hosttokens": [] }, "allt_frontend.package.destination.accordion_detail": { "tokens": [["variable", "\/", "\\d+", "hotelId"], ["text", "\/package\/accordion\/detail"]], "defaults": [], "requirements": { "hotelId": "\\d+" }, "hosttokens": [] }, "allt_frontend.package.detail": { "tokens": [["variable", "-", "\\d+", "hotelId"], ["variable", "\/", "[\\w\\-]+", "hotelSlug"], ["text", "\/package\/detail"]], "defaults": [], "requirements": { "hotelId": "\\d+", "hotelSlug": "[\\w\\-]+" }, "hosttokens": [] }, "allt_frontend.package.detail.offers": { "tokens": [["variable", "\/", "\\d+", "hotelId"], ["text", "\/package\/detail\/offers"]], "defaults": [], "requirements": { "hotelId": "\\d+" }, "hosttokens": [] }, "allt_frontend.package.detail.offer_check": { "tokens": [["text", "\/package\/detail\/offer_check"]], "defaults": [], "requirements": [], "hosttokens": [] }, "allt_frontend.package.detail.alternatives": { "tokens": [["variable", "\/", "\\d+", "hotelId"], ["text", "\/package\/detail\/alternatives"]], "defaults": [], "requirements": { "hotelId": "\\d+" }, "hosttokens": [] }, "allt_frontend.hotel.update_count": { "tokens": [["text", "\/hotelonly\/updatecount\/"]], "defaults": [], "requirements": [], "hosttokens": [] }, "allt_frontend.hotel.destination": { "tokens": [["text", "\/hotelonly\/destination"]], "defaults": [], "requirements": [], "hosttokens": [] }, "allt_frontend.hotel.destination.accordion_content": { "tokens": [["text", "\/hotelonly\/accordion\/"]], "defaults": [], "requirements": [], "hosttokens": [] }, "allt_frontend.hotel.destination.accordion_offers": { "tokens": [["text", "\/hotelonly\/accordion\/offers\/"]], "defaults": [], "requirements": { "groupId": "\\d+" }, "hosttokens": [] }, "allt_frontend.hotel.destination.accordion_detail": { "tokens": [["variable", "\/", "\\d+", "hotelId"], ["text", "\/hotelonly\/accordion\/detail"]], "defaults": [], "requirements": { "hotelId": "\\d+" }, "hosttokens": [] }, "allt_frontend.hotel.detail": { "tokens": [["variable", "-", "\\d+", "hotelId"], ["variable", "\/", "[\\w\\-]+", "hotelSlug"], ["text", "\/hotelonly\/detail"]], "defaults": [], "requirements": { "hotelId": "\\d+", "hotelSlug": "[\\w\\-]+" }, "hosttokens": [] }, "allt_frontend.hotel.detail.offers": { "tokens": [["variable", "\/", "\\d+", "hotelId"], ["text", "\/hotelonly\/detail\/offers"]], "defaults": [], "requirements": { "hotelId": "\\d+" }, "hosttokens": [] }, "allt_frontend.hotel.detail.reviews": { "tokens": [["variable", "\/", "\\d+", "hotelId"], ["text", "\/hotelonly\/detail\/reviews"]], "defaults": [], "requirements": { "hotelId": "\\d+" }, "hosttokens": [] }, "allt_frontend.hotel.detail.reviews.picture": { "tokens": [["variable", "\/", "\\d+", "hotelId"], ["text", "\/hotelonly\/detail\/reviews\/pictures"]], "defaults": [], "requirements": { "hotelId": "\\d+" }, "hosttokens": [] }, "allt_frontend.hotel.detail.reviews.video": { "tokens": [["variable", "\/", "\\d+", "hotelId"], ["text", "\/hotelonly\/detail\/reviews\/videos"]], "defaults": [], "requirements": { "hotelId": "\\d+" }, "hosttokens": [] }, "allt_frontend.hotel.detail.package_offer": { "tokens": [["variable", "\/", "\\d+", "hotelId"], ["text", "\/hotelonly\/detail\/packageoffer"]], "defaults": [], "requirements": { "hotelId": "\\d+" }, "hosttokens": [] }, "allt_frontend.favorites.count": { "tokens": [["text", "\/favorites\/count\/"]], "defaults": [], "requirements": [], "hosttokens": [] }, "allt_frontend.favorites.add": { "tokens": [["text", "\/favorites\/add\/"]], "defaults": [], "requirements": [], "hosttokens": [] }, "allt_frontend.favorites.remove": { "tokens": [["text", "\/favorites\/remove\/"]], "defaults": [], "requirements": [], "hosttokens": [] }, "fcse_ferien_kalender.event_list": { "tokens": [["variable", "\/", "[^\/]++", "id"], ["text", "\/events"]], "defaults": [], "requirements": [], "hosttokens": [] }, "allt_frontend.zoover": { "tokens": [["variable", "\/", "\\w+", "sorting"], ["variable", "\/", "\\d+", "page"], ["variable", "\/", ".+", "requestId"], ["text", "\/zoover"]], "defaults": { "sorting": "recent" }, "requirements": { "requestId": ".+", "page": "\\d+", "perPage": "\\d+", "sorting": "\\w+" }, "hosttokens": [] }, "allt_frontend.nonebookable.detail.content": { "tokens": [["text", ".html"], ["variable", "\/", "[\\w\\-]+", "productCode"], ["variable", "\/", "[\\w\\-]+", "season"], ["text", "\/hotelinfos"]], "defaults": [], "requirements": { "season": "[\\w\\-]+", "productCode": "[\\w\\-]+" }, "hosttokens": [] }, "allt_frontend.hotel_content_season_fallback": { "tokens": [["variable", "\/", ".+", "seasonsAndCodes"], ["text", "\/hotelcontent\/seasonfallback"]], "defaults": [], "requirements": { "seasonsAndCodes": ".+" }, "hosttokens": [] }, "newsletter": { "tokens": [["text", "\/newsletter"]], "defaults": [], "requirements": [], "hosttokens": [] }, "newsletter_submit": { "tokens": [["text", "\/newsletter\/submit"]], "defaults": [], "requirements": [], "hosttokens": [] }, "homepage": { "tokens": [["text", "\/"]], "defaults": [], "requirements": [], "hosttokens": [] }, "pmpage": { "tokens": [["text", "\/test-page"]], "defaults": [], "requirements": [], "hosttokens": [] }, "pressteaserpage": { "tokens": [["text", "\/test-page2"]], "defaults": [], "requirements": [], "hosttokens": [] }, "newspage": { "tokens": [["text", "\/test-page3"]], "defaults": [], "requirements": [], "hosttokens": [] }, "allt_frontend.index": { "tokens": [["text", "\/oldhomepage"]], "defaults": [], "requirements": [], "hosttokens": [] }, "allt_frontend.offer_check": { "tokens": [["text", "\/offer_check"]], "defaults": [], "requirements": [], "hosttokens": [] }, "allt_frontend.get_hotel_rating": { "tokens": [["variable", "\/", "[^\/]++", "ratingId"], ["variable", "\/", "[^\/]++", "iffCode"], ["text", "\/tt\/get_hotel_rating"]], "defaults": [], "requirements": [], "hosttokens": [] }, "allt_frontend.get_hotel_ratings": { "tokens": [["variable", "\/", "[^\/]++", "page"], ["variable", "\/", "[^\/]++", "travelledAs"], ["variable", "\/", "[^\/]++", "iffCode"], ["text", "\/tt\/get_hotel_ratings"]], "defaults": [], "requirements": [], "hosttokens": [] }, "allt_frontend.ssg.search_hotels": { "tokens": [["variable", "\/", ".*", "term"], ["variable", "\/", "[^\/]++", "type"], ["text", "\/ssg_search\/hotel"]], "defaults": { "type": "hotel_suggestion,hotel_only_suggestion", "term": "" }, "requirements": { "term": ".*" }, "hosttokens": [] }, "allt_frontend.ssg.search_destinations": { "tokens": [["variable", "\/", ".*", "term"], ["text", "\/ssg_search\/destination"]], "defaults": { "term": "" }, "requirements": { "term": ".*" }, "hosttokens": [] }, "allt_frontend.user_tracking.last_visited": { "tokens": [["variable", "\/", "\\d+", "page"], ["variable", "\/", "visited_hotels", "type"], ["text", "\/user_tracking\/last_visited"]], "defaults": { "type": "visited_hotels", "page": 1 }, "requirements": { "type": "visited_hotels", "page": "\\d+" }, "hosttokens": [] }, "allt_frontend.traveltainment.rating_content": { "tokens": [["text", "\/traveltainment_rating"]], "defaults": [], "requirements": [], "hosttokens": [] }, "allt_frontend.map.places_preflight": { "tokens": [["text", "\/map_places_preflight"]], "defaults": [], "requirements": [], "hosttokens": [] }, "allt_frontend.map.places": { "tokens": [["text", "\/map_places"]], "defaults": [], "requirements": [], "hosttokens": [] }, "allt_frontend.map.place_details": { "tokens": [["text", "\/map_place_details"]], "defaults": [], "requirements": [], "hosttokens": [] }, "allt_frontend.offer.matrix": { "tokens": [["text", "\/package\/detail\/matrix"]], "defaults": [], "requirements": [], "hosttokens": [] } }, "prefix": "", "host": "localhost", "scheme": "http" });
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	}();

	;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(3), __webpack_require__(14), __webpack_require__(160)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, _, Url, TravelsearchMetadata) {
	
	        /**
	         * Custom converters for scope => query transformation
	         */
	        var customConvertersToQuery = {
	            bool: function (value) {
	                //backend expects int here
	                return value ? 1 : 0;
	            }
	        };
	
	        /**
	         * Custom converters for query => scope transformation
	         */
	        var customConvertersFromQuery = {
	            int: function (value) {
	                return parseInt(value, 10);
	            },
	            float: function (value) {
	                return parseFloat(value);
	            },
	            bool: function (value) {
	                return "true" == value || value > 0;
	            }
	        };
	
	        var ParamConverter = { };
	
	        ParamConverter.convertParamToQuery = function (name, value, url) {
	            var nameWithoutPrefix = name.replace(/.+\./, "");
	            if (nameWithoutPrefix in TravelsearchMetadata) {
	                var convert = function (value) {
	                    return value.toString();
	                };
	                if (TravelsearchMetadata[nameWithoutPrefix].type in customConvertersToQuery) {
	                    convert = customConvertersToQuery[TravelsearchMetadata[nameWithoutPrefix].type];
	                }
	                if (TravelsearchMetadata[nameWithoutPrefix].array) {
	                    if (!$.isArray(value)) {
	                        throw new Error("Parameter " + name + " is supposed to be an array but it's not.");
	                    }
	                    if (value.length) {
	                        url[name] = _.map(value, convert).join(";");
	                    } else {
	                        delete url[name];
	                    }
	                } else {
	                    url[name] = convert(value);
	                }
	            } else if ($.isArray(value)) {
	                url[name] = value.join(";");
	            } else {
	                url[name] = value;
	            }
	        };
	
	        ParamConverter.convertParamFromQuery = function (name, value, params) {
	            var nameWithoutPrefix = name.replace(/.+\./, "");
	            if (nameWithoutPrefix in TravelsearchMetadata) {
	                var convert = function (value) {
	                    return value;
	                };
	                if (TravelsearchMetadata[nameWithoutPrefix].type in customConvertersFromQuery) {
	                    convert = customConvertersFromQuery[TravelsearchMetadata[nameWithoutPrefix].type];
	                }
	                if (TravelsearchMetadata[nameWithoutPrefix].array) {
	                    params[name] = _.map(value.split(";"), convert);
	                } else {
	                    params[name] = convert(value);
	                }
	            } else {
	                //unknown custom parameter not in Travelsearch
	                params[name] = value;
	            }
	        };
	
	        ParamConverter.convertParams = function (params, url) {
	            var queryKeys = _.keys(url.query);
	            var common = _.intersection(_.keys(params), queryKeys);
	            // cleanup params which are already in url.query but not in scope.params.
	            _.each(_.difference(queryKeys, common), function (key) {
	                url.query[key] = null;
	            });
	
	            for (var param in params) {
	                if (params.hasOwnProperty(param)) {
	                    ParamConverter.convertParamToQuery(param, params[param], url.query);
	                }
	            }
	            // temporary cleanup to avoid empty params from going to query.
	            _.each(url.query, function (value, key, obj) {
	                if ((_.isObject(value) || _.isString(value) ||
	                    value === null || value === undefined) &&
	                    _.isEmpty(value)) {
	                    // Do not delete primitive type values (underscore counts
	                    // them as empty objects) -- AG.
	                    delete obj[key];
	                }
	            });
	        };
	
	        ParamConverter.convertQuery = function (query, params) {
	            for (var param in query) {
	                if (query.hasOwnProperty(param)) {
	                    ParamConverter.convertParamFromQuery(param, query[param], params);
	                }
	            }
	        };
	
	        ParamConverter.toQuery = function (params) {
	            var url = new Url();
	            ParamConverter.convertParams(params, url);
	            return url.query;
	        };
	
	        ParamConverter.fromQuery = function (url) {
	            var query = {},
	                hash = {};
	            ParamConverter.convertQuery(url.query, query);
	            ParamConverter.convertQuery(url.hash, hash);
	            //hash takes preference
	            var merged = _.extend({}, query, hash);
	            return {
	                query: query,
	                hash: hash,
	                merged: merged
	            }
	        };
	
	        return ParamConverter;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(26);
	var document = __webpack_require__(6).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(1),
	    __webpack_require__(11)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function($, EventDispatcher) {
	        /**
	         * Visiblity Controll
	         *
	         * @param selector
	         * @constructor
	         */
	        var VisibilityControl = function (selector, options) {
	            EventDispatcher.apply(this, arguments);
	            //Set elements
	            this._elements = $(selector);
	
	            //Set options
	            var defaultOptions = {
	                // The attribute for the target selector of the element
	                'targetSelectorAttribute': 'data-target',
	
	                // The class name that the caller element (button) has when target is hidden
	                'elementTargetIsHiddenClass': 'is-targethidden',
	
	                // THe class name that caller element has when target is visible
	                'elementTargetIsVisibleClass': 'is-targetvisible',
	
	                // Class name of target when hidden
	                'targetIsHiddenClass': 'is-hidden',
	
	                // Class name of target when visible
	                'targetIsVisibleClass': 'is-visible',
	
	                // Animation duration in ms or jQuery animation speed keyword
	                'animationDuration': 'fast',
	
	                // If set to true, the labels will be exchanged
	                'exchangeLabel': false,
	
	                // Exchange label selector
	                'exchangeLabelSelector': '[data-label-visible]',
	
	                // True if we should see only one element under visibility control at a single moment of time
	                'showSingleElement': false,
	
	                // Defines group behavior. Useful for display flyouts simultaneously
	                'groupExclude': true 
	            };
	            this.addOptions(defaultOptions, options);
	
	            this.registerEvent('close');
	            this.registerEvent('open');
	            this.registerEvent('beforeOpen');
	
	            this._initListeners();
	        };
	
	        VisibilityControl.prototype = $.extend(Object.create(EventDispatcher.prototype), {
	            /**
	             * Initializes listeners
	             * @returns {undefined}
	             */
	            _initListeners: function(){
	                this._elements.on('click', $.proxy(this._onElementClick, this));
	            },
	
	            /**
	             * Element click handler
	             * @param {type} event
	             * @returns {undefined}
	             */
	            _onElementClick: function(event){
	                var $element = $(event.currentTarget);
	
	                var $target = $($element.attr(this.option('targetSelectorAttribute')));
	
	                // Stop propagation if oustideclick close is enabled to prevent immediate close
	                if ($element.attr('data-outsideclick-close') == '1'){
	                    event.stopPropagation();
	                }
	
	                this.toggleTarget($element, $target);
	            },
	
	            /**
	             * When destroying the component
	             * @returns {undefined}
	             */
	            destroy: function(){
	                this._elements.on('click', $.proxy(this._onElementClick, this));
	            },
	
	            /**
	             * Toggle visibility of target
	             * @param {type} element
	             * @param {type} target
	             * @returns {undefined}
	             */
	            toggleTarget: function(element, target){
	                if (target.hasClass(this.option('targetIsHiddenClass'))){
	                    this.openTarget(element, target);
	                } else {
	                    this.closeTarget(element, target);
	                }
	            },
	
	            /**
	             * Open target
	             * @param {type} element
	             * @param {type} target
	             * @returns {undefined}
	             */
	            openTarget: function(element, target){
	                var self = this;
	
	                if (this.option('showSingleElement')) {
	                    $(this._elements).each(function(idx, elem) {
	                        var $elem = $(elem);
	                        var shouldNotHide = $elem.attr('data-group') === $(element).attr('data-group');
	                        if (self.option('groupExclude')) {
	                            shouldNotHide = !shouldNotHide;
	                        }
	                        if ($(element).attr('data-group') && shouldNotHide) {
	                            return;
	                        }
	                        $elem.addClass(self.option('elementTargetIsHiddenClass'));
	                        $($elem.attr('data-target')).addClass(self.option('targetIsHiddenClass'));
	                    });
	                }
	
	                // Fire up beforeOpen hook
	                this.dispatchEvent('beforeOpen', element, target);
	
	                //Show target
	                $(target).addClass(this.option('targetIsVisibleClass'));
	                $(target).removeClass(this.option('targetIsHiddenClass'));
	
	                //Change classes on caller element
	                $(element).removeClass(this.option('elementTargetIsHiddenClass'));
	                $(element).addClass(this.option('elementTargetIsVisibleClass'));
	
	                //Change labels on caller element if enabled
	                if (this.option('exchangeLabel')){
	                    $(this.option('exchangeLabelSelector'), element).each(function(index, labelElement){
	                        $(labelElement).text($(labelElement).attr('data-label-visible'));
	                    });
	                }
	
	                //Attach close handler on outside click (for tooltips, flyouts etc.)
	                if ($(element).attr('data-outsideclick-close') == '1'){
	                    $('html').on('click', $.proxy(this.closeTarget, this, element, target));
	                    $(target).on('click', this._stopEventPropagation);
	
	                }
	
	                //Attach close handler on closebutton elements
	                $('[data-fcse-role="visibilitycontrol--closebutton"]', target).on('click',
	                    $.proxy(this.closeTarget, this, element, target));
	
	                //Animate target
	                var effect = $(target).attr('data-show-effect');
	                switch (effect){
	                    case 'fade': {
	                        $(target).hide().fadeIn(this.option('animationDuration'));
	                        break;
	                    }
	                    case 'slide': {
	                        $(target).hide().slideDown(this.option('animationDuration'));
	                        break;
	                    }
	                    case 'slidefade': {
	                        $(target).hide().slideDown(this.option('animationDuration'))
	                            .css({opacity:0})
	                            .animate({opacity: 1}, this.option('animationDuration'));
	                        break;
	                    }
	                }
	                this.dispatchEvent('open', $(target));
	            },
	
	            /**
	             * Stops event propagation
	             * @param {type} e
	             * @returns {undefined}
	             */
	            _stopEventPropagation: function(e){
	                e.stopPropagation();
	            },
	
	            /**
	             * Close target
	             * @param {type} element
	             * @param {type} target
	             * @returns {undefined}
	             */
	            closeTarget: function(element, target, e){
	                //Hide target
	                if (typeof(e) !== 'undefined') {
	                    e.stopPropagation();
	                }
	                $(target).removeClass(this.option('targetIsVisibleClass'));
	                $(target).addClass(this.option('targetIsHiddenClass'));
	
	                //Change classes on caller element
	                $(element).addClass(this.option('elementTargetIsHiddenClass'));
	                $(element).removeClass(this.option('elementTargetIsVisibleClass'));
	
	                //Remove close handler on outside click (for tooltips, flyouts etc.)
	                $(target).off('click', this._stopEventPropagation);
	                $('html').off('click', $.proxy(this.closeTarget, this, element, target));
	
	
	                //Change labels on caller element if enabled
	                if (this.option('exchangeLabel')){
	                    $(this.option('exchangeLabelSelector'), element).each(function(index, labelElement){
	                        $(labelElement).text($(labelElement).attr('data-label-hidden'));
	                    });
	                }
	
	                //Animate target
	                var effect = $(target).attr('data-hide-effect');
	                switch (effect){
	                    case 'fade': {
	                        $(target).hide().fadeOut(this.option('animationDuration'));
	                        break;
	                    }
	                    case 'slide': {
	                        $(target).hide().slideUp(this.option('animationDuration'));
	                        break;
	                    }
	                    case 'slidefade': {
	                        $(target).hide().css({opacity:1, display: 'inherit'})
	                            .animate({opacity: 0}, this.option('animationDuration'))
	                            .slideUp(this.option('animationDuration'));
	                        break;
	                    }
	                }
	
	                this.dispatchEvent('close', $(target));
	            },
	
	
	
	            /**
	             * Internal variable to store configuration values
	             */
	            _options: {},
	
	            /**
	             * Adds options to the component.
	             * The parameter options will overwrite the defaults
	             * @param {object} defaults
	             * @param {object|undefined} options
	             * @returns {undefined}
	             */
	            addOptions: function(defaults, options){
	                this._options = $.extend({}, this.getOptions(), defaults, options || {});
	            },
	
	            /**
	             * Returns an object of all configuration options of the component
	             * @returns {undefined|Object}
	             */
	            getOptions: function(){
	                return this._options;
	            },
	
	            /**
	             * Gets or sets option
	             * @param name
	             * @param value optional
	             */
	            option: function (name, value) {
	                if (!_.isUndefined(value)) {
	                    this._options[name] = value;
	                }
	                return this._options[name];
	            }
	        });
	
	        return VisibilityControl;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(155);
	
	__webpack_require__(68);
	
	var Router = window.fos && window.fos.Router;
	
	module.exports = Router;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(Router, 'Router', '/home/jenkins/agent/workspace/ALLSUN_Deploy_to_Prod/src/Allt/FrontendBundle/Resources/assets/util/router.js');
	}();

	;

/***/ }),
/* 73 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(18) && !__webpack_require__(32)(function () {
	  return Object.defineProperty(__webpack_require__(70)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(10);
	var toIObject = __webpack_require__(21);
	var arrayIndexOf = __webpack_require__(103)(false);
	var IE_PROTO = __webpack_require__(50)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(52);
	var $export = __webpack_require__(39);
	var redefine = __webpack_require__(28);
	var hide = __webpack_require__(15);
	var has = __webpack_require__(10);
	var Iterators = __webpack_require__(49);
	var $iterCreate = __webpack_require__(131);
	var setToStringTag = __webpack_require__(53);
	var getPrototypeOf = __webpack_require__(136);
	var ITERATOR = __webpack_require__(7)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(75);
	var hiddenKeys = __webpack_require__(48).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(127), __esModule: true };

/***/ }),
/* 79 */,
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(114);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(113);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(3), __webpack_require__(4), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, _, Widget, Object) {
	
	    var GlobalTypeWidget = function GlobalTypeWidget(element, options) {
	        // GT-Codes
	        this.gtcodes = $(element).data("initial-gtcodes");
	
	        // Default Options
	        var defaultOptions = {
	            hiddenClassName: 'is-hidden',
	            activeClassName: 'is-active',
	            collapsedClassName: 'is-collapsed',
	            prefix: 'hotelAttributes_',
	            delimiter: ';'
	        };
	
	        //Add default options and custom options
	        this.addOptions(defaultOptions, options);
	
	        // Widget Apply
	        Widget.apply(this, arguments);
	
	        // Initialize
	        this._init();
	    };
	
	    GlobalTypeWidget.prototype = $.extend(Object.create(Widget.prototype), {
	        /**
	         * Initialize Widget
	         * 
	         */
	        _init: function _init() {
	            // Register Clickhandler to globaltype elements
	            $('[data-fcse-role="globaltypewidget--element"]', this.element).on('click', $.proxy(this._clickHandler, this));
	
	            // Register moreListitems-Clickhandler
	            $('[data-fcse-role="globaltypewidget--listmorebutton"]', this.element).on('click', $.proxy(this._moreListItemsClickHandler, this));
	
	            // Register listItem-Clickhandler
	            $('[data-fcse-role="globaltypewidget--list-item"]', this.element).find('input:checkbox').on('change', $.proxy(this._listItemclickHandler, this));
	
	            // Check for hidden elements
	            this._checkHiddenElements();
	        },
	
	        /**
	         * Check for hidden elements by GT-Code and display each
	         * 
	         */
	        _checkHiddenElements: function _checkHiddenElements() {
	            var self = this;
	            $('ul.' + this.option('hiddenClassName') + ' > li.' + this.option('activeClassName'), this.element).each(function (index, elementSelector) {
	                // Get Element
	                var element = $(elementSelector);
	                var container = element.closest('[data-fcse-role="globaltypewidget--list"]');
	
	                // Display all sub-elements of container, that are hidden
	                container.find('ul.' + self.option('hiddenClassName')).removeClass(self.option('hiddenClassName')).addClass(self.option('collapsedClassName'));
	
	                // Remove "more"-button
	                container.find('[data-fcse-role="globaltypewidget--listmorebutton"]').addClass(self.option('hiddenClassName'));
	            });
	        },
	
	        /**
	        * Convert GT-Codes to value
	        * 
	        * @param value
	        */
	        _processData: function _processData(value) {
	            var params = {};
	            var self = this;
	
	            // Get selected top-level values
	            $('[data-fcse-role="globaltypewidget--element"]', self.element).each(function (index, elementSelector) {
	                var element = $(elementSelector);
	                var id = element.data('id');
	
	                if ($.inArray(element.data('code'), self.gtcodes) >= 0) {
	                    params[id] = element.data('code');
	                }
	            });
	
	            // Get selected list-items
	            $('[data-fcse-role="globaltypewidget--list-item"]', self.element).each(function (index, elementSelector) {
	                var element = $(elementSelector);
	                var elementid = element.data('elementid');
	
	                if ($.inArray(element.data('code'), self.gtcodes) >= 0) {
	                    params[elementid] += self.option('delimiter') + element.data('code');
	                }
	            });
	
	            return params;
	        },
	
	        /**
	         * MoreListItems Click handler
	         * 
	         * @param event
	         */
	        _moreListItemsClickHandler: function _moreListItemsClickHandler(event) {
	            var element = $(event.currentTarget);
	
	            // Display all elements of the selected list 
	            element.closest('[data-fcse-role="globaltypewidget--list"]').children('.' + this.option('hiddenClassName')).addClass(this.option('collapsedClassName')).removeClass(this.option('hiddenClassName'));
	
	            // Hide more-Button
	            element.addClass(this.option('hiddenClassName')).removeClass(this.option('collapsedClassName'));
	        },
	
	        /**
	         * ListItem Click handler
	         * 
	         * @param event
	         */
	        _listItemclickHandler: function _listItemclickHandler(event) {
	            var checkbox = $(event.currentTarget);
	
	            // Set/Unset active class
	            checkbox.closest('[data-fcse-role="globaltypewidget--list-item"]').toggleClass(this.option('activeClassName'));
	
	            // Set Values
	            this._propagateValues();
	        },
	
	        /**
	         * Click handler for main elements
	         * 
	         * @param event
	         */
	        _clickHandler: function _clickHandler(event) {
	            var element = $(event.currentTarget);
	
	            // Set/Unset active class
	            element.toggleClass(this.option('activeClassName'));
	
	            // Display list elements if any exist
	            this._displayListElements(element.data('id'));
	
	            // Set Values
	            this._propagateValues();
	        },
	
	        /**
	         * Display list elements of an main element
	         * 
	         * @param id
	         */
	        _displayListElements: function _displayListElements(id) {
	            var element = $('[data-fcse-role="globaltypewidget--list"][data-id="' + id + '"]', this.element);
	
	            if (element.hasClass(this.option('hiddenClassName'))) {
	                // Remove hidden class
	                element.removeClass(this.option('hiddenClassName'));
	            } else {
	                // Add hidden Class
	                element.addClass(this.option('hiddenClassName'));
	
	                // Remove active class from all list elements
	                var listitems = $('[data-fcse-role="globaltypewidget--list-item"]', element);
	                listitems.removeClass(this.option('activeClassName'));
	
	                // Uncheck all checkboxes of list items
	                listitems.find('input:checkbox').prop('checked', false);
	            }
	        },
	
	        /**
	         * Get Scope Binding Map
	         * (it is used in Widgetfactory to bind each GT-Scope to the rootscope)
	         * 
	         */
	        getScopeBindingMap: function getScopeBindingMap() {
	            var self = this;
	            var map = {};
	            $('[data-fcse-role="globaltypewidget--element"]', this.element).each(function (index, element) {
	                var id = $(element).data('id');
	                map[self.option('prefix') + id] = id;
	            });
	
	            return map;
	        },
	
	        setValue: function setValue(value) {
	            this.gtcodes = _.isObject(value) ? _.values(value) : [];
	            Widget.prototype.setValue.apply(this, arguments);
	        },
	
	        /**
	         * Set Value To UI
	         * 
	         */
	        setValueToUi: function setValueToUi() {
	            var self = this;
	
	            // Unselect elements
	            $('[data-fcse-role="globaltypewidget--element"]', this.element).removeClass(this.option('activeClassName'));
	
	            // Unselect list-elements
	            $('[data-fcse-role="globaltypewidget--list"]', this.element).addClass(this.option('hiddenClassName'));
	
	            // Activate GT-Codes
	            $.each(self.gtcodes, function (index, gtcode) {
	                gtcode = gtcode.split(self.option('delimiter'));
	                // Activate elements
	                var elements = $('[data-fcse-role="globaltypewidget--element"][data-code="' + gtcode[0] + '"]', self.element);
	                elements.addClass(self.option('activeClassName'));
	
	                // Display list elements of active elements
	                elements.each(function (index, elementSelector) {
	                    var element = $(elementSelector);
	                    self._displayListElements(element.data('id'));
	                });
	            });
	        },
	
	        /**
	         * Propagate values
	         * 
	         */
	        _propagateValues: function _propagateValues() {
	            // Get Values from UI
	            var val = this.getValueFromUi();
	
	            // Set UI Values to Scope
	            this.setValue(val);
	        },
	
	        /**
	         * Get Value From UI
	         * 
	         */
	        getValueFromUi: function getValueFromUi() {
	            var self = this;
	            var params = {};
	            self.gtcodes = [];
	
	            // Get selected top-level values
	            $('[data-fcse-role="globaltypewidget--element"]', this.element).each(function (index, elementSelector) {
	                var element = $(elementSelector);
	                var id = element.data('id');
	
	                if (element.hasClass(self.option('activeClassName'))) {
	                    params[id] = element.data('code');
	                    self.gtcodes.push(element.data('code'));
	                }
	            });
	
	            // Get selected list-items
	            $('[data-fcse-role="globaltypewidget--list-item"]', this.element).each(function (index, elementSelector) {
	                var element = $(elementSelector);
	                var elementid = element.data('elementid');
	
	                if (element.hasClass(self.option('activeClassName'))) {
	                    params[elementid] += self.option('delimiter') + element.data('code');
	                    self.gtcodes.push(element.data('code'));
	                }
	            });
	
	            return params;
	        }
	    });
	
	    GlobalTypeWidget.getScopeBindingMap = function () {
	        var map = {};
	        $('[data-fcse-role="globaltypewidget--element"]').each(function (index, element) {
	            var id = $(element).data('id');
	            map['hotelAttributes_' + id] = id;
	        });
	
	        return map;
	    };
	
	    return GlobalTypeWidget;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(3), __webpack_require__(4), __webpack_require__(2), __webpack_require__(63), __webpack_require__(62)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, _, Widget, Object) {
	
	    // TODO: refactor range feature
	    var SliderFilterWidget = function SliderFilterWidget(selector, options) {
	        Widget.call(this, selector, $.extend({
	            handleClass: 'selector'
	        }, options));
	
	        this._init();
	    };
	
	    SliderFilterWidget.prototype = $.extend(Object.create(Widget.prototype), {
	
	        _init: function _init() {
	            var $control = $(this.element);
	
	            var self = this;
	            var slider = $control.find('.slider');
	
	            if (!slider.length) return;
	
	            var steps = $.parseJSON($control.attr('data-steps'));
	            var snaps = _.map(steps, function (step) {
	                return parseInt(step.value);
	            });
	
	            this._nullValue = parseInt($control.data('null-value'));
	            this._nullValueText = $control.data('null-value-text');
	            this._minValueText = $control.data('min-value-text');
	            this._minValueTemplate = $control.data('min-value-template');
	            this._maxValueTemplate = $control.data('max-value-template');
	            this._valuePostfix = $control.data('value-postfix');
	            this._labelMin = $control.find('[data-fcse-role="slider-label-min"]');
	            this._labelMax = $control.find('[data-fcse-role="slider-label-max"]');
	            this._snaps = snaps;
	
	            this._internalNullValue = null;
	
	            // Replace null value internally to prevent weird slider behaviour with negative values
	            if (this._nullValue) {
	                if (snaps[snaps.length - 1] == this._nullValue) {
	                    this._internalNullValue = parseInt(snaps[snaps.length - 2]) + 100;
	                    snaps.pop();
	                    snaps.push(this._internalNullValue);
	                }
	            }
	
	            var value;
	
	            // Set value
	            if (this.getValue() === null || typeof this.getValue() === 'undefined') {
	                if (this._internalNullValue) {
	                    value = [snaps[0], this._internalNullValue];
	                } else {
	                    value = [snaps[0], snaps[snaps.length - 1]];
	                }
	            } else {
	                if (this.getValue()[1] == this._nullValue) {
	                    value = [this.getValue()[0], this._internalNullValue];
	                } else {
	                    value = this.getValue();
	                }
	            }
	
	            var distribution = _.map(snaps, function (value) {
	                return parseInt(value);
	            });
	
	            slider.xslider({
	                min: parseInt(snaps[0]),
	                max: parseInt(snaps[snaps.length - 1]),
	                values: value,
	                snaps: snaps,
	                range: true,
	                distribution: distribution,
	                slide: function slide(event, ui) {
	                    self._updateLabel(ui.values);
	                },
	                stop: function stop(event, ui) {
	                    if (ui.values[1] == self._internalNullValue) {
	                        self.setValue([ui.values[0], self._nullValue]);
	                    } else {
	                        self.setValue(ui.values);
	                    }
	                },
	                create: function create(event, ui) {
	                    $('.ui-slider-handle', this).addClass(self.option('handleClass'));
	                }
	            });
	        },
	
	        _processData: function _processData(value) {
	            return _.map(value, function (val) {
	                return parseInt(val);
	            });
	        },
	
	        _updateLabel: function _updateLabel(values) {
	            var label = '';
	            if (this._labelMin && this._labelMin.length) {
	
	                if (values[0] == this._snaps[0]) {
	                    label = this._minValueText;
	                } else {
	                    if (this._minValueTemplate) {
	                        label = this._minValueTemplate.replace('%d', values[0]);
	                    }
	                    if (this._valuePostfix) {
	                        label = label + '' + this._valuePostfix;
	                    }
	                }
	                this._labelMin.text(label);
	            }
	            if (this._labelMax && this._labelMax.length) {
	                if (values[1] == this._internalNullValue || values[1] == this._nullValue) {
	                    label = this._nullValueText;
	                } else {
	                    if (this._maxValueTemplate) {
	                        label = this._maxValueTemplate.replace('%d', values[1]);
	                    }
	                    if (this._valuePostfix) {
	                        label = label + '' + this._valuePostfix;
	                    }
	                }
	                this._labelMax.text(label);
	            }
	        },
	
	        setValueToUi: function setValueToUi() {
	            if (this.value === null) {
	                return;
	            }
	
	            var slider = $(this.element).find('.slider');
	
	            if (!_.isEqual(this.value, slider.xslider('xvalues'))) {
	                if (this.value[1] == this._nullValue) {
	                    // Set internal null value to allow negative numbers
	                    slider.xslider('xvalues', [this.value[0], this._internalNullValue]);
	                } else {
	                    slider.xslider('xvalues', this.value);
	                }
	
	                this._updateLabel(this.value);
	            }
	        },
	        getValueFromUi: function getValueFromUi() {}
	    });
	
	    return SliderFilterWidget;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(3), __webpack_require__(4), __webpack_require__(2), __webpack_require__(63), __webpack_require__(62)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, _, Widget, Object) {
	
	    var RatingSliderRangeFilterWidget = function RatingSliderRangeFilterWidget(selector, options) {
	        Widget.call(this, selector, $.extend({
	            handleClass: 'selector'
	        }, options));
	
	        this._init();
	    };
	
	    RatingSliderRangeFilterWidget.prototype = $.extend(Object.create(Widget.prototype), {
	
	        _init: function _init() {
	            var $control = $(this.element);
	
	            var self = this;
	            var slider = $control.find('.slider');
	
	            if (!slider.length) return;
	
	            var snaps = _.range(0, 101, 1);
	
	            this._snaps = snaps;
	            this._labelMin = $control.find('[data-fcse-role="slider-label-min"]');
	            this._labelMax = $control.find('[data-fcse-role="slider-label-max"]');
	            this._valuePostfix = $control.data('value-postfix');
	            this._maxValue = parseFloat($control.data('max-value'));
	
	            var value;
	
	            // Set value
	            if (this.getValue() === null || typeof this.getValue() === 'undefined') {
	                value = [snaps[0], snaps[snaps.length - 1]];
	            } else {
	                value = this._convertToSlider(this.getValue());
	            }
	
	            slider.xslider({
	                min: parseInt(snaps[0]),
	                max: parseInt(snaps[snaps.length - 1]),
	                values: value,
	                snaps: snaps,
	                range: true,
	                distribution: snaps,
	                slide: function slide(event, ui) {
	                    self._updateLabel(ui.values);
	                },
	                stop: function stop(event, ui) {
	                    var val = self._convertToValue(ui.values);
	                    self.setValue(val);
	                },
	                create: function create(event, ui) {
	                    $('.ui-slider-handle', this).addClass(self.option('handleClass'));
	                }
	            });
	            this._updateLabel(value);
	        },
	
	        _processData: function _processData(value) {
	            return value;
	        },
	
	        _updateLabel: function _updateLabel(values) {
	            var label = '';
	            if (this._labelMin.length) {
	                label = values[0];
	                if (this._valuePostfix) {
	                    label += this._valuePostfix;
	                }
	
	                this._labelMin.text(label);
	            }
	            if (this._labelMax.length) {
	                label = values[1];
	                if (this._valuePostfix) {
	                    label += this._valuePostfix;
	                }
	                this._labelMax.text(label);
	            }
	        },
	
	        setValueToUi: function setValueToUi() {
	            if (this.value === null) {
	                return;
	            }
	
	            var slider = $(this.element).find('.slider');
	
	            if (!_.isEqual(this.value, this._convertToValue(slider.xslider('xvalues')))) {
	                var sliderVal = this._convertToSlider(this.value);
	                slider.xslider('xvalues', sliderVal);
	
	                this._updateLabel(sliderVal);
	            }
	        },
	        getValueFromUi: function getValueFromUi() {},
	
	        _convertToValue: function _convertToValue(values) {
	            var minVal = values[0] * this._maxValue / 100;
	            var maxVal = values[1] * this._maxValue / 100;
	
	            return [minVal, maxVal];
	        },
	
	        _convertToSlider: function _convertToSlider(values) {
	            var minVal = values[0] * 100 / this._maxValue;
	            var maxVal = values[1] * 100 / this._maxValue;
	
	            return [minVal, maxVal];
	        }
	    });
	
	    return RatingSliderRangeFilterWidget;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Created by Pavel Kozhin on 29.05.15.
	 */
	
	/* global define:false */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, __webpack_require__(1), __webpack_require__(4), __webpack_require__(2), __webpack_require__(14), __webpack_require__(9), __webpack_require__(11), __webpack_require__(72), __webpack_require__(191)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, $, Widget, Object, Url, OptionsMixin, EventDispatcher, Routing, Handlebars) {
	    'use strict';
	    /**
	     * Search widget
	     *
	     * @name SearchWidget
	     * @constructor
	     */
	
	    var SearchWidget = function SearchWidget(element, options, scope) {
	
	        var url = new Url();
	
	        this._locale = url.getLocale();
	        this._currentQuery = null;
	        this._lastResponse = null;
	        this._lastDestinationsResponse = null;
	        this._isHotelDataLoaded = false;
	        this._isDestinationDataLoaded = false;
	
	        var defaultOptions = {
	            minLength: 3,
	            limit: 100,
	            delay: 225,
	            hotelsRoute: 'allt_frontend.ssg.search_hotels',
	            destinationsRoute: 'allt_frontend.ssg.search_destinations',
	            routeParamName: 'term',
	            routeTypeName: 'type',
	            routeType: 'hotel_only_suggestion,hotel_suggestion',
	            responseDataField: 'items',
	            dataField: 'name',
	            useHint: false,
	            useHighlight: false,
	            useHeader: false,
	            useRootScopeParams: [],
	            identifyField: 'id',
	            hotelResponseType: 'hotel',
	            destinationResponseType: 'destination',
	            // scoped means we update widget value on change
	            scoped: false,
	            emptyResultText: 'No hotels found',
	            bookingType: scope.getParam('bookingType'),
	            rootScope: null,
	            isTyping: false
	        };
	
	        options = $.extend({}, defaultOptions, options || {});
	
	        // Widget Apply
	        Widget.apply(this, [element, options]);
	
	        this._init();
	    };
	
	    SearchWidget.prototype = $.extend(Object.create(Widget.prototype), {
	
	        /**
	         * @private
	         */
	        _locale: null,
	
	        /**
	         * typeAhead JQuery element
	         * @private
	         */
	        _typeAhead: null,
	
	        /**
	         * Selectors for element
	         * @private
	         */
	        _selectors: {
	            input: '[data-fcse-role="ajax-type-ahead"]'
	        },
	
	        /**
	         * This is the hook for all initialization logic
	         * @protected
	         */
	        _init: function _init() {
	            this._hotelsRoute = this.option('hotelsRoute');
	            this._destinationsRoute = this.option('destinationsRoute');
	            this._redirectTarget = this.element.data('redirect-target');
	
	            $('[data-fcse-role="ssg-submit"]', this.element).click($.proxy(this._onSubmit, this, true));
	
	            __webpack_require__.e/* require */(0, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(224), __webpack_require__(225)]; ($.proxy(this._initTypeAhead, this).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	
	            $.cookie('hotelSearch-searchmask-search-widget', '', {
	                path: '/',
	                secure: false
	            });
	            $.cookie('hotelSearch-search-widget', '', {
	                path: '/',
	                secure: false
	            });
	        },
	
	        _oncompleted: function _oncompleted() {
	            this.isTyping = false;
	        },
	
	        /**
	         * Initializes typeahead
	         * @param Bloodhound
	         * @private
	         */
	        _initTypeAhead: function _initTypeAhead(Bloodhound) {
	            this._typeAhead = $(this._selectors.input, this.element);
	            if (this._typeAhead) {
	                this._typeAhead.bind('typeahead:select', $.proxy(this._onSuggestionSelect, this));
	                this._typeAhead.bind('typeahead:asyncreceive', $.proxy(this._oncompleted, this));
	
	                var self = this;
	
	                this._typeAhead.keypress(function (event) {
	
	                    if (event.which !== 13) {
	                        self.isTyping = true;
	                        return;
	                    }
	
	                    if (event.which == 13 && self.isTyping === false) {
	                        self._onSubmit(true);
	                    }
	                });
	
	                var hotelsSource = this._getHotelsSource();
	                var suggestionTemplate = function suggestionTemplate(item) {
	
	                    var text = item.name,
	                        cur = 0,
	                        el = document.createElement('DIV');
	
	                    $.each(item.highlightWidth, function (i, highlight) {
	
	                        var pos = highlight[0],
	                            width = highlight[1];
	
	                        if (cur < pos) {
	                            el.appendChild(document.createTextNode(text.substr(cur, pos - cur)));
	                        }
	
	                        el.appendChild(document.createElement('STRONG')).appendChild(document.createTextNode(text.substr(pos, width)));
	
	                        cur = pos + width;
	                    });
	
	                    if (cur < text.length) {
	                        el.appendChild(document.createTextNode(text.substr(cur, text.length - cur)));
	                    }
	                    if (item.country) {
	                        el.appendChild(document.createTextNode(' (' + item.country + ' | ' + item.region + ')'));
	                    }
	                    var iconDiv = document.createElement('DIV');
	                    var textDiv = el;
	
	                    iconDiv.setAttribute('class', item.isDestination ? 'destination-icon' : 'hotel-icon');
	                    el = document.createElement('DIV');
	                    el.appendChild(iconDiv);
	                    el.appendChild(textDiv);
	
	                    return el.outerHTML;
	                };
	                var hotelsSettings = {
	                    name: 'hotels',
	                    display: this.option('dataField'),
	                    source: hotelsSource,
	                    limit: this.option('limit'),
	                    templates: {
	                        suggestion: suggestionTemplate,
	                        notFound: function notFound() {
	                            return self._shouldShowNoSearchResults() ? $('[data-fcse-role="not-found-proto"]', self.element).html() : null;
	                        }
	                    }
	                };
	
	                var destinationsSource = this._getDestinationsSource();
	                var destinationsSettings = {
	                    name: 'destinations',
	                    display: this.option('dataField'),
	                    source: destinationsSource,
	                    limit: this.option('limit'),
	                    templates: {
	                        suggestion: suggestionTemplate,
	                        header: Handlebars.compile($('[data-fcse-role="destinations-header-proto"]', this.element).html()),
	                        notFound: function notFound() {
	                            return self._shouldShowNoSearchResults() ? $('[data-fcse-role="not-found-proto"]', self.element).html() : null;
	                        }
	                    }
	                };
	
	                if (this.option('useHeader') && $('[data-fcse-role="hotels-header-proto"]', this.element).length) {
	                    hotelsSettings.templates.header = Handlebars.compile($('[data-fcse-role="hotels-header-proto"]', this.element).html());
	                    $('body').on('click', '.searchwidget-header-clickable', $.proxy(this._onSubmit, this, false));
	                }
	
	                this._typeAhead.typeahead({
	                    minLength: this.option('minLength'),
	                    hint: this.option('useHint'),
	                    highlight: this.option('useHighlight')
	                }, hotelsSettings, destinationsSettings);
	
	                this.element.on('click', '[data-fcse-role="paging"]', function () {});
	
	                /*var searchMaskHotelSearch = this._getHotelSearch('searchmask-search-widget');
	                 if (searchMaskHotelSearch) {
	                    this._typeAhead.typeahead('val', searchMaskHotelSearch.replace(/\+/g, ' '));
	                    this.setValueToUi();
	                }*/
	
	                var searchFieldMatch = window.location.search.match(/searchField=([\w\-]+)&?/);
	                var searchFieldValue = null;
	                if (searchFieldMatch && searchFieldMatch.length === 2) {
	                    searchFieldValue = searchFieldMatch[1];
	                }
	                if (searchFieldValue == self.element.attr('id')) {
	                    if (searchFieldValue == 'searchmask-search-widget') {
	                        var hotelNameMatch = window.location.search.match(/searchValue=(.[^&]+)/);
	                        if (hotelNameMatch && hotelNameMatch.length == 2) {
	                            this._typeAhead.typeahead('val', decodeURIComponent(hotelNameMatch[1].replace(/\+/g, ' ')));
	                        }
	                    }
	                    self.setValueToUi();
	                }
	            }
	        },
	
	        /**
	         * Prepares and returns source for typeahead
	         * @returns {Bloodhound}
	         * @private
	         */
	        _getHotelsSource: function _getHotelsSource() {
	            return new Bloodhound({
	                datumTokenizer: Bloodhound.tokenizers.obj.whitespace(this.option('dataField')),
	                queryTokenizer: function queryTokenizer(str) {
	                    str = $.trim(_.isUndefined(str) || str === null ? '' : str + '');
	                    return str ? str.split(/\s+/) : [];
	                },
	                identify: $.proxy(this._identify, this),
	                remote: {
	                    url: 'hotels',
	                    wildcard: '%QUERY',
	                    transform: $.proxy(this._transformResponse, this),
	                    prepare: $.proxy(this._prepareHotelsRequest, this),
	                    rateLimitWait: this.option('delay')
	                }
	            });
	        },
	
	        /**
	         * Prepares and returns source for typeahead
	         * @returns {Bloodhound}
	         * @private
	         */
	        _getDestinationsSource: function _getDestinationsSource() {
	            return new Bloodhound({
	                datumTokenizer: Bloodhound.tokenizers.obj.whitespace(this.option('dataField')),
	                queryTokenizer: function queryTokenizer(str) {
	                    str = $.trim(_.isUndefined(str) || str === null ? '' : str + '');
	                    return str ? str.split(/\s+/) : [];
	                },
	                identify: $.proxy(this._identify, this),
	                remote: {
	                    url: 'destinations',
	                    wildcard: '%QUERY',
	                    transform: $.proxy(this._transformResponse, this),
	                    prepare: $.proxy(this._prepareDestinationsRequest, this),
	                    rateLimitWait: this.option('delay')
	                }
	            });
	        },
	
	        /**
	         * Overrides request settings before actual ajax request
	         * @param term
	         * @param settings
	         * @returns {*}
	         * @private
	         */
	        _prepareHotelsRequest: function _prepareHotelsRequest(term, settings) {
	            var params = {};
	
	            params[this.option('routeParamName')] = $.trim(term);
	            params[this.option('routeTypeName')] = this.option('routeType');
	            params['_locale'] = this._locale;
	            params['bookingType'] = this.option('bookingType');
	            params['searchField'] = this._getWidgetId();
	            params = $.extend(params, this._getRootScopeParams());
	
	            settings.url = Routing.generate(this._hotelsRoute, params);
	            this._isHotelDataLoaded = false;
	
	            return settings;
	        },
	
	        /**
	         * Overrides request settings before actual ajax request
	         * @param term
	         * @param settings
	         * @returns {*}
	         * @private
	         */
	        _prepareDestinationsRequest: function _prepareDestinationsRequest(term, settings) {
	            var params = {};
	
	            params[this.option('routeParamName')] = $.trim(term);
	            params[this.option('routeTypeName')] = this.option('routeType');
	            params['_locale'] = this._locale;
	            params['bookingType'] = this.option('bookingType');
	            params['searchField'] = this._getWidgetId();
	            params = $.extend(params, this._getRootScopeParams());
	
	            settings.url = Routing.generate(this._destinationsRoute, params);
	            this._isDestinationDataLoaded = false;
	
	            return settings;
	        },
	
	        /**
	         * Transforms received response to array of items
	         * @param response
	         * @returns {*}
	         * @private
	         */
	        _transformResponse: function _transformResponse(response) {
	            var fieldName = this.option('responseDataField');
	
	            if (!response.meta || !response.meta[fieldName]) {
	                throw Error('Field "' + fieldName + '" is mandatory for the response');
	            }
	            var items = response.meta[fieldName];
	
	            $.each(items, function (i, item) {
	                if (!item.highlights) {
	                    item.highlights = [];
	                }
	                if (!item.highlightWidth) {
	                    item.highlightWidth = [];
	                }
	            });
	
	            if (response.meta.type == this.option('hotelResponseType')) {
	                this._lastResponse = items;
	                this._isHotelDataLoaded = true;
	                if (this._posponedSubmit) {
	                    this._onSubmit(true);
	                }
	            } else if (response.meta.type == this.option('destinationResponseType')) {
	                this._lastDestinationsResponse = items;
	                this._isDestinationDataLoaded = true;
	            }
	            return items;
	        },
	
	        /**
	         * Returns identity for data object
	         * @param item
	         * @returns {*}
	         * @private
	         */
	        _identify: function _identify(item) {
	            var identity = item[this.option('identifyField')];
	            if (!identity) {
	                throw Error('Object must have identity field "id"');
	            }
	            return identity;
	        },
	
	        _shouldShowNoSearchResults: function _shouldShowNoSearchResults() {
	            var isAllLoaded = this._isHotelDataLoaded && this._isDestinationDataLoaded;
	
	            if (!isAllLoaded) {
	                return false;
	            }
	            return !this._lastResponse.length && !this._lastDestinationsResponse.length;
	        },
	
	        /**
	         * Select item handler
	         * @param e
	         * @param suggestion
	         * @private
	         */
	        _onSuggestionSelect: function _onSuggestionSelect(e, suggestion) {
	            this._currentQuery = $.trim(suggestion[this.option('dataField')]);
	
	            var widgetId = this._getWidgetId();
	
	            if (this.option('scoped')) {
	                this.setValue({
	                    'hotelName': this._currentQuery,
	                    'hotelId': suggestion.hotelId
	                });
	            } else if (!suggestion.url) {
	                // In case url is empty we use indistinct search
	                this._onSubmit(true, null);
	            } else {
	                var query = this._getQuery(),
	                    widgetContext = '';
	
	                if (query) {
	                    delete query['hotelName'];
	                    delete query['hotelId'];
	                    delete query['giataId'];
	                }
	                if (widgetId == 'search-widget') {
	                    // Reset query params for header search
	                    query = {};
	                }
	                if (suggestion.isDestination) {
	                    delete query['groupNames'];
	                    widgetContext = '&searchField=' + widgetId + '-destination';
	                } else {
	                    widgetContext = '&searchField=' + widgetId + '&searchValue=' + this._currentQuery;
	                    // TODO: Consider to not apply model query to the top search
	                    if (widgetId == 'search-widget') {
	                        this._setHotelSearch('searchmask-search-widget', '');
	                        this._setHotelSearch('search-widget', this._currentQuery);
	                    } else if (widgetId == 'searchmask-search-widget') {
	                        this._setHotelSearch('search-widget', '');
	                        this._setHotelSearch('searchmask-search-widget', this._currentQuery);
	                    }
	                }
	                var additionalParams = $.param(query);
	
	                additionalParams += widgetContext;
	
	                window.location.href = suggestion.url + (additionalParams ? '&' + additionalParams : '');
	            }
	        },
	
	        /**
	         * Submits the current search value
	         * @param force
	         * @param event
	         * @private
	         */
	        _onSubmit: function _onSubmit(force, event) {
	            var value = $.trim(this._typeAhead.typeahead('val'));
	            this._posponedSubmit = false;
	
	            if (!value && !this._lastResponse) {
	                return;
	            }
	            if (value && !this._isHotelDataLoaded) {
	                // If user hit enter before hotels loaded we wait for result and reproduce it
	                this._posponedSubmit = true;
	                return;
	            }
	
	            if (value && this._lastResponse && this._lastResponse.length === 1) {
	                this._onSuggestionSelect({}, this._lastResponse[0]);
	                return;
	            }
	            if (!value && this._getWidgetId() == 'search-widget') {
	                return;
	            }
	
	            if (this._lastDestinationsResponse && this._lastDestinationsResponse.length === 1) {
	                var item = this._lastDestinationsResponse[0];
	                this._onSuggestionSelect({}, item);
	                return false;
	            }
	
	            if (this._lastDestinationsResponse && this._lastDestinationsResponse.length > 1) {
	                var matchedItem = void 0;
	                var expr = new RegExp(".*?" + value + "(\W|$)", 'gi');
	                $.each(this._lastDestinationsResponse, function (i, item) {
	                    if (item.name.match(expr)) {
	                        matchedItem = item;
	                        return false;
	                    }
	                });
	
	                if (matchedItem) {
	                    this._onSuggestionSelect({}, matchedItem);
	                    return false;
	                }
	            }
	
	            if (force || this._redirectTarget && this._typeAhead.parent().children('.tt-menu').hasClass('tt-open') == true) {
	                var widgetId = typeof this._typeAhead.closest('div[data-fcse-role="searchwidget"]').attr('id') !== 'undefined' ? this._typeAhead.closest('div[data-fcse-role="searchwidget"]').attr('id') : '';
	                var rootScopeQuery = {
	                    'hotelName': value,
	                    'searchField': widgetId
	                };
	
	                if (widgetId == 'searchmask-search-widget') {
	                    rootScopeQuery = $.extend({}, this._getQuery(), rootScopeQuery);
	                    this._setHotelSearch('searchmask-search-widget', value);
	                    this._setHotelSearch('search-widget', '');
	                } else if (widgetId == 'search-widget') {
	                    this._setHotelSearch('searchmask-search-widget', '');
	                    this._setHotelSearch('search-widget', value);
	                }
	                // Deleting hotelId and giataId if we use not concrete search
	                // TODO: Need to refactor processing both hotelId and hotelName logic
	                delete rootScopeQuery['hotelId'];
	                delete rootScopeQuery['giataId'];
	
	                window.location.href = this._redirectTarget + '?' + $.param(rootScopeQuery) + '&searchValue=' + value;
	            }
	            this._typeAhead.typeahead('close');
	        },
	
	        /**
	         * Returns query
	         * @returns {Object}
	         * @private
	         */
	        _getQuery: function _getQuery() {
	            return this._options.rootScope ? this._options.rootScope.getQuery() : {};
	        },
	
	        /**
	         * Returns matches root scope params
	         * @returns {{}}
	         * @private
	         */
	        _getRootScopeParams: function _getRootScopeParams() {
	            var result = {},
	                rootScopeParams;
	
	            if (this.option('rootScope') && this.option('useRootScopeParams').length) {
	                rootScopeParams = this.option('rootScope').getParams();
	
	                _.each(this.option('useRootScopeParams'), function (name) {
	                    _.each(rootScopeParams, function (paramValue, paramName) {
	                        if (paramName.indexOf(name) === 0) {
	                            result[paramName] = _.isArray(paramValue) ? paramValue.join(';') : paramValue;
	                        }
	                    });
	                });
	            }
	            return result;
	        },
	
	        /**
	         * @protected
	         * @returns {void}
	         */
	        setValueToUi: function setValueToUi() {
	            var value = this.getValue();
	            if (this._typeAhead && this._typeAhead.typeahead('val') !== value.name) {
	                this._typeAhead.typeahead('val', value.name);
	                this._currentQuery = value.name;
	            }
	        },
	
	        /**
	         * Returns the current hotel name search query
	         * @protected
	         * @returns {String} The hotel name search query
	         */
	        getValueFromUi: function getValueFromUi() {
	            return this._currentQuery;
	        },
	
	        /**
	         * Returns current value
	         * @returns {null|*}
	         */
	        getValue: function getValue() {
	            var result = this._typeAhead ? this._typeAhead.typeahead('val') : '';
	            // TODO: Need to refactor processing both hotelId and hotelName logic
	            if (!result) {
	                var value = Widget.prototype.getValue.apply(this, []);
	                value = value ? value.name : null;
	            }
	            return {
	                'hotelName': result || value,
	                'hotelId': this._getQuery()['hotelId'] || this._getQuery()['giataId'] || ''
	            };
	        },
	
	        /**
	         * @protected
	         */
	        _updateDisplay: function _updateDisplay() {},
	
	        /**
	         * Return widget id
	         * @returns {*}
	         * @private
	         */
	        _getWidgetId: function _getWidgetId() {
	            if (!this._typeAhead) {
	                return null;
	            }
	
	            return typeof this._typeAhead.closest('div[data-fcse-role="searchwidget"]').attr('id') !== 'undefined' ? this._typeAhead.closest('div[data-fcse-role="searchwidget"]').attr('id') : '';
	        },
	
	        /**
	         *
	         * @param widgetId
	         * @param searchValue
	         * @private
	         */
	        _setHotelSearch: function _setHotelSearch(widgetId, searchValue) {
	            searchValue = searchValue ? $.trim(searchValue) : null;
	
	            if (searchValue) {
	                $.cookie('hotelSearch-' + widgetId, encodeURIComponent(searchValue), {
	                    path: '/',
	                    secure: false
	                });
	            } else {
	                $.cookie('hotelSearch-' + widgetId, '', {
	                    path: '/',
	                    secure: false
	                });
	            }
	        },
	
	        /**
	         *
	         * @param widgetId
	         * @returns {*}
	         * @private
	         */
	        _getHotelSearch: function _getHotelSearch(widgetId) {
	            var value = $.cookie('hotelSearch' + widgetId);
	
	            if (value) {
	                return decodeURIComponent(value);
	            }
	            return null;
	        }
	    });
	
	    return SearchWidget;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(1),
	    __webpack_require__(4),
	    __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function($, Widget, Object) {
	
	        var LocationWidget = function(element, options) {
	            Widget.apply(this, arguments);
	
	            //Set options
	            var defaultOptions = {
	                'activeClassName': 'is-active',
	                'labelCount': this.element.data('label-count'),
	                'labelNoCount': this.element.data('label-no-count')
	            };
	            this.addOptions(defaultOptions, options);
	
	            this._registerTabNavigationClickEvent();
	            this._registerOptionsClickEvent();
	            this._registerRemoveFromTagBarClickEvent();
	
	            this._init();
	        };
	
	        LocationWidget.prototype = $.extend({}, Widget.prototype,
	            {
	                _init: function()
	                {
	                    var tagTemplate = $('[data-fcse-role="locationwidget--tagitem"][data-tag-id="{TAG_ID}"]',
	                        this.element);
	
	                    if (tagTemplate.length) {
	                        this._tagTemplate = tagTemplate.detach().get(0).outerHTML;
	                    }
	
	                    this.setValueToUi();
	                },
	
	                _registerTabNavigationClickEvent: function()
	                {
	                    var self = this;
	
	                    $('[data-fcse-role="locationwidget--grouptab"]',
	                        this.element).on("click", function (e) {
	                            var $this = $(this);
	
	                            self._switchTab($this.data('group-id'));
	                            e.preventDefault();
	                            e.stopImmediatePropagation();
	                        });
	                },
	
	                _registerOptionsClickEvent: function()
	                {
	                    var self = this;
	
	                    $('[data-fcse-role="locationwidget--mainoption"], [data-fcse-role="locationwidget--option"]',
	                        this.element).on("click", function(e) {
	                            var $this = $(this);
	                            var cbx = $('[data-fcse-role="locationwidget--cbx"]', $this);
	                            var isCbx = $(e.target).is('[data-fcse-role="locationwidget--cbx"]');
	                            var isChecked = isCbx ? cbx.is(':checked') : !cbx.is(':checked');
	                            var isMainSelected = false;
	
	
	                            if ($this.is('[data-fcse-role="locationwidget--mainoption"]')) {
	                                // Reset options every time mainoption is clicked.
	                                self._getContentElement('data-group-id', $this.data('id'))
	                                    .find('[data-fcse-role="locationwidget--cbx"]').each(function(i, item){
	                                        $(item).prop('checked', false);
	                                    });
	                            } else {
	                                var mainCheckbox = $('[data-fcse-role="locationwidget--mainoption"][data-id="'+
	                                              $this.data('group-id') +'"] [data-fcse-role="locationwidget--cbx"]',
	                                              self.element);
	                                isMainSelected = mainCheckbox.is(':checked');
	
	                                if (isMainSelected) {
	                                    // Un-Check MainCheckbox of clicked Checkbox
	                                    mainCheckbox.prop('checked', false);
	                                    self._removeTag($this.data('group-id'));
	                                    isMainSelected = false;
	                                    
	                                    // Check clicked Checkbox
	                                    cbx.prop('checked', isChecked);                            
	                                    e.preventDefault();
	                                } else if (!isCbx) {
	                                    cbx.prop('checked', isChecked);
	                                    e.preventDefault();
	                                }
	                            }
	                            
	                            
	                            if (!isMainSelected) {
	                                (isChecked) ? self._addTag($this.data('id')) : self._removeTag($this.data('id'));
	                            }
	                            e.stopPropagation();
	                        });
	                },
	
	                _registerRemoveFromTagBarClickEvent: function()
	                {
	                    var self = this;
	
	                    $('[data-fcse-role="locationwidget--tagbar"]', this.element).on('click',
	                        '[data-fcse-role="locationwidget--tagitemremovebtn"]', function() {
	                            var id = $(this).closest('[data-tag-id]').data('tag-id');
	
	                            self._getContentElement('data-id', id)
	                                .find('[data-fcse-role="locationwidget--cbx"]').prop('checked', false);
	
	                            self._removeTag(id);
	                        });
	                },
	
	                _switchTab: function(groupId)
	                {
	                    var activeClassName = this.option('activeClassName');
	
	                    $('[data-fcse-role="locationwidget--grouptab"]', this.element).removeClass(activeClassName)
	                        .filter('[data-group-id="' + groupId + '"]').addClass(activeClassName);
	
	                    $('[data-fcse-role="locationwidget--grouptabcontent"]', this.element).hide()
	                        .filter('[data-group-id="' + groupId + '"]').show();
	                },
	
	                _getContentElement: function(attrName, attrValue) {
	                    return $('[data-fcse-role="locationwidget--grouptabcontent"]', self.element)
	                        .find('['+ attrName +'="'+ attrValue +'"]');
	                },
	
	                _removeTag: function(id)
	                {
	                    var tagBar = $('[data-fcse-role="locationwidget--tagbar"]', this.element);
	
	                    tagBar.find('[data-fcse-role="locationwidget--tagitem"][data-tag-id="'+ id +'"]').remove();
	
	                    this._showHideTagsPrompt();
	                },
	
	                _addTag: function(id) {
	                    var option = this._getContentElement('data-id', id);
	                    var tagBar = $('[data-fcse-role="locationwidget--tagbar"]', this.element);
	
	                    if (!tagBar.find('[data-fcse-role="locationwidget--tagitem"][data-tag-id="'+id +'"]').length) {
	                        if (option.is('[data-fcse-role="locationwidget--mainoption"]')) {
	                            this._getContentElement('data-group-id', id).each(function(i, item) {
	                                tagBar.find('[data-fcse-role="locationwidget--tagitem"][data-tag-id="'+
	                                    $(item).data('id') +'"]').remove();
	                            });
	                        }
	
	                        var tagTemplate = this._tagTemplate.replace('{TAG_ID}', id)
	                            .replace('{TAG_NAME}', option.data('name'));
	
	                        tagBar.append($(tagTemplate));
	
	                        this._showHideTagsPrompt();
	                    }
	                },
	
	                _showHideTagsPrompt: function()
	                {
	                    var defaultTag = $('[data-fcse-role="locationwidget--defaulttagitem"]', this.element);
	
	                    (!$('[data-fcse-role="locationwidget--tagitem"]', this.element)
	                        .filter(':not([data-tag-id="{TAG_ID}"])').length) ? defaultTag.show() : defaultTag.hide();
	                },
	
	                setValueToUi: function()
	                {
	                    var self = this;
	                    var valueArray = this.value;
	
	                    $('[data-fcse-role="locationwidget--tagitem"]', this.element).filter(':not([data-tag-id="{TAG_ID}"])').remove();
	
	                    $('[data-fcse-role="locationwidget--cbx"]', this.element).each(function(i, item) {
	                        $(item).prop('checked', false);
	                    });
	
	                    _.each(valueArray, function(value, key) {
	                        var option = self._getContentElement('data-value', value);
	
	                        option.find('[data-fcse-role="locationwidget--cbx"]').prop('checked', true);
	                        self._addTag(option.data('id'));
	                    });
	
	                    this._showHideTagsPrompt();
	                },
	
	                getValueFromUi: function()
	                {
	                    var self = this;
	                    var value = [];
	                    var $selectedItems = $('[data-fcse-role="locationwidget--tagitem"]', this.element);
	
	                    _.each($selectedItems, function(selectedItem, key) {
	                        var id = $(selectedItem).data('tag-id');
	                        value.push(self._getContentElement('data-id', id).data('value'));
	                    });
	
	                    return value;
	                },
	
	                formatValue: function()
	                {
	                    if (!_.isUndefined(this.getValue()) && this.getValue().length > 1) {
	                        return this.getValue().length + " " + this.option('labelCount');
	                    } else if (_.isUndefined(this.getValue()) || this.getValue().length == 0) {
	                        return this.option('labelNoCount');
	                    } else {
	                        return this._getContentElement('data-value', this.getValue()[0]).data('name');
	                    }
	                },
	
	                _processData: function(data)
	                {
	                    var processedData = [];
	                    if (_.isString(data)) {
	                        processedData = data.length ? data.split(";") : [];
	                    } else if (_.isNumber(data)) {
	                        processedData = [data];
	                    } else if (_.isUndefined(data)){
	                        // Allow undefined values for some browsers
	                    } else {
	                        throw new Error("Only string/integer value is valid for initial value.");
	                    }
	
	                    return processedData;
	                }
	            });
	
	        return LocationWidget;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * • FCSE Travelsearch Sandbox 2013 •
	 * 
	 * © Copyright 2012, Tom Hülser [freshcells systems engineering GmbH]
	 * 
	 * 
	 */
	
	
	/**
	 * Logging
	 * 
	 * @author Hermann Bier, bier@freshcells.de
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function($) {
	  
	  return function(debugPrefix) {
	    this.debugPrefix = debugPrefix || '';
	    this.layerMaxHeight = "200";
	    this.layerMinHeight = "40";
	    
	    this.debug = function(message, dump) 
	    {
	      message = this.debugPrefix + ': '+ message;
	
	      if(this.debuging())
	      {
	        if(typeof console.debug == 'undefined')
	        {
	          console.log(message);
	        }
	        else if(dump)
	        {
	          console.debug(message, dump);
	        }
	        else
	        {
	          console.debug(message);
	        }
	      }
	//      else if(this.debugingIE())
	//      {
	//        // logging for msie, #messages must be available
	//        $('#messages').append(message + '<br/>');
	//      }
	    };
	
	    this.error = function(error)
	    {
	      error = this.debugPrefix + ': '+ error;
	      
	      if(this.debuging() && typeof console.error != 'undefined')
	      {
	        console.error(error);
	      }
	//      else if(this.debugingIE())
	//      {
	//        // logging for msie, #messages must be available
	//        $('#messages').append('<span class="error">' + error + '</span>' + '<br/>');
	//      }
	    };
	
	
	    this.warn = function(warn)
	    {
	      warn = this.debugPrefix + ': '+ warn;
	      
	      if(this.debuging() && typeof console.warn != 'undefined')
	      {
	        console.warn(warn);
	      }
	//      else if(this.debugingIE())
	//      {
	//        // logging for msie, #messages must be available
	//        $('#messages').append('<span class="error">' + error + '</span>' + '<br/>');
	//      }
	    };
	
	    this.timeStart = function(label)
	    {
	      if(this.debuging() && typeof console.time != 'undefined')
	      {
	        console.time(label);
	      }
	    };
	
	    this.timeEnd = function(label)
	    {
	      if(this.debuging() && typeof console.timeEnd != 'undefined')
	      {
	        console.timeEnd(label);
	      }
	    };
	
	    this.createLayer = function() 
	    {
	      if(this.layer) return;
	      this.layer = $('<div style="position:relative; height: ' + this.layerMinHeight + 'px; background-color: #fff; overflow: auto"></div>');
	      $('body').prepend(this.layer);
	      // checkbox to lock size
	      var checkbox = $('<input type="checkbox" style="position: absolute; top: 10px; left: ' + (this.layer.width() - 20) + 'px;"/>');
	      this.layer.append(checkbox);
	      var self = this;
	      // let it grow
	      this.layer.on({
	        mouseenter: function()
	        {
	          if(checkbox.is(':checked')) return;
	          $(this).stop().animate({height: self.layerMaxHeight});
	        },
	        mouseleave: function()
	        {
	          if(checkbox.is(':checked')) return;
	          $(this).stop().animate({height: self.layerMinHeight});
	        }
	      });
	    };
	    
	    this.debugLayer = function(message) 
	    {
	      if(!GLOBAL_DEBUG) return;
	      this.createLayer();
	      this.layer.append('<p style="font-size: 10px;">' + this.debugPrefix + ': ' + message + '</p>');
	    };
	    
	    
	    /**
	    * Should message be ouptuted
	    */
	    this.debuging = function()
	    {
	      return GLOBAL_DEBUG && typeof window.console != 'undefined';
	    };
	    /**
	    * Same for IE
	    */
	    this.debugingIE = function()
	    {
	      return GLOBAL_DEBUG && $('#messages').length != 0;
	    };
	  };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(1),
	    __webpack_require__(3),
	    __webpack_require__(2),
	    __webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = function($, _, Object, Widget) {
	        
	        var RatingWidget = function (element, options) {
	            Widget.apply(this, arguments);
	            
	            //Set options
	            var defaultOptions = {
	                'activeClassName': 'is-active'
	            };
	            this.addOptions(defaultOptions, options);
	            
	            //Register click event handler
	            this._registerClickEvent();
	        };
	
	        RatingWidget.prototype = $.extend(Object.create(Widget.prototype), {
	            _registerClickEvent: function () {
	                var self = this;
	                $('[data-value]', this.element).on("click", function (e) {
	                    var value = $(this).data('value');
	                    if (self.value !== value) {
	                        self.setValue(value);
	                    }
	                    e.preventDefault();
	                });
	            },
	            setValueToUi: function () {
	                var self = this;
	                $('[data-value]', self.element).removeClass(self.option('activeClassName'));
	                _.each($('[data-value]', self.element), function(btn, index){
	                    var $btn = $(btn);
	                    if(parseFloat($btn.attr('data-value')) <= parseFloat(self.value)){
	                        $btn.addClass(self.option('activeClassName'));
	                    }
	                });
	            },
	            getValueFromUi: function () {
	                var active = $('[data-fcse-role="ratingwidget--bar"]').find("." + this.option('activeClassName') + ":last");
	                if (active.length === 0) {
	                    return null;
	                }
	                else {
	                    return active.attr('data-value');
	                }
	            }
	        });
	
	        return RatingWidget;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var COMPILER_REVISION = __webpack_require__(30).COMPILER_REVISION;
	var REVISION_CHANGES = __webpack_require__(30).REVISION_CHANGES;
	var log = __webpack_require__(30).log;
	
	function Literal(value) {
	  this.value = value;
	}
	
	function JavaScriptCompiler() {}
	
	JavaScriptCompiler.prototype = {
	  // PUBLIC API: You can override these methods in a subclass to provide
	  // alternative compiled forms for name lookup and buffering semantics
	  nameLookup: function(parent, name /* , type*/) {
	    var wrap,
	        ret;
	    if (parent.indexOf('depth') === 0) {
	      wrap = true;
	    }
	
	    if (/^[0-9]+$/.test(name)) {
	      ret = parent + "[" + name + "]";
	    } else if (JavaScriptCompiler.isValidJavaScriptVariableName(name)) {
	      ret = parent + "." + name;
	    }
	    else {
	      ret = parent + "['" + name + "']";
	    }
	
	    if (wrap) {
	      return '(' + parent + ' && ' + ret + ')';
	    } else {
	      return ret;
	    }
	  },
	
	  appendToBuffer: function(string) {
	    if (this.environment.isSimple) {
	      return "return " + string + ";";
	    } else {
	      return {
	        appendToBuffer: true,
	        content: string,
	        toString: function() { return "buffer += " + string + ";"; }
	      };
	    }
	  },
	
	  initializeBuffer: function() {
	    return this.quotedString("");
	  },
	
	  namespace: "Handlebars",
	  // END PUBLIC API
	
	  compile: function(environment, options, context, asObject) {
	    this.environment = environment;
	    this.options = options || {};
	
	    log('debug', this.environment.disassemble() + "\n\n");
	
	    this.name = this.environment.name;
	    this.isChild = !!context;
	    this.context = context || {
	      programs: [],
	      environments: [],
	      aliases: { }
	    };
	
	    this.preamble();
	
	    this.stackSlot = 0;
	    this.stackVars = [];
	    this.registers = { list: [] };
	    this.compileStack = [];
	    this.inlineStack = [];
	
	    this.compileChildren(environment, options);
	
	    var opcodes = environment.opcodes, opcode;
	
	    this.i = 0;
	
	    for(var l=opcodes.length; this.i<l; this.i++) {
	      opcode = opcodes[this.i];
	
	      if(opcode.opcode === 'DECLARE') {
	        this[opcode.name] = opcode.value;
	      } else {
	        this[opcode.opcode].apply(this, opcode.args);
	      }
	
	      // Reset the stripNext flag if it was not set by this operation.
	      if (opcode.opcode !== this.stripNext) {
	        this.stripNext = false;
	      }
	    }
	
	    // Flush any trailing content that might be pending.
	    this.pushSource('');
	
	    return this.createFunctionContext(asObject);
	  },
	
	  preamble: function() {
	    var out = [];
	
	    if (!this.isChild) {
	      var namespace = this.namespace;
	
	      var copies = "helpers = this.merge(helpers, " + namespace + ".helpers);";
	      if (this.environment.usePartial) { copies = copies + " partials = this.merge(partials, " + namespace + ".partials);"; }
	      if (this.options.data) { copies = copies + " data = data || {};"; }
	      out.push(copies);
	    } else {
	      out.push('');
	    }
	
	    if (!this.environment.isSimple) {
	      out.push(", buffer = " + this.initializeBuffer());
	    } else {
	      out.push("");
	    }
	
	    // track the last context pushed into place to allow skipping the
	    // getContext opcode when it would be a noop
	    this.lastContext = 0;
	    this.source = out;
	  },
	
	  createFunctionContext: function(asObject) {
	    var locals = this.stackVars.concat(this.registers.list);
	
	    if(locals.length > 0) {
	      this.source[1] = this.source[1] + ", " + locals.join(", ");
	    }
	
	    // Generate minimizer alias mappings
	    if (!this.isChild) {
	      for (var alias in this.context.aliases) {
	        if (this.context.aliases.hasOwnProperty(alias)) {
	          this.source[1] = this.source[1] + ', ' + alias + '=' + this.context.aliases[alias];
	        }
	      }
	    }
	
	    if (this.source[1]) {
	      this.source[1] = "var " + this.source[1].substring(2) + ";";
	    }
	
	    // Merge children
	    if (!this.isChild) {
	      this.source[1] += '\n' + this.context.programs.join('\n') + '\n';
	    }
	
	    if (!this.environment.isSimple) {
	      this.pushSource("return buffer;");
	    }
	
	    var params = this.isChild ? ["depth0", "data"] : ["Handlebars", "depth0", "helpers", "partials", "data"];
	
	    for(var i=0, l=this.environment.depths.list.length; i<l; i++) {
	      params.push("depth" + this.environment.depths.list[i]);
	    }
	
	    // Perform a second pass over the output to merge content when possible
	    var source = this.mergeSource();
	
	    if (!this.isChild) {
	      var revision = COMPILER_REVISION,
	          versions = REVISION_CHANGES[revision];
	      source = "this.compilerInfo = ["+revision+",'"+versions+"'];\n"+source;
	    }
	
	    if (asObject) {
	      params.push(source);
	
	      return Function.apply(this, params);
	    } else {
	      var functionSource = 'function ' + (this.name || '') + '(' + params.join(',') + ') {\n  ' + source + '}';
	      log('debug', functionSource + "\n\n");
	      return functionSource;
	    }
	  },
	  mergeSource: function() {
	    // WARN: We are not handling the case where buffer is still populated as the source should
	    // not have buffer append operations as their final action.
	    var source = '',
	        buffer;
	    for (var i = 0, len = this.source.length; i < len; i++) {
	      var line = this.source[i];
	      if (line.appendToBuffer) {
	        if (buffer) {
	          buffer = buffer + '\n    + ' + line.content;
	        } else {
	          buffer = line.content;
	        }
	      } else {
	        if (buffer) {
	          source += 'buffer += ' + buffer + ';\n  ';
	          buffer = undefined;
	        }
	        source += line + '\n  ';
	      }
	    }
	    return source;
	  },
	
	  // [blockValue]
	  //
	  // On stack, before: hash, inverse, program, value
	  // On stack, after: return value of blockHelperMissing
	  //
	  // The purpose of this opcode is to take a block of the form
	  // `{{#foo}}...{{/foo}}`, resolve the value of `foo`, and
	  // replace it on the stack with the result of properly
	  // invoking blockHelperMissing.
	  blockValue: function() {
	    this.context.aliases.blockHelperMissing = 'helpers.blockHelperMissing';
	
	    var params = ["depth0"];
	    this.setupParams(0, params);
	
	    this.replaceStack(function(current) {
	      params.splice(1, 0, current);
	      return "blockHelperMissing.call(" + params.join(", ") + ")";
	    });
	  },
	
	  // [ambiguousBlockValue]
	  //
	  // On stack, before: hash, inverse, program, value
	  // Compiler value, before: lastHelper=value of last found helper, if any
	  // On stack, after, if no lastHelper: same as [blockValue]
	  // On stack, after, if lastHelper: value
	  ambiguousBlockValue: function() {
	    this.context.aliases.blockHelperMissing = 'helpers.blockHelperMissing';
	
	    var params = ["depth0"];
	    this.setupParams(0, params);
	
	    var current = this.topStack();
	    params.splice(1, 0, current);
	
	    // Use the options value generated from the invocation
	    params[params.length-1] = 'options';
	
	    this.pushSource("if (!" + this.lastHelper + ") { " + current + " = blockHelperMissing.call(" + params.join(", ") + "); }");
	  },
	
	  // [appendContent]
	  //
	  // On stack, before: ...
	  // On stack, after: ...
	  //
	  // Appends the string value of `content` to the current buffer
	  appendContent: function(content) {
	    if (this.pendingContent) {
	      content = this.pendingContent + content;
	    }
	    if (this.stripNext) {
	      content = content.replace(/^\s+/, '');
	    }
	
	    this.pendingContent = content;
	  },
	
	  // [strip]
	  //
	  // On stack, before: ...
	  // On stack, after: ...
	  //
	  // Removes any trailing whitespace from the prior content node and flags
	  // the next operation for stripping if it is a content node.
	  strip: function() {
	    if (this.pendingContent) {
	      this.pendingContent = this.pendingContent.replace(/\s+$/, '');
	    }
	    this.stripNext = 'strip';
	  },
	
	  // [append]
	  //
	  // On stack, before: value, ...
	  // On stack, after: ...
	  //
	  // Coerces `value` to a String and appends it to the current buffer.
	  //
	  // If `value` is truthy, or 0, it is coerced into a string and appended
	  // Otherwise, the empty string is appended
	  append: function() {
	    // Force anything that is inlined onto the stack so we don't have duplication
	    // when we examine local
	    this.flushInline();
	    var local = this.popStack();
	    this.pushSource("if(" + local + " || " + local + " === 0) { " + this.appendToBuffer(local) + " }");
	    if (this.environment.isSimple) {
	      this.pushSource("else { " + this.appendToBuffer("''") + " }");
	    }
	  },
	
	  // [appendEscaped]
	  //
	  // On stack, before: value, ...
	  // On stack, after: ...
	  //
	  // Escape `value` and append it to the buffer
	  appendEscaped: function() {
	    this.context.aliases.escapeExpression = 'this.escapeExpression';
	
	    this.pushSource(this.appendToBuffer("escapeExpression(" + this.popStack() + ")"));
	  },
	
	  // [getContext]
	  //
	  // On stack, before: ...
	  // On stack, after: ...
	  // Compiler value, after: lastContext=depth
	  //
	  // Set the value of the `lastContext` compiler value to the depth
	  getContext: function(depth) {
	    if(this.lastContext !== depth) {
	      this.lastContext = depth;
	    }
	  },
	
	  // [lookupOnContext]
	  //
	  // On stack, before: ...
	  // On stack, after: currentContext[name], ...
	  //
	  // Looks up the value of `name` on the current context and pushes
	  // it onto the stack.
	  lookupOnContext: function(name) {
	    this.push(this.nameLookup('depth' + this.lastContext, name, 'context'));
	  },
	
	  // [pushContext]
	  //
	  // On stack, before: ...
	  // On stack, after: currentContext, ...
	  //
	  // Pushes the value of the current context onto the stack.
	  pushContext: function() {
	    this.pushStackLiteral('depth' + this.lastContext);
	  },
	
	  // [resolvePossibleLambda]
	  //
	  // On stack, before: value, ...
	  // On stack, after: resolved value, ...
	  //
	  // If the `value` is a lambda, replace it on the stack by
	  // the return value of the lambda
	  resolvePossibleLambda: function() {
	    this.context.aliases.functionType = '"function"';
	
	    this.replaceStack(function(current) {
	      return "typeof " + current + " === functionType ? " + current + ".apply(depth0) : " + current;
	    });
	  },
	
	  // [lookup]
	  //
	  // On stack, before: value, ...
	  // On stack, after: value[name], ...
	  //
	  // Replace the value on the stack with the result of looking
	  // up `name` on `value`
	  lookup: function(name) {
	    this.replaceStack(function(current) {
	      return current + " == null || " + current + " === false ? " + current + " : " + this.nameLookup(current, name, 'context');
	    });
	  },
	
	  // [lookupData]
	  //
	  // On stack, before: ...
	  // On stack, after: data, ...
	  //
	  // Push the data lookup operator
	  lookupData: function() {
	    this.push('data');
	  },
	
	  // [pushStringParam]
	  //
	  // On stack, before: ...
	  // On stack, after: string, currentContext, ...
	  //
	  // This opcode is designed for use in string mode, which
	  // provides the string value of a parameter along with its
	  // depth rather than resolving it immediately.
	  pushStringParam: function(string, type) {
	    this.pushStackLiteral('depth' + this.lastContext);
	
	    this.pushString(type);
	
	    if (typeof string === 'string') {
	      this.pushString(string);
	    } else {
	      this.pushStackLiteral(string);
	    }
	  },
	
	  emptyHash: function() {
	    this.pushStackLiteral('{}');
	
	    if (this.options.stringParams) {
	      this.register('hashTypes', '{}');
	      this.register('hashContexts', '{}');
	    }
	  },
	  pushHash: function() {
	    this.hash = {values: [], types: [], contexts: []};
	  },
	  popHash: function() {
	    var hash = this.hash;
	    this.hash = undefined;
	
	    if (this.options.stringParams) {
	      this.register('hashContexts', '{' + hash.contexts.join(',') + '}');
	      this.register('hashTypes', '{' + hash.types.join(',') + '}');
	    }
	    this.push('{\n    ' + hash.values.join(',\n    ') + '\n  }');
	  },
	
	  // [pushString]
	  //
	  // On stack, before: ...
	  // On stack, after: quotedString(string), ...
	  //
	  // Push a quoted version of `string` onto the stack
	  pushString: function(string) {
	    this.pushStackLiteral(this.quotedString(string));
	  },
	
	  // [push]
	  //
	  // On stack, before: ...
	  // On stack, after: expr, ...
	  //
	  // Push an expression onto the stack
	  push: function(expr) {
	    this.inlineStack.push(expr);
	    return expr;
	  },
	
	  // [pushLiteral]
	  //
	  // On stack, before: ...
	  // On stack, after: value, ...
	  //
	  // Pushes a value onto the stack. This operation prevents
	  // the compiler from creating a temporary variable to hold
	  // it.
	  pushLiteral: function(value) {
	    this.pushStackLiteral(value);
	  },
	
	  // [pushProgram]
	  //
	  // On stack, before: ...
	  // On stack, after: program(guid), ...
	  //
	  // Push a program expression onto the stack. This takes
	  // a compile-time guid and converts it into a runtime-accessible
	  // expression.
	  pushProgram: function(guid) {
	    if (guid != null) {
	      this.pushStackLiteral(this.programExpression(guid));
	    } else {
	      this.pushStackLiteral(null);
	    }
	  },
	
	  // [invokeHelper]
	  //
	  // On stack, before: hash, inverse, program, params..., ...
	  // On stack, after: result of helper invocation
	  //
	  // Pops off the helper's parameters, invokes the helper,
	  // and pushes the helper's return value onto the stack.
	  //
	  // If the helper is not found, `helperMissing` is called.
	  invokeHelper: function(paramSize, name) {
	    this.context.aliases.helperMissing = 'helpers.helperMissing';
	
	    var helper = this.lastHelper = this.setupHelper(paramSize, name, true);
	    var nonHelper = this.nameLookup('depth' + this.lastContext, name, 'context');
	
	    this.push(helper.name + ' || ' + nonHelper);
	    this.replaceStack(function(name) {
	      return name + ' ? ' + name + '.call(' +
	          helper.callParams + ") " + ": helperMissing.call(" +
	          helper.helperMissingParams + ")";
	    });
	  },
	
	  // [invokeKnownHelper]
	  //
	  // On stack, before: hash, inverse, program, params..., ...
	  // On stack, after: result of helper invocation
	  //
	  // This operation is used when the helper is known to exist,
	  // so a `helperMissing` fallback is not required.
	  invokeKnownHelper: function(paramSize, name) {
	    var helper = this.setupHelper(paramSize, name);
	    this.push(helper.name + ".call(" + helper.callParams + ")");
	  },
	
	  // [invokeAmbiguous]
	  //
	  // On stack, before: hash, inverse, program, params..., ...
	  // On stack, after: result of disambiguation
	  //
	  // This operation is used when an expression like `{{foo}}`
	  // is provided, but we don't know at compile-time whether it
	  // is a helper or a path.
	  //
	  // This operation emits more code than the other options,
	  // and can be avoided by passing the `knownHelpers` and
	  // `knownHelpersOnly` flags at compile-time.
	  invokeAmbiguous: function(name, helperCall) {
	    this.context.aliases.functionType = '"function"';
	
	    this.pushStackLiteral('{}');    // Hash value
	    var helper = this.setupHelper(0, name, helperCall);
	
	    var helperName = this.lastHelper = this.nameLookup('helpers', name, 'helper');
	
	    var nonHelper = this.nameLookup('depth' + this.lastContext, name, 'context');
	    var nextStack = this.nextStack();
	
	    this.pushSource('if (' + nextStack + ' = ' + helperName + ') { ' + nextStack + ' = ' + nextStack + '.call(' + helper.callParams + '); }');
	    this.pushSource('else { ' + nextStack + ' = ' + nonHelper + '; ' + nextStack + ' = typeof ' + nextStack + ' === functionType ? ' + nextStack + '.call(' + helper.callParams + ') : ' + nextStack + '; }');
	  },
	
	  // [invokePartial]
	  //
	  // On stack, before: context, ...
	  // On stack after: result of partial invocation
	  //
	  // This operation pops off a context, invokes a partial with that context,
	  // and pushes the result of the invocation back.
	  invokePartial: function(name) {
	    var params = [this.nameLookup('partials', name, 'partial'), "'" + name + "'", this.popStack(), "helpers", "partials"];
	
	    if (this.options.data) {
	      params.push("data");
	    }
	
	    this.context.aliases.self = "this";
	    this.push("self.invokePartial(" + params.join(", ") + ")");
	  },
	
	  // [assignToHash]
	  //
	  // On stack, before: value, hash, ...
	  // On stack, after: hash, ...
	  //
	  // Pops a value and hash off the stack, assigns `hash[key] = value`
	  // and pushes the hash back onto the stack.
	  assignToHash: function(key) {
	    var value = this.popStack(),
	        context,
	        type;
	
	    if (this.options.stringParams) {
	      type = this.popStack();
	      context = this.popStack();
	    }
	
	    var hash = this.hash;
	    if (context) {
	      hash.contexts.push("'" + key + "': " + context);
	    }
	    if (type) {
	      hash.types.push("'" + key + "': " + type);
	    }
	    hash.values.push("'" + key + "': (" + value + ")");
	  },
	
	  // HELPERS
	
	  compiler: JavaScriptCompiler,
	
	  compileChildren: function(environment, options) {
	    var children = environment.children, child, compiler;
	
	    for(var i=0, l=children.length; i<l; i++) {
	      child = children[i];
	      compiler = new this.compiler();
	
	      var index = this.matchExistingProgram(child);
	
	      if (index == null) {
	        this.context.programs.push('');     // Placeholder to prevent name conflicts for nested children
	        index = this.context.programs.length;
	        child.index = index;
	        child.name = 'program' + index;
	        this.context.programs[index] = compiler.compile(child, options, this.context);
	        this.context.environments[index] = child;
	      } else {
	        child.index = index;
	        child.name = 'program' + index;
	      }
	    }
	  },
	  matchExistingProgram: function(child) {
	    for (var i = 0, len = this.context.environments.length; i < len; i++) {
	      var environment = this.context.environments[i];
	      if (environment && environment.equals(child)) {
	        return i;
	      }
	    }
	  },
	
	  programExpression: function(guid) {
	    this.context.aliases.self = "this";
	
	    if(guid == null) {
	      return "self.noop";
	    }
	
	    var child = this.environment.children[guid],
	        depths = child.depths.list, depth;
	
	    var programParams = [child.index, child.name, "data"];
	
	    for(var i=0, l = depths.length; i<l; i++) {
	      depth = depths[i];
	
	      if(depth === 1) { programParams.push("depth0"); }
	      else { programParams.push("depth" + (depth - 1)); }
	    }
	
	    return (depths.length === 0 ? "self.program(" : "self.programWithDepth(") + programParams.join(", ") + ")";
	  },
	
	  register: function(name, val) {
	    this.useRegister(name);
	    this.pushSource(name + " = " + val + ";");
	  },
	
	  useRegister: function(name) {
	    if(!this.registers[name]) {
	      this.registers[name] = true;
	      this.registers.list.push(name);
	    }
	  },
	
	  pushStackLiteral: function(item) {
	    return this.push(new Literal(item));
	  },
	
	  pushSource: function(source) {
	    if (this.pendingContent) {
	      this.source.push(this.appendToBuffer(this.quotedString(this.pendingContent)));
	      this.pendingContent = undefined;
	    }
	
	    if (source) {
	      this.source.push(source);
	    }
	  },
	
	  pushStack: function(item) {
	    this.flushInline();
	
	    var stack = this.incrStack();
	    if (item) {
	      this.pushSource(stack + " = " + item + ";");
	    }
	    this.compileStack.push(stack);
	    return stack;
	  },
	
	  replaceStack: function(callback) {
	    var prefix = '',
	        inline = this.isInline(),
	        stack;
	
	    // If we are currently inline then we want to merge the inline statement into the
	    // replacement statement via ','
	    if (inline) {
	      var top = this.popStack(true);
	
	      if (top instanceof Literal) {
	        // Literals do not need to be inlined
	        stack = top.value;
	      } else {
	        // Get or create the current stack name for use by the inline
	        var name = this.stackSlot ? this.topStackName() : this.incrStack();
	
	        prefix = '(' + this.push(name) + ' = ' + top + '),';
	        stack = this.topStack();
	      }
	    } else {
	      stack = this.topStack();
	    }
	
	    var item = callback.call(this, stack);
	
	    if (inline) {
	      if (this.inlineStack.length || this.compileStack.length) {
	        this.popStack();
	      }
	      this.push('(' + prefix + item + ')');
	    } else {
	      // Prevent modification of the context depth variable. Through replaceStack
	      if (!/^stack/.test(stack)) {
	        stack = this.nextStack();
	      }
	
	      this.pushSource(stack + " = (" + prefix + item + ");");
	    }
	    return stack;
	  },
	
	  nextStack: function() {
	    return this.pushStack();
	  },
	
	  incrStack: function() {
	    this.stackSlot++;
	    if(this.stackSlot > this.stackVars.length) { this.stackVars.push("stack" + this.stackSlot); }
	    return this.topStackName();
	  },
	  topStackName: function() {
	    return "stack" + this.stackSlot;
	  },
	  flushInline: function() {
	    var inlineStack = this.inlineStack;
	    if (inlineStack.length) {
	      this.inlineStack = [];
	      for (var i = 0, len = inlineStack.length; i < len; i++) {
	        var entry = inlineStack[i];
	        if (entry instanceof Literal) {
	          this.compileStack.push(entry);
	        } else {
	          this.pushStack(entry);
	        }
	      }
	    }
	  },
	  isInline: function() {
	    return this.inlineStack.length;
	  },
	
	  popStack: function(wrapped) {
	    var inline = this.isInline(),
	        item = (inline ? this.inlineStack : this.compileStack).pop();
	
	    if (!wrapped && (item instanceof Literal)) {
	      return item.value;
	    } else {
	      if (!inline) {
	        this.stackSlot--;
	      }
	      return item;
	    }
	  },
	
	  topStack: function(wrapped) {
	    var stack = (this.isInline() ? this.inlineStack : this.compileStack),
	        item = stack[stack.length - 1];
	
	    if (!wrapped && (item instanceof Literal)) {
	      return item.value;
	    } else {
	      return item;
	    }
	  },
	
	  quotedString: function(str) {
	    return '"' + str
	      .replace(/\\/g, '\\\\')
	      .replace(/"/g, '\\"')
	      .replace(/\n/g, '\\n')
	      .replace(/\r/g, '\\r')
	      .replace(/\u2028/g, '\\u2028')   // Per Ecma-262 7.3 + 7.8.4
	      .replace(/\u2029/g, '\\u2029') + '"';
	  },
	
	  setupHelper: function(paramSize, name, missingParams) {
	    var params = [];
	    this.setupParams(paramSize, params, missingParams);
	    var foundHelper = this.nameLookup('helpers', name, 'helper');
	
	    return {
	      params: params,
	      name: foundHelper,
	      callParams: ["depth0"].concat(params).join(", "),
	      helperMissingParams: missingParams && ["depth0", this.quotedString(name)].concat(params).join(", ")
	    };
	  },
	
	  // the params and contexts arguments are passed in arrays
	  // to fill in
	  setupParams: function(paramSize, params, useRegister) {
	    var options = [], contexts = [], types = [], param, inverse, program;
	
	    options.push("hash:" + this.popStack());
	
	    inverse = this.popStack();
	    program = this.popStack();
	
	    // Avoid setting fn and inverse if neither are set. This allows
	    // helpers to do a check for `if (options.fn)`
	    if (program || inverse) {
	      if (!program) {
	        this.context.aliases.self = "this";
	        program = "self.noop";
	      }
	
	      if (!inverse) {
	       this.context.aliases.self = "this";
	        inverse = "self.noop";
	      }
	
	      options.push("inverse:" + inverse);
	      options.push("fn:" + program);
	    }
	
	    for(var i=0; i<paramSize; i++) {
	      param = this.popStack();
	      params.push(param);
	
	      if(this.options.stringParams) {
	        types.push(this.popStack());
	        contexts.push(this.popStack());
	      }
	    }
	
	    if (this.options.stringParams) {
	      options.push("contexts:[" + contexts.join(",") + "]");
	      options.push("types:[" + types.join(",") + "]");
	      options.push("hashContexts:hashContexts");
	      options.push("hashTypes:hashTypes");
	    }
	
	    if(this.options.data) {
	      options.push("data:data");
	    }
	
	    options = "{" + options.join(",") + "}";
	    if (useRegister) {
	      this.register('options', options);
	      params.push('options');
	    } else {
	      params.push(options);
	    }
	    return params.join(", ");
	  }
	};
	
	var reservedWords = (
	  "break else new var" +
	  " case finally return void" +
	  " catch for switch while" +
	  " continue function this with" +
	  " default if throw" +
	  " delete in try" +
	  " do instanceof typeof" +
	  " abstract enum int short" +
	  " boolean export interface static" +
	  " byte extends long super" +
	  " char final native synchronized" +
	  " class float package throws" +
	  " const goto private transient" +
	  " debugger implements protected volatile" +
	  " double import public let yield"
	).split(" ");
	
	var compilerWords = JavaScriptCompiler.RESERVED_WORDS = {};
	
	for(var i=0, l=reservedWords.length; i<l; i++) {
	  compilerWords[reservedWords[i]] = true;
	}
	
	JavaScriptCompiler.isValidJavaScriptVariableName = function(name) {
	  if(!JavaScriptCompiler.RESERVED_WORDS[name] && /^[a-zA-Z_$][0-9a-zA-Z_$]+$/.test(name)) {
	    return true;
	  }
	  return false;
	};
	
	exports["default"] = JavaScriptCompiler;

/***/ }),
/* 89 */
/***/ (function(module, exports) {

	"use strict";
	function Visitor() {}
	
	Visitor.prototype = {
	  constructor: Visitor,
	
	  accept: function(object) {
	    return this[object.type](object);
	  }
	};
	
	exports["default"] = Visitor;

/***/ }),
/* 90 */
/***/ (function(module, exports) {

	"use strict";
	// Build out our basic SafeString type
	function SafeString(string) {
	  this.string = string;
	}
	
	SafeString.prototype.toString = function() {
	  return "" + this.string;
	};
	
	exports["default"] = SafeString;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Keycode 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Keycode
	//>>group: Core
	//>>description: Provide keycodes as keynames
	//>>docs: http://api.jqueryui.com/jQuery.ui.keyCode/
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1), __webpack_require__(41) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	return $.ui.keyCode = {
		BACKSPACE: 8,
		COMMA: 188,
		DELETE: 46,
		DOWN: 40,
		END: 35,
		ENTER: 13,
		ESCAPE: 27,
		HOME: 36,
		LEFT: 37,
		PAGE_DOWN: 34,
		PAGE_UP: 33,
		PERIOD: 190,
		RIGHT: 39,
		SPACE: 32,
		TAB: 9,
		UP: 38
	};
	
	} ) );


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(152), __webpack_require__(151), __webpack_require__(148), __webpack_require__(150), __webpack_require__(147), __webpack_require__(149), __webpack_require__(2), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_RESULT__ = function (GtmProductPage, GtmListingPage, GtmEventTracker, GtmHomePage, GtmCommonPage, GtmFlightProductPage, Object, OptionsMixin) {
	
	    var instance = null;
	
	    function GtmManager() {
	        if (instance !== null) {
	            throw new Error("Cannot instantiate more than one GtmManager, use GtmManager.getInstance()");
	        }
	
	        this.initialize();
	    }
	
	    GtmManager.prototype = $.extend(Object.create(OptionsMixin), /** @lends GtmBase.prototype */{
	        eventTracker: null,
	        getInstance: function getInstance() {
	            if (instance === null) {
	                instance = new GtmManager();
	            }
	            return instance;
	        },
	        initialize: function initialize() {},
	        setOptions: function setOptions(options) {
	            this.addOptions(options);
	            var scope = this.option('scope');
	            if (scope) {
	                scope.paramChange($.proxy(this._scopeParamChanged, this));
	            }
	            return this;
	        },
	        initPageTracker: function initPageTracker(pageType, options) {
	            var trackerOptions = $.extend(this.getOptions(), options);
	            switch (pageType) {
	                case 'productPage':
	                    return new GtmProductPage(trackerOptions);
	                    break;
	                case 'flightProductPage':
	                    return new GtmFlightProductPage(trackerOptions);
	                    break;
	                case 'homePage':
	                    return new GtmHomePage(trackerOptions);
	                    break;
	                case 'listingPage':
	                    return new GtmListingPage(trackerOptions);
	                    break;
	                case 'commonPage':
	                    return new GtmCommonPage(trackerOptions);
	                    break;
	            }
	        },
	        initEventTracker: function initEventTracker(options) {
	            this.eventTracker = new GtmEventTracker($.extend(this.getOptions(), options));
	            return this.eventTracker;
	        },
	        _scopeParamChanged: function _scopeParamChanged(event) {
	            this.eventTracker._scopeParamChanged(event);
	        }
	    });
	
	    GtmManager.getInstance = function () {
	        if (instance === null) {
	            instance = new GtmManager();
	        }
	        return instance;
	    };
	
	    return GtmManager.getInstance();
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(98);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 94 */,
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(3), __webpack_require__(2), __webpack_require__(11)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, _, Object, EventDispatcher) {
	
	    // Allocate memory only once for these:
	    var validShowEffects = ['show', 'fadeIn'],
	        validHideEffects = ['hide', 'fadeOut'];
	
	    /**
	     * The InlineModal constructor
	     *
	     * @param {String} selector The selector to the inline modal(s)
	     * @param {Object} [options] An optional options object
	     * @param {String} [options.showMethod='fadeIn'] The jQuery method to use to
	     *  show the modal. Can be one of 'show' or 'fadeIn'.
	     * @param {Number} [options.showEffectDuration=300] The duration for the
	     *  show effect.
	     * @param {String} [options.hideMethod='fadeOut'] The jQuery method to use to
	     *  hide the modal. Can be one of 'hide' or 'fadeOut'.
	     * @param {Number} [options.hideEffectDuration=600] The duration for the
	     *  show effect.
	     * @param {String} [options.triggerEventName='mouseenter'] The event type
	     *  to listen to.
	     * @param {String} [options.triggerSelectorAttribute='data-trigger'] The
	     *  attribute that contains the selector to the trigger element.
	     * @param {Boolean} [options.hideOnLeave=true] Whether to hide the modal
	     *  when the user leaves it with the mouse.
	     * @param {Number} [options.hideDelay=300] If hideOnLeave is set to true,
	     *  this defines the duration by which hiding is delayed
	     * @param {String} [options.closeButtonSelector='[data-fcse-role=inlinemodal-close]']
	     *  The selector for nodes inside of the modal that should act as close
	     *  buttons.
	     * @param {Boolean} [options.autoHide=true] Whether to auto-hide the modal
	     *  if the user doesn't interact with it.
	     * @param {Number} [options.autoHideDelay=5000] If autoHide is set to true,
	     *  this defines the delay after which the modal is hidden.
	     * @constructor
	     * @name InlineModal
	     */
	    var InlineModal = function InlineModal(selector, options) {
	        EventDispatcher.apply(this, arguments);
	
	        // Set elements
	        this._elements = $(selector);
	
	        // Set options
	        var defaultOptions = {
	
	            // The jQuery method to use to show the modal. Can be one of 'show' or 'fadeIn'.
	            showMethod: 'fadeIn',
	
	            // The duration for the show effect.
	            showEffectDuration: 300,
	
	            //The jQuery method to use to hide the modal. Can be one of 'hide' or 'fadeOut'.
	            hideMethod: 'fadeOut',
	
	            // The duration for the show effect.
	            hideEffectDuration: 600,
	
	            // The event type to listen to.
	            triggerEventName: 'mouseenter',
	
	            // The attribute that contains the selector to the trigger element.
	            triggerSelectorAttribute: 'data-trigger',
	
	            // Whether to hide the modal when the user leaves it with the mouse.
	            hideOnLeave: true,
	
	            // If hideOnLeave is set to true, this defines the duration by which hiding is delayed
	            hideDelay: 300,
	
	            // The selector for nodes inside of the modal that should act as close buttons.
	            closeButtonSelector: '[data-fcse-role=inlinemodal-close]',
	
	            // Whether to auto-hide the modal if the user doesn't interact with it.
	            autoHide: true,
	
	            // If autoHide is set to true, this defines the delay after which the modal is hidden.
	            autoHideDelay: 5000
	        };
	
	        this.options = $.extend({}, defaultOptions, options);
	
	        if (_.indexOf(validShowEffects, this.options.showMethod) == -1) {
	            this.options.showMethod = defaultOptions.showMethod;
	        }
	
	        if (_.indexOf(validHideEffects, this.options.hideMethod) == -1) {
	            this.options.hideMethod = defaultOptions.hideMethod;
	        }
	
	        // Register events
	        this.registerEvent("show");
	        this.registerEvent("hide");
	
	        this._init();
	    };
	
	    InlineModal.prototype = /** @lends InlineModal */$.extend(Object.create(EventDispatcher.prototype), {
	
	        /**
	         * A reference to the ctor
	         *
	         * @type {InlineModal}
	         */
	        constructor: InlineModal,
	
	        /**
	         * The applied options for this instance
	         *
	         * @type {Object}
	         */
	        options: null,
	
	        /**
	         * The internally used timeout id
	         *
	         * @type {Number}
	         * @private
	         */
	        _closeTimeout: null,
	
	        /**
	         * Initialises matching InlineModals
	         *
	         * @private
	         */
	        _init: function _init() {
	            this._elements.each($.proxy(this._initItem, this));
	        },
	
	        /**
	         * Runs initialisation for a single matching node
	         *
	         * @param {Number} _ The index of the node in jQuery's node collection
	         * @param {HTMLElement} node The matching node
	         * @private
	         */
	        _initItem: function _initItem(_, node) {
	            node = $(node);
	            var triggerNodeSelector = node.attr(this.options.triggerSelectorAttribute),
	                triggerNode = $(triggerNodeSelector),
	                triggerEventName = this.options.triggerEventName,
	                closeButtonSelector = this.options.closeButtonSelector;
	
	            if (!triggerNode.length) {
	                throw new Error('InlineModal cannot find trigger node, selector was ' + triggerNodeSelector);
	            }
	
	            triggerNode.on(triggerEventName, $.proxy(this.show, this, node));
	            node.find(closeButtonSelector).on('click', $.proxy(this.hide, this, node));
	        },
	
	        /**
	         * Shows the inline modal
	         *
	         * @param {jQuery} node The node of the modal
	         */
	        show: function show(node) {
	            if (this._currentNode != node) {
	                // If there are multiple modals managed by this instance, hide
	                // others before showing this one
	                this._elements.hide();
	            }
	
	            clearTimeout(this._closeTimeout);
	            this._currentNode = node;
	            node[this.options.showMethod](this.options.showEffectDuration);
	
	            if (this.options.hideOnLeave) {
	                node.on('mouseenter', $.proxy(function () {
	                    clearTimeout(this._closeTimeout);
	                }, this));
	                node.on('mouseleave', $.proxy(this._scheduleClose, this, node, this.options.hideDelay));
	            }
	
	            if (this.options.autoHide) {
	                this._scheduleClose(node, this.options.autoHideDelay);
	            }
	
	            // Dispatch show event
	            if (!node.data('inline-modal-open')) {
	                node.data('inline-modal-open', true);
	                this.dispatchEvent("show", node);
	            }
	        },
	
	        /**
	         * Hides the modal
	         *
	         * @param {jQuery} node The node of the modal
	         */
	        hide: function hide(node) {
	            if (this.options.hideOnLeave) {
	                node.off('mouseenter').off('mouseleave');
	            }
	            clearTimeout(this._closeTimeout);
	            node[this.options.hideMethod](this.options.hideEffectDuration);
	
	            // Dispatch hide event
	            this.dispatchEvent("hide", node);
	            node.data('inline-modal-open', false);
	        },
	
	        /**
	         * Schedules hiding of the modal
	         *
	         * @param {jQuery} node The node of the modal
	         * @param {Number} delay The delay in ms
	         * @private
	         */
	        _scheduleClose: function _scheduleClose(node, delay) {
	            this._closeTimeout = setTimeout($.proxy(this.hide, this, node), delay);
	        }
	    });
	
	    return InlineModal;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Created by Pavel on 14.11.14.
	 *
	 * Lazy image component
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($) {
	    var defaultAttr = 'data-lazy-img-src',
	        LazyLoader = {
	        loadImages: function loadImages(element, attr) {
	            if (typeof attr === 'undefined') {
	                attr = defaultAttr;
	            }
	            $('img[' + attr + ']', element).each(function () {
	                var image = $(this);
	                image[0].onload = function () {
	                    image.removeAttr('data-lazy-img-src');
	                };
	                image.attr('src', image.attr('data-lazy-img-src'));
	            });
	        }
	    };
	
	    return LazyLoader;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(45);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 98 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(42);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(47);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(137)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(76)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(7)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(15)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(21);
	var toLength = __webpack_require__(100);
	var toAbsoluteIndex = __webpack_require__(107);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(42);
	var TAG = __webpack_require__(7)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(6).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(42);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(47);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(138);
	var getKeys = __webpack_require__(33);
	var redefine = __webpack_require__(28);
	var global = __webpack_require__(6);
	var hide = __webpack_require__(15);
	var Iterators = __webpack_require__(49);
	var wks = __webpack_require__(7);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	// This file is autogenerated via the `commonjs` Grunt task. You can require() this file in a CommonJS environment.
	__webpack_require__(126)
	__webpack_require__(116)
	__webpack_require__(117)
	__webpack_require__(118)
	__webpack_require__(119)
	__webpack_require__(120)
	__webpack_require__(121)
	__webpack_require__(125)
	__webpack_require__(122)
	__webpack_require__(123)
	__webpack_require__(124)
	__webpack_require__(115)

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(44);
	var createDesc = __webpack_require__(36);
	var toIObject = __webpack_require__(21);
	var toPrimitive = __webpack_require__(51);
	var has = __webpack_require__(10);
	var IE8_DOM_DEFINE = __webpack_require__(74);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(18) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(104);
	var test = {};
	test[__webpack_require__(7)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(28)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ }),
/* 112 */,
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(128), __esModule: true };

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(129), __esModule: true };

/***/ }),
/* 115 */
/***/ (function(module, exports) {

	/* ========================================================================
	 * Bootstrap: affix.js v3.3.7
	 * http://getbootstrap.com/javascript/#affix
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // AFFIX CLASS DEFINITION
	  // ======================
	
	  var Affix = function (element, options) {
	    this.options = $.extend({}, Affix.DEFAULTS, options)
	
	    this.$target = $(this.options.target)
	      .on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this))
	      .on('click.bs.affix.data-api',  $.proxy(this.checkPositionWithEventLoop, this))
	
	    this.$element     = $(element)
	    this.affixed      = null
	    this.unpin        = null
	    this.pinnedOffset = null
	
	    this.checkPosition()
	  }
	
	  Affix.VERSION  = '3.3.7'
	
	  Affix.RESET    = 'affix affix-top affix-bottom'
	
	  Affix.DEFAULTS = {
	    offset: 0,
	    target: window
	  }
	
	  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
	    var scrollTop    = this.$target.scrollTop()
	    var position     = this.$element.offset()
	    var targetHeight = this.$target.height()
	
	    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false
	
	    if (this.affixed == 'bottom') {
	      if (offsetTop != null) return (scrollTop + this.unpin <= position.top) ? false : 'bottom'
	      return (scrollTop + targetHeight <= scrollHeight - offsetBottom) ? false : 'bottom'
	    }
	
	    var initializing   = this.affixed == null
	    var colliderTop    = initializing ? scrollTop : position.top
	    var colliderHeight = initializing ? targetHeight : height
	
	    if (offsetTop != null && scrollTop <= offsetTop) return 'top'
	    if (offsetBottom != null && (colliderTop + colliderHeight >= scrollHeight - offsetBottom)) return 'bottom'
	
	    return false
	  }
	
	  Affix.prototype.getPinnedOffset = function () {
	    if (this.pinnedOffset) return this.pinnedOffset
	    this.$element.removeClass(Affix.RESET).addClass('affix')
	    var scrollTop = this.$target.scrollTop()
	    var position  = this.$element.offset()
	    return (this.pinnedOffset = position.top - scrollTop)
	  }
	
	  Affix.prototype.checkPositionWithEventLoop = function () {
	    setTimeout($.proxy(this.checkPosition, this), 1)
	  }
	
	  Affix.prototype.checkPosition = function () {
	    if (!this.$element.is(':visible')) return
	
	    var height       = this.$element.height()
	    var offset       = this.options.offset
	    var offsetTop    = offset.top
	    var offsetBottom = offset.bottom
	    var scrollHeight = Math.max($(document).height(), $(document.body).height())
	
	    if (typeof offset != 'object')         offsetBottom = offsetTop = offset
	    if (typeof offsetTop == 'function')    offsetTop    = offset.top(this.$element)
	    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element)
	
	    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom)
	
	    if (this.affixed != affix) {
	      if (this.unpin != null) this.$element.css('top', '')
	
	      var affixType = 'affix' + (affix ? '-' + affix : '')
	      var e         = $.Event(affixType + '.bs.affix')
	
	      this.$element.trigger(e)
	
	      if (e.isDefaultPrevented()) return
	
	      this.affixed = affix
	      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null
	
	      this.$element
	        .removeClass(Affix.RESET)
	        .addClass(affixType)
	        .trigger(affixType.replace('affix', 'affixed') + '.bs.affix')
	    }
	
	    if (affix == 'bottom') {
	      this.$element.offset({
	        top: scrollHeight - height - offsetBottom
	      })
	    }
	  }
	
	
	  // AFFIX PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.affix')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.affix', (data = new Affix(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.affix
	
	  $.fn.affix             = Plugin
	  $.fn.affix.Constructor = Affix
	
	
	  // AFFIX NO CONFLICT
	  // =================
	
	  $.fn.affix.noConflict = function () {
	    $.fn.affix = old
	    return this
	  }
	
	
	  // AFFIX DATA-API
	  // ==============
	
	  $(window).on('load', function () {
	    $('[data-spy="affix"]').each(function () {
	      var $spy = $(this)
	      var data = $spy.data()
	
	      data.offset = data.offset || {}
	
	      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom
	      if (data.offsetTop    != null) data.offset.top    = data.offsetTop
	
	      Plugin.call($spy, data)
	    })
	  })
	
	}(jQuery);


/***/ }),
/* 116 */
/***/ (function(module, exports) {

	/* ========================================================================
	 * Bootstrap: alert.js v3.3.7
	 * http://getbootstrap.com/javascript/#alerts
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // ALERT CLASS DEFINITION
	  // ======================
	
	  var dismiss = '[data-dismiss="alert"]'
	  var Alert   = function (el) {
	    $(el).on('click', dismiss, this.close)
	  }
	
	  Alert.VERSION = '3.3.7'
	
	  Alert.TRANSITION_DURATION = 150
	
	  Alert.prototype.close = function (e) {
	    var $this    = $(this)
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    var $parent = $(selector === '#' ? [] : selector)
	
	    if (e) e.preventDefault()
	
	    if (!$parent.length) {
	      $parent = $this.closest('.alert')
	    }
	
	    $parent.trigger(e = $.Event('close.bs.alert'))
	
	    if (e.isDefaultPrevented()) return
	
	    $parent.removeClass('in')
	
	    function removeElement() {
	      // detach from parent, fire event then clean up data
	      $parent.detach().trigger('closed.bs.alert').remove()
	    }
	
	    $.support.transition && $parent.hasClass('fade') ?
	      $parent
	        .one('bsTransitionEnd', removeElement)
	        .emulateTransitionEnd(Alert.TRANSITION_DURATION) :
	      removeElement()
	  }
	
	
	  // ALERT PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.alert')
	
	      if (!data) $this.data('bs.alert', (data = new Alert(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  var old = $.fn.alert
	
	  $.fn.alert             = Plugin
	  $.fn.alert.Constructor = Alert
	
	
	  // ALERT NO CONFLICT
	  // =================
	
	  $.fn.alert.noConflict = function () {
	    $.fn.alert = old
	    return this
	  }
	
	
	  // ALERT DATA-API
	  // ==============
	
	  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close)
	
	}(jQuery);


/***/ }),
/* 117 */
/***/ (function(module, exports) {

	/* ========================================================================
	 * Bootstrap: button.js v3.3.7
	 * http://getbootstrap.com/javascript/#buttons
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // BUTTON PUBLIC CLASS DEFINITION
	  // ==============================
	
	  var Button = function (element, options) {
	    this.$element  = $(element)
	    this.options   = $.extend({}, Button.DEFAULTS, options)
	    this.isLoading = false
	  }
	
	  Button.VERSION  = '3.3.7'
	
	  Button.DEFAULTS = {
	    loadingText: 'loading...'
	  }
	
	  Button.prototype.setState = function (state) {
	    var d    = 'disabled'
	    var $el  = this.$element
	    var val  = $el.is('input') ? 'val' : 'html'
	    var data = $el.data()
	
	    state += 'Text'
	
	    if (data.resetText == null) $el.data('resetText', $el[val]())
	
	    // push to event loop to allow forms to submit
	    setTimeout($.proxy(function () {
	      $el[val](data[state] == null ? this.options[state] : data[state])
	
	      if (state == 'loadingText') {
	        this.isLoading = true
	        $el.addClass(d).attr(d, d).prop(d, true)
	      } else if (this.isLoading) {
	        this.isLoading = false
	        $el.removeClass(d).removeAttr(d).prop(d, false)
	      }
	    }, this), 0)
	  }
	
	  Button.prototype.toggle = function () {
	    var changed = true
	    var $parent = this.$element.closest('[data-toggle="buttons"]')
	
	    if ($parent.length) {
	      var $input = this.$element.find('input')
	      if ($input.prop('type') == 'radio') {
	        if ($input.prop('checked')) changed = false
	        $parent.find('.active').removeClass('active')
	        this.$element.addClass('active')
	      } else if ($input.prop('type') == 'checkbox') {
	        if (($input.prop('checked')) !== this.$element.hasClass('active')) changed = false
	        this.$element.toggleClass('active')
	      }
	      $input.prop('checked', this.$element.hasClass('active'))
	      if (changed) $input.trigger('change')
	    } else {
	      this.$element.attr('aria-pressed', !this.$element.hasClass('active'))
	      this.$element.toggleClass('active')
	    }
	  }
	
	
	  // BUTTON PLUGIN DEFINITION
	  // ========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.button')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.button', (data = new Button(this, options)))
	
	      if (option == 'toggle') data.toggle()
	      else if (option) data.setState(option)
	    })
	  }
	
	  var old = $.fn.button
	
	  $.fn.button             = Plugin
	  $.fn.button.Constructor = Button
	
	
	  // BUTTON NO CONFLICT
	  // ==================
	
	  $.fn.button.noConflict = function () {
	    $.fn.button = old
	    return this
	  }
	
	
	  // BUTTON DATA-API
	  // ===============
	
	  $(document)
	    .on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	      var $btn = $(e.target).closest('.btn')
	      Plugin.call($btn, 'toggle')
	      if (!($(e.target).is('input[type="radio"], input[type="checkbox"]'))) {
	        // Prevent double click on radios, and the double selections (so cancellation) on checkboxes
	        e.preventDefault()
	        // The target component still receive the focus
	        if ($btn.is('input,button')) $btn.trigger('focus')
	        else $btn.find('input:visible,button:visible').first().trigger('focus')
	      }
	    })
	    .on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	      $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type))
	    })
	
	}(jQuery);


/***/ }),
/* 118 */
/***/ (function(module, exports) {

	/* ========================================================================
	 * Bootstrap: carousel.js v3.3.7
	 * http://getbootstrap.com/javascript/#carousel
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CAROUSEL CLASS DEFINITION
	  // =========================
	
	  var Carousel = function (element, options) {
	    this.$element    = $(element)
	    this.$indicators = this.$element.find('.carousel-indicators')
	    this.options     = options
	    this.paused      = null
	    this.sliding     = null
	    this.interval    = null
	    this.$active     = null
	    this.$items      = null
	
	    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this))
	
	    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element
	      .on('mouseenter.bs.carousel', $.proxy(this.pause, this))
	      .on('mouseleave.bs.carousel', $.proxy(this.cycle, this))
	  }
	
	  Carousel.VERSION  = '3.3.7'
	
	  Carousel.TRANSITION_DURATION = 600
	
	  Carousel.DEFAULTS = {
	    interval: 5000,
	    pause: 'hover',
	    wrap: true,
	    keyboard: true
	  }
	
	  Carousel.prototype.keydown = function (e) {
	    if (/input|textarea/i.test(e.target.tagName)) return
	    switch (e.which) {
	      case 37: this.prev(); break
	      case 39: this.next(); break
	      default: return
	    }
	
	    e.preventDefault()
	  }
	
	  Carousel.prototype.cycle = function (e) {
	    e || (this.paused = false)
	
	    this.interval && clearInterval(this.interval)
	
	    this.options.interval
	      && !this.paused
	      && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))
	
	    return this
	  }
	
	  Carousel.prototype.getItemIndex = function (item) {
	    this.$items = item.parent().children('.item')
	    return this.$items.index(item || this.$active)
	  }
	
	  Carousel.prototype.getItemForDirection = function (direction, active) {
	    var activeIndex = this.getItemIndex(active)
	    var willWrap = (direction == 'prev' && activeIndex === 0)
	                || (direction == 'next' && activeIndex == (this.$items.length - 1))
	    if (willWrap && !this.options.wrap) return active
	    var delta = direction == 'prev' ? -1 : 1
	    var itemIndex = (activeIndex + delta) % this.$items.length
	    return this.$items.eq(itemIndex)
	  }
	
	  Carousel.prototype.to = function (pos) {
	    var that        = this
	    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'))
	
	    if (pos > (this.$items.length - 1) || pos < 0) return
	
	    if (this.sliding)       return this.$element.one('slid.bs.carousel', function () { that.to(pos) }) // yes, "slid"
	    if (activeIndex == pos) return this.pause().cycle()
	
	    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos))
	  }
	
	  Carousel.prototype.pause = function (e) {
	    e || (this.paused = true)
	
	    if (this.$element.find('.next, .prev').length && $.support.transition) {
	      this.$element.trigger($.support.transition.end)
	      this.cycle(true)
	    }
	
	    this.interval = clearInterval(this.interval)
	
	    return this
	  }
	
	  Carousel.prototype.next = function () {
	    if (this.sliding) return
	    return this.slide('next')
	  }
	
	  Carousel.prototype.prev = function () {
	    if (this.sliding) return
	    return this.slide('prev')
	  }
	
	  Carousel.prototype.slide = function (type, next) {
	    var $active   = this.$element.find('.item.active')
	    var $next     = next || this.getItemForDirection(type, $active)
	    var isCycling = this.interval
	    var direction = type == 'next' ? 'left' : 'right'
	    var that      = this
	
	    if ($next.hasClass('active')) return (this.sliding = false)
	
	    var relatedTarget = $next[0]
	    var slideEvent = $.Event('slide.bs.carousel', {
	      relatedTarget: relatedTarget,
	      direction: direction
	    })
	    this.$element.trigger(slideEvent)
	    if (slideEvent.isDefaultPrevented()) return
	
	    this.sliding = true
	
	    isCycling && this.pause()
	
	    if (this.$indicators.length) {
	      this.$indicators.find('.active').removeClass('active')
	      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)])
	      $nextIndicator && $nextIndicator.addClass('active')
	    }
	
	    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }) // yes, "slid"
	    if ($.support.transition && this.$element.hasClass('slide')) {
	      $next.addClass(type)
	      $next[0].offsetWidth // force reflow
	      $active.addClass(direction)
	      $next.addClass(direction)
	      $active
	        .one('bsTransitionEnd', function () {
	          $next.removeClass([type, direction].join(' ')).addClass('active')
	          $active.removeClass(['active', direction].join(' '))
	          that.sliding = false
	          setTimeout(function () {
	            that.$element.trigger(slidEvent)
	          }, 0)
	        })
	        .emulateTransitionEnd(Carousel.TRANSITION_DURATION)
	    } else {
	      $active.removeClass('active')
	      $next.addClass('active')
	      this.sliding = false
	      this.$element.trigger(slidEvent)
	    }
	
	    isCycling && this.cycle()
	
	    return this
	  }
	
	
	  // CAROUSEL PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.carousel')
	      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == 'object' && option)
	      var action  = typeof option == 'string' ? option : options.slide
	
	      if (!data) $this.data('bs.carousel', (data = new Carousel(this, options)))
	      if (typeof option == 'number') data.to(option)
	      else if (action) data[action]()
	      else if (options.interval) data.pause().cycle()
	    })
	  }
	
	  var old = $.fn.carousel
	
	  $.fn.carousel             = Plugin
	  $.fn.carousel.Constructor = Carousel
	
	
	  // CAROUSEL NO CONFLICT
	  // ====================
	
	  $.fn.carousel.noConflict = function () {
	    $.fn.carousel = old
	    return this
	  }
	
	
	  // CAROUSEL DATA-API
	  // =================
	
	  var clickHandler = function (e) {
	    var href
	    var $this   = $(this)
	    var $target = $($this.attr('data-target') || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7
	    if (!$target.hasClass('carousel')) return
	    var options = $.extend({}, $target.data(), $this.data())
	    var slideIndex = $this.attr('data-slide-to')
	    if (slideIndex) options.interval = false
	
	    Plugin.call($target, options)
	
	    if (slideIndex) {
	      $target.data('bs.carousel').to(slideIndex)
	    }
	
	    e.preventDefault()
	  }
	
	  $(document)
	    .on('click.bs.carousel.data-api', '[data-slide]', clickHandler)
	    .on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler)
	
	  $(window).on('load', function () {
	    $('[data-ride="carousel"]').each(function () {
	      var $carousel = $(this)
	      Plugin.call($carousel, $carousel.data())
	    })
	  })
	
	}(jQuery);


/***/ }),
/* 119 */
/***/ (function(module, exports) {

	/* ========================================================================
	 * Bootstrap: collapse.js v3.3.7
	 * http://getbootstrap.com/javascript/#collapse
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	/* jshint latedef: false */
	
	+function ($) {
	  'use strict';
	
	  // COLLAPSE PUBLIC CLASS DEFINITION
	  // ================================
	
	  var Collapse = function (element, options) {
	    this.$element      = $(element)
	    this.options       = $.extend({}, Collapse.DEFAULTS, options)
	    this.$trigger      = $('[data-toggle="collapse"][href="#' + element.id + '"],' +
	                           '[data-toggle="collapse"][data-target="#' + element.id + '"]')
	    this.transitioning = null
	
	    if (this.options.parent) {
	      this.$parent = this.getParent()
	    } else {
	      this.addAriaAndCollapsedClass(this.$element, this.$trigger)
	    }
	
	    if (this.options.toggle) this.toggle()
	  }
	
	  Collapse.VERSION  = '3.3.7'
	
	  Collapse.TRANSITION_DURATION = 350
	
	  Collapse.DEFAULTS = {
	    toggle: true
	  }
	
	  Collapse.prototype.dimension = function () {
	    var hasWidth = this.$element.hasClass('width')
	    return hasWidth ? 'width' : 'height'
	  }
	
	  Collapse.prototype.show = function () {
	    if (this.transitioning || this.$element.hasClass('in')) return
	
	    var activesData
	    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing')
	
	    if (actives && actives.length) {
	      activesData = actives.data('bs.collapse')
	      if (activesData && activesData.transitioning) return
	    }
	
	    var startEvent = $.Event('show.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    if (actives && actives.length) {
	      Plugin.call(actives, 'hide')
	      activesData || actives.data('bs.collapse', null)
	    }
	
	    var dimension = this.dimension()
	
	    this.$element
	      .removeClass('collapse')
	      .addClass('collapsing')[dimension](0)
	      .attr('aria-expanded', true)
	
	    this.$trigger
	      .removeClass('collapsed')
	      .attr('aria-expanded', true)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse in')[dimension]('')
	      this.transitioning = 0
	      this.$element
	        .trigger('shown.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    var scrollSize = $.camelCase(['scroll', dimension].join('-'))
	
	    this.$element
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])
	  }
	
	  Collapse.prototype.hide = function () {
	    if (this.transitioning || !this.$element.hasClass('in')) return
	
	    var startEvent = $.Event('hide.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    var dimension = this.dimension()
	
	    this.$element[dimension](this.$element[dimension]())[0].offsetHeight
	
	    this.$element
	      .addClass('collapsing')
	      .removeClass('collapse in')
	      .attr('aria-expanded', false)
	
	    this.$trigger
	      .addClass('collapsed')
	      .attr('aria-expanded', false)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.transitioning = 0
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse')
	        .trigger('hidden.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    this.$element
	      [dimension](0)
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
	  }
	
	  Collapse.prototype.toggle = function () {
	    this[this.$element.hasClass('in') ? 'hide' : 'show']()
	  }
	
	  Collapse.prototype.getParent = function () {
	    return $(this.options.parent)
	      .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
	      .each($.proxy(function (i, element) {
	        var $element = $(element)
	        this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)
	      }, this))
	      .end()
	  }
	
	  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
	    var isOpen = $element.hasClass('in')
	
	    $element.attr('aria-expanded', isOpen)
	    $trigger
	      .toggleClass('collapsed', !isOpen)
	      .attr('aria-expanded', isOpen)
	  }
	
	  function getTargetFromTrigger($trigger) {
	    var href
	    var target = $trigger.attr('data-target')
	      || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7
	
	    return $(target)
	  }
	
	
	  // COLLAPSE PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.collapse')
	      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false
	      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.collapse
	
	  $.fn.collapse             = Plugin
	  $.fn.collapse.Constructor = Collapse
	
	
	  // COLLAPSE NO CONFLICT
	  // ====================
	
	  $.fn.collapse.noConflict = function () {
	    $.fn.collapse = old
	    return this
	  }
	
	
	  // COLLAPSE DATA-API
	  // =================
	
	  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
	    var $this   = $(this)
	
	    if (!$this.attr('data-target')) e.preventDefault()
	
	    var $target = getTargetFromTrigger($this)
	    var data    = $target.data('bs.collapse')
	    var option  = data ? 'toggle' : $this.data()
	
	    Plugin.call($target, option)
	  })
	
	}(jQuery);


/***/ }),
/* 120 */
/***/ (function(module, exports) {

	/* ========================================================================
	 * Bootstrap: dropdown.js v3.3.7
	 * http://getbootstrap.com/javascript/#dropdowns
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // DROPDOWN CLASS DEFINITION
	  // =========================
	
	  var backdrop = '.dropdown-backdrop'
	  var toggle   = '[data-toggle="dropdown"]'
	  var Dropdown = function (element) {
	    $(element).on('click.bs.dropdown', this.toggle)
	  }
	
	  Dropdown.VERSION = '3.3.7'
	
	  function getParent($this) {
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    var $parent = selector && $(selector)
	
	    return $parent && $parent.length ? $parent : $this.parent()
	  }
	
	  function clearMenus(e) {
	    if (e && e.which === 3) return
	    $(backdrop).remove()
	    $(toggle).each(function () {
	      var $this         = $(this)
	      var $parent       = getParent($this)
	      var relatedTarget = { relatedTarget: this }
	
	      if (!$parent.hasClass('open')) return
	
	      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return
	
	      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this.attr('aria-expanded', 'false')
	      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget))
	    })
	  }
	
	  Dropdown.prototype.toggle = function (e) {
	    var $this = $(this)
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    clearMenus()
	
	    if (!isActive) {
	      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
	        // if mobile we use a backdrop because click events don't delegate
	        $(document.createElement('div'))
	          .addClass('dropdown-backdrop')
	          .insertAfter($(this))
	          .on('click', clearMenus)
	      }
	
	      var relatedTarget = { relatedTarget: this }
	      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this
	        .trigger('focus')
	        .attr('aria-expanded', 'true')
	
	      $parent
	        .toggleClass('open')
	        .trigger($.Event('shown.bs.dropdown', relatedTarget))
	    }
	
	    return false
	  }
	
	  Dropdown.prototype.keydown = function (e) {
	    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return
	
	    var $this = $(this)
	
	    e.preventDefault()
	    e.stopPropagation()
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    if (!isActive && e.which != 27 || isActive && e.which == 27) {
	      if (e.which == 27) $parent.find(toggle).trigger('focus')
	      return $this.trigger('click')
	    }
	
	    var desc = ' li:not(.disabled):visible a'
	    var $items = $parent.find('.dropdown-menu' + desc)
	
	    if (!$items.length) return
	
	    var index = $items.index(e.target)
	
	    if (e.which == 38 && index > 0)                 index--         // up
	    if (e.which == 40 && index < $items.length - 1) index++         // down
	    if (!~index)                                    index = 0
	
	    $items.eq(index).trigger('focus')
	  }
	
	
	  // DROPDOWN PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.dropdown')
	
	      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  var old = $.fn.dropdown
	
	  $.fn.dropdown             = Plugin
	  $.fn.dropdown.Constructor = Dropdown
	
	
	  // DROPDOWN NO CONFLICT
	  // ====================
	
	  $.fn.dropdown.noConflict = function () {
	    $.fn.dropdown = old
	    return this
	  }
	
	
	  // APPLY TO STANDARD DROPDOWN ELEMENTS
	  // ===================================
	
	  $(document)
	    .on('click.bs.dropdown.data-api', clearMenus)
	    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
	    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
	    .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
	    .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown)
	
	}(jQuery);


/***/ }),
/* 121 */
/***/ (function(module, exports) {

	/* ========================================================================
	 * Bootstrap: modal.js v3.3.7
	 * http://getbootstrap.com/javascript/#modals
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // MODAL CLASS DEFINITION
	  // ======================
	
	  var Modal = function (element, options) {
	    this.options             = options
	    this.$body               = $(document.body)
	    this.$element            = $(element)
	    this.$dialog             = this.$element.find('.modal-dialog')
	    this.$backdrop           = null
	    this.isShown             = null
	    this.originalBodyPad     = null
	    this.scrollbarWidth      = 0
	    this.ignoreBackdropClick = false
	
	    if (this.options.remote) {
	      this.$element
	        .find('.modal-content')
	        .load(this.options.remote, $.proxy(function () {
	          this.$element.trigger('loaded.bs.modal')
	        }, this))
	    }
	  }
	
	  Modal.VERSION  = '3.3.7'
	
	  Modal.TRANSITION_DURATION = 300
	  Modal.BACKDROP_TRANSITION_DURATION = 150
	
	  Modal.DEFAULTS = {
	    backdrop: true,
	    keyboard: true,
	    show: true
	  }
	
	  Modal.prototype.toggle = function (_relatedTarget) {
	    return this.isShown ? this.hide() : this.show(_relatedTarget)
	  }
	
	  Modal.prototype.show = function (_relatedTarget) {
	    var that = this
	    var e    = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })
	
	    this.$element.trigger(e)
	
	    if (this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = true
	
	    this.checkScrollbar()
	    this.setScrollbar()
	    this.$body.addClass('modal-open')
	
	    this.escape()
	    this.resize()
	
	    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))
	
	    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
	      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
	        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
	      })
	    })
	
	    this.backdrop(function () {
	      var transition = $.support.transition && that.$element.hasClass('fade')
	
	      if (!that.$element.parent().length) {
	        that.$element.appendTo(that.$body) // don't move modals dom position
	      }
	
	      that.$element
	        .show()
	        .scrollTop(0)
	
	      that.adjustDialog()
	
	      if (transition) {
	        that.$element[0].offsetWidth // force reflow
	      }
	
	      that.$element.addClass('in')
	
	      that.enforceFocus()
	
	      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })
	
	      transition ?
	        that.$dialog // wait for modal to slide in
	          .one('bsTransitionEnd', function () {
	            that.$element.trigger('focus').trigger(e)
	          })
	          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
	        that.$element.trigger('focus').trigger(e)
	    })
	  }
	
	  Modal.prototype.hide = function (e) {
	    if (e) e.preventDefault()
	
	    e = $.Event('hide.bs.modal')
	
	    this.$element.trigger(e)
	
	    if (!this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = false
	
	    this.escape()
	    this.resize()
	
	    $(document).off('focusin.bs.modal')
	
	    this.$element
	      .removeClass('in')
	      .off('click.dismiss.bs.modal')
	      .off('mouseup.dismiss.bs.modal')
	
	    this.$dialog.off('mousedown.dismiss.bs.modal')
	
	    $.support.transition && this.$element.hasClass('fade') ?
	      this.$element
	        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
	        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
	      this.hideModal()
	  }
	
	  Modal.prototype.enforceFocus = function () {
	    $(document)
	      .off('focusin.bs.modal') // guard against infinite focus loop
	      .on('focusin.bs.modal', $.proxy(function (e) {
	        if (document !== e.target &&
	            this.$element[0] !== e.target &&
	            !this.$element.has(e.target).length) {
	          this.$element.trigger('focus')
	        }
	      }, this))
	  }
	
	  Modal.prototype.escape = function () {
	    if (this.isShown && this.options.keyboard) {
	      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
	        e.which == 27 && this.hide()
	      }, this))
	    } else if (!this.isShown) {
	      this.$element.off('keydown.dismiss.bs.modal')
	    }
	  }
	
	  Modal.prototype.resize = function () {
	    if (this.isShown) {
	      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
	    } else {
	      $(window).off('resize.bs.modal')
	    }
	  }
	
	  Modal.prototype.hideModal = function () {
	    var that = this
	    this.$element.hide()
	    this.backdrop(function () {
	      that.$body.removeClass('modal-open')
	      that.resetAdjustments()
	      that.resetScrollbar()
	      that.$element.trigger('hidden.bs.modal')
	    })
	  }
	
	  Modal.prototype.removeBackdrop = function () {
	    this.$backdrop && this.$backdrop.remove()
	    this.$backdrop = null
	  }
	
	  Modal.prototype.backdrop = function (callback) {
	    var that = this
	    var animate = this.$element.hasClass('fade') ? 'fade' : ''
	
	    if (this.isShown && this.options.backdrop) {
	      var doAnimate = $.support.transition && animate
	
	      this.$backdrop = $(document.createElement('div'))
	        .addClass('modal-backdrop ' + animate)
	        .appendTo(this.$body)
	
	      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
	        if (this.ignoreBackdropClick) {
	          this.ignoreBackdropClick = false
	          return
	        }
	        if (e.target !== e.currentTarget) return
	        this.options.backdrop == 'static'
	          ? this.$element[0].focus()
	          : this.hide()
	      }, this))
	
	      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow
	
	      this.$backdrop.addClass('in')
	
	      if (!callback) return
	
	      doAnimate ?
	        this.$backdrop
	          .one('bsTransitionEnd', callback)
	          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
	        callback()
	
	    } else if (!this.isShown && this.$backdrop) {
	      this.$backdrop.removeClass('in')
	
	      var callbackRemove = function () {
	        that.removeBackdrop()
	        callback && callback()
	      }
	      $.support.transition && this.$element.hasClass('fade') ?
	        this.$backdrop
	          .one('bsTransitionEnd', callbackRemove)
	          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
	        callbackRemove()
	
	    } else if (callback) {
	      callback()
	    }
	  }
	
	  // these following methods are used to handle overflowing modals
	
	  Modal.prototype.handleUpdate = function () {
	    this.adjustDialog()
	  }
	
	  Modal.prototype.adjustDialog = function () {
	    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight
	
	    this.$element.css({
	      paddingLeft:  !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
	      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
	    })
	  }
	
	  Modal.prototype.resetAdjustments = function () {
	    this.$element.css({
	      paddingLeft: '',
	      paddingRight: ''
	    })
	  }
	
	  Modal.prototype.checkScrollbar = function () {
	    var fullWindowWidth = window.innerWidth
	    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
	      var documentElementRect = document.documentElement.getBoundingClientRect()
	      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
	    }
	    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
	    this.scrollbarWidth = this.measureScrollbar()
	  }
	
	  Modal.prototype.setScrollbar = function () {
	    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
	    this.originalBodyPad = document.body.style.paddingRight || ''
	    if (this.bodyIsOverflowing) this.$body.css('padding-right', bodyPad + this.scrollbarWidth)
	  }
	
	  Modal.prototype.resetScrollbar = function () {
	    this.$body.css('padding-right', this.originalBodyPad)
	  }
	
	  Modal.prototype.measureScrollbar = function () { // thx walsh
	    var scrollDiv = document.createElement('div')
	    scrollDiv.className = 'modal-scrollbar-measure'
	    this.$body.append(scrollDiv)
	    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
	    this.$body[0].removeChild(scrollDiv)
	    return scrollbarWidth
	  }
	
	
	  // MODAL PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option, _relatedTarget) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.modal')
	      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
	      if (typeof option == 'string') data[option](_relatedTarget)
	      else if (options.show) data.show(_relatedTarget)
	    })
	  }
	
	  var old = $.fn.modal
	
	  $.fn.modal             = Plugin
	  $.fn.modal.Constructor = Modal
	
	
	  // MODAL NO CONFLICT
	  // =================
	
	  $.fn.modal.noConflict = function () {
	    $.fn.modal = old
	    return this
	  }
	
	
	  // MODAL DATA-API
	  // ==============
	
	  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
	    var $this   = $(this)
	    var href    = $this.attr('href')
	    var $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))) // strip for ie7
	    var option  = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())
	
	    if ($this.is('a')) e.preventDefault()
	
	    $target.one('show.bs.modal', function (showEvent) {
	      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
	      $target.one('hidden.bs.modal', function () {
	        $this.is(':visible') && $this.trigger('focus')
	      })
	    })
	    Plugin.call($target, option, this)
	  })
	
	}(jQuery);


/***/ }),
/* 122 */
/***/ (function(module, exports) {

	/* ========================================================================
	 * Bootstrap: popover.js v3.3.7
	 * http://getbootstrap.com/javascript/#popovers
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // POPOVER PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Popover = function (element, options) {
	    this.init('popover', element, options)
	  }
	
	  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')
	
	  Popover.VERSION  = '3.3.7'
	
	  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
	    placement: 'right',
	    trigger: 'click',
	    content: '',
	    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
	  })
	
	
	  // NOTE: POPOVER EXTENDS tooltip.js
	  // ================================
	
	  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)
	
	  Popover.prototype.constructor = Popover
	
	  Popover.prototype.getDefaults = function () {
	    return Popover.DEFAULTS
	  }
	
	  Popover.prototype.setContent = function () {
	    var $tip    = this.tip()
	    var title   = this.getTitle()
	    var content = this.getContent()
	
	    $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title)
	    $tip.find('.popover-content').children().detach().end()[ // we use append for html objects to maintain js events
	      this.options.html ? (typeof content == 'string' ? 'html' : 'append') : 'text'
	    ](content)
	
	    $tip.removeClass('fade top bottom left right in')
	
	    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
	    // this manually by checking the contents.
	    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
	  }
	
	  Popover.prototype.hasContent = function () {
	    return this.getTitle() || this.getContent()
	  }
	
	  Popover.prototype.getContent = function () {
	    var $e = this.$element
	    var o  = this.options
	
	    return $e.attr('data-content')
	      || (typeof o.content == 'function' ?
	            o.content.call($e[0]) :
	            o.content)
	  }
	
	  Popover.prototype.arrow = function () {
	    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
	  }
	
	
	  // POPOVER PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.popover')
	      var options = typeof option == 'object' && option
	
	      if (!data && /destroy|hide/.test(option)) return
	      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.popover
	
	  $.fn.popover             = Plugin
	  $.fn.popover.Constructor = Popover
	
	
	  // POPOVER NO CONFLICT
	  // ===================
	
	  $.fn.popover.noConflict = function () {
	    $.fn.popover = old
	    return this
	  }
	
	}(jQuery);


/***/ }),
/* 123 */
/***/ (function(module, exports) {

	/* ========================================================================
	 * Bootstrap: scrollspy.js v3.3.7
	 * http://getbootstrap.com/javascript/#scrollspy
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // SCROLLSPY CLASS DEFINITION
	  // ==========================
	
	  function ScrollSpy(element, options) {
	    this.$body          = $(document.body)
	    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element)
	    this.options        = $.extend({}, ScrollSpy.DEFAULTS, options)
	    this.selector       = (this.options.target || '') + ' .nav li > a'
	    this.offsets        = []
	    this.targets        = []
	    this.activeTarget   = null
	    this.scrollHeight   = 0
	
	    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this))
	    this.refresh()
	    this.process()
	  }
	
	  ScrollSpy.VERSION  = '3.3.7'
	
	  ScrollSpy.DEFAULTS = {
	    offset: 10
	  }
	
	  ScrollSpy.prototype.getScrollHeight = function () {
	    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
	  }
	
	  ScrollSpy.prototype.refresh = function () {
	    var that          = this
	    var offsetMethod  = 'offset'
	    var offsetBase    = 0
	
	    this.offsets      = []
	    this.targets      = []
	    this.scrollHeight = this.getScrollHeight()
	
	    if (!$.isWindow(this.$scrollElement[0])) {
	      offsetMethod = 'position'
	      offsetBase   = this.$scrollElement.scrollTop()
	    }
	
	    this.$body
	      .find(this.selector)
	      .map(function () {
	        var $el   = $(this)
	        var href  = $el.data('target') || $el.attr('href')
	        var $href = /^#./.test(href) && $(href)
	
	        return ($href
	          && $href.length
	          && $href.is(':visible')
	          && [[$href[offsetMethod]().top + offsetBase, href]]) || null
	      })
	      .sort(function (a, b) { return a[0] - b[0] })
	      .each(function () {
	        that.offsets.push(this[0])
	        that.targets.push(this[1])
	      })
	  }
	
	  ScrollSpy.prototype.process = function () {
	    var scrollTop    = this.$scrollElement.scrollTop() + this.options.offset
	    var scrollHeight = this.getScrollHeight()
	    var maxScroll    = this.options.offset + scrollHeight - this.$scrollElement.height()
	    var offsets      = this.offsets
	    var targets      = this.targets
	    var activeTarget = this.activeTarget
	    var i
	
	    if (this.scrollHeight != scrollHeight) {
	      this.refresh()
	    }
	
	    if (scrollTop >= maxScroll) {
	      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i)
	    }
	
	    if (activeTarget && scrollTop < offsets[0]) {
	      this.activeTarget = null
	      return this.clear()
	    }
	
	    for (i = offsets.length; i--;) {
	      activeTarget != targets[i]
	        && scrollTop >= offsets[i]
	        && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1])
	        && this.activate(targets[i])
	    }
	  }
	
	  ScrollSpy.prototype.activate = function (target) {
	    this.activeTarget = target
	
	    this.clear()
	
	    var selector = this.selector +
	      '[data-target="' + target + '"],' +
	      this.selector + '[href="' + target + '"]'
	
	    var active = $(selector)
	      .parents('li')
	      .addClass('active')
	
	    if (active.parent('.dropdown-menu').length) {
	      active = active
	        .closest('li.dropdown')
	        .addClass('active')
	    }
	
	    active.trigger('activate.bs.scrollspy')
	  }
	
	  ScrollSpy.prototype.clear = function () {
	    $(this.selector)
	      .parentsUntil(this.options.target, '.active')
	      .removeClass('active')
	  }
	
	
	  // SCROLLSPY PLUGIN DEFINITION
	  // ===========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.scrollspy')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.scrollspy', (data = new ScrollSpy(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.scrollspy
	
	  $.fn.scrollspy             = Plugin
	  $.fn.scrollspy.Constructor = ScrollSpy
	
	
	  // SCROLLSPY NO CONFLICT
	  // =====================
	
	  $.fn.scrollspy.noConflict = function () {
	    $.fn.scrollspy = old
	    return this
	  }
	
	
	  // SCROLLSPY DATA-API
	  // ==================
	
	  $(window).on('load.bs.scrollspy.data-api', function () {
	    $('[data-spy="scroll"]').each(function () {
	      var $spy = $(this)
	      Plugin.call($spy, $spy.data())
	    })
	  })
	
	}(jQuery);


/***/ }),
/* 124 */
/***/ (function(module, exports) {

	/* ========================================================================
	 * Bootstrap: tab.js v3.3.7
	 * http://getbootstrap.com/javascript/#tabs
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // TAB CLASS DEFINITION
	  // ====================
	
	  var Tab = function (element) {
	    // jscs:disable requireDollarBeforejQueryAssignment
	    this.element = $(element)
	    // jscs:enable requireDollarBeforejQueryAssignment
	  }
	
	  Tab.VERSION = '3.3.7'
	
	  Tab.TRANSITION_DURATION = 150
	
	  Tab.prototype.show = function () {
	    var $this    = this.element
	    var $ul      = $this.closest('ul:not(.dropdown-menu)')
	    var selector = $this.data('target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    if ($this.parent('li').hasClass('active')) return
	
	    var $previous = $ul.find('.active:last a')
	    var hideEvent = $.Event('hide.bs.tab', {
	      relatedTarget: $this[0]
	    })
	    var showEvent = $.Event('show.bs.tab', {
	      relatedTarget: $previous[0]
	    })
	
	    $previous.trigger(hideEvent)
	    $this.trigger(showEvent)
	
	    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return
	
	    var $target = $(selector)
	
	    this.activate($this.closest('li'), $ul)
	    this.activate($target, $target.parent(), function () {
	      $previous.trigger({
	        type: 'hidden.bs.tab',
	        relatedTarget: $this[0]
	      })
	      $this.trigger({
	        type: 'shown.bs.tab',
	        relatedTarget: $previous[0]
	      })
	    })
	  }
	
	  Tab.prototype.activate = function (element, container, callback) {
	    var $active    = container.find('> .active')
	    var transition = callback
	      && $.support.transition
	      && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length)
	
	    function next() {
	      $active
	        .removeClass('active')
	        .find('> .dropdown-menu > .active')
	          .removeClass('active')
	        .end()
	        .find('[data-toggle="tab"]')
	          .attr('aria-expanded', false)
	
	      element
	        .addClass('active')
	        .find('[data-toggle="tab"]')
	          .attr('aria-expanded', true)
	
	      if (transition) {
	        element[0].offsetWidth // reflow for transition
	        element.addClass('in')
	      } else {
	        element.removeClass('fade')
	      }
	
	      if (element.parent('.dropdown-menu').length) {
	        element
	          .closest('li.dropdown')
	            .addClass('active')
	          .end()
	          .find('[data-toggle="tab"]')
	            .attr('aria-expanded', true)
	      }
	
	      callback && callback()
	    }
	
	    $active.length && transition ?
	      $active
	        .one('bsTransitionEnd', next)
	        .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
	      next()
	
	    $active.removeClass('in')
	  }
	
	
	  // TAB PLUGIN DEFINITION
	  // =====================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.tab')
	
	      if (!data) $this.data('bs.tab', (data = new Tab(this)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.tab
	
	  $.fn.tab             = Plugin
	  $.fn.tab.Constructor = Tab
	
	
	  // TAB NO CONFLICT
	  // ===============
	
	  $.fn.tab.noConflict = function () {
	    $.fn.tab = old
	    return this
	  }
	
	
	  // TAB DATA-API
	  // ============
	
	  var clickHandler = function (e) {
	    e.preventDefault()
	    Plugin.call($(this), 'show')
	  }
	
	  $(document)
	    .on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
	    .on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler)
	
	}(jQuery);


/***/ }),
/* 125 */
/***/ (function(module, exports) {

	/* ========================================================================
	 * Bootstrap: tooltip.js v3.3.7
	 * http://getbootstrap.com/javascript/#tooltip
	 * Inspired by the original jQuery.tipsy by Jason Frame
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // TOOLTIP PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Tooltip = function (element, options) {
	    this.type       = null
	    this.options    = null
	    this.enabled    = null
	    this.timeout    = null
	    this.hoverState = null
	    this.$element   = null
	    this.inState    = null
	
	    this.init('tooltip', element, options)
	  }
	
	  Tooltip.VERSION  = '3.3.7'
	
	  Tooltip.TRANSITION_DURATION = 150
	
	  Tooltip.DEFAULTS = {
	    animation: true,
	    placement: 'top',
	    selector: false,
	    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
	    trigger: 'hover focus',
	    title: '',
	    delay: 0,
	    html: false,
	    container: false,
	    viewport: {
	      selector: 'body',
	      padding: 0
	    }
	  }
	
	  Tooltip.prototype.init = function (type, element, options) {
	    this.enabled   = true
	    this.type      = type
	    this.$element  = $(element)
	    this.options   = this.getOptions(options)
	    this.$viewport = this.options.viewport && $($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))
	    this.inState   = { click: false, hover: false, focus: false }
	
	    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
	      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
	    }
	
	    var triggers = this.options.trigger.split(' ')
	
	    for (var i = triggers.length; i--;) {
	      var trigger = triggers[i]
	
	      if (trigger == 'click') {
	        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
	      } else if (trigger != 'manual') {
	        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
	        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'
	
	        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
	        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
	      }
	    }
	
	    this.options.selector ?
	      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
	      this.fixTitle()
	  }
	
	  Tooltip.prototype.getDefaults = function () {
	    return Tooltip.DEFAULTS
	  }
	
	  Tooltip.prototype.getOptions = function (options) {
	    options = $.extend({}, this.getDefaults(), this.$element.data(), options)
	
	    if (options.delay && typeof options.delay == 'number') {
	      options.delay = {
	        show: options.delay,
	        hide: options.delay
	      }
	    }
	
	    return options
	  }
	
	  Tooltip.prototype.getDelegateOptions = function () {
	    var options  = {}
	    var defaults = this.getDefaults()
	
	    this._options && $.each(this._options, function (key, value) {
	      if (defaults[key] != value) options[key] = value
	    })
	
	    return options
	  }
	
	  Tooltip.prototype.enter = function (obj) {
	    var self = obj instanceof this.constructor ?
	      obj : $(obj.currentTarget).data('bs.' + this.type)
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
	      $(obj.currentTarget).data('bs.' + this.type, self)
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
	    }
	
	    if (self.tip().hasClass('in') || self.hoverState == 'in') {
	      self.hoverState = 'in'
	      return
	    }
	
	    clearTimeout(self.timeout)
	
	    self.hoverState = 'in'
	
	    if (!self.options.delay || !self.options.delay.show) return self.show()
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'in') self.show()
	    }, self.options.delay.show)
	  }
	
	  Tooltip.prototype.isInStateTrue = function () {
	    for (var key in this.inState) {
	      if (this.inState[key]) return true
	    }
	
	    return false
	  }
	
	  Tooltip.prototype.leave = function (obj) {
	    var self = obj instanceof this.constructor ?
	      obj : $(obj.currentTarget).data('bs.' + this.type)
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
	      $(obj.currentTarget).data('bs.' + this.type, self)
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false
	    }
	
	    if (self.isInStateTrue()) return
	
	    clearTimeout(self.timeout)
	
	    self.hoverState = 'out'
	
	    if (!self.options.delay || !self.options.delay.hide) return self.hide()
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'out') self.hide()
	    }, self.options.delay.hide)
	  }
	
	  Tooltip.prototype.show = function () {
	    var e = $.Event('show.bs.' + this.type)
	
	    if (this.hasContent() && this.enabled) {
	      this.$element.trigger(e)
	
	      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
	      if (e.isDefaultPrevented() || !inDom) return
	      var that = this
	
	      var $tip = this.tip()
	
	      var tipId = this.getUID(this.type)
	
	      this.setContent()
	      $tip.attr('id', tipId)
	      this.$element.attr('aria-describedby', tipId)
	
	      if (this.options.animation) $tip.addClass('fade')
	
	      var placement = typeof this.options.placement == 'function' ?
	        this.options.placement.call(this, $tip[0], this.$element[0]) :
	        this.options.placement
	
	      var autoToken = /\s?auto?\s?/i
	      var autoPlace = autoToken.test(placement)
	      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'
	
	      $tip
	        .detach()
	        .css({ top: 0, left: 0, display: 'block' })
	        .addClass(placement)
	        .data('bs.' + this.type, this)
	
	      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element)
	      this.$element.trigger('inserted.bs.' + this.type)
	
	      var pos          = this.getPosition()
	      var actualWidth  = $tip[0].offsetWidth
	      var actualHeight = $tip[0].offsetHeight
	
	      if (autoPlace) {
	        var orgPlacement = placement
	        var viewportDim = this.getPosition(this.$viewport)
	
	        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :
	                    placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :
	                    placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :
	                    placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :
	                    placement
	
	        $tip
	          .removeClass(orgPlacement)
	          .addClass(placement)
	      }
	
	      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)
	
	      this.applyPlacement(calculatedOffset, placement)
	
	      var complete = function () {
	        var prevHoverState = that.hoverState
	        that.$element.trigger('shown.bs.' + that.type)
	        that.hoverState = null
	
	        if (prevHoverState == 'out') that.leave(that)
	      }
	
	      $.support.transition && this.$tip.hasClass('fade') ?
	        $tip
	          .one('bsTransitionEnd', complete)
	          .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
	        complete()
	    }
	  }
	
	  Tooltip.prototype.applyPlacement = function (offset, placement) {
	    var $tip   = this.tip()
	    var width  = $tip[0].offsetWidth
	    var height = $tip[0].offsetHeight
	
	    // manually read margins because getBoundingClientRect includes difference
	    var marginTop = parseInt($tip.css('margin-top'), 10)
	    var marginLeft = parseInt($tip.css('margin-left'), 10)
	
	    // we must check for NaN for ie 8/9
	    if (isNaN(marginTop))  marginTop  = 0
	    if (isNaN(marginLeft)) marginLeft = 0
	
	    offset.top  += marginTop
	    offset.left += marginLeft
	
	    // $.fn.offset doesn't round pixel values
	    // so we use setOffset directly with our own function B-0
	    $.offset.setOffset($tip[0], $.extend({
	      using: function (props) {
	        $tip.css({
	          top: Math.round(props.top),
	          left: Math.round(props.left)
	        })
	      }
	    }, offset), 0)
	
	    $tip.addClass('in')
	
	    // check to see if placing tip in new offset caused the tip to resize itself
	    var actualWidth  = $tip[0].offsetWidth
	    var actualHeight = $tip[0].offsetHeight
	
	    if (placement == 'top' && actualHeight != height) {
	      offset.top = offset.top + height - actualHeight
	    }
	
	    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)
	
	    if (delta.left) offset.left += delta.left
	    else offset.top += delta.top
	
	    var isVertical          = /top|bottom/.test(placement)
	    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
	    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'
	
	    $tip.offset(offset)
	    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
	  }
	
	  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
	    this.arrow()
	      .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
	      .css(isVertical ? 'top' : 'left', '')
	  }
	
	  Tooltip.prototype.setContent = function () {
	    var $tip  = this.tip()
	    var title = this.getTitle()
	
	    $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title)
	    $tip.removeClass('fade in top bottom left right')
	  }
	
	  Tooltip.prototype.hide = function (callback) {
	    var that = this
	    var $tip = $(this.$tip)
	    var e    = $.Event('hide.bs.' + this.type)
	
	    function complete() {
	      if (that.hoverState != 'in') $tip.detach()
	      if (that.$element) { // TODO: Check whether guarding this code with this `if` is really necessary.
	        that.$element
	          .removeAttr('aria-describedby')
	          .trigger('hidden.bs.' + that.type)
	      }
	      callback && callback()
	    }
	
	    this.$element.trigger(e)
	
	    if (e.isDefaultPrevented()) return
	
	    $tip.removeClass('in')
	
	    $.support.transition && $tip.hasClass('fade') ?
	      $tip
	        .one('bsTransitionEnd', complete)
	        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
	      complete()
	
	    this.hoverState = null
	
	    return this
	  }
	
	  Tooltip.prototype.fixTitle = function () {
	    var $e = this.$element
	    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
	      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
	    }
	  }
	
	  Tooltip.prototype.hasContent = function () {
	    return this.getTitle()
	  }
	
	  Tooltip.prototype.getPosition = function ($element) {
	    $element   = $element || this.$element
	
	    var el     = $element[0]
	    var isBody = el.tagName == 'BODY'
	
	    var elRect    = el.getBoundingClientRect()
	    if (elRect.width == null) {
	      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
	      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
	    }
	    var isSvg = window.SVGElement && el instanceof window.SVGElement
	    // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
	    // See https://github.com/twbs/bootstrap/issues/20280
	    var elOffset  = isBody ? { top: 0, left: 0 } : (isSvg ? null : $element.offset())
	    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
	    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null
	
	    return $.extend({}, elRect, scroll, outerDims, elOffset)
	  }
	
	  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
	    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
	           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
	           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
	        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }
	
	  }
	
	  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
	    var delta = { top: 0, left: 0 }
	    if (!this.$viewport) return delta
	
	    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
	    var viewportDimensions = this.getPosition(this.$viewport)
	
	    if (/right|left/.test(placement)) {
	      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
	      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
	      if (topEdgeOffset < viewportDimensions.top) { // top overflow
	        delta.top = viewportDimensions.top - topEdgeOffset
	      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
	        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
	      }
	    } else {
	      var leftEdgeOffset  = pos.left - viewportPadding
	      var rightEdgeOffset = pos.left + viewportPadding + actualWidth
	      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
	        delta.left = viewportDimensions.left - leftEdgeOffset
	      } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
	        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
	      }
	    }
	
	    return delta
	  }
	
	  Tooltip.prototype.getTitle = function () {
	    var title
	    var $e = this.$element
	    var o  = this.options
	
	    title = $e.attr('data-original-title')
	      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)
	
	    return title
	  }
	
	  Tooltip.prototype.getUID = function (prefix) {
	    do prefix += ~~(Math.random() * 1000000)
	    while (document.getElementById(prefix))
	    return prefix
	  }
	
	  Tooltip.prototype.tip = function () {
	    if (!this.$tip) {
	      this.$tip = $(this.options.template)
	      if (this.$tip.length != 1) {
	        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')
	      }
	    }
	    return this.$tip
	  }
	
	  Tooltip.prototype.arrow = function () {
	    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
	  }
	
	  Tooltip.prototype.enable = function () {
	    this.enabled = true
	  }
	
	  Tooltip.prototype.disable = function () {
	    this.enabled = false
	  }
	
	  Tooltip.prototype.toggleEnabled = function () {
	    this.enabled = !this.enabled
	  }
	
	  Tooltip.prototype.toggle = function (e) {
	    var self = this
	    if (e) {
	      self = $(e.currentTarget).data('bs.' + this.type)
	      if (!self) {
	        self = new this.constructor(e.currentTarget, this.getDelegateOptions())
	        $(e.currentTarget).data('bs.' + this.type, self)
	      }
	    }
	
	    if (e) {
	      self.inState.click = !self.inState.click
	      if (self.isInStateTrue()) self.enter(self)
	      else self.leave(self)
	    } else {
	      self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
	    }
	  }
	
	  Tooltip.prototype.destroy = function () {
	    var that = this
	    clearTimeout(this.timeout)
	    this.hide(function () {
	      that.$element.off('.' + that.type).removeData('bs.' + that.type)
	      if (that.$tip) {
	        that.$tip.detach()
	      }
	      that.$tip = null
	      that.$arrow = null
	      that.$viewport = null
	      that.$element = null
	    })
	  }
	
	
	  // TOOLTIP PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.tooltip')
	      var options = typeof option == 'object' && option
	
	      if (!data && /destroy|hide/.test(option)) return
	      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.tooltip
	
	  $.fn.tooltip             = Plugin
	  $.fn.tooltip.Constructor = Tooltip
	
	
	  // TOOLTIP NO CONFLICT
	  // ===================
	
	  $.fn.tooltip.noConflict = function () {
	    $.fn.tooltip = old
	    return this
	  }
	
	}(jQuery);


/***/ }),
/* 126 */
/***/ (function(module, exports) {

	/* ========================================================================
	 * Bootstrap: transition.js v3.3.7
	 * http://getbootstrap.com/javascript/#transitions
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
	  // ============================================================
	
	  function transitionEnd() {
	    var el = document.createElement('bootstrap')
	
	    var transEndEventNames = {
	      WebkitTransition : 'webkitTransitionEnd',
	      MozTransition    : 'transitionend',
	      OTransition      : 'oTransitionEnd otransitionend',
	      transition       : 'transitionend'
	    }
	
	    for (var name in transEndEventNames) {
	      if (el.style[name] !== undefined) {
	        return { end: transEndEventNames[name] }
	      }
	    }
	
	    return false // explicit for ie8 (  ._.)
	  }
	
	  // http://blog.alexmaccaw.com/css-transitions
	  $.fn.emulateTransitionEnd = function (duration) {
	    var called = false
	    var $el = this
	    $(this).one('bsTransitionEnd', function () { called = true })
	    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
	    setTimeout(callback, duration)
	    return this
	  }
	
	  $(function () {
	    $.support.transition = transitionEnd()
	
	    if (!$.support.transition) return
	
	    $.event.special.bsTransitionEnd = {
	      bindType: $.support.transition.end,
	      delegateType: $.support.transition.end,
	      handle: function (e) {
	        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
	      }
	    }
	  })
	
	}(jQuery);


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(139);
	var $Object = __webpack_require__(17).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(140);
	__webpack_require__(111);
	__webpack_require__(141);
	__webpack_require__(142);
	module.exports = __webpack_require__(17).Symbol;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(101);
	__webpack_require__(108);
	module.exports = __webpack_require__(56).f('iterator');


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(33);
	var gOPS = __webpack_require__(73);
	var pIE = __webpack_require__(44);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(54);
	var descriptor = __webpack_require__(36);
	var setToStringTag = __webpack_require__(53);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(15)(IteratorPrototype, __webpack_require__(7)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 132 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(27)('meta');
	var isObject = __webpack_require__(26);
	var has = __webpack_require__(10);
	var setDesc = __webpack_require__(20).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(32)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(20);
	var anObject = __webpack_require__(31);
	var getKeys = __webpack_require__(33);
	
	module.exports = __webpack_require__(18) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(21);
	var gOPN = __webpack_require__(77).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(10);
	var toObject = __webpack_require__(97);
	var IE_PROTO = __webpack_require__(50)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(47);
	var defined = __webpack_require__(45);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(102);
	var step = __webpack_require__(132);
	var Iterators = __webpack_require__(49);
	var toIObject = __webpack_require__(21);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(76)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(39);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(54) });


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(6);
	var has = __webpack_require__(10);
	var DESCRIPTORS = __webpack_require__(18);
	var $export = __webpack_require__(39);
	var redefine = __webpack_require__(28);
	var META = __webpack_require__(133).KEY;
	var $fails = __webpack_require__(32);
	var shared = __webpack_require__(46);
	var setToStringTag = __webpack_require__(53);
	var uid = __webpack_require__(27);
	var wks = __webpack_require__(7);
	var wksExt = __webpack_require__(56);
	var wksDefine = __webpack_require__(55);
	var enumKeys = __webpack_require__(130);
	var isArray = __webpack_require__(106);
	var anObject = __webpack_require__(31);
	var isObject = __webpack_require__(26);
	var toIObject = __webpack_require__(21);
	var toPrimitive = __webpack_require__(51);
	var createDesc = __webpack_require__(36);
	var _create = __webpack_require__(54);
	var gOPNExt = __webpack_require__(135);
	var $GOPD = __webpack_require__(110);
	var $DP = __webpack_require__(20);
	var $keys = __webpack_require__(33);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(77).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(44).f = $propertyIsEnumerable;
	  __webpack_require__(73).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(52)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(15)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(55)('asyncIterator');


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(55)('observable');


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery Cookie Plugin v1.4.1
	 * https://github.com/carhartl/jquery-cookie
	 *
	 * Copyright 2013 Klaus Hartl
	 * Released under the MIT license
	 */
	(function (factory) {
		if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof exports === 'object') {
			// CommonJS
			factory(require('jquery'));
		} else {
			// Browser globals
			factory(jQuery);
		}
	}(function ($) {
	
		var pluses = /\+/g;
	
		function encode(s) {
			return config.raw ? s : encodeURIComponent(s);
		}
	
		function decode(s) {
			return config.raw ? s : decodeURIComponent(s);
		}
	
		function stringifyCookieValue(value) {
			return encode(config.json ? JSON.stringify(value) : String(value));
		}
	
		function parseCookieValue(s) {
			if (s.indexOf('"') === 0) {
				// This is a quoted cookie as according to RFC2068, unescape...
				s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
			}
	
			try {
				// Replace server-side written pluses with spaces.
				// If we can't decode the cookie, ignore it, it's unusable.
				// If we can't parse the cookie, ignore it, it's unusable.
				s = decodeURIComponent(s.replace(pluses, ' '));
				return config.json ? JSON.parse(s) : s;
			} catch(e) {}
		}
	
		function read(s, converter) {
			var value = config.raw ? s : parseCookieValue(s);
			return $.isFunction(converter) ? converter(value) : value;
		}
	
		var config = $.cookie = function (key, value, options) {
	
			// Write
	
			if (value !== undefined && !$.isFunction(value)) {
				options = $.extend({}, config.defaults, options);
	
				if (typeof options.expires === 'number') {
					var days = options.expires, t = options.expires = new Date();
					t.setTime(+t + days * 864e+5);
				}
	
				return (document.cookie = [
					encode(key), '=', stringifyCookieValue(value),
					options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
					options.path    ? '; path=' + options.path : '',
					options.domain  ? '; domain=' + options.domain : '',
					options.secure  ? '; secure' : ''
				].join(''));
			}
	
			// Read
	
			var result = key ? undefined : {};
	
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all. Also prevents odd result when
			// calling $.cookie().
			var cookies = document.cookie ? document.cookie.split('; ') : [];
	
			for (var i = 0, l = cookies.length; i < l; i++) {
				var parts = cookies[i].split('=');
				var name = decode(parts.shift());
				var cookie = parts.join('=');
	
				if (key && key === name) {
					// If second argument (value) is a function it's a converter...
					result = read(cookie, value);
					break;
				}
	
				// Prevent storing a cookie that we couldn't decode.
				if (!key && (cookie = read(cookie)) !== undefined) {
					result[name] = cookie;
				}
			}
	
			return result;
		};
	
		config.defaults = {};
	
		$.removeCookie = function (key, options) {
			if ($.cookie(key) === undefined) {
				return false;
			}
	
			// Must not alter options, thus extending a fresh object...
			$.cookie(key, '', $.extend({}, options, { expires: -1 }));
			return !$.cookie(key);
		};
	
	}));


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($) {
	  var isMobile = $('body').data('is-mobile');
	
	  if (isMobile) {
	    var mobileMenuCheckboxes = $('[data-fcse-role="navMobileMenuCheckbox"]');
	    mobileMenuCheckboxes.on('change', function (event) {
	      if ($(event.target).prop('checked')) {
	        mobileMenuCheckboxes.each(function (index, element) {
	          if (element !== event.target) {
	            $(element).prop('checked', null);
	          }
	        });
	      }
	    });
	    var featuresContainer = $('[data-fcse-role="mobile-features-container"]');
	    var featuresMenu = $('[data-fcse-role="mobile-features-menu"]');
	    var searchMaskFeature = $('[data-feature-type="feature-searchmask"]', featuresContainer);
	    featuresContainer.on('click', '[data-fcse-mobile-role="searchmask-mobile-ok-button"]', function () {
	      searchMaskFeature.addClass('is-hidden');
	    });
	    $('[data-feature-type]', featuresMenu).on('click', function (event) {
	      var featureType = $(event.target).data('feature-type');
	      if (featureType === 'scroll-to') {
	        searchMaskFeature.addClass('is-hidden');
	        $('html, body').animate({
	          scrollTop: $($(event.target).data('scroll-target')).offset().top
	        }, 'slow');
	      } else {
	        var selector = '[data-feature-type="' + $(event.target).data('feature-type') + '"]';
	        $('[data-feature-type]', featuresContainer).filter(':not(' + selector + ')').addClass('is-hidden');
	        $(selector, featuresContainer).toggleClass('is-hidden');
	      }
	    });
	  }
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	}();

	;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    var deviceInfo = {
	        isTouching: false,
	        pointerDown: false
	    };
	
	    window.addEventListener('touchstart', function onFirstTouch() {
	        deviceInfo.isTouching = true;
	        window.removeEventListener('touchstart', onFirstTouch, false);
	    }, false);
	
	    return deviceInfo;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Created by ivo on 01.08.14.
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(3), __webpack_require__(2), __webpack_require__(9), __webpack_require__(11)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, _, Object, OptionsMixin, EventDispatcher) {
	
	    var FavoritesHandler = function FavoritesHandler(requestHandler, options) {
	        EventDispatcher.apply(this, arguments);
	
	        // Set default options
	        var defaultOptions = {
	            buttonActiveClass: 'is-active',
	            addRoute: 'allt_frontend.favorites.add',
	            removeRoute: 'allt_frontend.favorites.remove',
	            countRoute: 'allt_frontend.favorites.count',
	            favoriteAddButtonSelector: '[data-fcse-role="favorites--add"]',
	            favoriteCountSelector: '[data-fcse-role="favorites--count"]',
	            favoriteRemoveButtonSelector: '[data-fcse-role="favorites--remove"]',
	            favoriteIdAttribute: 'data-favorites-id'
	        };
	
	        // Save local variables
	        this.requestHandler = requestHandler;
	
	        this.addOptions(defaultOptions, options);
	
	        // Register events
	        this.registerEvent("remove");
	        this.registerEvent("add");
	
	        this._init();
	        this._initLoadingEvents();
	        this._updateCount();
	    };
	
	    FavoritesHandler.prototype = $.extend(Object.create(EventDispatcher.prototype), Object.create(OptionsMixin), {
	        /**
	         * Initialize
	         *
	         * @private
	         */
	        _init: function _init() {
	            $('body').on('click', this.option('favoriteAddButtonSelector'), $.proxy(this._onFavoriteAddButtonClick, this));
	            $('body').on('click', this.option('favoriteRemoveButtonSelector'), $.proxy(this._onFavoriteRemoveButtonClick, this));
	        },
	
	        /**
	         * update count
	         */
	        _updateCount: function _updateCount() {
	            this.requestHandler.send(this.option('countRoute'), {}, {}, { method: 'POST' });
	        },
	
	        /**
	         * Initialize Loading Events
	         *
	         * @private
	         */
	        _initLoadingEvents: function _initLoadingEvents() {
	            // Requesthandler loading events
	            this.requestHandler.on('success', $.proxy(this._onLoadSuccess, this));
	            this.requestHandler.on('error', $.proxy(this._onLoadError, this));
	        },
	
	        /**
	         * Click handler for adding favorite items
	         * @param jQuery.Event event
	         * @private
	         */
	        _onFavoriteAddButtonClick: function _onFavoriteAddButtonClick(event) {
	            var elem = $(event.currentTarget);
	
	            // Check if is already active
	            if (elem.hasClass(this.option('buttonActiveClass'))) {
	                return;
	            }
	
	            // Send ajax request
	            this.requestHandler.send(this.option('addRoute'), {
	                item: elem.attr('data-fcse-favorites'),
	                timestamp: elem.attr('data-fcse-favorites-timestamp'),
	                key: elem.attr('data-fcse-favorites-key')
	            }, {}, { method: 'POST' });
	
	            // Update active class
	            elem.addClass(this.option('buttonActiveClass'));
	            elem.attr('data-fcse-role', 'favorites--remove');
	
	            // Update label
	            elem.find('[data-favorites-label-selected]').each(function (idx, labelElem) {
	                $(labelElem).text($(labelElem).attr('data-favorites-label-selected'));
	            });
	        },
	
	        /**
	         * Click handler for removing favorite items
	         * @param jQuery.Event event
	         * @private
	         */
	        _onFavoriteRemoveButtonClick: function _onFavoriteRemoveButtonClick(event) {
	            var elem = $(event.currentTarget);
	            this.requestHandler.send(this.option('removeRoute'), {
	                item: elem.attr('data-fcse-favorites'),
	                timestamp: elem.attr('data-fcse-favorites-timestamp'),
	                key: elem.attr('data-fcse-favorites-key')
	            }, {}, { method: 'POST' });
	
	            // Remove item
	            elem.closest('[data-fcse-role="favorites-item"]').fadeOut(300, function () {
	                $(this).remove();
	            });
	            elem.removeClass(this.option('buttonActiveClass'));
	            elem.attr('data-fcse-role', 'favorites--add');
	
	            // Decrease counter
	            var count = $(this.option('favoriteCountSelector'));
	            var itemCount = Math.max(parseInt(count.first().text()) - 1, 0);
	            count.text(itemCount);
	
	            // Update label
	            elem.find('[data-favorites-label-unselected]').each(function (idx, labelElem) {
	                $(labelElem).text($(labelElem).attr('data-favorites-label-unselected'));
	            });
	
	            this.dispatchEvent('remove', itemCount);
	            return;
	        },
	
	        /**
	         * Loads the content of the offerlist
	         *
	         * @private
	         */
	        _loadContent: function _loadContent(routeName, additionalParams, additionalRouteParams) {
	            // Merge Parameters
	            var params = $.extend(this.scope.getQuery(), additionalParams || {});
	
	            // Send request
	            this.requestHandler.cancel(this.option(routeName));
	            this.requestHandler.send(this.option(routeName), params, routeparams);
	        },
	
	        /**
	         * Handler for loading success
	         *
	         * @param event
	         * @param data
	         * @private
	         */
	        _onLoadSuccess: function _onLoadSuccess(event, data) {
	            var count = $(this.option('favoriteCountSelector'));
	            if (data.route === this.option('countRoute')) {
	                count.text(event.meta.count);
	            }
	            // Success handling for adding item
	            if (data.route === this.option('addRoute')) {
	                var itemCount = parseInt(count.first().text()) + 1;
	                count.text(itemCount);
	                this.dispatchEvent('add', itemCount);
	                return;
	            }
	
	            // Success handling for removing item
	            if (data.route !== this.option('removeRoute')) {
	                return;
	            }
	        },
	
	        /**
	         * Handler for content loading error
	         *
	         * @param event
	         * @private
	         */
	        _onLoadError: function _onLoadError(event) {}
	    });
	
	    return FavoritesHandler;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(2), __webpack_require__(25)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Object, GtmBase) {
	
	    function GtmCommonPage(options) {
	        GtmBase.apply(this, arguments);
	    }
	
	    GtmCommonPage.prototype = $.extend(Object.create(GtmBase.prototype), /** @lends GtmCommonPage.prototype */{
	        trackPage: function trackPage() {
	            var self = this;
	            try {
	                if (window.dataLayer) {
	                    var result = $.grep(window.dataLayer, function (e) {
	                        return typeof e.pageType !== 'undefined' && e.pageType;
	                    });
	                    if (!result.length) {
	                        var data = {
	                            canonicalUrl: window.location.href
	                        };
	                        var pageType = this.option('pageType');
	                        if (pageType) {
	                            data.pageType = pageType;
	                        }
	                        self.trackData(data);
	                    }
	                }
	            } catch (e) {}
	        }
	    });
	
	    return GtmCommonPage;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(2), __webpack_require__(25)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Object, GtmBase) {
	
	    function GtmEventTracker(options) {
	        GtmBase.apply(this, arguments);
	
	        $('body').on('click', '[data-gtm-event="analyticsEvent"]', $.proxy(this._trackElementClick, this));
	        $('body').on('gtm.analyticsEvent', $.proxy(function (e, originEvent) {
	            this._trackElementClick(originEvent);
	        }, this));
	    }
	
	    GtmEventTracker.prototype = $.extend(Object.create(GtmBase.prototype), /** @lends GtmEventTracker.prototype */{
	        trackPage: function trackPage() {},
	        _trackElementClick: function _trackElementClick(event) {
	            if (!event) {
	                return;
	            }
	
	            var source = false;
	            if (typeof event.source !== 'undefined') {
	                source = event.source;
	            }
	
	            if (typeof event.event !== 'undefined') {
	                event = event.event;
	            }
	
	            var $elem = $(event.currentTarget);
	            if ($elem.data('toggle') === "navbar-menu" && !source) {
	                event.preventDefault();
	                return;
	            }
	
	            if (!$elem.data('gtm-event')) {
	                return;
	            }
	
	            var targetUrl = $elem.attr('href');
	            var redirectFunction = function redirectFunction() {};
	
	            if (targetUrl && !/^#.*/i.test(targetUrl)) {
	                event.preventDefault();
	                redirectFunction = function redirectFunction() {
	                    document.location = targetUrl;
	                };
	            }
	
	            window.setTimeout(redirectFunction, 2000);
	
	            var action = $elem.data('gtm-action');
	            try {
	                var product = JSON.parse(atob(action));
	                if (product && typeof product.id !== 'undefined') {
	                    action = product;
	                }
	            } catch (e) {}
	
	            var analyticsEvent = {
	                event: 'analyticsEvent',
	                eventCategory: $elem.data('gtm-category'),
	                eventAction: action,
	                eventCallback: redirectFunction
	            };
	
	            if ($elem.data('gtm-label')) {
	                analyticsEvent.eventLabel = $elem.data('gtm-label');
	            }
	            this.trackEvent(analyticsEvent);
	        },
	        _scopeParamChanged: function _scopeParamChanged(event) {
	            var self = this;
	            if (event.changedParams) {
	                $.each(event.changedParams, function (i, paramName) {
	                    var label = '';
	                    var param = event.scope.getParam(paramName);
	
	                    if (typeof param === 'string' || typeof param === 'number' || typeof param === 'boolean') {
	                        label = param;
	                    } else if (Array.isArray(param)) {
	                        label = param.sort().join(';');
	                    }
	
	                    self.trackEvent({
	                        'event': 'analyticsEvent',
	                        'eventCategory': 'Filter',
	                        'eventAction': paramName,
	                        'eventLabel': label
	                    });
	                });
	            }
	        }
	    });
	
	    return GtmEventTracker;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(2), __webpack_require__(25), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Object, GtmBase, moment) {
	
	    function GtmFlightProductPage(options) {
	        GtmBase.apply(this, arguments);
	        $('[data-fcse-role="offerlist"] [data-fcse-role="check-offer-button"]').on('click', $.proxy(this._onClickCheckOfferButton, this));
	    }
	
	    GtmFlightProductPage.prototype = $.extend(Object.create(GtmBase.prototype), /** @lends GtmFlightProductPage.prototype */{
	        trackPage: function trackPage() {
	            var data = {};
	            var $offer = $('[data-fcse-role="offer-item"] [data-fcse-role="favorites--add"]').first();
	
	            if (!$offer.length) {
	                return;
	            }
	
	            try {
	                var offerData = JSON.parse($offer.data('fcse-favorites').data);
	                var $hotelDetails = $('[data-fcse-role="hotel-details"]');
	
	                if ($hotelDetails.length) {
	                    offerData = $.extend(offerData, $hotelDetails.data(), $hotelDetails.data('fcse-booking-data'));
	                }
	
	                data = this.getProductData(offerData);
	            } catch (e) {
	                console.log(e);
	            }
	
	            return this.trackData(data);
	        },
	        getProductData: function getProductData(offerData) {
	            try {
	                var travelDates = {
	                    from: moment(offerData.airport.offers["0"].departureFlight.departureDateTime).format('YYYY.MM.DD'),
	                    to: moment(offerData.airport.offers["0"].returnFlight.arrivalDateTime).format('YYYY.MM.DD')
	                };
	
	                var data = {
	                    canonicalUrl: window.location.href,
	                    product: {
	                        name: offerData.airport.offers["0"].departureFlight.departureAirport.code + '-' + offerData.airport.offers["0"].departureFlight.arrivalAirport.code,
	                        id: offerData.airport.offers["0"].departureFlight.flightNumber,
	                        brand: offerData.airport.offers["0"].tourOperator.code,
	                        variant: travelDates.from + '/' + travelDates.to,
	                        price: offerData.airport.offers["0"].price.amount,
	                        category: 'flight/' + offerData.airport.location.country.code + '/' + offerData.airport.airportIdentifier.name,
	                        list: offerData.airport.airportIdentifier.name, // i.e. 'Hurghada'
	                        adults: offerData.productSearch.travellers.adults.length,
	                        durationOfStay: moment(offerData.airport.offers["0"].returnFlight.arrivalDateTime).diff(moment(offerData.airport.offers["0"].departureFlight.departureDateTime), 'days'),
	                        travelDates: travelDates.from + '/' + travelDates.to
	                    }
	                };
	
	                if (typeof offerData.productSearch.travellers.children !== "undefined") {
	                    data.product.children = offerData.productSearch.travellers.children.length;
	                }
	            } catch (e) {
	                console.log(e);
	            }
	
	            return data;
	        },
	        _onClickCheckOfferButton: function _onClickCheckOfferButton(e) {
	            var $elem = $(e.target);
	
	            if ($elem.hasClass('success')) {
	                var $offer = $elem.parents('[data-fcse-role="offer-item"]');
	                var offerData = JSON.parse($offer.find('[data-fcse-favorites]').data('fcse-favorites').data);
	
	                dataLayer.push({
	                    'event': 'shoppingCartAction',
	                    'cartAction': 'add',
	                    product: this.getProductData(offerData).product
	                });
	            }
	        }
	    });
	
	    return GtmFlightProductPage;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(2), __webpack_require__(25)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Object, GtmBase) {
	
	    function GtmHomePage(options) {
	        GtmBase.apply(this, arguments);
	        $('body').on('click', '[data-gtm-product]', $.proxy(this._onTeaserClick, this));
	    }
	
	    GtmHomePage.prototype = $.extend(Object.create(GtmBase.prototype), /** @lends GtmHomePage.prototype */{
	        _onTeaserClick: function _onTeaserClick(event) {
	            try {
	                var $teaser = $(event.target).closest('[data-gtm-product]');
	                var targetUrl = $teaser.find('a').first().attr('href');
	                var redirectFunction = function redirectFunction() {};
	
	                if (targetUrl && !/^#.*/i.test(targetUrl)) {
	                    event.preventDefault();
	                    redirectFunction = function redirectFunction() {
	                        document.location = targetUrl;
	                    };
	                }
	
	                window.setTimeout(redirectFunction, 2000);
	                var promotionEvent = {
	                    'event': 'promotionClick',
	                    'promotion': {
	                        id: $teaser.data('cms-module-id'),
	                        name: $teaser.data('gtm-teaser-title'),
	                        creative: $teaser.data('gtm-teaser-title')
	                    },
	                    eventCallback: redirectFunction
	                };
	
	                return this.trackEvent(promotionEvent);
	            } catch (e) {
	                console.log(e);
	            }
	        },
	        trackPage: function trackPage() {
	            var data = {
	                promotions: this.getPagePromotions(),
	                products: this.getPageProducts()
	            };
	
	            return this.trackData(data);
	        },
	        getPagePromotions: function getPagePromotions() {
	            var teasers = [];
	            $('[data-gtm-product]').each(function (index, teaser) {
	                var $teaser = $(teaser);
	                teasers.push({
	                    id: $teaser.data('gtm-teaser-id'),
	                    name: $teaser.data('gtm-teaser-title'),
	                    creative: $teaser.data('gtm-teaser-title'),
	                    position: index
	                });
	            });
	            return teasers;
	        },
	        getPageProducts: function getPageProducts() {
	            var products = [];
	            $('[data-gtm-product]').each(function (index, product) {
	                var productData = JSON.parse(atob($(product).data('gtm-product')));
	                products.push(productData);
	            });
	            return products;
	        }
	    });
	
	    return GtmHomePage;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(2), __webpack_require__(25), __webpack_require__(14), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Object, GtmBase, Url, moment) {
	
	    /**
	     * @param options
	     * @extends Object
	     * @extends OptionsMixin
	     * @constructor
	     */
	    function GtmListingPage(options) {
	        var self = this;
	        var defaultOptions = {};
	        //Add default options and custom options
	        this.addOptions(defaultOptions, options);
	
	        this.option('offersUpdateRoutes', ['allt_frontend.package.destination.accordion_offers', 'allt_frontend.hotel.destination.accordion_offers']);
	        this.option('accordionUpdateRoutes', ['allt_frontend.package.destination.accordion_content', 'allt_frontend.hotel.destination.accordion_content']);
	
	        options.stateHandler.on('success', function (responseContent, requestData) {
	            if (self.option('offersUpdateRoutes').indexOf(requestData.route) === -1) {
	                return false;
	            }
	
	            self.onAccordionOffersUpdate(requestData.queryParams.groupNames, true);
	        });
	
	        $('body').on('click', '[data-fcse-role="hotel-link"]', $.proxy(this._onClickHotelLink, this));
	        $('body').on('click', 'div[data-fcse-role="flightdestionationlist-offers"] a.flightrow', $.proxy(this._onClickFlightLink, this));
	
	        var groupNames = void 0;
	        var location = new Url();
	        if (typeof location.query.groupNames !== "undefined") {
	            if ($('[data-fcse-role="accordion--contentnode"][data-group-name="' + location.query.groupNames + '"]').length) {
	                groupNames = location.query.groupNames;
	            }
	        }
	        self.onAccordionOffersUpdate(groupNames, false);
	    }
	
	    GtmListingPage.prototype = $.extend(Object.create(GtmBase.prototype), /** @lends GtmListingPage.prototype */{
	        onAccordionOffersUpdate: function onAccordionOffersUpdate(groupNames, isUpdate) {
	            try {
	                var $responseContent = [];
	                var isFlightDestination = this.option('siteArea') === 'flightDestination';
	
	                if (!isFlightDestination) {
	                    $responseContent = $('[data-fcse-role="accordion--contentnode"][data-group-name="' + groupNames + '"]');
	                } else {
	                    $responseContent = $('.accordion[data-group-name="' + groupNames + '"]');
	                }
	
	                var canonicalUrl = new Url(window.location.href);
	
	                if (!$responseContent.length) {
	                    if ($(['data-fcse-role="accordion--node--header"']).length) {
	                        if (this.option('pageType') === 'searchResultPage') {
	                            this.trackData({
	                                canonicalUrl: canonicalUrl.toString(),
	                                pageType: 'searchResultPage',
	                                searchQuery: canonicalUrl.query.searchValue,
	                                products: []
	                            });
	                        } else {
	                            this.trackEvent({
	                                canonicalUrl: canonicalUrl.toString(),
	                                pageType: 'listingPage',
	                                listName: 'Filter/Alle Reiseziele',
	                                products: []
	                            });
	                        }
	                    }
	
	                    return;
	                }
	
	                var $offers = [];
	                if (!isFlightDestination) {
	                    $offers = $responseContent.find('[data-fcse-role="offer-item"][data-gtm-product]');
	                } else {
	                    $offers = $responseContent.find('div[data-fcse-role="flightdestionationlist-offers"] a.flightrow');
	                }
	
	                var data = {};
	                if ($offers.length) {
	                    if (isUpdate) {
	                        var products = [];
	                        if (!isFlightDestination) {
	                            products = this._getProductsData($offers, $offers.first().data('group-name'));
	                        } else {
	                            products = this._getFlightOnlyProductsData($offers);
	                        }
	                        this.trackEvent({
	                            event: 'productPush',
	                            eventLabel: products
	                        });
	                    } else {
	                        if (typeof canonicalUrl.query.groupNames === "undefined") {
	                            canonicalUrl.query.groupNames = groupNames;
	                        }
	
	                        data = {
	                            canonicalUrl: canonicalUrl.toString()
	                        };
	
	                        if (!isFlightDestination) {
	                            var _products = this._getProductsData($offers, $offers.first().data('group-name'));
	                            if (this.option('pageType') === 'searchResultPage') {
	                                data = $.extend(data, {
	                                    searchQuery: canonicalUrl.query.searchValue,
	                                    searchResults: $responseContent.find('[data-gtm-results-total]').data('gtm-results-total'),
	                                    products: _products
	                                });
	                            } else {
	                                data = $.extend(data, {
	                                    listName: 'Filter/' + $offers.first().data('group-name'),
	                                    products: _products
	                                });
	                            }
	                        } else {
	                            var _products2 = this._getFlightOnlyProductsData($offers);
	                            if (this.option('pageType') === 'searchResultPage') {
	                                data = $.extend(data, {
	                                    searchQuery: canonicalUrl.query.searchValue,
	                                    searchResults: $responseContent.find('[data-gtm-results-total]').data('gtm-results-total'),
	                                    products: _products2
	                                });
	                            } else {
	                                data = $.extend(data, {
	                                    listName: 'Filter/' + $offers.first().data('group-name'),
	                                    products: _products2
	                                });
	                            }
	                        }
	                        this.trackData(data);
	                    }
	                }
	            } catch (e) {
	                console.log(e);
	            }
	        },
	        _getProductsData: function _getProductsData($offers, listName) {
	            var self = this;
	            var products = [];
	            var siteArea = this.option('siteArea');
	            $offers.each(function (i) {
	                var $offerItem = $(this);
	                var data = $offerItem.data('gtm-product');
	                var position = i + 1;
	                data = $.extend(data, JSON.parse($offerItem.find('[data-fcse-favorites]').data('fcse-favorites').data));
	
	                try {
	                    switch (siteArea) {
	                        case 'packageDestination':
	                            products.push(self._createPackageDestinationProduct(data, listName, position));
	                            break;
	                        case 'hotelDestination':
	                            products.push(self._createHotelDestinationProduct(data, listName, position));
	                            break;
	                    }
	                } catch (e) {
	                    console.log(e);
	                }
	            });
	
	            return products;
	        },
	        _createPackageDestinationProduct: function _createPackageDestinationProduct(data, listName, position) {
	            var product = {
	                name: data.hotel.name,
	                id: data.hotel.id, //if available otherwise repeat the hotelname
	                brand: data.hotel.offers["0"].tourOperator.code,
	                variant: data.hotel.offers["0"].departureFlight.departureAirport.code + '-' + data.hotel.offers["0"].departureFlight.arrivalAirport.code,
	                price: data.offer.price.total, //in this case the cheapest Offer price of the product as shown in the list
	                category: 'package/' + data.hotel.location.country.name + '/' + data.hotel.location.city.name,
	                list: listName, // i.e. 'Hurghada'
	                position: position, //i.e.. '1'. only on list pages
	                adults: data.productSearch.travellers.adults.length,
	                durationOfStay: data.hotel.offers["0"].lengthOfStay,
	                travelDates: data.offer.period.from + '/' + data.offer.period.to
	            };
	
	            if (typeof data.productSearch.travellers.children !== "undefined") {
	                product.children = data.productSearch.travellers.children.length;
	            }
	
	            return product;
	        },
	        _createHotelDestinationProduct: function _createHotelDestinationProduct(data, listName, position) {
	            var product = {
	                name: data.hotel.name,
	                id: data.hotel.id, //if available otherwise repeat the hotelname
	                brand: data.hotel.offers["0"].tourOperator.code,
	                variant: data.hotel.location.city.name, //data.hotel.offers["0"].nearestAirportDLC,
	                price: data.offer.price.total, //in this case the cheapest Offer price of the product as shown in the list
	                category: 'package/' + data.hotel.location.country.name + '/' + data.hotel.location.city.name,
	                list: listName, // i.e. 'Hurghada'
	                position: position, //i.e.. '1'. only on list pages
	                adults: data.productSearch.travellers.adults.length,
	                durationOfStay: data.hotel.offers["0"].lengthOfStay,
	                travelDates: data.offer.period.from + '/' + data.offer.period.to
	            };
	
	            if (typeof data.productSearch.travellers.children !== "undefined") {
	                product.children = data.productSearch.travellers.children.length;
	            }
	
	            return product;
	        },
	        _getFlightOnlyProductsData: function _getFlightOnlyProductsData($offers) {
	            var products = [];
	            $offers.each(function (i) {
	                var $offerItem = $(this);
	                var data = $offerItem.data('tracking-data');
	                var productSearch = $offerItem.data('tracking-product-search');
	                var position = i + 1;
	
	                var travelDates = {
	                    from: moment(data.offers["0"].departureFlight.departureDateTime).format('YYYY.MM.DD'),
	                    to: moment(data.offers["0"].returnFlight.departureDateTime).format('YYYY.MM.DD')
	                };
	
	                try {
	                    var product = {
	                        name: data.offers["0"].departureFlight.departureAirport.code + '-' + data.offers["0"].returnFlight.departureAirport.code,
	                        id: data.offers["0"].departureFlight.flightNumber, //if available otherwise repeat the name
	                        brand: data.offers["0"].tourOperator.code,
	                        variant: travelDates.from + '/' + travelDates.to,
	                        price: data.offers["0"].price.amount,
	                        category: 'flight/' + data.location.country.code + '/' + data.airportIdentifier.name,
	                        list: data.airportIdentifier.name,
	                        position: position,
	                        adults: productSearch.travellers.adults.length,
	                        durationOfStay: productSearch.travelPeriod.duration,
	                        travelDates: travelDates.from + '/' + travelDates.to
	                    };
	
	                    if (typeof productSearch.travellers.children !== "undefined") {
	                        product.children = productSearch.travellers.children.length;
	                    }
	
	                    products.push(product);
	                } catch (e) {
	                    console.log(e);
	                }
	            });
	
	            return products;
	        },
	        _onClickHotelLink: function _onClickHotelLink(e) {
	
	            /**
	             * Triggered event
	             */
	            if (typeof e.which === 'undefined') {
	                e.which = 1;
	            }
	            //right Click
	            if (e.which === 3) {
	                return true;
	            }
	
	            e.preventDefault();
	            e.stopImmediatePropagation();
	
	            var $elem = $(e.currentTarget);
	            var targetUrl = $elem.attr('href').trim();
	
	            var offerData = this._getOfferData($elem);
	
	            //(e.which === 1) - left Click
	            // Not change location in case of middle btn click
	            var eventCallback = e.which === 1 ? function () {
	                document.location = targetUrl;
	            } : function () {};
	
	            setTimeout(eventCallback, 2000);
	
	            var product = {};
	            if (this.option('siteArea') === 'hotelDestination') {
	                product = this._createHotelDestinationProduct(offerData, offerData.listName, offerData.offerIndex);
	            } else {
	                product = this._createPackageDestinationProduct(offerData, offerData.listName, offerData.offerIndex);
	            }
	
	            window.dataLayer.push({
	                'event': 'productClick',
	                product: product,
	                'eventCallback': eventCallback
	            });
	
	            return false;
	        },
	        _onClickFlightLink: function _onClickFlightLink(e) {
	
	            //right Click
	            if (e.which === 3) {
	                return true;
	            }
	
	            e.preventDefault();
	            e.stopImmediatePropagation();
	
	            var $elem = $(e.currentTarget);
	            var targetUrl = $elem.attr('href').trim();
	
	            //(e.which === 1) - left Click
	            // Not change location in case of middle btn click
	            var eventCallback = e.which === 1 ? function () {
	                document.location = targetUrl;
	            } : function () {};
	
	            setTimeout(eventCallback, 2000);
	
	            var products = this._getFlightOnlyProductsData($elem);
	
	            window.dataLayer.push({
	                'event': 'productClick',
	                product: products[0] ? products[0] : {},
	                // (e.which === 1) left btn Click
	                // Not change location in case of middle btn click
	                'eventCallback': eventCallback
	            });
	
	            return false;
	        },
	        _getOfferData: function _getOfferData($elem) {
	            var $offerItem = $elem.parents('[data-fcse-role="offer-item"]');
	            var offerData = JSON.parse($offerItem.find('[data-fcse-favorites]').data('fcse-favorites').data);
	            var $hotelDetails = $('[data-fcse-role="hotel-details"]');
	            if ($hotelDetails.length) {
	                offerData = $.extend(offerData, $hotelDetails.data(), $hotelDetails.data('fcse-booking-data'));
	            }
	
	            offerData = $.extend(offerData, $offerItem.data('gtm-product'));
	            offerData.listName = $offerItem.data('group-name');
	            offerData.offerIndex = $offerItem.data('fcse-offer-index');
	
	            return offerData;
	        }
	    });
	
	    return GtmListingPage;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(2), __webpack_require__(25), __webpack_require__(8), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Object, GtmBase, moment, _) {
	
	    function GtmProductPage(options) {
	        GtmBase.apply(this, arguments);
	
	        $('[data-fcse-role="hotel-details"] [data-fcse-role="check-offer-button"]').on('click', $.proxy(this._onClickCheckOfferButton, this));
	    }
	
	    GtmProductPage.prototype = $.extend(Object.create(GtmBase.prototype), /** @lends GtmProductPage.prototype */{
	        trackPage: function trackPage() {
	            var $offer = $('.favorites-offer [data-fcse-role="favorites--add"]');
	
	            if (!$offer.length) {
	                return;
	            }
	
	            try {
	                var data = {};
	                var offerData = JSON.parse($offer.data('fcse-favorites').data);
	                var $hotelDetails = $('[data-fcse-role="hotel-details"]');
	
	                if ($hotelDetails.length) {
	                    offerData = $.extend(offerData, $hotelDetails.data(), $hotelDetails.data('fcse-booking-data'));
	                }
	
	                if (this.option('siteArea') === 'hotelDetail') {
	                    data = this.getHotelDetailData(offerData);
	                } else {
	                    data = this.getPackageDetailData(offerData);
	                }
	            } catch (e) {
	                console.log(e);
	            }
	
	            return this.trackData(data);
	        },
	        getHotelDetailData: function getHotelDetailData(offerData) {
	            var $firstOffer = $('[data-fcse-role="offerlist"] [data-fcse-role="offer-item"]');
	            if ($firstOffer.length) {
	                $firstOffer = $firstOffer.first();
	                offerData = $.extend(offerData, $firstOffer.data());
	            }
	
	            try {
	                var data = {
	                    canonicalUrl: window.location.href,
	                    product: {
	                        name: offerData.hotel.name,
	                        id: offerData.hotel.id,
	                        brand: offerData.tourOperator,
	                        variant: offerData.hotel.location.city.name,
	                        price: offerData.hotel.offers["0"].price.amount,
	                        category: 'package/' + offerData.hotel.location.country.name + '/' + offerData.hotel.location.city.name,
	                        list: offerData.hotel.location.country.name, // i.e. 'Hurghada'
	                        adults: offerData.productSearch.travellers.adults.length,
	                        durationOfStay: offerData.hotel.offers["0"].lengthOfStay,
	                        travelDates: offerData.packageRouteParams.departureDate + '/' + offerData.packageRouteParams.returnDate
	                    }
	                };
	
	                if (typeof offerData.productSearch.travellers.children !== "undefined") {
	                    offerData.product.children = offerData.productSearch.travellers.children.length;
	                }
	            } catch (e) {
	                console.log(e);
	            }
	
	            return data;
	        },
	        getPackageDetailData: function getPackageDetailData(offerData) {
	            try {
	                var data = {
	                    canonicalUrl: window.location.href,
	                    product: {
	                        name: offerData.hotel.name,
	                        id: offerData.hotel.id,
	                        brand: offerData.tourOperator,
	                        variant: offerData.hotel.offers["0"].departureFlight.departureAirport.code + '-' + offerData.hotel.offers["0"].departureFlight.arrivalAirport.code,
	                        price: offerData.hotel.offers["0"].price.amount,
	                        category: 'package/' + offerData.hotel.location.country.name + '/' + offerData.hotel.location.city.name,
	                        list: offerData.hotelRegion, // i.e. 'Hurghada'
	                        adults: offerData.productSearch.travellers.adults.length,
	                        durationOfStay: offerData.hotel.offers["0"].lengthOfStay,
	                        travelDates: moment(offerData.hotel.offers["0"].departureFlight.departureDateTime).format('YYYY.MM.DD') + '/' + moment(offerData.hotel.offers["0"].returnFlight.departureDateTime).format('YYYY.MM.DD')
	                    }
	                };
	
	                if (typeof offerData.productSearch.travellers.children !== "undefined") {
	                    offerData.product.children = offerData.productSearch.travellers.children.length;
	                }
	            } catch (e) {
	                console.log(e);
	            }
	
	            return data;
	        },
	        _onClickCheckOfferButton: function _onClickCheckOfferButton(e) {
	            var $elem = $(e.target);
	
	            if ($elem.hasClass('success')) {
	                var offerData = this._getOfferData($elem);
	                var product = {};
	
	                if (this.option('siteArea') === 'hotelDetail') {
	                    product = this.getHotelDetailData(offerData).product;
	                } else {
	                    product = this.getPackageDetailData(offerData).product;
	                }
	
	                dataLayer.push({
	                    'event': 'shoppingCartAction',
	                    'cartAction': 'add',
	                    product: product
	                });
	            }
	        },
	        _getOfferData: function _getOfferData($elem) {
	            var $offer = $elem.parents('[data-fcse-role="offer-item"]');
	            var offerData = JSON.parse($offer.find('[data-fcse-favorites]').data('fcse-favorites').data);
	            var $hotelDetails = $('[data-fcse-role="hotel-details"]');
	            if ($hotelDetails.length) {
	                offerData = $.extend(offerData, $hotelDetails.data(), $hotelDetails.data('fcse-booking-data'));
	            }
	
	            return offerData;
	        }
	    });
	
	    return GtmProductPage;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _create = __webpack_require__(78);
	
	var _create2 = _interopRequireDefault(_create);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by Pavel Kozhin on 28/01/16.
	 */
	
	/**
	 * LastVisitedHotels component.
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(1), __webpack_require__(9), __webpack_require__(58), __webpack_require__(96), __webpack_require__(109)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, $, OptionsMixin, MultiRequestHandler, LazyImage) {
	
	    function getStorage() {
	        try {
	            var storage = window.localStorage,
	                x = '__storage_test__';
	            storage.setItem(x, x);
	            storage.removeItem(x);
	            return window.localStorage;
	        } catch (e) {
	            return null;
	        }
	    }
	    /**
	     * LastVisitedHotels
	     * @param element
	     * @param options
	     * @constructor
	     */
	    var LastVisitedHotels = function LastVisitedHotels(element, options) {
	        this.topElement = $(element);
	
	        this.element = $('[data-fcse-role="last-visited-hotels-slider-container"]', this.topElement);
	        this.requestHandler = new MultiRequestHandler();
	        this._lastPageIndex = null;
	        this._storage = getStorage();
	
	        var amountPerPage = this.element.data('per-page') || 3;
	        var amountMobilePerPage = this.element.data('mobile-per-page') || 2;
	        var isMobile = this.element.data('is-mobile');
	
	        amountPerPage = isMobile ? amountMobilePerPage : amountPerPage;
	
	        var defaultOptions = {
	            route: 'allt_frontend.user_tracking.last_visited',
	            sliderSelector: '',
	            loadingClass: 'is-slider-loading',
	            amountPerPage: amountPerPage,
	            perPage: amountPerPage * 2,
	            isMobile: isMobile,
	            sliderPrevBtnSelector: '[data-fcse-role="slide-prev-btn"]',
	            sliderNextBtnSelector: '[data-fcse-role="slide-next-btn"]'
	        };
	
	        this.addOptions(defaultOptions, options);
	
	        this._init();
	    };
	
	    LastVisitedHotels.prototype = $.extend({}, (0, _create2.default)(OptionsMixin), {
	        /**
	         * Initializer
	         * @private
	         */
	        _init: function _init() {
	
	            if (!this.element.length) {
	                return;
	            }
	            if (!this._storage) {
	                this.element.hide();
	            }
	            var hotel = this.element.attr('data-persist-hotel');
	            var visitedHotels = this._storage.getItem('visited_hotels');
	            // var visitedHotelsMarkup = this._storage.getItem('visited_hotels_markup');
	            var amountPerPage = this.option('amountPerPage');
	
	            this.requestHandler.on('success', $.proxy(this._dataSuccessHandler, this));
	            var routeParams = {
	                type: 'visited_hotels',
	                page: 1,
	                perPage: amountPerPage
	            };
	            // We send stored visited hotels to backend for rendering
	            var params = {
	                hotel: hotel || null,
	                visitedHotels: visitedHotels || null
	            };
	            this._loadData(routeParams, params);
	
	            // If hotel to persist
	            /* if (hotel) {
	                this.requestHandler.on('success', $.proxy(this._dataSuccessHandler, this));
	                var routeParams = {
	                    type: 'visited_hotels',
	                    page: 1,
	                    perPage: this.option('amountPerPage')
	                };
	                // We send stored visited hotels to backend for rendering
	                var params = {
	                    hotel: hotel || null,
	                    visitedHotels: visitedHotels || null
	                };
	                this._loadData(routeParams, params);
	            } else if (visitedHotelsMarkup) {
	                this._injectMarkup(visitedHotelsMarkup);
	            } else if (!visitedHotelsMarkup) {
	                this.topElement.hide();
	            } */
	        },
	
	        /**
	         * Loads slider data
	         * @param routeParams
	         * @private
	         */
	        _loadData: function _loadData(routeParams, params) {
	            this.element.addClass(this.option('loadingClass'));
	            this.requestHandler.cancel(this.option('route'));
	            this.requestHandler.send(this.option('route'), params, routeParams, { method: 'POST' });
	        },
	
	        /**
	         * Request success handler
	         * @param data
	         * @private
	         */
	        _dataSuccessHandler: function _dataSuccessHandler(data, requestData) {
	            this.element.removeClass(this.option('loadingClass'));
	
	            if (requestData && requestData.route == this.option('route')) {
	                if (data && data.html) {
	                    this._injectMarkup(data.html);
	                    if (this._storage && data.meta && data.meta.hotels) {
	                        this._storage.setItem('visited_hotels', data.meta.hotels);
	                        this._storage.setItem('visited_hotels_markup', data.html);
	                    }
	                    this.element.show();
	                    this.topElement.show();
	                } else {
	                    this.topElement.hide();
	                }
	            }
	        },
	
	        /**
	         * Injects markup to DOM
	         * @param html
	         * @private
	         */
	        _injectMarkup: function _injectMarkup(html) {
	            this.element.removeClass(this.option('loadingClass'));
	            this.element.html(html);
	            this._carouselElement = $('[data-fcse-role="carousel"]', this.element);
	            this._carouselElement.carousel(0);
	            this._carouselElement.on('slide.bs.carousel', $.proxy(this._loadImages, this));
	            this._loadImages();
	            this._lastPageIndex = $('.item', this.element).last().data('index');
	        },
	
	        /**
	         * Lazy load of images
	         * @param event
	         * @private
	         */
	        _loadImages: function _loadImages(event) {
	            var self = this,
	                pageIndex = event ? $(event.relatedTarget).data('index') : 0,
	                startIndexFrom = pageIndex * this.option('perPage'),
	                range = _.range(startIndexFrom, (pageIndex + 1) * this.option('perPage')),
	                prevBtn = $(this.option('sliderPrevBtnSelector'), this.element).hide(),
	                nextBtn = $(this.option('sliderNextBtnSelector'), this.element).hide();
	
	            pageIndex === 0 ? prevBtn.hide() : prevBtn.show();
	            pageIndex === this._lastPageIndex ? nextBtn.hide() : nextBtn.show();
	
	            _.each(range, function (index) {
	                var itemElement = $('[data-hotel-index="' + index + '"]', self._carouselElement);
	                if (itemElement.length) {
	                    LazyImage.loadImages(itemElement);
	                }
	            });
	        }
	    });
	
	    return LastVisitedHotels;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(145)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, deviceInfo) {
	    'use strict';
	
	    var backdrop = '.navbar-menu-backdrop';
	    var toggle = '[data-toggle="navbar-menu"]';
	    var NavbarMenu = function NavbarMenu(element) {
	        $(element).on('click.navbar-menu', this.toggle);
	    };
	
	    NavbarMenu.VERSION = '1.0.0';
	
	    function getParent($this) {
	        var selector = $this.attr('data-target');
	
	        if (!selector) {
	            selector = $this.attr('href');
	            selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '');
	        }
	
	        var $parent = selector && $(selector);
	
	        return $parent && $parent.length ? $parent : $this.parent();
	    }
	
	    function clearMenus(e) {
	        if (e && e.which === 3) {
	            return;
	        }
	
	        if (e && typeof e.type !== 'undefined') {
	            if ($(e.target).parents('.cms').length || $(e.target).hasClass('cms') || $(e.target).hasClass('modal-backdrop')) {
	                return;
	            }
	            if (e.type === 'mouseover') {
	                if ($(e.target).parents('[data-fcse-role="navbar-container"]').length) {
	                    return;
	                }
	            }
	        }
	
	        $(backdrop).remove();
	        $(toggle).each(function () {
	            var $this = $(this);
	            var $parent = getParent($this);
	            var relatedTarget = { relatedTarget: this };
	
	            if (!$parent.hasClass('open')) {
	                return;
	            }
	
	            if (e && e.type === 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) {
	                return;
	            }
	
	            $parent.trigger(e = $.Event('hide.navbar-menu', relatedTarget));
	
	            if (e.isDefaultPrevented()) {
	                return;
	            }
	
	            $this.attr('aria-expanded', 'false');
	            $this.toggleClass('open');
	            $parent.removeClass('open').trigger('hidden.navbar-menu', relatedTarget);
	        });
	    }
	
	    NavbarMenu.prototype.toggle = function (e) {
	        var $this = $(this);
	        if ($this.is('.disabled, :disabled')) {
	            return;
	        }
	
	        if (deviceInfo.isTouching && e.type === 'mouseover') {
	            return;
	        }
	
	        var $parent = getParent($this);
	        var isActive = $parent.hasClass('open');
	
	        clearMenus();
	
	        if (!isActive) {
	            if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
	                $(document.createElement('div')).addClass('navbar-menu-backdrop').insertAfter($(this)).on('click', clearMenus);
	            }
	
	            $this.trigger('focus').attr('aria-expanded', 'true');
	
	            $this.toggleClass('open');
	            $parent.toggleClass('open');
	        }
	
	        if (e.type === 'click') {
	            if (deviceInfo.isTouching) {
	                if ($this.hasClass('touch-opened')) {
	                    $this.removeClass('touch-opened');
	                    $this.trigger('follow.navbar-menu');
	                } else {
	                    $(toggle).removeClass('touch-opened');
	                    $this.addClass('touch-opened');
	                }
	            } else {
	                $this.trigger('follow.navbar-menu');
	            }
	        }
	
	        return false;
	    };
	
	    function Plugin(option) {
	        return this.each(function () {
	            var $this = $(this);
	            var data = $this.data('navbar-menu');
	
	            if (!data) {
	                $this.data('navbar-menu', data = new NavbarMenu(this));
	            }
	            if (typeof option === 'string') {
	                data[option].call($this);
	            }
	        });
	    }
	
	    var old = $.fn.navbarMenu;
	
	    $.fn.navbarMenu = Plugin;
	    $.fn.navbarMenu.Constructor = NavbarMenu;
	
	    $.fn.navbarMenu.noConflict = function () {
	        $.fn.navbarMenu = old;
	        return this;
	    };
	
	    $(document).on('click.navbar-menu.data-api', clearMenus).on('mouseover.navbar-menu.data-api', 'html,body', clearMenus).on('mouseover.navbar-menu.data-api', toggle + ':not(.open)', NavbarMenu.prototype.toggle).on('click.navbar-menu.data-api', toggle, NavbarMenu.prototype.toggle);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(80);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports.default = Router;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Portions of this code are from the Google Closure Library,
	 * received from the Closure Authors under the Apache 2.0 license.
	 *
	 * All other code is (C) FriendsOfSymfony and subject to the MIT license.
	 */
	function Router() {
	  var f = !1,
	      i,
	      k = this;
	
	  function l(a, c) {
	    var b = a.split("."),
	        d = k;
	    !(b[0] in d) && d.execScript && d.execScript("var " + b[0]);
	    for (var e; b.length && (e = b.shift());) {
	      !b.length && void 0 !== c ? d[e] = c : d = d[e] ? d[e] : d[e] = {};
	    }
	  };
	  var m = Array.prototype,
	      n = m.forEach ? function (a, c, b) {
	    m.forEach.call(a, c, b);
	  } : function (a, c, b) {
	    for (var d = a.length, e = "string" == typeof a ? a.split("") : a, g = 0; g < d; g++) {
	      g in e && c.call(b, e[g], g, a);
	    }
	  };
	
	  function q(a, c) {
	    this.c = {};
	    this.a = [];
	    var b = arguments.length;
	    if (1 < b) {
	      if (b % 2) throw Error("Uneven number of arguments");
	      for (var d = 0; d < b; d += 2) {
	        this.set(arguments[d], arguments[d + 1]);
	      }
	    } else if (a) {
	      var e;
	      if (a instanceof q) {
	        r(a);
	        d = a.a.concat();
	        r(a);
	        e = [];
	        for (b = 0; b < a.a.length; b++) {
	          e.push(a.c[a.a[b]]);
	        }
	      } else {
	        var b = [],
	            g = 0;
	        for (d in a) {
	          b[g++] = d;
	        }d = b;
	        b = [];
	        g = 0;
	        for (e in a) {
	          b[g++] = a[e];
	        }e = b;
	      }
	      for (b = 0; b < d.length; b++) {
	        this.set(d[b], e[b]);
	      }
	    }
	  }
	
	  q.prototype.f = 0;
	  q.prototype.p = 0;
	  function r(a) {
	    if (a.f != a.a.length) {
	      for (var c = 0, b = 0; c < a.a.length;) {
	        var d = a.a[c];
	        t(a.c, d) && (a.a[b++] = d);
	        c++;
	      }
	      a.a.length = b;
	    }
	    if (a.f != a.a.length) {
	      for (var e = {}, b = c = 0; c < a.a.length;) {
	        d = a.a[c], t(e, d) || (a.a[b++] = d, e[d] = 1), c++;
	      }a.a.length = b;
	    }
	  }
	
	  q.prototype.get = function (a, c) {
	    return t(this.c, a) ? this.c[a] : c;
	  };
	  q.prototype.set = function (a, c) {
	    t(this.c, a) || (this.f++, this.a.push(a), this.p++);
	    this.c[a] = c;
	  };
	  function t(a, c) {
	    return Object.prototype.hasOwnProperty.call(a, c);
	  };
	  var u, v, w, x;
	
	  function y() {
	    return k.navigator ? k.navigator.userAgent : null;
	  }
	
	  x = w = v = u = f;
	  var C;
	  if (C = y()) {
	    var D = k.navigator;
	    u = 0 == C.indexOf("Opera");
	    v = !u && -1 != C.indexOf("MSIE");
	    w = !u && -1 != C.indexOf("WebKit");
	    x = !u && !w && "Gecko" == D.product;
	  }
	  var E = v,
	      F = x,
	      G = w;
	  var I;
	  if (u && k.opera) {
	    var J = k.opera.version;
	    "function" == typeof J && J();
	  } else F ? I = /rv\:([^\);]+)(\)|;)/ : E ? I = /MSIE\s+([^\);]+)(\)|;)/ : G && (I = /WebKit\/(\S+)/), I && I.exec(y());
	  function K(a, c) {
	    this.b = a || { e: "", prefix: "", host: "", scheme: "" };
	    this.h(c || {});
	  }
	
	  K.g = function () {
	    return K.j ? K.j : K.j = new K();
	  };
	  i = K.prototype;
	  i.h = function (a) {
	    this.d = new q(a);
	  };
	  i.o = function () {
	    return this.d;
	  };
	  i.k = function (a) {
	    this.b.e = a;
	  };
	  i.n = function () {
	    return this.b.e;
	  };
	  i.l = function (a) {
	    this.b.prefix = a;
	  };
	  function L(a, c, b, d) {
	    var e,
	        g = RegExp(/\[\]$/);
	    if (b instanceof Array) n(b, function (b, e) {
	      g.test(c) ? d(c, b) : L(a, c + "[" + ("object" === (typeof b === "undefined" ? "undefined" : (0, _typeof3.default)(b)) ? e : "") + "]", b, d);
	    });else if ("object" === (typeof b === "undefined" ? "undefined" : (0, _typeof3.default)(b))) for (e in b) {
	      L(a, c + "[" + e + "]", b[e], d);
	    } else d(c, b);
	  }
	
	  i.i = function (a) {
	    var c = this.b.prefix + a;
	    if (t(this.d.c, c)) a = c;else if (!t(this.d.c, a)) throw Error('The route "' + a + '" does not exist.');
	    return this.d.get(a);
	  };
	  i.m = function (a, c, b) {
	    var d = this.i(a),
	        e = c || {},
	        g = {},
	        z;
	    for (z in e) {
	      g[z] = e[z];
	    }var h = "",
	        s = !0,
	        j = "";
	    n(d.tokens, function (b) {
	      if ("text" === b[0]) h = b[1] + h, s = f;else if ("variable" === b[0]) {
	        var c = b[3] in d.defaults;
	        if (f === s || !c || b[3] in e && e[b[3]] != d.defaults[b[3]]) {
	          if (b[3] in e) {
	            var c = e[b[3]],
	                p = b[3];
	            p in g && delete g[p];
	          } else if (c) c = d.defaults[b[3]];else {
	            if (s) return;
	            throw Error('The route "' + a + '" requires the parameter "' + b[3] + '".');
	          }
	          if (!(!0 === c || f === c || "" === c) || !s) p = encodeURIComponent(c).replace(/%2F/g, "/"), "null" === p && null === c && (p = ""), h = b[1] + p + h;
	          s = f;
	        } else c && (b = b[3], b in g && delete g[b]);
	      } else throw Error('The token type "' + b[0] + '" is not supported.');
	    });
	    "" === h && (h = "/");
	    n(d.hosttokens, function (a) {
	      var b;
	      if ("text" === a[0]) j = a[1] + j;else if ("variable" === a[0]) {
	        if (a[3] in e) {
	          b = e[a[3]];
	          var c = a[3];
	          c in g && delete g[c];
	        } else a[3] in d.defaults && (b = d.defaults[a[3]]);
	        j = a[1] + b + j;
	      }
	    });
	    h = this.b.e + h;
	    "_scheme" in d.requirements && this.b.scheme != d.requirements._scheme ? h = d.requirements._scheme + "://" + (j || this.b.host) + h : j && this.b.host !== j ? h = this.b.scheme + "://" + j + h : !0 === b && (h = this.b.scheme + "://" + this.b.host + h);
	    var c = 0,
	        A;
	    for (A in g) {
	      c++;
	    }if (0 < c) {
	      var B,
	          H = [];
	      A = function A(a, b) {
	        b = "function" === typeof b ? b() : b;
	        H.push(encodeURIComponent(a) + "=" + encodeURIComponent(null === b ? "" : b));
	      };
	      for (B in g) {
	        L(this, B, g[B], A);
	      }h = h + "?" + H.join("&").replace(/%20/g, "+");
	    }
	    return h;
	  };
	  var setData = function setData(a) {
	    var c = K.g();
	    c.k(a.base_url);
	    c.h(a.routes);
	    "prefix" in a && c.l(a.prefix);
	    c.b.host = a.host;
	    c.b.scheme = a.scheme;
	  };
	  l("fos.Router", K);
	  l("fos.Router.setData", setData);
	  K.getInstance = K.g;
	  K.prototype.setRoutes = K.prototype.h;
	  K.prototype.getRoutes = K.prototype.o;
	  K.prototype.setBaseUrl = K.prototype.k;
	  K.prototype.getBaseUrl = K.prototype.n;
	  K.prototype.generate = K.prototype.m;
	  K.prototype.setPrefix = K.prototype.l;
	  K.prototype.getRoute = K.prototype.i;
	  K.prototype.setData = setData;
	
	  return K.g();
	}
	
	window.fos = {
	  Router: new Router()
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(Router, "Router", "/home/jenkins/agent/workspace/ALLSUN_Deploy_to_Prod/src/Allt/FrontendBundle/Resources/assets/util/lib/router.js");
	}();

	;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(3),
	    __webpack_require__(1),
	    __webpack_require__(59),
	    __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, $, Binding, Object) {
	        var MultiplePropertiesBinding = function (mapping) {
	            Binding.call(this);
	            this.mapping = mapping;
	            this.invertMapping = _.invert(this.mapping);
	        };
	        MultiplePropertiesBinding.prototype = $.extend(Object.create(Binding), {
	            fromScope: function (scope) {
	                var self = this;
	                var widgetValue = {};
	                _.each(_.keys(this.mapping), function (scopeParamName) {
	                    widgetValue[self.mapping[scopeParamName]] = scope[scopeParamName];
	                });
	                return widgetValue;
	            },
	            toScope: function (widgetValue) {
	                var self = this;
	                var scopeParamValues = {};
	                _.each(_.keys(this.invertMapping), function (widgetPropertyName) {
	                    // Catch null values
	                    if (widgetValue === null){
	                        return;
	                    }
	                    scopeParamValues[self.invertMapping[widgetPropertyName]] = widgetValue[widgetPropertyName];
	                });
	                return scopeParamValues;
	            },
	            isValueAffectedBy: function (scopeParamName) {
	                return this.mapping.hasOwnProperty(scopeParamName);
	            }
	        });
	        return MultiplePropertiesBinding;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(3),
	    __webpack_require__(1),
	    __webpack_require__(59),
	    __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, $, Binding, Object) {
	        var SinglePropertyBinding = function (scopeProperty) {
	            Binding.call(this);
	            this.scopeProperty = scopeProperty;
	        };
	        SinglePropertyBinding.prototype = $.extend(Object.create(Binding), {
	            fromScope: function (scope) {
	                return scope[this.scopeProperty];
	            },
	            toScope: function (widgetValue) {
	                var scopeValues = {};
	                scopeValues[this.scopeProperty] = widgetValue;
	                return scopeValues;
	            },
	            isValueAffectedBy: function (scopeParamName) {
	                return scopeParamName === this.scopeProperty;
	            }
	        });
	        return SinglePropertyBinding;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v1.1.3 - 2014-05-20
	 * http://eightmedia.github.io/hammer.js
	 *
	 * Copyright (c) 2014 Jorik Tangelder <j.tangelder@gmail.com>;
	 * Licensed under the MIT license */
	
	(function(window, undefined) {
	  'use strict';
	
	/**
	 * @main
	 * @module hammer
	 *
	 * @class Hammer
	 * @static
	 */
	
	/**
	 * Hammer, use this to create instances
	 * ````
	 * var hammertime = new Hammer(myElement);
	 * ````
	 *
	 * @method Hammer
	 * @param {HTMLElement} element
	 * @param {Object} [options={}]
	 * @return {Hammer.Instance}
	 */
	var Hammer = function Hammer(element, options) {
	    return new Hammer.Instance(element, options || {});
	};
	
	/**
	 * version, as defined in package.json
	 * the value will be set at each build
	 * @property VERSION
	 * @final
	 * @type {String}
	 */
	Hammer.VERSION = '1.1.3';
	
	/**
	 * default settings.
	 * more settings are defined per gesture at `/gestures`. Each gesture can be disabled/enabled
	 * by setting it's name (like `swipe`) to false.
	 * You can set the defaults for all instances by changing this object before creating an instance.
	 * @example
	 * ````
	 *  Hammer.defaults.drag = false;
	 *  Hammer.defaults.behavior.touchAction = 'pan-y';
	 *  delete Hammer.defaults.behavior.userSelect;
	 * ````
	 * @property defaults
	 * @type {Object}
	 */
	Hammer.defaults = {
	    /**
	     * this setting object adds styles and attributes to the element to prevent the browser from doing
	     * its native behavior. The css properties are auto prefixed for the browsers when needed.
	     * @property defaults.behavior
	     * @type {Object}
	     */
	    behavior: {
	        /**
	         * Disables text selection to improve the dragging gesture. When the value is `none` it also sets
	         * `onselectstart=false` for IE on the element. Mainly for desktop browsers.
	         * @property defaults.behavior.userSelect
	         * @type {String}
	         * @default 'none'
	         */
	        userSelect: 'none',
	
	        /**
	         * Specifies whether and how a given region can be manipulated by the user (for instance, by panning or zooming).
	         * Used by Chrome 35> and IE10>. By default this makes the element blocking any touch event.
	         * @property defaults.behavior.touchAction
	         * @type {String}
	         * @default: 'pan-y'
	         */
	        touchAction: 'pan-y',
	
	        /**
	         * Disables the default callout shown when you touch and hold a touch target.
	         * On iOS, when you touch and hold a touch target such as a link, Safari displays
	         * a callout containing information about the link. This property allows you to disable that callout.
	         * @property defaults.behavior.touchCallout
	         * @type {String}
	         * @default 'none'
	         */
	        touchCallout: 'none',
	
	        /**
	         * Specifies whether zooming is enabled. Used by IE10>
	         * @property defaults.behavior.contentZooming
	         * @type {String}
	         * @default 'none'
	         */
	        contentZooming: 'none',
	
	        /**
	         * Specifies that an entire element should be draggable instead of its contents.
	         * Mainly for desktop browsers.
	         * @property defaults.behavior.userDrag
	         * @type {String}
	         * @default 'none'
	         */
	        userDrag: 'none',
	
	        /**
	         * Overrides the highlight color shown when the user taps a link or a JavaScript
	         * clickable element in Safari on iPhone. This property obeys the alpha value, if specified.
	         *
	         * If you don't specify an alpha value, Safari on iPhone applies a default alpha value
	         * to the color. To disable tap highlighting, set the alpha value to 0 (invisible).
	         * If you set the alpha value to 1.0 (opaque), the element is not visible when tapped.
	         * @property defaults.behavior.tapHighlightColor
	         * @type {String}
	         * @default 'rgba(0,0,0,0)'
	         */
	        tapHighlightColor: 'rgba(0,0,0,0)'
	    }
	};
	
	/**
	 * hammer document where the base events are added at
	 * @property DOCUMENT
	 * @type {HTMLElement}
	 * @default window.document
	 */
	Hammer.DOCUMENT = document;
	
	/**
	 * detect support for pointer events
	 * @property HAS_POINTEREVENTS
	 * @type {Boolean}
	 */
	Hammer.HAS_POINTEREVENTS = navigator.pointerEnabled || navigator.msPointerEnabled;
	
	/**
	 * detect support for touch events
	 * @property HAS_TOUCHEVENTS
	 * @type {Boolean}
	 */
	Hammer.HAS_TOUCHEVENTS = ('ontouchstart' in window);
	
	/**
	 * detect mobile browsers
	 * @property IS_MOBILE
	 * @type {Boolean}
	 */
	Hammer.IS_MOBILE = /mobile|tablet|ip(ad|hone|od)|android|silk/i.test(navigator.userAgent);
	
	/**
	 * detect if we want to support mouseevents at all
	 * @property NO_MOUSEEVENTS
	 * @type {Boolean}
	 */
	Hammer.NO_MOUSEEVENTS = (Hammer.HAS_TOUCHEVENTS && Hammer.IS_MOBILE) || Hammer.HAS_POINTEREVENTS;
	
	/**
	 * interval in which Hammer recalculates current velocity/direction/angle in ms
	 * @property CALCULATE_INTERVAL
	 * @type {Number}
	 * @default 25
	 */
	Hammer.CALCULATE_INTERVAL = 25;
	
	/**
	 * eventtypes per touchevent (start, move, end) are filled by `Event.determineEventTypes` on `setup`
	 * the object contains the DOM event names per type (`EVENT_START`, `EVENT_MOVE`, `EVENT_END`)
	 * @property EVENT_TYPES
	 * @private
	 * @writeOnce
	 * @type {Object}
	 */
	var EVENT_TYPES = {};
	
	/**
	 * direction strings, for safe comparisons
	 * @property DIRECTION_DOWN|LEFT|UP|RIGHT
	 * @final
	 * @type {String}
	 * @default 'down' 'left' 'up' 'right'
	 */
	var DIRECTION_DOWN = Hammer.DIRECTION_DOWN = 'down';
	var DIRECTION_LEFT = Hammer.DIRECTION_LEFT = 'left';
	var DIRECTION_UP = Hammer.DIRECTION_UP = 'up';
	var DIRECTION_RIGHT = Hammer.DIRECTION_RIGHT = 'right';
	
	/**
	 * pointertype strings, for safe comparisons
	 * @property POINTER_MOUSE|TOUCH|PEN
	 * @final
	 * @type {String}
	 * @default 'mouse' 'touch' 'pen'
	 */
	var POINTER_MOUSE = Hammer.POINTER_MOUSE = 'mouse';
	var POINTER_TOUCH = Hammer.POINTER_TOUCH = 'touch';
	var POINTER_PEN = Hammer.POINTER_PEN = 'pen';
	
	/**
	 * eventtypes
	 * @property EVENT_START|MOVE|END|RELEASE|TOUCH
	 * @final
	 * @type {String}
	 * @default 'start' 'change' 'move' 'end' 'release' 'touch'
	 */
	var EVENT_START = Hammer.EVENT_START = 'start';
	var EVENT_MOVE = Hammer.EVENT_MOVE = 'move';
	var EVENT_END = Hammer.EVENT_END = 'end';
	var EVENT_RELEASE = Hammer.EVENT_RELEASE = 'release';
	var EVENT_TOUCH = Hammer.EVENT_TOUCH = 'touch';
	
	/**
	 * if the window events are set...
	 * @property READY
	 * @writeOnce
	 * @type {Boolean}
	 * @default false
	 */
	Hammer.READY = false;
	
	/**
	 * plugins namespace
	 * @property plugins
	 * @type {Object}
	 */
	Hammer.plugins = Hammer.plugins || {};
	
	/**
	 * gestures namespace
	 * see `/gestures` for the definitions
	 * @property gestures
	 * @type {Object}
	 */
	Hammer.gestures = Hammer.gestures || {};
	
	/**
	 * setup events to detect gestures on the document
	 * this function is called when creating an new instance
	 * @private
	 */
	function setup() {
	    if(Hammer.READY) {
	        return;
	    }
	
	    // find what eventtypes we add listeners to
	    Event.determineEventTypes();
	
	    // Register all gestures inside Hammer.gestures
	    Utils.each(Hammer.gestures, function(gesture) {
	        Detection.register(gesture);
	    });
	
	    // Add touch events on the document
	    Event.onTouch(Hammer.DOCUMENT, EVENT_MOVE, Detection.detect);
	    Event.onTouch(Hammer.DOCUMENT, EVENT_END, Detection.detect);
	
	    // Hammer is ready...!
	    Hammer.READY = true;
	}
	
	/**
	 * @module hammer
	 *
	 * @class Utils
	 * @static
	 */
	var Utils = Hammer.utils = {
	    /**
	     * extend method, could also be used for cloning when `dest` is an empty object.
	     * changes the dest object
	     * @method extend
	     * @param {Object} dest
	     * @param {Object} src
	     * @param {Boolean} [merge=false]  do a merge
	     * @return {Object} dest
	     */
	    extend: function extend(dest, src, merge) {
	        for(var key in src) {
	            if(!src.hasOwnProperty(key) || (dest[key] !== undefined && merge)) {
	                continue;
	            }
	            dest[key] = src[key];
	        }
	        return dest;
	    },
	
	    /**
	     * simple addEventListener wrapper
	     * @method on
	     * @param {HTMLElement} element
	     * @param {String} type
	     * @param {Function} handler
	     */
	    on: function on(element, type, handler) {
	        element.addEventListener(type, handler, false);
	    },
	
	    /**
	     * simple removeEventListener wrapper
	     * @method off
	     * @param {HTMLElement} element
	     * @param {String} type
	     * @param {Function} handler
	     */
	    off: function off(element, type, handler) {
	        element.removeEventListener(type, handler, false);
	    },
	
	    /**
	     * forEach over arrays and objects
	     * @method each
	     * @param {Object|Array} obj
	     * @param {Function} iterator
	     * @param {any} iterator.item
	     * @param {Number} iterator.index
	     * @param {Object|Array} iterator.obj the source object
	     * @param {Object} context value to use as `this` in the iterator
	     */
	    each: function each(obj, iterator, context) {
	        var i, len;
	
	        // native forEach on arrays
	        if('forEach' in obj) {
	            obj.forEach(iterator, context);
	        // arrays
	        } else if(obj.length !== undefined) {
	            for(i = 0, len = obj.length; i < len; i++) {
	                if(iterator.call(context, obj[i], i, obj) === false) {
	                    return;
	                }
	            }
	        // objects
	        } else {
	            for(i in obj) {
	                if(obj.hasOwnProperty(i) &&
	                    iterator.call(context, obj[i], i, obj) === false) {
	                    return;
	                }
	            }
	        }
	    },
	
	    /**
	     * find if a string contains the string using indexOf
	     * @method inStr
	     * @param {String} src
	     * @param {String} find
	     * @return {Boolean} found
	     */
	    inStr: function inStr(src, find) {
	        return src.indexOf(find) > -1;
	    },
	
	    /**
	     * find if a array contains the object using indexOf or a simple polyfill
	     * @method inArray
	     * @param {String} src
	     * @param {String} find
	     * @return {Boolean|Number} false when not found, or the index
	     */
	    inArray: function inArray(src, find) {
	        if(src.indexOf) {
	            var index = src.indexOf(find);
	            return (index === -1) ? false : index;
	        } else {
	            for(var i = 0, len = src.length; i < len; i++) {
	                if(src[i] === find) {
	                    return i;
	                }
	            }
	            return false;
	        }
	    },
	
	    /**
	     * convert an array-like object (`arguments`, `touchlist`) to an array
	     * @method toArray
	     * @param {Object} obj
	     * @return {Array}
	     */
	    toArray: function toArray(obj) {
	        return Array.prototype.slice.call(obj, 0);
	    },
	
	    /**
	     * find if a node is in the given parent
	     * @method hasParent
	     * @param {HTMLElement} node
	     * @param {HTMLElement} parent
	     * @return {Boolean} found
	     */
	    hasParent: function hasParent(node, parent) {
	        while(node) {
	            if(node == parent) {
	                return true;
	            }
	            node = node.parentNode;
	        }
	        return false;
	    },
	
	    /**
	     * get the center of all the touches
	     * @method getCenter
	     * @param {Array} touches
	     * @return {Object} center contains `pageX`, `pageY`, `clientX` and `clientY` properties
	     */
	    getCenter: function getCenter(touches) {
	        var pageX = [],
	            pageY = [],
	            clientX = [],
	            clientY = [],
	            min = Math.min,
	            max = Math.max;
	
	        // no need to loop when only one touch
	        if(touches.length === 1) {
	            return {
	                pageX: touches[0].pageX,
	                pageY: touches[0].pageY,
	                clientX: touches[0].clientX,
	                clientY: touches[0].clientY
	            };
	        }
	
	        Utils.each(touches, function(touch) {
	            pageX.push(touch.pageX);
	            pageY.push(touch.pageY);
	            clientX.push(touch.clientX);
	            clientY.push(touch.clientY);
	        });
	
	        return {
	            pageX: (min.apply(Math, pageX) + max.apply(Math, pageX)) / 2,
	            pageY: (min.apply(Math, pageY) + max.apply(Math, pageY)) / 2,
	            clientX: (min.apply(Math, clientX) + max.apply(Math, clientX)) / 2,
	            clientY: (min.apply(Math, clientY) + max.apply(Math, clientY)) / 2
	        };
	    },
	
	    /**
	     * calculate the velocity between two points. unit is in px per ms.
	     * @method getVelocity
	     * @param {Number} deltaTime
	     * @param {Number} deltaX
	     * @param {Number} deltaY
	     * @return {Object} velocity `x` and `y`
	     */
	    getVelocity: function getVelocity(deltaTime, deltaX, deltaY) {
	        return {
	            x: Math.abs(deltaX / deltaTime) || 0,
	            y: Math.abs(deltaY / deltaTime) || 0
	        };
	    },
	
	    /**
	     * calculate the angle between two coordinates
	     * @method getAngle
	     * @param {Touch} touch1
	     * @param {Touch} touch2
	     * @return {Number} angle
	     */
	    getAngle: function getAngle(touch1, touch2) {
	        var x = touch2.clientX - touch1.clientX,
	            y = touch2.clientY - touch1.clientY;
	
	        return Math.atan2(y, x) * 180 / Math.PI;
	    },
	
	    /**
	     * do a small comparision to get the direction between two touches.
	     * @method getDirection
	     * @param {Touch} touch1
	     * @param {Touch} touch2
	     * @return {String} direction matches `DIRECTION_LEFT|RIGHT|UP|DOWN`
	     */
	    getDirection: function getDirection(touch1, touch2) {
	        var x = Math.abs(touch1.clientX - touch2.clientX),
	            y = Math.abs(touch1.clientY - touch2.clientY);
	
	        if(x >= y) {
	            return touch1.clientX - touch2.clientX > 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
	        }
	        return touch1.clientY - touch2.clientY > 0 ? DIRECTION_UP : DIRECTION_DOWN;
	    },
	
	    /**
	     * calculate the distance between two touches
	     * @method getDistance
	     * @param {Touch}touch1
	     * @param {Touch} touch2
	     * @return {Number} distance
	     */
	    getDistance: function getDistance(touch1, touch2) {
	        var x = touch2.clientX - touch1.clientX,
	            y = touch2.clientY - touch1.clientY;
	
	        return Math.sqrt((x * x) + (y * y));
	    },
	
	    /**
	     * calculate the scale factor between two touchLists
	     * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
	     * @method getScale
	     * @param {Array} start array of touches
	     * @param {Array} end array of touches
	     * @return {Number} scale
	     */
	    getScale: function getScale(start, end) {
	        // need two fingers...
	        if(start.length >= 2 && end.length >= 2) {
	            return this.getDistance(end[0], end[1]) / this.getDistance(start[0], start[1]);
	        }
	        return 1;
	    },
	
	    /**
	     * calculate the rotation degrees between two touchLists
	     * @method getRotation
	     * @param {Array} start array of touches
	     * @param {Array} end array of touches
	     * @return {Number} rotation
	     */
	    getRotation: function getRotation(start, end) {
	        // need two fingers
	        if(start.length >= 2 && end.length >= 2) {
	            return this.getAngle(end[1], end[0]) - this.getAngle(start[1], start[0]);
	        }
	        return 0;
	    },
	
	    /**
	     * find out if the direction is vertical   *
	     * @method isVertical
	     * @param {String} direction matches `DIRECTION_UP|DOWN`
	     * @return {Boolean} is_vertical
	     */
	    isVertical: function isVertical(direction) {
	        return direction == DIRECTION_UP || direction == DIRECTION_DOWN;
	    },
	
	    /**
	     * set css properties with their prefixes
	     * @param {HTMLElement} element
	     * @param {String} prop
	     * @param {String} value
	     * @param {Boolean} [toggle=true]
	     * @return {Boolean}
	     */
	    setPrefixedCss: function setPrefixedCss(element, prop, value, toggle) {
	        var prefixes = ['', 'Webkit', 'Moz', 'O', 'ms'];
	        prop = Utils.toCamelCase(prop);
	
	        for(var i = 0; i < prefixes.length; i++) {
	            var p = prop;
	            // prefixes
	            if(prefixes[i]) {
	                p = prefixes[i] + p.slice(0, 1).toUpperCase() + p.slice(1);
	            }
	
	            // test the style
	            if(p in element.style) {
	                element.style[p] = (toggle == null || toggle) && value || '';
	                break;
	            }
	        }
	    },
	
	    /**
	     * toggle browser default behavior by setting css properties.
	     * `userSelect='none'` also sets `element.onselectstart` to false
	     * `userDrag='none'` also sets `element.ondragstart` to false
	     *
	     * @method toggleBehavior
	     * @param {HtmlElement} element
	     * @param {Object} props
	     * @param {Boolean} [toggle=true]
	     */
	    toggleBehavior: function toggleBehavior(element, props, toggle) {
	        if(!props || !element || !element.style) {
	            return;
	        }
	
	        // set the css properties
	        Utils.each(props, function(value, prop) {
	            Utils.setPrefixedCss(element, prop, value, toggle);
	        });
	
	        var falseFn = toggle && function() {
	            return false;
	        };
	
	        // also the disable onselectstart
	        if(props.userSelect == 'none') {
	            element.onselectstart = falseFn;
	        }
	        // and disable ondragstart
	        if(props.userDrag == 'none') {
	            element.ondragstart = falseFn;
	        }
	    },
	
	    /**
	     * convert a string with underscores to camelCase
	     * so prevent_default becomes preventDefault
	     * @param {String} str
	     * @return {String} camelCaseStr
	     */
	    toCamelCase: function toCamelCase(str) {
	        return str.replace(/[_-]([a-z])/g, function(s) {
	            return s[1].toUpperCase();
	        });
	    }
	};
	
	
	/**
	 * @module hammer
	 */
	/**
	 * @class Event
	 * @static
	 */
	var Event = Hammer.event = {
	    /**
	     * when touch events have been fired, this is true
	     * this is used to stop mouse events
	     * @property prevent_mouseevents
	     * @private
	     * @type {Boolean}
	     */
	    preventMouseEvents: false,
	
	    /**
	     * if EVENT_START has been fired
	     * @property started
	     * @private
	     * @type {Boolean}
	     */
	    started: false,
	
	    /**
	     * when the mouse is hold down, this is true
	     * @property should_detect
	     * @private
	     * @type {Boolean}
	     */
	    shouldDetect: false,
	
	    /**
	     * simple event binder with a hook and support for multiple types
	     * @method on
	     * @param {HTMLElement} element
	     * @param {String} type
	     * @param {Function} handler
	     * @param {Function} [hook]
	     * @param {Object} hook.type
	     */
	    on: function on(element, type, handler, hook) {
	        var types = type.split(' ');
	        Utils.each(types, function(type) {
	            Utils.on(element, type, handler);
	            hook && hook(type);
	        });
	    },
	
	    /**
	     * simple event unbinder with a hook and support for multiple types
	     * @method off
	     * @param {HTMLElement} element
	     * @param {String} type
	     * @param {Function} handler
	     * @param {Function} [hook]
	     * @param {Object} hook.type
	     */
	    off: function off(element, type, handler, hook) {
	        var types = type.split(' ');
	        Utils.each(types, function(type) {
	            Utils.off(element, type, handler);
	            hook && hook(type);
	        });
	    },
	
	    /**
	     * the core touch event handler.
	     * this finds out if we should to detect gestures
	     * @method onTouch
	     * @param {HTMLElement} element
	     * @param {String} eventType matches `EVENT_START|MOVE|END`
	     * @param {Function} handler
	     * @return onTouchHandler {Function} the core event handler
	     */
	    onTouch: function onTouch(element, eventType, handler) {
	        var self = this;
	
	        var onTouchHandler = function onTouchHandler(ev) {
	            var srcType = ev.type.toLowerCase(),
	                isPointer = Hammer.HAS_POINTEREVENTS,
	                isMouse = Utils.inStr(srcType, 'mouse'),
	                triggerType;
	
	            // if we are in a mouseevent, but there has been a touchevent triggered in this session
	            // we want to do nothing. simply break out of the event.
	            if(isMouse && self.preventMouseEvents) {
	                return;
	
	            // mousebutton must be down
	            } else if(isMouse && eventType == EVENT_START && ev.button === 0) {
	                self.preventMouseEvents = false;
	                self.shouldDetect = true;
	            } else if(isPointer && eventType == EVENT_START) {
	                self.shouldDetect = (ev.buttons === 1 || PointerEvent.matchType(POINTER_TOUCH, ev));
	            // just a valid start event, but no mouse
	            } else if(!isMouse && eventType == EVENT_START) {
	                self.preventMouseEvents = true;
	                self.shouldDetect = true;
	            }
	
	            // update the pointer event before entering the detection
	            if(isPointer && eventType != EVENT_END) {
	                PointerEvent.updatePointer(eventType, ev);
	            }
	
	            // we are in a touch/down state, so allowed detection of gestures
	            if(self.shouldDetect) {
	                triggerType = self.doDetect.call(self, ev, eventType, element, handler);
	            }
	
	            // ...and we are done with the detection
	            // so reset everything to start each detection totally fresh
	            if(triggerType == EVENT_END) {
	                self.preventMouseEvents = false;
	                self.shouldDetect = false;
	                PointerEvent.reset();
	            // update the pointerevent object after the detection
	            }
	
	            if(isPointer && eventType == EVENT_END) {
	                PointerEvent.updatePointer(eventType, ev);
	            }
	        };
	
	        this.on(element, EVENT_TYPES[eventType], onTouchHandler);
	        return onTouchHandler;
	    },
	
	    /**
	     * the core detection method
	     * this finds out what hammer-touch-events to trigger
	     * @method doDetect
	     * @param {Object} ev
	     * @param {String} eventType matches `EVENT_START|MOVE|END`
	     * @param {HTMLElement} element
	     * @param {Function} handler
	     * @return {String} triggerType matches `EVENT_START|MOVE|END`
	     */
	    doDetect: function doDetect(ev, eventType, element, handler) {
	        var touchList = this.getTouchList(ev, eventType);
	        var touchListLength = touchList.length;
	        var triggerType = eventType;
	        var triggerChange = touchList.trigger; // used by fakeMultitouch plugin
	        var changedLength = touchListLength;
	
	        // at each touchstart-like event we want also want to trigger a TOUCH event...
	        if(eventType == EVENT_START) {
	            triggerChange = EVENT_TOUCH;
	        // ...the same for a touchend-like event
	        } else if(eventType == EVENT_END) {
	            triggerChange = EVENT_RELEASE;
	
	            // keep track of how many touches have been removed
	            changedLength = touchList.length - ((ev.changedTouches) ? ev.changedTouches.length : 1);
	        }
	
	        // after there are still touches on the screen,
	        // we just want to trigger a MOVE event. so change the START or END to a MOVE
	        // but only after detection has been started, the first time we actualy want a START
	        if(changedLength > 0 && this.started) {
	            triggerType = EVENT_MOVE;
	        }
	
	        // detection has been started, we keep track of this, see above
	        this.started = true;
	
	        // generate some event data, some basic information
	        var evData = this.collectEventData(element, triggerType, touchList, ev);
	
	        // trigger the triggerType event before the change (TOUCH, RELEASE) events
	        // but the END event should be at last
	        if(eventType != EVENT_END) {
	            handler.call(Detection, evData);
	        }
	
	        // trigger a change (TOUCH, RELEASE) event, this means the length of the touches changed
	        if(triggerChange) {
	            evData.changedLength = changedLength;
	            evData.eventType = triggerChange;
	
	            handler.call(Detection, evData);
	
	            evData.eventType = triggerType;
	            delete evData.changedLength;
	        }
	
	        // trigger the END event
	        if(triggerType == EVENT_END) {
	            handler.call(Detection, evData);
	
	            // ...and we are done with the detection
	            // so reset everything to start each detection totally fresh
	            this.started = false;
	        }
	
	        return triggerType;
	    },
	
	    /**
	     * we have different events for each device/browser
	     * determine what we need and set them in the EVENT_TYPES constant
	     * the `onTouch` method is bind to these properties.
	     * @method determineEventTypes
	     * @return {Object} events
	     */
	    determineEventTypes: function determineEventTypes() {
	        var types;
	        if(Hammer.HAS_POINTEREVENTS) {
	            if(window.PointerEvent) {
	                types = [
	                    'pointerdown',
	                    'pointermove',
	                    'pointerup pointercancel lostpointercapture'
	                ];
	            } else {
	                types = [
	                    'MSPointerDown',
	                    'MSPointerMove',
	                    'MSPointerUp MSPointerCancel MSLostPointerCapture'
	                ];
	            }
	        } else if(Hammer.NO_MOUSEEVENTS) {
	            types = [
	                'touchstart',
	                'touchmove',
	                'touchend touchcancel'
	            ];
	        } else {
	            types = [
	                'touchstart mousedown',
	                'touchmove mousemove',
	                'touchend touchcancel mouseup'
	            ];
	        }
	
	        EVENT_TYPES[EVENT_START] = types[0];
	        EVENT_TYPES[EVENT_MOVE] = types[1];
	        EVENT_TYPES[EVENT_END] = types[2];
	        return EVENT_TYPES;
	    },
	
	    /**
	     * create touchList depending on the event
	     * @method getTouchList
	     * @param {Object} ev
	     * @param {String} eventType
	     * @return {Array} touches
	     */
	    getTouchList: function getTouchList(ev, eventType) {
	        // get the fake pointerEvent touchlist
	        if(Hammer.HAS_POINTEREVENTS) {
	            return PointerEvent.getTouchList();
	        }
	
	        // get the touchlist
	        if(ev.touches) {
	            if(eventType == EVENT_MOVE) {
	                return ev.touches;
	            }
	
	            var identifiers = [];
	            var concat = [].concat(Utils.toArray(ev.touches), Utils.toArray(ev.changedTouches));
	            var touchList = [];
	
	            Utils.each(concat, function(touch) {
	                if(Utils.inArray(identifiers, touch.identifier) === false) {
	                    touchList.push(touch);
	                }
	                identifiers.push(touch.identifier);
	            });
	
	            return touchList;
	        }
	
	        // make fake touchList from mouse position
	        ev.identifier = 1;
	        return [ev];
	    },
	
	    /**
	     * collect basic event data
	     * @method collectEventData
	     * @param {HTMLElement} element
	     * @param {String} eventType matches `EVENT_START|MOVE|END`
	     * @param {Array} touches
	     * @param {Object} ev
	     * @return {Object} ev
	     */
	    collectEventData: function collectEventData(element, eventType, touches, ev) {
	        // find out pointerType
	        var pointerType = POINTER_TOUCH;
	        if(Utils.inStr(ev.type, 'mouse') || PointerEvent.matchType(POINTER_MOUSE, ev)) {
	            pointerType = POINTER_MOUSE;
	        } else if(PointerEvent.matchType(POINTER_PEN, ev)) {
	            pointerType = POINTER_PEN;
	        }
	
	        return {
	            center: Utils.getCenter(touches),
	            timeStamp: Date.now(),
	            target: ev.target,
	            touches: touches,
	            eventType: eventType,
	            pointerType: pointerType,
	            srcEvent: ev,
	
	            /**
	             * prevent the browser default actions
	             * mostly used to disable scrolling of the browser
	             */
	            preventDefault: function() {
	                var srcEvent = this.srcEvent;
	                srcEvent.preventManipulation && srcEvent.preventManipulation();
	                srcEvent.preventDefault && srcEvent.preventDefault();
	            },
	
	            /**
	             * stop bubbling the event up to its parents
	             */
	            stopPropagation: function() {
	                this.srcEvent.stopPropagation();
	            },
	
	            /**
	             * immediately stop gesture detection
	             * might be useful after a swipe was detected
	             * @return {*}
	             */
	            stopDetect: function() {
	                return Detection.stopDetect();
	            }
	        };
	    }
	};
	
	
	/**
	 * @module hammer
	 *
	 * @class PointerEvent
	 * @static
	 */
	var PointerEvent = Hammer.PointerEvent = {
	    /**
	     * holds all pointers, by `identifier`
	     * @property pointers
	     * @type {Object}
	     */
	    pointers: {},
	
	    /**
	     * get the pointers as an array
	     * @method getTouchList
	     * @return {Array} touchlist
	     */
	    getTouchList: function getTouchList() {
	        var touchlist = [];
	        // we can use forEach since pointerEvents only is in IE10
	        Utils.each(this.pointers, function(pointer) {
	            touchlist.push(pointer);
	        });
	        return touchlist;
	    },
	
	    /**
	     * update the position of a pointer
	     * @method updatePointer
	     * @param {String} eventType matches `EVENT_START|MOVE|END`
	     * @param {Object} pointerEvent
	     */
	    updatePointer: function updatePointer(eventType, pointerEvent) {
	        if(eventType == EVENT_END || (eventType != EVENT_END && pointerEvent.buttons !== 1)) {
	            delete this.pointers[pointerEvent.pointerId];
	        } else {
	            pointerEvent.identifier = pointerEvent.pointerId;
	            this.pointers[pointerEvent.pointerId] = pointerEvent;
	        }
	    },
	
	    /**
	     * check if ev matches pointertype
	     * @method matchType
	     * @param {String} pointerType matches `POINTER_MOUSE|TOUCH|PEN`
	     * @param {PointerEvent} ev
	     */
	    matchType: function matchType(pointerType, ev) {
	        if(!ev.pointerType) {
	            return false;
	        }
	
	        var pt = ev.pointerType,
	            types = {};
	
	        types[POINTER_MOUSE] = (pt === (ev.MSPOINTER_TYPE_MOUSE || POINTER_MOUSE));
	        types[POINTER_TOUCH] = (pt === (ev.MSPOINTER_TYPE_TOUCH || POINTER_TOUCH));
	        types[POINTER_PEN] = (pt === (ev.MSPOINTER_TYPE_PEN || POINTER_PEN));
	        return types[pointerType];
	    },
	
	    /**
	     * reset the stored pointers
	     * @method reset
	     */
	    reset: function resetList() {
	        this.pointers = {};
	    }
	};
	
	
	/**
	 * @module hammer
	 *
	 * @class Detection
	 * @static
	 */
	var Detection = Hammer.detection = {
	    // contains all registred Hammer.gestures in the correct order
	    gestures: [],
	
	    // data of the current Hammer.gesture detection session
	    current: null,
	
	    // the previous Hammer.gesture session data
	    // is a full clone of the previous gesture.current object
	    previous: null,
	
	    // when this becomes true, no gestures are fired
	    stopped: false,
	
	    /**
	     * start Hammer.gesture detection
	     * @method startDetect
	     * @param {Hammer.Instance} inst
	     * @param {Object} eventData
	     */
	    startDetect: function startDetect(inst, eventData) {
	        // already busy with a Hammer.gesture detection on an element
	        if(this.current) {
	            return;
	        }
	
	        this.stopped = false;
	
	        // holds current session
	        this.current = {
	            inst: inst, // reference to HammerInstance we're working for
	            startEvent: Utils.extend({}, eventData), // start eventData for distances, timing etc
	            lastEvent: false, // last eventData
	            lastCalcEvent: false, // last eventData for calculations.
	            futureCalcEvent: false, // last eventData for calculations.
	            lastCalcData: {}, // last lastCalcData
	            name: '' // current gesture we're in/detected, can be 'tap', 'hold' etc
	        };
	
	        this.detect(eventData);
	    },
	
	    /**
	     * Hammer.gesture detection
	     * @method detect
	     * @param {Object} eventData
	     * @return {any}
	     */
	    detect: function detect(eventData) {
	        if(!this.current || this.stopped) {
	            return;
	        }
	
	        // extend event data with calculations about scale, distance etc
	        eventData = this.extendEventData(eventData);
	
	        // hammer instance and instance options
	        var inst = this.current.inst,
	            instOptions = inst.options;
	
	        // call Hammer.gesture handlers
	        Utils.each(this.gestures, function triggerGesture(gesture) {
	            // only when the instance options have enabled this gesture
	            if(!this.stopped && inst.enabled && instOptions[gesture.name]) {
	                gesture.handler.call(gesture, eventData, inst);
	            }
	        }, this);
	
	        // store as previous event event
	        if(this.current) {
	            this.current.lastEvent = eventData;
	        }
	
	        if(eventData.eventType == EVENT_END) {
	            this.stopDetect();
	        }
	
	        return eventData;
	    },
	
	    /**
	     * clear the Hammer.gesture vars
	     * this is called on endDetect, but can also be used when a final Hammer.gesture has been detected
	     * to stop other Hammer.gestures from being fired
	     * @method stopDetect
	     */
	    stopDetect: function stopDetect() {
	        // clone current data to the store as the previous gesture
	        // used for the double tap gesture, since this is an other gesture detect session
	        this.previous = Utils.extend({}, this.current);
	
	        // reset the current
	        this.current = null;
	        this.stopped = true;
	    },
	
	    /**
	     * calculate velocity, angle and direction
	     * @method getVelocityData
	     * @param {Object} ev
	     * @param {Object} center
	     * @param {Number} deltaTime
	     * @param {Number} deltaX
	     * @param {Number} deltaY
	     */
	    getCalculatedData: function getCalculatedData(ev, center, deltaTime, deltaX, deltaY) {
	        var cur = this.current,
	            recalc = false,
	            calcEv = cur.lastCalcEvent,
	            calcData = cur.lastCalcData;
	
	        if(calcEv && ev.timeStamp - calcEv.timeStamp > Hammer.CALCULATE_INTERVAL) {
	            center = calcEv.center;
	            deltaTime = ev.timeStamp - calcEv.timeStamp;
	            deltaX = ev.center.clientX - calcEv.center.clientX;
	            deltaY = ev.center.clientY - calcEv.center.clientY;
	            recalc = true;
	        }
	
	        if(ev.eventType == EVENT_TOUCH || ev.eventType == EVENT_RELEASE) {
	            cur.futureCalcEvent = ev;
	        }
	
	        if(!cur.lastCalcEvent || recalc) {
	            calcData.velocity = Utils.getVelocity(deltaTime, deltaX, deltaY);
	            calcData.angle = Utils.getAngle(center, ev.center);
	            calcData.direction = Utils.getDirection(center, ev.center);
	
	            cur.lastCalcEvent = cur.futureCalcEvent || ev;
	            cur.futureCalcEvent = ev;
	        }
	
	        ev.velocityX = calcData.velocity.x;
	        ev.velocityY = calcData.velocity.y;
	        ev.interimAngle = calcData.angle;
	        ev.interimDirection = calcData.direction;
	    },
	
	    /**
	     * extend eventData for Hammer.gestures
	     * @method extendEventData
	     * @param {Object} ev
	     * @return {Object} ev
	     */
	    extendEventData: function extendEventData(ev) {
	        var cur = this.current,
	            startEv = cur.startEvent,
	            lastEv = cur.lastEvent || startEv;
	
	        // update the start touchlist to calculate the scale/rotation
	        if(ev.eventType == EVENT_TOUCH || ev.eventType == EVENT_RELEASE) {
	            startEv.touches = [];
	            Utils.each(ev.touches, function(touch) {
	                startEv.touches.push({
	                    clientX: touch.clientX,
	                    clientY: touch.clientY
	                });
	            });
	        }
	
	        var deltaTime = ev.timeStamp - startEv.timeStamp,
	            deltaX = ev.center.clientX - startEv.center.clientX,
	            deltaY = ev.center.clientY - startEv.center.clientY;
	
	        this.getCalculatedData(ev, lastEv.center, deltaTime, deltaX, deltaY);
	
	        Utils.extend(ev, {
	            startEvent: startEv,
	
	            deltaTime: deltaTime,
	            deltaX: deltaX,
	            deltaY: deltaY,
	
	            distance: Utils.getDistance(startEv.center, ev.center),
	            angle: Utils.getAngle(startEv.center, ev.center),
	            direction: Utils.getDirection(startEv.center, ev.center),
	            scale: Utils.getScale(startEv.touches, ev.touches),
	            rotation: Utils.getRotation(startEv.touches, ev.touches)
	        });
	
	        return ev;
	    },
	
	    /**
	     * register new gesture
	     * @method register
	     * @param {Object} gesture object, see `gestures/` for documentation
	     * @return {Array} gestures
	     */
	    register: function register(gesture) {
	        // add an enable gesture options if there is no given
	        var options = gesture.defaults || {};
	        if(options[gesture.name] === undefined) {
	            options[gesture.name] = true;
	        }
	
	        // extend Hammer default options with the Hammer.gesture options
	        Utils.extend(Hammer.defaults, options, true);
	
	        // set its index
	        gesture.index = gesture.index || 1000;
	
	        // add Hammer.gesture to the list
	        this.gestures.push(gesture);
	
	        // sort the list by index
	        this.gestures.sort(function(a, b) {
	            if(a.index < b.index) {
	                return -1;
	            }
	            if(a.index > b.index) {
	                return 1;
	            }
	            return 0;
	        });
	
	        return this.gestures;
	    }
	};
	
	
	/**
	 * @module hammer
	 */
	
	/**
	 * create new hammer instance
	 * all methods should return the instance itself, so it is chainable.
	 *
	 * @class Instance
	 * @constructor
	 * @param {HTMLElement} element
	 * @param {Object} [options={}] options are merged with `Hammer.defaults`
	 * @return {Hammer.Instance}
	 */
	Hammer.Instance = function(element, options) {
	    var self = this;
	
	    // setup HammerJS window events and register all gestures
	    // this also sets up the default options
	    setup();
	
	    /**
	     * @property element
	     * @type {HTMLElement}
	     */
	    this.element = element;
	
	    /**
	     * @property enabled
	     * @type {Boolean}
	     * @protected
	     */
	    this.enabled = true;
	
	    /**
	     * options, merged with the defaults
	     * options with an _ are converted to camelCase
	     * @property options
	     * @type {Object}
	     */
	    Utils.each(options, function(value, name) {
	        delete options[name];
	        options[Utils.toCamelCase(name)] = value;
	    });
	
	    this.options = Utils.extend(Utils.extend({}, Hammer.defaults), options || {});
	
	    // add some css to the element to prevent the browser from doing its native behavoir
	    if(this.options.behavior) {
	        Utils.toggleBehavior(this.element, this.options.behavior, true);
	    }
	
	    /**
	     * event start handler on the element to start the detection
	     * @property eventStartHandler
	     * @type {Object}
	     */
	    this.eventStartHandler = Event.onTouch(element, EVENT_START, function(ev) {
	        if(self.enabled && ev.eventType == EVENT_START) {
	            Detection.startDetect(self, ev);
	        } else if(ev.eventType == EVENT_TOUCH) {
	            Detection.detect(ev);
	        }
	    });
	
	    /**
	     * keep a list of user event handlers which needs to be removed when calling 'dispose'
	     * @property eventHandlers
	     * @type {Array}
	     */
	    this.eventHandlers = [];
	};
	
	Hammer.Instance.prototype = {
	    /**
	     * bind events to the instance
	     * @method on
	     * @chainable
	     * @param {String} gestures multiple gestures by splitting with a space
	     * @param {Function} handler
	     * @param {Object} handler.ev event object
	     */
	    on: function onEvent(gestures, handler) {
	        var self = this;
	        Event.on(self.element, gestures, handler, function(type) {
	            self.eventHandlers.push({ gesture: type, handler: handler });
	        });
	        return self;
	    },
	
	    /**
	     * unbind events to the instance
	     * @method off
	     * @chainable
	     * @param {String} gestures
	     * @param {Function} handler
	     */
	    off: function offEvent(gestures, handler) {
	        var self = this;
	
	        Event.off(self.element, gestures, handler, function(type) {
	            var index = Utils.inArray({ gesture: type, handler: handler });
	            if(index !== false) {
	                self.eventHandlers.splice(index, 1);
	            }
	        });
	        return self;
	    },
	
	    /**
	     * trigger gesture event
	     * @method trigger
	     * @chainable
	     * @param {String} gesture
	     * @param {Object} [eventData]
	     */
	    trigger: function triggerEvent(gesture, eventData) {
	        // optional
	        if(!eventData) {
	            eventData = {};
	        }
	
	        // create DOM event
	        var event = Hammer.DOCUMENT.createEvent('Event');
	        event.initEvent(gesture, true, true);
	        event.gesture = eventData;
	
	        // trigger on the target if it is in the instance element,
	        // this is for event delegation tricks
	        var element = this.element;
	        if(Utils.hasParent(eventData.target, element)) {
	            element = eventData.target;
	        }
	
	        element.dispatchEvent(event);
	        return this;
	    },
	
	    /**
	     * enable of disable hammer.js detection
	     * @method enable
	     * @chainable
	     * @param {Boolean} state
	     */
	    enable: function enable(state) {
	        this.enabled = state;
	        return this;
	    },
	
	    /**
	     * dispose this hammer instance
	     * @method dispose
	     * @return {Null}
	     */
	    dispose: function dispose() {
	        var i, eh;
	
	        // undo all changes made by stop_browser_behavior
	        Utils.toggleBehavior(this.element, this.options.behavior, false);
	
	        // unbind all custom event handlers
	        for(i = -1; (eh = this.eventHandlers[++i]);) {
	            Utils.off(this.element, eh.gesture, eh.handler);
	        }
	
	        this.eventHandlers = [];
	
	        // unbind the start event listener
	        Event.off(this.element, EVENT_TYPES[EVENT_START], this.eventStartHandler);
	
	        return null;
	    }
	};
	
	
	/**
	 * @module gestures
	 */
	/**
	 * Move with x fingers (default 1) around on the page.
	 * Preventing the default browser behavior is a good way to improve feel and working.
	 * ````
	 *  hammertime.on("drag", function(ev) {
	 *    console.log(ev);
	 *    ev.gesture.preventDefault();
	 *  });
	 * ````
	 *
	 * @class Drag
	 * @static
	 */
	/**
	 * @event drag
	 * @param {Object} ev
	 */
	/**
	 * @event dragstart
	 * @param {Object} ev
	 */
	/**
	 * @event dragend
	 * @param {Object} ev
	 */
	/**
	 * @event drapleft
	 * @param {Object} ev
	 */
	/**
	 * @event dragright
	 * @param {Object} ev
	 */
	/**
	 * @event dragup
	 * @param {Object} ev
	 */
	/**
	 * @event dragdown
	 * @param {Object} ev
	 */
	
	/**
	 * @param {String} name
	 */
	(function(name) {
	    var triggered = false;
	
	    function dragGesture(ev, inst) {
	        var cur = Detection.current;
	
	        // max touches
	        if(inst.options.dragMaxTouches > 0 &&
	            ev.touches.length > inst.options.dragMaxTouches) {
	            return;
	        }
	
	        switch(ev.eventType) {
	            case EVENT_START:
	                triggered = false;
	                break;
	
	            case EVENT_MOVE:
	                // when the distance we moved is too small we skip this gesture
	                // or we can be already in dragging
	                if(ev.distance < inst.options.dragMinDistance &&
	                    cur.name != name) {
	                    return;
	                }
	
	                var startCenter = cur.startEvent.center;
	
	                // we are dragging!
	                if(cur.name != name) {
	                    cur.name = name;
	                    if(inst.options.dragDistanceCorrection && ev.distance > 0) {
	                        // When a drag is triggered, set the event center to dragMinDistance pixels from the original event center.
	                        // Without this correction, the dragged distance would jumpstart at dragMinDistance pixels instead of at 0.
	                        // It might be useful to save the original start point somewhere
	                        var factor = Math.abs(inst.options.dragMinDistance / ev.distance);
	                        startCenter.pageX += ev.deltaX * factor;
	                        startCenter.pageY += ev.deltaY * factor;
	                        startCenter.clientX += ev.deltaX * factor;
	                        startCenter.clientY += ev.deltaY * factor;
	
	                        // recalculate event data using new start point
	                        ev = Detection.extendEventData(ev);
	                    }
	                }
	
	                // lock drag to axis?
	                if(cur.lastEvent.dragLockToAxis ||
	                    ( inst.options.dragLockToAxis &&
	                        inst.options.dragLockMinDistance <= ev.distance
	                        )) {
	                    ev.dragLockToAxis = true;
	                }
	
	                // keep direction on the axis that the drag gesture started on
	                var lastDirection = cur.lastEvent.direction;
	                if(ev.dragLockToAxis && lastDirection !== ev.direction) {
	                    if(Utils.isVertical(lastDirection)) {
	                        ev.direction = (ev.deltaY < 0) ? DIRECTION_UP : DIRECTION_DOWN;
	                    } else {
	                        ev.direction = (ev.deltaX < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
	                    }
	                }
	
	                // first time, trigger dragstart event
	                if(!triggered) {
	                    inst.trigger(name + 'start', ev);
	                    triggered = true;
	                }
	
	                // trigger events
	                inst.trigger(name, ev);
	                inst.trigger(name + ev.direction, ev);
	
	                var isVertical = Utils.isVertical(ev.direction);
	
	                // block the browser events
	                if((inst.options.dragBlockVertical && isVertical) ||
	                    (inst.options.dragBlockHorizontal && !isVertical)) {
	                    ev.preventDefault();
	                }
	                break;
	
	            case EVENT_RELEASE:
	                if(triggered && ev.changedLength <= inst.options.dragMaxTouches) {
	                    inst.trigger(name + 'end', ev);
	                    triggered = false;
	                }
	                break;
	
	            case EVENT_END:
	                triggered = false;
	                break;
	        }
	    }
	
	    Hammer.gestures.Drag = {
	        name: name,
	        index: 50,
	        handler: dragGesture,
	        defaults: {
	            /**
	             * minimal movement that have to be made before the drag event gets triggered
	             * @property dragMinDistance
	             * @type {Number}
	             * @default 10
	             */
	            dragMinDistance: 10,
	
	            /**
	             * Set dragDistanceCorrection to true to make the starting point of the drag
	             * be calculated from where the drag was triggered, not from where the touch started.
	             * Useful to avoid a jerk-starting drag, which can make fine-adjustments
	             * through dragging difficult, and be visually unappealing.
	             * @property dragDistanceCorrection
	             * @type {Boolean}
	             * @default true
	             */
	            dragDistanceCorrection: true,
	
	            /**
	             * set 0 for unlimited, but this can conflict with transform
	             * @property dragMaxTouches
	             * @type {Number}
	             * @default 1
	             */
	            dragMaxTouches: 1,
	
	            /**
	             * prevent default browser behavior when dragging occurs
	             * be careful with it, it makes the element a blocking element
	             * when you are using the drag gesture, it is a good practice to set this true
	             * @property dragBlockHorizontal
	             * @type {Boolean}
	             * @default false
	             */
	            dragBlockHorizontal: false,
	
	            /**
	             * same as `dragBlockHorizontal`, but for vertical movement
	             * @property dragBlockVertical
	             * @type {Boolean}
	             * @default false
	             */
	            dragBlockVertical: false,
	
	            /**
	             * dragLockToAxis keeps the drag gesture on the axis that it started on,
	             * It disallows vertical directions if the initial direction was horizontal, and vice versa.
	             * @property dragLockToAxis
	             * @type {Boolean}
	             * @default false
	             */
	            dragLockToAxis: false,
	
	            /**
	             * drag lock only kicks in when distance > dragLockMinDistance
	             * This way, locking occurs only when the distance has become large enough to reliably determine the direction
	             * @property dragLockMinDistance
	             * @type {Number}
	             * @default 25
	             */
	            dragLockMinDistance: 25
	        }
	    };
	})('drag');
	
	/**
	 * @module gestures
	 */
	/**
	 * trigger a simple gesture event, so you can do anything in your handler.
	 * only usable if you know what your doing...
	 *
	 * @class Gesture
	 * @static
	 */
	/**
	 * @event gesture
	 * @param {Object} ev
	 */
	Hammer.gestures.Gesture = {
	    name: 'gesture',
	    index: 1337,
	    handler: function releaseGesture(ev, inst) {
	        inst.trigger(this.name, ev);
	    }
	};
	
	/**
	 * @module gestures
	 */
	/**
	 * Touch stays at the same place for x time
	 *
	 * @class Hold
	 * @static
	 */
	/**
	 * @event hold
	 * @param {Object} ev
	 */
	
	/**
	 * @param {String} name
	 */
	(function(name) {
	    var timer;
	
	    function holdGesture(ev, inst) {
	        var options = inst.options,
	            current = Detection.current;
	
	        switch(ev.eventType) {
	            case EVENT_START:
	                clearTimeout(timer);
	
	                // set the gesture so we can check in the timeout if it still is
	                current.name = name;
	
	                // set timer and if after the timeout it still is hold,
	                // we trigger the hold event
	                timer = setTimeout(function() {
	                    if(current && current.name == name) {
	                        inst.trigger(name, ev);
	                    }
	                }, options.holdTimeout);
	                break;
	
	            case EVENT_MOVE:
	                if(ev.distance > options.holdThreshold) {
	                    clearTimeout(timer);
	                }
	                break;
	
	            case EVENT_RELEASE:
	                clearTimeout(timer);
	                break;
	        }
	    }
	
	    Hammer.gestures.Hold = {
	        name: name,
	        index: 10,
	        defaults: {
	            /**
	             * @property holdTimeout
	             * @type {Number}
	             * @default 500
	             */
	            holdTimeout: 500,
	
	            /**
	             * movement allowed while holding
	             * @property holdThreshold
	             * @type {Number}
	             * @default 2
	             */
	            holdThreshold: 2
	        },
	        handler: holdGesture
	    };
	})('hold');
	
	/**
	 * @module gestures
	 */
	/**
	 * when a touch is being released from the page
	 *
	 * @class Release
	 * @static
	 */
	/**
	 * @event release
	 * @param {Object} ev
	 */
	Hammer.gestures.Release = {
	    name: 'release',
	    index: Infinity,
	    handler: function releaseGesture(ev, inst) {
	        if(ev.eventType == EVENT_RELEASE) {
	            inst.trigger(this.name, ev);
	        }
	    }
	};
	
	/**
	 * @module gestures
	 */
	/**
	 * triggers swipe events when the end velocity is above the threshold
	 * for best usage, set `preventDefault` (on the drag gesture) to `true`
	 * ````
	 *  hammertime.on("dragleft swipeleft", function(ev) {
	 *    console.log(ev);
	 *    ev.gesture.preventDefault();
	 *  });
	 * ````
	 *
	 * @class Swipe
	 * @static
	 */
	/**
	 * @event swipe
	 * @param {Object} ev
	 */
	/**
	 * @event swipeleft
	 * @param {Object} ev
	 */
	/**
	 * @event swiperight
	 * @param {Object} ev
	 */
	/**
	 * @event swipeup
	 * @param {Object} ev
	 */
	/**
	 * @event swipedown
	 * @param {Object} ev
	 */
	Hammer.gestures.Swipe = {
	    name: 'swipe',
	    index: 40,
	    defaults: {
	        /**
	         * @property swipeMinTouches
	         * @type {Number}
	         * @default 1
	         */
	        swipeMinTouches: 1,
	
	        /**
	         * @property swipeMaxTouches
	         * @type {Number}
	         * @default 1
	         */
	        swipeMaxTouches: 1,
	
	        /**
	         * horizontal swipe velocity
	         * @property swipeVelocityX
	         * @type {Number}
	         * @default 0.6
	         */
	        swipeVelocityX: 0.6,
	
	        /**
	         * vertical swipe velocity
	         * @property swipeVelocityY
	         * @type {Number}
	         * @default 0.6
	         */
	        swipeVelocityY: 0.6
	    },
	
	    handler: function swipeGesture(ev, inst) {
	        if(ev.eventType == EVENT_RELEASE) {
	            var touches = ev.touches.length,
	                options = inst.options;
	
	            // max touches
	            if(touches < options.swipeMinTouches ||
	                touches > options.swipeMaxTouches) {
	                return;
	            }
	
	            // when the distance we moved is too small we skip this gesture
	            // or we can be already in dragging
	            if(ev.velocityX > options.swipeVelocityX ||
	                ev.velocityY > options.swipeVelocityY) {
	                // trigger swipe events
	                inst.trigger(this.name, ev);
	                inst.trigger(this.name + ev.direction, ev);
	            }
	        }
	    }
	};
	
	/**
	 * @module gestures
	 */
	/**
	 * Single tap and a double tap on a place
	 *
	 * @class Tap
	 * @static
	 */
	/**
	 * @event tap
	 * @param {Object} ev
	 */
	/**
	 * @event doubletap
	 * @param {Object} ev
	 */
	
	/**
	 * @param {String} name
	 */
	(function(name) {
	    var hasMoved = false;
	
	    function tapGesture(ev, inst) {
	        var options = inst.options,
	            current = Detection.current,
	            prev = Detection.previous,
	            sincePrev,
	            didDoubleTap;
	
	        switch(ev.eventType) {
	            case EVENT_START:
	                hasMoved = false;
	                break;
	
	            case EVENT_MOVE:
	                hasMoved = hasMoved || (ev.distance > options.tapMaxDistance);
	                break;
	
	            case EVENT_END:
	                if(!Utils.inStr(ev.srcEvent.type, 'cancel') && ev.deltaTime < options.tapMaxTime && !hasMoved) {
	                    // previous gesture, for the double tap since these are two different gesture detections
	                    sincePrev = prev && prev.lastEvent && ev.timeStamp - prev.lastEvent.timeStamp;
	                    didDoubleTap = false;
	
	                    // check if double tap
	                    if(prev && prev.name == name &&
	                        (sincePrev && sincePrev < options.doubleTapInterval) &&
	                        ev.distance < options.doubleTapDistance) {
	                        inst.trigger('doubletap', ev);
	                        didDoubleTap = true;
	                    }
	
	                    // do a single tap
	                    if(!didDoubleTap || options.tapAlways) {
	                        current.name = name;
	                        inst.trigger(current.name, ev);
	                    }
	                }
	                break;
	        }
	    }
	
	    Hammer.gestures.Tap = {
	        name: name,
	        index: 100,
	        handler: tapGesture,
	        defaults: {
	            /**
	             * max time of a tap, this is for the slow tappers
	             * @property tapMaxTime
	             * @type {Number}
	             * @default 250
	             */
	            tapMaxTime: 250,
	
	            /**
	             * max distance of movement of a tap, this is for the slow tappers
	             * @property tapMaxDistance
	             * @type {Number}
	             * @default 10
	             */
	            tapMaxDistance: 10,
	
	            /**
	             * always trigger the `tap` event, even while double-tapping
	             * @property tapAlways
	             * @type {Boolean}
	             * @default true
	             */
	            tapAlways: true,
	
	            /**
	             * max distance between two taps
	             * @property doubleTapDistance
	             * @type {Number}
	             * @default 20
	             */
	            doubleTapDistance: 20,
	
	            /**
	             * max time between two taps
	             * @property doubleTapInterval
	             * @type {Number}
	             * @default 300
	             */
	            doubleTapInterval: 300
	        }
	    };
	})('tap');
	
	/**
	 * @module gestures
	 */
	/**
	 * when a touch is being touched at the page
	 *
	 * @class Touch
	 * @static
	 */
	/**
	 * @event touch
	 * @param {Object} ev
	 */
	Hammer.gestures.Touch = {
	    name: 'touch',
	    index: -Infinity,
	    defaults: {
	        /**
	         * call preventDefault at touchstart, and makes the element blocking by disabling the scrolling of the page,
	         * but it improves gestures like transforming and dragging.
	         * be careful with using this, it can be very annoying for users to be stuck on the page
	         * @property preventDefault
	         * @type {Boolean}
	         * @default false
	         */
	        preventDefault: false,
	
	        /**
	         * disable mouse events, so only touch (or pen!) input triggers events
	         * @property preventMouse
	         * @type {Boolean}
	         * @default false
	         */
	        preventMouse: false
	    },
	    handler: function touchGesture(ev, inst) {
	        if(inst.options.preventMouse && ev.pointerType == POINTER_MOUSE) {
	            ev.stopDetect();
	            return;
	        }
	
	        if(inst.options.preventDefault) {
	            ev.preventDefault();
	        }
	
	        if(ev.eventType == EVENT_TOUCH) {
	            inst.trigger('touch', ev);
	        }
	    }
	};
	
	/**
	 * @module gestures
	 */
	/**
	 * User want to scale or rotate with 2 fingers
	 * Preventing the default browser behavior is a good way to improve feel and working. This can be done with the
	 * `preventDefault` option.
	 *
	 * @class Transform
	 * @static
	 */
	/**
	 * @event transform
	 * @param {Object} ev
	 */
	/**
	 * @event transformstart
	 * @param {Object} ev
	 */
	/**
	 * @event transformend
	 * @param {Object} ev
	 */
	/**
	 * @event pinchin
	 * @param {Object} ev
	 */
	/**
	 * @event pinchout
	 * @param {Object} ev
	 */
	/**
	 * @event rotate
	 * @param {Object} ev
	 */
	
	/**
	 * @param {String} name
	 */
	(function(name) {
	    var triggered = false;
	
	    function transformGesture(ev, inst) {
	        switch(ev.eventType) {
	            case EVENT_START:
	                triggered = false;
	                break;
	
	            case EVENT_MOVE:
	                // at least multitouch
	                if(ev.touches.length < 2) {
	                    return;
	                }
	
	                var scaleThreshold = Math.abs(1 - ev.scale);
	                var rotationThreshold = Math.abs(ev.rotation);
	
	                // when the distance we moved is too small we skip this gesture
	                // or we can be already in dragging
	                if(scaleThreshold < inst.options.transformMinScale &&
	                    rotationThreshold < inst.options.transformMinRotation) {
	                    return;
	                }
	
	                // we are transforming!
	                Detection.current.name = name;
	
	                // first time, trigger dragstart event
	                if(!triggered) {
	                    inst.trigger(name + 'start', ev);
	                    triggered = true;
	                }
	
	                inst.trigger(name, ev); // basic transform event
	
	                // trigger rotate event
	                if(rotationThreshold > inst.options.transformMinRotation) {
	                    inst.trigger('rotate', ev);
	                }
	
	                // trigger pinch event
	                if(scaleThreshold > inst.options.transformMinScale) {
	                    inst.trigger('pinch', ev);
	                    inst.trigger('pinch' + (ev.scale < 1 ? 'in' : 'out'), ev);
	                }
	                break;
	
	            case EVENT_RELEASE:
	                if(triggered && ev.changedLength < 2) {
	                    inst.trigger(name + 'end', ev);
	                    triggered = false;
	                }
	                break;
	        }
	    }
	
	    Hammer.gestures.Transform = {
	        name: name,
	        index: 45,
	        defaults: {
	            /**
	             * minimal scale factor, no scale is 1, zoomin is to 0 and zoomout until higher then 1
	             * @property transformMinScale
	             * @type {Number}
	             * @default 0.01
	             */
	            transformMinScale: 0.01,
	
	            /**
	             * rotation in degrees
	             * @property transformMinRotation
	             * @type {Number}
	             * @default 1
	             */
	            transformMinRotation: 1
	        },
	
	        handler: transformGesture
	    };
	})('transform');
	
	/**
	 * @module hammer
	 */
	
	// AMD export
	if(true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	        return Hammer;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	// commonjs export
	} else if(typeof module !== 'undefined' && module.exports) {
	    module.exports = Hammer;
	// browser export
	} else {
	    window.Hammer = Hammer;
	}
	
	})(window);

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	//     Underscore.js 1.4.2
	//     http://underscorejs.org
	//     (c) 2009-2012 Jeremy Ashkenas, DocumentCloud Inc.
	//     Underscore may be freely distributed under the MIT license.
	
	(function() {
	
	  // Baseline setup
	  // --------------
	
	  // Establish the root object, `window` in the browser, or `global` on the server.
	  var root = this;
	
	  // Save the previous value of the `_` variable.
	  var previousUnderscore = root._;
	
	  // Establish the object that gets returned to break out of a loop iteration.
	  var breaker = {};
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var push             = ArrayProto.push,
	      slice            = ArrayProto.slice,
	      concat           = ArrayProto.concat,
	      unshift          = ArrayProto.unshift,
	      toString         = ObjProto.toString,
	      hasOwnProperty   = ObjProto.hasOwnProperty;
	
	  // All **ECMAScript 5** native function implementations that we hope to use
	  // are declared here.
	  var
	    nativeForEach      = ArrayProto.forEach,
	    nativeMap          = ArrayProto.map,
	    nativeReduce       = ArrayProto.reduce,
	    nativeReduceRight  = ArrayProto.reduceRight,
	    nativeFilter       = ArrayProto.filter,
	    nativeEvery        = ArrayProto.every,
	    nativeSome         = ArrayProto.some,
	    nativeIndexOf      = ArrayProto.indexOf,
	    nativeLastIndexOf  = ArrayProto.lastIndexOf,
	    nativeIsArray      = Array.isArray,
	    nativeKeys         = Object.keys,
	    nativeBind         = FuncProto.bind;
	
	  // Create a safe reference to the Underscore object for use below.
	  var _ = function(obj) {
	    if (obj instanceof _) return obj;
	    if (!(this instanceof _)) return new _(obj);
	    this._wrapped = obj;
	  };
	
	  // Export the Underscore object for **Node.js**, with
	  // backwards-compatibility for the old `require()` API. If we're in
	  // the browser, add `_` as a global object via a string identifier,
	  // for Closure Compiler "advanced" mode.
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports) {
	      exports = module.exports = _;
	    }
	    exports._ = _;
	  } else {
	    root['_'] = _;
	  }
	
	  // Current version.
	  _.VERSION = '1.4.2';
	
	  // Collection Functions
	  // --------------------
	
	  // The cornerstone, an `each` implementation, aka `forEach`.
	  // Handles objects with the built-in `forEach`, arrays, and raw objects.
	  // Delegates to **ECMAScript 5**'s native `forEach` if available.
	  var each = _.each = _.forEach = function(obj, iterator, context) {
	    if (obj == null) return;
	    if (nativeForEach && obj.forEach === nativeForEach) {
	      obj.forEach(iterator, context);
	    } else if (obj.length === +obj.length) {
	      for (var i = 0, l = obj.length; i < l; i++) {
	        if (iterator.call(context, obj[i], i, obj) === breaker) return;
	      }
	    } else {
	      for (var key in obj) {
	        if (_.has(obj, key)) {
	          if (iterator.call(context, obj[key], key, obj) === breaker) return;
	        }
	      }
	    }
	  };
	
	  // Return the results of applying the iterator to each element.
	  // Delegates to **ECMAScript 5**'s native `map` if available.
	  _.map = _.collect = function(obj, iterator, context) {
	    var results = [];
	    if (obj == null) return results;
	    if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);
	    each(obj, function(value, index, list) {
	      results[results.length] = iterator.call(context, value, index, list);
	    });
	    return results;
	  };
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`. Delegates to **ECMAScript 5**'s native `reduce` if available.
	  _.reduce = _.foldl = _.inject = function(obj, iterator, memo, context) {
	    var initial = arguments.length > 2;
	    if (obj == null) obj = [];
	    if (nativeReduce && obj.reduce === nativeReduce) {
	      if (context) iterator = _.bind(iterator, context);
	      return initial ? obj.reduce(iterator, memo) : obj.reduce(iterator);
	    }
	    each(obj, function(value, index, list) {
	      if (!initial) {
	        memo = value;
	        initial = true;
	      } else {
	        memo = iterator.call(context, memo, value, index, list);
	      }
	    });
	    if (!initial) throw new TypeError('Reduce of empty array with no initial value');
	    return memo;
	  };
	
	  // The right-associative version of reduce, also known as `foldr`.
	  // Delegates to **ECMAScript 5**'s native `reduceRight` if available.
	  _.reduceRight = _.foldr = function(obj, iterator, memo, context) {
	    var initial = arguments.length > 2;
	    if (obj == null) obj = [];
	    if (nativeReduceRight && obj.reduceRight === nativeReduceRight) {
	      if (context) iterator = _.bind(iterator, context);
	      return arguments.length > 2 ? obj.reduceRight(iterator, memo) : obj.reduceRight(iterator);
	    }
	    var length = obj.length;
	    if (length !== +length) {
	      var keys = _.keys(obj);
	      length = keys.length;
	    }
	    each(obj, function(value, index, list) {
	      index = keys ? keys[--length] : --length;
	      if (!initial) {
	        memo = obj[index];
	        initial = true;
	      } else {
	        memo = iterator.call(context, memo, obj[index], index, list);
	      }
	    });
	    if (!initial) throw new TypeError('Reduce of empty array with no initial value');
	    return memo;
	  };
	
	  // Return the first value which passes a truth test. Aliased as `detect`.
	  _.find = _.detect = function(obj, iterator, context) {
	    var result;
	    any(obj, function(value, index, list) {
	      if (iterator.call(context, value, index, list)) {
	        result = value;
	        return true;
	      }
	    });
	    return result;
	  };
	
	  // Return all the elements that pass a truth test.
	  // Delegates to **ECMAScript 5**'s native `filter` if available.
	  // Aliased as `select`.
	  _.filter = _.select = function(obj, iterator, context) {
	    var results = [];
	    if (obj == null) return results;
	    if (nativeFilter && obj.filter === nativeFilter) return obj.filter(iterator, context);
	    each(obj, function(value, index, list) {
	      if (iterator.call(context, value, index, list)) results[results.length] = value;
	    });
	    return results;
	  };
	
	  // Return all the elements for which a truth test fails.
	  _.reject = function(obj, iterator, context) {
	    var results = [];
	    if (obj == null) return results;
	    each(obj, function(value, index, list) {
	      if (!iterator.call(context, value, index, list)) results[results.length] = value;
	    });
	    return results;
	  };
	
	  // Determine whether all of the elements match a truth test.
	  // Delegates to **ECMAScript 5**'s native `every` if available.
	  // Aliased as `all`.
	  _.every = _.all = function(obj, iterator, context) {
	    iterator || (iterator = _.identity);
	    var result = true;
	    if (obj == null) return result;
	    if (nativeEvery && obj.every === nativeEvery) return obj.every(iterator, context);
	    each(obj, function(value, index, list) {
	      if (!(result = result && iterator.call(context, value, index, list))) return breaker;
	    });
	    return !!result;
	  };
	
	  // Determine if at least one element in the object matches a truth test.
	  // Delegates to **ECMAScript 5**'s native `some` if available.
	  // Aliased as `any`.
	  var any = _.some = _.any = function(obj, iterator, context) {
	    iterator || (iterator = _.identity);
	    var result = false;
	    if (obj == null) return result;
	    if (nativeSome && obj.some === nativeSome) return obj.some(iterator, context);
	    each(obj, function(value, index, list) {
	      if (result || (result = iterator.call(context, value, index, list))) return breaker;
	    });
	    return !!result;
	  };
	
	  // Determine if the array or object contains a given value (using `===`).
	  // Aliased as `include`.
	  _.contains = _.include = function(obj, target) {
	    var found = false;
	    if (obj == null) return found;
	    if (nativeIndexOf && obj.indexOf === nativeIndexOf) return obj.indexOf(target) != -1;
	    found = any(obj, function(value) {
	      return value === target;
	    });
	    return found;
	  };
	
	  // Invoke a method (with arguments) on every item in a collection.
	  _.invoke = function(obj, method) {
	    var args = slice.call(arguments, 2);
	    return _.map(obj, function(value) {
	      return (_.isFunction(method) ? method : value[method]).apply(value, args);
	    });
	  };
	
	  // Convenience version of a common use case of `map`: fetching a property.
	  _.pluck = function(obj, key) {
	    return _.map(obj, function(value){ return value[key]; });
	  };
	
	  // Convenience version of a common use case of `filter`: selecting only objects
	  // with specific `key:value` pairs.
	  _.where = function(obj, attrs) {
	    if (_.isEmpty(attrs)) return [];
	    return _.filter(obj, function(value) {
	      for (var key in attrs) {
	        if (attrs[key] !== value[key]) return false;
	      }
	      return true;
	    });
	  };
	
	  // Return the maximum element or (element-based computation).
	  // Can't optimize arrays of integers longer than 65,535 elements.
	  // See: https://bugs.webkit.org/show_bug.cgi?id=80797
	  _.max = function(obj, iterator, context) {
	    if (!iterator && _.isArray(obj) && obj[0] === +obj[0] && obj.length < 65535) {
	      return Math.max.apply(Math, obj);
	    }
	    if (!iterator && _.isEmpty(obj)) return -Infinity;
	    var result = {computed : -Infinity};
	    each(obj, function(value, index, list) {
	      var computed = iterator ? iterator.call(context, value, index, list) : value;
	      computed >= result.computed && (result = {value : value, computed : computed});
	    });
	    return result.value;
	  };
	
	  // Return the minimum element (or element-based computation).
	  _.min = function(obj, iterator, context) {
	    if (!iterator && _.isArray(obj) && obj[0] === +obj[0] && obj.length < 65535) {
	      return Math.min.apply(Math, obj);
	    }
	    if (!iterator && _.isEmpty(obj)) return Infinity;
	    var result = {computed : Infinity};
	    each(obj, function(value, index, list) {
	      var computed = iterator ? iterator.call(context, value, index, list) : value;
	      computed < result.computed && (result = {value : value, computed : computed});
	    });
	    return result.value;
	  };
	
	  // Shuffle an array.
	  _.shuffle = function(obj) {
	    var rand;
	    var index = 0;
	    var shuffled = [];
	    each(obj, function(value) {
	      rand = _.random(index++);
	      shuffled[index - 1] = shuffled[rand];
	      shuffled[rand] = value;
	    });
	    return shuffled;
	  };
	
	  // An internal function to generate lookup iterators.
	  var lookupIterator = function(value) {
	    return _.isFunction(value) ? value : function(obj){ return obj[value]; };
	  };
	
	  // Sort the object's values by a criterion produced by an iterator.
	  _.sortBy = function(obj, value, context) {
	    var iterator = lookupIterator(value);
	    return _.pluck(_.map(obj, function(value, index, list) {
	      return {
	        value : value,
	        index : index,
	        criteria : iterator.call(context, value, index, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index < right.index ? -1 : 1;
	    }), 'value');
	  };
	
	  // An internal function used for aggregate "group by" operations.
	  var group = function(obj, value, context, behavior) {
	    var result = {};
	    var iterator = lookupIterator(value);
	    each(obj, function(value, index) {
	      var key = iterator.call(context, value, index, obj);
	      behavior(result, key, value);
	    });
	    return result;
	  };
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  _.groupBy = function(obj, value, context) {
	    return group(obj, value, context, function(result, key, value) {
	      (_.has(result, key) ? result[key] : (result[key] = [])).push(value);
	    });
	  };
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  _.countBy = function(obj, value, context) {
	    return group(obj, value, context, function(result, key, value) {
	      if (!_.has(result, key)) result[key] = 0;
	      result[key]++;
	    });
	  };
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  _.sortedIndex = function(array, obj, iterator, context) {
	    iterator = iterator == null ? _.identity : lookupIterator(iterator);
	    var value = iterator.call(context, obj);
	    var low = 0, high = array.length;
	    while (low < high) {
	      var mid = (low + high) >>> 1;
	      iterator.call(context, array[mid]) < value ? low = mid + 1 : high = mid;
	    }
	    return low;
	  };
	
	  // Safely convert anything iterable into a real, live array.
	  _.toArray = function(obj) {
	    if (!obj) return [];
	    if (obj.length === +obj.length) return slice.call(obj);
	    return _.values(obj);
	  };
	
	  // Return the number of elements in an object.
	  _.size = function(obj) {
	    return (obj.length === +obj.length) ? obj.length : _.keys(obj).length;
	  };
	
	  // Array Functions
	  // ---------------
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. Aliased as `head` and `take`. The **guard** check
	  // allows it to work with `_.map`.
	  _.first = _.head = _.take = function(array, n, guard) {
	    return (n != null) && !guard ? slice.call(array, 0, n) : array[0];
	  };
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N. The **guard** check allows it to work with
	  // `_.map`.
	  _.initial = function(array, n, guard) {
	    return slice.call(array, 0, array.length - ((n == null) || guard ? 1 : n));
	  };
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array. The **guard** check allows it to work with `_.map`.
	  _.last = function(array, n, guard) {
	    if ((n != null) && !guard) {
	      return slice.call(array, Math.max(array.length - n, 0));
	    } else {
	      return array[array.length - 1];
	    }
	  };
	
	  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
	  // Especially useful on the arguments object. Passing an **n** will return
	  // the rest N values in the array. The **guard**
	  // check allows it to work with `_.map`.
	  _.rest = _.tail = _.drop = function(array, n, guard) {
	    return slice.call(array, (n == null) || guard ? 1 : n);
	  };
	
	  // Trim out all falsy values from an array.
	  _.compact = function(array) {
	    return _.filter(array, function(value){ return !!value; });
	  };
	
	  // Internal implementation of a recursive `flatten` function.
	  var flatten = function(input, shallow, output) {
	    each(input, function(value) {
	      if (_.isArray(value)) {
	        shallow ? push.apply(output, value) : flatten(value, shallow, output);
	      } else {
	        output.push(value);
	      }
	    });
	    return output;
	  };
	
	  // Return a completely flattened version of an array.
	  _.flatten = function(array, shallow) {
	    return flatten(array, shallow, []);
	  };
	
	  // Return a version of the array that does not contain the specified value(s).
	  _.without = function(array) {
	    return _.difference(array, slice.call(arguments, 1));
	  };
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // Aliased as `unique`.
	  _.uniq = _.unique = function(array, isSorted, iterator, context) {
	    var initial = iterator ? _.map(array, iterator, context) : array;
	    var results = [];
	    var seen = [];
	    each(initial, function(value, index) {
	      if (isSorted ? (!index || seen[seen.length - 1] !== value) : !_.contains(seen, value)) {
	        seen.push(value);
	        results.push(array[index]);
	      }
	    });
	    return results;
	  };
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  _.union = function() {
	    return _.uniq(concat.apply(ArrayProto, arguments));
	  };
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  _.intersection = function(array) {
	    var rest = slice.call(arguments, 1);
	    return _.filter(_.uniq(array), function(item) {
	      return _.every(rest, function(other) {
	        return _.indexOf(other, item) >= 0;
	      });
	    });
	  };
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  _.difference = function(array) {
	    var rest = concat.apply(ArrayProto, slice.call(arguments, 1));
	    return _.filter(array, function(value){ return !_.contains(rest, value); });
	  };
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  _.zip = function() {
	    var args = slice.call(arguments);
	    var length = _.max(_.pluck(args, 'length'));
	    var results = new Array(length);
	    for (var i = 0; i < length; i++) {
	      results[i] = _.pluck(args, "" + i);
	    }
	    return results;
	  };
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values.
	  _.object = function(list, values) {
	    var result = {};
	    for (var i = 0, l = list.length; i < l; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  };
	
	  // If the browser doesn't supply us with indexOf (I'm looking at you, **MSIE**),
	  // we need this function. Return the position of the first occurrence of an
	  // item in an array, or -1 if the item is not included in the array.
	  // Delegates to **ECMAScript 5**'s native `indexOf` if available.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  _.indexOf = function(array, item, isSorted) {
	    if (array == null) return -1;
	    var i = 0, l = array.length;
	    if (isSorted) {
	      if (typeof isSorted == 'number') {
	        i = (isSorted < 0 ? Math.max(0, l + isSorted) : isSorted);
	      } else {
	        i = _.sortedIndex(array, item);
	        return array[i] === item ? i : -1;
	      }
	    }
	    if (nativeIndexOf && array.indexOf === nativeIndexOf) return array.indexOf(item, isSorted);
	    for (; i < l; i++) if (array[i] === item) return i;
	    return -1;
	  };
	
	  // Delegates to **ECMAScript 5**'s native `lastIndexOf` if available.
	  _.lastIndexOf = function(array, item, from) {
	    if (array == null) return -1;
	    var hasIndex = from != null;
	    if (nativeLastIndexOf && array.lastIndexOf === nativeLastIndexOf) {
	      return hasIndex ? array.lastIndexOf(item, from) : array.lastIndexOf(item);
	    }
	    var i = (hasIndex ? from : array.length);
	    while (i--) if (array[i] === item) return i;
	    return -1;
	  };
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](http://docs.python.org/library/functions.html#range).
	  _.range = function(start, stop, step) {
	    if (arguments.length <= 1) {
	      stop = start || 0;
	      start = 0;
	    }
	    step = arguments[2] || 1;
	
	    var len = Math.max(Math.ceil((stop - start) / step), 0);
	    var idx = 0;
	    var range = new Array(len);
	
	    while(idx < len) {
	      range[idx++] = start;
	      start += step;
	    }
	
	    return range;
	  };
	
	  // Function (ahem) Functions
	  // ------------------
	
	  // Reusable constructor function for prototype setting.
	  var ctor = function(){};
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally). Binding with arguments is also known as `curry`.
	  // Delegates to **ECMAScript 5**'s native `Function.bind` if available.
	  // We check for `func.bind` first, to fail fast when `func` is undefined.
	  _.bind = function bind(func, context) {
	    var bound, args;
	    if (func.bind === nativeBind && nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
	    if (!_.isFunction(func)) throw new TypeError;
	    args = slice.call(arguments, 2);
	    return bound = function() {
	      if (!(this instanceof bound)) return func.apply(context, args.concat(slice.call(arguments)));
	      ctor.prototype = func.prototype;
	      var self = new ctor;
	      var result = func.apply(self, args.concat(slice.call(arguments)));
	      if (Object(result) === result) return result;
	      return self;
	    };
	  };
	
	  // Bind all of an object's methods to that object. Useful for ensuring that
	  // all callbacks defined on an object belong to it.
	  _.bindAll = function(obj) {
	    var funcs = slice.call(arguments, 1);
	    if (funcs.length == 0) funcs = _.functions(obj);
	    each(funcs, function(f) { obj[f] = _.bind(obj[f], obj); });
	    return obj;
	  };
	
	  // Memoize an expensive function by storing its results.
	  _.memoize = function(func, hasher) {
	    var memo = {};
	    hasher || (hasher = _.identity);
	    return function() {
	      var key = hasher.apply(this, arguments);
	      return _.has(memo, key) ? memo[key] : (memo[key] = func.apply(this, arguments));
	    };
	  };
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  _.delay = function(func, wait) {
	    var args = slice.call(arguments, 2);
	    return setTimeout(function(){ return func.apply(null, args); }, wait);
	  };
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  _.defer = function(func) {
	    return _.delay.apply(_, [func, 1].concat(slice.call(arguments, 1)));
	  };
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time.
	  _.throttle = function(func, wait) {
	    var context, args, timeout, throttling, more, result;
	    var whenDone = _.debounce(function(){ more = throttling = false; }, wait);
	    return function() {
	      context = this; args = arguments;
	      var later = function() {
	        timeout = null;
	        if (more) {
	          result = func.apply(context, args);
	        }
	        whenDone();
	      };
	      if (!timeout) timeout = setTimeout(later, wait);
	      if (throttling) {
	        more = true;
	      } else {
	        throttling = true;
	        result = func.apply(context, args);
	      }
	      whenDone();
	      return result;
	    };
	  };
	
	  // Returns a function, that, as long as it continues to be invoked, will not
	  // be triggered. The function will be called after it stops being called for
	  // N milliseconds. If `immediate` is passed, trigger the function on the
	  // leading edge, instead of the trailing.
	  _.debounce = function(func, wait, immediate) {
	    var timeout, result;
	    return function() {
	      var context = this, args = arguments;
	      var later = function() {
	        timeout = null;
	        if (!immediate) result = func.apply(context, args);
	      };
	      var callNow = immediate && !timeout;
	      clearTimeout(timeout);
	      timeout = setTimeout(later, wait);
	      if (callNow) result = func.apply(context, args);
	      return result;
	    };
	  };
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  _.once = function(func) {
	    var ran = false, memo;
	    return function() {
	      if (ran) return memo;
	      ran = true;
	      memo = func.apply(this, arguments);
	      func = null;
	      return memo;
	    };
	  };
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  _.wrap = function(func, wrapper) {
	    return function() {
	      var args = [func];
	      push.apply(args, arguments);
	      return wrapper.apply(this, args);
	    };
	  };
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  _.compose = function() {
	    var funcs = arguments;
	    return function() {
	      var args = arguments;
	      for (var i = funcs.length - 1; i >= 0; i--) {
	        args = [funcs[i].apply(this, args)];
	      }
	      return args[0];
	    };
	  };
	
	  // Returns a function that will only be executed after being called N times.
	  _.after = function(times, func) {
	    if (times <= 0) return func();
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  };
	
	  // Object Functions
	  // ----------------
	
	  // Retrieve the names of an object's properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`
	  _.keys = nativeKeys || function(obj) {
	    if (obj !== Object(obj)) throw new TypeError('Invalid object');
	    var keys = [];
	    for (var key in obj) if (_.has(obj, key)) keys[keys.length] = key;
	    return keys;
	  };
	
	  // Retrieve the values of an object's properties.
	  _.values = function(obj) {
	    var values = [];
	    for (var key in obj) if (_.has(obj, key)) values.push(obj[key]);
	    return values;
	  };
	
	  // Convert an object into a list of `[key, value]` pairs.
	  _.pairs = function(obj) {
	    var pairs = [];
	    for (var key in obj) if (_.has(obj, key)) pairs.push([key, obj[key]]);
	    return pairs;
	  };
	
	  // Invert the keys and values of an object. The values must be serializable.
	  _.invert = function(obj) {
	    var result = {};
	    for (var key in obj) if (_.has(obj, key)) result[obj[key]] = key;
	    return result;
	  };
	
	  // Return a sorted list of the function names available on the object.
	  // Aliased as `methods`
	  _.functions = _.methods = function(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (_.isFunction(obj[key])) names.push(key);
	    }
	    return names.sort();
	  };
	
	  // Extend a given object with all the properties in passed-in object(s).
	  _.extend = function(obj) {
	    each(slice.call(arguments, 1), function(source) {
	      for (var prop in source) {
	        obj[prop] = source[prop];
	      }
	    });
	    return obj;
	  };
	
	  // Return a copy of the object only containing the whitelisted properties.
	  _.pick = function(obj) {
	    var copy = {};
	    var keys = concat.apply(ArrayProto, slice.call(arguments, 1));
	    each(keys, function(key) {
	      if (key in obj) copy[key] = obj[key];
	    });
	    return copy;
	  };
	
	   // Return a copy of the object without the blacklisted properties.
	  _.omit = function(obj) {
	    var copy = {};
	    var keys = concat.apply(ArrayProto, slice.call(arguments, 1));
	    for (var key in obj) {
	      if (!_.contains(keys, key)) copy[key] = obj[key];
	    }
	    return copy;
	  };
	
	  // Fill in a given object with default properties.
	  _.defaults = function(obj) {
	    each(slice.call(arguments, 1), function(source) {
	      for (var prop in source) {
	        if (obj[prop] == null) obj[prop] = source[prop];
	      }
	    });
	    return obj;
	  };
	
	  // Create a (shallow-cloned) duplicate of an object.
	  _.clone = function(obj) {
	    if (!_.isObject(obj)) return obj;
	    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
	  };
	
	  // Invokes interceptor with the obj, and then returns obj.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  _.tap = function(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  };
	
	  // Internal recursive comparison function for `isEqual`.
	  var eq = function(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the Harmony `egal` proposal: http://wiki.ecmascript.org/doku.php?id=harmony:egal.
	    if (a === b) return a !== 0 || 1 / a == 1 / b;
	    // A strict comparison is necessary because `null == undefined`.
	    if (a == null || b == null) return a === b;
	    // Unwrap any wrapped objects.
	    if (a instanceof _) a = a._wrapped;
	    if (b instanceof _) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className != toString.call(b)) return false;
	    switch (className) {
	      // Strings, numbers, dates, and booleans are compared by value.
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return a == String(b);
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive. An `egal` comparison is performed for
	        // other numeric values.
	        return a != +a ? b != +b : (a == 0 ? 1 / a == 1 / b : a == +b);
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a == +b;
	      // RegExps are compared by their source patterns and flags.
	      case '[object RegExp]':
	        return a.source == b.source &&
	               a.global == b.global &&
	               a.multiline == b.multiline &&
	               a.ignoreCase == b.ignoreCase;
	    }
	    if (typeof a != 'object' || typeof b != 'object') return false;
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] == a) return bStack[length] == b;
	    }
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	    var size = 0, result = true;
	    // Recursively compare objects and arrays.
	    if (className == '[object Array]') {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      size = a.length;
	      result = size == b.length;
	      if (result) {
	        // Deep compare the contents, ignoring non-numeric properties.
	        while (size--) {
	          if (!(result = eq(a[size], b[size], aStack, bStack))) break;
	        }
	      }
	    } else {
	      // Objects with different constructors are not equivalent, but `Object`s
	      // from different frames are.
	      var aCtor = a.constructor, bCtor = b.constructor;
	      if (aCtor !== bCtor && !(_.isFunction(aCtor) && (aCtor instanceof aCtor) &&
	                               _.isFunction(bCtor) && (bCtor instanceof bCtor))) {
	        return false;
	      }
	      // Deep compare objects.
	      for (var key in a) {
	        if (_.has(a, key)) {
	          // Count the expected number of properties.
	          size++;
	          // Deep compare each member.
	          if (!(result = _.has(b, key) && eq(a[key], b[key], aStack, bStack))) break;
	        }
	      }
	      // Ensure that both objects contain the same number of properties.
	      if (result) {
	        for (key in b) {
	          if (_.has(b, key) && !(size--)) break;
	        }
	        result = !size;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return result;
	  };
	
	  // Perform a deep comparison to check if two objects are equal.
	  _.isEqual = function(a, b) {
	    return eq(a, b, [], []);
	  };
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  _.isEmpty = function(obj) {
	    if (obj == null) return true;
	    if (_.isArray(obj) || _.isString(obj)) return obj.length === 0;
	    for (var key in obj) if (_.has(obj, key)) return false;
	    return true;
	  };
	
	  // Is a given value a DOM element?
	  _.isElement = function(obj) {
	    return !!(obj && obj.nodeType === 1);
	  };
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native Array.isArray
	  _.isArray = nativeIsArray || function(obj) {
	    return toString.call(obj) == '[object Array]';
	  };
	
	  // Is a given variable an object?
	  _.isObject = function(obj) {
	    return obj === Object(obj);
	  };
	
	  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp.
	  each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp'], function(name) {
	    _['is' + name] = function(obj) {
	      return toString.call(obj) == '[object ' + name + ']';
	    };
	  });
	
	  // Define a fallback version of the method in browsers (ahem, IE), where
	  // there isn't any inspectable "Arguments" type.
	  if (!_.isArguments(arguments)) {
	    _.isArguments = function(obj) {
	      return !!(obj && _.has(obj, 'callee'));
	    };
	  }
	
	  // Optimize `isFunction` if appropriate.
	  if (true) {
	    _.isFunction = function(obj) {
	      return typeof obj === 'function';
	    };
	  }
	
	  // Is a given object a finite number?
	  _.isFinite = function(obj) {
	    return _.isNumber(obj) && isFinite(obj);
	  };
	
	  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
	  _.isNaN = function(obj) {
	    return _.isNumber(obj) && obj != +obj;
	  };
	
	  // Is a given value a boolean?
	  _.isBoolean = function(obj) {
	    return obj === true || obj === false || toString.call(obj) == '[object Boolean]';
	  };
	
	  // Is a given value equal to null?
	  _.isNull = function(obj) {
	    return obj === null;
	  };
	
	  // Is a given variable undefined?
	  _.isUndefined = function(obj) {
	    return obj === void 0;
	  };
	
	  // Shortcut function for checking if an object has a given property directly
	  // on itself (in other words, not on a prototype).
	  _.has = function(obj, key) {
	    return hasOwnProperty.call(obj, key);
	  };
	
	  // Utility Functions
	  // -----------------
	
	  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
	  // previous owner. Returns a reference to the Underscore object.
	  _.noConflict = function() {
	    root._ = previousUnderscore;
	    return this;
	  };
	
	  // Keep the identity function around for default iterators.
	  _.identity = function(value) {
	    return value;
	  };
	
	  // Run a function **n** times.
	  _.times = function(n, iterator, context) {
	    for (var i = 0; i < n; i++) iterator.call(context, i);
	  };
	
	  // Return a random integer between min and max (inclusive).
	  _.random = function(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + (0 | Math.random() * (max - min + 1));
	  };
	
	  // List of HTML entities for escaping.
	  var entityMap = {
	    escape: {
	      '&': '&amp;',
	      '<': '&lt;',
	      '>': '&gt;',
	      '"': '&quot;',
	      "'": '&#x27;',
	      '/': '&#x2F;'
	    }
	  };
	  entityMap.unescape = _.invert(entityMap.escape);
	
	  // Regexes containing the keys and values listed immediately above.
	  var entityRegexes = {
	    escape:   new RegExp('[' + _.keys(entityMap.escape).join('') + ']', 'g'),
	    unescape: new RegExp('(' + _.keys(entityMap.unescape).join('|') + ')', 'g')
	  };
	
	  // Functions for escaping and unescaping strings to/from HTML interpolation.
	  _.each(['escape', 'unescape'], function(method) {
	    _[method] = function(string) {
	      if (string == null) return '';
	      return ('' + string).replace(entityRegexes[method], function(match) {
	        return entityMap[method][match];
	      });
	    };
	  });
	
	  // If the value of the named property is a function then invoke it;
	  // otherwise, return it.
	  _.result = function(object, property) {
	    if (object == null) return null;
	    var value = object[property];
	    return _.isFunction(value) ? value.call(object) : value;
	  };
	
	  // Add your own custom functions to the Underscore object.
	  _.mixin = function(obj) {
	    each(_.functions(obj), function(name){
	      var func = _[name] = obj[name];
	      _.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return result.call(this, func.apply(_, args));
	      };
	    });
	  };
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  _.uniqueId = function(prefix) {
	    var id = idCounter++;
	    return prefix ? prefix + id : id;
	  };
	
	  // By default, Underscore uses ERB-style template delimiters, change the
	  // following template settings to use alternative delimiters.
	  _.templateSettings = {
	    evaluate    : /<%([\s\S]+?)%>/g,
	    interpolate : /<%=([\s\S]+?)%>/g,
	    escape      : /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'":      "'",
	    '\\':     '\\',
	    '\r':     'r',
	    '\n':     'n',
	    '\t':     't',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escaper = /\\|'|\r|\n|\t|\u2028|\u2029/g;
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  _.template = function(text, data, settings) {
	    settings = _.defaults({}, settings, _.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = new RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset)
	        .replace(escaper, function(match) { return '\\' + escapes[match]; });
	      source +=
	        escape ? "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'" :
	        interpolate ? "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'" :
	        evaluate ? "';\n" + evaluate + "\n__p+='" : '';
	      index = offset + match.length;
	    });
	    source += "';\n";
	
	    // If a variable is not specified, place data values in local scope.
	    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
	
	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + "return __p;\n";
	
	    try {
	      var render = new Function(settings.variable || 'obj', '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    if (data) return render(data, _);
	    var template = function(data) {
	      return render.call(this, data, _);
	    };
	
	    // Provide the compiled function source as a convenience for precompilation.
	    template.source = 'function(' + (settings.variable || 'obj') + '){\n' + source + '}';
	
	    return template;
	  };
	
	  // Add a "chain" function, which will delegate to the wrapper.
	  _.chain = function(obj) {
	    return _(obj).chain();
	  };
	
	  // OOP
	  // ---------------
	  // If Underscore is called as a function, it returns a wrapped object that
	  // can be used OO-style. This wrapper holds altered versions of all the
	  // underscore functions. Wrapped objects may be chained.
	
	  // Helper function to continue chaining intermediate results.
	  var result = function(obj) {
	    return this._chain ? _(obj).chain() : obj;
	  };
	
	  // Add all of the Underscore functions to the wrapper object.
	  _.mixin(_);
	
	  // Add all mutator Array functions to the wrapper.
	  each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      var obj = this._wrapped;
	      method.apply(obj, arguments);
	      if ((name == 'shift' || name == 'splice') && obj.length === 0) delete obj[0];
	      return result.call(this, obj);
	    };
	  });
	
	  // Add all accessor Array functions to the wrapper.
	  each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      return result.call(this, method.apply(this._wrapped, arguments));
	    };
	  });
	
	  _.extend(_.prototype, {
	
	    // Start chaining a wrapped Underscore object.
	    chain: function() {
	      this._chain = true;
	      return this;
	    },
	
	    // Extracts the result from a wrapped and chained object.
	    value: function() {
	      return this._wrapped;
	    }
	
	  });
	
	}).call(this);


/***/ }),
/* 160 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _default = {};
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, "default", "/home/jenkins/agent/workspace/ALLSUN_Deploy_to_Prod/src/Allt/FrontendBundle/Resources/assets/TravelsearchMetadata.js");
	}();

	;

/***/ }),
/* 161 */,
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* 
	 * Facet mixins for 
	 */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){
	        var FacetMixin = {
	            /**
	             * Facets object:
	             * {
	             *   "GT02-356" : 365,
	             *   "GT03-2355" : 1209
	             * }
	             */
	            _facets: [],
	            
	            /**
	             * Applys the facet-data to an object (Widget for example)
	             * @param {object} facetObject A facet object, exampe: 
	             * {
	             *      "globalType" : {
	             *          "GT02-356" : 365,
	             *          "GT03-2355" : 1209
	             *      },
	             *      "board" : {
	             *          "FB" : 450
	             *      }
	             * }
	             */
	            setFacets : function(facetObject){
	                throw new Error("Required method setFacets not implemented");
	            },
	            
	            /**
	             * Returns an object with all faceted data
	             * For example
	             * {
	             *      "globalType" : {
	             *          "GT02-356" : 365,
	             *          "GT03-2355" : 1209
	             *      },
	             *      "board" : {
	             *          "FB" : 450
	             *      }
	             * }
	             * @returns {object}
	             */
	            getFacets : function(){
	                throw new Error("Required method getFacets not implemented");
	            },
	            
	            /**
	             * Override the setFacets() method and call this method.
	             * This method expects the each of globalTypeElements has data-value="GT03-XXX" 
	             * attribute set.
	             * 
	             * 
	             * @param {String} globalTypeElements All global type elements
	             * @param {String} facetsCountElementSelector Selector for counter
	             * @returns {undefined}
	             */
	            _setFacetsCounts: function(globalTypeElements, facetsCountElementSelector) {
	                var self = this;
	                globalTypeElements.each(function(index, gtElement) {
	                    gtElement = $(gtElement);
	                    var currentGt = gtElement.data('value');
	                    // _setFacetsCountForElement() comes from FacetsMixin
	                    var count = 0;
	                    if(_.has(self._facets, currentGt)) {
	                        count = self._facets[currentGt];
	                    }
	                    $(facetsCountElementSelector, gtElement).text(count);
	                    
	                    if(count === 0) {
	                        self._disableThroughFacets(gtElement);
	                    }
	                });
	            },
	            
	            /**
	             * Adds a class to show a zero/disalbed state of an element
	             * 
	             * @param {type} element
	             * @returns {undefined}
	             */
	            _disableThroughFacets: function(element) {
	                element.addClass('disabled');
	            }
	        };
	        
	        return FacetMixin;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(1),
	    __webpack_require__(3),
	    __webpack_require__(178),
	    __webpack_require__(2),
	    __webpack_require__(182)], __WEBPACK_AMD_DEFINE_RESULT__ = function($, _, Component, Object, FlyoutRegistry) {
	        /**
	         * Flyout Component
	         * @constructor
	         */
	        var Flyout = function (element, options) {
	            // Set default options
	            var defaultOptions = {
	                flyoutClassName: 'flyout',
	                hideClassName: 'is-hidden',
	                errorClassName: 'error',
	                callerElementClass : 'btn',
	                closeOnOutsideClick: false,
	                closeOnOverlayClick: false,
	                submitOnOutsideClick: false
	            };
	
	            //Add default options and custom options
	            this.addOptions(defaultOptions, options);
	
	            // Call Component
	            Component.apply(this, arguments);
	
	            // Myself
	            var self = this;
	
	            // Click-handler for Submit-Element
	            $('[data-fcse-role="flyout--button-ok"]', this.getElement()).on('click', null, null, function () {
	                if (self.hasWidget()){
	                    // If validation fails, don't close flyout
	                    if (!self.getWidget().isValid()){
	                        return;
	                    }
	                }
	                self.accept();
	            });
	
	            // Click-Handler for Cancel-Element
	            $('[data-fcse-role="flyout--button-cancel"]', this.getElement()).on('click', null, null, function () {
	                self.cancel();
	            });
	
	            // Register flyout in registry
	            this._flyoutRegistry = new FlyoutRegistry();
	            this._flyoutRegistry.add(this);
	        };
	
	        // Extending Base Component
	        Flyout.prototype = $.extend(Object.create(Component.prototype), {
	            /**
	             * Bind Event-Handler to DOM-Element
	             */
	            bindEventToCallerElement: function(eventType, callerElement, eventData) {
	                var callback = $.proxy(this.bindEventToCallerElementCallback, this);
	                Component.prototype.bindEventToCallerElement.call(this, eventType, callerElement, eventData, callback);
	            },
	
	            bindEventToCallerElementCallback: function () {
	                    var self = this;
	                    if (self.getElement().is(':visible')) {
	                        self.cancel();
	                    } else {
	                        self.openFlyout();
	                    }
	             },
	
	            /**
	             * Closer other Flyouts and set its Caller-Elements to initial state
	             */
	            _closeOther: function() {
	                var self = this;
	                $.each(this._flyoutRegistry.getAll(), function(idx, flyout){
	                    if (flyout !== self){
	                        if (flyout.option('submitOnOutsideClick') && !flyout.getElement().hasClass(flyout.option('hideClassName'))) {
	                            flyout.accept();
	                        } else {
	                            flyout.closeFlyout();
	                        }
	                    }
	                });
	            },
	
	            /**
	             * Open Flyout
	             */
	            openFlyout: function () {
	                var self = this;
	
	                // Close Other Flyouts
	                this._closeOther();
	
	                // Show Flyout-Container
	                this.getElement().removeClass(this.option('hideClassName'));
	
	                // Add Class to Caller-Element
	                this.getCallerElement().addClass(this.option('callerElementOpenClass'));
	
	                // Add handler to close flyout on outside click
	                if (this.option('closeOnOutsideClick')){
	                    $('html').on('click', $.proxy(this._outsideClickHandler, this));
	                }
	            },
	
	            /**
	             * Handler for handling outside click to close the flyout
	             * @param e
	             * @private
	             */
	            _outsideClickHandler: function(e){
	                var clickedElement = e.target;
	
	                var self = this;
	                if (self.getElement().is(':visible')){
	                    var ignoreClick = false;
	
	                    /*
	                    This was removed and should be handled by components properly that trigger click events
	                    // Avoid clicks that are triggered on HTML element directly, (for example from dropdown)
	                    if (clickedElement == $('html')[0]){
	                        // ignoreClick = true;
	                    }
	                    */
	
	                    // Ignore clicks from flyout
	                    if (!self.option('closeOnOverlayClick')) {
	                        $.each($(self.getElement()), function(idx, elem){
	                            if (elem == clickedElement){
	                                ignoreClick = true;
	                            }
	                        });
	                    }
	
	                    // Ignore clicks from caller elements
	                    $.each($(self.getCallerElement()), function(idx, elem){
	                        if (elem == clickedElement){
	                            ignoreClick = true;
	                        }
	                    });
	
	                    $(clickedElement).parentsUntil('html').each(function(index, element){
	                        // Ignore clicks from flyout
	                        $.each($(self.getElement()), function(idx, elem){
	                            if (elem == element){
	                                ignoreClick = true;
	                            }
	                        });
	
	                        // Ignore clicks from caller elements
	                        $.each($(self.getCallerElement()), function(idx, elem){
	                            if (elem == element){
	                                ignoreClick = true;
	                            }
	                        });
	                    });
	                    if (!ignoreClick) {
	                        if (this.option('submitOnOutsideClick')) {
	                            self.accept();
	                        } else {
	                            self.cancel();
	                        }
	                    }
	                }
	            },
	
	            /**
	             * Update Caption
	             */
	            updateCaption: function() {
	                if(this.hasCaptionElement() && this.hasWidget()) {
	                    var value = this.getWidget().formatValue();
	                    if(!_.isNull(value)) {
	                        if (this.getWidget().option('captionIsHtml')){
	                            this.getCaptionElement().html(this.getWidget().formatValue());
	                        } else {
	                            this.getCaptionElement().text(this.getWidget().formatValue());
	                        }
	                    }
	                }
	            },
	            
	            /**
	             * Close Flyout
	             */
	            closeFlyout: function () {
	                // Update Caption
	                this.updateCaption();
	                
	                // Hide Flyout-Container
	                this.getElement().addClass(this.option('hideClassName'));
	                
	                // Remove Class from Caller-Element
	                this.getCallerElement().removeClass(this.option('callerElementOpenClass'));
	
	                // Remove outside click handler
	                $('html').off('click', $.proxy(this._outsideClickHandler, this));
	            },
	
	            /**
	             * Set Widget
	             */
	            setWidget: function (widget) {
	                // Call setWidget from parent
	                Component.prototype.setWidget.call(this, widget);
	                
	                // Bind Accept Event To Widget
	                this.bindAcceptEventToWidget($.proxy(this.closeFlyout, this));
	                
	                // Bind Cancel Event To Widget
	                this.bindCancelEventToWidget($.proxy(this.closeFlyout, this));
	
	                // Bind Undo Event To Widget
	                this.bindUndoEventToWidget($.proxy(this.closeFlyout, this));
	
	                // Bind Widget change event
	                widget.on('change', $.proxy(this._onWidgetChange, this));
	
	                // Bind Widget validationError event
	                widget.on('validationError', $.proxy(this._onWidgetValidationError, this));
	            },
	            
	            /**
	             * Cancel (Calls Cancel-Method of a Widget)
	             * For Flyout cancel calls undo-method, because of the penultimate value is needed
	             */
	            cancel: function () {
	                if(this.hasWidget()) {
	                    this._setErrorState(false);
	                    this.getWidget().cancel();
	                }
	            },
	
	            /**
	             * Change handler for widget update
	             * @param event
	             * @private
	             */
	            _onWidgetChange: function(event){
	                this._setErrorState(false);
	                this.updateCaption();
	            },
	
	            /**
	             * Handler for widget ValidationError
	             * @param event
	             * @private
	             */
	            _onWidgetValidationError: function(event){
	                this._setErrorState(true);
	                this.updateCaption();
	            },
	
	            /**
	             * Helper to set error state to flyout caption
	             * @param boolean yes
	             * @private
	             */
	            _setErrorState: function(yes){
	                if (this.hasCaptionElement()) {
	                    if (yes) {
	                        this.getCaptionElement().addClass(this.option('errorClassName'));
	                    } else {
	                        this.getCaptionElement().removeClass(this.option('errorClassName'));
	                    }
	                }
	            }
	        });
	        
	        return Flyout;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(3), __webpack_require__(69)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, _, ParamConverter) {
	    /**
	     * @param parentScope parent scope
	     * @param name name of the scope
	     * @param persistent is scope persistent, as in, do we save prefixed parameters in the root scope
	     * @param {Object|null} initialScopeParams    An object of initial scope parameters, can be used to pass parameters to backend
	     *                  that have no widget on the current page
	     * @constructor
	     */
	    var Scope = function (parentScope, name, persistent, initialScopeParams) {
	        this.children = [];
	        this.parentScope = parentScope;
	        if(this.parentScope) {
	            this.parentScope.children.push(this);
	        }
	        this.name = name;
	        this._persistent = !!persistent;
	        if (this._persistent && !name) {
	            throw "persistent scope must have a name";
	        }
	
	        this.params = this._convertInitialParams(initialScopeParams);
	        this._changeHandlers = [];
	        this._paramChangeHandlers = [];
	        this._subscribeToParentParamChange();
	        this._subscribeToRootParamChange();
	    };
	
	    Scope.prototype = {
	        /**
	         * Gets all params associated with this scope
	         * @returns {*}
	         */
	        getParams: function () {
	            if (this.parentScope) {
	                var parentParams = this.parentScope.getParams();
	                //we only want persistent parameters to be saved in the root scope
	                var copyWithoutPersistent = {};
	                for (var key in parentParams) {
	                    if (parentParams.hasOwnProperty(key) && key.indexOf('.') < 0) {
	                        copyWithoutPersistent[key] = parentParams[key];
	                    }
	                }
	                return $.extend({}, true, copyWithoutPersistent, this.params);
	            } else {
	                return $.extend({}, true, this.params);
	            }
	        },
	        /**
	         * Sets all parameters to this scope
	         * @param params
	         */
	        setParams: function (params) {
	            var self = this;
	            /*
	            INFO: Is removed, to be able to set null (default) values in widgets
	            So far needed for URL history ajax handling UrlHandling.enableBrowserHistory
	            _.each(params, function(value, key, obj) {
	                if ((_.isObject(value) && _.isEmpty(value)) || (obj[key] == null)) {
	                    delete obj[key];
	                }
	            });
	            */
	            var oldParams = $.extend({}, true, this.params);
	            this.params = $.extend({}, true, params);
	            var changed = false;
	
	            var oldKeys = _.keys(oldParams);
	            var newKeys = _.keys(this.params);
	            var common = _.intersection(oldKeys, newKeys);
	            var changedParams = [];
	
	            //check for changed parameters
	            _.each(common, function (key) {
	                if (!_.isEqual(oldParams[key], self.params[key])) {
	                    self._setPersistentParam(key, self.params[key]);
	                    self._fireParamChangeEvent(key, self.params[key], this);
	                    changed = true;
	                    changedParams.push(key);
	                }
	            });
	            //check for removed parameters
	            _.each(_.difference(oldKeys, common), function (key) {
	                self._setPersistentParam(key, null);
	                self._fireParamChangeEvent(key, null, this);
	                changed = true;
	                changedParams.push(key);
	            });
	            //check for added parameters
	            _.each(_.difference(newKeys, common), function (key) {
	                self._setPersistentParam(key, self.params[key]);
	                self._fireParamChangeEvent(key, self.params[key], this);
	                changed = true;
	                changedParams.push(key);
	            });
	            //if a parameter was added/removed or changed, fire a change event
	            if (changed) {
	                this._fireChangeEvent(this, 'setParams', changedParams);
	            }
	        },
	        /**
	         * Converts the initial params to actual param values
	         * They need to go through ParamConverter to use travelSearchMetadata
	         *
	         * @param params
	         * @returns {{}}
	         * @private
	         */
	        _convertInitialParams: function(params)
	        {
	            if (!params){
	                return {};
	            }
	
	            // Convert initial value to native widget values using ParamConverter
	            var convertedParams = {};
	            $.each(params, function(name, value){
	                ParamConverter.convertParamFromQuery(name, value, convertedParams);
	            });
	
	            return convertedParams;
	        },
	        /**
	         * Sets a single parameter to this scope. If value is <code>null</code> then parameter gets removed.
	         * @param name
	         * @param value
	         */
	        setParam: function (name, value) {
	            this._setPersistentParam(name, value);
	            var oldValue = this.params[name];
	            if (value != null) {
	                this.params[name] = value;
	            } else {
	                delete this.params[name];
	            }
	            if (oldValue != value) {
	                this._fireParamChangeEvent(name, value, this);
	                this._fireChangeEvent(this, 'setParam', [name]);
	            }
	        },
	        /**
	         * Sets multiple parameters to this scope.
	         * @param params
	         */
	        setMultipleParams: function (params) {
	            var changed = false;
	            var changedParams = [];
	            for (var name in params) {
	                if (params.hasOwnProperty(name)) {
	                    var value = params[name];
	                    this._setPersistentParam(name, value);
	                    var oldValue = this.params[name];
	                    if (value != null) {
	                        this.params[name] = value;
	                    } else {
	                        delete this.params[name];
	                    }
	                    if (oldValue != value) {
	                        this._fireParamChangeEvent(name, value, this);
	                        changed = true;
	                        changedParams.push(name);
	                    }
	                }
	            }
	            if (changed) {
	                this._fireChangeEvent(this, 'setMultipleParams', changedParams);
	            }
	        },
	        /**
	         * Sets multiple parameters to this scope; if parameter is prefixed, set it down to children
	         * @param params
	         */
	        setMultiplePrefixedParams: function (params) {
	            var changed = false;
	            var changedParams = [];
	            //parameters to be sent to children of this scope
	            var sendDown = {};
	            for (var name in params) {
	                if (params.hasOwnProperty(name)) {
	                    var value = params[name];
	                    var prefixEnd = name.indexOf(".");
	                    var prefix = prefixEnd == -1 ? "" : name.substr(0, prefixEnd);
	                    if (prefix !== "" && prefix !== this.name) {
	                        //if it does not belong to this scope, add it to params to be sent to children
	                        sendDown[name] = value;
	                    } else if (prefix === "" || prefix === this.name) {
	                        //parameter does belong to this scope, set it
	                        if(prefix !== "") {
	                            //prefixed parameter
	                            name = name.substr(prefix.length + 1);
	                        }
	                        this._setPersistentParam(name, value);
	                        var oldValue = this.params[name];
	                        if (value != null) {
	                            this.params[name] = value;
	                        } else {
	                            delete this.params[name];
	                        }
	                        if (oldValue != value) {
	                            this._fireParamChangeEvent(name, value, this);
	                            changed = true;
	                        }
	                    }
	                    changedParams.push(name);
	                }
	            }
	            if(!_.isEmpty(sendDown) && this.children.length) {
	                for (var i = 0; i < this.children.length; i++) {
	                    this.children[i].setMultiplePrefixedParams(sendDown);
	                }
	            }
	            if (changed) {
	                this._fireChangeEvent(this, 'setMultiplePrefixedParams', changedParams);
	            }
	        },
	        /**
	         * Gets a single parameter from this scope
	         * @param name
	         * @returns {*}
	         */
	        getParam: function (name) {
	            var params = this.getParams();
	            if (params.hasOwnProperty(name)) {
	                return params[name];
	            } else {
	                return null;
	            }
	        },
	        /**
	         * Adds a change handler for when this scope's parameters change
	         * @param handler
	         */
	        change: function (handler) {
	            if (!$.isFunction(handler)) {
	                throw "handler must be a function";
	            }
	            this._changeHandlers[this._changeHandlers.length] = handler;
	        },
	        /**
	         * Adds a param change handler for when this scope's parameter changes
	         * @param handler
	         */
	        paramChange: function (handler) {
	            if (!$.isFunction(handler)) {
	                throw "handler must be a function";
	            }
	            this._paramChangeHandlers[this._paramChangeHandlers.length] = handler;
	        },
	        /**
	         * Get encoded params query
	         */
	        getQuery: function () {
	            return ParamConverter.toQuery(this.getParams());
	        },
	        /**
	         * Finds root scope
	         * @returns {*}
	         * @protected
	         */
	        _findRoot: function () {
	            var root = this;
	            //searching for root scope
	            while (root.parentScope) {
	                root = root.parentScope;
	            }
	            return root;
	        },
	        /**
	         * Sets persistent param (all the way to root)
	         * @param name
	         * @param value
	         * @private
	         */
	        _setPersistentParam: function (name, value) {
	            if (this._persistent) {
	                var root = this._findRoot();
	                if (root !== this) {
	                    //only need to set prefixed parameter if we are not the root scope
	                    //also, we don't want this change to trigger event handler back in this scope,
	                    //so, suppressing handling of parent updates
	                    root._suppressChildUpdates = true;
	                    root.setParam(this.name + '.' + name, value);
	                    root._suppressChildUpdates = false;
	                }
	            }
	        },
	        /**
	         * Subscribes to parent scope change event
	         * @protected
	         */
	        _subscribeToParentParamChange: function () {
	            var self = this;
	            if (this.parentScope) {
	                //if we have a parent scope and it fires a param change event, we are getting changed too
	                this.parentScope.paramChange(function (event, name, value) {
	                    //special case when we're setting persistent parameter from a persistent scope should not trigger
	                    //change event in child, also we should not listen to persistent param (prefixed) changes as it's
	                    //done in a separate handler
	                    if (self._findRoot()._suppressChildUpdates || name.indexOf('.') >= 0) {
	                        return;
	                    }
	                    //if a value is getting changed in parent, it needs to be changed in child too
	                    if (self.params.hasOwnProperty(name)) {
	                        self.params[name] = value;
	                    }
	                    self._fireParamChangeEvent(name, value, event.source);
	                    self._fireChangeEvent(event.source, '_subscribeToParentParamChange', [name]);
	                });
	            }
	        },
	        /**
	         * Subscribes to root scope change event
	         * @protected
	         */
	        _subscribeToRootParamChange: function () {
	            var self = this;
	            if (self._persistent) {
	                //if we are non-root persistent scope, we need to monitor for prefixed value changes in root
	                var root = this._findRoot();
	                if (root !== this) {
	                    root.paramChange(function (event, name, value) {
	                        //special case when we're setting persistent parameter from a persistent scope should not
	                        //trigger change event in child
	                        if (root._suppressChildUpdates) {
	                            return;
	                        }
	                        //if a prefixed value is getting changed in parent, it needs to be changed in persistent child
	                        //too, but without prefix
	                        var prefix = self.name + ".";
	                        if (name.indexOf(prefix) === 0) {
	                            var prefixedName = name.substr(prefix.length);
	                            self.params[prefixedName] = value;
	                            self._fireParamChangeEvent(prefixedName, value, event.source);
	                            self._fireChangeEvent(event.source, '_subscribeToRootParamChange', [name]);
	                        }
	                    });
	                }
	            }
	        },
	        /**
	         * Fires a change event to all registered handlers
	         * @param sourceScope
	         * @private
	         */
	        _fireChangeEvent: function (sourceScope, eventSource, changedParams) {
	            var event = {
	                source: sourceScope || null,
	                scope: this,
	                eventSource: eventSource || null,
	                changedParams: changedParams || []
	            };
	            for (var i = 0; i < this._changeHandlers.length; i++) {
	                this._changeHandlers[i].apply(this, [event, this.getParams()]);
	            }
	        },
	        /**
	         * Fires a param change event to all registered handlers
	         * @param name
	         * @param value
	         * @param sourceScope
	         * @private
	         */
	        _fireParamChangeEvent: function (name, value, sourceScope) {
	            var event = {
	                source: sourceScope,
	                scope: this,
	                changedParams: [name]
	            };
	            for (var i = 0; i < this._paramChangeHandlers.length; i++) {
	                this._paramChangeHandlers[i].apply(this, [event, name, value]);
	            }
	        }
	    };
	
	    return Scope;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Created by ivo on 14.05.14.
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(3), __webpack_require__(95), __webpack_require__(146), __webpack_require__(58), __webpack_require__(153), __webpack_require__(92), __webpack_require__(154), __webpack_require__(144), __webpack_require__(221)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, _, InlineModal, FavoritesHandler, MultiRequestHandler, LastVisitedHotelSlider, GtmManager) {
	    if ($('[data-fcse-role=inline-click-modal]').length && $('[data-fcse-role=inline-modal-trigger]').length) {
	        // Initialize service modals
	        var inlineModalOnClick = new InlineModal('[data-fcse-role=inline-click-modal]', {
	            autoHide: false,
	            hideOnLeave: false,
	            triggerEventName: 'click'
	        });
	    }
	
	    if ($('[data-fcse-role=inline-modal]').length) {
	        var inlineModal = new InlineModal('[data-fcse-role=inline-modal]', {
	            autoHide: false,
	            hideOnLeave: false,
	            triggerEventName: 'mouseover'
	        });
	    }
	
	    var requestHandler = new MultiRequestHandler();
	    var favoritesHandler = new FavoritesHandler(requestHandler);
	    var lastVisitedHotels = new LastVisitedHotelSlider('[data-fcse-role="last-visited-hotels-slider"]', { route: 'allt_frontend.user_tracking.last_visited' });
	
	    $('#navbar [data-fcse-role="navbar-container"]').on('follow.navbar-menu', '[data-toggle="navbar-menu"]', function (e) {
	        $('body').trigger('gtm.analyticsEvent', { source: 'navbarToggle', event: e });
	    });
	
	    GtmManager.initEventTracker({});
	
	    var Common = function Common() {};
	
	    return Common;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Airline filter component.
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(3), __webpack_require__(4), __webpack_require__(2), __webpack_require__(143)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, _, Widget, Object) {
	
	    /**
	     * Constructor
	     * @param element
	     * @constructor
	     */
	    var AirlineFilter = function AirlineFilter(element) {
	        var self = this;
	        // %3B = ';'
	        this._paramSeparator = ';';
	        this._valueToString = function (value) {
	            return _.isArray(value) ? value.join(self._paramSeparator) : value;
	        };
	        this._valueToArray = function (value) {
	            return _.isString(value) ? value.split(self._paramSeparator) : value;
	        };
	        Widget.apply(this, arguments);
	
	        // Store element
	        this.element = $(element);
	        this._init();
	        this.setValueToUi();
	    };
	
	    AirlineFilter.prototype = $.extend(Object.create(Widget.prototype), {
	        /**
	         * Initialize AirlineFilter
	         *
	         * @private
	         */
	        _init: function _init() {
	            this._registerClickHandler();
	        },
	
	        /**
	         * Registers event handlers
	         * @private
	         */
	        _registerClickHandler: function _registerClickHandler() {
	            var self = this;
	            $('[fcse-data-role="airline-filter-item"]', this.element).click(function (e) {
	                e.stopPropagation();
	
	                var checkbox = $('.list-checkbox--checkbox', this),
	                    value;
	
	                checkbox.prop('checked', checkbox.is(':checked'));
	                value = self.getValueFromUi();
	
	                if (value.excludedAirline.length > 0) {
	                    $.cookie("excludedAirline", value.excludedAirline.join(self._paramSeparator), {
	                        path: '/', //The value of the path attribute of the cookie
	                        secure: false
	                    });
	                } else {
	                    $.removeCookie("excludedAirline", {
	                        path: '/', //The value of the path attribute of the cookie
	                        secure: false
	                    });
	                }
	                // Setting value only after cookies are set
	                self.setValue(value);
	            });
	        },
	
	        /**
	         * {@inheritdoc}
	         */
	        setValueToUi: function setValueToUi() {
	            var value = this._decodeValue(this.value);
	
	            $('[fcse-data-role="airline-filter-item"]', this.element).each(function () {
	                var filterItem = $(this),
	                    checkbox = $('.list-checkbox--checkbox', filterItem);
	
	                if (value.excludedAirline && $.inArray(filterItem.data('value'), value.excludedAirline) >= 0) {
	                    checkbox.prop('checked', false);
	                } else {
	                    checkbox.prop('checked', true);
	                }
	            });
	        },
	
	        /**
	         * {@inheritdoc}
	         */
	        getValueFromUi: function getValueFromUi() {
	            var params = {
	                airlineCodes: [],
	                excludedAirline: []
	            };
	
	            $('[fcse-data-role="airline-filter-item"]', this.element).each(function () {
	                var filterItem = $(this);
	                var checkbox = $('.list-checkbox--checkbox', filterItem);
	
	                if (checkbox.is(':checked')) {
	                    params.airlineCodes.push(filterItem.data('value'));
	                } else {
	                    params.excludedAirline.push(filterItem.data('value'));
	                }
	            });
	
	            return params;
	        },
	
	        /**
	         * Sets value with encode, we do not want to allow arrays in query
	         * @param value
	         */
	        setValue: function setValue(value) {
	            Widget.prototype.setValue.call(this, this._encodeValue(value));
	        },
	
	        /**
	         * Value encoder
	         * @param value
	         * @returns {*}
	         * @private
	         */
	        _encodeValue: function _encodeValue(value) {
	            return this._valueConvertor(value, this._valueToString);
	        },
	
	        /**
	         * Value decoder
	         * @param value
	         * @returns {*}
	         * @private
	         */
	        _decodeValue: function _decodeValue(value) {
	            return this._valueConvertor(value, this._valueToArray);
	        },
	
	        /**
	         * Basic value converter
	         * @param value
	         * @param convertor
	         * @returns {{}}
	         * @private
	         */
	        _valueConvertor: function _valueConvertor(value, convertor) {
	            var result = {};
	
	            if (_.isObject(value)) {
	                // Converting array values to strings understandable by server mappers
	                _.each(value, function (val, key) {
	                    if (val) {
	                        val = convertor(val);
	                    }
	                    result[key] = val;
	                });
	            }
	            return result;
	        }
	    });
	
	    return AirlineFilter;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Offerlist component.
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(3), __webpack_require__(4), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, _, Widget, Object) {
	
	    var Checkbox = function Checkbox(element) {
	        Widget.apply(this, arguments);
	
	        // Store element
	        this.element = $(element);
	
	        this._init();
	    };
	
	    Checkbox.prototype = $.extend(Object.create(Widget.prototype), {
	
	        /**
	         * Initialize Checkbox
	         *
	         * @private
	         */
	        _init: function _init() {
	            var self = this;
	            $(this.element).on('change', function () {
	                self.setValue(this.checked ? 0 : 10000);
	            });
	        },
	        setValueToUi: function setValueToUi() {}
	    });
	
	    return Checkbox;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(3), __webpack_require__(162), __webpack_require__(2), __webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, _, FacetsMixin, Object, Widget) {
	
	  var Checklist = function Checklist(element, options) {
	    Widget.apply(this, arguments);
	
	    //Default options
	    var defaultOptions = {
	      'selectedClassName': 'is-selected',
	      'disabledClassName': 'is-disabled',
	      'facetProperty': null
	    };
	    this.addOptions(defaultOptions, options);
	
	    this._registerClickEvent();
	  };
	
	  Checklist.prototype = $.extend(Object.create(Widget.prototype), FacetsMixin, {
	    /**
	     * Returns the facets
	     */
	    getFacets: function getFacets() {},
	
	    /**
	     * Applys the facets to the widget
	     * @param {type} facets
	     * @returns {undefined}
	     */
	    setFacets: function setFacets(facets) {
	      // If no facets are set, nothing has to be done here.
	      if (!facets) {
	        return;
	      }
	
	      var self = this;
	      this._facets = facets;
	
	      //Update facet
	      //$('[data-fcse-role="checkboxbutton--facet"]', this.element).text(0);
	
	      $('[data-value]', this.element).each($.proxy(function (index, element) {
	        var code = $(element).attr('data-value');
	        if (this._facets.hasOwnProperty(code)) {
	          if (this._facets[code] > 0) {
	            $(element).removeClass(this.option('disabledClassName'));
	          } else {
	            $(element).removeClass(this.option('selectedClassName'));
	            $('input[type=checkbox]', element).prop('checked', false);
	            $(element).addClass(this.option('disabledClassName'));
	          }
	          $('[data-fcse-role="checkboxbutton--facet"]', element).text(this._facets[code]);
	        }
	      }, this));
	    },
	
	    /**
	     * Gets the values and triggers them
	     */
	    _getAndTriggerValues: function _getAndTriggerValues() {
	      var value = [];
	      $('[data-value]', this.element).each(function (index, element) {
	        if ($(element).find('input:checkbox').is(':checked')) {
	          value.push($(element).attr('data-value'));
	        }
	      });
	
	      if (!_.isEqual(this.value, value)) {
	        this.setValue(value);
	      }
	    },
	
	    /**
	     * Register click event handler
	     * @returns {undefined}
	     */
	    _registerClickEvent: function _registerClickEvent() {
	      var self = this;
	      $('[data-value]', this.element).on("click", function (e) {
	        var $target = $(this);
	        if ($target.hasClass(self.option('disabledClassName'))) {
	          e.preventDefault();
	          return;
	        }
	
	        var selected = false;
	        if (!$target.hasClass(self.option('selectedClassName'))) {
	          selected = true;
	        }
	        e.preventDefault();
	        e.stopImmediatePropagation();
	        $('input:checkbox', $target).prop('checked', selected ? 'checked' : null);
	
	        self._getAndTriggerValues();
	      });
	
	      /**
	       * Click event for the checkboxes
	       * Fix for this problem: Checkbox being checked twice when inside an li with a click event
	       */
	      $('input[type=checkbox]', this.element).on('click', function (e) {
	        e.stopPropagation();
	        self._getAndTriggerValues();
	      });
	    },
	
	    getValueFromUi: function getValueFromUi() {
	      var value = [];
	      $('[data-value]', this.element).each(function (index, element) {
	        if ($(element).find('input:checkbox').is(':checked')) {
	          value.push($(element).attr('data-value'));
	        }
	      });
	      return value;
	    },
	
	    setValueToUi: function setValueToUi() {
	      var self = this;
	      $('[data-value]', this.element).each(function (index, element) {
	        var $element = $(element);
	        if ($.inArray($element.attr('data-value'), self.getValue()) !== -1) {
	          $element.addClass(self.option('selectedClassName'));
	          $('input[type=checkbox]', $element).prop('checked', true);
	          $(self.option('checkboxSelector'), $element).addClass(self.option('checkboxSelectedClassName'));
	        } else {
	          $element.removeClass(self.option('selectedClassName'));
	          $('input[type=checkbox]', $element).prop('checked', false);
	          $(self.option('checkboxSelector'), $element).removeClass(self.option('checkboxSelectedClassName'));
	        }
	      });
	    },
	
	    formatValue: function formatValue() {
	      var self = this;
	      var result = '';
	      if (!(this.value && this.value.length)) {
	        return this.element.data('any');
	      }
	      if (this.value.length === 1) {
	        result = $('[data-value="' + this.value[0] + '"][data-label]', this.element).data('label');
	      } else {
	        result = this.element.data('plural').replace('%count%', this.value.length);
	      }
	      return result;
	    }
	  });
	
	  return Checklist;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	}();

	;

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(3), __webpack_require__(85), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, _, LocationWidget, Object) {
	
	    var DestinationWidgetExtended = function DestinationWidgetExtended(element, options) {
	        // Call Constructor of parent class
	        LocationWidget.apply(this, arguments);
	
	        var defaultOptions = {
	            labelCountPrefix: this.element.data('label-count-prefix')
	        };
	
	        // Add default options and custom options
	        this.addOptions(defaultOptions, options);
	
	        // Regsiter All Locations Click Event
	        this._registerAllLocationsClickEvent();
	    };
	
	    DestinationWidgetExtended.prototype = $.extend(Object.create(LocationWidget.prototype), {
	        // All Locations Click Handler
	        _registerAllLocationsClickEvent: function _registerAllLocationsClickEvent() {
	            $('[data-fcse-role="locationwidget--alllocations"]', this.element).on('click', $.proxy(this._allLocationsClickEvent, this));
	        },
	
	        _allLocationsClickEvent: function _allLocationsClickEvent() {
	            // Un-Check all other checkboxes
	            $('[data-fcse-role="locationwidget--mainoption"], [data-fcse-role="locationwidget--option"]').find('[data-fcse-role="locationwidget--cbx"]').prop('checked', false);
	
	            // Remove-Tags
	            var tagBar = $('[data-fcse-role="locationwidget--tagbar"]', this.element);
	            tagBar.find('[data-fcse-role="locationwidget--tagitem"]').remove();
	
	            // Show Default value of Tagbar and Check AllLocations-Checkbox
	            this._showHideTagsPrompt();
	        },
	
	        // Override RegisterOptionsClickEvent
	        _registerOptionsClickEvent: function _registerOptionsClickEvent() {
	            var self = this;
	
	            $('[data-fcse-role="locationwidget--mainoption"], [data-fcse-role="locationwidget--option"]', this.element).on("click", function (e) {
	                var $this = $(this);
	                var cbx = $('[data-fcse-role="locationwidget--cbx"]:first', $this);
	                var isCbx = $(e.target).is('[data-fcse-role="locationwidget--cbx"]');
	                var isChecked = isCbx ? cbx.is(':checked') : !cbx.is(':checked');
	                var isMainSelected = false;
	
	                if (!isCbx) {
	                    return;
	                }
	
	                if ($this.is('[data-fcse-role="locationwidget--mainoption"]')) {
	                    var checkSubCheckboxes;
	                    if ($this.find('[data-fcse-role="locationwidget--cbx"]:first').is(':checked')) {
	                        checkSubCheckboxes = true;
	                    } else {
	                        checkSubCheckboxes = false;
	                    }
	
	                    // Check/Un-Check all options every time mainoption is clicked.
	                    self._getContentElement('data-group-id', $this.data('id')).find('[data-fcse-role="locationwidget--cbx"]').each(function (i, item) {
	                        $(item).prop('checked', checkSubCheckboxes);
	                    });
	                } else {
	                    var mainCheckbox = $('[data-fcse-role="locationwidget--mainoption"][data-id="' + $this.data('group-id') + '"] [data-fcse-role="locationwidget--cbx"]:first', self.element);
	                    isMainSelected = mainCheckbox.is(':checked');
	
	                    if (isMainSelected) {
	                        // Un-Check MainCheckbox of clicked Checkbox
	                        mainCheckbox.prop('checked', false);
	                        self._removeTag($this.data('group-id'));
	                        isMainSelected = false;
	
	                        // Un-Check clicked Checkbox
	                        cbx.prop('checked', false);
	
	                        // Add Tags for all active elements
	                        self._getContentElement('data-group-id', $this.data('group-id')).find('[data-fcse-role="locationwidget--cbx"]:checked').each(function (i, item) {
	                            self._addTag($(item).closest('[data-fcse-role="locationwidget--option"]').data('id'));
	                        });
	
	                        e.preventDefault();
	                    }
	                }
	
	                if (!isMainSelected) {
	                    isChecked ? self._addTag($this.data('id')) : self._removeTag($this.data('id'));
	                }
	                e.stopPropagation();
	            });
	
	            $('[data-fcse-role="locationwidget--mainoption"] .list-main-option', this.element).on("click", function (e) {
	                var $this = $(this);
	                var $target = $(e.target);
	
	                if ($target.is('.list-sub-option') || $target.parents('.list-sub-option').length) {
	                    return;
	                }
	
	                var isCbx = $(e.target).is('[data-fcse-role="locationwidget--cbx"]');
	                var list = $this.find('.list-checkbox--option');
	                var icon = $this.find('.icon');
	
	                if (!isCbx) {
	                    list.toggle();
	                    icon.toggleClass('icon-arrow-bottom icon-arrow-top');
	                } else {
	                    var cbx = $('[data-fcse-role="locationwidget--cbx"]:first', $this);
	                    var isChecked = isCbx ? cbx.is(':checked') : !cbx.is(':checked');
	
	                    if (isChecked) {
	                        list.show();
	                        icon.removeClass('icon-arrow-bottom').addClass('icon-arrow-top');
	                    }
	                }
	            });
	        },
	
	        // Override RegisterRemoveFromTabBarClickEvent
	        _registerRemoveFromTagBarClickEvent: function _registerRemoveFromTagBarClickEvent() {
	            var self = this;
	
	            $('[data-fcse-role="locationwidget--tagbar"]', this.element).on('click', '[data-fcse-role="locationwidget--tagitemremovebtn"]', function (e) {
	                e.preventDefault();
	                e.stopPropagation();
	
	                var id = $(this).closest('[data-tag-id]').data('tag-id');
	
	                // Un-Check Checkbox from directly related element
	                self._getContentElement('data-id', id).find('[data-fcse-role="locationwidget--cbx"]').prop('checked', false);
	
	                // Un-Check Checkbox from elements, that are part of the related group
	                self._getContentElement('data-group-id', id).find('[data-fcse-role="locationwidget--cbx"]').prop('checked', false);
	
	                // Remove Tag
	                self._removeTag(id);
	            });
	        },
	
	        // Override ShowHideTagsPrompt
	        _showHideTagsPrompt: function _showHideTagsPrompt() {
	            var defaultTag = $('[data-fcse-role="locationwidget--defaulttagitem"]', this.element);
	
	            if (!$('[data-fcse-role="locationwidget--tagitem"]', this.element).filter(':not([data-tag-id="{TAG_ID}"])').length) {
	                // Show Default-Tag
	                defaultTag.show();
	
	                // Check All Locations-Checkbox
	                $('[data-fcse-role="locationwidget--alllocations"]', this.element).find('[data-fcse-role="locationwidget--cbx"]').prop('checked', true);
	            } else {
	                // Hide Default-Tag
	                defaultTag.hide();
	
	                // Un-Check All Locations-Checkbox
	                $('[data-fcse-role="locationwidget--alllocations"]', this.element).find('[data-fcse-role="locationwidget--cbx"]').prop('checked', false);
	            }
	        },
	
	        // Set Value To UI
	        setValueToUi: function setValueToUi() {
	            var self = this;
	            var valueArray = this.value;
	
	            $('[data-fcse-role="locationwidget--tagitem"]', this.element).filter(':not([data-tag-id="{TAG_ID}"])').remove();
	
	            $('[data-fcse-role="locationwidget--cbx"]', this.element).each(function (i, item) {
	                $(item).prop('checked', false);
	            });
	
	            _.each(valueArray, function (value, key) {
	                var options = self._getContentElement('data-value', value);
	
	                options.find('[data-fcse-role="locationwidget--cbx"]').prop('checked', true);
	
	                _.each(options, function (item) {
	                    var $item = $(item);
	                    // If Main-Option is selected, all other Sub-Checkboxes must be also checked
	                    if ($item.attr('data-fcse-role') == 'locationwidget--mainoption') {
	                        $item.parent().find('[data-fcse-role="locationwidget--option"][data-group-id="' + $item.data('id') + '"]').find('[data-fcse-role="locationwidget--cbx"]').prop('checked', true);
	                    }
	                });
	
	                self._addTag(options.data('id'));
	            });
	
	            this._showHideTagsPrompt();
	        },
	
	        // Override FormatValue
	        formatValue: function formatValue() {
	            if (!_.isUndefined(this.getValue()) && this.getValue().length > 1) {
	                //                        var count = 0;
	                //                        
	                //                        // Count elements
	                //                        $.each(this.getValue(), function(index, item) {
	                //                            var $item = $('[data-value="'+item+'"]', this.element);
	                //                            var groupElements = $('[data-fcse-role="locationwidget--option"][data-group-id="'+
	                //                                              $item.data('id') +'"]', this.element);                            
	                //                            
	                //                            if(groupElements.length >= 1) { // Is Main-Option
	                //                                count = count + groupElements.length;
	                //                            } else { // Is single Option
	                //                                count++;
	                //                            }
	                //                        });
	
	                var labelCountPrefix = this.option('labelCountPrefix');
	                if (labelCountPrefix.length >= 1) {
	                    labelCountPrefix += " ";
	                }
	                return labelCountPrefix + this.getValue().length + " " + this.option('labelCount');
	            } else if (_.isUndefined(this.getValue()) || this.getValue().length == 0) {
	                return this.option('labelNoCount');
	            } else {
	                return this._getContentElement('data-value', this.getValue()[0]).data('name');
	            }
	        }
	    });
	
	    return DestinationWidgetExtended;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(3), __webpack_require__(4), __webpack_require__(2), __webpack_require__(34), __webpack_require__(87), __webpack_require__(81), __webpack_require__(84), __webpack_require__(82), __webpack_require__(83)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, _, Widget, Object, Dropdown, RatingWidget, GlobalTypeWidget, SearchWidget, PriceSliderRangeWidget, RatingSliderRangeWidget) {
	
	  var ExtendedSearchWidget = function ExtendedSearchWidget(element, options) {
	    Widget.apply(this, arguments);
	
	    //Set options
	    var defaultOptions = {};
	
	    this.addOptions(defaultOptions, options);
	    this._init();
	  };
	
	  ExtendedSearchWidget.prototype = $.extend(Object.create(Widget.prototype), {
	    _init: function _init() {
	      var options = this.getOptions();
	      /*var hotelSearch = new SearchWidget('#searchmask-search-widget',
	        {
	          rootScope: options.scopes.rootScope,
	          useHeader: true,
	          useRootScopeParams: ['groupNames', 'category', 'hotelAttributes']
	        },
	        options.scopes.localScope,
	        true);*/
	
	      // this._excludedWidgetKeys = ['globalTypes', 'minPrice', 'maxPrice', 'minRating', 'maxRating'];
	      this._excludedWidgetKeys = ['globalTypes', 'minPrice', 'maxPrice'];
	
	      var priceRangeWidget = new PriceSliderRangeWidget('#widget-price-range');
	      // var ratingRangeWidget = new RatingSliderRangeWidget('#widget-rating-range');
	
	      this._widgets = {
	        /*'hotelName': null,*/
	        'room': new Dropdown('#widget-room'),
	        'board': new Dropdown('#widget-board'),
	        'rating': new RatingWidget('#widget-rating'),
	        'minPrice': priceRangeWidget,
	        'maxPrice': priceRangeWidget,
	        /*'minRating' : ratingRangeWidget,
	        'maxRating' : ratingRangeWidget,*/
	        'category': new RatingWidget('#widget-category'),
	        'globalTypes': new GlobalTypeWidget('[data-fcse-role="globaltypewidget"]')
	      };
	
	      this.setValue(this.getValueFromUi());
	    },
	
	    getValueFromUi: function getValueFromUi() {
	      var result = {};
	
	      _.each(this._widgets, function (value, key) {
	        if (!value) {
	          return;
	        }
	        if (key === 'minPrice' || key == 'maxPrice') {
	          result = $.extend(result, key === 'minPrice' ? { minPrice: value.getValue()[0] } : { maxPrice: value.getValue()[1] });
	        } else if (key === 'minRating' || key == 'maxRating') {
	          result = $.extend(result, key === 'minRating' ? { minRating: value.getValue()[0] } : { maxRating: value.getValue()[1] });
	        } else if (key === 'globalTypes') {
	          result = $.extend(result, value.getValue());
	        } else {
	          result[key] = value.getValue();
	        }
	      });
	      return result;
	    },
	
	    setValueToUi: function setValueToUi() {
	      var self = this;
	      var value = this.getValue();
	      var valueKeys = _.keys(value);
	      var widgetKeys = _.keys(this._widgets);
	      delete widgetKeys['globalTypes'];
	
	      var gtValue = {};
	      var gtKeys = _.difference(valueKeys, widgetKeys);
	
	      if (gtKeys.length) {
	        _.each(gtKeys, function (key) {
	          gtValue[key] = value[key];
	        });
	      }
	      _.each(value, function (value, key) {
	        if (!self._widgets[key]) {
	          return;
	        }
	        if (_.indexOf(self._excludedWidgetKeys, key) === -1) {
	          self._widgets[key].setValue(value);
	        }
	      });
	      this._widgets.globalTypes.setValue(gtValue);
	      this._widgets.minPrice.setValue([value.minPrice, value.maxPrice]);
	      // this._widgets.minRating.setValue([value.minRating, value.maxRating]);
	    }
	  });
	
	  return ExtendedSearchWidget;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	}();

	;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(3), __webpack_require__(4), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, _, Widget, Object) {
	
	    /**
	     * The HotelSearchWidget constructor
	     *
	     * @constructor
	     * @name HotelSearchWidget
	     * @extends Widget
	     * @param {String} element A CSS selector to the root element of the widget
	     * @param {Object} [options] An optional options object
	     */
	    var HotelSearchWidget = function HotelSearchWidget(element, options) {
	        Widget.apply(this, arguments);
	        if (this.element.length === 0) {
	            return;
	        }
	        var defaultOptions = {
	            triggerRedirect: false,
	            rootScope: null
	        };
	
	        // Add default options and custom options
	        this.addOptions(defaultOptions, options);
	
	        // Startup
	        this._init();
	    };
	
	    HotelSearchWidget.prototype = /** @lends HotelSearchWidget */$.extend(Object.create(Widget.prototype), {
	
	        /**
	         * A reference to the input field
	         *
	         * @type {jQuery}
	         */
	        searchField: null,
	
	        /**
	         * A reference to the submit button
	         *
	         * @type {jQuery}
	         */
	        submitButton: null,
	
	        /**
	         * The current query string
	         *
	         * @type {String}
	         */
	        currentQuery: '',
	
	        /**
	         * The place holder string
	         *
	         * @type {String}
	         */
	        placeholder: '',
	
	        /**
	         * The base route to redirect to
	         *
	         * @type {String}
	         */
	        redirectTarget: '',
	
	        /**
	         * Runs widget startup
	         *
	         * @returns {void}
	         * @private
	         */
	        _init: function _init() {
	            this._obtainNodeReferences();
	            this._runConnections();
	
	            this.placeholder = this.element.data('placeholder');
	            this.redirectTarget = this.element.data('redirect-target');
	
	            this.setValueToUi();
	        },
	
	        /**
	         * Gathers node references
	         *
	         * @returns {void}
	         * @private
	         */
	        _obtainNodeReferences: function _obtainNodeReferences() {
	            this.submitButton = $('[data-fcse-role="hotelsearch-submit"]', this.element);
	            this.searchField = $('[data-fcse-role="hotelsearch-input"]', this.element);
	        },
	
	        /**
	         * Runs event connections
	         *
	         * @returns {void}
	         * @private
	         */
	        _runConnections: function _runConnections() {
	            this.submitButton.on('click', $.proxy(this._onSubmitButtonClick, this));
	            this.searchField.on('focus', $.proxy(this._onSearchFieldFocus, this));
	            this.searchField.on('blur', $.proxy(this._onSearchFieldBlur, this));
	            this.searchField.on('keydown', $.proxy(this._onSearchFieldKeyDown, this));
	        },
	
	        /**
	         * Called when the user clicks on the submit button. Set's the value to
	         * scope if it is a non-empty user entered value.
	         *
	         * @param {jQuery.Event} evt The jQuery click event
	         * @returns {void}
	         * @private
	         */
	        _onSubmitButtonClick: function _onSubmitButtonClick(evt) {
	            evt.stopImmediatePropagation();
	            evt.preventDefault();
	
	            this._updateHotelNameQuery();
	        },
	
	        /**
	         * Called when user focuses the search field. Handles placeholder
	         * placement.
	         *
	         * @returns {void}
	         * @private
	         */
	        _onSearchFieldFocus: function _onSearchFieldFocus() {
	            if (_.isObject(this.searchField)) {
	                if (this._getTrimmedSearchFieldValue() == this.placeholder) {
	                    this.searchField.val('');
	                }
	            }
	        },
	
	        /**
	         * Called when user leaves the search field. Handles placeholder
	         * placement and triggers a value update.
	         *
	         * @returns {void}
	         * @private
	         */
	        _onSearchFieldBlur: function _onSearchFieldBlur() {
	            if (_.isObject(this.searchField)) {
	                if (!this._getTrimmedSearchFieldValue().length) {
	                    this.searchField.val(this.placeholder);
	                }
	            }
	
	            this._updateHotelNameQuery();
	        },
	
	        /**
	         * Monitors key presses on the search field. Will call the submit
	         * handler if the return key is pressed.
	         *
	         * @param {jQuery.Event} evt The keydown event
	         * @returns {void}
	         * @private
	         */
	        _onSearchFieldKeyDown: function _onSearchFieldKeyDown(evt) {
	            if (evt.which == 13) {
	                this.searchField.blur();
	                this._onSubmitButtonClick(evt);
	            }
	        },
	
	        /**
	         * Updates the scope object with the value present in the search field.
	         *
	         * @returns {void}
	         * @private
	         */
	        _updateHotelNameQuery: function _updateHotelNameQuery() {
	            var hotelNameQuery = this._getTrimmedSearchFieldValue();
	
	            if (hotelNameQuery == this.placeholder) {
	                hotelNameQuery = '';
	            }
	
	            if (!hotelNameQuery.length) {
	                // TODO: We may want to handle empty queries here differently.
	                // However, as I see it, it's the only way to reset a hotel
	                // name search.
	            }
	            this.currentQuery = hotelNameQuery;
	
	            if (this._options.triggerRedirect && !!this.currentQuery.length) {
	                var rootScopeQuery = $.extend(this._options.rootScope.getQuery(), {
	                    'hotelName': hotelNameQuery
	                }),
	                    url = this.redirectTarget + '?' + $.param(rootScopeQuery);
	
	                window.location.href = url;
	            } else {
	                this.setValue(hotelNameQuery);
	            }
	        },
	
	        /**
	         * Returns the trimmed search field value
	         *
	         * @returns {String} The trimmed search field value
	         * @private
	         */
	        _getTrimmedSearchFieldValue: function _getTrimmedSearchFieldValue() {
	            if (!_.isObject(this.searchField)) {
	                return '';
	            }
	            return $.trim(this.searchField.val());
	        },
	
	        /**
	         * Sets the scope value to the search field
	         *
	         * @returns {void}
	         */
	        setValueToUi: function setValueToUi() {
	            this.currentQuery = this.getValue();
	            if (_.isObject(this.searchField)) {
	                this.searchField.val(this.currentQuery.length ? this.currentQuery : this.placeholder);
	            }
	        },
	
	        /**
	         * Returns the current hotel name search query
	         *
	         * @returns {String} The hotel name search query
	         */
	        getValueFromUi: function getValueFromUi() {
	            return this.currentQuery;
	        }
	    });
	
	    return HotelSearchWidget;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(3), __webpack_require__(85), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, _, LocationWidget, Object) {
	
	    var LocationWidgetExtended = function LocationWidgetExtended(element, options) {
	        // Call Constructor of parent class
	        LocationWidget.apply(this, arguments);
	
	        var defaultOptions = {
	            labelCountPrefix: this.element.data('label-count-prefix')
	        };
	
	        // Add default options and custom options
	        this.addOptions(defaultOptions, options);
	
	        // Regsiter All Locations Click Event
	        this._registerAllLocationsClickEvent();
	    };
	
	    LocationWidgetExtended.prototype = $.extend(Object.create(LocationWidget.prototype), {
	        // All Locations Click Handler
	        _registerAllLocationsClickEvent: function _registerAllLocationsClickEvent() {
	            $('[data-fcse-role="locationwidget--alllocations"]', this.element).on('click', $.proxy(this._allLocationsClickEvent, this));
	        },
	
	        _allLocationsClickEvent: function _allLocationsClickEvent() {
	            // Un-Check all other checkboxes
	            $('[data-fcse-role="locationwidget--mainoption"], [data-fcse-role="locationwidget--option"]').find('[data-fcse-role="locationwidget--cbx"]').prop('checked', false);
	
	            // Remove-Tags
	            var tagBar = $('[data-fcse-role="locationwidget--tagbar"]', this.element);
	            tagBar.find('[data-fcse-role="locationwidget--tagitem"]').remove();
	
	            // Show Default value of Tagbar and Check AllLocations-Checkbox
	            this._showHideTagsPrompt();
	        },
	
	        // Override RegisterOptionsClickEvent
	        _registerOptionsClickEvent: function _registerOptionsClickEvent() {
	            var self = this;
	
	            $('[data-fcse-role="locationwidget--mainoption"], [data-fcse-role="locationwidget--option"]', this.element).on("click", function (e) {
	                var $this = $(this);
	                var cbx = $('[data-fcse-role="locationwidget--cbx"]', $this);
	                var isCbx = $(e.target).is('[data-fcse-role="locationwidget--cbx"]');
	                var isChecked = isCbx ? cbx.is(':checked') : !cbx.is(':checked');
	                var isMainSelected = false;
	
	                if ($this.is('[data-fcse-role="locationwidget--mainoption"]')) {
	                    var checkSubCheckboxes;
	                    if ($this.find('[data-fcse-role="locationwidget--cbx"]').is(':checked')) {
	                        checkSubCheckboxes = true;
	                    } else {
	                        checkSubCheckboxes = false;
	                    }
	
	                    // If main-option is of type region
	                    if ($this.data('type') == 'region') {
	                        // Check/Un-Check all options every time region-mainoption is clicked.
	                        self._getContentElement('data-group-id', $this.data('id')).find('[data-fcse-role="locationwidget--cbx"]').each(function (i, item) {
	                            $(item).prop('checked', checkSubCheckboxes);
	                        });
	                        // if main-option is of type country
	                    } else if ($this.data('type') == 'country') {
	                        // Un-Check all options every time country-mainoption is clicked and remove the related tag.
	                        self._getContentElement('data-country-id', $this.data('id')).find('[data-fcse-role="locationwidget--cbx"]').each(function (i, item) {
	                            var $item = $(item);
	
	                            // Uncheck Option
	                            $item.prop('checked', false);
	
	                            // Remove Tag
	                            self._removeTag($item.closest('[data-fcse-role="locationwidget--mainoption"], [data-fcse-role="locationwidget--option"]').data('id'));
	                        });
	                    }
	                } else {
	                    var mainCheckbox = $('[data-fcse-role="locationwidget--mainoption"][data-id="' + $this.data('group-id') + '"][data-type="region"] [data-fcse-role="locationwidget--cbx"]', self.element);
	                    isMainSelected = mainCheckbox.is(':checked');
	
	                    if (isMainSelected) {
	                        // Un-Check MainCheckbox of clicked Checkbox
	                        mainCheckbox.prop('checked', false);
	                        self._removeTag($this.data('group-id'));
	                        isMainSelected = false;
	
	                        // Un-Check clicked Checkbox
	                        cbx.prop('checked', false);
	
	                        // Add Tags for all active elements
	                        self._getContentElement('data-group-id', $this.data('group-id')).find('[data-fcse-role="locationwidget--cbx"]:checked').each(function (i, item) {
	                            self._addTag($(item).closest('[data-fcse-role="locationwidget--option"]').data('id'));
	                        });
	
	                        e.preventDefault();
	                    } else if (!isCbx) {
	                        cbx.prop('checked', isChecked);
	                        e.preventDefault();
	                    }
	                }
	
	                // Uncheck Country-Mainoption
	                self._getContentElement('data-id', $this.data('country-id')).find('[data-fcse-role="locationwidget--cbx"]').prop('checked', false);
	
	                // Remove Tag for Country-Mainoption
	                self._removeTag($this.data('country-id'));
	
	                if (!isMainSelected) {
	                    isChecked ? self._addTag($this.data('id')) : self._removeTag($this.data('id'));
	                }
	                e.stopPropagation();
	            });
	        },
	
	        // Override RegisterRemoveFromTabBarClickEvent
	        _registerRemoveFromTagBarClickEvent: function _registerRemoveFromTagBarClickEvent() {
	            var self = this;
	
	            $('[data-fcse-role="locationwidget--tagbar"]', this.element).on('click', '[data-fcse-role="locationwidget--tagitemremovebtn"]', function (e) {
	                e.preventDefault();
	                e.stopPropagation();
	
	                var id = $(this).closest('[data-tag-id]').data('tag-id');
	
	                // Un-Check Checkbox from directly related element
	                self._getContentElement('data-id', id).find('[data-fcse-role="locationwidget--cbx"]').prop('checked', false);
	
	                // Un-Check Checkbox from elements, that are part of the related group
	                self._getContentElement('data-group-id', id).find('[data-fcse-role="locationwidget--cbx"]').prop('checked', false);
	
	                // Remove Tag
	                self._removeTag(id);
	            });
	        },
	
	        // Override ShowHideTagsPrompt
	        _showHideTagsPrompt: function _showHideTagsPrompt() {
	            var defaultTag = $('[data-fcse-role="locationwidget--defaulttagitem"]', this.element);
	
	            if (!$('[data-fcse-role="locationwidget--tagitem"]', this.element).filter(':not([data-tag-id="{TAG_ID}"])').length) {
	                // Show Default-Tag
	                defaultTag.show();
	
	                // Check All Locations-Checkbox
	                $('[data-fcse-role="locationwidget--alllocations"]', this.element).find('[data-fcse-role="locationwidget--cbx"]').prop('checked', true);
	            } else {
	                // Hide Default-Tag
	                defaultTag.hide();
	
	                // Un-Check All Locations-Checkbox
	                $('[data-fcse-role="locationwidget--alllocations"]', this.element).find('[data-fcse-role="locationwidget--cbx"]').prop('checked', false);
	            }
	        },
	
	        // Set Value To UI
	        setValueToUi: function setValueToUi() {
	            var self = this;
	            var valueArray = this.value;
	
	            $('[data-fcse-role="locationwidget--tagitem"]', this.element).filter(':not([data-tag-id="{TAG_ID}"])').remove();
	
	            $('[data-fcse-role="locationwidget--cbx"]', this.element).each(function (i, item) {
	                $(item).prop('checked', false);
	            });
	
	            _.each(valueArray, function (value, key) {
	                var option = self._getContentElement('data-value', value);
	
	                option.find('[data-fcse-role="locationwidget--cbx"]').prop('checked', true);
	
	                // If Main-Option is selected, all other Sub-Checkboxes must be also checked
	                if (option.attr('data-fcse-role') == 'locationwidget--mainoption') {
	                    option.parent().find('[data-fcse-role="locationwidget--option"][data-group-id="' + option.data('id') + '"]').find('[data-fcse-role="locationwidget--cbx"]').prop('checked', true);
	                }
	
	                self._addTag(option.data('id'));
	            });
	
	            this._showHideTagsPrompt();
	        },
	
	        // Override FormatValue
	        formatValue: function formatValue() {
	            if (!_.isUndefined(this.getValue()) && this.getValue().length > 1) {
	                //                        var count = 0;
	                //                        
	                //                        // Count elements
	                //                        $.each(this.getValue(), function(index, item) {
	                //                            // Current Item
	                //                            var $item = $('[data-value="'+item+'"]', this.element);
	                //                            
	                //                            // Get Group-Elements
	                //                            var groupElements = $('[data-fcse-role="locationwidget--option"][data-group-id="'+
	                //                                              $item.data('id') +'"]', this.element);                            
	                //                            
	                //                            // Get Country-Elements
	                //                            var countryElements = $('[data-fcse-role="locationwidget--option"][data-country-id="'+
	                //                                              $item.data('id') +'"]', this.element);    
	                //                                      
	                //                            if(groupElements.length >= 1) { // Is Main-Option (Region)
	                //                                count = count + groupElements.length;
	                //                            } else if(countryElements.length >= 1) { // Is Main-Option (Country)
	                //                                count = count + countryElements.length;
	                //                            } else { // Is single Option
	                //                                count++;
	                //                            }
	                //                        });
	
	                var labelCountPrefix = this.option('labelCountPrefix');
	                if (labelCountPrefix.length >= 1) {
	                    labelCountPrefix += " ";
	                }
	                return labelCountPrefix + this.getValue().length + " " + this.option('labelCount');
	            } else if (_.isUndefined(this.getValue()) || this.getValue().length == 0) {
	                return this.option('labelNoCount');
	            } else {
	                return this._getContentElement('data-value', this.getValue()[0]).data('name');
	            }
	        }
	    });
	
	    return LocationWidgetExtended;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(4), __webpack_require__(2), __webpack_require__(63), __webpack_require__(62)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Widget, Object) {
	
	    var SliderFilterWidget = function SliderFilterWidget(selector, options) {
	        Widget.call(this, selector, $.extend({
	            handleClass: 'selector'
	        }, options));
	
	        this._init();
	    };
	
	    SliderFilterWidget.prototype = $.extend(Object.create(Widget.prototype), {
	
	        _init: function _init() {
	            var $control = $(this.element);
	
	            var self = this;
	            var slider = $control.find('.slider');
	
	            if (!slider.length) return;
	
	            var steps = $.parseJSON($control.attr('data-steps'));
	            var snaps = _.map(steps, function (step) {
	                return step.value;
	            });
	
	            this._nullValue = parseInt($control.data('null-value'));
	            this._nullValueText = $control.data('null-value-text');
	            this._valueTemplate = $control.data('value-template');
	            this._valuePostfix = $control.data('value-postfix');
	            this._label = $control.find('[data-fcse-role="slider-label"]');
	
	            this._internalNullValue = null;
	
	            // Replace null value internally to prevent weird slider behaviour with negative values
	            if (this._nullValue) {
	                if (snaps[snaps.length - 1] == this._nullValue) {
	                    this._internalNullValue = parseInt(snaps[snaps.length - 2]) + 100;
	                    snaps.pop();
	                    snaps.push(this._internalNullValue);
	                }
	            }
	
	            var value;
	
	            // Set value
	            if (this.getValue() === null || typeof this.getValue() === 'undefined') {
	                if (this._internalNullValue) {
	                    value = this._internalNullValue;
	                } else {
	                    value = snaps[0];
	                }
	            } else {
	                if (this.getValue() == this._nullValue) {
	                    value = this._internalNullValue;
	                } else {
	                    value = this.getValue();
	                }
	            }
	
	            var distribution = _.map(snaps, function (value) {
	                return parseInt(value);
	            });
	
	            slider.xslider({
	                min: parseInt(snaps[0]),
	                max: parseInt(snaps[snaps.length - 1]),
	                value: parseInt(value),
	                snaps: snaps,
	                distribution: distribution,
	                slide: function slide(event, ui) {
	                    if (ui.value == self._internalNullValue) {
	                        self._updateLabel(self._nullValue);
	                    } else {
	                        self._updateLabel(ui.value);
	                    }
	                },
	                stop: function stop(event, ui) {
	                    if (ui.value == self._internalNullValue) {
	                        self.setValue(self._nullValue);
	                    } else {
	                        self.setValue(ui.value);
	                    }
	                },
	                create: function create(event, ui) {
	                    $('.ui-slider-handle', this).addClass(self.option('handleClass'));
	                }
	            });
	        },
	
	        _processData: function _processData(value) {
	            if (value) {
	                return parseInt(value);
	            }
	        },
	
	        _updateLabel: function _updateLabel(value) {
	            if (this._label.length) {
	                var label = value;
	
	                if (value == this._nullValue) {
	                    label = this._nullValueText;
	                } else {
	                    if (this._valueTemplate) {
	                        label = this._valueTemplate.replace('%d', label);
	                    }
	                    if (this._valuePostfix) {
	                        label = label + '' + this._valuePostfix;
	                    }
	                }
	
	                this._label.text(label);
	            }
	        },
	
	        setValueToUi: function setValueToUi() {
	            if (this.value === null) {
	                return;
	            }
	
	            var slider = $(this.element).find('.slider');
	
	            if (this.value != slider.xslider('xvalue')) {
	                if (this.value == this._nullValue) {
	                    // Set internal null value to allow negative numbers
	                    slider.xslider('xvalue', this._internalNullValue);
	                } else {
	                    slider.xslider('xvalue', this.value);
	                }
	
	                this._updateLabel(this.value);
	            }
	        },
	        getValueFromUi: function getValueFromUi() {},
	        _formatValue: function _formatValue(value) {
	            return value == this._anyValue ? this._anyValueText : (value || this.value) + ' ' + this._valuePostfix;
	        }
	    });
	
	    return SliderFilterWidget;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _create = __webpack_require__(78);
	
	var _create2 = _interopRequireDefault(_create);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(3), __webpack_require__(4), __webpack_require__(14)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, _, Widget, Url) {
	
	    var TagBarSearch = function TagBarSearch(element, options, scope) {
	
	        var defaultOptions = {
	            tagBarWidget: null,
	            rootScope: null
	        };
	
	        options = $.extend({}, defaultOptions, options || {});
	
	        if (!options.tagBarWidget) {
	            throw new Error('Widget "tagBarWidget" is not defined');
	        }
	        if (!options.rootScope) {
	            throw new Error('Scope "rootScope" is not defined');
	        }
	
	        Widget.apply(this, [element, options]);
	
	        this._init();
	    };
	
	    TagBarSearch.prototype = $.extend((0, _create2.default)(Widget.prototype), {
	        _init: function _init() {
	            var self = this;
	            var tagBarWidget = this.option('tagBarWidget');
	
	            tagBarWidget.on('change', function () {
	                var value = self._getValueFromTagBar();
	                if (!_.isEqual(value, self.value)) {
	                    self.setValue(value);
	
	                    if (!value.hotelName) {
	                        self.element.addClass('is-hidden');
	                    }
	                }
	            });
	
	            this.setValue(this._getValueFromTagBar());
	        },
	
	        setValueToUi: function setValueToUi() {
	            var tagBarWidget = this.option('tagBarWidget');
	            tagBarWidget.setValue(this.value ? [this.value.hotelName] : []);
	        },
	
	        getValueFromUi: function getValueFromUi() {
	            return this._getValueFromTagBar();
	        },
	
	        _getValueFromTagBar: function _getValueFromTagBar() {
	            var tagBarWidget = this.option('tagBarWidget');
	            var barValue = tagBarWidget.getValue();
	            return {
	                hotelName: barValue && barValue.length ? barValue[0] : ''
	            };
	        },
	
	        getValue: function getValue() {
	            var urlObj = new Url();
	            var result = {};
	            var tagBarValue = this._getValueFromTagBar();
	            var hotelName = tagBarValue.hotelName;
	
	            if (hotelName && this.element.data('use-product-code')) {
	                result.productCode = hotelName;
	                result.hotelName = '';
	            } else if (hotelName && urlObj.query.productCode) {
	                result.productCode = urlObj.query.productCode;
	                result.hotelName = '';
	            } else {
	                result.hotelName = hotelName;
	                result.productCode = '';
	            }
	
	            return result;
	        }
	    });
	
	    return TagBarSearch;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(3), __webpack_require__(184), __webpack_require__(71), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, _, TravellersWidget, VisibilityControl, Object) {
	
	    var TravellersWidgetExtended = function TravellersWidgetExtended(element, options) {
	        // Initialize Visibility Controls
	        this._initVisibilityControls();
	
	        var defaultOptions = {
	            'disableClassName': 'is-disabled'
	        };
	
	        // Add default options and custom options
	        this.addOptions(defaultOptions, options);
	
	        // Call Constructor of parent class
	        TravellersWidget.apply(this, arguments);
	    };
	
	    TravellersWidgetExtended.prototype = $.extend(Object.create(TravellersWidget.prototype), {
	        _initVisibilityControls: function _initVisibilityControls() {
	            // Description
	            this.descriptionCallerElement = $('[data-fcse-role="travellers--description"]', this.element);
	            this.descriptionVisibilityControl = new VisibilityControl(this.descriptionCallerElement);
	
	            // More Adults
	            this.moreAdultsCallerElement = $('[data-fcse-role="travellers--moreadults"]', this.element);
	            this.moreAdultsVisibilityControl = new VisibilityControl(this.moreAdultsCallerElement);
	            this.moreAdultsCallerElement.on('click', $.proxy(this._moreAdultsCallerElementClick, this));
	
	            // Adults Limit
	            this.limitAdultsCallerElement = $('[data-fcse-role="travellerswidget"]', this.element);
	            this.limitAdultsVisibilityControl = new VisibilityControl(this.limitAdultsCallerElement);
	
	            // More Childs
	            this.moreChildsCallerElement = $('[data-fcse-role="travellers--morechilds"]', this.element);
	            this.moreChildsVisibilityControl = new VisibilityControl(this.moreChildsCallerElement);
	            this.moreChildsCallerElement.on('click', $.proxy(this._moreChildsCallerElementClick, this));
	
	            // Too many Childs Error
	            this.tooManyChildsCallerElement = $('[data-fcse-role="travellers--toomanychilds"]', this.element);
	            this.tooManyChildsVisibilityControl = new VisibilityControl(this.tooManyChildsCallerElement);
	        },
	
	        _moreAdultsCallerElementClick: function _moreAdultsCallerElementClick(e) {
	            // Stop Propagation / Prevent Default Handling
	            e.stopPropagation();
	            e.preventDefault();
	
	            // Close Dropdown
	            this.adultDropdown.closeDropdown();
	        },
	
	        _moreChildsCallerElementClick: function _moreChildsCallerElementClick(e) {
	            // Stop Propagation / Prevent Default Handling
	            e.stopPropagation();
	            e.preventDefault();
	
	            // Close Dropdown
	            this.childDropdown.closeDropdown();
	        },
	
	        // Override onAdultsChange
	        onAdultsChange: function onAdultsChange(event) {
	            // Call Parent-method
	            TravellersWidget.prototype.onAdultsChange.call(this, event);
	
	            if (this.adultDropdown.getValue() == this.option('moreAdultsValue')) {
	                // Open Visibility Control Target for Adults
	                this.moreAdultsVisibilityControl.openTarget(this.moreAdultsCallerElement, $(this.moreAdultsCallerElement.data('target')));
	            } else {
	                this.moreAdultsVisibilityControl.closeTarget(this.moreAdultsCallerElement, $(this.moreAdultsCallerElement.data('target')), event);
	            }
	
	            if (this.adultDropdown.getValue() == 3 || this.adultDropdown.getValue() == 4) {
	                this.limitAdultsVisibilityControl.openTarget(this.limitAdultsCallerElement, $('#widget-travellers--adults-limit'));
	            } else {
	                this.limitAdultsVisibilityControl.closeTarget(this.limitAdultsCallerElement, $('#widget-travellers--adults-limit'), event);
	            }
	
	            // Check Child Ages
	            this._checkChildAges();
	        },
	
	        // Override onChildrenChange
	        onChildrenChange: function onChildrenChange(event) {
	            // Call Parent-method
	            TravellersWidget.prototype.onChildrenChange.call(this, event);
	
	            // Set Default value to first item (which is for now '1') if no other dropdown item is selected
	            $.each(this.ageChooserList, function (id, ageDropdown) {
	                if (_.isUndefined(ageDropdown.getValue())) {
	                    ageDropdown.setValue(1); // Set value to 1
	                }
	            });
	
	            // Open/Close Description
	            if (this.childDropdown.getValue() >= 1) {
	                this.descriptionVisibilityControl.openTarget(this.descriptionCallerElement, $(this.descriptionCallerElement.data('target')));
	            } else {
	                this.descriptionVisibilityControl.closeTarget(this.descriptionCallerElement, $(this.descriptionCallerElement.data('target')));
	            }
	
	            if (this.childDropdown.getValue() == this.option('moreChildsValue')) {
	                // Open Visibility Control Target for Childs
	                this.moreChildsVisibilityControl.openTarget(this.moreChildsCallerElement, $(this.moreChildsCallerElement.data('target')));
	                // close the description
	                this.descriptionVisibilityControl.closeTarget(this.descriptionCallerElement, $(this.descriptionCallerElement.data('target')));
	            } else {
	                this.moreChildsVisibilityControl.closeTarget(this.moreChildsCallerElement, $(this.moreChildsCallerElement.data('target')));
	            }
	
	            // Check Child Ages
	            this._checkChildAges();
	        },
	
	        _getParentFlyout: function _getParentFlyout() {
	            return this.element.closest('[data-fcse-role="flyout"]');
	        },
	
	        _checkChildAges: function _checkChildAges() {
	            // Get All ChildAge-Dropdowns
	            var currentValueFromUi = this.getValueFromUi();
	
	            // Filter Children
	            var childrenWithAgeSmallerTwo = _.filter(currentValueFromUi.children, function (num) {
	                return num == 1;
	            });
	
	            if (childrenWithAgeSmallerTwo.length > currentValueFromUi.adults) {
	                // Handle too many Childss
	                this.tooManyChildsVisibilityControl.openTarget(this.tooManyChildsCallerElement, $(this.tooManyChildsCallerElement.data('target')));
	
	                $('[data-fcse-role="flyout--button-ok"]', this._getParentFlyout()).attr('disabled', 'disabled').addClass(this.option('disableClassName'));
	            } else {
	                this.tooManyChildsVisibilityControl.closeTarget(this.tooManyChildsCallerElement, $(this.tooManyChildsCallerElement.data('target')));
	
	                $('[data-fcse-role="flyout--button-ok"]', this._getParentFlyout()).removeAttr('disabled').removeClass(this.option('disableClassName'));
	            }
	            $.each(this.ageChooserList, function (i, dropdown) {
	                var selected = $('.dropdown--option.is-selected', dropdown.element);
	                if (selected.length > 0) {
	                    $('[data-fcse-role="dropdown--label"]', dropdown.element).html(selected.text());
	                }
	            });
	        },
	
	        onChildAgeChange: function onChildAgeChange(event) {
	            this._checkChildAges();
	        },
	
	        formatValue: function formatValue() {
	            var val = this.getValueFromUi();
	            var text = val.adults;
	
	            if (val.adults != 1) {
	                text += ' ' + this.option('adultLabelPlural');
	            } else {
	                text += ' ' + this.option('adultLabel');
	            }
	
	            if (val.children.length != 1) {
	                text += ', ' + val.children.length + ' ' + this.option('childLabelPlural');
	            } else {
	                text += ', ' + val.children.length + ' ' + this.option('childLabel');
	            }
	            return text;
	        },
	
	        /**
	         * Validate data and show errors
	         */
	        isValid: function isValid() {
	            // Call Parent-method
	            var result = TravellersWidget.prototype.isValid.call(this);
	
	            if (this.adultDropdown.getValue() == this.option('moreAdultsValue')) {
	                // decrease adult number
	                this.adultDropdown.setValue(this.option('moreAdultsValue') - 1);
	            }
	
	            if (this.childDropdown.getValue() == this.option('moreChildsValue')) {
	                // decrease child number
	                this.childDropdown.setValue(this.option('moreChildsValue') - 1);
	                result = false;
	            }
	
	            return result;
	        }
	    });
	
	    return TravellersWidgetExtended;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(3), __webpack_require__(8), __webpack_require__(4), __webpack_require__(2), __webpack_require__(34), __webpack_require__(71), __webpack_require__(197), __webpack_require__(37), __webpack_require__(179), __webpack_require__(180), __webpack_require__(181)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, _, moment, Widget, Object, Dropdown, VisibilityControl, PerfectScrollBar) {
	
	    var TravelPerdiodWidget = function TravelPerdiodWidget(element, options) {
	        Widget.apply(this, arguments);
	        var self = this;
	        var defaultOptions = {
	            'periodCaptionDatesClassName': 'widget-travelperiod--dates',
	            'periodCaptionDurationClassName': 'widget-travelperiod--duration',
	            'hiddenClassName': 'is-hidden',
	            'disableClassName': 'is-disabled',
	            'durationTypeExact': 'exact',
	            'durationTypeRange': 'range',
	            'valueAnyPeriod': '-1',
	            'captionIsHtml': true,
	            'submitOn': []
	        };
	        /* I18N
	         * 1. Use "" for english
	         * 2. The i18n package for a language for datepicker should be bound as dependency.
	         *    For ex.: for "de" use library/jquery-ui/ui/i18n/jquery.ui.datepicker-de.js
	         * 3. Extend the requirejs config so this file is properly shimed.
	         */
	        switch (window.locale) {
	            case 'nl':
	                defaultOptions.language = 'nl';
	                break;
	            case 'es':
	                defaultOptions.language = 'es';
	                break;
	            default:
	                defaultOptions.language = 'de';
	                break;
	        }
	        //Add default options and custom options
	        this.addOptions(defaultOptions, options);
	
	        // Duration Dropdown
	        this.durationDropdown = {};
	
	        // DepartureDate-Datepicker
	        this.departureDateDatepicker = $('[data-fcse-role="travelperiod--departuredate-datepicker"]', this.element);
	
	        // ReturnDate-Datepicker
	        this.returnDateDatepicker = $('[data-fcse-role="travelperiod--returndate-datepicker"]', this.element);
	
	        // LongtimeAlert-Button
	        this.longtimeAlertButton = $('#widget-durationchooser').find('[data-fcse-role="travelperiod--longtimealert"]');
	
	        // Duration Type Chooser
	        this.durationTypeChooser = $('[data-fcse-role="travelperiod--durationtype"]');
	
	        // Initialize
	        this._initDatePicker();
	        this._initDurationDropdown();
	        this._initDuratonTypeChooser();
	        this._initLongtimeAlertButton();
	        this._blockClickPropagation();
	
	        // We need to notify flyout to update caption
	        setTimeout(function () {
	            self.dispatchEvent("change");
	        }, 150);
	    };
	
	    TravelPerdiodWidget.prototype = $.extend(Object.create(Widget.prototype), {
	
	        _initLongtimeAlertButton: function _initLongtimeAlertButton() {
	            this.longtimeAlertButton.on('click', $.proxy(this._onLongtimeAlertButtonClick, this));
	        },
	
	        _onLongtimeAlertButtonClick: function _onLongtimeAlertButtonClick(e) {
	            // Stop Propagation / Prevent Default Handling
	            e.stopPropagation();
	            e.preventDefault();
	
	            // Close Dropdown
	            this.durationDropdown.closeDropdown();
	
	            // Initialize Visibility Control Target
	            var callerElement = $('#widget-durationchooser').find('[data-fcse-role="travelperiod--longtimealert"]');
	            var visibilityControl = new VisibilityControl(callerElement);
	            visibilityControl.toggleTarget(callerElement, $(callerElement.data('target')));
	        },
	
	        _initDuratonTypeChooser: function _initDuratonTypeChooser() {
	            this.durationTypeChooser.on('change', $.proxy(this._onDurationTypeChange, this));
	        },
	
	        _onDurationTypeChange: function _onDurationTypeChange(e) {
	            if (e.currentTarget.value == this.option('durationTypeExact')) {
	                // Disable Duration Dropdown
	                this.durationDropdown.element.addClass(this.option('disableClassName'));
	                $('button', this.durationDropdown.element).attr('disabled', 'disabled');
	                // Restrict maxDate / Set new Duration
	                var departureDate = this.departureDateDatepicker.datepicker("getDate");
	                var returnDate = this.returnDateDatepicker.datepicker("getDate");
	                var diffDays = Math.min(28, moment(returnDate).diff(moment(departureDate), "days"));
	                var maxDate = moment(new Date(departureDate.getTime())).add(diffDays, "days").toDate();
	                var maxDateLimit = moment(new Date(departureDate.getTime())).add(28, "days").toDate();
	
	                this.returnDateDatepicker.datepicker("setDate", maxDate);
	                this.returnDateDatepicker.datepicker("option", "maxDate", maxDateLimit);
	
	                this.durationDropdown.setValue(diffDays);
	
	                // Check radio buttons
	                $('[value="' + this.option('durationTypeRange') + '"]', this.element).removeAttr('checked');
	                $('[value="' + this.option('durationTypeExact') + '"]', this.element).attr('checked', 'checked');
	            } else {
	                // Re-Activate Duration Dropdown
	                this.durationDropdown.element.removeClass(this.option('disableClassName'));
	                $('button', this.durationDropdown.element).removeAttr('disabled');
	                // Every Date is possible
	                this.returnDateDatepicker.datepicker("option", "maxDate", null);
	                this.durationDropdown.setValue(this.option('valueAnyPeriod'));
	
	                // Check radio buttons
	                $('[value="' + this.option('durationTypeExact') + '"]', this.element).removeAttr('checked');
	                $('[value="' + this.option('durationTypeRange') + '"]', this.element).attr('checked', 'checked');
	            }
	            if (this.option('submitOn').indexOf('periodTypeChange') != -1) {
	                this.accept();
	            }
	        },
	
	        _initDurationDropdown: function _initDurationDropdown() {
	            var dropDownElem = $('[data-fcse-role="travelperiod--durationchooser-dropdown"]');
	            var dropDownContent = $('[data-fcse-role="dropdown--content"]', dropDownElem).get(0);
	            if (!dropDownContent) {
	                return;
	            }
	            PerfectScrollBar.initialize(dropDownContent);
	            // PerfectScrollBar.update($('[data-fcse-role="dropdown--content"]', dropDownElem).get(0));
	            this.durationDropdown = new Dropdown(dropDownElem);
	            this.durationDropdown.on('close', $.proxy(this._onDurationClose, this));
	            this.durationDropdown.on('open', function () {
	                PerfectScrollBar.update(dropDownContent);
	            });
	        },
	
	        _onDurationClose: function _onDurationClose() {
	            // Get current Departure-Date
	            var departureDate = this.departureDateDatepicker.datepicker("getDate");
	
	            // Get Current Return-Date
	            var returnDate = this.returnDateDatepicker.datepicker("getDate");
	
	            // Set new Return-Date
	            var diffDays = moment(returnDate).diff(moment(departureDate), "days");
	            if (diffDays < this._getDurationMaxDays()) {
	                var returnDateWithDurationMaxDays = moment(new Date(departureDate.getTime())).add(this._getDurationMaxDays(), "days");
	                this.returnDateDatepicker.datepicker("setDate", returnDateWithDurationMaxDays.toDate());
	            }
	            if (this.option('submitOn').indexOf('durationChange') != -1) {
	                this.accept();
	            }
	        },
	
	        _getDurationMaxDays: function _getDurationMaxDays() {
	            // Get current Duration value
	            var duration = this.durationDropdown.getValue();
	
	            // Get highest value of the range and set as duration
	            if (_.isString(duration) && duration.indexOf('-') >= 0) {
	                // Range
	                var durationParts = duration.split('-');
	                if (_.size(durationParts) == 2) {
	                    // Got exactly two values
	                    duration = durationParts[1];
	                }
	            }
	            return duration;
	        },
	
	        _getDurationMinDays: function _getDurationMinDays() {
	            // Get current Duration value
	            var duration = this.durationDropdown.getValue();
	
	            // Get highest value of the range and set as duration
	            if (_.isString(duration) && duration.indexOf('-') >= 0) {
	                // Range
	                var durationParts = duration.split('-');
	                if (_.size(durationParts) == 2) {
	                    // Got exactly two values
	                    duration = durationParts[0];
	                }
	            }
	            return duration;
	        },
	
	        _initDatePicker: function _initDatePicker() {
	            var _this = this;
	
	            if (!this.value) {
	                return;
	            }
	
	            var departureDatapickerOptions = $.extend({
	                dateFormat: "dd.mm.y",
	                minDate: "+1d",
	                defaultDate: moment(this.value.departureDate, "YYYY-MM-DD").toDate(),
	                onSelect: $.proxy(this._onDepartureDatepickerSelect, this)
	            }, $.datepicker.regional[this.option('language')]);
	
	            var returnDatapickerOptions = $.extend({
	                dateFormat: "dd.mm.yy",
	                minDate: moment(this.value.departureDate, "YYYY-MM-DD").add(1, "day").toDate(),
	                defaultDate: moment(this.value.returnDate, "YYYY-MM-DD").toDate(),
	                onSelect: $.proxy(this._onReturnDatepickerSelect, this)
	            }, $.datepicker.regional[this.option('language')]);
	
	            if (window.locale === 'es') {
	                departureDatapickerOptions.monthNames = departureDatapickerOptions.monthNames.map(function (monthName) {
	                    return _this._lowerCase(monthName);
	                });
	                returnDatapickerOptions.monthNames = returnDatapickerOptions.monthNames.map(function (monthName) {
	                    return _this._lowerCase(monthName);
	                });
	            }
	
	            // Initialize Departure-Datepicker
	            this.departureDateDatepicker.datepicker(departureDatapickerOptions);
	
	            // Initialize Return-Datepicker
	            this.returnDateDatepicker.datepicker(returnDatapickerOptions);
	        },
	
	        _blockClickPropagation: function _blockClickPropagation() {
	            // We should block click propagation, otherwise flyout will be closed when months are changed
	            $(this.element).click(function (e) {
	                e.stopPropagation();
	            });
	        },
	
	        _lowerCase: function _lowerCase(string) {
	            return string.toLowerCase();
	        },
	
	        _getDurationTypeValue: function _getDurationTypeValue() {
	            return $('[data-fcse-role="travelperiod--durationtype"]:checked').val();
	        },
	
	        _onDepartureDatepickerSelect: function _onDepartureDatepickerSelect() {
	            var self = this;
	
	            // MinDate / MaxDate
	            var departureDate = self.departureDateDatepicker.datepicker("getDate");
	            var returnDate = self.returnDateDatepicker.datepicker("getDate");
	
	            var diffDays = moment(returnDate).diff(moment(departureDate), "days");
	
	            if (self._getDurationTypeValue() == self.option('durationTypeExact')) {
	                // Exact Dates
	                // Set new Date
	                if (diffDays < 1) {
	                    self.returnDateDatepicker.datepicker("setDate", moment(new Date(departureDate.getTime())).add(1, "days").toDate());
	                }
	
	                // Set New MaxDate
	                self.returnDateDatepicker.datepicker("option", "maxDate", moment(new Date(departureDate.getTime())).add(28, "days").toDate());
	            } else {
	                // Set new Date
	                if (diffDays < self._getDurationMaxDays()) {
	                    self.returnDateDatepicker.datepicker("setDate", moment(new Date(departureDate.getTime())).add(self._getDurationMaxDays(), "days").toDate());
	                }
	            }
	
	            // In returndate-calendar select of earlier dates than
	            // departuredate should not be possible.
	            self.returnDateDatepicker.datepicker("option", "minDate", moment(new Date(departureDate.getTime())).add(1, "days").toDate());
	
	            // Close Datepicker
	            self.departureDateDatepicker.trigger('click');
	        },
	
	        _onReturnDatepickerSelect: function _onReturnDatepickerSelect() {
	            var self = this;
	
	            // MinDate / MaxDate
	            var minDate = self.departureDateDatepicker.datepicker("getDate");
	            var maxDate = self.returnDateDatepicker.datepicker("getDate");
	
	            // Limiting duration by its max possible
	            // value which is (return date - departure date).
	            self._setMaxDuration(minDate, maxDate);
	
	            // Close Datepicker
	            self.returnDateDatepicker.trigger('click');
	        },
	
	        formatValue: function formatValue() {
	            var val = this.getValue();
	            var formattedValue = '';
	
	            if (val && this.durationDropdown.formatValue()) {
	                var period = $('<span>').text(moment(val.departureDate).format('DD.MM.YY') + ' - ' + moment(val.returnDate).format('DD.MM.YY'));
	                period.addClass(this.option('periodCaptionDatesClassName'));
	
	                var duration = $('<span>').text(this.durationDropdown.formatValue());
	                duration.addClass(this.option('periodCaptionDurationClassName'));
	
	                formattedValue = $($('<div></div>').html(period.clone())).html();
	
	                if (val.exactDepartureDate && val.exactReturnDate) {
	                    // formattedValue = formattedValue + ', ' + $($('<div></div>').html(duration.clone())).html();
	                } else {
	                        // formattedValue = formattedValue + ', ' + $($('<div></div>').html(duration.clone())).html();
	                    }
	            }
	            return formattedValue;
	        },
	
	        setValueToUi: function setValueToUi() {
	            var departureDate = moment(this.value.departureDate, "YYYY-MM-DD").toDate();
	            var returnDate = moment(this.value.returnDate, "YYYY-MM-DD").toDate();
	            this.departureDateDatepicker.datepicker("setDate", departureDate);
	            this.returnDateDatepicker.datepicker("setDate", returnDate);
	
	            // set Duration Value
	            this.durationDropdown.setValue(this.value.duration);
	
	            // Exact Return+Departure Date
	            if (this.value.exactReturnDate && this.value.exactReturnDate == true && this.value.exactDepartureDate && this.value.exactDepartureDate == true) {
	                // Set value of DurationType-Chooser
	                $('[value="' + this.option('durationTypeRange') + '"]', this.element).removeAttr('checked');
	                $('[value="' + this.option('durationTypeExact') + '"]', this.element).attr('checked', 'checked');
	
	                var departureDateWithMaxDuration = moment(this.value.departureDate, "YYYY-MM-DD").add(28, "days").toDate();
	                this.returnDateDatepicker.datepicker("option", "maxDate", departureDateWithMaxDuration);
	            } else {
	                // Set Value of DurationType-Chooser
	                $('[value="' + this.option('durationTypeExact') + '"]', this.element).removeAttr('checked');
	                $('[value="' + this.option('durationTypeRange') + '"]', this.element).attr('checked', 'checked');
	
	                this.returnDateDatepicker.datepicker("option", "maxDate", null);
	            }
	        },
	
	        getValueFromUi: function getValueFromUi() {
	            var departureDate = moment(this.departureDateDatepicker.datepicker("getDate"));
	            var returnDate = moment(this.returnDateDatepicker.datepicker("getDate"));
	            var isExactDurationType = this._getDurationTypeValue() == this.option('durationTypeExact');
	
	            // Set Calculated Duration when both exact Departure and Return-Date are set.
	            if (isExactDurationType) {
	                //params.duration = 0;
	                var diffDays = Math.min(28, returnDate.diff(departureDate, "days"));
	                this.durationDropdown.setValue(diffDays);
	            }
	
	            var params = {
	                departureDate: departureDate.format("YYYY-MM-DD"),
	                returnDate: returnDate.format("YYYY-MM-DD"),
	                duration: this.durationDropdown.getValue(),
	                exactDepartureDate: isExactDurationType,
	                exactReturnDate: isExactDurationType
	            };
	
	            return params;
	        },
	
	        _setMaxDuration: function _setMaxDuration(minDate, maxDate) {
	            var diffDays = Math.min(28, moment(maxDate).diff(moment(minDate), "days"));
	            var minDays = this._getDurationMinDays();
	            var maxDays = this._getDurationMaxDays();
	
	            if (minDays != maxDays) {
	                // Range
	                if (minDays > diffDays || maxDays > diffDays) {
	                    this.durationDropdown.setValue(diffDays);
	                }
	            } else {
	                // Single value
	                if (maxDays > diffDays) {
	                    this.durationDropdown.setValue(diffDays);
	                }
	            }
	        }
	    });
	
	    return TravelPerdiodWidget;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Created by ivo on 14.05.14.
	 */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(3), __webpack_require__(2), __webpack_require__(185), __webpack_require__(34), __webpack_require__(87), __webpack_require__(176), __webpack_require__(175), __webpack_require__(163), __webpack_require__(172), __webpack_require__(169), __webpack_require__(171), __webpack_require__(81), __webpack_require__(167), __webpack_require__(84), __webpack_require__(166), __webpack_require__(170), __webpack_require__(173), __webpack_require__(82), __webpack_require__(83), __webpack_require__(168), __webpack_require__(183), __webpack_require__(174)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, _, Object, WidgetFactory, Dropdown, RatingWidget, TravelPeriodWidget, TravellersWidget, Flyout, LocationWidget, DestinationWidget, HotelSearchWidget, GlobalTypeWidget, CheckboxWidget, SearchWidget, AirlineFilterWidget, ExtendedSearchWidget, PriceSliderWidget, PriceSliderRangeWidget, RatingSliderRangeWidget, CheckList, TagBarWidget, TagBarSearch) {
	
	    /**
	     * Abstract pseudo class for the creational process of
	     * the filter widgets.
	     *
	     * @constructor
	     * @param {Object} scope
	     * @param array An array of widgets to be instantiated
	     * @returns {_L1.WidgetFactory}
	     */
	    var AbstractWidgetFactory = function AbstractWidgetFactory(scopes) {
	        WidgetFactory.apply(this, arguments);
	    };
	
	    AbstractWidgetFactory.prototype = $.extend(Object.create(WidgetFactory.prototype), {
	        /**
	         * An array of active widget names, should be overwritten by subclass
	         */
	        _activeWidgets: [],
	
	        /**
	         * Creation process of widgets
	         *
	         * @returns {undefined}
	         */
	        _createWidgets: function _createWidgets() {
	            var self = this;
	            $.each(this._activeWidgets, function (index, name) {
	                switch (name) {
	                    case 'board':
	                        {
	                            self._createBoardWidget();
	                            break;
	                        }
	                    case 'category':
	                        {
	                            self._createCategoryWidget();
	                            break;
	                        }
	                    case 'departureAirport':
	                        {
	                            self._createDepartureAirportWidget();
	                            break;
	                        }
	                    case 'destination':
	                        {
	                            self._createDestinationWidget();
	                            break;
	                        }
	                    case 'globalType':
	                        {
	                            self._createGlobalTypeWidget();
	                            break;
	                        }
	                    case 'price':
	                        {
	                            self._createPriceWidget();
	                            break;
	                        }
	                    case 'priceRange':
	                        {
	                            self._createPriceRangeWidget();
	                            break;
	                        }
	                    case 'rating':
	                        {
	                            self._createRatingWidget();
	                            break;
	                        }
	                    case 'ratingRange':
	                        {
	                            self._createRatingRangeWidget();
	                            break;
	                        }
	                    case 'room':
	                        {
	                            self._createRoomWidget();
	                            break;
	                        }
	                    case 'travellers':
	                        {
	                            self._createTravellersWidget();
	                            break;
	                        }
	                    case 'travelPeriod':
	                        {
	                            self._createTravelPeriodWidget();
	                            break;
	                        }
	                    case 'hotelSearch':
	                        {
	                            self._createHotelSearchWidget();
	                            break;
	                        }
	                    case 'redirectingHotelSearch':
	                        {
	                            self._createRedirectingHotelSearchWidget();
	                            break;
	                        }
	                    case 'headerHotelSearch':
	                        {
	                            self._createHeaderHotelSearchWidget();
	                            break;
	                        }
	                    case 'redirectingHeaderHotelSearch':
	                        {
	                            self._createRedirectingHeaderHotelSearchWidget();
	                            break;
	                        }
	                    case 'directFlight':
	                        {
	                            self._createDirectFlightWidget();
	                            break;
	                        }
	                    case 'headerSearch':
	                        {
	                            self._createSearchWidget();
	                            break;
	                        }
	                    case 'searchmaskSearch':
	                        {
	                            self._createSearchmaskSearchWidget();
	                            break;
	                        }
	                    case 'airlineFilter':
	                        {
	                            self._createAirlineFilterWidget();
	                            break;
	                        }
	                    case 'tourOperatorFilter':
	                        {
	                            self._createTourOperatorFilterWidget();
	                            break;
	                        }
	                    case 'extendedSearch':
	                        {
	                            self._createExtendedSearchWidget();
	                            break;
	                        }
	                    case 'hotelSearchTagBar':
	                        {
	                            self._createHotelSearchTagBarWidget();
	                            break;
	                        }
	                    default:
	                        {
	                            throw new Error('Invalid widget name provided: "' + name + '".');
	                            break;
	                        }
	                }
	            });
	        },
	
	        /**
	         * Creates the board widget
	         * @private
	         */
	        _createBoardWidget: function _createBoardWidget() {
	            // Board widget logic
	            var boardWidget = new Dropdown('#widget-board');
	            this.set('boardWidget', boardWidget);
	        },
	
	        /**
	         * Creates the category widget
	         * @private
	         */
	        _createCategoryWidget: function _createCategoryWidget() {
	            // Category widget logic
	            var categoryWidget = new RatingWidget('#widget-category');
	            this.set('categoryWidget', categoryWidget);
	        },
	
	        /**
	         * Creates the departure airport widget
	         * @private
	         */
	        _createDepartureAirportWidget: function _createDepartureAirportWidget() {
	            // Departure flyout
	            var departureFlyout = new Flyout('#flyout-airport', {
	                closeOnOutsideClick: true,
	                submitOnOutsideClick: true
	            });
	            departureFlyout.setCaptionElement($('.widget--value-truncate', '.widget-airport'));
	            departureFlyout.bindEventToCallerElement('click', $('.widget--btn, .widget--value', '.widget-airport'));
	
	            // Departure widget
	            var departureWidget = new LocationWidget('#widget-airport');
	            departureFlyout.setWidget(departureWidget);
	            this.set('departureWidget', departureWidget);
	        },
	
	        /**
	         * Creates the destination widget
	         * @private
	         */
	        _createDestinationWidget: function _createDestinationWidget() {
	            // Destination flyout
	            var destinationFlyout = new Flyout('#flyout-destination', {
	                closeOnOutsideClick: true,
	                submitOnOutsideClick: true
	            });
	            destinationFlyout.setCaptionElement($('.widget--value', '.widget-destination'));
	            destinationFlyout.bindEventToCallerElement('click', $('.widget--btn, .widget--value', '.widget-destination'));
	
	            // Destination widget
	            var destinationWidget = new DestinationWidget('#widget-destination');
	            destinationFlyout.setWidget(destinationWidget);
	            this.set('destinationWidget', destinationWidget);
	        },
	
	        /**
	         * Creates global types widget
	         * @private
	         */
	        _createGlobalTypeWidget: function _createGlobalTypeWidget() {
	            // Create global types
	            var globaltypeWidget = new GlobalTypeWidget('[data-fcse-role="globaltypewidget"]');
	            this.set('globaltypeWidget', globaltypeWidget);
	        },
	
	        /**
	         * Creates the travellers widget
	         * @private
	         */
	        _createTravellersWidget: function _createTravellersWidget() {
	            //Travellers widget plus flyout
	            var travellersFlyout = new Flyout('#flyout-travellers', {
	                closeOnOutsideClick: true,
	                submitOnOutsideClick: true
	            });
	            travellersFlyout.setCaptionElement($('[data-fcse-role="travellerswidget--caption"]', $('#button-travellers')));
	            travellersFlyout.bindEventToCallerElement('click', $('#button-travellers'));
	
	            var travellersWidget = new TravellersWidget('#widget-travellers', {
	                ensureEqualAdults: false
	            });
	            this.set('travellersWidget', travellersWidget);
	            travellersFlyout.setWidget(travellersWidget);
	        },
	
	        /**
	         * Creates price widget
	         * @private
	         */
	        _createPriceWidget: function _createPriceWidget() {
	            // Price widget logic
	            var priceWidget = new PriceSliderWidget('#widget-price');
	            this.set('priceWidget', priceWidget);
	        },
	
	        /**
	         * Creates price range widget
	         * @private
	         */
	        _createPriceRangeWidget: function _createPriceRangeWidget() {
	            // Price widget logic
	            var priceWidget = new PriceSliderRangeWidget('#widget-price-range');
	            this.set('priceRangeWidget', priceWidget);
	        },
	
	        /**
	         * Creates the rating widget
	         * @private
	         */
	        _createRatingWidget: function _createRatingWidget() {
	            // Logic to create rating widget
	            var ratingWidget = new RatingWidget('#widget-rating');
	            this.set('ratingWidget', ratingWidget);
	        },
	
	        /**
	         * Creates the rating range widget
	         * @private
	         */
	        _createRatingRangeWidget: function _createRatingRangeWidget() {
	            var ratingWidget = new RatingSliderRangeWidget('#widget-rating-range');
	            this.set('ratingRangeWidget', ratingWidget);
	        },
	
	        /**
	         * Creates room widget
	         * @private
	         */
	        _createRoomWidget: function _createRoomWidget() {
	            // Room widget logic
	            var roomWidget = new Dropdown('#widget-room');
	            this.set('roomWidget', roomWidget);
	        },
	
	        /**
	         * Creates travelperiod widget
	         * @private
	         */
	        //            _createTravelPeriodWidget: function(){
	        //                // Travelperiod widget logic
	        //                var travelPeriodWidget = new TravelPeriodWidget('#widget-travelperiod');
	        //                this.set('travelPeriodWidget', travelPeriodWidget);
	        //            },
	
	        /**
	         * Creates the travelperiod widget
	         * @private
	         */
	        _createTravelPeriodWidget: function _createTravelPeriodWidget() {
	            // Travelperiod flyout
	            var travelPeriodFlyout = new Flyout('#flyout-travelperiod', {
	                closeOnOutsideClick: true,
	                submitOnOutsideClick: true
	            });
	            travelPeriodFlyout.setCaptionElement($('.widget--value', '.widget-travelperiod'));
	            travelPeriodFlyout.bindEventToCallerElement('click', $('.widget--btn, .widget--value', '.widget-travelperiod'));
	
	            // Travelperiod widget
	            var travelPeriodWidget = new TravelPeriodWidget('#widget-travelperiod', { submitOn: ['periodTypeChange', 'durationChange'] });
	            travelPeriodFlyout.setWidget(travelPeriodWidget);
	            this.set('travelPeriodWidget', travelPeriodWidget);
	        },
	
	        /**
	         * Creates Hotelsearch widget
	         * @private
	         */
	        _createHotelSearchWidget: function _createHotelSearchWidget() {
	            var hotelSearchWidget = new HotelSearchWidget('#widget-hotelsearch');
	            this.set('hotelSearchWidget', hotelSearchWidget);
	        },
	
	        /**
	         * Creates Redirecting Hotelsearch widget
	         * @private
	         */
	        _createRedirectingHotelSearchWidget: function _createRedirectingHotelSearchWidget() {
	            var hotelSearchWidget = new HotelSearchWidget('#widget-hotelsearch', {
	                rootScope: this._scopes.rootScope,
	                triggerRedirect: true
	            });
	            this.set('hotelSearchWidget', hotelSearchWidget);
	        },
	
	        /**
	         * Creates Hotelsearch widget for header
	         * @private
	         */
	        _createHeaderHotelSearchWidget: function _createHeaderHotelSearchWidget() {
	            var hotelSearchWidget = new HotelSearchWidget('#widget-headerhotelsearch');
	            this.set('headerHotelSearchWidget', hotelSearchWidget);
	        },
	
	        /**
	         * Creates Redirecting Hotelsearch widget for header
	         * @private
	         */
	        _createRedirectingHeaderHotelSearchWidget: function _createRedirectingHeaderHotelSearchWidget() {
	            var hotelSearchWidget = new HotelSearchWidget('#widget-headerhotelsearch', {
	                rootScope: this._scopes.rootScope,
	                triggerRedirect: true
	            });
	            this.set('headerHotelSearchWidget', hotelSearchWidget);
	        },
	
	        /**
	         * Creates direct flight widget
	         * @private
	         */
	        _createDirectFlightWidget: function _createDirectFlightWidget() {
	            if ($('#direct-flight').length > 0) {
	                var directFlight = new CheckboxWidget('#direct-flight');
	                this.set('directFlightWidget', directFlight);
	            }
	        },
	
	        /**
	         * Creates search widget
	         * @private
	         */
	        _createSearchWidget: function _createSearchWidget() {
	            if ($('#search-widget').length) {
	                var searchWidget = new SearchWidget('#search-widget', { rootScope: this._scopes.rootScope, useHeader: true }, this._scopes.localScope, true);
	                this.set('searchWidget', searchWidget);
	            }
	        },
	
	        /**
	         * Creates searchmask search widget
	         * @private
	         */
	        _createSearchmaskSearchWidget: function _createSearchmaskSearchWidget() {
	            if ($('#searchmask-search-widget').length) {
	                var searchWidget = new SearchWidget('#searchmask-search-widget', {
	                    rootScope: this._scopes.rootScope,
	                    useHeader: true,
	                    useRootScopeParams: ['groupNames', 'category', 'hotelAttributes']
	                }, this._scopes.localScope, true);
	
	                this.set('searchmaskSearchWidget', searchWidget);
	            }
	        },
	
	        /**
	         * Creates airline filter widget
	         * @private
	         */
	        _createAirlineFilterWidget: function _createAirlineFilterWidget() {
	            var airlineFilterWidget = new AirlineFilterWidget('#widget-airlineFilter', {
	                rootScope: this._scopes.rootScope
	            });
	            this.set('airlineFilterWidget', airlineFilterWidget);
	        },
	
	        /**
	         * Creates extended search widget
	         * @private
	         */
	        _createExtendedSearchWidget: function _createExtendedSearchWidget() {
	            var flyout = new Flyout('#flyout-extended-search', {
	                closeOnOutsideClick: true,
	                submitOnOutsideClick: true
	            });
	            flyout.bindEventToCallerElement('click', $('#button-extended-search'));
	
	            var extendedSearchWidget = new ExtendedSearchWidget('#widget-extended-search', { scopes: this._scopes });
	            flyout.setWidget(extendedSearchWidget);
	            this.set('extendedSearchWidget', extendedSearchWidget);
	        },
	
	        _createHotelSearchTagBarWidget: function _createHotelSearchTagBarWidget() {
	            var tagBar = new TagBarWidget('#hotel-search-tagbar-bar');
	            var hotelSearchTagBar = new TagBarSearch('#hotel-search-tagbar', {
	                rootScope: this._scopes.rootScope,
	                tagBarWidget: tagBar
	            });
	            this.set('hotelSearchTagBarWidget', hotelSearchTagBar);
	        },
	
	        _createTourOperatorFilterWidget: function _createTourOperatorFilterWidget() {
	            var tourOperatorFlyout = new Flyout('#flyout-tourOperatorFilter', {
	                closeOnOutsideClick: true
	            });
	            tourOperatorFlyout.setCaptionElement($('.widget--value', '.widget-touroperator'));
	            tourOperatorFlyout.bindEventToCallerElement('click', $('.widget--btn, .widget--value', '.widget-touroperator'));
	
	            var tourOperatorWidget = new CheckList('#widget-tourOperatorFilter');
	            tourOperatorFlyout.setWidget(tourOperatorWidget);
	            this.set('tourOperatorWidget', tourOperatorWidget);
	        },
	
	        /**
	         * Bind created widgets to the scope
	         * @return {undefined}
	         */
	        _bindWidgetsToScope: function _bindWidgetsToScope() {
	            var self = this;
	            $.each(this._activeWidgets, function (index, name) {
	                switch (name) {
	                    case 'board':
	                        {
	                            // Binding for board
	                            self.get('boardWidget').bindToScope(self._scopes.rootScope, 'board');
	                            break;
	                        }
	                    case 'category':
	                        {
	                            // Binding for category
	                            self.get('categoryWidget').bindToScope(self._scopes.rootScope, 'category');
	                            break;
	                        }
	                    case 'departureAirport':
	                        {
	                            // Binding for departure airport
	                            self.get('departureWidget').bindToScope(self._scopes.rootScope, 'departureAirports');
	                            break;
	                        }
	                    case 'destination':
	                        {
	                            // Binding for destination
	                            self.get('destinationWidget').bindToScope(self._scopes.rootScope, 'groupIds');
	                            break;
	                        }
	                    case 'globalType':
	                        {
	                            var globaltypeWidget = self.get('globaltypeWidget');
	                            globaltypeWidget.bindToScope(self._scopes.rootScope, globaltypeWidget.getScopeBindingMap());
	                            break;
	                        }
	                    case 'price':
	                        {
	                            // Binding for price
	                            self.get('priceWidget').bindToScope(self._scopes.rootScope, 'maxPrice');
	                            break;
	                        }
	                    case 'priceRange':
	                        {
	                            // Binding for price
	                            self.get('priceRangeWidget').bindToScope(self._scopes.rootScope, {
	                                'minPrice': '0',
	                                'maxPrice': '1'
	                            });
	                            break;
	                        }
	                    case 'rating':
	                        {
	                            // Binding for rating
	                            self.get('ratingWidget').bindToScope(self._scopes.rootScope, 'rating');
	                            break;
	                        }
	                    case 'ratingRange':
	                        {
	                            // Binding for rating
	                            self.get('ratingRangeWidget').bindToScope(self._scopes.rootScope, {
	                                'minRating': '0',
	                                'maxRating': '1'
	                            });
	                            break;
	                        }
	                    case 'room':
	                        {
	                            // Binding for room
	                            self.get('roomWidget').bindToScope(self._scopes.rootScope, 'room');
	                            break;
	                        }
	                    case 'travellers':
	                        {
	                            var i;
	                            // Binding for travellers
	                            self.get('travellersWidget').bindToScope(self._scopes.rootScope, 'travellers');
	                            // clear params, whose were included into 
	                            for (i in self._scopes.rootScope.params) {
	                                if (i !== "travellers" && i.indexOf("travellers") === 0) {
	                                    delete self._scopes.rootScope.params[i];
	                                }
	                            }
	                            break;
	                        }
	                    case 'travelPeriod':
	                        {
	                            // Binding for travel period
	                            self.get('travelPeriodWidget').bindToScope(self._scopes.rootScope, {
	                                'departureDate': 'departureDate',
	                                'returnDate': 'returnDate',
	                                'duration': 'duration',
	                                'exactDepartureDate': 'exactDepartureDate',
	                                'exactReturnDate': 'exactReturnDate'
	                            });
	                            break;
	                        }
	                    case 'hotelSearch': // fall-through intended
	                    case 'redirectingHotelSearch':
	                        {
	                            // Binding for hotel name search
	                            self.get('hotelSearchWidget').bindToScope(self._scopes.rootScope, 'hotelName');
	                            break;
	                        }
	                    case 'headerHotelSearch':
	                    case 'redirectingHeaderHotelSearch':
	                        {
	                            // Binding for hotel name search
	                            self.get('headerHotelSearchWidget').bindToScope(self._scopes.rootScope, 'hotelName');
	                            break;
	                        }
	                    case 'directFlight':
	                        {
	                            // Binding for stopOver
	                            if (!_.isUndefined(self.get('directFlightWidget'))) {
	                                self.get('directFlightWidget').bindToScope(self._scopes.rootScope, 'stopOver');
	                            }
	                            break;
	                        }
	                    case 'airlineFilter':
	                        {
	                            self.get('airlineFilterWidget').bindToScope(self._scopes.rootScope, {
	                                'airlineCodes': 'airlineCodes',
	                                'excludedAirline': 'excludedAirline'
	                            });
	                            break;
	                        }
	                    case 'tourOperatorFilter':
	                        {
	                            self.get('tourOperatorWidget').bindToScope(self._scopes.rootScope, 'tourOperators');
	                            break;
	                        }
	                    case 'headerSearch':
	                        {
	                            // Binding not needed
	                            break;
	                        }
	                    case 'searchmaskSearch':
	                        {
	                            if (self.get('searchmaskSearchWidget')) {
	                                self.get('searchmaskSearchWidget').bindToScope(self._scopes.rootScope, {
	                                    'hotelName': 'hotelName',
	                                    'hotelId': 'hotelId'
	                                });
	                            }
	                            break;
	                        }
	                    case 'extendedSearch':
	                        {
	                            self.get('extendedSearchWidget').bindToScope(self._scopes.rootScope, $.extend({
	                                'room': 'room',
	                                'board': 'board',
	                                'rating': 'rating',
	                                'maxPrice': 'maxPrice',
	                                'minPrice': 'minPrice',
	                                'maxRating': 'maxRating',
	                                'minRating': 'minRating',
	                                'category': 'category'
	                            }, GlobalTypeWidget.getScopeBindingMap()));
	                            break;
	                        }
	                    case 'hotelSearchTagBar':
	                        {
	                            self.get('hotelSearchTagBarWidget').bindToScope(self._scopes.rootScope, {
	                                'hotelName': 'hotelName',
	                                'productCode': 'productCode'
	                            });
	                            break;
	                        }
	                    default:
	                        {
	                            throw new Error('Binding for parameter ' + name + ' not implemented.');
	                            break;
	                        }
	                }
	            });
	        }
	    });
	
	    return AbstractWidgetFactory;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(1),
	    __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function($, _) {
	        /**
	         * Base class for all components
	         *
	         * @param element
	         * @param options
	         * @param elements
	         * @constructor
	         */
	        var Component = function (element, options) {
	            // Component Instance
	            if(element instanceof jQuery) {
	                this.element = element;
	            } else {
	                this.element = $(element);
	            }
	            
	            // Widget Instance
	            this.widget = null;
	            
	            // DOM-Element that has the Click Handler applied
	            this.callerElement = null;
	            
	            // DOM-Element for caption output
	            this.captionElement = null;            
	            
	            /**
	             * Current options for this Widget
	             */
	            var defaultOptions = {
	                callerElementOpenClass: 'component-is-open'
	            };
	            this.addOptions(defaultOptions, options);
	        };
	
	        Component.prototype = {
	            /**
	             * Set Caption DOM-Element
	             */
	            setCaptionElement: function(captionElement) {
	                this.captionElement = captionElement;
	            },
	            
	            /**
	             * Get Caption DOM-Element
	             */
	            getCaptionElement: function() {
	                return this.captionElement;
	            },
	            
	            /**
	             * Has a Caption DOM-Element
	             */
	            hasCaptionElement: function() {
	                if(this.captionElement) {
	                    return true;
	                } else {
	                    return false;
	                }
	            },
	            
	            /**
	             * Bind Event-Handler to DOM-Element
	             */
	            bindEventToCallerElement: function(eventType, callerElement, eventData, callback) {
	                this.setCallerElement(callerElement);
	                this.getCallerElement().on(eventType, null, eventData, callback);
	            },
	            
	            /**
	             * Set Caller DOM-Element
	             */
	            setCallerElement: function(callerElement) {
	                this.callerElement = callerElement;
	            },
	            
	            /**
	             * Get Caller DOM-Element
	             */
	            getCallerElement: function() {
	                return this.callerElement;
	            },
	            
	            /**
	             * Has a caller DOM-Element
	             */
	            hasCallerElement: function() {
	                if(this.callerElement) {
	                    return true;
	                } else {
	                    return false;
	                }
	            },
	            
	            /**
	             * Set Widget-Instance
	             */
	            setWidget: function (widget) {
	                // Set Widget
	                this.widget = widget;
	            },
	            
	            /**
	             * Bind Accept-Event to Widget
	             */
	            bindAcceptEventToWidget: function (callback) {
	                this.getWidget().on("accept", callback);
	            },
	            
	            /**
	             * Bind Cancel-Event to Widget
	             */
	            bindCancelEventToWidget: function (callback) {
	                this.getWidget().on("cancel", callback);
	            },
	            
	           /**
	             * Bind Undo-Event to Widget
	             */
	            bindUndoEventToWidget: function (callback) {
	                this.getWidget().on("undo", callback);
	            },            
	            
	            /**
	             * Has a Widget registered
	             */
	            hasWidget: function() {
	                if(this.getWidget()) {
	                    return true;
	                } else {
	                    return false;
	                }
	            },
	            
	            /**
	             * Get Widget-Instance
	             */
	            getWidget: function() {
	                return this.widget;
	            },
	            
	            /**
	             * Get Element
	             */
	            getElement: function() {
	                return this.element;
	            },           
	            
	            /**
	             * The Options
	             */
	            _options: {},
	            
	            /**
	             * Adds options to the widget. 
	             * The parameter options will overwrite the defaults
	             * @param {object} defaults
	             * @param {object|undefined} options
	             * @returns {undefined}
	             */
	            addOptions: function(defaults, options){
	                this._options = $.extend({}, this.getOptions(), defaults, options || {});
	            },
	            
	            /**
	             * Returns an object of all configuration options of the widget
	             * @returns {undefined|Object}
	             */
	            getOptions: function(){
	                return this._options;
	            },
	            
	            /**
	             * Gets or sets option
	             * @param name
	             * @param value optional
	             */
	            option: function (name, value) {
	                if (!_.isUndefined(value)) {
	                    this._options[name] = value;
	                }
	                return this._options[name];
	            },
	            
	            /**
	             * Accept method (Calls Accept-Method of a Widget)
	             */
	            accept: function () {
	                if(this.hasWidget()) {
	                    this.getWidget().accept();
	                }
	            },
	            /**
	             * Cancel (Calls Cancel-Method of a Widget)
	             */
	            cancel: function () {
	                if(this.hasWidget()) {
	                    this.getWidget().cancel();
	                }
	            }
	        };
	
	        return Component;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* German initialisation for the jQuery UI date picker plugin. */
	/* Written by Milian Wolff (mail@milianw.de). */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(1),
	    __webpack_require__(37)], __WEBPACK_AMD_DEFINE_RESULT__ = function($){
		$.datepicker.regional['de'] = {
			closeText: 'Schließen',
			prevText: '&#x3C;Zurück',
			nextText: 'Vor&#x3E;',
			currentText: 'Heute',
			monthNames: ['Januar','Februar','März','April','Mai','Juni',
			'Juli','August','September','Oktober','November','Dezember'],
			monthNamesShort: ['Jan','Feb','Mär','Apr','Mai','Jun',
			'Jul','Aug','Sep','Okt','Nov','Dez'],
			dayNames: ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'],
			dayNamesShort: ['So','Mo','Di','Mi','Do','Fr','Sa'],
			dayNamesMin: ['So','Mo','Di','Mi','Do','Fr','Sa'],
			weekHeader: 'KW',
			dateFormat: 'dd.mm.yy',
			firstDay: 1,
			isRTL: false,
			showMonthAfterYear: false,
			yearSuffix: ''};
		$.datepicker.setDefaults($.datepicker.regional['de']);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* Inicialización en español para la extensión 'UI date picker' para jQuery. */
	/* Traducido por Vester (xvester@gmail.com). */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(1),
	    __webpack_require__(37)], __WEBPACK_AMD_DEFINE_RESULT__ = function($){
		$.datepicker.regional['es'] = {
			closeText: 'Cerrar',
			prevText: '&#x3C;Ant',
			nextText: 'Sig&#x3E;',
			currentText: 'Hoy',
			monthNames: ['Enero','Febrero','Marzo','Abril','Mayo','Junio',
			'Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'],
			monthNamesShort: ['Ene','Feb','Mar','Abr','May','Jun',
			'Jul','Ago','Sep','Oct','Nov','Dic'],
			dayNames: ['Domingo','Lunes','Martes','Miércoles','Jueves','Viernes','Sábado'],
			dayNamesShort: ['Dom','Lun','Mar','Mié','Juv','Vie','Sáb'],
			dayNamesMin: ['Do','Lu','Ma','Mi','Ju','Vi','Sá'],
			weekHeader: 'Sm',
			dateFormat: 'dd/mm/yy',
			firstDay: 1,
			isRTL: false,
			showMonthAfterYear: false,
			yearSuffix: ''};
		$.datepicker.setDefaults($.datepicker.regional['es']);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* Dutch (UTF-8) initialisation for the jQuery UI date picker plugin. */
	/* Written by Mathias Bynens <http://mathiasbynens.be/> */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(1),
	    __webpack_require__(37)], __WEBPACK_AMD_DEFINE_RESULT__ = function($){
		$.datepicker.regional.nl = {
			closeText: 'Sluiten',
			prevText: '←',
			nextText: '→',
			currentText: 'Vandaag',
			monthNames: ['januari', 'februari', 'maart', 'april', 'mei', 'juni',
			'juli', 'augustus', 'september', 'oktober', 'november', 'december'],
			monthNamesShort: ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun',
			'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
			dayNames: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'],
			dayNamesShort: ['zon', 'maa', 'din', 'woe', 'don', 'vri', 'zat'],
			dayNamesMin: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
			weekHeader: 'Wk',
			dateFormat: 'dd-mm-yy',
			firstDay: 1,
			isRTL: false,
			showMonthAfterYear: false,
			yearSuffix: ''};
		$.datepicker.setDefaults($.datepicker.regional.nl);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * Created by ivo on 11.08.14.
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	        /**
	         * Flyout Component
	         * @constructor
	         */
	        var FlyoutRegistry = function () {
	            // Singleton
	            if (typeof FlyoutRegistry.instance === 'object') {
	                return FlyoutRegistry.instance;
	            }
	
	            // Cache for singleton
	            FlyoutRegistry.instance = this;
	        };
	
	        /**
	         * Add functions
	         * @type {{}}
	         */
	        FlyoutRegistry.prototype = {
	            /**
	             * An array of all flyout components
	             */
	            _flyouts: [],
	
	            /**
	             * Adds a flyout to the registry
	             * @param Flyout
	             */
	            add: function(flyout)
	            {
	                this._flyouts.push(flyout);
	            },
	
	            /**
	             * Removes all flyouts from the registry, does NOT destroy the instances
	             */
	            clear: function()
	            {
	                this._flyouts = [];
	            },
	
	            /**
	             * Returns all flyouts
	             * @return Array
	             */
	            getAll: function()
	            {
	                return this._flyouts;
	            }
	        };
	
	        return FlyoutRegistry;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* 
	 * To change this license header, choose License Headers in Project Properties.
	 * To change this template file, choose Tools | Templates
	 * and open the template in the editor.
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(1),
	    __webpack_require__(3),
	    __webpack_require__(4),
	    __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function($, _, Widget, Object) {
	
	            var TagbarWidget = function(element, options) {
	                Widget.apply(this, arguments);
	
	                var defaultOptions = {
	                    'selectedClassName': 'is-selected',
	                    'emptyClassName': 'is-empty',
	                    'deselectedClassName': 'is-hidden'
	                };
	                this.addOptions(defaultOptions, options);
	
	                this._registerClickEvent();
	            };
	
	            TagbarWidget.prototype = $.extend(Object.create(Widget.prototype), {
	                _registerClickEvent: function() {
	                    var self = this;
	                    $('[data-fcse-role="tagbar--remove"]', this.element).on("click", function(e) {
	                        var $target = $(this).closest('[data-value]');
	                        $target.addClass(self.option('deselectedClassName'));
	                        $target.removeClass(self.option('selectedClassName'));
	                        var value = [];
	                        $('[data-value]', self.element).each(function(index, element){
	                            if ($(element).hasClass(self.option('selectedClassName'))){
	                                value.push($(element).attr('data-value'));
	                            }
	                        });
	
	                        if (self.value !== value) {
	                            self.setValue(value);
	                        }
	                        e.preventDefault();
	                    });
	                },
	                setValueToUi: function() {
	                    var self = this;
	                    if ($.isArray(this.getValue())){
	                        if (this.getValue().length == 0){
	                            this.element.addClass(this.option('emptyClassName'));
	                        } else {
	                            this.element.removeClass(this.option('emptyClassName'));
	                        }
	                    }
	                    $('[data-value]', this.element).removeClass(self.option('selectedClassName'));
	                    $('[data-value]', this.element).addClass(self.option('deselectedClassName'));
	                    _.each($('[data-value]', self.element), function(btn, index) {
	                        var $btn = $(btn);
	                        if ($.inArray($btn.attr('data-value'), self.value) !== -1) {
	                            $btn.removeClass(self.option('deselectedClassName'));
	                            $btn.addClass(self.option('selectedClassName'));
	                        }
	                    });
	                },
	                
	               /**
	                * Convert initial value
	                * @param {type} data
	                * @returns {Array}
	                */
	                _processData : function(data){
	                    if ($.isArray(data)){
	                        return data;
	                    } else {
	                        var initialData = $.parseJSON(data);
	                        if (!$.isArray(initialData)){
	                            return []; 
	                        }
	                    }
	                }
	            });
	
	            return TagbarWidget;
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(1),
	    __webpack_require__(4),
	    __webpack_require__(2),
	    __webpack_require__(34)
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function($, Widget, Object, Dropdown) {
	        
	        var TravellersWidget = function (element, options) {
	            Widget.apply(this, arguments);
	            
	            //Set options
	            var defaultOptions = {
	                'ensureEqualAdults': false, 
	                'childLabel' : 'Kind',
	                'childLabelPlural' : 'Kinder',
	                'adultLabel' : 'Erwachsener',
	                'adultLabelPlural' : 'Erwachsene',
	                'ageChildLabelSelector' : '.label',
	                'ageChildLabel' : 'Alter Kind {0}',
	                'moreChildsValue' : 9999,
	                'moreAdultsValue' : 9999
	            };
	            
	            //Set defaults from data attribtues
	            if ($(element).attr('data-child-label')){
	                defaultOptions['childLabel'] = $(element).attr('data-child-label');
	            }
	            if ($(element).attr('data-child-label-plural')){
	                defaultOptions['childLabelPlural'] = $(element).attr('data-child-label-plural');
	            }
	            if ($(element).attr('data-adult-label')){
	                defaultOptions['adultLabel'] = $(element).attr('data-adult-label');
	            }
	            if ($(element).attr('data-adult-label-plural')){
	                defaultOptions['adultLabelPlural'] = $(element).attr('data-adult-label-plural');
	            }
	            if ($(element).attr('data-age-child-label')){
	                defaultOptions['ageChildLabel'] = $(element).attr('data-age-child-label');
	            }
	            if ($('[data-fcse-role="travellers--morechilds"]').data('value')){
	                defaultOptions['moreChildsValue'] = $('[data-fcse-role="travellers--morechilds"]').data('value');
	            }
	            if ($('[data-fcse-role="travellers--moreadults"]').data('value')){
	                defaultOptions['moreAdultsValue'] = $('[data-fcse-role="travellers--moreadults"]').data('value');
	            }
	            
	            this.addOptions(defaultOptions, options);
	            
	            // Internal array of all age chooser for children
	            this.ageChooserList = [];
	            this._ageDropdown = $('[data-fcse-role="travellerswidget--agedropdown"]', this.element);
	            
	            //Instances of the dropdowns
	            this.childDropdown = {};
	            this.adultDropdown = {};
	
	            this._initDropdowns();
	            
	            if (this.getValue()){
	                this.setValueToUi();
	            }
	        };
	
	        TravellersWidget.prototype = $.extend(Object.create(Widget.prototype), {
	            _initDropdowns : function() {
	                this.childDropdown = new Dropdown($('[data-fcse-role="travellerswidget--childdropdown"]', this.element));
	                this.childDropdown.on('change', $.proxy(this.onChildrenChange, this));
	                
	                this.adultDropdown = new Dropdown($('[data-fcse-role="travellerswidget--adultdropdown"]', this.element));
	                this.adultDropdown.on('change', $.proxy(this.onAdultsChange, this));
	                
	                // Detach age chooser from dom and keep as a template
	                this._ageDropdown.detach();
	                this.onChildrenChange();
	            },
	            
	            onAdultsChange : function(event) {
	                var numChildren = parseInt(this.childDropdown.getValue());
	                //Make sure we have no more children than parents
	                if (this.option('ensureEqualAdults')){
	                    if (numChildren > parseInt(this.adultDropdown.getValue())){
	                        this.childDropdown.setValue(this.adultDropdown.getValue());
	                        return;
	                    }
	                }
	            },
	            onChildrenChange : function(event) {
	                var numChildren = parseInt(this.childDropdown.getValue());
	                numChildrenChanged = false;
	                if (this.option('moreChildsValue') != numChildren) {
	                    //Make sure we have no more children than parents
	                    if (this.option('ensureEqualAdults')){
	                        if (numChildren > parseInt(this.adultDropdown.getValue())){
	                            this.childDropdown.setValue(this.adultDropdown.getValue());
	                            return;
	                        }
	                    }
	                    
	                    // Create missing age chooser dropdowns
	                    while (this.ageChooserList.length < numChildren) {
	                        var ageChooser = this._ageDropdown.clone().appendTo($('[data-fcse-role="travellerswidget--agecontainer"]', this.element));
	                        var childAgeDropdown = new Dropdown(ageChooser);
	                        childAgeDropdown.element.on('change', $.proxy(this.onChildAgeChange, this));
	                
	                        //Set title
	                        var title = this.option('ageChildLabel').replace('{0}', this.ageChooserList.length + 1);
	                        childAgeDropdown.element.find('[data-fcse-role="travellerswidget--agelabel"]').text(title);
	                        this.ageChooserList.push(childAgeDropdown);
	                    }
	                } else {
	                    // Triggers when > 4 children item is chosen
	                    // Make it behave the same way as it does when no children are chosen
	                    numChildrenChanged = numChildren;
	                    numChildren = 0;
	                }
	                
	                // Remove unnecessary dropdowns
	                for (var i = this.ageChooserList.length - 1; i >= numChildren; i--){
	                    if (i === 0){
	                        // Keep last dropdown as a template for cloning
	                        $(this.ageChooserList[i].element).detach();
	                    } else {
	                        $(this.ageChooserList[i].element).remove();
	                    }
	                    
	                    this.ageChooserList.pop();
	                }
	                
	                if (numChildrenChanged) {
	                    numChildren = numChildrenChanged;
	                }
	            },
	            _processData : function(value) {
	                if (value){
	                    if ($.isPlainObject(value)){
	                        return value;
	                    } else {
	                        return $.parseJSON(value);
	                    }
	                } else {
	                    return {};
	                }
	            },
	            setValueToUi : function () {
	                var val = this.getValue();
	                if (val == null) return;
	
	                if (val.adults) {
	                    this.adultDropdown.setValue(val.adults);
	                }
	                if ($.isArray(val.children)) {
	                    // Update children dropdown
	                    this.childDropdown.setValue(val.children.length);
	                    
	                    var self = this;
	                    $.each(val.children, function(idx, element){
	                        // Check if age chooser exists when ensureEqualAdults is true
	                        if (self.option('ensureEqualAdults')){
	                            if (self.ageChooserList[idx] === undefined){
	                                return;
	                            }
	                        }
	                        self.ageChooserList[idx].setValue(element);
	                    });
	                }
	            },
	            getValueFromUi : function () {
	                var children = [];
	                for (var i = 0; i < this.ageChooserList.length; i++){
	                    if (this.ageChooserList[i].getValue()){
	                        children.push(this.ageChooserList[i].getValue());
	                    }
	                }
	                return {
	                    'adults' : this.adultDropdown.getValue(),
	                    'children' : children
	                };
	            },
	            formatValue : function() {
	                var val = this.getValueFromUi();
	                var text = val.adults;
	                
	                if (val.adults != 1){
	                    text += ' ' + this.option('adultLabelPlural');
	                } else {
	                    text += ' ' + this.option('adultLabel');
	                }
	                
	                if (val.children.length > 0){
	                    if (val.children.length != 1){
	                        text += ', ' + val.children.length + ' ' + this.option('childLabelPlural');
	                    } else {
	                        text += ', ' + val.children.length + ' ' + this.option('childLabel');
	                    }
	                }
	                 return text;
	            },
	
	            /**
	             * Validate data and show errors, if no age is selected
	             */
	            isValid: function() {
	                var val = this.getValue();
	                var self = this;
	                var dataValid = true;
	
	                // Check if all required ages for children are selected
	                $.each(self.ageChooserList, function(idx, element){
	                    // Check if age chooser exists when ensureEqualAdults is true
	                    if (element.getValue() == undefined){
	                        dataValid = false;
	                    }
	                });
	
	                // Hide / SHow Error message
	                if (dataValid){
	                    $('[data-fcse-role="travellerswidget--error"]', self.element).hide();
	                } else {
	                    $('[data-fcse-role="travellerswidget--error"]', self.element).show();
	                }
	
	                return dataValid;
	            }
	        });
	
	        return TravellersWidget;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    
	    
	    /**
	     * Abstract pseudo class for the creational process of 
	     * the filter widgets.
	     * 
	     * @constructor
	     * @param {Object} scope
	     * @returns {_L1.WidgetFactory}
	     */
	    function WidgetFactory (scopes) {
	        this._widgets = {};
	        this._scopes = scopes;
	        this._createWidgets();
	        this._bindWidgetsToScope();
	    }
	    
	    WidgetFactory.prototype = {
	        
	        /**
	         * Creational process 
	         * 
	         * @returns {undefined}
	         */
	        _createWidgets: function() {
	            throw "Implement WidgetFactory._createWidgets()";
	        },
	        
	        /**
	         * Bind created widgets to the scope
	         * @return {undefined}
	         */
	        _bindWidgetsToScope: function() {
	            throw "Implement WidgetFactory._bindWidgetsToScope()";
	        },
	        
	        /**
	         * Populates the this._widgets object
	         * 
	         * @param {String} name
	         * @param {Object} widget
	         * @returns {undefined}
	         */
	        set: function(name, widget) {
	            this._widgets[name] = widget;
	        },
	        
	        
	        /**
	         * Getter for this.widgets
	         * 
	         * @param {type} name
	         * @returns {_L1.WidgetFactory._widgets}
	         */
	        get: function(name) {
	            return this._widgets[name];
	        },
	
	        /**
	         * Filter for this.widgets
	         *
	         * @param {Array} names
	         * @returns {Array} of {_L1.WidgetFactory._widgets}
	         */
	        getList: function(names) {
	            var result = [];
	            var self = this;
	
	            if (_.isArray(names)) {
	                _.each(names, function(name) {
	                    if (self._widgets[name]) {
	                        result.push(self._widgets[name]);
	                    }
	                });
	            } else {
	                result = _.values(this._widgets);
	            }
	
	            return result;
	        }
	    };
	    
	    return WidgetFactory;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Handlebars = __webpack_require__(187)["default"];
	
	// Compiler imports
	var AST = __webpack_require__(64);
	var Parser = __webpack_require__(65).parser;
	var parse = __webpack_require__(65).parse;
	var Compiler = __webpack_require__(66).Compiler;
	var compile = __webpack_require__(66).compile;
	var precompile = __webpack_require__(66).precompile;
	var JavaScriptCompiler = __webpack_require__(88)["default"];
	
	var _create = Handlebars.create;
	var create = function() {
	  var hb = _create();
	
	  hb.compile = function(input, options) {
	    return compile(input, options, hb);
	  };
	  hb.precompile = precompile;
	
	  hb.AST = AST;
	  hb.Compiler = Compiler;
	  hb.JavaScriptCompiler = JavaScriptCompiler;
	  hb.Parser = Parser;
	  hb.parse = parse;
	
	  return hb;
	};
	
	Handlebars = create();
	Handlebars.create = create;
	
	exports["default"] = Handlebars;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var base = __webpack_require__(30);
	
	// Each of these augment the Handlebars object. No need to setup here.
	// (This is done to easily share code between commonjs and browse envs)
	var SafeString = __webpack_require__(90)["default"];
	var Exception = __webpack_require__(38)["default"];
	var Utils = __webpack_require__(67);
	var runtime = __webpack_require__(190);
	
	// For compatibility and usage outside of module systems, make the Handlebars object a namespace
	var create = function() {
	  var hb = new base.HandlebarsEnvironment();
	
	  Utils.extend(hb, base);
	  hb.SafeString = SafeString;
	  hb.Exception = Exception;
	  hb.Utils = Utils;
	
	  hb.VM = runtime;
	  hb.template = function(spec) {
	    return runtime.template(spec, hb);
	  };
	
	  return hb;
	};
	
	var Handlebars = create();
	Handlebars.create = create;
	
	exports["default"] = Handlebars;

/***/ }),
/* 188 */
/***/ (function(module, exports) {

	"use strict";
	/* Jison generated parser */
	var handlebars = (function(){
	var parser = {trace: function trace() { },
	yy: {},
	symbols_: {"error":2,"root":3,"statements":4,"EOF":5,"program":6,"simpleInverse":7,"statement":8,"openInverse":9,"closeBlock":10,"openBlock":11,"mustache":12,"partial":13,"CONTENT":14,"COMMENT":15,"OPEN_BLOCK":16,"inMustache":17,"CLOSE":18,"OPEN_INVERSE":19,"OPEN_ENDBLOCK":20,"path":21,"OPEN":22,"OPEN_UNESCAPED":23,"CLOSE_UNESCAPED":24,"OPEN_PARTIAL":25,"partialName":26,"partial_option0":27,"inMustache_repetition0":28,"inMustache_option0":29,"dataName":30,"param":31,"STRING":32,"INTEGER":33,"BOOLEAN":34,"hash":35,"hash_repetition_plus0":36,"hashSegment":37,"ID":38,"EQUALS":39,"DATA":40,"pathSegments":41,"SEP":42,"$accept":0,"$end":1},
	terminals_: {2:"error",5:"EOF",14:"CONTENT",15:"COMMENT",16:"OPEN_BLOCK",18:"CLOSE",19:"OPEN_INVERSE",20:"OPEN_ENDBLOCK",22:"OPEN",23:"OPEN_UNESCAPED",24:"CLOSE_UNESCAPED",25:"OPEN_PARTIAL",32:"STRING",33:"INTEGER",34:"BOOLEAN",38:"ID",39:"EQUALS",40:"DATA",42:"SEP"},
	productions_: [0,[3,2],[6,2],[6,3],[6,2],[6,1],[6,1],[6,0],[4,1],[4,2],[8,3],[8,3],[8,1],[8,1],[8,1],[8,1],[11,3],[9,3],[10,3],[12,3],[12,3],[13,4],[7,2],[17,3],[17,1],[31,1],[31,1],[31,1],[31,1],[31,1],[35,1],[37,3],[26,1],[26,1],[26,1],[30,2],[21,1],[41,3],[41,1],[27,0],[27,1],[28,0],[28,2],[29,0],[29,1],[36,1],[36,2]],
	performAction: function anonymous(yytext,yyleng,yylineno,yy,yystate,$$,_$) {
	
	var $0 = $$.length - 1;
	switch (yystate) {
	case 1: return new yy.ProgramNode($$[$0-1]); 
	break;
	case 2:this.$ = new yy.ProgramNode([], $$[$0-1], $$[$0]);
	break;
	case 3:this.$ = new yy.ProgramNode($$[$0-2], $$[$0-1], $$[$0]);
	break;
	case 4:this.$ = new yy.ProgramNode($$[$0-1], $$[$0], []);
	break;
	case 5:this.$ = new yy.ProgramNode($$[$0]);
	break;
	case 6:this.$ = new yy.ProgramNode([]);
	break;
	case 7:this.$ = new yy.ProgramNode([]);
	break;
	case 8:this.$ = [$$[$0]];
	break;
	case 9: $$[$0-1].push($$[$0]); this.$ = $$[$0-1]; 
	break;
	case 10:this.$ = new yy.BlockNode($$[$0-2], $$[$0-1].inverse, $$[$0-1], $$[$0]);
	break;
	case 11:this.$ = new yy.BlockNode($$[$0-2], $$[$0-1], $$[$0-1].inverse, $$[$0]);
	break;
	case 12:this.$ = $$[$0];
	break;
	case 13:this.$ = $$[$0];
	break;
	case 14:this.$ = new yy.ContentNode($$[$0]);
	break;
	case 15:this.$ = new yy.CommentNode($$[$0]);
	break;
	case 16:this.$ = new yy.MustacheNode($$[$0-1][0], $$[$0-1][1], $$[$0-2], stripFlags($$[$0-2], $$[$0]));
	break;
	case 17:this.$ = new yy.MustacheNode($$[$0-1][0], $$[$0-1][1], $$[$0-2], stripFlags($$[$0-2], $$[$0]));
	break;
	case 18:this.$ = {path: $$[$0-1], strip: stripFlags($$[$0-2], $$[$0])};
	break;
	case 19:this.$ = new yy.MustacheNode($$[$0-1][0], $$[$0-1][1], $$[$0-2], stripFlags($$[$0-2], $$[$0]));
	break;
	case 20:this.$ = new yy.MustacheNode($$[$0-1][0], $$[$0-1][1], $$[$0-2], stripFlags($$[$0-2], $$[$0]));
	break;
	case 21:this.$ = new yy.PartialNode($$[$0-2], $$[$0-1], stripFlags($$[$0-3], $$[$0]));
	break;
	case 22:this.$ = stripFlags($$[$0-1], $$[$0]);
	break;
	case 23:this.$ = [[$$[$0-2]].concat($$[$0-1]), $$[$0]];
	break;
	case 24:this.$ = [[$$[$0]], null];
	break;
	case 25:this.$ = $$[$0];
	break;
	case 26:this.$ = new yy.StringNode($$[$0]);
	break;
	case 27:this.$ = new yy.IntegerNode($$[$0]);
	break;
	case 28:this.$ = new yy.BooleanNode($$[$0]);
	break;
	case 29:this.$ = $$[$0];
	break;
	case 30:this.$ = new yy.HashNode($$[$0]);
	break;
	case 31:this.$ = [$$[$0-2], $$[$0]];
	break;
	case 32:this.$ = new yy.PartialNameNode($$[$0]);
	break;
	case 33:this.$ = new yy.PartialNameNode(new yy.StringNode($$[$0]));
	break;
	case 34:this.$ = new yy.PartialNameNode(new yy.IntegerNode($$[$0]));
	break;
	case 35:this.$ = new yy.DataNode($$[$0]);
	break;
	case 36:this.$ = new yy.IdNode($$[$0]);
	break;
	case 37: $$[$0-2].push({part: $$[$0], separator: $$[$0-1]}); this.$ = $$[$0-2]; 
	break;
	case 38:this.$ = [{part: $$[$0]}];
	break;
	case 41:this.$ = [];
	break;
	case 42:$$[$0-1].push($$[$0]);
	break;
	case 45:this.$ = [$$[$0]];
	break;
	case 46:$$[$0-1].push($$[$0]);
	break;
	}
	},
	table: [{3:1,4:2,8:3,9:4,11:5,12:6,13:7,14:[1,8],15:[1,9],16:[1,11],19:[1,10],22:[1,12],23:[1,13],25:[1,14]},{1:[3]},{5:[1,15],8:16,9:4,11:5,12:6,13:7,14:[1,8],15:[1,9],16:[1,11],19:[1,10],22:[1,12],23:[1,13],25:[1,14]},{5:[2,8],14:[2,8],15:[2,8],16:[2,8],19:[2,8],20:[2,8],22:[2,8],23:[2,8],25:[2,8]},{4:19,6:17,7:18,8:3,9:4,11:5,12:6,13:7,14:[1,8],15:[1,9],16:[1,11],19:[1,20],20:[2,7],22:[1,12],23:[1,13],25:[1,14]},{4:19,6:21,7:18,8:3,9:4,11:5,12:6,13:7,14:[1,8],15:[1,9],16:[1,11],19:[1,20],20:[2,7],22:[1,12],23:[1,13],25:[1,14]},{5:[2,12],14:[2,12],15:[2,12],16:[2,12],19:[2,12],20:[2,12],22:[2,12],23:[2,12],25:[2,12]},{5:[2,13],14:[2,13],15:[2,13],16:[2,13],19:[2,13],20:[2,13],22:[2,13],23:[2,13],25:[2,13]},{5:[2,14],14:[2,14],15:[2,14],16:[2,14],19:[2,14],20:[2,14],22:[2,14],23:[2,14],25:[2,14]},{5:[2,15],14:[2,15],15:[2,15],16:[2,15],19:[2,15],20:[2,15],22:[2,15],23:[2,15],25:[2,15]},{17:22,21:23,30:24,38:[1,27],40:[1,26],41:25},{17:28,21:23,30:24,38:[1,27],40:[1,26],41:25},{17:29,21:23,30:24,38:[1,27],40:[1,26],41:25},{17:30,21:23,30:24,38:[1,27],40:[1,26],41:25},{21:32,26:31,32:[1,33],33:[1,34],38:[1,27],41:25},{1:[2,1]},{5:[2,9],14:[2,9],15:[2,9],16:[2,9],19:[2,9],20:[2,9],22:[2,9],23:[2,9],25:[2,9]},{10:35,20:[1,36]},{4:37,8:3,9:4,11:5,12:6,13:7,14:[1,8],15:[1,9],16:[1,11],19:[1,10],20:[2,6],22:[1,12],23:[1,13],25:[1,14]},{7:38,8:16,9:4,11:5,12:6,13:7,14:[1,8],15:[1,9],16:[1,11],19:[1,20],20:[2,5],22:[1,12],23:[1,13],25:[1,14]},{17:22,18:[1,39],21:23,30:24,38:[1,27],40:[1,26],41:25},{10:40,20:[1,36]},{18:[1,41]},{18:[2,41],24:[2,41],28:42,32:[2,41],33:[2,41],34:[2,41],38:[2,41],40:[2,41]},{18:[2,24],24:[2,24]},{18:[2,36],24:[2,36],32:[2,36],33:[2,36],34:[2,36],38:[2,36],40:[2,36],42:[1,43]},{21:44,38:[1,27],41:25},{18:[2,38],24:[2,38],32:[2,38],33:[2,38],34:[2,38],38:[2,38],40:[2,38],42:[2,38]},{18:[1,45]},{18:[1,46]},{24:[1,47]},{18:[2,39],21:49,27:48,38:[1,27],41:25},{18:[2,32],38:[2,32]},{18:[2,33],38:[2,33]},{18:[2,34],38:[2,34]},{5:[2,10],14:[2,10],15:[2,10],16:[2,10],19:[2,10],20:[2,10],22:[2,10],23:[2,10],25:[2,10]},{21:50,38:[1,27],41:25},{8:16,9:4,11:5,12:6,13:7,14:[1,8],15:[1,9],16:[1,11],19:[1,10],20:[2,2],22:[1,12],23:[1,13],25:[1,14]},{4:51,8:3,9:4,11:5,12:6,13:7,14:[1,8],15:[1,9],16:[1,11],19:[1,10],20:[2,4],22:[1,12],23:[1,13],25:[1,14]},{14:[2,22],15:[2,22],16:[2,22],19:[2,22],20:[2,22],22:[2,22],23:[2,22],25:[2,22]},{5:[2,11],14:[2,11],15:[2,11],16:[2,11],19:[2,11],20:[2,11],22:[2,11],23:[2,11],25:[2,11]},{14:[2,17],15:[2,17],16:[2,17],19:[2,17],20:[2,17],22:[2,17],23:[2,17],25:[2,17]},{18:[2,43],21:55,24:[2,43],29:52,30:59,31:53,32:[1,56],33:[1,57],34:[1,58],35:54,36:60,37:61,38:[1,62],40:[1,26],41:25},{38:[1,63]},{18:[2,35],24:[2,35],32:[2,35],33:[2,35],34:[2,35],38:[2,35],40:[2,35]},{14:[2,16],15:[2,16],16:[2,16],19:[2,16],20:[2,16],22:[2,16],23:[2,16],25:[2,16]},{5:[2,19],14:[2,19],15:[2,19],16:[2,19],19:[2,19],20:[2,19],22:[2,19],23:[2,19],25:[2,19]},{5:[2,20],14:[2,20],15:[2,20],16:[2,20],19:[2,20],20:[2,20],22:[2,20],23:[2,20],25:[2,20]},{18:[1,64]},{18:[2,40]},{18:[1,65]},{8:16,9:4,11:5,12:6,13:7,14:[1,8],15:[1,9],16:[1,11],19:[1,10],20:[2,3],22:[1,12],23:[1,13],25:[1,14]},{18:[2,23],24:[2,23]},{18:[2,42],24:[2,42],32:[2,42],33:[2,42],34:[2,42],38:[2,42],40:[2,42]},{18:[2,44],24:[2,44]},{18:[2,25],24:[2,25],32:[2,25],33:[2,25],34:[2,25],38:[2,25],40:[2,25]},{18:[2,26],24:[2,26],32:[2,26],33:[2,26],34:[2,26],38:[2,26],40:[2,26]},{18:[2,27],24:[2,27],32:[2,27],33:[2,27],34:[2,27],38:[2,27],40:[2,27]},{18:[2,28],24:[2,28],32:[2,28],33:[2,28],34:[2,28],38:[2,28],40:[2,28]},{18:[2,29],24:[2,29],32:[2,29],33:[2,29],34:[2,29],38:[2,29],40:[2,29]},{18:[2,30],24:[2,30],37:66,38:[1,67]},{18:[2,45],24:[2,45],38:[2,45]},{18:[2,38],24:[2,38],32:[2,38],33:[2,38],34:[2,38],38:[2,38],39:[1,68],40:[2,38],42:[2,38]},{18:[2,37],24:[2,37],32:[2,37],33:[2,37],34:[2,37],38:[2,37],40:[2,37],42:[2,37]},{5:[2,21],14:[2,21],15:[2,21],16:[2,21],19:[2,21],20:[2,21],22:[2,21],23:[2,21],25:[2,21]},{5:[2,18],14:[2,18],15:[2,18],16:[2,18],19:[2,18],20:[2,18],22:[2,18],23:[2,18],25:[2,18]},{18:[2,46],24:[2,46],38:[2,46]},{39:[1,68]},{21:55,30:59,31:69,32:[1,56],33:[1,57],34:[1,58],38:[1,27],40:[1,26],41:25},{18:[2,31],24:[2,31],38:[2,31]}],
	defaultActions: {15:[2,1],49:[2,40]},
	parseError: function parseError(str, hash) {
	    throw new Error(str);
	},
	parse: function parse(input) {
	    var self = this, stack = [0], vstack = [null], lstack = [], table = this.table, yytext = "", yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
	    this.lexer.setInput(input);
	    this.lexer.yy = this.yy;
	    this.yy.lexer = this.lexer;
	    this.yy.parser = this;
	    if (typeof this.lexer.yylloc == "undefined")
	        this.lexer.yylloc = {};
	    var yyloc = this.lexer.yylloc;
	    lstack.push(yyloc);
	    var ranges = this.lexer.options && this.lexer.options.ranges;
	    if (typeof this.yy.parseError === "function")
	        this.parseError = this.yy.parseError;
	    function popStack(n) {
	        stack.length = stack.length - 2 * n;
	        vstack.length = vstack.length - n;
	        lstack.length = lstack.length - n;
	    }
	    function lex() {
	        var token;
	        token = self.lexer.lex() || 1;
	        if (typeof token !== "number") {
	            token = self.symbols_[token] || token;
	        }
	        return token;
	    }
	    var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
	    while (true) {
	        state = stack[stack.length - 1];
	        if (this.defaultActions[state]) {
	            action = this.defaultActions[state];
	        } else {
	            if (symbol === null || typeof symbol == "undefined") {
	                symbol = lex();
	            }
	            action = table[state] && table[state][symbol];
	        }
	        if (typeof action === "undefined" || !action.length || !action[0]) {
	            var errStr = "";
	            if (!recovering) {
	                expected = [];
	                for (p in table[state])
	                    if (this.terminals_[p] && p > 2) {
	                        expected.push("'" + this.terminals_[p] + "'");
	                    }
	                if (this.lexer.showPosition) {
	                    errStr = "Parse error on line " + (yylineno + 1) + ":\n" + this.lexer.showPosition() + "\nExpecting " + expected.join(", ") + ", got '" + (this.terminals_[symbol] || symbol) + "'";
	                } else {
	                    errStr = "Parse error on line " + (yylineno + 1) + ": Unexpected " + (symbol == 1?"end of input":"'" + (this.terminals_[symbol] || symbol) + "'");
	                }
	                this.parseError(errStr, {text: this.lexer.match, token: this.terminals_[symbol] || symbol, line: this.lexer.yylineno, loc: yyloc, expected: expected});
	            }
	        }
	        if (action[0] instanceof Array && action.length > 1) {
	            throw new Error("Parse Error: multiple actions possible at state: " + state + ", token: " + symbol);
	        }
	        switch (action[0]) {
	        case 1:
	            stack.push(symbol);
	            vstack.push(this.lexer.yytext);
	            lstack.push(this.lexer.yylloc);
	            stack.push(action[1]);
	            symbol = null;
	            if (!preErrorSymbol) {
	                yyleng = this.lexer.yyleng;
	                yytext = this.lexer.yytext;
	                yylineno = this.lexer.yylineno;
	                yyloc = this.lexer.yylloc;
	                if (recovering > 0)
	                    recovering--;
	            } else {
	                symbol = preErrorSymbol;
	                preErrorSymbol = null;
	            }
	            break;
	        case 2:
	            len = this.productions_[action[1]][1];
	            yyval.$ = vstack[vstack.length - len];
	            yyval._$ = {first_line: lstack[lstack.length - (len || 1)].first_line, last_line: lstack[lstack.length - 1].last_line, first_column: lstack[lstack.length - (len || 1)].first_column, last_column: lstack[lstack.length - 1].last_column};
	            if (ranges) {
	                yyval._$.range = [lstack[lstack.length - (len || 1)].range[0], lstack[lstack.length - 1].range[1]];
	            }
	            r = this.performAction.call(yyval, yytext, yyleng, yylineno, this.yy, action[1], vstack, lstack);
	            if (typeof r !== "undefined") {
	                return r;
	            }
	            if (len) {
	                stack = stack.slice(0, -1 * len * 2);
	                vstack = vstack.slice(0, -1 * len);
	                lstack = lstack.slice(0, -1 * len);
	            }
	            stack.push(this.productions_[action[1]][0]);
	            vstack.push(yyval.$);
	            lstack.push(yyval._$);
	            newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
	            stack.push(newState);
	            break;
	        case 3:
	            return true;
	        }
	    }
	    return true;
	}
	};
	
	
	function stripFlags(open, close) {
	  return {
	    left: open[2] === '~',
	    right: close[0] === '~' || close[1] === '~'
	  };
	}
	
	/* Jison generated lexer */
	var lexer = (function(){
	var lexer = ({EOF:1,
	parseError:function parseError(str, hash) {
	        if (this.yy.parser) {
	            this.yy.parser.parseError(str, hash);
	        } else {
	            throw new Error(str);
	        }
	    },
	setInput:function (input) {
	        this._input = input;
	        this._more = this._less = this.done = false;
	        this.yylineno = this.yyleng = 0;
	        this.yytext = this.matched = this.match = '';
	        this.conditionStack = ['INITIAL'];
	        this.yylloc = {first_line:1,first_column:0,last_line:1,last_column:0};
	        if (this.options.ranges) this.yylloc.range = [0,0];
	        this.offset = 0;
	        return this;
	    },
	input:function () {
	        var ch = this._input[0];
	        this.yytext += ch;
	        this.yyleng++;
	        this.offset++;
	        this.match += ch;
	        this.matched += ch;
	        var lines = ch.match(/(?:\r\n?|\n).*/g);
	        if (lines) {
	            this.yylineno++;
	            this.yylloc.last_line++;
	        } else {
	            this.yylloc.last_column++;
	        }
	        if (this.options.ranges) this.yylloc.range[1]++;
	
	        this._input = this._input.slice(1);
	        return ch;
	    },
	unput:function (ch) {
	        var len = ch.length;
	        var lines = ch.split(/(?:\r\n?|\n)/g);
	
	        this._input = ch + this._input;
	        this.yytext = this.yytext.substr(0, this.yytext.length-len-1);
	        //this.yyleng -= len;
	        this.offset -= len;
	        var oldLines = this.match.split(/(?:\r\n?|\n)/g);
	        this.match = this.match.substr(0, this.match.length-1);
	        this.matched = this.matched.substr(0, this.matched.length-1);
	
	        if (lines.length-1) this.yylineno -= lines.length-1;
	        var r = this.yylloc.range;
	
	        this.yylloc = {first_line: this.yylloc.first_line,
	          last_line: this.yylineno+1,
	          first_column: this.yylloc.first_column,
	          last_column: lines ?
	              (lines.length === oldLines.length ? this.yylloc.first_column : 0) + oldLines[oldLines.length - lines.length].length - lines[0].length:
	              this.yylloc.first_column - len
	          };
	
	        if (this.options.ranges) {
	            this.yylloc.range = [r[0], r[0] + this.yyleng - len];
	        }
	        return this;
	    },
	more:function () {
	        this._more = true;
	        return this;
	    },
	less:function (n) {
	        this.unput(this.match.slice(n));
	    },
	pastInput:function () {
	        var past = this.matched.substr(0, this.matched.length - this.match.length);
	        return (past.length > 20 ? '...':'') + past.substr(-20).replace(/\n/g, "");
	    },
	upcomingInput:function () {
	        var next = this.match;
	        if (next.length < 20) {
	            next += this._input.substr(0, 20-next.length);
	        }
	        return (next.substr(0,20)+(next.length > 20 ? '...':'')).replace(/\n/g, "");
	    },
	showPosition:function () {
	        var pre = this.pastInput();
	        var c = new Array(pre.length + 1).join("-");
	        return pre + this.upcomingInput() + "\n" + c+"^";
	    },
	next:function () {
	        if (this.done) {
	            return this.EOF;
	        }
	        if (!this._input) this.done = true;
	
	        var token,
	            match,
	            tempMatch,
	            index,
	            col,
	            lines;
	        if (!this._more) {
	            this.yytext = '';
	            this.match = '';
	        }
	        var rules = this._currentRules();
	        for (var i=0;i < rules.length; i++) {
	            tempMatch = this._input.match(this.rules[rules[i]]);
	            if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
	                match = tempMatch;
	                index = i;
	                if (!this.options.flex) break;
	            }
	        }
	        if (match) {
	            lines = match[0].match(/(?:\r\n?|\n).*/g);
	            if (lines) this.yylineno += lines.length;
	            this.yylloc = {first_line: this.yylloc.last_line,
	                           last_line: this.yylineno+1,
	                           first_column: this.yylloc.last_column,
	                           last_column: lines ? lines[lines.length-1].length-lines[lines.length-1].match(/\r?\n?/)[0].length : this.yylloc.last_column + match[0].length};
	            this.yytext += match[0];
	            this.match += match[0];
	            this.matches = match;
	            this.yyleng = this.yytext.length;
	            if (this.options.ranges) {
	                this.yylloc.range = [this.offset, this.offset += this.yyleng];
	            }
	            this._more = false;
	            this._input = this._input.slice(match[0].length);
	            this.matched += match[0];
	            token = this.performAction.call(this, this.yy, this, rules[index],this.conditionStack[this.conditionStack.length-1]);
	            if (this.done && this._input) this.done = false;
	            if (token) return token;
	            else return;
	        }
	        if (this._input === "") {
	            return this.EOF;
	        } else {
	            return this.parseError('Lexical error on line '+(this.yylineno+1)+'. Unrecognized text.\n'+this.showPosition(),
	                    {text: "", token: null, line: this.yylineno});
	        }
	    },
	lex:function lex() {
	        var r = this.next();
	        if (typeof r !== 'undefined') {
	            return r;
	        } else {
	            return this.lex();
	        }
	    },
	begin:function begin(condition) {
	        this.conditionStack.push(condition);
	    },
	popState:function popState() {
	        return this.conditionStack.pop();
	    },
	_currentRules:function _currentRules() {
	        return this.conditions[this.conditionStack[this.conditionStack.length-1]].rules;
	    },
	topState:function () {
	        return this.conditionStack[this.conditionStack.length-2];
	    },
	pushState:function begin(condition) {
	        this.begin(condition);
	    }});
	lexer.options = {};
	lexer.performAction = function anonymous(yy,yy_,$avoiding_name_collisions,YY_START) {
	
	
	function strip(start, end) {
	  return yy_.yytext = yy_.yytext.substr(start, yy_.yyleng-end);
	}
	
	
	var YYSTATE=YY_START
	switch($avoiding_name_collisions) {
	case 0:
	                                   if(yy_.yytext.slice(-2) === "\\\\") {
	                                     strip(0,1);
	                                     this.begin("mu");
	                                   } else if(yy_.yytext.slice(-1) === "\\") {
	                                     strip(0,1);
	                                     this.begin("emu");
	                                   } else {
	                                     this.begin("mu");
	                                   }
	                                   if(yy_.yytext) return 14;
	                                 
	break;
	case 1:return 14;
	break;
	case 2:
	                                   if(yy_.yytext.slice(-1) !== "\\") this.popState();
	                                   if(yy_.yytext.slice(-1) === "\\") strip(0,1);
	                                   return 14;
	                                 
	break;
	case 3:strip(0,4); this.popState(); return 15;
	break;
	case 4:return 25;
	break;
	case 5:return 16;
	break;
	case 6:return 20;
	break;
	case 7:return 19;
	break;
	case 8:return 19;
	break;
	case 9:return 23;
	break;
	case 10:return 22;
	break;
	case 11:this.popState(); this.begin('com');
	break;
	case 12:strip(3,5); this.popState(); return 15;
	break;
	case 13:return 22;
	break;
	case 14:return 39;
	break;
	case 15:return 38;
	break;
	case 16:return 38;
	break;
	case 17:return 42;
	break;
	case 18:/*ignore whitespace*/
	break;
	case 19:this.popState(); return 24;
	break;
	case 20:this.popState(); return 18;
	break;
	case 21:yy_.yytext = strip(1,2).replace(/\\"/g,'"'); return 32;
	break;
	case 22:yy_.yytext = strip(1,2).replace(/\\'/g,"'"); return 32;
	break;
	case 23:return 40;
	break;
	case 24:return 34;
	break;
	case 25:return 34;
	break;
	case 26:return 33;
	break;
	case 27:return 38;
	break;
	case 28:yy_.yytext = strip(1,2); return 38;
	break;
	case 29:return 'INVALID';
	break;
	case 30:return 5;
	break;
	}
	};
	lexer.rules = [/^(?:[^\x00]*?(?=(\{\{)))/,/^(?:[^\x00]+)/,/^(?:[^\x00]{2,}?(?=(\{\{|$)))/,/^(?:[\s\S]*?--\}\})/,/^(?:\{\{(~)?>)/,/^(?:\{\{(~)?#)/,/^(?:\{\{(~)?\/)/,/^(?:\{\{(~)?\^)/,/^(?:\{\{(~)?\s*else\b)/,/^(?:\{\{(~)?\{)/,/^(?:\{\{(~)?&)/,/^(?:\{\{!--)/,/^(?:\{\{![\s\S]*?\}\})/,/^(?:\{\{(~)?)/,/^(?:=)/,/^(?:\.\.)/,/^(?:\.(?=([=~}\s\/.])))/,/^(?:[\/.])/,/^(?:\s+)/,/^(?:\}(~)?\}\})/,/^(?:(~)?\}\})/,/^(?:"(\\["]|[^"])*")/,/^(?:'(\\[']|[^'])*')/,/^(?:@)/,/^(?:true(?=([~}\s])))/,/^(?:false(?=([~}\s])))/,/^(?:-?[0-9]+(?=([~}\s])))/,/^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.]))))/,/^(?:\[[^\]]*\])/,/^(?:.)/,/^(?:$)/];
	lexer.conditions = {"mu":{"rules":[4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30],"inclusive":false},"emu":{"rules":[2],"inclusive":false},"com":{"rules":[3],"inclusive":false},"INITIAL":{"rules":[0,1,30],"inclusive":true}};
	return lexer;})()
	parser.lexer = lexer;
	function Parser () { this.yy = {}; }Parser.prototype = parser;parser.Parser = Parser;
	return new Parser;
	})();exports["default"] = handlebars;

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Visitor = __webpack_require__(89)["default"];
	
	function print(ast) {
	  return new PrintVisitor().accept(ast);
	}
	
	exports.print = print;function PrintVisitor() {
	  this.padding = 0;
	}
	
	exports.PrintVisitor = PrintVisitor;PrintVisitor.prototype = new Visitor();
	
	PrintVisitor.prototype.pad = function(string, newline) {
	  var out = "";
	
	  for(var i=0,l=this.padding; i<l; i++) {
	    out = out + "  ";
	  }
	
	  out = out + string;
	
	  if(newline !== false) { out = out + "\n"; }
	  return out;
	};
	
	PrintVisitor.prototype.program = function(program) {
	  var out = "",
	      statements = program.statements,
	      inverse = program.inverse,
	      i, l;
	
	  for(i=0, l=statements.length; i<l; i++) {
	    out = out + this.accept(statements[i]);
	  }
	
	  this.padding--;
	
	  return out;
	};
	
	PrintVisitor.prototype.block = function(block) {
	  var out = "";
	
	  out = out + this.pad("BLOCK:");
	  this.padding++;
	  out = out + this.accept(block.mustache);
	  if (block.program) {
	    out = out + this.pad("PROGRAM:");
	    this.padding++;
	    out = out + this.accept(block.program);
	    this.padding--;
	  }
	  if (block.inverse) {
	    if (block.program) { this.padding++; }
	    out = out + this.pad("{{^}}");
	    this.padding++;
	    out = out + this.accept(block.inverse);
	    this.padding--;
	    if (block.program) { this.padding--; }
	  }
	  this.padding--;
	
	  return out;
	};
	
	PrintVisitor.prototype.mustache = function(mustache) {
	  var params = mustache.params, paramStrings = [], hash;
	
	  for(var i=0, l=params.length; i<l; i++) {
	    paramStrings.push(this.accept(params[i]));
	  }
	
	  params = "[" + paramStrings.join(", ") + "]";
	
	  hash = mustache.hash ? " " + this.accept(mustache.hash) : "";
	
	  return this.pad("{{ " + this.accept(mustache.id) + " " + params + hash + " }}");
	};
	
	PrintVisitor.prototype.partial = function(partial) {
	  var content = this.accept(partial.partialName);
	  if(partial.context) { content = content + " " + this.accept(partial.context); }
	  return this.pad("{{> " + content + " }}");
	};
	
	PrintVisitor.prototype.hash = function(hash) {
	  var pairs = hash.pairs;
	  var joinedPairs = [], left, right;
	
	  for(var i=0, l=pairs.length; i<l; i++) {
	    left = pairs[i][0];
	    right = this.accept(pairs[i][1]);
	    joinedPairs.push( left + "=" + right );
	  }
	
	  return "HASH{" + joinedPairs.join(", ") + "}";
	};
	
	PrintVisitor.prototype.STRING = function(string) {
	  return '"' + string.string + '"';
	};
	
	PrintVisitor.prototype.INTEGER = function(integer) {
	  return "INTEGER{" + integer.integer + "}";
	};
	
	PrintVisitor.prototype.BOOLEAN = function(bool) {
	  return "BOOLEAN{" + bool.bool + "}";
	};
	
	PrintVisitor.prototype.ID = function(id) {
	  var path = id.parts.join("/");
	  if(id.parts.length > 1) {
	    return "PATH:" + path;
	  } else {
	    return "ID:" + path;
	  }
	};
	
	PrintVisitor.prototype.PARTIAL_NAME = function(partialName) {
	    return "PARTIAL:" + partialName.name;
	};
	
	PrintVisitor.prototype.DATA = function(data) {
	  return "@" + this.accept(data.id);
	};
	
	PrintVisitor.prototype.content = function(content) {
	  return this.pad("CONTENT[ '" + content.string + "' ]");
	};
	
	PrintVisitor.prototype.comment = function(comment) {
	  return this.pad("{{! '" + comment.comment + "' }}");
	};

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*global Utils */
	var Utils = __webpack_require__(67);
	var Exception = __webpack_require__(38)["default"];
	var COMPILER_REVISION = __webpack_require__(30).COMPILER_REVISION;
	var REVISION_CHANGES = __webpack_require__(30).REVISION_CHANGES;
	
	function checkRevision(compilerInfo) {
	  var compilerRevision = compilerInfo && compilerInfo[0] || 1,
	      currentRevision = COMPILER_REVISION;
	
	  if (compilerRevision !== currentRevision) {
	    if (compilerRevision < currentRevision) {
	      var runtimeVersions = REVISION_CHANGES[currentRevision],
	          compilerVersions = REVISION_CHANGES[compilerRevision];
	      throw new Error("Template was precompiled with an older version of Handlebars than the current runtime. "+
	            "Please update your precompiler to a newer version ("+runtimeVersions+") or downgrade your runtime to an older version ("+compilerVersions+").");
	    } else {
	      // Use the embedded version info since the runtime doesn't know about this revision yet
	      throw new Error("Template was precompiled with a newer version of Handlebars than the current runtime. "+
	            "Please update your runtime to a newer version ("+compilerInfo[1]+").");
	    }
	  }
	}
	
	// TODO: Remove this line and break up compilePartial
	
	function template(templateSpec, env) {
	  if (!env) {
	    throw new Error("No environment passed to template");
	  }
	
	  var invokePartialWrapper;
	  if (env.compile) {
	    invokePartialWrapper = function(partial, name, context, helpers, partials, data) {
	      // TODO : Check this for all inputs and the options handling (partial flag, etc). This feels
	      // like there should be a common exec path
	      var result = invokePartial.apply(this, arguments);
	      if (result) { return result; }
	
	      var options = { helpers: helpers, partials: partials, data: data };
	      partials[name] = env.compile(partial, { data: data !== undefined }, env);
	      return partials[name](context, options);
	    };
	  } else {
	    invokePartialWrapper = function(partial, name /* , context, helpers, partials, data */) {
	      var result = invokePartial.apply(this, arguments);
	      if (result) { return result; }
	      throw new Exception("The partial " + name + " could not be compiled when running in runtime-only mode");
	    };
	  }
	
	  // Just add water
	  var container = {
	    escapeExpression: Utils.escapeExpression,
	    invokePartial: invokePartialWrapper,
	    programs: [],
	    program: function(i, fn, data) {
	      var programWrapper = this.programs[i];
	      if(data) {
	        programWrapper = program(i, fn, data);
	      } else if (!programWrapper) {
	        programWrapper = this.programs[i] = program(i, fn);
	      }
	      return programWrapper;
	    },
	    merge: function(param, common) {
	      var ret = param || common;
	
	      if (param && common && (param !== common)) {
	        ret = {};
	        Utils.extend(ret, common);
	        Utils.extend(ret, param);
	      }
	      return ret;
	    },
	    programWithDepth: programWithDepth,
	    noop: noop,
	    compilerInfo: null
	  };
	
	  return function(context, options) {
	    options = options || {};
	    var namespace = options.partial ? options : env,
	        helpers,
	        partials;
	
	    if (!options.partial) {
	      helpers = options.helpers;
	      partials = options.partials;
	    }
	    var result = templateSpec.call(
	          container,
	          namespace, context,
	          helpers,
	          partials,
	          options.data);
	
	    if (!options.partial) {
	      checkRevision(container.compilerInfo);
	    }
	
	    return result;
	  };
	}
	
	exports.template = template;function programWithDepth(i, fn, data /*, $depth */) {
	  var args = Array.prototype.slice.call(arguments, 3);
	
	  var prog = function(context, options) {
	    options = options || {};
	
	    return fn.apply(this, [context, options.data || data].concat(args));
	  };
	  prog.program = i;
	  prog.depth = args.length;
	  return prog;
	}
	
	exports.programWithDepth = programWithDepth;function program(i, fn, data) {
	  var prog = function(context, options) {
	    options = options || {};
	
	    return fn(context, options.data || data);
	  };
	  prog.program = i;
	  prog.depth = 0;
	  return prog;
	}
	
	exports.program = program;function invokePartial(partial, name, context, helpers, partials, data) {
	  var options = { partial: true, helpers: helpers, partials: partials, data: data };
	
	  if(partial === undefined) {
	    throw new Exception("The partial " + name + " could not be found");
	  } else if(partial instanceof Function) {
	    return partial(context, options);
	  }
	}
	
	exports.invokePartial = invokePartial;function noop() { return ""; }
	
	exports.noop = noop;

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	// USAGE:
	// var handlebars = require('handlebars');
	
	// var local = handlebars.create();
	
	var handlebars = __webpack_require__(186).default;
	
	handlebars.Visitor = __webpack_require__(89).default;
	
	var printer = __webpack_require__(189);
	handlebars.PrintVisitor = printer.PrintVisitor;
	handlebars.print = printer.print;
	
	module.exports = handlebars;
	
	// Publish a Node.js require() handler for .handlebars and .hbs files
	if ("function" !== 'undefined' && (void 0)) {
	  var extension = function(module, filename) {
	    var fs = __webpack_require__(196);
	    var templateString = fs.readFileSync(filename, "utf8");
	    module.exports = handlebars.compile(templateString);
	  };
	  (void 0)[".handlebars"] = extension;
	  (void 0)[".hbs"] = extension;
	}


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1), __webpack_require__(41) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	
	// This file is deprecated
	return $.ui.ie = !!/msie [\w.]+/.exec( navigator.userAgent.toLowerCase() );
	} ) );


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// jscs:disable maximumLineLength
	/* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
	/*!
	 * jQuery UI Datepicker 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Datepicker
	//>>group: Widgets
	//>>description: Displays a calendar from an input or inline for selecting dates.
	//>>docs: http://api.jqueryui.com/datepicker/
	//>>demos: http://jqueryui.com/datepicker/
	//>>css.structure: ../../themes/base/core.css
	//>>css.structure: ../../themes/base/datepicker.css
	//>>css.theme: ../../themes/base/theme.css
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
				__webpack_require__(1),
				__webpack_require__(41),
				__webpack_require__(91)
			], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	}( function( $ ) {
	
	$.extend( $.ui, { datepicker: { version: "1.12.1" } } );
	
	var datepicker_instActive;
	
	function datepicker_getZindex( elem ) {
		var position, value;
		while ( elem.length && elem[ 0 ] !== document ) {
	
			// Ignore z-index if position is set to a value where z-index is ignored by the browser
			// This makes behavior of this function consistent across browsers
			// WebKit always returns auto if the element is positioned
			position = elem.css( "position" );
			if ( position === "absolute" || position === "relative" || position === "fixed" ) {
	
				// IE returns 0 when zIndex is not specified
				// other browsers return a string
				// we ignore the case of nested elements with an explicit value of 0
				// <div style="z-index: -10;"><div style="z-index: 0;"></div></div>
				value = parseInt( elem.css( "zIndex" ), 10 );
				if ( !isNaN( value ) && value !== 0 ) {
					return value;
				}
			}
			elem = elem.parent();
		}
	
		return 0;
	}
	/* Date picker manager.
	   Use the singleton instance of this class, $.datepicker, to interact with the date picker.
	   Settings for (groups of) date pickers are maintained in an instance object,
	   allowing multiple different settings on the same page. */
	
	function Datepicker() {
		this._curInst = null; // The current instance in use
		this._keyEvent = false; // If the last event was a key event
		this._disabledInputs = []; // List of date picker inputs that have been disabled
		this._datepickerShowing = false; // True if the popup picker is showing , false if not
		this._inDialog = false; // True if showing within a "dialog", false if not
		this._mainDivId = "ui-datepicker-div"; // The ID of the main datepicker division
		this._inlineClass = "ui-datepicker-inline"; // The name of the inline marker class
		this._appendClass = "ui-datepicker-append"; // The name of the append marker class
		this._triggerClass = "ui-datepicker-trigger"; // The name of the trigger marker class
		this._dialogClass = "ui-datepicker-dialog"; // The name of the dialog marker class
		this._disableClass = "ui-datepicker-disabled"; // The name of the disabled covering marker class
		this._unselectableClass = "ui-datepicker-unselectable"; // The name of the unselectable cell marker class
		this._currentClass = "ui-datepicker-current-day"; // The name of the current day marker class
		this._dayOverClass = "ui-datepicker-days-cell-over"; // The name of the day hover marker class
		this.regional = []; // Available regional settings, indexed by language code
		this.regional[ "" ] = { // Default regional settings
			closeText: "Done", // Display text for close link
			prevText: "Prev", // Display text for previous month link
			nextText: "Next", // Display text for next month link
			currentText: "Today", // Display text for current month link
			monthNames: [ "January","February","March","April","May","June",
				"July","August","September","October","November","December" ], // Names of months for drop-down and formatting
			monthNamesShort: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ], // For formatting
			dayNames: [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ], // For formatting
			dayNamesShort: [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ], // For formatting
			dayNamesMin: [ "Su","Mo","Tu","We","Th","Fr","Sa" ], // Column headings for days starting at Sunday
			weekHeader: "Wk", // Column header for week of the year
			dateFormat: "mm/dd/yy", // See format options on parseDate
			firstDay: 0, // The first day of the week, Sun = 0, Mon = 1, ...
			isRTL: false, // True if right-to-left language, false if left-to-right
			showMonthAfterYear: false, // True if the year select precedes month, false for month then year
			yearSuffix: "" // Additional text to append to the year in the month headers
		};
		this._defaults = { // Global defaults for all the date picker instances
			showOn: "focus", // "focus" for popup on focus,
				// "button" for trigger button, or "both" for either
			showAnim: "fadeIn", // Name of jQuery animation for popup
			showOptions: {}, // Options for enhanced animations
			defaultDate: null, // Used when field is blank: actual date,
				// +/-number for offset from today, null for today
			appendText: "", // Display text following the input box, e.g. showing the format
			buttonText: "...", // Text for trigger button
			buttonImage: "", // URL for trigger button image
			buttonImageOnly: false, // True if the image appears alone, false if it appears on a button
			hideIfNoPrevNext: false, // True to hide next/previous month links
				// if not applicable, false to just disable them
			navigationAsDateFormat: false, // True if date formatting applied to prev/today/next links
			gotoCurrent: false, // True if today link goes back to current selection instead
			changeMonth: false, // True if month can be selected directly, false if only prev/next
			changeYear: false, // True if year can be selected directly, false if only prev/next
			yearRange: "c-10:c+10", // Range of years to display in drop-down,
				// either relative to today's year (-nn:+nn), relative to currently displayed year
				// (c-nn:c+nn), absolute (nnnn:nnnn), or a combination of the above (nnnn:-n)
			showOtherMonths: false, // True to show dates in other months, false to leave blank
			selectOtherMonths: false, // True to allow selection of dates in other months, false for unselectable
			showWeek: false, // True to show week of the year, false to not show it
			calculateWeek: this.iso8601Week, // How to calculate the week of the year,
				// takes a Date and returns the number of the week for it
			shortYearCutoff: "+10", // Short year values < this are in the current century,
				// > this are in the previous century,
				// string value starting with "+" for current year + value
			minDate: null, // The earliest selectable date, or null for no limit
			maxDate: null, // The latest selectable date, or null for no limit
			duration: "fast", // Duration of display/closure
			beforeShowDay: null, // Function that takes a date and returns an array with
				// [0] = true if selectable, false if not, [1] = custom CSS class name(s) or "",
				// [2] = cell title (optional), e.g. $.datepicker.noWeekends
			beforeShow: null, // Function that takes an input field and
				// returns a set of custom settings for the date picker
			onSelect: null, // Define a callback function when a date is selected
			onChangeMonthYear: null, // Define a callback function when the month or year is changed
			onClose: null, // Define a callback function when the datepicker is closed
			numberOfMonths: 1, // Number of months to show at a time
			showCurrentAtPos: 0, // The position in multipe months at which to show the current month (starting at 0)
			stepMonths: 1, // Number of months to step back/forward
			stepBigMonths: 12, // Number of months to step back/forward for the big links
			altField: "", // Selector for an alternate field to store selected dates into
			altFormat: "", // The date format to use for the alternate field
			constrainInput: true, // The input is constrained by the current date format
			showButtonPanel: false, // True to show button panel, false to not show it
			autoSize: false, // True to size the input for the date format, false to leave as is
			disabled: false // The initial disabled state
		};
		$.extend( this._defaults, this.regional[ "" ] );
		this.regional.en = $.extend( true, {}, this.regional[ "" ] );
		this.regional[ "en-US" ] = $.extend( true, {}, this.regional.en );
		this.dpDiv = datepicker_bindHover( $( "<div id='" + this._mainDivId + "' class='ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>" ) );
	}
	
	$.extend( Datepicker.prototype, {
		/* Class name added to elements to indicate already configured with a date picker. */
		markerClassName: "hasDatepicker",
	
		//Keep track of the maximum number of rows displayed (see #7043)
		maxRows: 4,
	
		// TODO rename to "widget" when switching to widget factory
		_widgetDatepicker: function() {
			return this.dpDiv;
		},
	
		/* Override the default settings for all instances of the date picker.
		 * @param  settings  object - the new settings to use as defaults (anonymous object)
		 * @return the manager object
		 */
		setDefaults: function( settings ) {
			datepicker_extendRemove( this._defaults, settings || {} );
			return this;
		},
	
		/* Attach the date picker to a jQuery selection.
		 * @param  target	element - the target input field or division or span
		 * @param  settings  object - the new settings to use for this date picker instance (anonymous)
		 */
		_attachDatepicker: function( target, settings ) {
			var nodeName, inline, inst;
			nodeName = target.nodeName.toLowerCase();
			inline = ( nodeName === "div" || nodeName === "span" );
			if ( !target.id ) {
				this.uuid += 1;
				target.id = "dp" + this.uuid;
			}
			inst = this._newInst( $( target ), inline );
			inst.settings = $.extend( {}, settings || {} );
			if ( nodeName === "input" ) {
				this._connectDatepicker( target, inst );
			} else if ( inline ) {
				this._inlineDatepicker( target, inst );
			}
		},
	
		/* Create a new instance object. */
		_newInst: function( target, inline ) {
			var id = target[ 0 ].id.replace( /([^A-Za-z0-9_\-])/g, "\\\\$1" ); // escape jQuery meta chars
			return { id: id, input: target, // associated target
				selectedDay: 0, selectedMonth: 0, selectedYear: 0, // current selection
				drawMonth: 0, drawYear: 0, // month being drawn
				inline: inline, // is datepicker inline or not
				dpDiv: ( !inline ? this.dpDiv : // presentation div
				datepicker_bindHover( $( "<div class='" + this._inlineClass + " ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>" ) ) ) };
		},
	
		/* Attach the date picker to an input field. */
		_connectDatepicker: function( target, inst ) {
			var input = $( target );
			inst.append = $( [] );
			inst.trigger = $( [] );
			if ( input.hasClass( this.markerClassName ) ) {
				return;
			}
			this._attachments( input, inst );
			input.addClass( this.markerClassName ).on( "keydown", this._doKeyDown ).
				on( "keypress", this._doKeyPress ).on( "keyup", this._doKeyUp );
			this._autoSize( inst );
			$.data( target, "datepicker", inst );
	
			//If disabled option is true, disable the datepicker once it has been attached to the input (see ticket #5665)
			if ( inst.settings.disabled ) {
				this._disableDatepicker( target );
			}
		},
	
		/* Make attachments based on settings. */
		_attachments: function( input, inst ) {
			var showOn, buttonText, buttonImage,
				appendText = this._get( inst, "appendText" ),
				isRTL = this._get( inst, "isRTL" );
	
			if ( inst.append ) {
				inst.append.remove();
			}
			if ( appendText ) {
				inst.append = $( "<span class='" + this._appendClass + "'>" + appendText + "</span>" );
				input[ isRTL ? "before" : "after" ]( inst.append );
			}
	
			input.off( "focus", this._showDatepicker );
	
			if ( inst.trigger ) {
				inst.trigger.remove();
			}
	
			showOn = this._get( inst, "showOn" );
			if ( showOn === "focus" || showOn === "both" ) { // pop-up date picker when in the marked field
				input.on( "focus", this._showDatepicker );
			}
			if ( showOn === "button" || showOn === "both" ) { // pop-up date picker when button clicked
				buttonText = this._get( inst, "buttonText" );
				buttonImage = this._get( inst, "buttonImage" );
				inst.trigger = $( this._get( inst, "buttonImageOnly" ) ?
					$( "<img/>" ).addClass( this._triggerClass ).
						attr( { src: buttonImage, alt: buttonText, title: buttonText } ) :
					$( "<button type='button'></button>" ).addClass( this._triggerClass ).
						html( !buttonImage ? buttonText : $( "<img/>" ).attr(
						{ src:buttonImage, alt:buttonText, title:buttonText } ) ) );
				input[ isRTL ? "before" : "after" ]( inst.trigger );
				inst.trigger.on( "click", function() {
					if ( $.datepicker._datepickerShowing && $.datepicker._lastInput === input[ 0 ] ) {
						$.datepicker._hideDatepicker();
					} else if ( $.datepicker._datepickerShowing && $.datepicker._lastInput !== input[ 0 ] ) {
						$.datepicker._hideDatepicker();
						$.datepicker._showDatepicker( input[ 0 ] );
					} else {
						$.datepicker._showDatepicker( input[ 0 ] );
					}
					return false;
				} );
			}
		},
	
		/* Apply the maximum length for the date format. */
		_autoSize: function( inst ) {
			if ( this._get( inst, "autoSize" ) && !inst.inline ) {
				var findMax, max, maxI, i,
					date = new Date( 2009, 12 - 1, 20 ), // Ensure double digits
					dateFormat = this._get( inst, "dateFormat" );
	
				if ( dateFormat.match( /[DM]/ ) ) {
					findMax = function( names ) {
						max = 0;
						maxI = 0;
						for ( i = 0; i < names.length; i++ ) {
							if ( names[ i ].length > max ) {
								max = names[ i ].length;
								maxI = i;
							}
						}
						return maxI;
					};
					date.setMonth( findMax( this._get( inst, ( dateFormat.match( /MM/ ) ?
						"monthNames" : "monthNamesShort" ) ) ) );
					date.setDate( findMax( this._get( inst, ( dateFormat.match( /DD/ ) ?
						"dayNames" : "dayNamesShort" ) ) ) + 20 - date.getDay() );
				}
				inst.input.attr( "size", this._formatDate( inst, date ).length );
			}
		},
	
		/* Attach an inline date picker to a div. */
		_inlineDatepicker: function( target, inst ) {
			var divSpan = $( target );
			if ( divSpan.hasClass( this.markerClassName ) ) {
				return;
			}
			divSpan.addClass( this.markerClassName ).append( inst.dpDiv );
			$.data( target, "datepicker", inst );
			this._setDate( inst, this._getDefaultDate( inst ), true );
			this._updateDatepicker( inst );
			this._updateAlternate( inst );
	
			//If disabled option is true, disable the datepicker before showing it (see ticket #5665)
			if ( inst.settings.disabled ) {
				this._disableDatepicker( target );
			}
	
			// Set display:block in place of inst.dpDiv.show() which won't work on disconnected elements
			// http://bugs.jqueryui.com/ticket/7552 - A Datepicker created on a detached div has zero height
			inst.dpDiv.css( "display", "block" );
		},
	
		/* Pop-up the date picker in a "dialog" box.
		 * @param  input element - ignored
		 * @param  date	string or Date - the initial date to display
		 * @param  onSelect  function - the function to call when a date is selected
		 * @param  settings  object - update the dialog date picker instance's settings (anonymous object)
		 * @param  pos int[2] - coordinates for the dialog's position within the screen or
		 *					event - with x/y coordinates or
		 *					leave empty for default (screen centre)
		 * @return the manager object
		 */
		_dialogDatepicker: function( input, date, onSelect, settings, pos ) {
			var id, browserWidth, browserHeight, scrollX, scrollY,
				inst = this._dialogInst; // internal instance
	
			if ( !inst ) {
				this.uuid += 1;
				id = "dp" + this.uuid;
				this._dialogInput = $( "<input type='text' id='" + id +
					"' style='position: absolute; top: -100px; width: 0px;'/>" );
				this._dialogInput.on( "keydown", this._doKeyDown );
				$( "body" ).append( this._dialogInput );
				inst = this._dialogInst = this._newInst( this._dialogInput, false );
				inst.settings = {};
				$.data( this._dialogInput[ 0 ], "datepicker", inst );
			}
			datepicker_extendRemove( inst.settings, settings || {} );
			date = ( date && date.constructor === Date ? this._formatDate( inst, date ) : date );
			this._dialogInput.val( date );
	
			this._pos = ( pos ? ( pos.length ? pos : [ pos.pageX, pos.pageY ] ) : null );
			if ( !this._pos ) {
				browserWidth = document.documentElement.clientWidth;
				browserHeight = document.documentElement.clientHeight;
				scrollX = document.documentElement.scrollLeft || document.body.scrollLeft;
				scrollY = document.documentElement.scrollTop || document.body.scrollTop;
				this._pos = // should use actual width/height below
					[ ( browserWidth / 2 ) - 100 + scrollX, ( browserHeight / 2 ) - 150 + scrollY ];
			}
	
			// Move input on screen for focus, but hidden behind dialog
			this._dialogInput.css( "left", ( this._pos[ 0 ] + 20 ) + "px" ).css( "top", this._pos[ 1 ] + "px" );
			inst.settings.onSelect = onSelect;
			this._inDialog = true;
			this.dpDiv.addClass( this._dialogClass );
			this._showDatepicker( this._dialogInput[ 0 ] );
			if ( $.blockUI ) {
				$.blockUI( this.dpDiv );
			}
			$.data( this._dialogInput[ 0 ], "datepicker", inst );
			return this;
		},
	
		/* Detach a datepicker from its control.
		 * @param  target	element - the target input field or division or span
		 */
		_destroyDatepicker: function( target ) {
			var nodeName,
				$target = $( target ),
				inst = $.data( target, "datepicker" );
	
			if ( !$target.hasClass( this.markerClassName ) ) {
				return;
			}
	
			nodeName = target.nodeName.toLowerCase();
			$.removeData( target, "datepicker" );
			if ( nodeName === "input" ) {
				inst.append.remove();
				inst.trigger.remove();
				$target.removeClass( this.markerClassName ).
					off( "focus", this._showDatepicker ).
					off( "keydown", this._doKeyDown ).
					off( "keypress", this._doKeyPress ).
					off( "keyup", this._doKeyUp );
			} else if ( nodeName === "div" || nodeName === "span" ) {
				$target.removeClass( this.markerClassName ).empty();
			}
	
			if ( datepicker_instActive === inst ) {
				datepicker_instActive = null;
			}
		},
	
		/* Enable the date picker to a jQuery selection.
		 * @param  target	element - the target input field or division or span
		 */
		_enableDatepicker: function( target ) {
			var nodeName, inline,
				$target = $( target ),
				inst = $.data( target, "datepicker" );
	
			if ( !$target.hasClass( this.markerClassName ) ) {
				return;
			}
	
			nodeName = target.nodeName.toLowerCase();
			if ( nodeName === "input" ) {
				target.disabled = false;
				inst.trigger.filter( "button" ).
					each( function() { this.disabled = false; } ).end().
					filter( "img" ).css( { opacity: "1.0", cursor: "" } );
			} else if ( nodeName === "div" || nodeName === "span" ) {
				inline = $target.children( "." + this._inlineClass );
				inline.children().removeClass( "ui-state-disabled" );
				inline.find( "select.ui-datepicker-month, select.ui-datepicker-year" ).
					prop( "disabled", false );
			}
			this._disabledInputs = $.map( this._disabledInputs,
				function( value ) { return ( value === target ? null : value ); } ); // delete entry
		},
	
		/* Disable the date picker to a jQuery selection.
		 * @param  target	element - the target input field or division or span
		 */
		_disableDatepicker: function( target ) {
			var nodeName, inline,
				$target = $( target ),
				inst = $.data( target, "datepicker" );
	
			if ( !$target.hasClass( this.markerClassName ) ) {
				return;
			}
	
			nodeName = target.nodeName.toLowerCase();
			if ( nodeName === "input" ) {
				target.disabled = true;
				inst.trigger.filter( "button" ).
					each( function() { this.disabled = true; } ).end().
					filter( "img" ).css( { opacity: "0.5", cursor: "default" } );
			} else if ( nodeName === "div" || nodeName === "span" ) {
				inline = $target.children( "." + this._inlineClass );
				inline.children().addClass( "ui-state-disabled" );
				inline.find( "select.ui-datepicker-month, select.ui-datepicker-year" ).
					prop( "disabled", true );
			}
			this._disabledInputs = $.map( this._disabledInputs,
				function( value ) { return ( value === target ? null : value ); } ); // delete entry
			this._disabledInputs[ this._disabledInputs.length ] = target;
		},
	
		/* Is the first field in a jQuery collection disabled as a datepicker?
		 * @param  target	element - the target input field or division or span
		 * @return boolean - true if disabled, false if enabled
		 */
		_isDisabledDatepicker: function( target ) {
			if ( !target ) {
				return false;
			}
			for ( var i = 0; i < this._disabledInputs.length; i++ ) {
				if ( this._disabledInputs[ i ] === target ) {
					return true;
				}
			}
			return false;
		},
	
		/* Retrieve the instance data for the target control.
		 * @param  target  element - the target input field or division or span
		 * @return  object - the associated instance data
		 * @throws  error if a jQuery problem getting data
		 */
		_getInst: function( target ) {
			try {
				return $.data( target, "datepicker" );
			}
			catch ( err ) {
				throw "Missing instance data for this datepicker";
			}
		},
	
		/* Update or retrieve the settings for a date picker attached to an input field or division.
		 * @param  target  element - the target input field or division or span
		 * @param  name	object - the new settings to update or
		 *				string - the name of the setting to change or retrieve,
		 *				when retrieving also "all" for all instance settings or
		 *				"defaults" for all global defaults
		 * @param  value   any - the new value for the setting
		 *				(omit if above is an object or to retrieve a value)
		 */
		_optionDatepicker: function( target, name, value ) {
			var settings, date, minDate, maxDate,
				inst = this._getInst( target );
	
			if ( arguments.length === 2 && typeof name === "string" ) {
				return ( name === "defaults" ? $.extend( {}, $.datepicker._defaults ) :
					( inst ? ( name === "all" ? $.extend( {}, inst.settings ) :
					this._get( inst, name ) ) : null ) );
			}
	
			settings = name || {};
			if ( typeof name === "string" ) {
				settings = {};
				settings[ name ] = value;
			}
	
			if ( inst ) {
				if ( this._curInst === inst ) {
					this._hideDatepicker();
				}
	
				date = this._getDateDatepicker( target, true );
				minDate = this._getMinMaxDate( inst, "min" );
				maxDate = this._getMinMaxDate( inst, "max" );
				datepicker_extendRemove( inst.settings, settings );
	
				// reformat the old minDate/maxDate values if dateFormat changes and a new minDate/maxDate isn't provided
				if ( minDate !== null && settings.dateFormat !== undefined && settings.minDate === undefined ) {
					inst.settings.minDate = this._formatDate( inst, minDate );
				}
				if ( maxDate !== null && settings.dateFormat !== undefined && settings.maxDate === undefined ) {
					inst.settings.maxDate = this._formatDate( inst, maxDate );
				}
				if ( "disabled" in settings ) {
					if ( settings.disabled ) {
						this._disableDatepicker( target );
					} else {
						this._enableDatepicker( target );
					}
				}
				this._attachments( $( target ), inst );
				this._autoSize( inst );
				this._setDate( inst, date );
				this._updateAlternate( inst );
				this._updateDatepicker( inst );
			}
		},
	
		// Change method deprecated
		_changeDatepicker: function( target, name, value ) {
			this._optionDatepicker( target, name, value );
		},
	
		/* Redraw the date picker attached to an input field or division.
		 * @param  target  element - the target input field or division or span
		 */
		_refreshDatepicker: function( target ) {
			var inst = this._getInst( target );
			if ( inst ) {
				this._updateDatepicker( inst );
			}
		},
	
		/* Set the dates for a jQuery selection.
		 * @param  target element - the target input field or division or span
		 * @param  date	Date - the new date
		 */
		_setDateDatepicker: function( target, date ) {
			var inst = this._getInst( target );
			if ( inst ) {
				this._setDate( inst, date );
				this._updateDatepicker( inst );
				this._updateAlternate( inst );
			}
		},
	
		/* Get the date(s) for the first entry in a jQuery selection.
		 * @param  target element - the target input field or division or span
		 * @param  noDefault boolean - true if no default date is to be used
		 * @return Date - the current date
		 */
		_getDateDatepicker: function( target, noDefault ) {
			var inst = this._getInst( target );
			if ( inst && !inst.inline ) {
				this._setDateFromField( inst, noDefault );
			}
			return ( inst ? this._getDate( inst ) : null );
		},
	
		/* Handle keystrokes. */
		_doKeyDown: function( event ) {
			var onSelect, dateStr, sel,
				inst = $.datepicker._getInst( event.target ),
				handled = true,
				isRTL = inst.dpDiv.is( ".ui-datepicker-rtl" );
	
			inst._keyEvent = true;
			if ( $.datepicker._datepickerShowing ) {
				switch ( event.keyCode ) {
					case 9: $.datepicker._hideDatepicker();
							handled = false;
							break; // hide on tab out
					case 13: sel = $( "td." + $.datepicker._dayOverClass + ":not(." +
										$.datepicker._currentClass + ")", inst.dpDiv );
							if ( sel[ 0 ] ) {
								$.datepicker._selectDay( event.target, inst.selectedMonth, inst.selectedYear, sel[ 0 ] );
							}
	
							onSelect = $.datepicker._get( inst, "onSelect" );
							if ( onSelect ) {
								dateStr = $.datepicker._formatDate( inst );
	
								// Trigger custom callback
								onSelect.apply( ( inst.input ? inst.input[ 0 ] : null ), [ dateStr, inst ] );
							} else {
								$.datepicker._hideDatepicker();
							}
	
							return false; // don't submit the form
					case 27: $.datepicker._hideDatepicker();
							break; // hide on escape
					case 33: $.datepicker._adjustDate( event.target, ( event.ctrlKey ?
								-$.datepicker._get( inst, "stepBigMonths" ) :
								-$.datepicker._get( inst, "stepMonths" ) ), "M" );
							break; // previous month/year on page up/+ ctrl
					case 34: $.datepicker._adjustDate( event.target, ( event.ctrlKey ?
								+$.datepicker._get( inst, "stepBigMonths" ) :
								+$.datepicker._get( inst, "stepMonths" ) ), "M" );
							break; // next month/year on page down/+ ctrl
					case 35: if ( event.ctrlKey || event.metaKey ) {
								$.datepicker._clearDate( event.target );
							}
							handled = event.ctrlKey || event.metaKey;
							break; // clear on ctrl or command +end
					case 36: if ( event.ctrlKey || event.metaKey ) {
								$.datepicker._gotoToday( event.target );
							}
							handled = event.ctrlKey || event.metaKey;
							break; // current on ctrl or command +home
					case 37: if ( event.ctrlKey || event.metaKey ) {
								$.datepicker._adjustDate( event.target, ( isRTL ? +1 : -1 ), "D" );
							}
							handled = event.ctrlKey || event.metaKey;
	
							// -1 day on ctrl or command +left
							if ( event.originalEvent.altKey ) {
								$.datepicker._adjustDate( event.target, ( event.ctrlKey ?
									-$.datepicker._get( inst, "stepBigMonths" ) :
									-$.datepicker._get( inst, "stepMonths" ) ), "M" );
							}
	
							// next month/year on alt +left on Mac
							break;
					case 38: if ( event.ctrlKey || event.metaKey ) {
								$.datepicker._adjustDate( event.target, -7, "D" );
							}
							handled = event.ctrlKey || event.metaKey;
							break; // -1 week on ctrl or command +up
					case 39: if ( event.ctrlKey || event.metaKey ) {
								$.datepicker._adjustDate( event.target, ( isRTL ? -1 : +1 ), "D" );
							}
							handled = event.ctrlKey || event.metaKey;
	
							// +1 day on ctrl or command +right
							if ( event.originalEvent.altKey ) {
								$.datepicker._adjustDate( event.target, ( event.ctrlKey ?
									+$.datepicker._get( inst, "stepBigMonths" ) :
									+$.datepicker._get( inst, "stepMonths" ) ), "M" );
							}
	
							// next month/year on alt +right
							break;
					case 40: if ( event.ctrlKey || event.metaKey ) {
								$.datepicker._adjustDate( event.target, +7, "D" );
							}
							handled = event.ctrlKey || event.metaKey;
							break; // +1 week on ctrl or command +down
					default: handled = false;
				}
			} else if ( event.keyCode === 36 && event.ctrlKey ) { // display the date picker on ctrl+home
				$.datepicker._showDatepicker( this );
			} else {
				handled = false;
			}
	
			if ( handled ) {
				event.preventDefault();
				event.stopPropagation();
			}
		},
	
		/* Filter entered characters - based on date format. */
		_doKeyPress: function( event ) {
			var chars, chr,
				inst = $.datepicker._getInst( event.target );
	
			if ( $.datepicker._get( inst, "constrainInput" ) ) {
				chars = $.datepicker._possibleChars( $.datepicker._get( inst, "dateFormat" ) );
				chr = String.fromCharCode( event.charCode == null ? event.keyCode : event.charCode );
				return event.ctrlKey || event.metaKey || ( chr < " " || !chars || chars.indexOf( chr ) > -1 );
			}
		},
	
		/* Synchronise manual entry and field/alternate field. */
		_doKeyUp: function( event ) {
			var date,
				inst = $.datepicker._getInst( event.target );
	
			if ( inst.input.val() !== inst.lastVal ) {
				try {
					date = $.datepicker.parseDate( $.datepicker._get( inst, "dateFormat" ),
						( inst.input ? inst.input.val() : null ),
						$.datepicker._getFormatConfig( inst ) );
	
					if ( date ) { // only if valid
						$.datepicker._setDateFromField( inst );
						$.datepicker._updateAlternate( inst );
						$.datepicker._updateDatepicker( inst );
					}
				}
				catch ( err ) {
				}
			}
			return true;
		},
	
		/* Pop-up the date picker for a given input field.
		 * If false returned from beforeShow event handler do not show.
		 * @param  input  element - the input field attached to the date picker or
		 *					event - if triggered by focus
		 */
		_showDatepicker: function( input ) {
			input = input.target || input;
			if ( input.nodeName.toLowerCase() !== "input" ) { // find from button/image trigger
				input = $( "input", input.parentNode )[ 0 ];
			}
	
			if ( $.datepicker._isDisabledDatepicker( input ) || $.datepicker._lastInput === input ) { // already here
				return;
			}
	
			var inst, beforeShow, beforeShowSettings, isFixed,
				offset, showAnim, duration;
	
			inst = $.datepicker._getInst( input );
			if ( $.datepicker._curInst && $.datepicker._curInst !== inst ) {
				$.datepicker._curInst.dpDiv.stop( true, true );
				if ( inst && $.datepicker._datepickerShowing ) {
					$.datepicker._hideDatepicker( $.datepicker._curInst.input[ 0 ] );
				}
			}
	
			beforeShow = $.datepicker._get( inst, "beforeShow" );
			beforeShowSettings = beforeShow ? beforeShow.apply( input, [ input, inst ] ) : {};
			if ( beforeShowSettings === false ) {
				return;
			}
			datepicker_extendRemove( inst.settings, beforeShowSettings );
	
			inst.lastVal = null;
			$.datepicker._lastInput = input;
			$.datepicker._setDateFromField( inst );
	
			if ( $.datepicker._inDialog ) { // hide cursor
				input.value = "";
			}
			if ( !$.datepicker._pos ) { // position below input
				$.datepicker._pos = $.datepicker._findPos( input );
				$.datepicker._pos[ 1 ] += input.offsetHeight; // add the height
			}
	
			isFixed = false;
			$( input ).parents().each( function() {
				isFixed |= $( this ).css( "position" ) === "fixed";
				return !isFixed;
			} );
	
			offset = { left: $.datepicker._pos[ 0 ], top: $.datepicker._pos[ 1 ] };
			$.datepicker._pos = null;
	
			//to avoid flashes on Firefox
			inst.dpDiv.empty();
	
			// determine sizing offscreen
			inst.dpDiv.css( { position: "absolute", display: "block", top: "-1000px" } );
			$.datepicker._updateDatepicker( inst );
	
			// fix width for dynamic number of date pickers
			// and adjust position before showing
			offset = $.datepicker._checkOffset( inst, offset, isFixed );
			inst.dpDiv.css( { position: ( $.datepicker._inDialog && $.blockUI ?
				"static" : ( isFixed ? "fixed" : "absolute" ) ), display: "none",
				left: offset.left + "px", top: offset.top + "px" } );
	
			if ( !inst.inline ) {
				showAnim = $.datepicker._get( inst, "showAnim" );
				duration = $.datepicker._get( inst, "duration" );
				inst.dpDiv.css( "z-index", datepicker_getZindex( $( input ) ) + 1 );
				$.datepicker._datepickerShowing = true;
	
				if ( $.effects && $.effects.effect[ showAnim ] ) {
					inst.dpDiv.show( showAnim, $.datepicker._get( inst, "showOptions" ), duration );
				} else {
					inst.dpDiv[ showAnim || "show" ]( showAnim ? duration : null );
				}
	
				if ( $.datepicker._shouldFocusInput( inst ) ) {
					inst.input.trigger( "focus" );
				}
	
				$.datepicker._curInst = inst;
			}
		},
	
		/* Generate the date picker content. */
		_updateDatepicker: function( inst ) {
			this.maxRows = 4; //Reset the max number of rows being displayed (see #7043)
			datepicker_instActive = inst; // for delegate hover events
			inst.dpDiv.empty().append( this._generateHTML( inst ) );
			this._attachHandlers( inst );
	
			var origyearshtml,
				numMonths = this._getNumberOfMonths( inst ),
				cols = numMonths[ 1 ],
				width = 17,
				activeCell = inst.dpDiv.find( "." + this._dayOverClass + " a" );
	
			if ( activeCell.length > 0 ) {
				datepicker_handleMouseover.apply( activeCell.get( 0 ) );
			}
	
			inst.dpDiv.removeClass( "ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4" ).width( "" );
			if ( cols > 1 ) {
				inst.dpDiv.addClass( "ui-datepicker-multi-" + cols ).css( "width", ( width * cols ) + "em" );
			}
			inst.dpDiv[ ( numMonths[ 0 ] !== 1 || numMonths[ 1 ] !== 1 ? "add" : "remove" ) +
				"Class" ]( "ui-datepicker-multi" );
			inst.dpDiv[ ( this._get( inst, "isRTL" ) ? "add" : "remove" ) +
				"Class" ]( "ui-datepicker-rtl" );
	
			if ( inst === $.datepicker._curInst && $.datepicker._datepickerShowing && $.datepicker._shouldFocusInput( inst ) ) {
				inst.input.trigger( "focus" );
			}
	
			// Deffered render of the years select (to avoid flashes on Firefox)
			if ( inst.yearshtml ) {
				origyearshtml = inst.yearshtml;
				setTimeout( function() {
	
					//assure that inst.yearshtml didn't change.
					if ( origyearshtml === inst.yearshtml && inst.yearshtml ) {
						inst.dpDiv.find( "select.ui-datepicker-year:first" ).replaceWith( inst.yearshtml );
					}
					origyearshtml = inst.yearshtml = null;
				}, 0 );
			}
		},
	
		// #6694 - don't focus the input if it's already focused
		// this breaks the change event in IE
		// Support: IE and jQuery <1.9
		_shouldFocusInput: function( inst ) {
			return inst.input && inst.input.is( ":visible" ) && !inst.input.is( ":disabled" ) && !inst.input.is( ":focus" );
		},
	
		/* Check positioning to remain on screen. */
		_checkOffset: function( inst, offset, isFixed ) {
			var dpWidth = inst.dpDiv.outerWidth(),
				dpHeight = inst.dpDiv.outerHeight(),
				inputWidth = inst.input ? inst.input.outerWidth() : 0,
				inputHeight = inst.input ? inst.input.outerHeight() : 0,
				viewWidth = document.documentElement.clientWidth + ( isFixed ? 0 : $( document ).scrollLeft() ),
				viewHeight = document.documentElement.clientHeight + ( isFixed ? 0 : $( document ).scrollTop() );
	
			offset.left -= ( this._get( inst, "isRTL" ) ? ( dpWidth - inputWidth ) : 0 );
			offset.left -= ( isFixed && offset.left === inst.input.offset().left ) ? $( document ).scrollLeft() : 0;
			offset.top -= ( isFixed && offset.top === ( inst.input.offset().top + inputHeight ) ) ? $( document ).scrollTop() : 0;
	
			// Now check if datepicker is showing outside window viewport - move to a better place if so.
			offset.left -= Math.min( offset.left, ( offset.left + dpWidth > viewWidth && viewWidth > dpWidth ) ?
				Math.abs( offset.left + dpWidth - viewWidth ) : 0 );
			offset.top -= Math.min( offset.top, ( offset.top + dpHeight > viewHeight && viewHeight > dpHeight ) ?
				Math.abs( dpHeight + inputHeight ) : 0 );
	
			return offset;
		},
	
		/* Find an object's position on the screen. */
		_findPos: function( obj ) {
			var position,
				inst = this._getInst( obj ),
				isRTL = this._get( inst, "isRTL" );
	
			while ( obj && ( obj.type === "hidden" || obj.nodeType !== 1 || $.expr.filters.hidden( obj ) ) ) {
				obj = obj[ isRTL ? "previousSibling" : "nextSibling" ];
			}
	
			position = $( obj ).offset();
			return [ position.left, position.top ];
		},
	
		/* Hide the date picker from view.
		 * @param  input  element - the input field attached to the date picker
		 */
		_hideDatepicker: function( input ) {
			var showAnim, duration, postProcess, onClose,
				inst = this._curInst;
	
			if ( !inst || ( input && inst !== $.data( input, "datepicker" ) ) ) {
				return;
			}
	
			if ( this._datepickerShowing ) {
				showAnim = this._get( inst, "showAnim" );
				duration = this._get( inst, "duration" );
				postProcess = function() {
					$.datepicker._tidyDialog( inst );
				};
	
				// DEPRECATED: after BC for 1.8.x $.effects[ showAnim ] is not needed
				if ( $.effects && ( $.effects.effect[ showAnim ] || $.effects[ showAnim ] ) ) {
					inst.dpDiv.hide( showAnim, $.datepicker._get( inst, "showOptions" ), duration, postProcess );
				} else {
					inst.dpDiv[ ( showAnim === "slideDown" ? "slideUp" :
						( showAnim === "fadeIn" ? "fadeOut" : "hide" ) ) ]( ( showAnim ? duration : null ), postProcess );
				}
	
				if ( !showAnim ) {
					postProcess();
				}
				this._datepickerShowing = false;
	
				onClose = this._get( inst, "onClose" );
				if ( onClose ) {
					onClose.apply( ( inst.input ? inst.input[ 0 ] : null ), [ ( inst.input ? inst.input.val() : "" ), inst ] );
				}
	
				this._lastInput = null;
				if ( this._inDialog ) {
					this._dialogInput.css( { position: "absolute", left: "0", top: "-100px" } );
					if ( $.blockUI ) {
						$.unblockUI();
						$( "body" ).append( this.dpDiv );
					}
				}
				this._inDialog = false;
			}
		},
	
		/* Tidy up after a dialog display. */
		_tidyDialog: function( inst ) {
			inst.dpDiv.removeClass( this._dialogClass ).off( ".ui-datepicker-calendar" );
		},
	
		/* Close date picker if clicked elsewhere. */
		_checkExternalClick: function( event ) {
			if ( !$.datepicker._curInst ) {
				return;
			}
	
			var $target = $( event.target ),
				inst = $.datepicker._getInst( $target[ 0 ] );
	
			if ( ( ( $target[ 0 ].id !== $.datepicker._mainDivId &&
					$target.parents( "#" + $.datepicker._mainDivId ).length === 0 &&
					!$target.hasClass( $.datepicker.markerClassName ) &&
					!$target.closest( "." + $.datepicker._triggerClass ).length &&
					$.datepicker._datepickerShowing && !( $.datepicker._inDialog && $.blockUI ) ) ) ||
				( $target.hasClass( $.datepicker.markerClassName ) && $.datepicker._curInst !== inst ) ) {
					$.datepicker._hideDatepicker();
			}
		},
	
		/* Adjust one of the date sub-fields. */
		_adjustDate: function( id, offset, period ) {
			var target = $( id ),
				inst = this._getInst( target[ 0 ] );
	
			if ( this._isDisabledDatepicker( target[ 0 ] ) ) {
				return;
			}
			this._adjustInstDate( inst, offset +
				( period === "M" ? this._get( inst, "showCurrentAtPos" ) : 0 ), // undo positioning
				period );
			this._updateDatepicker( inst );
		},
	
		/* Action for current link. */
		_gotoToday: function( id ) {
			var date,
				target = $( id ),
				inst = this._getInst( target[ 0 ] );
	
			if ( this._get( inst, "gotoCurrent" ) && inst.currentDay ) {
				inst.selectedDay = inst.currentDay;
				inst.drawMonth = inst.selectedMonth = inst.currentMonth;
				inst.drawYear = inst.selectedYear = inst.currentYear;
			} else {
				date = new Date();
				inst.selectedDay = date.getDate();
				inst.drawMonth = inst.selectedMonth = date.getMonth();
				inst.drawYear = inst.selectedYear = date.getFullYear();
			}
			this._notifyChange( inst );
			this._adjustDate( target );
		},
	
		/* Action for selecting a new month/year. */
		_selectMonthYear: function( id, select, period ) {
			var target = $( id ),
				inst = this._getInst( target[ 0 ] );
	
			inst[ "selected" + ( period === "M" ? "Month" : "Year" ) ] =
			inst[ "draw" + ( period === "M" ? "Month" : "Year" ) ] =
				parseInt( select.options[ select.selectedIndex ].value, 10 );
	
			this._notifyChange( inst );
			this._adjustDate( target );
		},
	
		/* Action for selecting a day. */
		_selectDay: function( id, month, year, td ) {
			var inst,
				target = $( id );
	
			if ( $( td ).hasClass( this._unselectableClass ) || this._isDisabledDatepicker( target[ 0 ] ) ) {
				return;
			}
	
			inst = this._getInst( target[ 0 ] );
			inst.selectedDay = inst.currentDay = $( "a", td ).html();
			inst.selectedMonth = inst.currentMonth = month;
			inst.selectedYear = inst.currentYear = year;
			this._selectDate( id, this._formatDate( inst,
				inst.currentDay, inst.currentMonth, inst.currentYear ) );
		},
	
		/* Erase the input field and hide the date picker. */
		_clearDate: function( id ) {
			var target = $( id );
			this._selectDate( target, "" );
		},
	
		/* Update the input field with the selected date. */
		_selectDate: function( id, dateStr ) {
			var onSelect,
				target = $( id ),
				inst = this._getInst( target[ 0 ] );
	
			dateStr = ( dateStr != null ? dateStr : this._formatDate( inst ) );
			if ( inst.input ) {
				inst.input.val( dateStr );
			}
			this._updateAlternate( inst );
	
			onSelect = this._get( inst, "onSelect" );
			if ( onSelect ) {
				onSelect.apply( ( inst.input ? inst.input[ 0 ] : null ), [ dateStr, inst ] );  // trigger custom callback
			} else if ( inst.input ) {
				inst.input.trigger( "change" ); // fire the change event
			}
	
			if ( inst.inline ) {
				this._updateDatepicker( inst );
			} else {
				this._hideDatepicker();
				this._lastInput = inst.input[ 0 ];
				if ( typeof( inst.input[ 0 ] ) !== "object" ) {
					inst.input.trigger( "focus" ); // restore focus
				}
				this._lastInput = null;
			}
		},
	
		/* Update any alternate field to synchronise with the main field. */
		_updateAlternate: function( inst ) {
			var altFormat, date, dateStr,
				altField = this._get( inst, "altField" );
	
			if ( altField ) { // update alternate field too
				altFormat = this._get( inst, "altFormat" ) || this._get( inst, "dateFormat" );
				date = this._getDate( inst );
				dateStr = this.formatDate( altFormat, date, this._getFormatConfig( inst ) );
				$( altField ).val( dateStr );
			}
		},
	
		/* Set as beforeShowDay function to prevent selection of weekends.
		 * @param  date  Date - the date to customise
		 * @return [boolean, string] - is this date selectable?, what is its CSS class?
		 */
		noWeekends: function( date ) {
			var day = date.getDay();
			return [ ( day > 0 && day < 6 ), "" ];
		},
	
		/* Set as calculateWeek to determine the week of the year based on the ISO 8601 definition.
		 * @param  date  Date - the date to get the week for
		 * @return  number - the number of the week within the year that contains this date
		 */
		iso8601Week: function( date ) {
			var time,
				checkDate = new Date( date.getTime() );
	
			// Find Thursday of this week starting on Monday
			checkDate.setDate( checkDate.getDate() + 4 - ( checkDate.getDay() || 7 ) );
	
			time = checkDate.getTime();
			checkDate.setMonth( 0 ); // Compare with Jan 1
			checkDate.setDate( 1 );
			return Math.floor( Math.round( ( time - checkDate ) / 86400000 ) / 7 ) + 1;
		},
	
		/* Parse a string value into a date object.
		 * See formatDate below for the possible formats.
		 *
		 * @param  format string - the expected format of the date
		 * @param  value string - the date in the above format
		 * @param  settings Object - attributes include:
		 *					shortYearCutoff  number - the cutoff year for determining the century (optional)
		 *					dayNamesShort	string[7] - abbreviated names of the days from Sunday (optional)
		 *					dayNames		string[7] - names of the days from Sunday (optional)
		 *					monthNamesShort string[12] - abbreviated names of the months (optional)
		 *					monthNames		string[12] - names of the months (optional)
		 * @return  Date - the extracted date value or null if value is blank
		 */
		parseDate: function( format, value, settings ) {
			if ( format == null || value == null ) {
				throw "Invalid arguments";
			}
	
			value = ( typeof value === "object" ? value.toString() : value + "" );
			if ( value === "" ) {
				return null;
			}
	
			var iFormat, dim, extra,
				iValue = 0,
				shortYearCutoffTemp = ( settings ? settings.shortYearCutoff : null ) || this._defaults.shortYearCutoff,
				shortYearCutoff = ( typeof shortYearCutoffTemp !== "string" ? shortYearCutoffTemp :
					new Date().getFullYear() % 100 + parseInt( shortYearCutoffTemp, 10 ) ),
				dayNamesShort = ( settings ? settings.dayNamesShort : null ) || this._defaults.dayNamesShort,
				dayNames = ( settings ? settings.dayNames : null ) || this._defaults.dayNames,
				monthNamesShort = ( settings ? settings.monthNamesShort : null ) || this._defaults.monthNamesShort,
				monthNames = ( settings ? settings.monthNames : null ) || this._defaults.monthNames,
				year = -1,
				month = -1,
				day = -1,
				doy = -1,
				literal = false,
				date,
	
				// Check whether a format character is doubled
				lookAhead = function( match ) {
					var matches = ( iFormat + 1 < format.length && format.charAt( iFormat + 1 ) === match );
					if ( matches ) {
						iFormat++;
					}
					return matches;
				},
	
				// Extract a number from the string value
				getNumber = function( match ) {
					var isDoubled = lookAhead( match ),
						size = ( match === "@" ? 14 : ( match === "!" ? 20 :
						( match === "y" && isDoubled ? 4 : ( match === "o" ? 3 : 2 ) ) ) ),
						minSize = ( match === "y" ? size : 1 ),
						digits = new RegExp( "^\\d{" + minSize + "," + size + "}" ),
						num = value.substring( iValue ).match( digits );
					if ( !num ) {
						throw "Missing number at position " + iValue;
					}
					iValue += num[ 0 ].length;
					return parseInt( num[ 0 ], 10 );
				},
	
				// Extract a name from the string value and convert to an index
				getName = function( match, shortNames, longNames ) {
					var index = -1,
						names = $.map( lookAhead( match ) ? longNames : shortNames, function( v, k ) {
							return [ [ k, v ] ];
						} ).sort( function( a, b ) {
							return -( a[ 1 ].length - b[ 1 ].length );
						} );
	
					$.each( names, function( i, pair ) {
						var name = pair[ 1 ];
						if ( value.substr( iValue, name.length ).toLowerCase() === name.toLowerCase() ) {
							index = pair[ 0 ];
							iValue += name.length;
							return false;
						}
					} );
					if ( index !== -1 ) {
						return index + 1;
					} else {
						throw "Unknown name at position " + iValue;
					}
				},
	
				// Confirm that a literal character matches the string value
				checkLiteral = function() {
					if ( value.charAt( iValue ) !== format.charAt( iFormat ) ) {
						throw "Unexpected literal at position " + iValue;
					}
					iValue++;
				};
	
			for ( iFormat = 0; iFormat < format.length; iFormat++ ) {
				if ( literal ) {
					if ( format.charAt( iFormat ) === "'" && !lookAhead( "'" ) ) {
						literal = false;
					} else {
						checkLiteral();
					}
				} else {
					switch ( format.charAt( iFormat ) ) {
						case "d":
							day = getNumber( "d" );
							break;
						case "D":
							getName( "D", dayNamesShort, dayNames );
							break;
						case "o":
							doy = getNumber( "o" );
							break;
						case "m":
							month = getNumber( "m" );
							break;
						case "M":
							month = getName( "M", monthNamesShort, monthNames );
							break;
						case "y":
							year = getNumber( "y" );
							break;
						case "@":
							date = new Date( getNumber( "@" ) );
							year = date.getFullYear();
							month = date.getMonth() + 1;
							day = date.getDate();
							break;
						case "!":
							date = new Date( ( getNumber( "!" ) - this._ticksTo1970 ) / 10000 );
							year = date.getFullYear();
							month = date.getMonth() + 1;
							day = date.getDate();
							break;
						case "'":
							if ( lookAhead( "'" ) ) {
								checkLiteral();
							} else {
								literal = true;
							}
							break;
						default:
							checkLiteral();
					}
				}
			}
	
			if ( iValue < value.length ) {
				extra = value.substr( iValue );
				if ( !/^\s+/.test( extra ) ) {
					throw "Extra/unparsed characters found in date: " + extra;
				}
			}
	
			if ( year === -1 ) {
				year = new Date().getFullYear();
			} else if ( year < 100 ) {
				year += new Date().getFullYear() - new Date().getFullYear() % 100 +
					( year <= shortYearCutoff ? 0 : -100 );
			}
	
			if ( doy > -1 ) {
				month = 1;
				day = doy;
				do {
					dim = this._getDaysInMonth( year, month - 1 );
					if ( day <= dim ) {
						break;
					}
					month++;
					day -= dim;
				} while ( true );
			}
	
			date = this._daylightSavingAdjust( new Date( year, month - 1, day ) );
			if ( date.getFullYear() !== year || date.getMonth() + 1 !== month || date.getDate() !== day ) {
				throw "Invalid date"; // E.g. 31/02/00
			}
			return date;
		},
	
		/* Standard date formats. */
		ATOM: "yy-mm-dd", // RFC 3339 (ISO 8601)
		COOKIE: "D, dd M yy",
		ISO_8601: "yy-mm-dd",
		RFC_822: "D, d M y",
		RFC_850: "DD, dd-M-y",
		RFC_1036: "D, d M y",
		RFC_1123: "D, d M yy",
		RFC_2822: "D, d M yy",
		RSS: "D, d M y", // RFC 822
		TICKS: "!",
		TIMESTAMP: "@",
		W3C: "yy-mm-dd", // ISO 8601
	
		_ticksTo1970: ( ( ( 1970 - 1 ) * 365 + Math.floor( 1970 / 4 ) - Math.floor( 1970 / 100 ) +
			Math.floor( 1970 / 400 ) ) * 24 * 60 * 60 * 10000000 ),
	
		/* Format a date object into a string value.
		 * The format can be combinations of the following:
		 * d  - day of month (no leading zero)
		 * dd - day of month (two digit)
		 * o  - day of year (no leading zeros)
		 * oo - day of year (three digit)
		 * D  - day name short
		 * DD - day name long
		 * m  - month of year (no leading zero)
		 * mm - month of year (two digit)
		 * M  - month name short
		 * MM - month name long
		 * y  - year (two digit)
		 * yy - year (four digit)
		 * @ - Unix timestamp (ms since 01/01/1970)
		 * ! - Windows ticks (100ns since 01/01/0001)
		 * "..." - literal text
		 * '' - single quote
		 *
		 * @param  format string - the desired format of the date
		 * @param  date Date - the date value to format
		 * @param  settings Object - attributes include:
		 *					dayNamesShort	string[7] - abbreviated names of the days from Sunday (optional)
		 *					dayNames		string[7] - names of the days from Sunday (optional)
		 *					monthNamesShort string[12] - abbreviated names of the months (optional)
		 *					monthNames		string[12] - names of the months (optional)
		 * @return  string - the date in the above format
		 */
		formatDate: function( format, date, settings ) {
			if ( !date ) {
				return "";
			}
	
			var iFormat,
				dayNamesShort = ( settings ? settings.dayNamesShort : null ) || this._defaults.dayNamesShort,
				dayNames = ( settings ? settings.dayNames : null ) || this._defaults.dayNames,
				monthNamesShort = ( settings ? settings.monthNamesShort : null ) || this._defaults.monthNamesShort,
				monthNames = ( settings ? settings.monthNames : null ) || this._defaults.monthNames,
	
				// Check whether a format character is doubled
				lookAhead = function( match ) {
					var matches = ( iFormat + 1 < format.length && format.charAt( iFormat + 1 ) === match );
					if ( matches ) {
						iFormat++;
					}
					return matches;
				},
	
				// Format a number, with leading zero if necessary
				formatNumber = function( match, value, len ) {
					var num = "" + value;
					if ( lookAhead( match ) ) {
						while ( num.length < len ) {
							num = "0" + num;
						}
					}
					return num;
				},
	
				// Format a name, short or long as requested
				formatName = function( match, value, shortNames, longNames ) {
					return ( lookAhead( match ) ? longNames[ value ] : shortNames[ value ] );
				},
				output = "",
				literal = false;
	
			if ( date ) {
				for ( iFormat = 0; iFormat < format.length; iFormat++ ) {
					if ( literal ) {
						if ( format.charAt( iFormat ) === "'" && !lookAhead( "'" ) ) {
							literal = false;
						} else {
							output += format.charAt( iFormat );
						}
					} else {
						switch ( format.charAt( iFormat ) ) {
							case "d":
								output += formatNumber( "d", date.getDate(), 2 );
								break;
							case "D":
								output += formatName( "D", date.getDay(), dayNamesShort, dayNames );
								break;
							case "o":
								output += formatNumber( "o",
									Math.round( ( new Date( date.getFullYear(), date.getMonth(), date.getDate() ).getTime() - new Date( date.getFullYear(), 0, 0 ).getTime() ) / 86400000 ), 3 );
								break;
							case "m":
								output += formatNumber( "m", date.getMonth() + 1, 2 );
								break;
							case "M":
								output += formatName( "M", date.getMonth(), monthNamesShort, monthNames );
								break;
							case "y":
								output += ( lookAhead( "y" ) ? date.getFullYear() :
									( date.getFullYear() % 100 < 10 ? "0" : "" ) + date.getFullYear() % 100 );
								break;
							case "@":
								output += date.getTime();
								break;
							case "!":
								output += date.getTime() * 10000 + this._ticksTo1970;
								break;
							case "'":
								if ( lookAhead( "'" ) ) {
									output += "'";
								} else {
									literal = true;
								}
								break;
							default:
								output += format.charAt( iFormat );
						}
					}
				}
			}
			return output;
		},
	
		/* Extract all possible characters from the date format. */
		_possibleChars: function( format ) {
			var iFormat,
				chars = "",
				literal = false,
	
				// Check whether a format character is doubled
				lookAhead = function( match ) {
					var matches = ( iFormat + 1 < format.length && format.charAt( iFormat + 1 ) === match );
					if ( matches ) {
						iFormat++;
					}
					return matches;
				};
	
			for ( iFormat = 0; iFormat < format.length; iFormat++ ) {
				if ( literal ) {
					if ( format.charAt( iFormat ) === "'" && !lookAhead( "'" ) ) {
						literal = false;
					} else {
						chars += format.charAt( iFormat );
					}
				} else {
					switch ( format.charAt( iFormat ) ) {
						case "d": case "m": case "y": case "@":
							chars += "0123456789";
							break;
						case "D": case "M":
							return null; // Accept anything
						case "'":
							if ( lookAhead( "'" ) ) {
								chars += "'";
							} else {
								literal = true;
							}
							break;
						default:
							chars += format.charAt( iFormat );
					}
				}
			}
			return chars;
		},
	
		/* Get a setting value, defaulting if necessary. */
		_get: function( inst, name ) {
			return inst.settings[ name ] !== undefined ?
				inst.settings[ name ] : this._defaults[ name ];
		},
	
		/* Parse existing date and initialise date picker. */
		_setDateFromField: function( inst, noDefault ) {
			if ( inst.input.val() === inst.lastVal ) {
				return;
			}
	
			var dateFormat = this._get( inst, "dateFormat" ),
				dates = inst.lastVal = inst.input ? inst.input.val() : null,
				defaultDate = this._getDefaultDate( inst ),
				date = defaultDate,
				settings = this._getFormatConfig( inst );
	
			try {
				date = this.parseDate( dateFormat, dates, settings ) || defaultDate;
			} catch ( event ) {
				dates = ( noDefault ? "" : dates );
			}
			inst.selectedDay = date.getDate();
			inst.drawMonth = inst.selectedMonth = date.getMonth();
			inst.drawYear = inst.selectedYear = date.getFullYear();
			inst.currentDay = ( dates ? date.getDate() : 0 );
			inst.currentMonth = ( dates ? date.getMonth() : 0 );
			inst.currentYear = ( dates ? date.getFullYear() : 0 );
			this._adjustInstDate( inst );
		},
	
		/* Retrieve the default date shown on opening. */
		_getDefaultDate: function( inst ) {
			return this._restrictMinMax( inst,
				this._determineDate( inst, this._get( inst, "defaultDate" ), new Date() ) );
		},
	
		/* A date may be specified as an exact value or a relative one. */
		_determineDate: function( inst, date, defaultDate ) {
			var offsetNumeric = function( offset ) {
					var date = new Date();
					date.setDate( date.getDate() + offset );
					return date;
				},
				offsetString = function( offset ) {
					try {
						return $.datepicker.parseDate( $.datepicker._get( inst, "dateFormat" ),
							offset, $.datepicker._getFormatConfig( inst ) );
					}
					catch ( e ) {
	
						// Ignore
					}
	
					var date = ( offset.toLowerCase().match( /^c/ ) ?
						$.datepicker._getDate( inst ) : null ) || new Date(),
						year = date.getFullYear(),
						month = date.getMonth(),
						day = date.getDate(),
						pattern = /([+\-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g,
						matches = pattern.exec( offset );
	
					while ( matches ) {
						switch ( matches[ 2 ] || "d" ) {
							case "d" : case "D" :
								day += parseInt( matches[ 1 ], 10 ); break;
							case "w" : case "W" :
								day += parseInt( matches[ 1 ], 10 ) * 7; break;
							case "m" : case "M" :
								month += parseInt( matches[ 1 ], 10 );
								day = Math.min( day, $.datepicker._getDaysInMonth( year, month ) );
								break;
							case "y": case "Y" :
								year += parseInt( matches[ 1 ], 10 );
								day = Math.min( day, $.datepicker._getDaysInMonth( year, month ) );
								break;
						}
						matches = pattern.exec( offset );
					}
					return new Date( year, month, day );
				},
				newDate = ( date == null || date === "" ? defaultDate : ( typeof date === "string" ? offsetString( date ) :
					( typeof date === "number" ? ( isNaN( date ) ? defaultDate : offsetNumeric( date ) ) : new Date( date.getTime() ) ) ) );
	
			newDate = ( newDate && newDate.toString() === "Invalid Date" ? defaultDate : newDate );
			if ( newDate ) {
				newDate.setHours( 0 );
				newDate.setMinutes( 0 );
				newDate.setSeconds( 0 );
				newDate.setMilliseconds( 0 );
			}
			return this._daylightSavingAdjust( newDate );
		},
	
		/* Handle switch to/from daylight saving.
		 * Hours may be non-zero on daylight saving cut-over:
		 * > 12 when midnight changeover, but then cannot generate
		 * midnight datetime, so jump to 1AM, otherwise reset.
		 * @param  date  (Date) the date to check
		 * @return  (Date) the corrected date
		 */
		_daylightSavingAdjust: function( date ) {
			if ( !date ) {
				return null;
			}
			date.setHours( date.getHours() > 12 ? date.getHours() + 2 : 0 );
			return date;
		},
	
		/* Set the date(s) directly. */
		_setDate: function( inst, date, noChange ) {
			var clear = !date,
				origMonth = inst.selectedMonth,
				origYear = inst.selectedYear,
				newDate = this._restrictMinMax( inst, this._determineDate( inst, date, new Date() ) );
	
			inst.selectedDay = inst.currentDay = newDate.getDate();
			inst.drawMonth = inst.selectedMonth = inst.currentMonth = newDate.getMonth();
			inst.drawYear = inst.selectedYear = inst.currentYear = newDate.getFullYear();
			if ( ( origMonth !== inst.selectedMonth || origYear !== inst.selectedYear ) && !noChange ) {
				this._notifyChange( inst );
			}
			this._adjustInstDate( inst );
			if ( inst.input ) {
				inst.input.val( clear ? "" : this._formatDate( inst ) );
			}
		},
	
		/* Retrieve the date(s) directly. */
		_getDate: function( inst ) {
			var startDate = ( !inst.currentYear || ( inst.input && inst.input.val() === "" ) ? null :
				this._daylightSavingAdjust( new Date(
				inst.currentYear, inst.currentMonth, inst.currentDay ) ) );
				return startDate;
		},
	
		/* Attach the onxxx handlers.  These are declared statically so
		 * they work with static code transformers like Caja.
		 */
		_attachHandlers: function( inst ) {
			var stepMonths = this._get( inst, "stepMonths" ),
				id = "#" + inst.id.replace( /\\\\/g, "\\" );
			inst.dpDiv.find( "[data-handler]" ).map( function() {
				var handler = {
					prev: function() {
						$.datepicker._adjustDate( id, -stepMonths, "M" );
					},
					next: function() {
						$.datepicker._adjustDate( id, +stepMonths, "M" );
					},
					hide: function() {
						$.datepicker._hideDatepicker();
					},
					today: function() {
						$.datepicker._gotoToday( id );
					},
					selectDay: function() {
						$.datepicker._selectDay( id, +this.getAttribute( "data-month" ), +this.getAttribute( "data-year" ), this );
						return false;
					},
					selectMonth: function() {
						$.datepicker._selectMonthYear( id, this, "M" );
						return false;
					},
					selectYear: function() {
						$.datepicker._selectMonthYear( id, this, "Y" );
						return false;
					}
				};
				$( this ).on( this.getAttribute( "data-event" ), handler[ this.getAttribute( "data-handler" ) ] );
			} );
		},
	
		/* Generate the HTML for the current state of the date picker. */
		_generateHTML: function( inst ) {
			var maxDraw, prevText, prev, nextText, next, currentText, gotoDate,
				controls, buttonPanel, firstDay, showWeek, dayNames, dayNamesMin,
				monthNames, monthNamesShort, beforeShowDay, showOtherMonths,
				selectOtherMonths, defaultDate, html, dow, row, group, col, selectedDate,
				cornerClass, calender, thead, day, daysInMonth, leadDays, curRows, numRows,
				printDate, dRow, tbody, daySettings, otherMonth, unselectable,
				tempDate = new Date(),
				today = this._daylightSavingAdjust(
					new Date( tempDate.getFullYear(), tempDate.getMonth(), tempDate.getDate() ) ), // clear time
				isRTL = this._get( inst, "isRTL" ),
				showButtonPanel = this._get( inst, "showButtonPanel" ),
				hideIfNoPrevNext = this._get( inst, "hideIfNoPrevNext" ),
				navigationAsDateFormat = this._get( inst, "navigationAsDateFormat" ),
				numMonths = this._getNumberOfMonths( inst ),
				showCurrentAtPos = this._get( inst, "showCurrentAtPos" ),
				stepMonths = this._get( inst, "stepMonths" ),
				isMultiMonth = ( numMonths[ 0 ] !== 1 || numMonths[ 1 ] !== 1 ),
				currentDate = this._daylightSavingAdjust( ( !inst.currentDay ? new Date( 9999, 9, 9 ) :
					new Date( inst.currentYear, inst.currentMonth, inst.currentDay ) ) ),
				minDate = this._getMinMaxDate( inst, "min" ),
				maxDate = this._getMinMaxDate( inst, "max" ),
				drawMonth = inst.drawMonth - showCurrentAtPos,
				drawYear = inst.drawYear;
	
			if ( drawMonth < 0 ) {
				drawMonth += 12;
				drawYear--;
			}
			if ( maxDate ) {
				maxDraw = this._daylightSavingAdjust( new Date( maxDate.getFullYear(),
					maxDate.getMonth() - ( numMonths[ 0 ] * numMonths[ 1 ] ) + 1, maxDate.getDate() ) );
				maxDraw = ( minDate && maxDraw < minDate ? minDate : maxDraw );
				while ( this._daylightSavingAdjust( new Date( drawYear, drawMonth, 1 ) ) > maxDraw ) {
					drawMonth--;
					if ( drawMonth < 0 ) {
						drawMonth = 11;
						drawYear--;
					}
				}
			}
			inst.drawMonth = drawMonth;
			inst.drawYear = drawYear;
	
			prevText = this._get( inst, "prevText" );
			prevText = ( !navigationAsDateFormat ? prevText : this.formatDate( prevText,
				this._daylightSavingAdjust( new Date( drawYear, drawMonth - stepMonths, 1 ) ),
				this._getFormatConfig( inst ) ) );
	
			prev = ( this._canAdjustMonth( inst, -1, drawYear, drawMonth ) ?
				"<a class='ui-datepicker-prev ui-corner-all' data-handler='prev' data-event='click'" +
				" title='" + prevText + "'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "e" : "w" ) + "'>" + prevText + "</span></a>" :
				( hideIfNoPrevNext ? "" : "<a class='ui-datepicker-prev ui-corner-all ui-state-disabled' title='" + prevText + "'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "e" : "w" ) + "'>" + prevText + "</span></a>" ) );
	
			nextText = this._get( inst, "nextText" );
			nextText = ( !navigationAsDateFormat ? nextText : this.formatDate( nextText,
				this._daylightSavingAdjust( new Date( drawYear, drawMonth + stepMonths, 1 ) ),
				this._getFormatConfig( inst ) ) );
	
			next = ( this._canAdjustMonth( inst, +1, drawYear, drawMonth ) ?
				"<a class='ui-datepicker-next ui-corner-all' data-handler='next' data-event='click'" +
				" title='" + nextText + "'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "w" : "e" ) + "'>" + nextText + "</span></a>" :
				( hideIfNoPrevNext ? "" : "<a class='ui-datepicker-next ui-corner-all ui-state-disabled' title='" + nextText + "'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "w" : "e" ) + "'>" + nextText + "</span></a>" ) );
	
			currentText = this._get( inst, "currentText" );
			gotoDate = ( this._get( inst, "gotoCurrent" ) && inst.currentDay ? currentDate : today );
			currentText = ( !navigationAsDateFormat ? currentText :
				this.formatDate( currentText, gotoDate, this._getFormatConfig( inst ) ) );
	
			controls = ( !inst.inline ? "<button type='button' class='ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all' data-handler='hide' data-event='click'>" +
				this._get( inst, "closeText" ) + "</button>" : "" );
	
			buttonPanel = ( showButtonPanel ) ? "<div class='ui-datepicker-buttonpane ui-widget-content'>" + ( isRTL ? controls : "" ) +
				( this._isInRange( inst, gotoDate ) ? "<button type='button' class='ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all' data-handler='today' data-event='click'" +
				">" + currentText + "</button>" : "" ) + ( isRTL ? "" : controls ) + "</div>" : "";
	
			firstDay = parseInt( this._get( inst, "firstDay" ), 10 );
			firstDay = ( isNaN( firstDay ) ? 0 : firstDay );
	
			showWeek = this._get( inst, "showWeek" );
			dayNames = this._get( inst, "dayNames" );
			dayNamesMin = this._get( inst, "dayNamesMin" );
			monthNames = this._get( inst, "monthNames" );
			monthNamesShort = this._get( inst, "monthNamesShort" );
			beforeShowDay = this._get( inst, "beforeShowDay" );
			showOtherMonths = this._get( inst, "showOtherMonths" );
			selectOtherMonths = this._get( inst, "selectOtherMonths" );
			defaultDate = this._getDefaultDate( inst );
			html = "";
	
			for ( row = 0; row < numMonths[ 0 ]; row++ ) {
				group = "";
				this.maxRows = 4;
				for ( col = 0; col < numMonths[ 1 ]; col++ ) {
					selectedDate = this._daylightSavingAdjust( new Date( drawYear, drawMonth, inst.selectedDay ) );
					cornerClass = " ui-corner-all";
					calender = "";
					if ( isMultiMonth ) {
						calender += "<div class='ui-datepicker-group";
						if ( numMonths[ 1 ] > 1 ) {
							switch ( col ) {
								case 0: calender += " ui-datepicker-group-first";
									cornerClass = " ui-corner-" + ( isRTL ? "right" : "left" ); break;
								case numMonths[ 1 ] - 1: calender += " ui-datepicker-group-last";
									cornerClass = " ui-corner-" + ( isRTL ? "left" : "right" ); break;
								default: calender += " ui-datepicker-group-middle"; cornerClass = ""; break;
							}
						}
						calender += "'>";
					}
					calender += "<div class='ui-datepicker-header ui-widget-header ui-helper-clearfix" + cornerClass + "'>" +
						( /all|left/.test( cornerClass ) && row === 0 ? ( isRTL ? next : prev ) : "" ) +
						( /all|right/.test( cornerClass ) && row === 0 ? ( isRTL ? prev : next ) : "" ) +
						this._generateMonthYearHeader( inst, drawMonth, drawYear, minDate, maxDate,
						row > 0 || col > 0, monthNames, monthNamesShort ) + // draw month headers
						"</div><table class='ui-datepicker-calendar'><thead>" +
						"<tr>";
					thead = ( showWeek ? "<th class='ui-datepicker-week-col'>" + this._get( inst, "weekHeader" ) + "</th>" : "" );
					for ( dow = 0; dow < 7; dow++ ) { // days of the week
						day = ( dow + firstDay ) % 7;
						thead += "<th scope='col'" + ( ( dow + firstDay + 6 ) % 7 >= 5 ? " class='ui-datepicker-week-end'" : "" ) + ">" +
							"<span title='" + dayNames[ day ] + "'>" + dayNamesMin[ day ] + "</span></th>";
					}
					calender += thead + "</tr></thead><tbody>";
					daysInMonth = this._getDaysInMonth( drawYear, drawMonth );
					if ( drawYear === inst.selectedYear && drawMonth === inst.selectedMonth ) {
						inst.selectedDay = Math.min( inst.selectedDay, daysInMonth );
					}
					leadDays = ( this._getFirstDayOfMonth( drawYear, drawMonth ) - firstDay + 7 ) % 7;
					curRows = Math.ceil( ( leadDays + daysInMonth ) / 7 ); // calculate the number of rows to generate
					numRows = ( isMultiMonth ? this.maxRows > curRows ? this.maxRows : curRows : curRows ); //If multiple months, use the higher number of rows (see #7043)
					this.maxRows = numRows;
					printDate = this._daylightSavingAdjust( new Date( drawYear, drawMonth, 1 - leadDays ) );
					for ( dRow = 0; dRow < numRows; dRow++ ) { // create date picker rows
						calender += "<tr>";
						tbody = ( !showWeek ? "" : "<td class='ui-datepicker-week-col'>" +
							this._get( inst, "calculateWeek" )( printDate ) + "</td>" );
						for ( dow = 0; dow < 7; dow++ ) { // create date picker days
							daySettings = ( beforeShowDay ?
								beforeShowDay.apply( ( inst.input ? inst.input[ 0 ] : null ), [ printDate ] ) : [ true, "" ] );
							otherMonth = ( printDate.getMonth() !== drawMonth );
							unselectable = ( otherMonth && !selectOtherMonths ) || !daySettings[ 0 ] ||
								( minDate && printDate < minDate ) || ( maxDate && printDate > maxDate );
							tbody += "<td class='" +
								( ( dow + firstDay + 6 ) % 7 >= 5 ? " ui-datepicker-week-end" : "" ) + // highlight weekends
								( otherMonth ? " ui-datepicker-other-month" : "" ) + // highlight days from other months
								( ( printDate.getTime() === selectedDate.getTime() && drawMonth === inst.selectedMonth && inst._keyEvent ) || // user pressed key
								( defaultDate.getTime() === printDate.getTime() && defaultDate.getTime() === selectedDate.getTime() ) ?
	
								// or defaultDate is current printedDate and defaultDate is selectedDate
								" " + this._dayOverClass : "" ) + // highlight selected day
								( unselectable ? " " + this._unselectableClass + " ui-state-disabled" : "" ) +  // highlight unselectable days
								( otherMonth && !showOtherMonths ? "" : " " + daySettings[ 1 ] + // highlight custom dates
								( printDate.getTime() === currentDate.getTime() ? " " + this._currentClass : "" ) + // highlight selected day
								( printDate.getTime() === today.getTime() ? " ui-datepicker-today" : "" ) ) + "'" + // highlight today (if different)
								( ( !otherMonth || showOtherMonths ) && daySettings[ 2 ] ? " title='" + daySettings[ 2 ].replace( /'/g, "&#39;" ) + "'" : "" ) + // cell title
								( unselectable ? "" : " data-handler='selectDay' data-event='click' data-month='" + printDate.getMonth() + "' data-year='" + printDate.getFullYear() + "'" ) + ">" + // actions
								( otherMonth && !showOtherMonths ? "&#xa0;" : // display for other months
								( unselectable ? "<span class='ui-state-default'>" + printDate.getDate() + "</span>" : "<a class='ui-state-default" +
								( printDate.getTime() === today.getTime() ? " ui-state-highlight" : "" ) +
								( printDate.getTime() === currentDate.getTime() ? " ui-state-active" : "" ) + // highlight selected day
								( otherMonth ? " ui-priority-secondary" : "" ) + // distinguish dates from other months
								"' href='#'>" + printDate.getDate() + "</a>" ) ) + "</td>"; // display selectable date
							printDate.setDate( printDate.getDate() + 1 );
							printDate = this._daylightSavingAdjust( printDate );
						}
						calender += tbody + "</tr>";
					}
					drawMonth++;
					if ( drawMonth > 11 ) {
						drawMonth = 0;
						drawYear++;
					}
					calender += "</tbody></table>" + ( isMultiMonth ? "</div>" +
								( ( numMonths[ 0 ] > 0 && col === numMonths[ 1 ] - 1 ) ? "<div class='ui-datepicker-row-break'></div>" : "" ) : "" );
					group += calender;
				}
				html += group;
			}
			html += buttonPanel;
			inst._keyEvent = false;
			return html;
		},
	
		/* Generate the month and year header. */
		_generateMonthYearHeader: function( inst, drawMonth, drawYear, minDate, maxDate,
				secondary, monthNames, monthNamesShort ) {
	
			var inMinYear, inMaxYear, month, years, thisYear, determineYear, year, endYear,
				changeMonth = this._get( inst, "changeMonth" ),
				changeYear = this._get( inst, "changeYear" ),
				showMonthAfterYear = this._get( inst, "showMonthAfterYear" ),
				html = "<div class='ui-datepicker-title'>",
				monthHtml = "";
	
			// Month selection
			if ( secondary || !changeMonth ) {
				monthHtml += "<span class='ui-datepicker-month'>" + monthNames[ drawMonth ] + "</span>";
			} else {
				inMinYear = ( minDate && minDate.getFullYear() === drawYear );
				inMaxYear = ( maxDate && maxDate.getFullYear() === drawYear );
				monthHtml += "<select class='ui-datepicker-month' data-handler='selectMonth' data-event='change'>";
				for ( month = 0; month < 12; month++ ) {
					if ( ( !inMinYear || month >= minDate.getMonth() ) && ( !inMaxYear || month <= maxDate.getMonth() ) ) {
						monthHtml += "<option value='" + month + "'" +
							( month === drawMonth ? " selected='selected'" : "" ) +
							">" + monthNamesShort[ month ] + "</option>";
					}
				}
				monthHtml += "</select>";
			}
	
			if ( !showMonthAfterYear ) {
				html += monthHtml + ( secondary || !( changeMonth && changeYear ) ? "&#xa0;" : "" );
			}
	
			// Year selection
			if ( !inst.yearshtml ) {
				inst.yearshtml = "";
				if ( secondary || !changeYear ) {
					html += "<span class='ui-datepicker-year'>" + drawYear + "</span>";
				} else {
	
					// determine range of years to display
					years = this._get( inst, "yearRange" ).split( ":" );
					thisYear = new Date().getFullYear();
					determineYear = function( value ) {
						var year = ( value.match( /c[+\-].*/ ) ? drawYear + parseInt( value.substring( 1 ), 10 ) :
							( value.match( /[+\-].*/ ) ? thisYear + parseInt( value, 10 ) :
							parseInt( value, 10 ) ) );
						return ( isNaN( year ) ? thisYear : year );
					};
					year = determineYear( years[ 0 ] );
					endYear = Math.max( year, determineYear( years[ 1 ] || "" ) );
					year = ( minDate ? Math.max( year, minDate.getFullYear() ) : year );
					endYear = ( maxDate ? Math.min( endYear, maxDate.getFullYear() ) : endYear );
					inst.yearshtml += "<select class='ui-datepicker-year' data-handler='selectYear' data-event='change'>";
					for ( ; year <= endYear; year++ ) {
						inst.yearshtml += "<option value='" + year + "'" +
							( year === drawYear ? " selected='selected'" : "" ) +
							">" + year + "</option>";
					}
					inst.yearshtml += "</select>";
	
					html += inst.yearshtml;
					inst.yearshtml = null;
				}
			}
	
			html += this._get( inst, "yearSuffix" );
			if ( showMonthAfterYear ) {
				html += ( secondary || !( changeMonth && changeYear ) ? "&#xa0;" : "" ) + monthHtml;
			}
			html += "</div>"; // Close datepicker_header
			return html;
		},
	
		/* Adjust one of the date sub-fields. */
		_adjustInstDate: function( inst, offset, period ) {
			var year = inst.selectedYear + ( period === "Y" ? offset : 0 ),
				month = inst.selectedMonth + ( period === "M" ? offset : 0 ),
				day = Math.min( inst.selectedDay, this._getDaysInMonth( year, month ) ) + ( period === "D" ? offset : 0 ),
				date = this._restrictMinMax( inst, this._daylightSavingAdjust( new Date( year, month, day ) ) );
	
			inst.selectedDay = date.getDate();
			inst.drawMonth = inst.selectedMonth = date.getMonth();
			inst.drawYear = inst.selectedYear = date.getFullYear();
			if ( period === "M" || period === "Y" ) {
				this._notifyChange( inst );
			}
		},
	
		/* Ensure a date is within any min/max bounds. */
		_restrictMinMax: function( inst, date ) {
			var minDate = this._getMinMaxDate( inst, "min" ),
				maxDate = this._getMinMaxDate( inst, "max" ),
				newDate = ( minDate && date < minDate ? minDate : date );
			return ( maxDate && newDate > maxDate ? maxDate : newDate );
		},
	
		/* Notify change of month/year. */
		_notifyChange: function( inst ) {
			var onChange = this._get( inst, "onChangeMonthYear" );
			if ( onChange ) {
				onChange.apply( ( inst.input ? inst.input[ 0 ] : null ),
					[ inst.selectedYear, inst.selectedMonth + 1, inst ] );
			}
		},
	
		/* Determine the number of months to show. */
		_getNumberOfMonths: function( inst ) {
			var numMonths = this._get( inst, "numberOfMonths" );
			return ( numMonths == null ? [ 1, 1 ] : ( typeof numMonths === "number" ? [ 1, numMonths ] : numMonths ) );
		},
	
		/* Determine the current maximum date - ensure no time components are set. */
		_getMinMaxDate: function( inst, minMax ) {
			return this._determineDate( inst, this._get( inst, minMax + "Date" ), null );
		},
	
		/* Find the number of days in a given month. */
		_getDaysInMonth: function( year, month ) {
			return 32 - this._daylightSavingAdjust( new Date( year, month, 32 ) ).getDate();
		},
	
		/* Find the day of the week of the first of a month. */
		_getFirstDayOfMonth: function( year, month ) {
			return new Date( year, month, 1 ).getDay();
		},
	
		/* Determines if we should allow a "next/prev" month display change. */
		_canAdjustMonth: function( inst, offset, curYear, curMonth ) {
			var numMonths = this._getNumberOfMonths( inst ),
				date = this._daylightSavingAdjust( new Date( curYear,
				curMonth + ( offset < 0 ? offset : numMonths[ 0 ] * numMonths[ 1 ] ), 1 ) );
	
			if ( offset < 0 ) {
				date.setDate( this._getDaysInMonth( date.getFullYear(), date.getMonth() ) );
			}
			return this._isInRange( inst, date );
		},
	
		/* Is the given date in the accepted range? */
		_isInRange: function( inst, date ) {
			var yearSplit, currentYear,
				minDate = this._getMinMaxDate( inst, "min" ),
				maxDate = this._getMinMaxDate( inst, "max" ),
				minYear = null,
				maxYear = null,
				years = this._get( inst, "yearRange" );
				if ( years ) {
					yearSplit = years.split( ":" );
					currentYear = new Date().getFullYear();
					minYear = parseInt( yearSplit[ 0 ], 10 );
					maxYear = parseInt( yearSplit[ 1 ], 10 );
					if ( yearSplit[ 0 ].match( /[+\-].*/ ) ) {
						minYear += currentYear;
					}
					if ( yearSplit[ 1 ].match( /[+\-].*/ ) ) {
						maxYear += currentYear;
					}
				}
	
			return ( ( !minDate || date.getTime() >= minDate.getTime() ) &&
				( !maxDate || date.getTime() <= maxDate.getTime() ) &&
				( !minYear || date.getFullYear() >= minYear ) &&
				( !maxYear || date.getFullYear() <= maxYear ) );
		},
	
		/* Provide the configuration settings for formatting/parsing. */
		_getFormatConfig: function( inst ) {
			var shortYearCutoff = this._get( inst, "shortYearCutoff" );
			shortYearCutoff = ( typeof shortYearCutoff !== "string" ? shortYearCutoff :
				new Date().getFullYear() % 100 + parseInt( shortYearCutoff, 10 ) );
			return { shortYearCutoff: shortYearCutoff,
				dayNamesShort: this._get( inst, "dayNamesShort" ), dayNames: this._get( inst, "dayNames" ),
				monthNamesShort: this._get( inst, "monthNamesShort" ), monthNames: this._get( inst, "monthNames" ) };
		},
	
		/* Format the given date for display. */
		_formatDate: function( inst, day, month, year ) {
			if ( !day ) {
				inst.currentDay = inst.selectedDay;
				inst.currentMonth = inst.selectedMonth;
				inst.currentYear = inst.selectedYear;
			}
			var date = ( day ? ( typeof day === "object" ? day :
				this._daylightSavingAdjust( new Date( year, month, day ) ) ) :
				this._daylightSavingAdjust( new Date( inst.currentYear, inst.currentMonth, inst.currentDay ) ) );
			return this.formatDate( this._get( inst, "dateFormat" ), date, this._getFormatConfig( inst ) );
		}
	} );
	
	/*
	 * Bind hover events for datepicker elements.
	 * Done via delegate so the binding only occurs once in the lifetime of the parent div.
	 * Global datepicker_instActive, set by _updateDatepicker allows the handlers to find their way back to the active picker.
	 */
	function datepicker_bindHover( dpDiv ) {
		var selector = "button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a";
		return dpDiv.on( "mouseout", selector, function() {
				$( this ).removeClass( "ui-state-hover" );
				if ( this.className.indexOf( "ui-datepicker-prev" ) !== -1 ) {
					$( this ).removeClass( "ui-datepicker-prev-hover" );
				}
				if ( this.className.indexOf( "ui-datepicker-next" ) !== -1 ) {
					$( this ).removeClass( "ui-datepicker-next-hover" );
				}
			} )
			.on( "mouseover", selector, datepicker_handleMouseover );
	}
	
	function datepicker_handleMouseover() {
		if ( !$.datepicker._isDisabledDatepicker( datepicker_instActive.inline ? datepicker_instActive.dpDiv.parent()[ 0 ] : datepicker_instActive.input[ 0 ] ) ) {
			$( this ).parents( ".ui-datepicker-calendar" ).find( "a" ).removeClass( "ui-state-hover" );
			$( this ).addClass( "ui-state-hover" );
			if ( this.className.indexOf( "ui-datepicker-prev" ) !== -1 ) {
				$( this ).addClass( "ui-datepicker-prev-hover" );
			}
			if ( this.className.indexOf( "ui-datepicker-next" ) !== -1 ) {
				$( this ).addClass( "ui-datepicker-next-hover" );
			}
		}
	}
	
	/* jQuery extend now ignores nulls! */
	function datepicker_extendRemove( target, props ) {
		$.extend( target, props );
		for ( var name in props ) {
			if ( props[ name ] == null ) {
				target[ name ] = props[ name ];
			}
		}
		return target;
	}
	
	/* Invoke the datepicker functionality.
	   @param  options  string - a command, optionally followed by additional parameters or
						Object - settings for attaching new datepicker functionality
	   @return  jQuery object */
	$.fn.datepicker = function( options ) {
	
		/* Verify an empty collection wasn't passed - Fixes #6976 */
		if ( !this.length ) {
			return this;
		}
	
		/* Initialise the date picker. */
		if ( !$.datepicker.initialized ) {
			$( document ).on( "mousedown", $.datepicker._checkExternalClick );
			$.datepicker.initialized = true;
		}
	
		/* Append datepicker main container to body if not exist. */
		if ( $( "#" + $.datepicker._mainDivId ).length === 0 ) {
			$( "body" ).append( $.datepicker.dpDiv );
		}
	
		var otherArgs = Array.prototype.slice.call( arguments, 1 );
		if ( typeof options === "string" && ( options === "isDisabled" || options === "getDate" || options === "widget" ) ) {
			return $.datepicker[ "_" + options + "Datepicker" ].
				apply( $.datepicker, [ this[ 0 ] ].concat( otherArgs ) );
		}
		if ( options === "option" && arguments.length === 2 && typeof arguments[ 1 ] === "string" ) {
			return $.datepicker[ "_" + options + "Datepicker" ].
				apply( $.datepicker, [ this[ 0 ] ].concat( otherArgs ) );
		}
		return this.each( function() {
			typeof options === "string" ?
				$.datepicker[ "_" + options + "Datepicker" ].
					apply( $.datepicker, [ this ].concat( otherArgs ) ) :
				$.datepicker._attachDatepicker( this, options );
		} );
	};
	
	$.datepicker = new Datepicker(); // singleton instance
	$.datepicker.initialized = false;
	$.datepicker.uuid = new Date().getTime();
	$.datepicker.version = "1.12.1";
	
	return $.datepicker;
	
	} ) );


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Mouse 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Mouse
	//>>group: Widgets
	//>>description: Abstracts mouse-based interactions to assist in creating certain widgets.
	//>>docs: http://api.jqueryui.com/mouse/
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
				__webpack_require__(1),
				__webpack_require__(192),
				__webpack_require__(41),
				__webpack_require__(79)
			], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	}( function( $ ) {
	
	var mouseHandled = false;
	$( document ).on( "mouseup", function() {
		mouseHandled = false;
	} );
	
	return $.widget( "ui.mouse", {
		version: "1.12.1",
		options: {
			cancel: "input, textarea, button, select, option",
			distance: 1,
			delay: 0
		},
		_mouseInit: function() {
			var that = this;
	
			this.element
				.on( "mousedown." + this.widgetName, function( event ) {
					return that._mouseDown( event );
				} )
				.on( "click." + this.widgetName, function( event ) {
					if ( true === $.data( event.target, that.widgetName + ".preventClickEvent" ) ) {
						$.removeData( event.target, that.widgetName + ".preventClickEvent" );
						event.stopImmediatePropagation();
						return false;
					}
				} );
	
			this.started = false;
		},
	
		// TODO: make sure destroying one instance of mouse doesn't mess with
		// other instances of mouse
		_mouseDestroy: function() {
			this.element.off( "." + this.widgetName );
			if ( this._mouseMoveDelegate ) {
				this.document
					.off( "mousemove." + this.widgetName, this._mouseMoveDelegate )
					.off( "mouseup." + this.widgetName, this._mouseUpDelegate );
			}
		},
	
		_mouseDown: function( event ) {
	
			// don't let more than one widget handle mouseStart
			if ( mouseHandled ) {
				return;
			}
	
			this._mouseMoved = false;
	
			// We may have missed mouseup (out of window)
			( this._mouseStarted && this._mouseUp( event ) );
	
			this._mouseDownEvent = event;
	
			var that = this,
				btnIsLeft = ( event.which === 1 ),
	
				// event.target.nodeName works around a bug in IE 8 with
				// disabled inputs (#7620)
				elIsCancel = ( typeof this.options.cancel === "string" && event.target.nodeName ?
					$( event.target ).closest( this.options.cancel ).length : false );
			if ( !btnIsLeft || elIsCancel || !this._mouseCapture( event ) ) {
				return true;
			}
	
			this.mouseDelayMet = !this.options.delay;
			if ( !this.mouseDelayMet ) {
				this._mouseDelayTimer = setTimeout( function() {
					that.mouseDelayMet = true;
				}, this.options.delay );
			}
	
			if ( this._mouseDistanceMet( event ) && this._mouseDelayMet( event ) ) {
				this._mouseStarted = ( this._mouseStart( event ) !== false );
				if ( !this._mouseStarted ) {
					event.preventDefault();
					return true;
				}
			}
	
			// Click event may never have fired (Gecko & Opera)
			if ( true === $.data( event.target, this.widgetName + ".preventClickEvent" ) ) {
				$.removeData( event.target, this.widgetName + ".preventClickEvent" );
			}
	
			// These delegates are required to keep context
			this._mouseMoveDelegate = function( event ) {
				return that._mouseMove( event );
			};
			this._mouseUpDelegate = function( event ) {
				return that._mouseUp( event );
			};
	
			this.document
				.on( "mousemove." + this.widgetName, this._mouseMoveDelegate )
				.on( "mouseup." + this.widgetName, this._mouseUpDelegate );
	
			event.preventDefault();
	
			mouseHandled = true;
			return true;
		},
	
		_mouseMove: function( event ) {
	
			// Only check for mouseups outside the document if you've moved inside the document
			// at least once. This prevents the firing of mouseup in the case of IE<9, which will
			// fire a mousemove event if content is placed under the cursor. See #7778
			// Support: IE <9
			if ( this._mouseMoved ) {
	
				// IE mouseup check - mouseup happened when mouse was out of window
				if ( $.ui.ie && ( !document.documentMode || document.documentMode < 9 ) &&
						!event.button ) {
					return this._mouseUp( event );
	
				// Iframe mouseup check - mouseup occurred in another document
				} else if ( !event.which ) {
	
					// Support: Safari <=8 - 9
					// Safari sets which to 0 if you press any of the following keys
					// during a drag (#14461)
					if ( event.originalEvent.altKey || event.originalEvent.ctrlKey ||
							event.originalEvent.metaKey || event.originalEvent.shiftKey ) {
						this.ignoreMissingWhich = true;
					} else if ( !this.ignoreMissingWhich ) {
						return this._mouseUp( event );
					}
				}
			}
	
			if ( event.which || event.button ) {
				this._mouseMoved = true;
			}
	
			if ( this._mouseStarted ) {
				this._mouseDrag( event );
				return event.preventDefault();
			}
	
			if ( this._mouseDistanceMet( event ) && this._mouseDelayMet( event ) ) {
				this._mouseStarted =
					( this._mouseStart( this._mouseDownEvent, event ) !== false );
				( this._mouseStarted ? this._mouseDrag( event ) : this._mouseUp( event ) );
			}
	
			return !this._mouseStarted;
		},
	
		_mouseUp: function( event ) {
			this.document
				.off( "mousemove." + this.widgetName, this._mouseMoveDelegate )
				.off( "mouseup." + this.widgetName, this._mouseUpDelegate );
	
			if ( this._mouseStarted ) {
				this._mouseStarted = false;
	
				if ( event.target === this._mouseDownEvent.target ) {
					$.data( event.target, this.widgetName + ".preventClickEvent", true );
				}
	
				this._mouseStop( event );
			}
	
			if ( this._mouseDelayTimer ) {
				clearTimeout( this._mouseDelayTimer );
				delete this._mouseDelayTimer;
			}
	
			this.ignoreMissingWhich = false;
			mouseHandled = false;
			event.preventDefault();
		},
	
		_mouseDistanceMet: function( event ) {
			return ( Math.max(
					Math.abs( this._mouseDownEvent.pageX - event.pageX ),
					Math.abs( this._mouseDownEvent.pageY - event.pageY )
				) >= this.options.distance
			);
		},
	
		_mouseDelayMet: function( /* event */ ) {
			return this.mouseDelayMet;
		},
	
		// These are placeholder methods, to be overriden by extending plugin
		_mouseStart: function( /* event */ ) {},
		_mouseDrag: function( /* event */ ) {},
		_mouseStop: function( /* event */ ) {},
		_mouseCapture: function( /* event */ ) { return true; }
	} );
	
	} ) );


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Slider 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Slider
	//>>group: Widgets
	//>>description: Displays a flexible slider with ranges and accessibility via keyboard.
	//>>docs: http://api.jqueryui.com/slider/
	//>>demos: http://jqueryui.com/slider/
	//>>css.structure: ../../themes/base/core.css
	//>>css.structure: ../../themes/base/slider.css
	//>>css.theme: ../../themes/base/theme.css
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
				__webpack_require__(1),
				__webpack_require__(194),
				__webpack_require__(91),
				__webpack_require__(41),
				__webpack_require__(79)
			], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	}( function( $ ) {
	
	return $.widget( "ui.slider", $.ui.mouse, {
		version: "1.12.1",
		widgetEventPrefix: "slide",
	
		options: {
			animate: false,
			classes: {
				"ui-slider": "ui-corner-all",
				"ui-slider-handle": "ui-corner-all",
	
				// Note: ui-widget-header isn't the most fittingly semantic framework class for this
				// element, but worked best visually with a variety of themes
				"ui-slider-range": "ui-corner-all ui-widget-header"
			},
			distance: 0,
			max: 100,
			min: 0,
			orientation: "horizontal",
			range: false,
			step: 1,
			value: 0,
			values: null,
	
			// Callbacks
			change: null,
			slide: null,
			start: null,
			stop: null
		},
	
		// Number of pages in a slider
		// (how many times can you page up/down to go through the whole range)
		numPages: 5,
	
		_create: function() {
			this._keySliding = false;
			this._mouseSliding = false;
			this._animateOff = true;
			this._handleIndex = null;
			this._detectOrientation();
			this._mouseInit();
			this._calculateNewMax();
	
			this._addClass( "ui-slider ui-slider-" + this.orientation,
				"ui-widget ui-widget-content" );
	
			this._refresh();
	
			this._animateOff = false;
		},
	
		_refresh: function() {
			this._createRange();
			this._createHandles();
			this._setupEvents();
			this._refreshValue();
		},
	
		_createHandles: function() {
			var i, handleCount,
				options = this.options,
				existingHandles = this.element.find( ".ui-slider-handle" ),
				handle = "<span tabindex='0'></span>",
				handles = [];
	
			handleCount = ( options.values && options.values.length ) || 1;
	
			if ( existingHandles.length > handleCount ) {
				existingHandles.slice( handleCount ).remove();
				existingHandles = existingHandles.slice( 0, handleCount );
			}
	
			for ( i = existingHandles.length; i < handleCount; i++ ) {
				handles.push( handle );
			}
	
			this.handles = existingHandles.add( $( handles.join( "" ) ).appendTo( this.element ) );
	
			this._addClass( this.handles, "ui-slider-handle", "ui-state-default" );
	
			this.handle = this.handles.eq( 0 );
	
			this.handles.each( function( i ) {
				$( this )
					.data( "ui-slider-handle-index", i )
					.attr( "tabIndex", 0 );
			} );
		},
	
		_createRange: function() {
			var options = this.options;
	
			if ( options.range ) {
				if ( options.range === true ) {
					if ( !options.values ) {
						options.values = [ this._valueMin(), this._valueMin() ];
					} else if ( options.values.length && options.values.length !== 2 ) {
						options.values = [ options.values[ 0 ], options.values[ 0 ] ];
					} else if ( $.isArray( options.values ) ) {
						options.values = options.values.slice( 0 );
					}
				}
	
				if ( !this.range || !this.range.length ) {
					this.range = $( "<div>" )
						.appendTo( this.element );
	
					this._addClass( this.range, "ui-slider-range" );
				} else {
					this._removeClass( this.range, "ui-slider-range-min ui-slider-range-max" );
	
					// Handle range switching from true to min/max
					this.range.css( {
						"left": "",
						"bottom": ""
					} );
				}
				if ( options.range === "min" || options.range === "max" ) {
					this._addClass( this.range, "ui-slider-range-" + options.range );
				}
			} else {
				if ( this.range ) {
					this.range.remove();
				}
				this.range = null;
			}
		},
	
		_setupEvents: function() {
			this._off( this.handles );
			this._on( this.handles, this._handleEvents );
			this._hoverable( this.handles );
			this._focusable( this.handles );
		},
	
		_destroy: function() {
			this.handles.remove();
			if ( this.range ) {
				this.range.remove();
			}
	
			this._mouseDestroy();
		},
	
		_mouseCapture: function( event ) {
			var position, normValue, distance, closestHandle, index, allowed, offset, mouseOverHandle,
				that = this,
				o = this.options;
	
			if ( o.disabled ) {
				return false;
			}
	
			this.elementSize = {
				width: this.element.outerWidth(),
				height: this.element.outerHeight()
			};
			this.elementOffset = this.element.offset();
	
			position = { x: event.pageX, y: event.pageY };
			normValue = this._normValueFromMouse( position );
			distance = this._valueMax() - this._valueMin() + 1;
			this.handles.each( function( i ) {
				var thisDistance = Math.abs( normValue - that.values( i ) );
				if ( ( distance > thisDistance ) ||
					( distance === thisDistance &&
						( i === that._lastChangedValue || that.values( i ) === o.min ) ) ) {
					distance = thisDistance;
					closestHandle = $( this );
					index = i;
				}
			} );
	
			allowed = this._start( event, index );
			if ( allowed === false ) {
				return false;
			}
			this._mouseSliding = true;
	
			this._handleIndex = index;
	
			this._addClass( closestHandle, null, "ui-state-active" );
			closestHandle.trigger( "focus" );
	
			offset = closestHandle.offset();
			mouseOverHandle = !$( event.target ).parents().addBack().is( ".ui-slider-handle" );
			this._clickOffset = mouseOverHandle ? { left: 0, top: 0 } : {
				left: event.pageX - offset.left - ( closestHandle.width() / 2 ),
				top: event.pageY - offset.top -
					( closestHandle.height() / 2 ) -
					( parseInt( closestHandle.css( "borderTopWidth" ), 10 ) || 0 ) -
					( parseInt( closestHandle.css( "borderBottomWidth" ), 10 ) || 0 ) +
					( parseInt( closestHandle.css( "marginTop" ), 10 ) || 0 )
			};
	
			if ( !this.handles.hasClass( "ui-state-hover" ) ) {
				this._slide( event, index, normValue );
			}
			this._animateOff = true;
			return true;
		},
	
		_mouseStart: function() {
			return true;
		},
	
		_mouseDrag: function( event ) {
			var position = { x: event.pageX, y: event.pageY },
				normValue = this._normValueFromMouse( position );
	
			this._slide( event, this._handleIndex, normValue );
	
			return false;
		},
	
		_mouseStop: function( event ) {
			this._removeClass( this.handles, null, "ui-state-active" );
			this._mouseSliding = false;
	
			this._stop( event, this._handleIndex );
			this._change( event, this._handleIndex );
	
			this._handleIndex = null;
			this._clickOffset = null;
			this._animateOff = false;
	
			return false;
		},
	
		_detectOrientation: function() {
			this.orientation = ( this.options.orientation === "vertical" ) ? "vertical" : "horizontal";
		},
	
		_normValueFromMouse: function( position ) {
			var pixelTotal,
				pixelMouse,
				percentMouse,
				valueTotal,
				valueMouse;
	
			if ( this.orientation === "horizontal" ) {
				pixelTotal = this.elementSize.width;
				pixelMouse = position.x - this.elementOffset.left -
					( this._clickOffset ? this._clickOffset.left : 0 );
			} else {
				pixelTotal = this.elementSize.height;
				pixelMouse = position.y - this.elementOffset.top -
					( this._clickOffset ? this._clickOffset.top : 0 );
			}
	
			percentMouse = ( pixelMouse / pixelTotal );
			if ( percentMouse > 1 ) {
				percentMouse = 1;
			}
			if ( percentMouse < 0 ) {
				percentMouse = 0;
			}
			if ( this.orientation === "vertical" ) {
				percentMouse = 1 - percentMouse;
			}
	
			valueTotal = this._valueMax() - this._valueMin();
			valueMouse = this._valueMin() + percentMouse * valueTotal;
	
			return this._trimAlignValue( valueMouse );
		},
	
		_uiHash: function( index, value, values ) {
			var uiHash = {
				handle: this.handles[ index ],
				handleIndex: index,
				value: value !== undefined ? value : this.value()
			};
	
			if ( this._hasMultipleValues() ) {
				uiHash.value = value !== undefined ? value : this.values( index );
				uiHash.values = values || this.values();
			}
	
			return uiHash;
		},
	
		_hasMultipleValues: function() {
			return this.options.values && this.options.values.length;
		},
	
		_start: function( event, index ) {
			return this._trigger( "start", event, this._uiHash( index ) );
		},
	
		_slide: function( event, index, newVal ) {
			var allowed, otherVal,
				currentValue = this.value(),
				newValues = this.values();
	
			if ( this._hasMultipleValues() ) {
				otherVal = this.values( index ? 0 : 1 );
				currentValue = this.values( index );
	
				if ( this.options.values.length === 2 && this.options.range === true ) {
					newVal =  index === 0 ? Math.min( otherVal, newVal ) : Math.max( otherVal, newVal );
				}
	
				newValues[ index ] = newVal;
			}
	
			if ( newVal === currentValue ) {
				return;
			}
	
			allowed = this._trigger( "slide", event, this._uiHash( index, newVal, newValues ) );
	
			// A slide can be canceled by returning false from the slide callback
			if ( allowed === false ) {
				return;
			}
	
			if ( this._hasMultipleValues() ) {
				this.values( index, newVal );
			} else {
				this.value( newVal );
			}
		},
	
		_stop: function( event, index ) {
			this._trigger( "stop", event, this._uiHash( index ) );
		},
	
		_change: function( event, index ) {
			if ( !this._keySliding && !this._mouseSliding ) {
	
				//store the last changed value index for reference when handles overlap
				this._lastChangedValue = index;
				this._trigger( "change", event, this._uiHash( index ) );
			}
		},
	
		value: function( newValue ) {
			if ( arguments.length ) {
				this.options.value = this._trimAlignValue( newValue );
				this._refreshValue();
				this._change( null, 0 );
				return;
			}
	
			return this._value();
		},
	
		values: function( index, newValue ) {
			var vals,
				newValues,
				i;
	
			if ( arguments.length > 1 ) {
				this.options.values[ index ] = this._trimAlignValue( newValue );
				this._refreshValue();
				this._change( null, index );
				return;
			}
	
			if ( arguments.length ) {
				if ( $.isArray( arguments[ 0 ] ) ) {
					vals = this.options.values;
					newValues = arguments[ 0 ];
					for ( i = 0; i < vals.length; i += 1 ) {
						vals[ i ] = this._trimAlignValue( newValues[ i ] );
						this._change( null, i );
					}
					this._refreshValue();
				} else {
					if ( this._hasMultipleValues() ) {
						return this._values( index );
					} else {
						return this.value();
					}
				}
			} else {
				return this._values();
			}
		},
	
		_setOption: function( key, value ) {
			var i,
				valsLength = 0;
	
			if ( key === "range" && this.options.range === true ) {
				if ( value === "min" ) {
					this.options.value = this._values( 0 );
					this.options.values = null;
				} else if ( value === "max" ) {
					this.options.value = this._values( this.options.values.length - 1 );
					this.options.values = null;
				}
			}
	
			if ( $.isArray( this.options.values ) ) {
				valsLength = this.options.values.length;
			}
	
			this._super( key, value );
	
			switch ( key ) {
				case "orientation":
					this._detectOrientation();
					this._removeClass( "ui-slider-horizontal ui-slider-vertical" )
						._addClass( "ui-slider-" + this.orientation );
					this._refreshValue();
					if ( this.options.range ) {
						this._refreshRange( value );
					}
	
					// Reset positioning from previous orientation
					this.handles.css( value === "horizontal" ? "bottom" : "left", "" );
					break;
				case "value":
					this._animateOff = true;
					this._refreshValue();
					this._change( null, 0 );
					this._animateOff = false;
					break;
				case "values":
					this._animateOff = true;
					this._refreshValue();
	
					// Start from the last handle to prevent unreachable handles (#9046)
					for ( i = valsLength - 1; i >= 0; i-- ) {
						this._change( null, i );
					}
					this._animateOff = false;
					break;
				case "step":
				case "min":
				case "max":
					this._animateOff = true;
					this._calculateNewMax();
					this._refreshValue();
					this._animateOff = false;
					break;
				case "range":
					this._animateOff = true;
					this._refresh();
					this._animateOff = false;
					break;
			}
		},
	
		_setOptionDisabled: function( value ) {
			this._super( value );
	
			this._toggleClass( null, "ui-state-disabled", !!value );
		},
	
		//internal value getter
		// _value() returns value trimmed by min and max, aligned by step
		_value: function() {
			var val = this.options.value;
			val = this._trimAlignValue( val );
	
			return val;
		},
	
		//internal values getter
		// _values() returns array of values trimmed by min and max, aligned by step
		// _values( index ) returns single value trimmed by min and max, aligned by step
		_values: function( index ) {
			var val,
				vals,
				i;
	
			if ( arguments.length ) {
				val = this.options.values[ index ];
				val = this._trimAlignValue( val );
	
				return val;
			} else if ( this._hasMultipleValues() ) {
	
				// .slice() creates a copy of the array
				// this copy gets trimmed by min and max and then returned
				vals = this.options.values.slice();
				for ( i = 0; i < vals.length; i += 1 ) {
					vals[ i ] = this._trimAlignValue( vals[ i ] );
				}
	
				return vals;
			} else {
				return [];
			}
		},
	
		// Returns the step-aligned value that val is closest to, between (inclusive) min and max
		_trimAlignValue: function( val ) {
			if ( val <= this._valueMin() ) {
				return this._valueMin();
			}
			if ( val >= this._valueMax() ) {
				return this._valueMax();
			}
			var step = ( this.options.step > 0 ) ? this.options.step : 1,
				valModStep = ( val - this._valueMin() ) % step,
				alignValue = val - valModStep;
	
			if ( Math.abs( valModStep ) * 2 >= step ) {
				alignValue += ( valModStep > 0 ) ? step : ( -step );
			}
	
			// Since JavaScript has problems with large floats, round
			// the final value to 5 digits after the decimal point (see #4124)
			return parseFloat( alignValue.toFixed( 5 ) );
		},
	
		_calculateNewMax: function() {
			var max = this.options.max,
				min = this._valueMin(),
				step = this.options.step,
				aboveMin = Math.round( ( max - min ) / step ) * step;
			max = aboveMin + min;
			if ( max > this.options.max ) {
	
				//If max is not divisible by step, rounding off may increase its value
				max -= step;
			}
			this.max = parseFloat( max.toFixed( this._precision() ) );
		},
	
		_precision: function() {
			var precision = this._precisionOf( this.options.step );
			if ( this.options.min !== null ) {
				precision = Math.max( precision, this._precisionOf( this.options.min ) );
			}
			return precision;
		},
	
		_precisionOf: function( num ) {
			var str = num.toString(),
				decimal = str.indexOf( "." );
			return decimal === -1 ? 0 : str.length - decimal - 1;
		},
	
		_valueMin: function() {
			return this.options.min;
		},
	
		_valueMax: function() {
			return this.max;
		},
	
		_refreshRange: function( orientation ) {
			if ( orientation === "vertical" ) {
				this.range.css( { "width": "", "left": "" } );
			}
			if ( orientation === "horizontal" ) {
				this.range.css( { "height": "", "bottom": "" } );
			}
		},
	
		_refreshValue: function() {
			var lastValPercent, valPercent, value, valueMin, valueMax,
				oRange = this.options.range,
				o = this.options,
				that = this,
				animate = ( !this._animateOff ) ? o.animate : false,
				_set = {};
	
			if ( this._hasMultipleValues() ) {
				this.handles.each( function( i ) {
					valPercent = ( that.values( i ) - that._valueMin() ) / ( that._valueMax() -
						that._valueMin() ) * 100;
					_set[ that.orientation === "horizontal" ? "left" : "bottom" ] = valPercent + "%";
					$( this ).stop( 1, 1 )[ animate ? "animate" : "css" ]( _set, o.animate );
					if ( that.options.range === true ) {
						if ( that.orientation === "horizontal" ) {
							if ( i === 0 ) {
								that.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
									left: valPercent + "%"
								}, o.animate );
							}
							if ( i === 1 ) {
								that.range[ animate ? "animate" : "css" ]( {
									width: ( valPercent - lastValPercent ) + "%"
								}, {
									queue: false,
									duration: o.animate
								} );
							}
						} else {
							if ( i === 0 ) {
								that.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
									bottom: ( valPercent ) + "%"
								}, o.animate );
							}
							if ( i === 1 ) {
								that.range[ animate ? "animate" : "css" ]( {
									height: ( valPercent - lastValPercent ) + "%"
								}, {
									queue: false,
									duration: o.animate
								} );
							}
						}
					}
					lastValPercent = valPercent;
				} );
			} else {
				value = this.value();
				valueMin = this._valueMin();
				valueMax = this._valueMax();
				valPercent = ( valueMax !== valueMin ) ?
						( value - valueMin ) / ( valueMax - valueMin ) * 100 :
						0;
				_set[ this.orientation === "horizontal" ? "left" : "bottom" ] = valPercent + "%";
				this.handle.stop( 1, 1 )[ animate ? "animate" : "css" ]( _set, o.animate );
	
				if ( oRange === "min" && this.orientation === "horizontal" ) {
					this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
						width: valPercent + "%"
					}, o.animate );
				}
				if ( oRange === "max" && this.orientation === "horizontal" ) {
					this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
						width: ( 100 - valPercent ) + "%"
					}, o.animate );
				}
				if ( oRange === "min" && this.orientation === "vertical" ) {
					this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
						height: valPercent + "%"
					}, o.animate );
				}
				if ( oRange === "max" && this.orientation === "vertical" ) {
					this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
						height: ( 100 - valPercent ) + "%"
					}, o.animate );
				}
			}
		},
	
		_handleEvents: {
			keydown: function( event ) {
				var allowed, curVal, newVal, step,
					index = $( event.target ).data( "ui-slider-handle-index" );
	
				switch ( event.keyCode ) {
					case $.ui.keyCode.HOME:
					case $.ui.keyCode.END:
					case $.ui.keyCode.PAGE_UP:
					case $.ui.keyCode.PAGE_DOWN:
					case $.ui.keyCode.UP:
					case $.ui.keyCode.RIGHT:
					case $.ui.keyCode.DOWN:
					case $.ui.keyCode.LEFT:
						event.preventDefault();
						if ( !this._keySliding ) {
							this._keySliding = true;
							this._addClass( $( event.target ), null, "ui-state-active" );
							allowed = this._start( event, index );
							if ( allowed === false ) {
								return;
							}
						}
						break;
				}
	
				step = this.options.step;
				if ( this._hasMultipleValues() ) {
					curVal = newVal = this.values( index );
				} else {
					curVal = newVal = this.value();
				}
	
				switch ( event.keyCode ) {
					case $.ui.keyCode.HOME:
						newVal = this._valueMin();
						break;
					case $.ui.keyCode.END:
						newVal = this._valueMax();
						break;
					case $.ui.keyCode.PAGE_UP:
						newVal = this._trimAlignValue(
							curVal + ( ( this._valueMax() - this._valueMin() ) / this.numPages )
						);
						break;
					case $.ui.keyCode.PAGE_DOWN:
						newVal = this._trimAlignValue(
							curVal - ( ( this._valueMax() - this._valueMin() ) / this.numPages ) );
						break;
					case $.ui.keyCode.UP:
					case $.ui.keyCode.RIGHT:
						if ( curVal === this._valueMax() ) {
							return;
						}
						newVal = this._trimAlignValue( curVal + step );
						break;
					case $.ui.keyCode.DOWN:
					case $.ui.keyCode.LEFT:
						if ( curVal === this._valueMin() ) {
							return;
						}
						newVal = this._trimAlignValue( curVal - step );
						break;
				}
	
				this._slide( event, index, newVal );
			},
			keyup: function( event ) {
				var index = $( event.target ).data( "ui-slider-handle-index" );
	
				if ( this._keySliding ) {
					this._keySliding = false;
					this._stop( event, index );
					this._change( event, index );
					this._removeClass( $( event.target ), null, "ui-state-active" );
				}
			}
		}
	} );
	
	} ) );


/***/ }),
/* 196 */
/***/ (function(module, exports) {



/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(200);


/***/ }),
/* 198 */
/***/ (function(module, exports) {

	'use strict';
	
	var EventElement = function (element) {
	  this.element = element;
	  this.events = {};
	};
	
	EventElement.prototype.bind = function (eventName, handler) {
	  if (typeof this.events[eventName] === 'undefined') {
	    this.events[eventName] = [];
	  }
	  this.events[eventName].push(handler);
	  this.element.addEventListener(eventName, handler, false);
	};
	
	EventElement.prototype.unbind = function (eventName, handler) {
	  var isHandlerProvided = (typeof handler !== 'undefined');
	  this.events[eventName] = this.events[eventName].filter(function (hdlr) {
	    if (isHandlerProvided && hdlr !== handler) {
	      return true;
	    }
	    this.element.removeEventListener(eventName, hdlr, false);
	    return false;
	  }, this);
	};
	
	EventElement.prototype.unbindAll = function () {
	  for (var name in this.events) {
	    this.unbind(name);
	  }
	};
	
	var EventManager = function () {
	  this.eventElements = [];
	};
	
	EventManager.prototype.eventElement = function (element) {
	  var ee = this.eventElements.filter(function (eventElement) {
	    return eventElement.element === element;
	  })[0];
	  if (typeof ee === 'undefined') {
	    ee = new EventElement(element);
	    this.eventElements.push(ee);
	  }
	  return ee;
	};
	
	EventManager.prototype.bind = function (element, eventName, handler) {
	  this.eventElement(element).bind(eventName, handler);
	};
	
	EventManager.prototype.unbind = function (element, eventName, handler) {
	  this.eventElement(element).unbind(eventName, handler);
	};
	
	EventManager.prototype.unbindAll = function () {
	  for (var i = 0; i < this.eventElements.length; i++) {
	    this.eventElements[i].unbindAll();
	  }
	};
	
	EventManager.prototype.once = function (element, eventName, handler) {
	  var ee = this.eventElement(element);
	  var onceHandler = function (e) {
	    ee.unbind(eventName, onceHandler);
	    handler(e);
	  };
	  ee.bind(eventName, onceHandler);
	};
	
	module.exports = EventManager;


/***/ }),
/* 199 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = (function () {
	  function s4() {
	    return Math.floor((1 + Math.random()) * 0x10000)
	               .toString(16)
	               .substring(1);
	  }
	  return function () {
	    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
	           s4() + '-' + s4() + s4() + s4();
	  };
	})();


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var destroy = __webpack_require__(202);
	var initialize = __webpack_require__(210);
	var update = __webpack_require__(211);
	
	module.exports = {
	  initialize: initialize,
	  update: update,
	  destroy: destroy
	};


/***/ }),
/* 201 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  handlers: ['click-rail', 'drag-scrollbar', 'keyboard', 'wheel', 'touch'],
	  maxScrollbarLength: null,
	  minScrollbarLength: null,
	  scrollXMarginOffset: 0,
	  scrollYMarginOffset: 0,
	  suppressScrollX: false,
	  suppressScrollY: false,
	  swipePropagation: true,
	  useBothWheelAxes: false,
	  wheelPropagation: false,
	  wheelSpeed: 1,
	  theme: 'default'
	};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(12);
	var dom = __webpack_require__(24);
	var instances = __webpack_require__(5);
	
	module.exports = function (element) {
	  var i = instances.get(element);
	
	  if (!i) {
	    return;
	  }
	
	  i.event.unbindAll();
	  dom.remove(i.scrollbarX);
	  dom.remove(i.scrollbarY);
	  dom.remove(i.scrollbarXRail);
	  dom.remove(i.scrollbarYRail);
	  _.removePsClasses(element);
	
	  instances.remove(element);
	};


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var instances = __webpack_require__(5);
	var updateGeometry = __webpack_require__(13);
	var updateScroll = __webpack_require__(16);
	
	function bindClickRailHandler(element, i) {
	  function pageOffset(el) {
	    return el.getBoundingClientRect();
	  }
	  var stopPropagation = function (e) { e.stopPropagation(); };
	
	  i.event.bind(i.scrollbarY, 'click', stopPropagation);
	  i.event.bind(i.scrollbarYRail, 'click', function (e) {
	    var positionTop = e.pageY - window.pageYOffset - pageOffset(i.scrollbarYRail).top;
	    var direction = positionTop > i.scrollbarYTop ? 1 : -1;
	
	    updateScroll(element, 'top', element.scrollTop + direction * i.containerHeight);
	    updateGeometry(element);
	
	    e.stopPropagation();
	  });
	
	  i.event.bind(i.scrollbarX, 'click', stopPropagation);
	  i.event.bind(i.scrollbarXRail, 'click', function (e) {
	    var positionLeft = e.pageX - window.pageXOffset - pageOffset(i.scrollbarXRail).left;
	    var direction = positionLeft > i.scrollbarXLeft ? 1 : -1;
	
	    updateScroll(element, 'left', element.scrollLeft + direction * i.containerWidth);
	    updateGeometry(element);
	
	    e.stopPropagation();
	  });
	}
	
	module.exports = function (element) {
	  var i = instances.get(element);
	  bindClickRailHandler(element, i);
	};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(12);
	var dom = __webpack_require__(24);
	var instances = __webpack_require__(5);
	var updateGeometry = __webpack_require__(13);
	var updateScroll = __webpack_require__(16);
	
	function bindMouseScrollXHandler(element, i) {
	  var currentLeft = null;
	  var currentPageX = null;
	
	  function updateScrollLeft(deltaX) {
	    var newLeft = currentLeft + (deltaX * i.railXRatio);
	    var maxLeft = Math.max(0, i.scrollbarXRail.getBoundingClientRect().left) + (i.railXRatio * (i.railXWidth - i.scrollbarXWidth));
	
	    if (newLeft < 0) {
	      i.scrollbarXLeft = 0;
	    } else if (newLeft > maxLeft) {
	      i.scrollbarXLeft = maxLeft;
	    } else {
	      i.scrollbarXLeft = newLeft;
	    }
	
	    var scrollLeft = _.toInt(i.scrollbarXLeft * (i.contentWidth - i.containerWidth) / (i.containerWidth - (i.railXRatio * i.scrollbarXWidth))) - i.negativeScrollAdjustment;
	    updateScroll(element, 'left', scrollLeft);
	  }
	
	  var mouseMoveHandler = function (e) {
	    updateScrollLeft(e.pageX - currentPageX);
	    updateGeometry(element);
	    e.stopPropagation();
	    e.preventDefault();
	  };
	
	  var mouseUpHandler = function () {
	    _.stopScrolling(element, 'x');
	    i.event.unbind(i.ownerDocument, 'mousemove', mouseMoveHandler);
	  };
	
	  i.event.bind(i.scrollbarX, 'mousedown', function (e) {
	    currentPageX = e.pageX;
	    currentLeft = _.toInt(dom.css(i.scrollbarX, 'left')) * i.railXRatio;
	    _.startScrolling(element, 'x');
	
	    i.event.bind(i.ownerDocument, 'mousemove', mouseMoveHandler);
	    i.event.once(i.ownerDocument, 'mouseup', mouseUpHandler);
	
	    e.stopPropagation();
	    e.preventDefault();
	  });
	}
	
	function bindMouseScrollYHandler(element, i) {
	  var currentTop = null;
	  var currentPageY = null;
	
	  function updateScrollTop(deltaY) {
	    var newTop = currentTop + (deltaY * i.railYRatio);
	    var maxTop = Math.max(0, i.scrollbarYRail.getBoundingClientRect().top) + (i.railYRatio * (i.railYHeight - i.scrollbarYHeight));
	
	    if (newTop < 0) {
	      i.scrollbarYTop = 0;
	    } else if (newTop > maxTop) {
	      i.scrollbarYTop = maxTop;
	    } else {
	      i.scrollbarYTop = newTop;
	    }
	
	    var scrollTop = _.toInt(i.scrollbarYTop * (i.contentHeight - i.containerHeight) / (i.containerHeight - (i.railYRatio * i.scrollbarYHeight)));
	    updateScroll(element, 'top', scrollTop);
	  }
	
	  var mouseMoveHandler = function (e) {
	    updateScrollTop(e.pageY - currentPageY);
	    updateGeometry(element);
	    e.stopPropagation();
	    e.preventDefault();
	  };
	
	  var mouseUpHandler = function () {
	    _.stopScrolling(element, 'y');
	    i.event.unbind(i.ownerDocument, 'mousemove', mouseMoveHandler);
	  };
	
	  i.event.bind(i.scrollbarY, 'mousedown', function (e) {
	    currentPageY = e.pageY;
	    currentTop = _.toInt(dom.css(i.scrollbarY, 'top')) * i.railYRatio;
	    _.startScrolling(element, 'y');
	
	    i.event.bind(i.ownerDocument, 'mousemove', mouseMoveHandler);
	    i.event.once(i.ownerDocument, 'mouseup', mouseUpHandler);
	
	    e.stopPropagation();
	    e.preventDefault();
	  });
	}
	
	module.exports = function (element) {
	  var i = instances.get(element);
	  bindMouseScrollXHandler(element, i);
	  bindMouseScrollYHandler(element, i);
	};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(12);
	var dom = __webpack_require__(24);
	var instances = __webpack_require__(5);
	var updateGeometry = __webpack_require__(13);
	var updateScroll = __webpack_require__(16);
	
	function bindKeyboardHandler(element, i) {
	  var hovered = false;
	  i.event.bind(element, 'mouseenter', function () {
	    hovered = true;
	  });
	  i.event.bind(element, 'mouseleave', function () {
	    hovered = false;
	  });
	
	  var shouldPrevent = false;
	  function shouldPreventDefault(deltaX, deltaY) {
	    var scrollTop = element.scrollTop;
	    if (deltaX === 0) {
	      if (!i.scrollbarYActive) {
	        return false;
	      }
	      if ((scrollTop === 0 && deltaY > 0) || (scrollTop >= i.contentHeight - i.containerHeight && deltaY < 0)) {
	        return !i.settings.wheelPropagation;
	      }
	    }
	
	    var scrollLeft = element.scrollLeft;
	    if (deltaY === 0) {
	      if (!i.scrollbarXActive) {
	        return false;
	      }
	      if ((scrollLeft === 0 && deltaX < 0) || (scrollLeft >= i.contentWidth - i.containerWidth && deltaX > 0)) {
	        return !i.settings.wheelPropagation;
	      }
	    }
	    return true;
	  }
	
	  i.event.bind(i.ownerDocument, 'keydown', function (e) {
	    if ((e.isDefaultPrevented && e.isDefaultPrevented()) || e.defaultPrevented) {
	      return;
	    }
	
	    var focused = dom.matches(i.scrollbarX, ':focus') ||
	                  dom.matches(i.scrollbarY, ':focus');
	
	    if (!hovered && !focused) {
	      return;
	    }
	
	    var activeElement = document.activeElement ? document.activeElement : i.ownerDocument.activeElement;
	    if (activeElement) {
	      if (activeElement.tagName === 'IFRAME') {
	        activeElement = activeElement.contentDocument.activeElement;
	      } else {
	        // go deeper if element is a webcomponent
	        while (activeElement.shadowRoot) {
	          activeElement = activeElement.shadowRoot.activeElement;
	        }
	      }
	      if (_.isEditable(activeElement)) {
	        return;
	      }
	    }
	
	    var deltaX = 0;
	    var deltaY = 0;
	
	    switch (e.which) {
	    case 37: // left
	      if (e.metaKey) {
	        deltaX = -i.contentWidth;
	      } else if (e.altKey) {
	        deltaX = -i.containerWidth;
	      } else {
	        deltaX = -30;
	      }
	      break;
	    case 38: // up
	      if (e.metaKey) {
	        deltaY = i.contentHeight;
	      } else if (e.altKey) {
	        deltaY = i.containerHeight;
	      } else {
	        deltaY = 30;
	      }
	      break;
	    case 39: // right
	      if (e.metaKey) {
	        deltaX = i.contentWidth;
	      } else if (e.altKey) {
	        deltaX = i.containerWidth;
	      } else {
	        deltaX = 30;
	      }
	      break;
	    case 40: // down
	      if (e.metaKey) {
	        deltaY = -i.contentHeight;
	      } else if (e.altKey) {
	        deltaY = -i.containerHeight;
	      } else {
	        deltaY = -30;
	      }
	      break;
	    case 33: // page up
	      deltaY = 90;
	      break;
	    case 32: // space bar
	      if (e.shiftKey) {
	        deltaY = 90;
	      } else {
	        deltaY = -90;
	      }
	      break;
	    case 34: // page down
	      deltaY = -90;
	      break;
	    case 35: // end
	      if (e.ctrlKey) {
	        deltaY = -i.contentHeight;
	      } else {
	        deltaY = -i.containerHeight;
	      }
	      break;
	    case 36: // home
	      if (e.ctrlKey) {
	        deltaY = element.scrollTop;
	      } else {
	        deltaY = i.containerHeight;
	      }
	      break;
	    default:
	      return;
	    }
	
	    updateScroll(element, 'top', element.scrollTop - deltaY);
	    updateScroll(element, 'left', element.scrollLeft + deltaX);
	    updateGeometry(element);
	
	    shouldPrevent = shouldPreventDefault(deltaX, deltaY);
	    if (shouldPrevent) {
	      e.preventDefault();
	    }
	  });
	}
	
	module.exports = function (element) {
	  var i = instances.get(element);
	  bindKeyboardHandler(element, i);
	};


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var instances = __webpack_require__(5);
	var updateGeometry = __webpack_require__(13);
	var updateScroll = __webpack_require__(16);
	
	function bindMouseWheelHandler(element, i) {
	  var shouldPrevent = false;
	
	  function shouldPreventDefault(deltaX, deltaY) {
	    var scrollTop = element.scrollTop;
	    if (deltaX === 0) {
	      if (!i.scrollbarYActive) {
	        return false;
	      }
	      if ((scrollTop === 0 && deltaY > 0) || (scrollTop >= i.contentHeight - i.containerHeight && deltaY < 0)) {
	        return !i.settings.wheelPropagation;
	      }
	    }
	
	    var scrollLeft = element.scrollLeft;
	    if (deltaY === 0) {
	      if (!i.scrollbarXActive) {
	        return false;
	      }
	      if ((scrollLeft === 0 && deltaX < 0) || (scrollLeft >= i.contentWidth - i.containerWidth && deltaX > 0)) {
	        return !i.settings.wheelPropagation;
	      }
	    }
	    return true;
	  }
	
	  function getDeltaFromEvent(e) {
	    var deltaX = e.deltaX;
	    var deltaY = -1 * e.deltaY;
	
	    if (typeof deltaX === "undefined" || typeof deltaY === "undefined") {
	      // OS X Safari
	      deltaX = -1 * e.wheelDeltaX / 6;
	      deltaY = e.wheelDeltaY / 6;
	    }
	
	    if (e.deltaMode && e.deltaMode === 1) {
	      // Firefox in deltaMode 1: Line scrolling
	      deltaX *= 10;
	      deltaY *= 10;
	    }
	
	    if (deltaX !== deltaX && deltaY !== deltaY/* NaN checks */) {
	      // IE in some mouse drivers
	      deltaX = 0;
	      deltaY = e.wheelDelta;
	    }
	
	    if (e.shiftKey) {
	      // reverse axis with shift key
	      return [-deltaY, -deltaX];
	    }
	    return [deltaX, deltaY];
	  }
	
	  function shouldBeConsumedByChild(deltaX, deltaY) {
	    var child = element.querySelector('textarea:hover, select[multiple]:hover, .ps-child:hover');
	    if (child) {
	      if (!window.getComputedStyle(child).overflow.match(/(scroll|auto)/)) {
	        // if not scrollable
	        return false;
	      }
	
	      var maxScrollTop = child.scrollHeight - child.clientHeight;
	      if (maxScrollTop > 0) {
	        if (!(child.scrollTop === 0 && deltaY > 0) && !(child.scrollTop === maxScrollTop && deltaY < 0)) {
	          return true;
	        }
	      }
	      var maxScrollLeft = child.scrollLeft - child.clientWidth;
	      if (maxScrollLeft > 0) {
	        if (!(child.scrollLeft === 0 && deltaX < 0) && !(child.scrollLeft === maxScrollLeft && deltaX > 0)) {
	          return true;
	        }
	      }
	    }
	    return false;
	  }
	
	  function mousewheelHandler(e) {
	    var delta = getDeltaFromEvent(e);
	
	    var deltaX = delta[0];
	    var deltaY = delta[1];
	
	    if (shouldBeConsumedByChild(deltaX, deltaY)) {
	      return;
	    }
	
	    shouldPrevent = false;
	    if (!i.settings.useBothWheelAxes) {
	      // deltaX will only be used for horizontal scrolling and deltaY will
	      // only be used for vertical scrolling - this is the default
	      updateScroll(element, 'top', element.scrollTop - (deltaY * i.settings.wheelSpeed));
	      updateScroll(element, 'left', element.scrollLeft + (deltaX * i.settings.wheelSpeed));
	    } else if (i.scrollbarYActive && !i.scrollbarXActive) {
	      // only vertical scrollbar is active and useBothWheelAxes option is
	      // active, so let's scroll vertical bar using both mouse wheel axes
	      if (deltaY) {
	        updateScroll(element, 'top', element.scrollTop - (deltaY * i.settings.wheelSpeed));
	      } else {
	        updateScroll(element, 'top', element.scrollTop + (deltaX * i.settings.wheelSpeed));
	      }
	      shouldPrevent = true;
	    } else if (i.scrollbarXActive && !i.scrollbarYActive) {
	      // useBothWheelAxes and only horizontal bar is active, so use both
	      // wheel axes for horizontal bar
	      if (deltaX) {
	        updateScroll(element, 'left', element.scrollLeft + (deltaX * i.settings.wheelSpeed));
	      } else {
	        updateScroll(element, 'left', element.scrollLeft - (deltaY * i.settings.wheelSpeed));
	      }
	      shouldPrevent = true;
	    }
	
	    updateGeometry(element);
	
	    shouldPrevent = (shouldPrevent || shouldPreventDefault(deltaX, deltaY));
	    if (shouldPrevent) {
	      e.stopPropagation();
	      e.preventDefault();
	    }
	  }
	
	  if (typeof window.onwheel !== "undefined") {
	    i.event.bind(element, 'wheel', mousewheelHandler);
	  } else if (typeof window.onmousewheel !== "undefined") {
	    i.event.bind(element, 'mousewheel', mousewheelHandler);
	  }
	}
	
	module.exports = function (element) {
	  var i = instances.get(element);
	  bindMouseWheelHandler(element, i);
	};


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var instances = __webpack_require__(5);
	var updateGeometry = __webpack_require__(13);
	
	function bindNativeScrollHandler(element, i) {
	  i.event.bind(element, 'scroll', function () {
	    updateGeometry(element);
	  });
	}
	
	module.exports = function (element) {
	  var i = instances.get(element);
	  bindNativeScrollHandler(element, i);
	};


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(12);
	var instances = __webpack_require__(5);
	var updateGeometry = __webpack_require__(13);
	var updateScroll = __webpack_require__(16);
	
	function bindSelectionHandler(element, i) {
	  function getRangeNode() {
	    var selection = window.getSelection ? window.getSelection() :
	                    document.getSelection ? document.getSelection() : '';
	    if (selection.toString().length === 0) {
	      return null;
	    } else {
	      return selection.getRangeAt(0).commonAncestorContainer;
	    }
	  }
	
	  var scrollingLoop = null;
	  var scrollDiff = {top: 0, left: 0};
	  function startScrolling() {
	    if (!scrollingLoop) {
	      scrollingLoop = setInterval(function () {
	        if (!instances.get(element)) {
	          clearInterval(scrollingLoop);
	          return;
	        }
	
	        updateScroll(element, 'top', element.scrollTop + scrollDiff.top);
	        updateScroll(element, 'left', element.scrollLeft + scrollDiff.left);
	        updateGeometry(element);
	      }, 50); // every .1 sec
	    }
	  }
	  function stopScrolling() {
	    if (scrollingLoop) {
	      clearInterval(scrollingLoop);
	      scrollingLoop = null;
	    }
	    _.stopScrolling(element);
	  }
	
	  var isSelected = false;
	  i.event.bind(i.ownerDocument, 'selectionchange', function () {
	    if (element.contains(getRangeNode())) {
	      isSelected = true;
	    } else {
	      isSelected = false;
	      stopScrolling();
	    }
	  });
	  i.event.bind(window, 'mouseup', function () {
	    if (isSelected) {
	      isSelected = false;
	      stopScrolling();
	    }
	  });
	  i.event.bind(window, 'keyup', function () {
	    if (isSelected) {
	      isSelected = false;
	      stopScrolling();
	    }
	  });
	
	  i.event.bind(window, 'mousemove', function (e) {
	    if (isSelected) {
	      var mousePosition = {x: e.pageX, y: e.pageY};
	      var containerGeometry = {
	        left: element.offsetLeft,
	        right: element.offsetLeft + element.offsetWidth,
	        top: element.offsetTop,
	        bottom: element.offsetTop + element.offsetHeight
	      };
	
	      if (mousePosition.x < containerGeometry.left + 3) {
	        scrollDiff.left = -5;
	        _.startScrolling(element, 'x');
	      } else if (mousePosition.x > containerGeometry.right - 3) {
	        scrollDiff.left = 5;
	        _.startScrolling(element, 'x');
	      } else {
	        scrollDiff.left = 0;
	      }
	
	      if (mousePosition.y < containerGeometry.top + 3) {
	        if (containerGeometry.top + 3 - mousePosition.y < 5) {
	          scrollDiff.top = -5;
	        } else {
	          scrollDiff.top = -20;
	        }
	        _.startScrolling(element, 'y');
	      } else if (mousePosition.y > containerGeometry.bottom - 3) {
	        if (mousePosition.y - containerGeometry.bottom + 3 < 5) {
	          scrollDiff.top = 5;
	        } else {
	          scrollDiff.top = 20;
	        }
	        _.startScrolling(element, 'y');
	      } else {
	        scrollDiff.top = 0;
	      }
	
	      if (scrollDiff.top === 0 && scrollDiff.left === 0) {
	        stopScrolling();
	      } else {
	        startScrolling();
	      }
	    }
	  });
	}
	
	module.exports = function (element) {
	  var i = instances.get(element);
	  bindSelectionHandler(element, i);
	};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(12);
	var instances = __webpack_require__(5);
	var updateGeometry = __webpack_require__(13);
	var updateScroll = __webpack_require__(16);
	
	function bindTouchHandler(element, i, supportsTouch, supportsIePointer) {
	  function shouldPreventDefault(deltaX, deltaY) {
	    var scrollTop = element.scrollTop;
	    var scrollLeft = element.scrollLeft;
	    var magnitudeX = Math.abs(deltaX);
	    var magnitudeY = Math.abs(deltaY);
	
	    if (magnitudeY > magnitudeX) {
	      // user is perhaps trying to swipe up/down the page
	
	      if (((deltaY < 0) && (scrollTop === i.contentHeight - i.containerHeight)) ||
	          ((deltaY > 0) && (scrollTop === 0))) {
	        return !i.settings.swipePropagation;
	      }
	    } else if (magnitudeX > magnitudeY) {
	      // user is perhaps trying to swipe left/right across the page
	
	      if (((deltaX < 0) && (scrollLeft === i.contentWidth - i.containerWidth)) ||
	          ((deltaX > 0) && (scrollLeft === 0))) {
	        return !i.settings.swipePropagation;
	      }
	    }
	
	    return true;
	  }
	
	  function applyTouchMove(differenceX, differenceY) {
	    updateScroll(element, 'top', element.scrollTop - differenceY);
	    updateScroll(element, 'left', element.scrollLeft - differenceX);
	
	    updateGeometry(element);
	  }
	
	  var startOffset = {};
	  var startTime = 0;
	  var speed = {};
	  var easingLoop = null;
	  var inGlobalTouch = false;
	  var inLocalTouch = false;
	
	  function globalTouchStart() {
	    inGlobalTouch = true;
	  }
	  function globalTouchEnd() {
	    inGlobalTouch = false;
	  }
	
	  function getTouch(e) {
	    if (e.targetTouches) {
	      return e.targetTouches[0];
	    } else {
	      // Maybe IE pointer
	      return e;
	    }
	  }
	  function shouldHandle(e) {
	    if (e.targetTouches && e.targetTouches.length === 1) {
	      return true;
	    }
	    if (e.pointerType && e.pointerType !== 'mouse' && e.pointerType !== e.MSPOINTER_TYPE_MOUSE) {
	      return true;
	    }
	    return false;
	  }
	  function touchStart(e) {
	    if (shouldHandle(e)) {
	      inLocalTouch = true;
	
	      var touch = getTouch(e);
	
	      startOffset.pageX = touch.pageX;
	      startOffset.pageY = touch.pageY;
	
	      startTime = (new Date()).getTime();
	
	      if (easingLoop !== null) {
	        clearInterval(easingLoop);
	      }
	
	      e.stopPropagation();
	    }
	  }
	  function touchMove(e) {
	    if (!inLocalTouch && i.settings.swipePropagation) {
	      touchStart(e);
	    }
	    if (!inGlobalTouch && inLocalTouch && shouldHandle(e)) {
	      var touch = getTouch(e);
	
	      var currentOffset = {pageX: touch.pageX, pageY: touch.pageY};
	
	      var differenceX = currentOffset.pageX - startOffset.pageX;
	      var differenceY = currentOffset.pageY - startOffset.pageY;
	
	      applyTouchMove(differenceX, differenceY);
	      startOffset = currentOffset;
	
	      var currentTime = (new Date()).getTime();
	
	      var timeGap = currentTime - startTime;
	      if (timeGap > 0) {
	        speed.x = differenceX / timeGap;
	        speed.y = differenceY / timeGap;
	        startTime = currentTime;
	      }
	
	      if (shouldPreventDefault(differenceX, differenceY)) {
	        e.stopPropagation();
	        e.preventDefault();
	      }
	    }
	  }
	  function touchEnd() {
	    if (!inGlobalTouch && inLocalTouch) {
	      inLocalTouch = false;
	
	      clearInterval(easingLoop);
	      easingLoop = setInterval(function () {
	        if (!instances.get(element)) {
	          clearInterval(easingLoop);
	          return;
	        }
	
	        if (!speed.x && !speed.y) {
	          clearInterval(easingLoop);
	          return;
	        }
	
	        if (Math.abs(speed.x) < 0.01 && Math.abs(speed.y) < 0.01) {
	          clearInterval(easingLoop);
	          return;
	        }
	
	        applyTouchMove(speed.x * 30, speed.y * 30);
	
	        speed.x *= 0.8;
	        speed.y *= 0.8;
	      }, 10);
	    }
	  }
	
	  if (supportsTouch) {
	    i.event.bind(window, 'touchstart', globalTouchStart);
	    i.event.bind(window, 'touchend', globalTouchEnd);
	    i.event.bind(element, 'touchstart', touchStart);
	    i.event.bind(element, 'touchmove', touchMove);
	    i.event.bind(element, 'touchend', touchEnd);
	  } else if (supportsIePointer) {
	    if (window.PointerEvent) {
	      i.event.bind(window, 'pointerdown', globalTouchStart);
	      i.event.bind(window, 'pointerup', globalTouchEnd);
	      i.event.bind(element, 'pointerdown', touchStart);
	      i.event.bind(element, 'pointermove', touchMove);
	      i.event.bind(element, 'pointerup', touchEnd);
	    } else if (window.MSPointerEvent) {
	      i.event.bind(window, 'MSPointerDown', globalTouchStart);
	      i.event.bind(window, 'MSPointerUp', globalTouchEnd);
	      i.event.bind(element, 'MSPointerDown', touchStart);
	      i.event.bind(element, 'MSPointerMove', touchMove);
	      i.event.bind(element, 'MSPointerUp', touchEnd);
	    }
	  }
	}
	
	module.exports = function (element) {
	  if (!_.env.supportsTouch && !_.env.supportsIePointer) {
	    return;
	  }
	
	  var i = instances.get(element);
	  bindTouchHandler(element, i, _.env.supportsTouch, _.env.supportsIePointer);
	};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(12);
	var cls = __webpack_require__(43);
	var instances = __webpack_require__(5);
	var updateGeometry = __webpack_require__(13);
	
	// Handlers
	var handlers = {
	  'click-rail': __webpack_require__(203),
	  'drag-scrollbar': __webpack_require__(204),
	  'keyboard': __webpack_require__(205),
	  'wheel': __webpack_require__(206),
	  'touch': __webpack_require__(209),
	  'selection': __webpack_require__(208)
	};
	var nativeScrollHandler = __webpack_require__(207);
	
	module.exports = function (element, userSettings) {
	  userSettings = typeof userSettings === 'object' ? userSettings : {};
	
	  cls.add(element, 'ps-container');
	
	  // Create a plugin instance.
	  var i = instances.add(element);
	
	  i.settings = _.extend(i.settings, userSettings);
	  cls.add(element, 'ps-theme-' + i.settings.theme);
	
	  i.settings.handlers.forEach(function (handlerName) {
	    handlers[handlerName](element);
	  });
	
	  nativeScrollHandler(element);
	
	  updateGeometry(element);
	};


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(12);
	var dom = __webpack_require__(24);
	var instances = __webpack_require__(5);
	var updateGeometry = __webpack_require__(13);
	var updateScroll = __webpack_require__(16);
	
	module.exports = function (element) {
	  var i = instances.get(element);
	
	  if (!i) {
	    return;
	  }
	
	  // Recalcuate negative scrollLeft adjustment
	  i.negativeScrollAdjustment = i.isNegativeScroll ? element.scrollWidth - element.clientWidth : 0;
	
	  // Recalculate rail margins
	  dom.css(i.scrollbarXRail, 'display', 'block');
	  dom.css(i.scrollbarYRail, 'display', 'block');
	  i.railXMarginWidth = _.toInt(dom.css(i.scrollbarXRail, 'marginLeft')) + _.toInt(dom.css(i.scrollbarXRail, 'marginRight'));
	  i.railYMarginHeight = _.toInt(dom.css(i.scrollbarYRail, 'marginTop')) + _.toInt(dom.css(i.scrollbarYRail, 'marginBottom'));
	
	  // Hide scrollbars not to affect scrollWidth and scrollHeight
	  dom.css(i.scrollbarXRail, 'display', 'none');
	  dom.css(i.scrollbarYRail, 'display', 'none');
	
	  updateGeometry(element);
	
	  // Update top/left scroll to trigger events
	  updateScroll(element, 'top', element.scrollTop);
	  updateScroll(element, 'left', element.scrollLeft);
	
	  dom.css(i.scrollbarXRail, 'display', '');
	  dom.css(i.scrollbarYRail, 'display', '');
	};


/***/ }),
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(226), __esModule: true };

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	/*
	 * SimpleModal @VERSION - jQuery Plugin
	 * http://simplemodal.com/
	 * Copyright (c) 2014 Eric Martin
	 * Licensed under MIT and GPL
	 * Date:
	 */
	
	/**
	 * SimpleModal is a lightweight jQuery plugin that provides a simple
	 * interface to create a modal dialog.
	 *
	 * The goal of SimpleModal is to provide developers with a cross-browser
	 * overlay and container that will be populated with data provided to
	 * SimpleModal.
	 *
	 * There are two ways to call SimpleModal:
	 * 1) As a chained function on a jQuery object, like $('#myDiv').modal();.
	 * This call would place the DOM object, #myDiv, inside a modal dialog.
	 * Chaining requires a jQuery object. An optional options object can be
	 * passed as a parameter.
	 *
	 * @example $('<div>my data</div>').modal({options});
	 * @example $('#myDiv').modal({options});
	 * @example jQueryObject.modal({options});
	 *
	 * 2) As a stand-alone function, like $.modal(data). The data parameter
	 * is required and an optional options object can be passed as a second
	 * parameter. This method provides more flexibility in the types of data
	 * that are allowed. The data could be a DOM object, a jQuery object, HTML
	 * or a string.
	 *
	 * @example $.modal('<div>my data</div>', {options});
	 * @example $.modal('my data', {options});
	 * @example $.modal($('#myDiv'), {options});
	 * @example $.modal(jQueryObject, {options});
	 * @example $.modal(document.getElementById('myDiv'), {options});
	 *
	 * A SimpleModal call can contain multiple elements, but only one modal
	 * dialog can be created at a time. Which means that all of the matched
	 * elements will be displayed within the modal container.
	 *
	 * SimpleModal internally sets the CSS needed to display the modal dialog
	 * properly in all browsers, yet provides the developer with the flexibility
	 * to easily control the look and feel. The styling for SimpleModal can be
	 * done through external stylesheets, or through SimpleModal, using the
	 * overlayCss, containerCss, and dataCss options.
	 *
	 * SimpleModal has been tested in the following browsers:
	 * - IE 6+
	 * - Firefox 2+
	 * - Opera 9+
	 * - Safari 3+
	 * - Chrome 1+
	 *
	 * @name SimpleModal
	 * @type jQuery
	 * @requires jQuery v1.3
	 * @cat Plugins/Windows and Overlays
	 * @author Eric Martin (http://ericmmartin.com)
	 * @version @VERSION
	 */
	
	;(function (factory) {
		if (true) {
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Browser globals
			factory(jQuery);
		}
	}
	(function ($) {
		var d = [],
			doc = $(document),
			ua = navigator.userAgent.toLowerCase(),
			wndw = $(window),
			w = [];
	
		var browser = {
			ieQuirks: null,
			msie: /msie/.test(ua) && !/opera/.test(ua),
			opera: /opera/.test(ua)
		};
		browser.ie6 = browser.msie && /msie 6./.test(ua) && typeof window['XMLHttpRequest'] !== 'object';
		browser.ie7 = browser.msie && /msie 7.0/.test(ua);
		browser.boxModel = (document.compatMode === "CSS1Compat");
	
		/*
		 * Create and display a modal dialog.
		 *
		 * @param {string, object} data A string, jQuery object or DOM object
		 * @param {object} [options] An optional object containing options overrides
		 */
		$.modal = function (data, options) {
			return $.modal.impl.init(data, options);
		};
	
		/*
		 * Close the modal dialog.
		 */
		$.modal.close = function () {
			$.modal.impl.close();
		};
	
		/*
		 * Set focus on first or last visible input in the modal dialog. To focus on the last
		 * element, call $.modal.focus('last'). If no input elements are found, focus is placed
		 * on the data wrapper element.
		 */
		$.modal.focus = function (pos) {
			$.modal.impl.focus(pos);
		};
	
		/*
		 * Determine and set the dimensions of the modal dialog container.
		 * setPosition() is called if the autoPosition option is true.
		 */
		$.modal.setContainerDimensions = function () {
			$.modal.impl.setContainerDimensions();
		};
	
		/*
		 * Re-position the modal dialog.
		 */
		$.modal.setPosition = function () {
			$.modal.impl.setPosition();
		};
	
		/*
		 * Update the modal dialog. If new dimensions are passed, they will be used to determine
		 * the dimensions of the container.
		 *
		 * setContainerDimensions() is called, which in turn calls setPosition(), if enabled.
		 * Lastly, focus() is called is the focus option is true.
		 */
		$.modal.update = function (height, width) {
			$.modal.impl.update(height, width);
		};
	
		/*
		 * Chained function to create a modal dialog.
		 *
		 * @param {object} [options] An optional object containing options overrides
		 */
		$.fn.modal = function (options) {
			return $.modal.impl.init(this, options);
		};
	
		/*
		 * SimpleModal default options
		 *
		 * appendTo:		(String:'body') The jQuery selector to append the elements to. For .NET, use 'form'.
		 * focus:			(Boolean:true) Focus in the first visible, enabled element?
		 * opacity:			(Number:50) The opacity value for the overlay div, from 0 - 100
		 * overlayId:		(String:'simplemodal-overlay') The DOM element id for the overlay div
		 * overlayCss:		(Object:{}) The CSS styling for the overlay div
		 * containerId:		(String:'simplemodal-container') The DOM element id for the container div
		 * containerCss:	(Object:{}) The CSS styling for the container div
		 * dataId:			(String:'simplemodal-data') The DOM element id for the data div
		 * dataCss:			(Object:{}) The CSS styling for the data div
		 * minHeight:		(Number:null) The minimum height for the container
		 * minWidth:		(Number:null) The minimum width for the container
		 * maxHeight:		(Number:null) The maximum height for the container. If not specified, the window height is used.
		 * maxWidth:		(Number:null) The maximum width for the container. If not specified, the window width is used.
		 * autoResize:		(Boolean:false) Automatically resize the container if it exceeds the browser window dimensions?
		 * autoPosition:	(Boolean:true) Automatically position the container upon creation and on window resize?
		 * zIndex:			(Number: 1000) Starting z-index value
		 * close:			(Boolean:true) If true, closeHTML, escClose and overClose will be used if set.
		 							If false, none of them will be used.
		 * closeHTML:		(String:'<a class="modalCloseImg" title="Close"></a>') The HTML for the default close link.
									SimpleModal will automatically add the closeClass to this element.
		 * closeClass:		(String:'simplemodal-close') The CSS class used to bind to the close event
		 * escClose:		(Boolean:true) Allow Esc keypress to close the dialog?
		 * overlayClose:	(Boolean:false) Allow click on overlay to close the dialog?
		 * fixed:			(Boolean:true) If true, the container will use a fixed position. If false, it will use a
									absolute position (the dialog will scroll with the page)
		 * position:		(Array:null) Position of container [top, left]. Can be number of pixels or percentage
		 * persist:			(Boolean:false) Persist the data across modal calls? Only used for existing
									DOM elements. If true, the data will be maintained across modal calls, if false,
									the data will be reverted to its original state.
		 * modal:			(Boolean:true) User will be unable to interact with the page below the modal or tab away from the dialog.
									If false, the overlay, iframe, and certain events will be disabled allowing the user to interact
									with the page below the dialog.
		 * onOpen:			(Function:null) The callback function used in place of SimpleModal's open
		 * onShow:			(Function:null) The callback function used after the modal dialog has opened
		 * onClose:			(Function:null) The callback function used in place of SimpleModal's close
		 */
		$.modal.defaults = {
			appendTo: 'body',
			focus: true,
			opacity: 50,
			overlayId: 'simplemodal-overlay',
			overlayCss: {},
			containerId: 'simplemodal-container',
			containerCss: {},
			dataId: 'simplemodal-data',
			dataCss: {},
			minHeight: null,
			minWidth: null,
			maxHeight: null,
			maxWidth: null,
			autoResize: false,
			autoPosition: true,
			zIndex: 1000,
			close: true,
			closeHTML: '<a class="modalCloseImg" title="Close"></a>',
			closeClass: 'simplemodal-close',
			escClose: true,
			overlayClose: false,
			fixed: true,
			position: null,
			persist: false,
			modal: true,
			onOpen: null,
			onShow: null,
			onClose: null
		};
	
		/*
		 * Main modal object
		 * o = options
		 */
		$.modal.impl = {
			/*
			 * Contains the modal dialog elements and is the object passed
			 * back to the callback (onOpen, onShow, onClose) functions
			 */
			d: {},
			/*
			 * Initialize the modal dialog
			 */
			init: function (data, options) {
				var s = this;
	
				// don't allow multiple calls
				if (s.d.data) {
					return false;
				}
	
				browser.ieQuirks = browser.msie && !browser.boxModel;
	
				// merge defaults and user options
				s.o = $.extend({}, $.modal.defaults, options);
	
				// keep track of z-index
				s.zIndex = s.o.zIndex;
	
				// set the onClose callback flag
				s.occb = false;
	
				// determine how to handle the data based on its type
				if (typeof data === 'object') {
					// convert DOM object to a jQuery object
					data = data instanceof $ ? data : $(data);
					s.d.placeholder = false;
	
					// if the object came from the DOM, keep track of its parent
					if (data.parent().parent().size() > 0) {
						data.before($('<span></span>')
							.attr('id', 'simplemodal-placeholder')
							.css({display: 'none'}));
	
						s.d.placeholder = true;
						s.display = data.css('display');
	
						// persist changes? if not, make a clone of the element
						if (!s.o.persist) {
							s.d.orig = data.clone(true);
						}
					}
				}
				else if (typeof data === 'string' || typeof data === 'number') {
					// just insert the data as innerHTML
					data = $('<div></div>').html(data);
				}
				else {
					// unsupported data type!
					alert('SimpleModal Error: Unsupported data type: ' + typeof data);
					return s;
				}
	
				// create the modal overlay, container and, if necessary, iframe
				s.create(data);
				data = null;
	
				// display the modal dialog
				s.open();
	
				// useful for adding events/manipulating data in the modal dialog
				if ($.isFunction(s.o.onShow)) {
					s.o.onShow.apply(s, [s.d]);
				}
	
				// don't break the chain =)
				return s;
			},
			/*
			 * Create and add the modal overlay and container to the page
			 */
			create: function (data) {
				var s = this;
	
				// get the window properties
				s.getDimensions();
	
				// add an iframe to prevent select options from bleeding through
				if (s.o.modal && browser.ie6) {
					s.d.iframe = $('<iframe src="javascript:false;"></iframe>')
						.css($.extend(s.o.iframeCss, {
							display: 'none',
							opacity: 0,
							position: 'fixed',
							height: w[0],
							width: w[1],
							zIndex: s.o.zIndex,
							top: 0,
							left: 0
						}))
						.appendTo(s.o.appendTo);
				}
	
				// create the overlay
				s.d.overlay = $('<div></div>')
					.attr('id', s.o.overlayId)
					.addClass('simplemodal-overlay')
					.css($.extend(s.o.overlayCss, {
						display: 'none',
						opacity: s.o.opacity / 100,
						height: s.o.modal ? d[0] : 0,
						width: s.o.modal ? d[1] : 0,
						position: 'fixed',
						left: 0,
						top: 0,
						zIndex: s.o.zIndex + 1
					}))
					.appendTo(s.o.appendTo);
	
				// create the container
				s.d.container = $('<div></div>')
					.attr('id', s.o.containerId)
					.addClass('simplemodal-container')
					.css($.extend(
						{position: s.o.fixed ? 'fixed' : 'absolute'},
						s.o.containerCss,
						{display: 'none', zIndex: s.o.zIndex + 2}
					))
					.append(s.o.close && s.o.closeHTML
						? $(s.o.closeHTML).addClass(s.o.closeClass)
						: '')
					.appendTo(s.o.appendTo);
	
				s.d.wrap = $('<div></div>')
					.attr('tabIndex', -1)
					.addClass('simplemodal-wrap')
					.css({height: '100%', outline: 0, width: '100%'})
					.appendTo(s.d.container);
	
				// add styling and attributes to the data
				// append to body to get correct dimensions, then move to wrap
				s.d.data = data
					.attr('id', data.attr('id') || s.o.dataId)
					.addClass('simplemodal-data')
					.css($.extend(s.o.dataCss, {
							display: 'none'
					}))
					.appendTo('body');
				data = null;
	
				s.setContainerDimensions();
				s.d.data.appendTo(s.d.wrap);
	
				// fix issues with IE
				if (browser.ie6 || browser.ieQuirks) {
					s.fixIE();
				}
			},
			/*
			 * Bind events
			 */
			bindEvents: function () {
				var s = this;
	
				// bind the close event to any element with the closeClass class
				$('.' + s.o.closeClass).bind('click.simplemodal', function (e) {
					e.preventDefault();
					s.close();
				});
	
				// bind the overlay click to the close function, if enabled
				if (s.o.modal && s.o.close && s.o.overlayClose) {
					s.d.overlay.bind('click.simplemodal', function (e) {
						e.preventDefault();
						s.close();
					});
				}
	
				// bind keydown events
				doc.bind('keydown.simplemodal', function (e) {
					if (s.o.modal && e.keyCode === 9) { // TAB
						s.watchTab(e);
					}
					else if ((s.o.close && s.o.escClose) && e.keyCode === 27) { // ESC
						e.preventDefault();
						s.close();
					}
				});
	
				// update window size
				wndw.bind('resize.simplemodal orientationchange.simplemodal', function () {
					// redetermine the window width/height
					s.getDimensions();
	
					// reposition the dialog
					s.o.autoResize ? s.setContainerDimensions() : s.o.autoPosition && s.setPosition();
	
					if (browser.ie6 || browser.ieQuirks) {
						s.fixIE();
					}
					else if (s.o.modal) {
						// update the iframe & overlay
						s.d.iframe && s.d.iframe.css({height: w[0], width: w[1]});
						s.d.overlay.css({height: d[0], width: d[1]});
					}
				});
			},
			/*
			 * Unbind events
			 */
			unbindEvents: function () {
				$('.' + this.o.closeClass).unbind('click.simplemodal');
				doc.unbind('keydown.simplemodal');
				wndw.unbind('.simplemodal');
				this.d.overlay.unbind('click.simplemodal');
			},
			/*
			 * Fix issues in IE6 and IE7 in quirks mode
			 */
			fixIE: function () {
				var s = this, p = s.o.position;
	
				// simulate fixed position - adapted from BlockUI
				$.each([s.d.iframe || null, !s.o.modal ? null : s.d.overlay, s.d.container.css('position') === 'fixed' ? s.d.container : null], function (i, el) {
					if (el) {
						var bch = 'document.body.clientHeight', bcw = 'document.body.clientWidth',
							bsh = 'document.body.scrollHeight', bsl = 'document.body.scrollLeft',
							bst = 'document.body.scrollTop', bsw = 'document.body.scrollWidth',
							ch = 'document.documentElement.clientHeight', cw = 'document.documentElement.clientWidth',
							sl = 'document.documentElement.scrollLeft', st = 'document.documentElement.scrollTop',
							s = el[0].style;
	
						s.position = 'absolute';
						if (i < 2) {
							s.removeExpression('height');
							s.removeExpression('width');
							s.setExpression('height','' + bsh + ' > ' + bch + ' ? ' + bsh + ' : ' + bch + ' + "px"');
							s.setExpression('width','' + bsw + ' > ' + bcw + ' ? ' + bsw + ' : ' + bcw + ' + "px"');
						}
						else {
							var te, le;
							if (p && p.constructor === Array) {
								var top = p[0]
									? typeof p[0] === 'number' ? p[0].toString() : p[0].replace(/px/, '')
									: el.css('top').replace(/px/, '');
								te = top.indexOf('%') === -1
									? top + ' + (t = ' + st + ' ? ' + st + ' : ' + bst + ') + "px"'
									: parseInt(top.replace(/%/, '')) + ' * ((' + ch + ' || ' + bch + ') / 100) + (t = ' + st + ' ? ' + st + ' : ' + bst + ') + "px"';
	
								if (p[1]) {
									var left = typeof p[1] === 'number' ? p[1].toString() : p[1].replace(/px/, '');
									le = left.indexOf('%') === -1
										? left + ' + (t = ' + sl + ' ? ' + sl + ' : ' + bsl + ') + "px"'
										: parseInt(left.replace(/%/, '')) + ' * ((' + cw + ' || ' + bcw + ') / 100) + (t = ' + sl + ' ? ' + sl + ' : ' + bsl + ') + "px"';
								}
							}
							else {
								te = '(' + ch + ' || ' + bch + ') / 2 - (this.offsetHeight / 2) + (t = ' + st + ' ? ' + st + ' : ' + bst + ') + "px"';
								le = '(' + cw + ' || ' + bcw + ') / 2 - (this.offsetWidth / 2) + (t = ' + sl + ' ? ' + sl + ' : ' + bsl + ') + "px"';
							}
							s.removeExpression('top');
							s.removeExpression('left');
							s.setExpression('top', te);
							s.setExpression('left', le);
						}
					}
				});
			},
			/*
			 * Place focus on the first or last visible input
			 */
			focus: function (pos) {
				var s = this, p = pos && $.inArray(pos, ['first', 'last']) !== -1 ? pos : 'first';
	
				// focus on dialog or the first visible/enabled input element
				var input = $(':input:enabled:visible:' + p, s.d.wrap);
				setTimeout(function () {
					input.length > 0 ? input.focus() : s.d.wrap.focus();
				}, 10);
			},
			getDimensions: function () {
				// fix a jQuery bug with determining the window height - use innerHeight if available
				var s = this,
					h = typeof window.innerHeight === 'undefined' ? wndw.height() : window.innerHeight;
	
				d = [doc.height(), doc.width()];
				w = [h, wndw.width()];
			},
			getVal: function (v, d) {
				return v ? (typeof v === 'number' ? v
						: v === 'auto' ? 0
						: v.indexOf('%') > 0 ? ((parseInt(v.replace(/%/, '')) / 100) * (d === 'h' ? w[0] : w[1]))
						: parseInt(v.replace(/px/, '')))
					: null;
			},
			/*
			 * Update the container. Set new dimensions, if provided.
			 * Focus, if enabled. Re-bind events.
			 */
			update: function (height, width) {
				var s = this;
	
				// prevent update if dialog does not exist
				if (!s.d.data) {
					return false;
				}
	
				// reset orig values
				s.d.origHeight = s.getVal(height, 'h');
				s.d.origWidth = s.getVal(width, 'w');
	
				// hide data to prevent screen flicker
				s.d.data.hide();
				height && s.d.container.css('height', height);
				width && s.d.container.css('width', width);
				s.setContainerDimensions();
				s.d.data.show();
				s.o.focus && s.focus();
	
				// rebind events
				s.unbindEvents();
				s.bindEvents();
			},
			setContainerDimensions: function () {
				var s = this,
					badIE = browser.ie6 || browser.ie7;
	
				// get the dimensions for the container and data
				var ch = s.d.origHeight ? s.d.origHeight : browser.opera ? s.d.container.height() : s.getVal(badIE ? s.d.container[0].currentStyle['height'] : s.d.container.css('height'), 'h'),
					cw = s.d.origWidth ? s.d.origWidth : browser.opera ? s.d.container.width() : s.getVal(badIE ? s.d.container[0].currentStyle['width'] : s.d.container.css('width'), 'w'),
					dh = s.d.data.outerHeight(true), dw = s.d.data.outerWidth(true);
	
				s.d.origHeight = s.d.origHeight || ch;
				s.d.origWidth = s.d.origWidth || cw;
	
				// mxoh = max option height, mxow = max option width
				var mxoh = s.o.maxHeight ? s.getVal(s.o.maxHeight, 'h') : null,
					mxow = s.o.maxWidth ? s.getVal(s.o.maxWidth, 'w') : null,
					mh = mxoh && mxoh < w[0] ? mxoh : w[0],
					mw = mxow && mxow < w[1] ? mxow : w[1];
	
				// moh = min option height
				var moh = s.o.minHeight ? s.getVal(s.o.minHeight, 'h') : 'auto';
				if (!ch) {
					if (!dh) {ch = moh;}
					else {
						if (dh > mh) {ch = mh;}
						else if (s.o.minHeight && moh !== 'auto' && dh < moh) {ch = moh;}
						else {ch = dh;}
					}
				}
				else {
					ch = s.o.autoResize && ch > mh ? mh : ch < moh ? moh : ch;
				}
	
				// mow = min option width
				var mow = s.o.minWidth ? s.getVal(s.o.minWidth, 'w') : 'auto';
				if (!cw) {
					if (!dw) {cw = mow;}
					else {
						if (dw > mw) {cw = mw;}
						else if (s.o.minWidth && mow !== 'auto' && dw < mow) {cw = mow;}
						else {cw = dw;}
					}
				}
				else {
					cw = s.o.autoResize && cw > mw ? mw : cw < mow ? mow : cw;
				}
	
				s.d.container.css({height: ch, width: cw});
				s.d.wrap.css({overflow: (dh > ch || dw > cw) ? 'auto' : 'visible'});
				s.o.autoPosition && s.setPosition();
			},
			setPosition: function () {
				var s = this, top, left,
					hc = (w[0]/2) - (s.d.container.outerHeight(true)/2),
					vc = (w[1]/2) - (s.d.container.outerWidth(true)/2),
					st = s.d.container.css('position') !== 'fixed' ? wndw.scrollTop() : 0;
	
				if (s.o.position && Object.prototype.toString.call(s.o.position) === '[object Array]') {
					top = parseFloat(st) + parseFloat(s.o.position[0] || hc);
					left = s.o.position[1] || vc;
				} else {
					top = st + hc;
					left = vc;
				}
				s.d.container.css({left: left, top: top});
			},
			watchTab: function (e) {
				var s = this;
	
				if ($(e.target).parents('.simplemodal-container').length > 0) {
					// save the list of inputs
					s.inputs = $(':input:enabled:visible:first, :input:enabled:visible:last', s.d.data[0]);
	
					// if it's the first or last tabbable element, refocus
					if ((!e.shiftKey && e.target === s.inputs[s.inputs.length -1]) ||
							(e.shiftKey && e.target === s.inputs[0]) ||
							s.inputs.length === 0) {
						e.preventDefault();
						var pos = e.shiftKey ? 'last' : 'first';
						s.focus(pos);
					}
				}
				else {
					// might be necessary when custom onShow callback is used
					e.preventDefault();
					s.focus();
				}
			},
			/*
			 * Open the modal dialog elements
			 * - Note: If you use the onOpen callback, you must "show" the
			 *         overlay and container elements manually
			 *         (the iframe will be handled by SimpleModal)
			 */
			open: function () {
				var s = this;
				// display the iframe
				s.d.iframe && s.d.iframe.show();
	
				if ($.isFunction(s.o.onOpen)) {
					// execute the onOpen callback
					s.o.onOpen.apply(s, [s.d]);
				}
				else {
					// display the remaining elements
					s.d.overlay.show();
					s.d.container.show();
					s.d.data.show();
				}
	
				s.o.focus && s.focus();
	
				// bind default events
				s.bindEvents();
			},
			/*
			 * Close the modal dialog
			 * - Note: If you use an onClose callback, you must remove the
			 *         overlay, container and iframe elements manually
			 *
			 * @param {boolean} external Indicates whether the call to this
			 *     function was internal or external. If it was external, the
			 *     onClose callback will be ignored
			 */
			close: function () {
				var s = this;
	
				// prevent close when dialog does not exist
				if (!s.d.data) {
					return false;
				}
	
				// remove the default events
				s.unbindEvents();
	
				if ($.isFunction(s.o.onClose) && !s.occb) {
					// set the onClose callback flag
					s.occb = true;
	
					// execute the onClose callback
					s.o.onClose.apply(s, [s.d]);
				}
				else {
					// if the data came from the DOM, put it back
					if (s.d.placeholder) {
						var ph = $('#simplemodal-placeholder');
						// save changes to the data?
						if (s.o.persist) {
							// insert the (possibly) modified data back into the DOM
							ph.replaceWith(s.d.data.removeClass('simplemodal-data').css('display', s.display));
						}
						else {
							// remove the current and insert the original,
							// unmodified data back into the DOM
							s.d.data.hide().remove();
							ph.replaceWith(s.d.orig);
						}
					}
					else {
						// otherwise, remove it
						s.d.data.hide().remove();
					}
	
					// remove the remaining elements
					s.d.container.hide().remove();
					s.d.overlay.hide();
					s.d.iframe && s.d.iframe.hide().remove();
					s.d.overlay.remove();
	
					// reset the dialog object
					s.d = {};
				}
			}
		};
	}));
	
	}.call(window));

/***/ }),
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(1),
	    __webpack_require__(69),
	    __webpack_require__(14)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, ParamConverter, Url) {
	        return {
	            useHashInScope: function (scope) {
	                scope.setMultiplePrefixedParams(ParamConverter.fromQuery(new Url(window.location.href)).merged);
	                function paramChangeHandler(event, name, value) {
	                    if (event.source == event.scope) {
	                        if (event.scope.name) {
	                            //add prefix if needed
	                            name = event.scope.name + '.' + name;
	                        }
	                        var url = new Url(window.location.href);
	                        ParamConverter.convertParamToQuery(name, value, url.hash);
	                        window.location.hash = url.getHash();
	                    }
	                }
	
	                function subscribe(parent) {
	                    parent.paramChange(paramChangeHandler);
	                    if (parent.children.length) {
	                        _.each(parent.children, function (child) {
	                            subscribe(child);
	                        });
	                    }
	                }
	
	                subscribe(scope);
	            },
	
	            /**
	             * Enables HTML5 browser history for the given scope and changes within that scope
	             * As browser fallback, page reload will be triggered
	             * @param scope
	             * @param options On object of options
	             *
	             * Example options:
	             * {
	             *      // An object of parameters and URLs. On scopechange of theses parameters, the Base URL changes to
	             *      // the given URL
	             *      'scopeParamUrls': {
	             *          'GlobalNames': '/de/package/destination'
	             *      }
	             * }
	             *
	             */
	            enableBrowserHistory: function(scope, options){
	                var options = options || {};
	                var scopeParamUrls = options.scopeParamUrls || {};
	                var previousParams = scope.getParams() || {};
	
	                $( window ).bind( 'popstate', function(event){
	                    // Load last page if the state is not empty
	                    if (null !== event.originalEvent.state) {
	                        scope.setParams(event.originalEvent.state);
	                    }
	                });
	                var paramChangeHandler = function(event){
	                    // Ignore scope changes on certain actions to avoid multiple page reloads and recursion
	                    if (event.eventSource == 'setParams' ||
	                        event.eventSource == 'setParam'){
	                        return;
	                    }
	
	                    // Get base URL
	                    var baseUrl = '?';
	                    $.each(scopeParamUrls, function(name, newUrl){
	                        // Check if this parameter has special baseUrl
	                        if (JSON.stringify(previousParams[name]) != JSON.stringify(scope.getParam(name))){
	                            baseUrl = newUrl + '?';
	                        }
	                    });
	
	                    // If history is available in browser
	                    if (history.pushState){
	                        history.pushState(scope.getParams(), '', baseUrl + $.param(scope.getQuery()));
	                    } else {
	                        // Old browser fallback, trigger page reload
	                        window.location.href = baseUrl + $.param(scope.getQuery());
	                    }
	
	                    // Update previous params
	                    previousParams = scope.getParams();
	                };
	                if (history.replaceState){
	                    history.replaceState(scope.getParams(), '', window.location.href);
	                }
	                scope.change(paramChangeHandler);
	            }
	        }
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(17);
	var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
	module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};


/***/ }),
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(3), __webpack_require__(232), __webpack_require__(2), __webpack_require__(69), __webpack_require__(14)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, _, CountButton, Object, ParamConverter, Url) {
	
	    var CountButtonExtended = function CountButtonExtended(requestHandler, scope, element, options) {
	        // Call Constructor of parent class
	        CountButton.apply(this, [element, options]);
	
	        // Save local variables
	        this.requestHandler = requestHandler;
	        this.scope = scope;
	
	        // Override Link-Text element
	        this.linkText = $('[data-fcse-role="countbutton--text"]');
	
	        // Set Link-Counter element
	        this.linkCounter = $('[data-fcse-role="countbutton--counter"]');
	        this.updateUrl(ParamConverter.toQuery(scope.params));
	
	        // Initialize events
	        this._initEventHandling();
	    };
	
	    CountButtonExtended.prototype = $.extend(Object.create(CountButton.prototype), {
	        /**
	         * Initializes event handling
	         * @private
	         */
	        _initEventHandling: function _initEventHandling() {
	            // Register scope change handler
	            this.scope.change($.proxy(this._onScopeChange, this));
	
	            // Register requestHandler
	            this.requestHandler.on('success', $.proxy(this._onUpdateSuccess, this));
	            this.requestHandler.on('error', $.proxy(this._onUpdateError, this));
	        },
	
	        /**
	         * Override RegisterClickHandler
	         * 
	         * @private
	         */
	        _registerClickHandler: function _registerClickHandler() {
	            this.link.on('click', $.proxy(this._buttonClickHandler, this));
	        },
	
	        /**
	         * Override RegisterClickHandler
	         * 
	         * @private
	         */
	        setCountText: function setCountText(count) {
	            if (_.isUndefined(count)) {
	                count = 0;
	            }
	
	            // Update count
	            this.count = count;
	
	            // Set Link Text
	            var text;
	            if (count === 1) {
	                text = this.labels.singularPattern;
	            } else {
	                text = this.labels.pluralPattern;
	            }
	            this.linkText.text(text);
	
	            // Update Counter
	            this.linkCounter.text(count);
	
	            // Remove loading
	            this.unsetLoading();
	            // Toggles enabled/disabled state based on the new value of this.count
	            this.toggleEnabled();
	        },
	
	        /**
	         * Unset loading
	         * 
	         * @public
	         */
	        unsetLoading: function unsetLoading() {
	            // Remove Class
	            this.link.removeClass("is-loading").children().removeClass('is-hidden');
	        },
	
	        /**
	         * Override SetLoading
	         * 
	         * @public
	         */
	        setLoading: function setLoading() {
	            // Add Class
	            this.link.addClass("is-loading").children().addClass('is-hidden');
	        },
	
	        updateUrl: function updateUrl(params) {
	            var routeParams = {};
	            var queryParams = params;
	
	            // Change the link on button.
	            var url = new Url(this.link.attr("href"));
	            var scrollToOffers = url.query.sto;
	            url.query = queryParams;
	            if (scrollToOffers) {
	                url.query.sto = scrollToOffers;
	            }
	            url.hash = {};
	            this.link.attr("href", url.toString());
	            this.toggleEnabled();
	        },
	
	        /**
	         * Button Click Handler
	         * 
	         * @param event
	         * @private
	         */
	        _buttonClickHandler: function _buttonClickHandler(event) {
	            if (this.count == 0) {
	                event.preventDefault();
	            } else {
	                var url = $(event.currentTarget).attr('href');
	
	                if (_.isFunction(this.options.queryUpdater)) {
	                    var urlObj = new Url($(event.currentTarget).attr('href'));
	                    urlObj.query = this.options.queryUpdater(urlObj.query);
	                    url = urlObj.toString();
	                }
	
	                window.location.href = url;
	            }
	        },
	
	        /**
	         * Handler for update loading success
	         * @param event
	         * @param data
	         * @private
	         */
	        _onUpdateSuccess: function _onUpdateSuccess(response, data) {
	            // Check if ajax response is from updateRoute
	            if (data.route !== this.options.updateRoute) {
	                return;
	            }
	
	            this.setCountText(response.html);
	        },
	
	        /**
	         * Handler for update loading error
	         * @param event
	         * @private
	         */
	        _onUpdateError: function _onUpdateError(event) {
	            console.log('Error handling');
	        },
	
	        /**
	         * Scope change handler
	         * @param event
	         * @private
	         */
	        _onScopeChange: function _onScopeChange(scope, params) {
	            // Set loading state
	            this.setLoading();
	
	            // Update Button
	            this.requestHandler.cancel(this.options.updateRoute);
	            this.requestHandler.send(this.options.updateRoute, this.scope.getQuery());
	
	            // Update Button URL
	            this.updateUrl(ParamConverter.toQuery(params));
	        }
	    });
	
	    return CountButtonExtended;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1),
	    __webpack_require__(233),
	    __webpack_require__(14)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function($, Request, Url) {
	        
	        var CountButton = function (element, options) {
	            this.element = $(element);
	            this.count = 1;
	            this.options = options;
	            this.request = new Request();
	            this.link = this.element;
	            this.linkText = this.element;
	            this.labels = {
	                singularPattern: this.element.data("singular-pattern"),
	                pluralPattern: this.element.data("plural-pattern")
	            };
	            this._registerClickHandler();
	        };
	        
	        CountButton.prototype = {
	            /**
	             * Register clickhandler to prevent click when 0 results
	             * @returns {undefined}
	             */
	            _registerClickHandler : function() {
	                var self = this;
	                this.link.click(function(event){
	                    if (self.count == 0){
	                        event.preventDefault();
	                    }
	                });
	            },
	            setCountText: function (count) {
	                var text;
	                this.count = count;
	                if (count === 1) {
	                    text = this.labels.singularPattern.replace("{1}", count);
	                }
	                else {
	                    text = this.labels.pluralPattern.replace("{1}", count);
	                }
	                this.linkText.removeClass("is-loading");
	                this.linkText.text(text);
	            },
	            updateUrl: function (params) {
	                var routeParams = { };
	                var queryParams = params;
	            
	                // Change the link on button.
	                var url = new Url(this.link.attr("href"));
	                url.query = queryParams;
	                url.hash = { };
	                this.link.attr("href", url.toString());
	                this.toggleEnabled();
	            },
	            setLoading: function () {
	                this.linkText.text("");
	                this.linkText.addClass("is-loading");
	            },
	            toggleEnabled: function () {
	                if (this.count > 0){
	                    this.element.removeClass("is-disabled");
	                } else {
	                    this.element.addClass("is-disabled");
	                }
	            }
	        };
	        
	        return CountButton;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * • FCSE Travelsearch Sandbox 2013 •
	 * 
	 * © Copyright 2013, Tom Hülser [freshcells systems engineering GmbH]
	 * 
	 * 
	 */
	
	/**
	 * Generic request handler. Handles:
	 * 1. Ajax requests
	 * 2. Errors
	 * 3. Ajax cancelling
	 *
	 * @author Hermann Bier, bier@freshcells.de
	 */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(86), __webpack_require__(3), __webpack_require__(14), __webpack_require__(72), __webpack_require__(68), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Log, _, Url, Routing, RoutingData, _) {
	    /**
	     * Request constructor
	     */
	    var Request = function (config) {
	        if ($.isPlainObject(config)) {
	            this.setup(config);
	        }
	        var url = new Url();
	        this.locale = url.getLocale();
	    };
	
	    Request.prototype = (function () {
	        /*
	         * Private scope
	         */
	        var config = {};
	        var log = new Log();
	        var syncNodeSet = []; // dom nodes to synchronize requests
	        var syncRouteSet = {}; // routes to sync requests
	
	        /**
	         * Checks whether request properly set up
	         */
	        function checkConfig(config) {
	            // check whether all routes exist
	            _.each(_.keys(config), function (route) {
	                // Routing.getRoute throws exception if route is not found
	                Routing.getRoute(route);
	            });
	        }
	
	
	        /**
	         * Called on ajax done
	         * Note: It is possible to have ajax calls without callback at all.
	         */
	        function ajaxDone(route, callback, response, status, jqXHR) {
	            if (typeof callback != 'function') { // if now callback give move the params
	                jqXHR = status;
	                status = response;
	                response = callback;
	            }
	
	            // we can get json or html
	            if (_.isObject(response)) {
	                if (_.has(response, 'error') && response.error !== false) {
	                    log.error('Route: ' + route + ' returned an error', response.error);
	
	                    if (_.has(config[route], 'errorHandler')) {
	                        config[route].errorHandler(response.error);
	                    }
	                }
	                else {
	                    if (typeof callback == 'function') {
	                        callback(response, status, jqXHR);
	                    }
	                    if (_.has(config[route], 'callback')) {
	                        config[route].callback(response, status, jqXHR);
	                    }
	                }
	            } else {
	                callback(response);
	            }
	        }
	
	        /**
	         * Creates new route config if not already
	         */
	        function createRouteConfig(route) {
	            if (!_.has(config, route)) {
	                config[route] = {};
	            }
	        }
	
	        /**
	         * Handle cancelling. There are two ways of cancelling an ajax request:
	         * 1. syncNode: ajax requests are synchronized on a dom element. In the first case syncNode is the same node.
	         * Previous call is cancelled if second call comes in with same syncNode. In the second case first syncNode is
	         * ancestor of seconds call syncNode, so the call for childSyncNode is cancelled.
	         * 2. synchronisation is done on route names. If a call for route say 'booking.check' is there second call for this
	         * route will cancel the first one and so on.
	         *
	         */
	        function processCancelling(route, jqXHR, sync, parentCancel) {
	            if (typeof sync != 'string') {// sync on nodes
	                var syncNode = sync;
	                syncNode = $(syncNode);
	                // get previous request
	                if (!parentCancel && syncNode.data('request') && syncNode.data('request').readyState != 4) {
	                    log.debug('Aborting request for syncNode: ', syncNode);
	                    syncNode.data('request').abort();
	                }
	
	                // look whether there are children syncnodes
	                _.each(syncNodeSet, function (node) {
	                    node = $(node); // node is not jquery wrapped
	                    if (syncNode.has(node).length > 0 && node.data('request').readyState != 4) {
	                        log.debug('Aborting child syncNode request for: ', syncNode, node);
	                        node.data('request').abort();
	                    }
	                });
	
	                syncNode.data('request', jqXHR);
	                if (_.indexOf(syncNodeSet, syncNode[0]) < 0) {
	                    syncNodeSet.push(syncNode[0]);
	                }
	            }
	            else if (sync == 'abort') {// sync on routes
	                if (_.has(syncRouteSet, route) && syncRouteSet[route].readyState != 4) {
	                    log.debug('Aborting request for route: ' + route);
	                    syncRouteSet[route].abort();
	                }
	                syncRouteSet[route] = jqXHR;
	            }
	        }
	
	
	        /*
	         * Public scope
	         */
	        return {
	            constructor: Request,
	            /**
	             * Setup of request
	             */
	            setup: function (inputConfig) {
	                config = inputConfig;
	                checkConfig(config);
	                _.each(config, function (routeConfig) {
	                    // error handlers
	                    var errorHandler = routeConfig.errorHandler;
	                    if (typeof errorHandler == 'string') {// error handler of other route is given
	                        errorHandler = _.getProperty(config, routeConfig.errorHandler).errorHandler;
	                    }
	                    routeConfig.errorHanlder = errorHandler;
	
	                    // callbacks
	                    var callback = routeConfig.callback;
	                    if (typeof callback == 'string') {// callback of other route given
	                        callback = _.getProperty(config, routeConfig.callback).callback;
	                    }
	                    if (_.has(routeConfig, 'callback')) {
	                        routeConfig.callback = callback;
	                    }
	                });
	            },
	
	
	            /**
	             * Set error handler for route
	             */
	            setErrorHandler: function (route, handler) {
	                createRouteConfig(route);
	                config[route].errorHandler = handler;
	            },
	
	            /**
	             * Set callback for route
	             */
	            setCallback: function (route, callback) {
	                createRouteConfig(route);
	                config[route].callback = callback;
	            },
	
	            /**
	             * Set ajax call params. For ex. type, dataType
	             * Function has two modes
	             */
	            setAjaxParams: function (route, key, value) {
	                createRouteConfig(route);
	                if (_.isObject(key)) {
	                    config[route].ajaxParams = key;
	                }
	                else {
	                    if (!_.has(config[route], 'ajaxParams')) {
	                        config[route].ajaxParams = {};
	                    }
	                    config[route].ajaxParams[key] = value;
	                }
	            },
	
	            /**
	             * Returns boolean whether a request for a route is done or running.
	             * @param {string} route Route key to check the status for.
	             * @return boolean
	             */
	            isRunning: function (route) {
	                return _.has(syncRouteSet, route) && syncRouteSet[route].readyState != 4;
	            },
	
	            /**
	             * Makes ajax call.
	             * Function call:
	             * send(route, [callback], routeParams, queryParams, sync);
	             *
	             * type of sync is ['prevent', 'abort'] | DomNode
	             *
	             * callback is optional. If not set as argument, it should be set per setup() or setCallback() before.
	             *
	             * @param {string} route Route key, for ex. booking.check
	             * @param {function} complete Optional callback function, executed on ajax complete
	             * @param {object} routeParams Route params. Placeholder in route will be replaced. Set null if nothing to replace
	             * @param {object} queryParams Parameters sent to server
	             * @param {string} cancel Cancelling method.
	             *                  'prevent': no further call made until previous one ends.
	             *                  'abort': each previous call is aborted.
	             *                  syncNode: synchronisation among dom node.
	             * @param {boolean} parentCancel Restrict canceling only by parent syncnode.
	             *                  e.g. when you want to allow multiple parallel calls in a nested component
	             *                  and at the same time should abort these calls when parent abort and starts new call.
	             * @return void
	             */
	            send: function (route, complete, routeParams, queryParams, cancel, parentCancel) {
	
	                createRouteConfig(route);
	
	                // prevent
	                if (cancel == 'prevent' && this.isRunning(route)) {
	                    log.debug('Prevent request for route: ' + route);
	                    return;
	                }
	
	                // care about optional callback argument
	                if (typeof complete != 'function') {// without callback
	                    cancel = queryParams;
	                    queryParams = routeParams;
	                    routeParams = complete;
	                }
	                routeParams = routeParams || {};
	                routeParams["_locale"] = this.locale;
	
	                // Generating URL for route.
	                // Routing adds unused query parameters to query string, we don't want that, so we remove those
	                var url = Routing.generate(route, routeParams).replace(/\?.+/, "");
	
	                // prepare ajax
	                var ajaxParams = {
	                    url: url,
	                    data: queryParams,
	                    cache: false
	                };
	
	                if (_.has(config[route], 'ajaxParams')) {
	                    ajaxParams = $.extend(true, ajaxParams, config[route].ajaxParams);
	                }
	
	                var jqXHR = $.ajax(ajaxParams).done(function (response, status, jqXHR) {
	                    if (typeof complete != 'function') { // use callback from config
	                        ajaxDone(route, response, status, jqXHR);
	                    }
	                    else { // use given callback
	                        ajaxDone(route, complete, response, status, jqXHR);
	                    }
	                }).fail(function (jqXHR, status, response) {
	                        log.error('Route: ' + route + ' HTTP error occurred. Status: ' + jqXHR.status + ' Text: ' + jqXHR.statusText);
	                        if (_.has(config[route], 'errorHandler')) {
	                            config[route].errorHandler('responseFail', jqXHR, status, response);
	                        }
	                    });
	
	                // save request
	                // in case of 'abort' cancelling there is an own technic
	                if (cancel != 'abort') {
	                    syncRouteSet[route] = jqXHR;
	                }
	
	                // ajax cancelling
	                if (cancel || config[route].cancelling) {
	                    processCancelling(route, jqXHR, cancel, parentCancel);
	                }
	            }
	        };
	    })();
	
	    return Request;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Base map is a copy of Gitlab map component
	 * Created by Pavel Kozhin on 13/05/16.
	 */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(3), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, _, Object) {
	
	  /**
	   * Constructor for MapPoint.
	   *
	   * This entity is used to encapsulate data related to the
	   * point on a map including marker and geo coordinates.
	   *
	   * The important thing is to get 'mapPoints' array via options
	   * to be able to render markers and have map properly positioned.
	   * The single map point is an object which has 2 mandatory fields:
	   * 'lat' (latitude) and 'lon' (longitude).
	   *
	   * @param data
	   * @constructor
	   */
	  var MapPoint = function MapPoint(data) {
	    if (!(data.lat && data.lon && parseFloat(data.lat) !== NaN && parseFloat(data.lon) !== NaN)) {
	      throw new Error("MapPoint coordinates are invalid.");
	    }
	    this.marker = null;
	    this.latlng = new google.maps.LatLng(parseFloat(data.lat), parseFloat(data.lon));
	  };
	
	  /**
	   * Constructor of Map component.
	   *
	   * @param element An jQuery selector.
	   * @param options An options for initialization.
	   * @constructor
	   */
	  var Map = function Map(element, options) {
	    if (!(element instanceof $ && element.length)) {
	      throw new Error("Map parameters are malformed.");
	    }
	    if (!(google && google.maps)) {
	      throw new Error("GoogleMaps API is not available.");
	    }
	
	    var defaultOptions = {
	      'mapOptions': {
	        'zoom': 11,
	        'panControl': false,
	        'zoomControl': true,
	        'zoomControlOptions': { style: google.maps.ZoomControlStyle.SMALL },
	        'mapTypeControl': true,
	        'scaleControl': false,
	        'streetViewControl': false,
	        'overviewMapControl': true,
	        'overviewMapControlOptions': { opened: true },
	        'rotateControl': false,
	        'mapTypeId': google.maps.MapTypeId.ROADMAP
	      },
	      /* Should be an array of objects with geo coordinates
	       e.g. {lat:123456, lon:123456} */
	      mapPoints: [],
	      pinchZoomDisabled: false
	    };
	
	    this.isCreated = false;
	
	    this._map = null;
	    this._mapElement = null;
	    this._element = element;
	    this._options = $.extend({}, defaultOptions, options || {});
	
	    this._init();
	  };
	
	  Map.prototype = {
	    /**
	     * Create a GoogleMap instance.
	     */
	    create: function create() {
	      var bounds,
	          mapOptions = this._options.mapOptions;
	
	      if (!this._map) {
	        this._map = new google.maps.Map(this._mapElement.get(0), mapOptions);
	        bounds = new google.maps.LatLngBounds();
	
	        _.each(this._mapPoints, function (mapPoint) {
	          bounds.extend(mapPoint.latlng);
	        });
	
	        this._applyMapBounds(bounds);
	        this._updateMarkers(this._mapPoints);
	        this.isCreated = true;
	      }
	    },
	
	    /**
	     * This method updates map with new map points raw data.
	     *
	     * @param {array} items An array of map points data,
	     *      map points should have at lest 'lat' and 'lon'
	     *      properties indicating geo location coordinates.
	     */
	    update: function update(items) {
	      if (!this._map) {
	        throw new Error("Map should be created. Use create() method first.");
	      }
	      var newMapPoints = this._createMapPoints(items);
	
	      this._updateMarkers(newMapPoints);
	      this._mapPoints = newMapPoints;
	    },
	
	    /**
	     * Initializes map component
	     * @private
	     */
	    _init: function _init() {
	      this._mapElement = this._element;
	      this._mapPoints = this._createMapPoints(this._options.mapPoints);
	
	      // Disable pinch zoom on map element
	      if (this._options.pinchZoomDisabled) {
	        $(this._mapElement)[0].addEventListener('touchmove', this._preventPinchZoom, true);
	      }
	    },
	
	    /**
	     * Prevents a pinch zoom event
	     * @param jQuery.Event
	     * @returns {boolean}
	     * @private
	     */
	    _preventPinchZoom: function _preventPinchZoom(e) {
	      if (e.touches.length > 1) {
	        e.preventDefault();
	      }
	
	      return false;
	    },
	
	    /**
	     * This method removes old markers and create the new ones
	     * (if passed).
	     *
	     * @param {array} mapPoints An array of MapPoint instances.
	     * @private
	     */
	    _updateMarkers: function _updateMarkers(mapPoints) {
	      if (!this._map) {
	        return;
	      }
	
	      var self = this;
	
	      _.each(this._mapPoints, function (mapPoint) {
	        if (mapPoint.marker) {
	          mapPoint.marker.setMap(null);
	        }
	      });
	
	      if (mapPoints) {
	        _.each(mapPoints, function (mapPoint) {
	          mapPoint.marker = new google.maps.Marker({
	            position: mapPoint.latlng,
	            map: self._map
	          });
	        });
	      }
	    },
	
	    /**
	     * This method converts map points raw data to MapPoint
	     * internal instances.
	     *
	     * @private
	     * @param {array} items An array of map points data,
	     *      map points should have at lest 'lat' and 'lon'
	     *      properties indicating geo location coordinates.
	     * @return {array} An array of MapPoint instances
	     *      or empty array.
	     */
	    _createMapPoints: function _createMapPoints(items) {
	      var result = [],
	          self = this;
	
	      if (_.isArray(items)) {
	        _.each(items, function (item) {
	          result.push(new MapPoint(item));
	        });
	      }
	      return result;
	    },
	
	    /**
	     * This method applies bounds, centering and zoom to
	     * the GoogleMap instance.
	     *
	     * @private
	     * @param {google.maps.LatLngBounds} bounds
	     */
	    _applyMapBounds: function _applyMapBounds(bounds) {
	      if (!this._map) {
	        return;
	      }
	
	      var center = bounds.getCenter(),
	          c = 0.1,
	          sw = new google.maps.LatLng(center.lat() + c, center.lng() - c),
	          ne = new google.maps.LatLng(center.lat() - c, center.lng() + c);
	
	      bounds.extend(sw);
	      bounds.extend(ne);
	
	      this._map.setCenter(bounds.getCenter());
	      this._map.setZoom(this._options.mapOptions.zoom);
	      this._map.fitBounds(bounds);
	    }
	  };
	
	  return Map;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	}();

	;

/***/ }),
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _stringify = __webpack_require__(216);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by pavelkozhin on 14/03/16.
	 */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(3), __webpack_require__(9), __webpack_require__(239), __webpack_require__(2), __webpack_require__(11)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, _, OptionsMixin, Map, Object, EventDispatcher) {
	    /**
	     * // TODO: Refactor
	     * MapComponent component
	     * @param element
	     * @param requestHandler
	     * @param options
	     * @constructor
	     */
	    var MapComponent = function MapComponent(element, requestHandler, options) {
	        element = $(element);
	
	        if (!element.length) {
	            return;
	        }
	
	        // Set default options
	        var defaultOptions = {
	            placeDetailsRoute: 'allt_frontend.map.place_details',
	            placesRoute: 'allt_frontend.map.places',
	            mapOpenButtonSelector: '[data-fcse-role="map-overlay-open-button"]',
	            mapContainerSelector: '[data-fcse-role="accordion-region-map-container"]',
	            productSearch: element.attr('product-search'),
	            loadingClass: 'is-loading',
	            detailInfoBoxFactory: null,
	            placeMarkerImage: '/bundles/alltfrontend/img/hotel-marker-blue.png',
	            placeActiveMarkerImage: '/bundles/alltfrontend/img/hotel-marker-red.png'
	        };
	
	        this.addOptions(defaultOptions, options);
	
	        this._uid = Math.round(Math.random() * new Date().getTime());
	        this._detailsInfoBox = null;
	        this._tooltipInfoBox = null;
	        this._loadingInfoBoxContent = $('<div class="map--info-box--content is-loading"></div>').get(0);
	        this._requestHandler = requestHandler;
	        this._markerIndex = 1;
	        this._productSearch = null;
	        this._activePlaceId = null;
	        this._isLoading = false;
	
	        Map.apply(this, [element, this.getOptions()]);
	        EventDispatcher.apply(this, arguments);
	
	        this.registerEvent("mapCreated");
	    };
	
	    MapComponent.prototype = $.extend(Object.create(OptionsMixin), Object.create(Map.prototype), Object.create(EventDispatcher.prototype), {
	        /**
	         * Return Google map instance
	         * @returns {null|*}
	         */
	        getMap: function getMap() {
	            return this._map;
	        },
	
	        /**
	         * Adds/removes loading indicator
	         * @param isLoading
	         */
	        setIsLoading: function setIsLoading(isLoading) {
	            if (!this._element) {
	                return;
	            }
	            this._isLoading = isLoading;
	            if (isLoading) {
	                this._element.addClass(this.option('loadingClass'));
	            } else {
	                this._element.removeClass(this.option('loadingClass'));
	            }
	        },
	
	        /**
	         * Loads places to render markers
	         * @param productSearch
	         */
	        loadMarkers: function loadMarkers(productSearch, activePlaceId) {
	            var options = { method: 'POST' };
	            var gBounds = null;
	            var params = {
	                token: this._uid,
	                productSearch: productSearch
	            };
	            this._productSearch = productSearch;
	            this._activePlaceId = activePlaceId;
	
	            if (_.isArray(this._mapPoints)) {
	                var excludeIds = _.map(this._mapPoints, function (mapPoint) {
	                    return mapPoint.data.id;
	                });
	                if (excludeIds.length) {
	                    params['excludeIds'] = excludeIds.join(',');
	                }
	            }
	            gBounds = this._map.getBounds();
	
	            var left = gBounds.getSouthWest().lat();
	            var right = gBounds.getNorthEast().lat();
	            var top = gBounds.getSouthWest().lng();
	            var bottom = gBounds.getNorthEast().lng();
	
	            params['geoPolygon'] = '0,' + left + ',' + top + ';' + '1,' + right + ',' + top + ';' + '2,' + right + ',' + bottom + ';' + '3,' + left + ',' + bottom;
	
	            this.setIsLoading(true);
	            this._requestHandler.send(this.option('placesRoute'), params, {}, options);
	        },
	
	        /**
	         * Removes current markers
	         */
	        removeMarkers: function removeMarkers() {
	            this._updateMarkers(null);
	        },
	
	        /**
	         * Initializes map component
	         * @private
	         */
	        _init: function _init() {
	            var self = this;
	
	            this._requestHandler.on('success', $.proxy(this._onLoadContentSuccess, this));
	            this._requestHandler.on('error', $.proxy(this._onLoadContentError, this));
	
	            this._mapElement = $(this.option('mapContainerSelector'), this._element);
	            this._mapPoints = this._createMapPoints(this._options.mapPoints);
	
	            var loadingCaptureProxyHandler = $.proxy(this._loadingCaptureClickHandler, this);
	            this._element.get(0).addEventListener('click', loadingCaptureProxyHandler, true);
	
	            // Disable pinch zoom on map element
	            if (this._options.pinchZoomDisabled) {
	                $(this._mapElement)[0].addEventListener('touchmove', this._preventPinchZoom, true);
	            }
	        },
	
	        /**
	         * Creates google map, updates map viewport
	         * @param {Object} bounds
	         * @param {Array} locations
	         * @param {Object} center
	         * @param {Number} zoom
	         */
	        create: function create(bounds, locations, center, zoom) {
	            if (!this.isCreated) {
	                this._map = new google.maps.Map(this._mapElement.get(0), this._options.mapOptions);
	                this._map.setOptions({
	                    mapTypeControlOptions: {
	                        style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
	                        position: google.maps.ControlPosition.RIGHT_TOP
	                    }
	                });
	                this.isCreated = true;
	                this.dispatchEvent('mapCreated');
	            }
	
	            if (bounds) {
	                var sw = new google.maps.LatLng(bounds.southwest);
	                var ne = new google.maps.LatLng(bounds.northeast);
	                var gBounds = new google.maps.LatLngBounds(sw, ne);
	                this._applyMapBounds(gBounds);
	            } else if (locations) {
	                var gBounds = new google.maps.LatLngBounds();
	                _.each(locations, function (location) {
	                    gBounds.extend(new google.maps.LatLng(location.latitude, location.longitude));
	                });
	                this._applyMapBounds(gBounds);
	            } else if (center) {
	                this._map.setCenter(new google.maps.LatLng(parseFloat(center.lat), parseFloat(center.lng)));
	                this._map.setZoom(zoom || this._options.mapOptions.zoom);
	            }
	        },
	
	        /**
	         * Converts data to MapPoints
	         * @param items
	         * @returns {*|array}
	         * @private
	         */
	        _createMapPoints: function _createMapPoints(items) {
	            var points = Map.prototype._createMapPoints.call(this, items);
	
	            if (_.isArray(points)) {
	                _.each(points, function (item, index) {
	                    points[index].data = items[index];
	                });
	            }
	            return points;
	        },
	
	        /**
	         * Creates detail InfoBox (marker on click info)
	         * @returns {window.InfoBox}
	         * @private
	         */
	        _createDetailsInfoBox: function _createDetailsInfoBox() {
	            var options = {
	                content: this._loadingInfoBoxContent,
	                disableAutoPan: false,
	                maxWidth: 250,
	                /*pixelOffset: new window.google.maps.Size(-125, -140),*/
	                alignBottom: true,
	                zIndex: 1001,
	                boxClass: 'map--info-box',
	                /*closeBoxMargin: "12px 4px 2px 2px",*/
	                closeBoxURL: "http://www.google.com/intl/en_us/mapfiles/close.gif",
	                infoBoxClearance: new window.google.maps.Size(5, 5)
	            };
	            var factory = this.option('detailInfoBoxFactory');
	            if (_.isFunction(factory)) {
	                return factory(options);
	            }
	            return new window.InfoBox(options);
	        },
	
	        /**
	         * Creates InfoBox for tooltip
	         * @param Tooltip
	         * @returns {*}
	         * @private
	         */
	        _createTooltipInfoBox: function _createTooltipInfoBox(Tooltip) {
	            var options = {
	                content: '',
	                markerOffsetTop: 45,
	                disableAutoPan: true,
	                maxWidth: 200,
	                zIndex: 1000,
	                boxClass: 'map--info-box--tooltip',
	                /*closeBoxMargin: "12px 4px 2px 2px",*/
	                closeBoxURL: " ",
	                infoBoxClearance: new window.google.maps.Size(0, 0)
	            };
	            if (_.isFunction(Tooltip)) {
	                return new Tooltip(options);
	            }
	            return new window.InfoBox(options);
	        },
	
	        /**
	         * Returns rendered tooltip content
	         * @param mapPoint
	         * @returns {HTMLElement}
	         * @private
	         */
	        _getTooltipContent: function _getTooltipContent(mapPoint) {
	            // TODO: Improve
	            var tooltip = $(this._tooltipTemplate);
	            if (new RegExp(/\+/).test(mapPoint.category)) {
	                mapPoint.category = mapPoint.category.replace(/\+/, '.5');
	            }
	            var categoryParts = String(mapPoint.category).split('.');
	            var categoryHtml = '';
	            var duration;
	            var priceLocaleParts;
	            if (categoryParts[0]) {
	                for (var i = 0; i < categoryParts[0]; i++) {
	                    categoryHtml += '<li class="hotel-rating-item">' + '<i class="icon icon-rating-sun icon-large"></i></li>';
	                }
	                if (categoryParts[1]) {
	                    categoryHtml += '<li class="hotel-rating-item half">' + '<i class="icon icon-rating-sun-o icon-large half"></i></li>';
	                }
	            }
	
	            duration = mapPoint.duration + ' ' + (parseInt(mapPoint.duration) > 1 ? tooltip.attr('data-days-trans') : tooltip.attr('data-day-trans'));
	
	            if (mapPoint.priceLocale) {
	                priceLocaleParts = mapPoint.priceLocale.split(' ');
	            }
	
	            var content = this._tooltipTemplate.replace('@name', mapPoint.name).replace('@category', categoryHtml).replace('@board', mapPoint.board).replace('@price', Math.round(parseFloat(mapPoint.price))).replace('@duration', duration).replace('@recommendation', mapPoint.recommendation).replace('@recommendation', mapPoint.recommendation);
	
	            if (priceLocaleParts) {
	                content = content.replace('@locale_price', priceLocaleParts[0]).replace('@locale_currency', priceLocaleParts[1]);
	            }
	
	            return $(content).get(0);
	        },
	
	        /**
	         * Adds and inits markers
	         * @param mapPoints
	         * @private
	         */
	        _updateMarkers: function _updateMarkers(mapPoints) {
	            this._markerIndex = 1;
	
	            if (this._detailsInfoBox) {
	                this._detailsInfoBox.close();
	            }
	            if (this._tooltipInfoBox) {
	                this._tooltipInfoBox.close();
	            }
	
	            // Releasing event listeners
	            _.each(this._mapPoints, function (mapPoint) {
	                if (mapPoint.marker) {
	                    window.google.maps.event.clearInstanceListeners(mapPoint.marker);
	                }
	            });
	            Map.prototype._updateMarkers.call(this, mapPoints);
	
	            if (!(mapPoints && mapPoints.length)) {
	                this._mapPoints = [];
	                return;
	            }
	
	            this._initMapPoints(mapPoints);
	        },
	
	        /**
	         * Appends markers to the map
	         * @param places
	         * @private
	         */
	        _appendMapPoints: function _appendMapPoints(places) {
	            var self = this;
	            var mapPoints = this._createMapPoints(places || []);
	
	            if (_.isArray(mapPoints)) {
	                var image = this.option('placeMarkerImage');
	                var activeImage = this.option('placeActiveMarkerImage');
	                _.each(mapPoints, function (mapPoint) {
	                    var isActive = mapPoint.data.id == self._activePlaceId;
	                    var icon = isActive ? activeImage : image;
	                    mapPoint.marker = new google.maps.Marker({
	                        position: mapPoint.latlng,
	                        map: self._map,
	                        animation: google.maps.Animation.DROP,
	                        icon: icon
	                    });
	                });
	                this._initMapPoints(mapPoints);
	            }
	            this._mapPoints = _.union(this._mapPoints, mapPoints);
	        },
	
	        /**
	         * Inits markers functionality, e.g. on hover handlers
	         * @param mapPoints
	         * @private
	         */
	        _initMapPoints: function _initMapPoints(mapPoints) {
	            var self = this;
	
	            _.each(mapPoints, function (mapPoint, index) {
	                var isActive = mapPoint.data.id == self._activePlaceId;
	                var clickHandler = function clickHandler() {
	                    self._detailsInfoBox.open(self._map, this);
	                    self._loadInfoBoxContent(mapPoint);
	                };
	                var mouseOverHandler = function mouseOverHandler() {
	                    this.setOptions({ zIndex: self._markerIndex + 1 });
	                    self._tooltipInfoBox.setContent(self._getTooltipContent(mapPoint.data));
	                    self._tooltipInfoBox.open(self._map, this);
	                };
	                var mouseOutHandler = function mouseOutHandler() {
	                    self._tooltipInfoBox.close();
	                };
	                var zIndex = isActive ? 1000 : self._markerIndex++;
	
	                mapPoint.marker.setOptions({ zIndex: zIndex });
	
	                window.google.maps.event.addListener(mapPoint.marker, 'click', clickHandler);
	                window.google.maps.event.addListener(mapPoint.marker, 'mouseover', mouseOverHandler);
	                window.google.maps.event.addListener(mapPoint.marker, 'mouseout', mouseOutHandler);
	            });
	        },
	
	        /**
	         *
	         * @param event
	         * @param requestData
	         * @private
	         */
	        _onLoadContentSuccess: function _onLoadContentSuccess(event, requestData) {
	            if (event.state !== 'OK' || requestData.queryParams.token !== this._uid) {
	                return;
	            }
	            var self = this;
	            if (requestData.route === this.option('placesRoute')) {
	                __webpack_require__.e/* require */(1, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(324)]; (function (MarkerTooltip) {
	                    if (self.isCreated) {
	                        if (self._tooltipInfoBox) {
	                            self._tooltipInfoBox.close();
	                        }
	                        self._tooltipTemplate = decodeURIComponent(event.meta.tooltipTemplate);
	                        self._tooltipInfoBox = self._createTooltipInfoBox(MarkerTooltip);
	                        self._detailsInfoBox = self._createDetailsInfoBox();
	                    }
	                    self._appendMapPoints(event.meta.places);
	                    self.setIsLoading(false);
	                }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));});
	            } else if (requestData.route === this.option('placeDetailsRoute')) {
	                this._detailsInfoBox.setContent($(event.html).get(0));
	            }
	        },
	
	        /**
	         * Loads detail infobox content
	         * @param mapPoint
	         * @private
	         */
	        _loadInfoBoxContent: function _loadInfoBoxContent(mapPoint) {
	            var options = { method: 'POST' };
	            var params = {
	                token: this._uid,
	                place: (0, _stringify2.default)(mapPoint.data),
	                productSearch: this._productSearch
	            };
	            if (!this.option('detailInfoBoxFactory')) {
	                this._detailsInfoBox.setContent(this._loadingInfoBoxContent);
	            } else {
	                this._detailsInfoBox.setContent(null);
	            }
	
	            this._requestHandler.send(this.option('placeDetailsRoute'), params, {}, options);
	        },
	
	        /**
	         * Ajax error handler
	         * @param requestData
	         * @private
	         */
	        _onLoadContentError: function _onLoadContentError(requestData) {
	            if (requestData.route === this.option('placeDetailsRoute') && requestData.queryParams.token === this._uid) {
	                this._detailsInfoBox.close();
	            }
	        },
	
	        /**
	         * Helps to stop event propagation when loading
	         * @param event
	         * @private
	         */
	        _loadingCaptureClickHandler: function _loadingCaptureClickHandler(event) {
	            if (this._isLoading) {
	                event.preventDefault();
	                event.stopImmediatePropagation();
	            }
	        }
	
	    });
	
	    return MapComponent;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Created by Pavel Kozhin on 18/04/16.
	 */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(3), __webpack_require__(9), __webpack_require__(2), __webpack_require__(254), __webpack_require__(270)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, _, OptionsMixin, Object, Map, DetailOverlay) {
	    /**
	     * MapModal component.
	     * @param {jQuery|String} element
	     * @param {MultiRequestHandler} requestHandler
	     * @param {Object} options
	     * @constructor
	     */
	    var MapModal = function MapModal(element, requestHandler, options) {
	        // Set default options
	        var defaultOptions = {
	            openClass: 'is-open',
	            closedClass: 'is-closed',
	            loadingClass: 'is-loading',
	            contentSelector: '[data-fcse-role="map-modal-content"]',
	            closeBtnSelector: '[data-fcse-role="map-modal-closebtn"]',
	            detailOverlaySelector: '[data-fcse-role="map-modal-detail-overlay"]',
	            preflightRoute: 'allt_frontend.map.places_preflight'
	        };
	        this.addOptions(defaultOptions, options || {});
	        this.element = element;
	        this._map = null;
	        this._requestHandler = requestHandler;
	        this._currentId = null;
	        this._productSearch = null;
	        this._activePlaceId = null;
	
	        this._init();
	    };
	
	    MapModal.prototype = $.extend(Object.create(OptionsMixin), Object.create(Map.prototype), {
	        /**
	         * Opens modal overlay
	         * @param {String} id
	         * @param {String} productSearch
	         * @param {Object} fallbackCenter
	         * @param {String} country
	         * @param {String} activePlaceId
	         */
	        open: function open(id, productSearch, fallbackCenter, country, activePlaceId) {
	            if (!productSearch) {
	                return;
	            }
	            this.element.get(0).style.display = 'block';
	
	            this._productSearch = productSearch;
	            this._activePlaceId = activePlaceId;
	
	            if (this._currentId !== id) {
	                this._currentId = id;
	                this._doPreflightRequest(id, country, fallbackCenter);
	            } else if (this._map) {
	                this._map.loadMarkers(this._productSearch, this._activePlaceId);
	            }
	        },
	
	        /**
	         * Closes the modal overlay
	         */
	        close: function close() {
	            this.element.get(0).style.display = 'none';
	
	            if (this._map) {
	                this._map.removeMarkers();
	            }
	            if (this._map && this._map._detailsInfoBox) {
	                this._map._detailsInfoBox.close();
	            }
	        },
	
	        /**
	         * Initializer
	         * @private
	         */
	        _init: function _init() {
	            this._detailOverlay = new DetailOverlay($(this.option('detailOverlaySelector'), this.element));
	            this._closeBtnElement = $(this.option('closeBtnSelector'), this.element);
	
	            this._closeBtnElement.click($.proxy(this.close, this));
	            this._requestHandler.on('success', $.proxy(this._onPreflightRequestSuccess, this));
	        },
	
	        /**
	         * Creates and inits Map component
	         * @param {Object} bounds
	         * @param {Array} locations
	         * @param {Object} center
	         * @param {Number} zoom
	         * @private
	         */
	        _initMap: function _initMap(bounds, locations, center, zoom) {
	            if (!this._map) {
	                var self = this;
	
	                this._map = new Map(this.element, this._requestHandler, {
	                    placeDetailsRoute: 'allt_frontend.map.place_details',
	                    placesRoute: 'allt_frontend.map.places',
	                    mapContainerSelector: '[data-fcse-role="map-modal-content"]',
	                    detailInfoBoxFactory: function detailInfoBoxFactory() {
	                        return self._detailOverlay;
	                    }
	                });
	                this._map.on('mapCreated', function () {
	                    var debouncer = _.debounce($.proxy(self._onBoundsZoomChanged, self), 1500);
	                    self._map.getMap().addListener('bounds_changed', debouncer);
	                    self._map.getMap().addListener('zoom_changed', debouncer);
	                });
	            }
	            this._map.create(bounds, locations, center, zoom);
	            this._map.removeMarkers();
	        },
	
	        /**
	         * Request initial map bounds
	         * @param {String} destination
	         * @param {String} country
	         * @param {Object} fallbackCenter
	         * @private
	         */
	        _doPreflightRequest: function _doPreflightRequest(destination, country, fallbackCenter) {
	            var options = { method: 'POST' };
	            var params = {
	                destination: destination,
	                country: country,
	                fallback_lat: fallbackCenter.latitude,
	                fallback_lng: fallbackCenter.longitude,
	                productSearch: this._productSearch
	            };
	            if (this._map) {
	                this._map.removeMarkers();
	                this._map.setIsLoading(true);
	            }
	            this._requestHandler.cancel(this.option('preflightRoute'));
	            this._requestHandler.send(this.option('preflightRoute'), params, {}, options);
	        },
	
	        /**
	         * Updates map viewport
	         * @param event
	         * @param requestData
	         * @private
	         */
	        _onPreflightRequestSuccess: function _onPreflightRequestSuccess(event, requestData) {
	            if (event.state !== 'OK') {
	                return;
	            }
	
	            if (requestData.route === this.option('preflightRoute')) {
	                this._initMap(event.meta.bounds, event.meta.locations, event.meta.center);
	            }
	        },
	
	        /**
	         * Loads markers on bounds or zoom change
	         * @private
	         */
	        _onBoundsZoomChanged: function _onBoundsZoomChanged() {
	            this._map.loadMarkers(this._productSearch, this._activePlaceId);
	        }
	    });
	
	    var instance;
	    var getInstance = function getInstance(element, requestHandler, options) {
	        return instance || (instance = new MapModal(element, requestHandler, options));
	    };
	
	    return {
	        getInstance: getInstance
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _stringify = __webpack_require__(216);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(8), __webpack_require__(9), __webpack_require__(86), __webpack_require__(143)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, moment, OptionsMixin, Log) {
	
	    /**
	     * Tracks and stores changed search params for user search
	     * @param options
	     * @constructor
	     */
	    var UserSearchPrefill = function UserSearchPrefill(options) {
	
	        var defaultOptions = {
	            trackedParams: ['departureAirports', 'departureDate', 'returnDate', 'duration', 'travellers', 'groupNames'],
	            arrayParams: ['departureAirports', 'groupNames'],
	            arraySeparator: ';'
	        };
	
	        this.addOptions(defaultOptions, options);
	
	        this._scope = null;
	        this._version = '1';
	    };
	
	    UserSearchPrefill.prototype = $.extend({}, OptionsMixin, {
	        /**
	         * Registers the scope so that scope changes will be tracked
	         *
	         * @param scope
	         */
	        registerScope: function registerScope(scope) {
	            this._scope = scope;
	            scope.change($.proxy(this._onScopeChange, this));
	        },
	
	        /**
	         * Scope change handler
	         *
	         * @param scope
	         * @param params
	         * @private
	         */
	        _onScopeChange: function _onScopeChange(scope, params) {
	            var self = this;
	            var paramsToTrack = [];
	
	            $.each(scope.changedParams, function (idx, paramName) {
	                if ($.inArray(paramName, self.option('trackedParams')) !== -1) {
	                    paramsToTrack.push(paramName);
	                }
	            });
	
	            if (paramsToTrack.length) {
	                this._updateParams(paramsToTrack, params);
	            }
	        },
	
	        /**
	         * Updates params
	         * @param paramNames
	         * @param values
	         * @private
	         */
	        _updateParams: function _updateParams(paramNames, values) {
	            var storedValue = this.getPrefillValue();
	            var paramName;
	
	            for (var i = 0; i < paramNames.length; i++) {
	                paramName = paramNames[i];
	                if ($.inArray(paramName, this.option('arrayParams')) !== -1) {
	                    storedValue[paramName] = values[paramName].join(this.option('arraySeparator'));
	                } else {
	                    storedValue[paramName] = values[paramName];
	                }
	            }
	
	            this.setPrefillValue(storedValue);
	        },
	
	        /**
	         * Returns storage name.
	         * We can bump storage with new version if e.g. structure is changed
	         * @returns {string}
	         * @private
	         */
	        _getStorageName: function _getStorageName() {
	            return 'uprefill' + this._version;
	        },
	        /**
	         * Logs error in debug env
	         * @param e
	         * @private
	         */
	        _logError: function _logError(e) {
	            if (!this._log) {
	                this._log = new Log();
	            }
	            this._log.error(e);
	        },
	
	        /**
	         * Returns current prefill value
	         * @returns {*|{}}
	         */
	        getPrefillValue: function getPrefillValue() {
	            var rawValue = $.cookie(this._getStorageName());
	            var result = null;
	
	            if (rawValue) {
	                try {
	                    // We use own data encoding to avoid any issues with manipulating
	                    // global $.cookie.json / $.cookie.raw in other libs usage.
	                    result = JSON.parse(decodeURIComponent(rawValue));
	                } catch (e) {
	                    this._logError(e);
	                }
	            }
	            return result || {};
	        },
	
	        /**
	         * Stores prefill value
	         * @param value
	         */
	        setPrefillValue: function setPrefillValue(value) {
	            if (!$.isPlainObject(value)) {
	                this._logError('Value is not an object');
	            }
	            var rawValue = encodeURIComponent((0, _stringify2.default)(value));
	            var expires = 1;
	
	            if (value.departureDate) {
	                var now = moment();
	                expires = moment(value.departureDate, 'YYYY-MM-DD').diff(now, 'days');
	            }
	
	            $.cookie(this._getStorageName(), rawValue, { path: '/', expires: expires });
	        }
	    });
	
	    return UserSearchPrefill;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(278);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ }),
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Created by Pavel Kozhin on 18/04/16.
	 */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Object, OptionsMixin) {
	  /**
	   * Shows the details for the map place
	   * @param element
	   * @param options
	   * @constructor
	   */
	  var DetailOverlay = function DetailOverlay(element, options) {
	    this.element = element;
	    this._elementNode = element.get(0);
	
	    var defaultOptions = {
	      contentSelector: '[data-fcse-role="map-modal-detail-overlay-content"]',
	      closeBtnSelector: '[data-fcse-role="map-overlay-closebtn"]'
	    };
	
	    this.addOptions(defaultOptions, options);
	    this._init();
	  };
	
	  DetailOverlay.prototype = $.extend(Object.create(OptionsMixin), {
	    /**
	     * Initializer
	     * @private
	     */
	    _init: function _init() {
	      var self = this;
	      this._contentElement = $(this.option('contentSelector'), this.element);
	
	      $(this.option('closeBtnSelector')).click(function () {
	        self.close();
	      });
	    },
	
	    /**
	     * Opens overlay
	     */
	    open: function open() {
	      if (this._elementNode.style.display !== 'block') {
	        this._elementNode.style.display = 'block';
	      }
	    },
	
	    /**
	     * Closes overaly
	     */
	    close: function close() {
	      if (this._elementNode.style.display === 'block') {
	        this._elementNode.style.display = 'none';
	      }
	    },
	
	    /**
	     * Sets html content
	     * @param {string|null} html
	     */
	    setContent: function setContent(html) {
	      if (!html) {
	        this.element.addClass('is-loading');
	        this._contentElement.html('');
	      } else {
	        this.element.removeClass('is-loading');
	        this._contentElement.html(html);
	      }
	    }
	  });
	
	  return DetailOverlay;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	}();

	;

/***/ }),
/* 271 */,
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * OldOffer component.
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(3), __webpack_require__(2), __webpack_require__(9), __webpack_require__(11)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, _, Object, OptionsMixin, EventDispatcher) {
	
	    /**
	     * OldOffer constructor
	     *
	     * @param {jQuery} element
	     * @param requestHandler
	     * @param options
	     * @constructor
	     */
	    var OldOffer = function OldOffer(element, requestHandler, options) {
	        // Set default options
	        var defaultOptions = {
	            loadingClass: 'is-loading'
	        };
	
	        // Cause of a bug in top level implementation
	        if (element.length > 1) {
	            element = element.last();
	        }
	        this.element = element;
	
	        // Save local variables
	        this.requestHandler = requestHandler;
	        this.initialRouteParams = this.element.data("initial-route-params");
	        this.addOptions(defaultOptions, options);
	        this.showOldPrice = this.element.closest('[data-fcse-role="offerlist"]').data('show-old-price');
	
	        this._initLoadingEvents();
	        this._init();
	    };
	
	    OldOffer.prototype = $.extend(Object.create(EventDispatcher.prototype), Object.create(OptionsMixin), {
	        /**
	         * Initialize OldOffer
	         *
	         * @private
	         */
	        _init: function _init() {
	            if (!_.isUndefined(this.showOldPrice) && this.showOldPrice !== 1) {
	                return false;
	            }
	
	            this.element.find('[data-fcse-role="price-pp"]').filter(function () {
	                return !$(this).closest('[data-fcse-role="offervaliditybar"]').length;
	            }).addClass(this.option('loadingClass'));
	
	            this.requestHandler.send(this.option('oldPriceRoute'), {
	                requestId: this.element.data('fcse-request-id'),
	                productSearchId: this.element.data('fcse-product-search-id')
	            }, this.initialRouteParams);
	        },
	
	        /**
	         * Initialize Loading Events
	         *
	         * @private
	         */
	        _initLoadingEvents: function _initLoadingEvents() {
	            this.requestHandler.on('success', $.proxy(this._onLoadContentSuccess, this));
	            this.requestHandler.on('error', $.proxy(this._onLoadContentError, this));
	        },
	
	        /**
	         * Handler for content loading success
	         *
	         * @param data
	         * @param requestData
	         * @protected
	         */
	        _onLoadContentSuccess: function _onLoadContentSuccess(data, requestData) {
	            // Check if ajax response is from oldPriceRoute
	            if (requestData.route == this.option('oldPriceRoute')) {
	                // Unset loading state
	                this.element.find('[data-fcse-role="price-pp"]').removeClass(this.option('loadingClass'));
	                this.element.find('[data-fcse-role="old-offer-price"]').each(function (index, element) {
	                    var badgeEl = $(element).closest('[data-fcse-role="offer-item"]').find('[data-fcse-role-placeholder="badge-placeholder"]');
	                    badgeEl.replaceWith($(data[index]).find('[data-fcse-role="campaign-badge-async"]').html());
	                    $(element).replaceWith($(data[index]).find('[data-fcse-role="price-pp-async"]').html());
	                });
	            }
	        },
	
	        /**
	         * Handler for content loading error
	         * @param event
	         * @private
	         */
	        _onLoadContentError: function _onLoadContentError(event) {
	            this.element.find('[data-fcse-role="price-pp"]').removeClass(this.option('loadingClass'));
	        }
	    });
	
	    return OldOffer;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Created by pavelkozhin on 28/07/16.
	 */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2), __webpack_require__(58), __webpack_require__(14)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Object, MultiRequestHandler, Url) {
	
	    var MultiRequestHandlerExtended = function MultiRequestHandlerExtended(options) {
	        MultiRequestHandler.apply(this, arguments);
	    };
	
	    MultiRequestHandlerExtended.prototype = $.extend(Object.create(MultiRequestHandler.prototype), {
	
	        send: function send(route, queryParams, routeParams, options) {
	            var url = new Url();
	            var isHotelSearch = url.query.searchField == 'search-widget' || url.query.searchField == 'searchmask-search-widget';
	
	            if (isHotelSearch && route.indexOf('accordion') > 0) {
	                queryParams.hotelName = url.query.hotelName;
	            }
	            MultiRequestHandler.prototype.send.call(this, route, queryParams, routeParams, options);
	        }
	    });
	
	    return MultiRequestHandlerExtended;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(306), __esModule: true };

/***/ }),
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Created by Pavel on 14.11.14.
	 *
	 * Show html in popup after loading
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(3), __webpack_require__(2), __webpack_require__(273), __webpack_require__(9), __webpack_require__(217)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, _, Object, MultiRequestHandler, OptionsMixin) {
	    var requestHandler = new MultiRequestHandler(),
	        AjaxContentLoader = function AjaxContentLoader(selector, scope, options) {
	        this.selector = selector;
	        this.scope = scope;
	        // Set default options
	        var defaultOptions = {
	            name: 'hotelId',
	            routeAttribute: 'data-route',
	            idAttribute: 'data-hotel-id',
	            departureDate: !_.isUndefined(productSearchParams) && productSearchParams['departureDate'] ? productSearchParams['departureDate'] : ''
	        };
	        this.addOptions(defaultOptions, options);
	        this._init();
	    };
	    AjaxContentLoader.prototype = $.extend(Object.create(OptionsMixin), {
	        _init: function _init() {
	            this._initEvents();
	            this._initLoadingEvents();
	        },
	        _initEvents: function _initEvents() {
	            $(document).on('click', this.selector, $.proxy(this._clickHandler, this));
	        },
	        _clickHandler: function _clickHandler(event) {
	            var target = $(event.target),
	                idAttr = this.option('idAttribute'),
	                routeAttr = this.option('routeAttribute'),
	                name = this.option('name'),
	                element = target.is('[' + idAttr + ']') ? target : target.closest('[' + idAttr + ']'),
	                value = element.attr(idAttr),
	                route = element.attr(routeAttr),
	                lightboxNode = $('[data-fcse-role="modal"]', element),
	                loadedNode = $('[data-fcse-role="modal"][data-loaded][data-' + name + '=' + value + ']'),
	                options = $.extend({}, this.scope.getQuery()),
	                currentTarget = $(event.currentTarget),
	                extraOptions = currentTarget.data('extra-options');
	
	            options[name] = value;
	
	            if (_.isObject(extraOptions)) {
	                _.extend(options, extraOptions);
	            }
	
	            if (!_.isObject(extraOptions) && (typeof options['departureDate'] == 'undefined' || options['departureDate'] == '')) {
	                options['departureDate'] = this.option('departureDate');
	            }
	            if (loadedNode.length > 0) {
	                this._showLightBox(loadedNode);
	                return;
	            }
	            lightboxNode.modal();
	            requestHandler.send(route, options, options, {
	                name: name,
	                value: value,
	                element: element,
	                lightBox: lightboxNode
	            });
	        },
	        _initLoadingEvents: function _initLoadingEvents() {
	            requestHandler.on('success', $.proxy(this._onLoadContentSuccess, this));
	        },
	        /**
	         * Handler for content loading success
	         * @param event
	         * @param data
	         * @private
	         */
	        _onLoadContentSuccess: function _onLoadContentSuccess(event, data) {
	            var element = data.options.element,
	                lightbox = data.options.lightBox,
	                name = data.options.name,
	                value = data.options.value;
	            if ($(element, this.element).length > 0) {
	                if (lightbox.closest('html').length === 0) {
	                    return;
	                }
	                if ($.modal) {
	                    $.modal.close();
	                }
	                lightbox.remove();
	                element.append(event.html);
	                lightbox = $('[data-fcse-role="modal"][data-loaded]', element);
	                lightbox.attr('data-' + name, value);
	                this._showLightBox(lightbox);
	            }
	        },
	        /**
	         * Show lightbox
	         * @param {jQueryElement} lightboxNode
	         */
	        _showLightBox: function _showLightBox(lightboxNode) {
	            var onshow = this.option('onshow');
	            lightboxNode.modal();
	            if (_.isFunction(onshow)) {
	                onshow(lightboxNode);
	            }
	        }
	    });
	
	    return AjaxContentLoader;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(307);
	var $Object = __webpack_require__(17).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(39);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(18), 'Object', { defineProperty: __webpack_require__(20).f });


/***/ }),
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Created by ivo on 22.05.14.
	 *
	 * Accordion component for destination pages
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(2), __webpack_require__(9), __webpack_require__(11), __webpack_require__(389)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Object, OptionsMixin, EventDispatcher, AccordionNode) {
	    /**
	     * Abstract pseudo class for the creational process of
	     * the filter widgets.
	     *
	     * @constructor
	     * @param {Object} scope
	     * @param array An array of widgets to be instantiated
	     * @returns {_L1.WidgetFactory}
	     */
	    var Accordion = function Accordion(requestHandler, scope, options) {
	        EventDispatcher.apply(this, arguments);
	        this._regionParamName = 'groupNames';
	
	        // Set default options
	        var defaultOptions = {
	            elementSelector: '[data-fcse-role="accordion"]',
	            loadingClass: 'is-loading'
	        };
	        this.addOptions(defaultOptions, options);
	
	        // Save local variables
	        this.requestHandler = requestHandler;
	        this.scope = scope;
	
	        // Get dom node
	        var element = $(this.option('elementSelector'));
	        if (element.length != 1) {
	            throw new Error('You have to have ONE node of accordion in the DOM');
	        }
	        this.element = $(element[0]);
	
	        // Register an event on successful getting of data
	        this.registerEvent("dataSuccess");
	
	        // Initialize events
	        this._initEventHandling();
	
	        // Initialize accordion nodes
	        this._initNodes();
	    };
	
	    Accordion.prototype = $.extend(Object.create(EventDispatcher.prototype), Object.create(OptionsMixin), {
	        /**
	         * An array of AccordionNode objects
	         * @private
	         */
	        _nodes: [],
	
	        /**
	         * Returns all nodes
	         */
	        getNodes: function getNodes() {
	            return this._nodes;
	        },
	
	        /**
	         * Initializes event handling
	         * @private
	         */
	        _initEventHandling: function _initEventHandling() {
	            // Register scope change handler
	            this.scope.change($.proxy(this._onScopeChange, this));
	
	            // Register requestHandler
	            this.requestHandler.on('success', $.proxy(this._onLoadContentSuccess, this));
	            this.requestHandler.on('error', $.proxy(this._onLoadContentError, this));
	        },
	
	        /**
	         * Handler for content loading success
	         * @param response
	         * @param data
	         * @private
	         */
	        _onLoadContentSuccess: function _onLoadContentSuccess(response, data) {
	            // Check if ajax response is from nodeContentRoute
	            if (data.route !== this.option('contentRoute')) {
	                return;
	            }
	
	            // Put HTML into DOM
	            var newElement = $(response.html);
	            $(this.element).replaceWith(newElement);
	            this.element = newElement;
	
	            // Initialize new nodes
	            this._initNodes();
	
	            // Dispatching the event on successful getting of data
	            this.dispatchEvent("dataSuccess", response);
	        },
	
	        /**
	         * Handler for content loading error
	         * @param event
	         * @private
	         */
	        _onLoadContentError: function _onLoadContentError(event) {
	            console.log('Error handling');
	        },
	
	        /**
	         * Scope change handler
	         * @param scope
	         * @param params
	         * @private
	         */
	        _onScopeChange: function _onScopeChange(scope, params) {
	            // we have to reset filterGroupIds if we change groupIds
	            if (scope.changedParams.includes('groupIds')) {
	                scope.scope.setMultipleParams({
	                    'filterGroupIds': null,
	                    'searchValue': null,
	                    'hotelName': null,
	                    'hotelId': null,
	                    'productCode': null
	                });
	            } else if (scope.changedParams.includes('hotelName')) {
	                scope.scope.setMultipleParams({
	                    'searchValue': null,
	                    'hotelName': null,
	                    'hotelId': null,
	                    'productCode': null
	                });
	            }
	            // we don't need update accordion if we update content in node
	            if (scope.changedParams.includes('filterGroupIds')) {
	                return false;
	            }
	
	            // Reload accordion
	            this.requestHandler.cancel(this.option('contentRoute'));
	            this.requestHandler.send(this.option('contentRoute'), this.scope.getQuery());
	
	            // Set loading state
	            $(this.element).addClass(this.option('loadingClass'));
	        },
	
	        /**
	         * Initializes all nodes
	         * @private
	         */
	        _initNodes: function _initNodes() {
	            var self = this;
	
	            this._resetFilterGroupIds();
	
	            $('[data-fcse-role="accordion--node"]', this.element).each(function (index, element) {
	                // Initialize node
	                var node = new AccordionNode(element, self.requestHandler, self.scope, {
	                    nodeContentRoute: self.option('nodeContentRoute')
	                });
	
	                // Open first node
	                if (index == 0) {
	                    node.open();
	                }
	            });
	        },
	
	        /**
	         * Reset filter when we have more than one destination
	         * @private
	         */
	        _resetFilterGroupIds: function _resetFilterGroupIds() {
	            var groupIdCount = $('[data-fcse-role="accordion--contentnode"]').length;
	            if (groupIdCount !== 1) {
	                this.scope.setParam('filterGroupIds', null);
	            }
	        }
	    });
	
	    return Accordion;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Created by Pavel
	 */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(3), __webpack_require__(2), __webpack_require__(9), __webpack_require__(11), __webpack_require__(14)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, _, Object, OptionsMixin, EventDispatcher, Url) {
	    'use strict';
	
	    var AccordionStateHandler = function AccordionStateHandler(param, options) {
	        EventDispatcher.apply(this, arguments);
	
	        // Set default options
	        var defaultOptions = {
	            idField: 'data-hotel-id',
	            nodeContentRoute: 'allt_frontend.package.destination.accordion_offers'
	        };
	        this.addOptions(defaultOptions, options);
	
	        this._param = param;
	        this._currentState = null;
	        this.registerEvent('changed');
	    };
	
	    AccordionStateHandler.prototype = $.extend({}, Object.create(OptionsMixin), Object.create(EventDispatcher.prototype), {
	        /**
	         * get parameter name
	         * @returns string
	         */
	        getParam: function getParam() {
	            return this._param;
	        },
	
	        /**
	         * get UI state from frontend
	         * @returns {Array}
	         */
	        getUIState: function getUIState() {
	            return [];
	        },
	
	        /**
	         * Apply to frontend
	         */
	        applyState: function applyState(state) {
	            /*
	            {'gname': '', hid: '', page: '', rpp:'', sort:''}
	             */
	            this._currentState = state;
	
	            if (!state || this._scrollToHotel(state.hid)) {
	                return;
	            }
	
	            var contentNode = $('[data-original-group-name="' + state.gname + '"]');
	            if (!contentNode.length) {
	                return;
	            }
	            var node = contentNode.closest('[data-fcse-role="accordion--node"]');
	
	            //$('[data-fcse-role="accordion--node--header"]', node).click();
	            node.data('node-instance').open();
	            contentNode.data('content-node-instance').open({
	                sort: state.sort,
	                resultsPerPage: state.rpp,
	                page: state.page
	            });
	        },
	
	        /**
	         * Content node route request success handler
	         * @param data
	         * @param requestData
	         * @private
	         */
	        _onRequestSuccess: function _onRequestSuccess(data, requestData) {
	            if (requestData && requestData.route == this.option('nodeContentRoute') && this._currentState) {
	                setTimeout($.proxy(this._scrollToHotel, this, this._currentState.hid), 300);
	            }
	        },
	
	        /**
	         * Scroll to hotel if found
	         * @param hotelId
	         * @returns {boolean}
	         * @private
	         */
	        _scrollToHotel: function _scrollToHotel(hotelId) {
	            var element = $('[data-hotel-id="' + hotelId + '"]');
	
	            if (element.length) {
	                setTimeout(function () {
	                    $(window).scrollTop(element.offset().top - 50);
	                }, 1000);
	
	                this._currentState = null;
	                return true;
	            }
	            return false;
	        },
	
	        /**
	         * Init handlers for all types
	         */
	        init: function init() {
	            this.option('requestHandler').on('success', $.proxy(this._onRequestSuccess, this));
	
	            if (typeof history.pushState !== 'undefined') {
	                $('body').off('click.acstate').on('click.acstate', '[data-fcse-role="offer-item"]', function (event) {
	                    if ($(event.target).is('[data-fcse-distinct-link]') || $(event.target).closest('[data-fcse-distinct-link]').length) {
	                        return;
	                    }
	
	                    var targetElement = $(event.currentTarget).closest('[data-fcse-role="offer-item"]');
	                    var url = targetElement.attr('data-back-button-support');
	                    if (url) {
	                        var urlObj = new Url(url);
	                        history.pushState(urlObj.query, '', url);
	                        targetElement.find('[data-fcse-role="hotel-link"]:first').trigger('click', event);
	                    }
	                });
	            }
	        },
	
	        /**
	         * state change handler
	         */
	        stateChanged: function stateChanged() {
	            this.dispatchEvent('changed');
	        }
	    });
	
	    return AccordionStateHandler;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _defineProperty2 = __webpack_require__(265);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by ivo on 26.05.14.
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(3), __webpack_require__(2), __webpack_require__(9), __webpack_require__(11), __webpack_require__(34), __webpack_require__(14), __webpack_require__(255), __webpack_require__(397), __webpack_require__(272), __webpack_require__(395), __webpack_require__(163)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, _, Object, OptionsMixin, EventDispatcher, Dropdown, Url, MapModal, DynamicRegionMap, OldOffer, CityMultiSelectFilter, Flyout) {
	    /**
	     * Abstract pseudo class for the creational process of
	     * the filter widgets.
	     *
	     * @constructor
	     * @param element
	     * @param requestHandler
	     * @param {Object} scope
	     * @param options
	     */
	    var ContentNode = function ContentNode(element, requestHandler, scope, options) {
	        EventDispatcher.apply(this, arguments);
	
	        // Store element
	        this.element = element;
	
	        // Store group ID for content loading
	        this.groupId = $(element).attr('data-group-id');
	        this.groupIds = $(element).attr('data-group-id');
	        this.filterGroupIds = null;
	
	        // Set default options
	        var defaultOptions = {
	            openClass: 'is-active',
	            closedClass: 'is-closed',
	            loadingClass: 'is-loading',
	            paramNameId: 'GroupIds',
	            groupIds: 'groupIds',
	            filterGroupIds: 'filterGroupIds',
	            offerItemSelector: '[data-fcse-role="offer-item"]',
	            nodeAccordionSelector: '[data-fcse-role="accordion--contentnode"]'
	        };
	        this.addOptions(defaultOptions, options);
	
	        // Save local variables
	        this.requestHandler = requestHandler;
	        this.scope = scope;
	
	        this._init();
	        // Init event handling
	        this._initEventHandling();
	    };
	
	    ContentNode.prototype = $.extend(Object.create(EventDispatcher.prototype), Object.create(OptionsMixin), {
	        /**
	         * Basic initialization
	         * @private
	         */
	        _init: function _init() {
	            // Check if content for this node already exist then initialize it
	            if ($(this.option('offerItemSelector'), this.element).length) {
	                this.contentIsLoaded = true;
	                this._initContent();
	            }
	            $(this.element).data('content-node-instance', this);
	        },
	
	        /**
	         * Initializes event handlers
	         * @private
	         */
	        _initEventHandling: function _initEventHandling() {
	            var self = this;
	            $('[data-fcse-role="accordion--contentnode--header"]', this.element).click(function () {
	                self.toggle();
	            });
	
	            // Content loading events
	            this.requestHandler.on('success', $.proxy(this._onLoadContentSuccess, this));
	            this.requestHandler.on('error', $.proxy(this._onLoadContentError, this));
	        },
	
	        /**
	         * Returns true if the node is open
	         * @return boolean
	         */
	        isOpen: function isOpen() {
	            return $(this.element).hasClass(this.option('openClass'));
	        },
	
	        /**
	         * Loads the content of the accordion
	         * @private
	         */
	        _loadContent: function _loadContent(additionalParams) {
	            this.filterGroupIds = null;
	            var params = this.scope.getQuery();
	            params = $.extend(params, additionalParams || {});
	            params[this.option('groupIds')] = this.groupIds;
	
	            if (typeof params[this.option('groupIds')] === 'undefined') {
	                params[this.option('groupIds')] = this.groupIds;
	            }
	
	            if (Array.isArray(params[this.option('groupIds')])) {
	                params[this.option('groupIds')] = params[this.option('groupIds')].join(';');
	            }
	
	            if (Array.isArray(params[this.option('filterGroupIds')])) {
	                params[this.option('filterGroupIds')] = params[this.option('filterGroupIds')].join(';');
	                this.filterGroupIds = params[this.option('filterGroupIds')];
	            }
	
	            if (typeof params[this.option('filterGroupIds')] === 'undefined') {
	                params[this.option('groupIds')] = this.groupIds;
	            }
	
	            this.requestHandler.send(this.option('nodeContentRoute'), params);
	
	            $("html, body").animate({ scrollTop: $(this.element).offset().top }, "fast");
	            // Set loading state
	            $('[data-fcse-role="accordion--contentnode--body"]', this.element).addClass(this.option('loadingClass'));
	        },
	
	        /**
	         * Handler for content loading success
	         * @param event
	         * @param data
	         * @private
	         */
	        _onLoadContentSuccess: function _onLoadContentSuccess(event, data) {
	            // Check if ajax response is from nodeContentRoute
	            if (data.route === this.option('nodeContentRoute')) {
	                // Check if ajax response if for this node
	                if (!this.filterGroupIds) {
	                    if (data.queryParams[this.option('groupIds')] !== this.groupIds) {
	                        return;
	                    }
	                } else {
	                    if (data.queryParams[this.option('filterGroupIds')] !== this.filterGroupIds) {
	                        return;
	                    }
	                }
	
	                this._onNodeContentLoad(event, data);
	            }
	        },
	
	        /**
	         * Handle loading node content
	         * @param {Object} event
	         * @param {Object} data
	         */
	        _onNodeContentLoad: function _onNodeContentLoad(event, data) {
	            var contentNode = $('[data-fcse-role="accordion--contentnode--body"]', this.element);
	            // Reset loading state
	            contentNode.removeClass(this.option('loadingClass'));
	
	            // Replace HTML content
	            contentNode.html(event.html);
	
	            this._initContent();
	
	            // Prevent duplicate loading
	            this.contentIsLoaded = true;
	        },
	
	        /**
	         * Click handler for pagination link
	         * @param event
	         * @private
	         */
	        _onPaginationClick: function _onPaginationClick(event) {
	            var _loadContent2;
	
	            // do nothing, if click on the same page
	            if ($(event.currentTarget).parent().hasClass('is-active')) {
	                return;
	            }
	            var page = $(event.currentTarget).attr('data-page');
	            if (Math.max($("html").scrollTop(), $("body").scrollTop()) > $(this.element).offset().top) {
	                $("html, body").animate({ scrollTop: $(this.element).offset().top - 5 }, "fast");
	            }
	
	            var filterGroupIds = this.cityMultiSelectFilter.getValue();
	
	            this._loadContent((_loadContent2 = {
	                'sort': this.sortingDropdown.getValue(),
	                'resultsPerPage': this.limitDropdown.getValue(),
	                'page': page
	            }, (0, _defineProperty3.default)(_loadContent2, this.option('filterGroupIds'), filterGroupIds), (0, _defineProperty3.default)(_loadContent2, this.option('groupIds'), this.groupIds), _loadContent2));
	        },
	
	        /**
	         * Handler for content loading error
	         * @param event
	         * @private
	         */
	        _onLoadContentError: function _onLoadContentError(event) {
	            console.log('Error handling');
	        },
	
	        /**
	         *
	         * @private
	         */
	        _onDropdownChange: function _onDropdownChange() {
	            var filterGroupIdsParamName = this.option('filterGroupIds');
	            var filterGroupIds = this.cityMultiSelectFilter.getValue();
	
	            if (!this._isUpdatedFilterGroupIds() && this.limitDropdown.getValue() == this.limitDropdown.prevVal && this.sortingDropdown.getValue() == this.sortingDropdown.prevVal) {
	                return false;
	            }
	
	            if (this._isUpdatedFilterGroupIds()) {
	                this._updateFilterGroupIds();
	            }
	
	            if (filterGroupIds && filterGroupIds.length) {
	                this._loadContent((0, _defineProperty3.default)({
	                    'sort': this.sortingDropdown.getValue(),
	                    'resultsPerPage': this.limitDropdown.getValue()
	                }, filterGroupIdsParamName, filterGroupIds));
	            } else {
	                this._loadContent((0, _defineProperty3.default)({
	                    'sort': this.sortingDropdown.getValue(),
	                    'resultsPerPage': this.limitDropdown.getValue()
	                }, filterGroupIdsParamName, ''));
	            }
	        },
	
	        /**
	         * Checking, was updated cities?
	         * @returns {boolean}
	         * @private
	         */
	        _isUpdatedFilterGroupIds: function _isUpdatedFilterGroupIds() {
	            var filterGroupIds = this.cityMultiSelectFilter.getValue();
	            var filterGroupIdsPrev = this.cityMultiSelectFilter.prevVal;
	
	            if (filterGroupIds.length === filterGroupIdsPrev.length && filterGroupIds.toString() === filterGroupIdsPrev.toString()) {
	                return false;
	            }
	
	            return true;
	        },
	
	        /**
	         * Saving filters for one groupId
	         *
	         * @returns {boolean}
	         * @private
	         */
	        _updateFilterGroupIds: function _updateFilterGroupIds() {
	            var url = new Url(window.location.href);
	            var filterGroupIdsParamName = this.option('filterGroupIds');
	            var filterGroupIds = this.cityMultiSelectFilter.getValue();
	            var groupIdCount = $(this.option('nodeAccordionSelector')).length;
	
	            // set filterGroupIds in scope for searchMask if we have one group id
	            if (groupIdCount !== 1) {
	                return false;
	            }
	
	            this.scope.setParam(filterGroupIdsParamName, filterGroupIds);
	
	            // update location
	            if (filterGroupIds) {
	                url.query[filterGroupIdsParamName] = filterGroupIds.join(';');
	            } else {
	                delete url.query[filterGroupIdsParamName];
	            }
	
	            window.history.pushState(this.scope.getParams(), '', window.location.pathname + url.getQuery());
	        },
	
	        /**
	         * Initialize content elements
	         * @private
	         */
	        _initContent: function _initContent() {
	            var self = this;
	            // Initialize dropdowns
	            this.sortingDropdown = new Dropdown($('[data-widget-type="widget-sorting"]', this.element));
	            this.sortingDropdown.on('change', $.proxy(this._onDropdownChange, this));
	            this.sortingDropdown.prevVal = this.sortingDropdown.getValue();
	            this.limitDropdown = new Dropdown($('[data-widget-type="widget-resultsperpage"]', this.element));
	            this.limitDropdown.on('change', $.proxy(this._onDropdownChange, this));
	            this.limitDropdown.prevVal = this.limitDropdown.getValue();
	
	            this._createCityMultiSelectWidget();
	            this.cityMultiSelectFilter.on('change', $.proxy(this._onDropdownChange, this));
	
	            var hotelsButton = $('[data-fcse-role="hotels-map-overlay-open-button"]', this.element);
	            var hotelProductSearch = hotelsButton.data('product-search');
	            var mapCountryName = $(this.element).attr('data-map-country-name');
	            var mapGroupName = hotelsButton.data('id');
	
	            hotelsButton.click(function () {
	                var thisElement = $(this);
	                MapModal.getInstance().open(mapGroupName, hotelProductSearch, thisElement.data('fallback-center'), mapCountryName, 'Liste');
	            });
	
	            var dynamicRegionMap = $(this.element).find('[data-fcse-role="dynamic-region-map"]');
	            if (dynamicRegionMap.length) {
	                this.dynamicRegionMap = new DynamicRegionMap(dynamicRegionMap, this.requestHandler, {});
	            }
	
	            $('[data-fcse-role="hotel-map-overlay-open-button"]', this.element).click(function () {
	                var thisElement = $(this);
	                MapModal.getInstance().open(mapGroupName, hotelProductSearch, thisElement.data('fallback-center'), mapCountryName, 'Hotel', thisElement.data('map-hotel-id'));
	            });
	
	            // Initialize paging
	            $('[data-fcse-role="pagination"] [data-page]', this.element).off('click').on('click', $.proxy(this._onPaginationClick, this));
	
	            if ($('[data-fcse-bookingtype="package"]').length) {
	                new OldOffer($(this.element).find('[data-fcse-role="accordion-hotels"]'), self.requestHandler, {
	                    oldPriceRoute: 'allt_old_price_offers.price'
	                });
	            }
	        },
	
	        _createCityMultiSelectWidget: function _createCityMultiSelectWidget() {
	            var cityMultiSelectFlyout = new Flyout($('.flyout-city-multi-select-filter', this.element), {
	                closeOnOutsideClick: true,
	                submitOnOutsideClick: true
	            });
	            cityMultiSelectFlyout.setCaptionElement($('.widget--value', $('.widget-citymultiselect', this.element)));
	            cityMultiSelectFlyout.bindEventToCallerElement('click', $('.widget--btn, .widget--value', $('.widget-citymultiselect', this.element)));
	
	            var cityMultiSelectFilter = new CityMultiSelectFilter($('.flyout-city-multi-select-checklist', this.element));
	            cityMultiSelectFlyout.setWidget(cityMultiSelectFilter);
	            this.cityMultiSelectFilter = cityMultiSelectFilter;
	            this.cityMultiSelectFilter.prevVal = this.cityMultiSelectFilter.getValue();
	        },
	
	        /**
	         * Opens the accordion node
	         */
	        open: function open(params) {
	            params = params || {};
	            $(this.element).addClass(this.option('openClass')).removeClass(this.option('closedClass'));
	
	            // Load content if there is none
	            if (!this.contentIsLoaded) {
	                this._loadContent(params);
	            }
	        },
	
	        /**
	         * Closes the accordion node
	         */
	        close: function close() {
	            $(this.element).removeClass(this.option('openClass')).addClass(this.option('closedClass'));
	        },
	
	        /**
	         * Toggles the open state of the accordion node
	         */
	        toggle: function toggle() {
	            if (this.isOpen()) {
	                this.close();
	            } else {
	                this.open();
	            }
	        }
	    });
	
	    return ContentNode;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Created by ivo on 22.05.14.
	 *
	 * Accordion component for destination pages
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(2), __webpack_require__(9), __webpack_require__(11), __webpack_require__(388), __webpack_require__(34)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Object, OptionsMixin, EventDispatcher, ContentNode, Dropdown) {
	    /**
	     * Abstract pseudo class for the creational process of
	     * the filter widgets.
	     *
	     * @constructor
	     * @param {Object} scope
	     * @param array An array of widgets to be instantiated
	     * @returns {_L1.WidgetFactory}
	     */
	    var Node = function Node(element, requestHandler, scope, options) {
	        EventDispatcher.apply(this, arguments);
	
	        // Store element
	        this.element = element;
	
	        // Set default options
	        var defaultOptions = {
	            openClass: 'is-active',
	            closedClass: 'is-closed'
	        };
	        this.addOptions(defaultOptions, options);
	
	        // Save local variables
	        this.requestHandler = requestHandler;
	        this.scope = scope;
	        this.contentIsLoaded = false;
	
	        this._init();
	
	        // Init event handling
	        this._initEventHandling();
	
	        // Init content nodes
	        this._initContentNodes();
	    };
	
	    Node.prototype = $.extend(Object.create(EventDispatcher.prototype), Object.create(OptionsMixin), {
	        /**
	         * Initializer
	         * @private
	         */
	        _init: function _init() {
	            $(this.element).data('node-instance', this);
	        },
	        /**
	         * Initializes event handlers
	         * @private
	         */
	        _initEventHandling: function _initEventHandling() {
	            var self = this;
	            $('[data-fcse-role="accordion--node--header"]', this.element).click(function () {
	                self.toggle();
	            });
	        },
	
	        /**
	         * Initializes the content nodes
	         * @private
	         */
	        _initContentNodes: function _initContentNodes() {
	            var self = this;
	            $('[data-fcse-role="accordion--contentnode"]', this.element).each(function (index, element) {
	                var contentNode = new ContentNode(element, self.requestHandler, self.scope, {
	                    nodeContentRoute: self.option('nodeContentRoute')
	                });
	            });
	        },
	
	        /**
	         * Returns true if the node is open
	         * @return boolean
	         */
	        isOpen: function isOpen() {
	            return $(this.element).hasClass(this.option('openClass'));
	        },
	
	        /**
	         * Opens the accordion node
	         */
	        open: function open() {
	            $(this.element).addClass(this.option('openClass')).removeClass(this.option('closedClass'));
	        },
	
	        /**
	         * Closes the accordion node
	         */
	        close: function close() {
	            $(this.element).removeClass(this.option('openClass')).addClass(this.option('closedClass'));
	        },
	
	        /**
	         * Toggles the open state of the accordion node
	         */
	        toggle: function toggle() {
	            if (this.isOpen()) {
	                this.close();
	            } else {
	                this.open();
	            }
	        }
	    });
	
	    return Node;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, _) {
	
	    var Breadcrumbs = function Breadcrumbs() {
	
	        // breadcrumbs container(s)
	        this.elements = $('[data-fcse-role="breadcrumbs--container"]');
	    };
	
	    Breadcrumbs.prototype = $.extend({
	        /**
	         * Update breadcrumbs
	         * @param params
	         * @private
	         */
	        update: function update(html) {
	            if (!_.isUndefined(html)) {
	                this.elements.html(html);
	            }
	        }
	    });
	
	    return Breadcrumbs;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(3), __webpack_require__(162), __webpack_require__(2), __webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, _, FacetsMixin, Object, Widget) {
	
	  var CityMultiSelectFilter = function CityMultiSelectFilter(element, options) {
	    Widget.apply(this, arguments);
	
	    //Default options
	    var defaultOptions = {
	      'selectedClassName': 'is-selected',
	      'disabledClassName': 'is-disabled',
	      'facetProperty': null
	    };
	    this.addOptions(defaultOptions, options);
	
	    this._registerClickEvent();
	  };
	
	  CityMultiSelectFilter.prototype = $.extend(Object.create(Widget.prototype), FacetsMixin, {
	    /**
	     * Gets the values and triggers them
	     */
	    _getAndTriggerValues: function _getAndTriggerValues() {
	      var value = [];
	      $('[data-value]', this.element).each(function (index, element) {
	        if ($(element).find('input:checkbox').is(':checked')) {
	          value.push($(element).attr('data-value'));
	        }
	      });
	    },
	
	    /**
	     * Register click event handler
	     * @returns {undefined}
	     */
	    _registerClickEvent: function _registerClickEvent() {
	      var self = this;
	      $('[data-value]', this.element).on("click", function (e) {
	        var $target = $(this);
	        if ($target.hasClass(self.option('disabledClassName'))) {
	          e.preventDefault();
	          return;
	        }
	
	        var selected = false;
	        if (!$target.hasClass(self.option('selectedClassName'))) {
	          selected = true;
	        }
	        e.preventDefault();
	        e.stopImmediatePropagation();
	        $('input:checkbox', $target).prop('checked', selected ? 'checked' : null);
	
	        self._getAndTriggerValues();
	      });
	
	      /**
	       * Click event for the checkboxes
	       * Fix for this problem: Checkbox being checked twice when inside an li with a click event
	       */
	      $('input[type=checkbox]', this.element).on('click', function (e) {
	        e.stopPropagation();
	        self._getAndTriggerValues();
	      });
	    },
	
	    getValueFromUi: function getValueFromUi() {
	      var value = [];
	      $('[data-value]', this.element).each(function (index, element) {
	        if ($(element).find('input:checkbox').is(':checked')) {
	          value.push($(element).attr('data-value'));
	        }
	      });
	      return value;
	    },
	
	    setValueToUi: function setValueToUi() {
	      var self = this;
	      $('[data-value]', this.element).each(function (index, element) {
	        var $element = $(element);
	        if ($.inArray($element.attr('data-value'), self.getValue()) !== -1) {
	          $element.addClass(self.option('selectedClassName'));
	          $('input[type=checkbox]', $element).prop('checked', true);
	          $(self.option('checkboxSelector'), $element).addClass(self.option('checkboxSelectedClassName'));
	        } else {
	          $element.removeClass(self.option('selectedClassName'));
	          $('input[type=checkbox]', $element).prop('checked', false);
	          $(self.option('checkboxSelector'), $element).removeClass(self.option('checkboxSelectedClassName'));
	        }
	      });
	    },
	
	    formatValue: function formatValue() {
	      var self = this;
	      var result = '';
	      if (!(this.value && this.value.length)) {
	        return this.element.data('any');
	      }
	      if (this.value.length === 1) {
	        result = $('[data-value="' + this.value[0] + '"][data-label]', this.element).data('label');
	      } else {
	        result = this.element.data('plural').replace('%count%', this.value.length);
	      }
	      return result;
	    }
	  });
	
	  return CityMultiSelectFilter;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	}();

	;

/***/ }),
/* 396 */,
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(3), __webpack_require__(9), __webpack_require__(2), __webpack_require__(254)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, _, OptionsMixin, Object, Map) {
	    /**
	     * @typedef {Object} PreflightResponseMeta
	     * @property {Object} bounds
	     * @property {Array} locations
	     * @property {Object} center
	     */
	    /**
	     * @typedef {Object} PreflightResponseEvent
	     * @property {string} state
	     * @property {PreflightResponseMeta} meta
	     */
	    /**
	     * DynamicRegionMap component.
	     * @param {jQuery|String} element
	     * @param {MultiRequestHandler} requestHandler
	     * @param {Object} options
	     * @constructor
	     */
	    var DynamicRegionMap = function DynamicRegionMap(element, requestHandler, options) {
	        // default options
	        var defaultOptions = {
	            loadingClass: 'is-loading',
	            contentSelector: '[data-fcse-role="map-region-content"]',
	            preflightRoute: 'allt_frontend.map.places_preflight'
	        };
	        this.addOptions(defaultOptions, options || {});
	        this.element = element;
	        this._map = null;
	        this._requestHandler = requestHandler;
	        this._requestInProgress = false;
	        this._currentId = null;
	        this._productSearch = null;
	
	        this._init(this.element.data('id'), this.element.data('map-product-search'), this.element.data('fallback-center'), '');
	    };
	
	    DynamicRegionMap.prototype = $.extend(Object.create(OptionsMixin), Object.create(Map.prototype), {
	        /**
	         * Initializer
	         * @param {String} id
	         * @param {String} productSearch
	         * @param {Object} defaultCenter
	         * @param {String} country
	         * @private
	         */
	        _init: function _init(id, productSearch, defaultCenter, country) {
	            this._requestHandler.on('success', $.proxy(this._onPreflightRequestSuccess, this));
	            this._requestHandler.on('cancel', $.proxy(this._onPreflightRequestCancel, this));
	
	            if (!productSearch) {
	                return;
	            }
	
	            this._productSearch = productSearch;
	
	            if (this._currentId !== id) {
	                this._currentId = id;
	                this._doPreflightRequest(id, country, defaultCenter);
	            } else if (this._map) {
	                this._map.loadMarkers(this._productSearch);
	            }
	        },
	
	        /**
	         * Creates and inits Map component
	         * @param {Object} bounds
	         * @param {Array} locations
	         * @param {Object} center
	         * @param {Number} zoom
	         * @private
	         */
	        _initMap: function _initMap(bounds, locations, center, zoom) {
	            if (!this._map) {
	                var self = this;
	
	                this._map = new Map(this.element, this._requestHandler, {
	                    placeDetailsRoute: 'allt_frontend.map.place_details',
	                    placesRoute: 'allt_frontend.map.places',
	                    mapContainerSelector: '[data-fcse-role="map-region-content"]',
	                    detailInfoBoxFactory: function detailInfoBoxFactory() {},
	                    productSearch: this._productSearch,
	                    mapOptions: {
	                        mapTypeControl: false,
	                        disableDefaultUI: true
	                    }
	                });
	                this._map.on('mapCreated', function () {
	                    self.element.show();
	                    var debouncer = _.debounce($.proxy(self._onBoundsZoomChanged, self), 1500);
	                    self._map.getMap().addListener('bounds_changed', debouncer);
	                });
	            }
	            this._map.create(bounds, locations, center, zoom);
	            // this._map.removeMarkers();
	        },
	
	        /**
	         * Request initial map bounds
	         * @param {String} destination
	         * @param {String} country
	         * @param {Object} defaultCenter
	         * @private
	         */
	        _doPreflightRequest: function _doPreflightRequest(destination, country, defaultCenter) {
	            var options = { method: 'POST' };
	            var params = {
	                destination: destination,
	                country: country,
	                fallback_lat: defaultCenter.latitude,
	                fallback_lng: defaultCenter.longitude,
	                productSearch: this._productSearch
	            };
	            if (this._map) {
	                this._map.removeMarkers();
	                this._map.setIsLoading(true);
	            }
	            this._requestHandler.cancel(this.option('preflightRoute'));
	            this._requestInProgress = true;
	            this._requestHandler.send(this.option('preflightRoute'), params, {}, options);
	        },
	
	        /**
	         * @param requestData
	         * @private
	         */
	        _onPreflightRequestCancel: function _onPreflightRequestCancel(requestData) {
	            if (requestData.route === this.option('preflightRoute')) {
	                this._requestInProgress = false;
	            }
	        },
	
	        /**
	         * Updates map viewport
	         * @param {PreflightResponseEvent} event
	         * @param requestData
	         * @private
	         */
	        _onPreflightRequestSuccess: function _onPreflightRequestSuccess(event, requestData) {
	            if (event.state !== 'OK') {
	                return;
	            }
	
	            if (requestData.route === this.option('preflightRoute') && this._requestInProgress === true) {
	                this._requestInProgress = false;
	                this._initMap(event.meta.bounds, event.meta.locations, event.meta.center, 30);
	            }
	        },
	
	        /**
	         * Loads markers on bounds or zoom change
	         * @private
	         */
	        _onBoundsZoomChanged: function _onBoundsZoomChanged() {
	            this._map.loadMarkers(this._productSearch);
	        }
	    });
	
	    return DynamicRegionMap;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 398 */,
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Created by pavelkozhin on 02/08/16.
	 */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, _) {
	
	    /**
	     * Component handles seasons data fallback when MightyC data is not there due to issue with season code.
	     *
	     * @param requestHandler
	     * @param route
	     * @param trackedRoutes
	     * @constructor
	     */
	    var SeasonFallback = function SeasonFallback(requestHandler, route, trackedRoutes) {
	        if (!requestHandler) {
	            throw new Error('Parameter \'requestHandler\' is mandatory');
	        }
	        this._requestHandler = requestHandler;
	
	        if (!_.isString(route)) {
	            throw new Error('Parameter \'route\' should be string');
	        }
	        this._route = route;
	
	        if (!_.isArray(trackedRoutes)) {
	            throw new Error('Parameter \'trackedRoutes\' should be array');
	        }
	        this._trackedRoutes = trackedRoutes;
	
	        this._defaults = {
	            itemSelector: '[data-fcse-role="accordion"] [data-fcse-role="offer-item"][data-season-fallback]',
	            itemSelectorTpl: '[data-fcse-role="accordion"] [data-fcse-role="offer-item"][data-season-fallback="@"]',
	            nameContainerSelector: '[data-fcse-role="name-container"]',
	            imageContainerSelector: '[data-fcse-role="image-container"]',
	            categoryContainerSelector: '[data-fcse-role="category-container"]',
	            locationContainerSelector: '[data-fcse-role="location-container"]'
	        };
	
	        this._init();
	    };
	
	    SeasonFallback.prototype = {
	        /**
	         * Initializes component
	         * @private
	         */
	        _init: function _init() {
	            this._requestHandler.on('start', $.proxy(this._onRequestStart, this));
	            this._requestHandler.on('success', $.proxy(this._onRequestSuccess, this));
	
	            this._requestFallback();
	        },
	
	        /**
	         * Aborts fallback request if any tracked request is started
	         * @param {Object} requestData
	         * @private
	         */
	        _onRequestStart: function _onRequestStart(requestData) {
	            if (_.indexOf(this._trackedRoutes, requestData.route) !== -1) {
	                this._requestHandler.cancel(this._route);
	            }
	        },
	
	        /**
	         * Starts fallback request on tracked route success or updates elements
	         * @param {Object} content
	         * @param {Object} requestData
	         * @private
	         */
	        _onRequestSuccess: function _onRequestSuccess(content, requestData) {
	            var self = this;
	            if (_.indexOf(this._trackedRoutes, requestData.route) !== -1) {
	                this._requestHandler.cancel(this._route);
	
	                setTimeout(function () {
	                    self._requestFallback();
	                }, 0);
	            } else if (requestData.route === this._route && content.meta && content.meta.items) {
	
	                _.each(content.meta.items, function (value, key) {
	                    var itemElement = $(self._defaults.itemSelectorTpl.replace('@', key));
	                    if (itemElement.length) {
	                        self._updateItem(itemElement, value);
	                    }
	                });
	            }
	        },
	
	        /**
	         * Does season fallback request if necessary
	         * @private
	         */
	        _requestFallback: function _requestFallback() {
	            var fallbackIds;
	            var fallbackItems = $(this._defaults.itemSelector);
	
	            if (!fallbackItems.length) {
	                return;
	            }
	            fallbackIds = [];
	
	            fallbackItems.each(function () {
	                var thisElement = $(this);
	                fallbackIds.push(thisElement.attr('data-season-fallback'));
	            });
	
	            if (fallbackIds.length) {
	                this._requestHandler.send(this._route, {}, { seasonsAndCodes: fallbackIds.join(',') });
	            }
	        },
	
	        /**
	         * Updates item content with fallback season data
	         * @param element
	         * @param {Object} fallbackData
	         * @private
	         */
	        _updateItem: function _updateItem(element, fallbackData) {
	            try {
	                if (fallbackData.name) {
	                    $(this._defaults.nameContainerSelector, element).text(fallbackData.name);
	                }
	                if (fallbackData.location) {
	                    $(this._defaults.locationContainerSelector, element).text(fallbackData.location);
	                }
	                if (fallbackData.imageUrl) {
	                    $(this._defaults.imageContainerSelector, element).find('img').attr('src', fallbackData.imageUrl);
	                }
	                if (fallbackData.category) {
	                    $(this._defaults.categoryContainerSelector, element).html(decodeURIComponent(fallbackData.categoryView));
	                }
	            } catch (e) {}
	            element.removeAttr('data-season-fallback');
	        }
	    };
	
	    return SeasonFallback;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _stringify = __webpack_require__(216);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by Pavel
	 */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, _) {
	    'use strict';
	
	    var instance = null;
	
	    var StateHandler = function StateHandler() {
	        this._handlers = [];
	        this._paramName = 'state';
	        this._state = this.getQueryState();
	    };
	
	    StateHandler.prototype = $.extend({}, {
	        queryToObject: function queryToObject(queryStr) {
	            if (queryStr && queryStr.indexOf(this._paramName)) {
	                var matches = queryStr.match(/state=[^&]+/);
	                var parts; // = queryStr.split(this._paramName + '=');
	
	                if (matches && matches.length) {
	                    parts = matches[0].split('=');
	                }
	
	                return parts && parts.length > 1 ? JSON.parse(decodeURIComponent(parts[1])) : [];
	            }
	            return null;
	        },
	        objectToQuery: function objectToQuery(obj) {
	            return obj ? this._paramName + '=' + (0, _stringify2.default)(obj) : '';
	        },
	
	        getQueryState: function getQueryState() {
	            return this.queryToObject(window.location.search);
	        },
	        /**
	         * Apply state to UI
	         */
	        applyState: function applyState() {
	            var state = this._state;
	
	            if (!state) {
	                return;
	            }
	            _.each(this._handlers, function (handler) {
	                var param = handler.getParam(),
	                    substate = state[param];
	                if (substate) {
	                    handler.applyState(substate);
	                }
	            });
	        },
	        /**
	         * Add handler
	         * @param {type} handler
	         * @returns {undefined}
	         */
	        addHandler: function addHandler(handler) {
	            handler.init();
	            this._handlers.push(handler);
	        }
	    });
	
	    var getInstance = function getInstance() {
	        return !instance ? instance = new StateHandler() : instance;
	    };
	
	    return { getInstance: getInstance };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(809);
	
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	}();

	;

/***/ }),
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Created by ivo on 06.05.14.
	 */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(165), __webpack_require__(1), __webpack_require__(810), __webpack_require__(386), __webpack_require__(273), __webpack_require__(164), __webpack_require__(222), __webpack_require__(231), __webpack_require__(71), __webpack_require__(394), __webpack_require__(299), __webpack_require__(96), __webpack_require__(400), __webpack_require__(387), __webpack_require__(255), __webpack_require__(14), __webpack_require__(399), __webpack_require__(256), __webpack_require__(92)], __WEBPACK_AMD_DEFINE_RESULT__ = function (common, $, WidgetFactory, Accordion, MultiRequestHandler, Scope, UrlHandling, CountButton, VisibilityControl, Breadcrumbs, AjaxContentLoader, LazyImage, StateHandler, AccordionStateHandler, MapModal, Url, SeasonFallback, UserSearchPrefillTracker, GtmManager) {
	    var params = {};
	    var url = new Url();
	
	    if (typeof window.productSearchParams !== 'undefined') {
	        params = window.productSearchParams;
	    }
	    // Create scopes
	    var rootScope = new Scope(null, null, null, params);
	    var localScope = new Scope(rootScope);
	    localScope.setParam('bookingType', 'hotel');
	
	    // Remove hotel related data from scope if header search used
	    if (url.query.searchField == 'search-widget') {
	        rootScope.setMultipleParams({
	            'hotelName': null,
	            'hotelId': null,
	            'giataId': null
	        });
	    }
	
	    // Create widget factory
	    var widgetFactory = new WidgetFactory({ rootScope: rootScope, localScope: localScope });
	
	    // Enable URL History
	    if (typeof history.pushState != 'undefined') {
	        UrlHandling.enableBrowserHistory(rootScope);
	    }
	
	    // Initialize MultiRequestHandler
	    var requestHandler = new MultiRequestHandler();
	
	    // Initialize BreadCrumbs
	    var breadcrumbs = new Breadcrumbs();
	
	    widgetFactory.get('destinationWidget').dispatchEvent("change");
	
	    // Remove hotel related data from scope if header search used
	    /*if (url.query.searchField == 'search-widget') {
	        rootScope.setMultipleParams({
	            'hotelName': '',
	            'hotelId': null,
	            'giataId': null
	        });
	        localScope.setMultipleParams({
	            'hotelName': '',
	            'hotelId': null,
	            'giataId': null
	        });
	    }*/
	
	    if (url.query.searchValue && url.query.hotelName && url.query.hotelId) {
	        rootScope.setMultipleParams({
	            'searchValue': url.query.searchValue,
	            'hotelName': url.query.hotelName,
	            'hotelId': url.query.hotelId
	        });
	        localScope.setMultipleParams({
	            'searchValue': url.query.searchValue,
	            'hotelName': url.query.hotelName,
	            'hotelId': url.query.hotelId
	        });
	    }
	
	    var stateHandler = StateHandler.getInstance();
	    stateHandler.addHandler(new AccordionStateHandler('ac', {
	        requestHandler: requestHandler,
	        nodeContentRoute: 'allt_frontend.hotel.destination.accordion_offers'
	    }));
	
	    // Initialize accordion
	    var accordion = new Accordion(requestHandler, rootScope, {
	        nodeContentRoute: 'allt_frontend.hotel.destination.accordion_offers',
	        nodeDetailsRoute: 'allt_frontend.hotel.destination.accordion_detail',
	        contentRoute: 'allt_frontend.hotel.destination.accordion_content'
	    });
	
	    var ajaxLoader = new AjaxContentLoader('[data-fcse-role="modal-trigger"]', rootScope, {
	        'onshow': function onshow(lightboxNode) {
	            LazyImage.loadImages(lightboxNode);
	            var visibilityControl = new VisibilityControl($('[data-fcse-role="visibility-control"]', lightboxNode), {
	                'targetIsVisibleClass': 'is-active',
	                'targetIsHiddenClass': 'is-collapsed'
	            });
	        }
	    });
	
	    // Initialize Button
	    var countButton = new CountButton(requestHandler, rootScope, '[data-fcse-role="countbutton"]', {
	        updateRoute: 'allt_frontend.hotel.update_count'
	        /* queryUpdater: function(queryParams) {
	            var hotelSearch = widgetFactory.get('searchmaskSearchWidget').getValue();
	            if (!hotelSearch.hotelName) {
	                delete queryParams['hotelId'];
	                delete queryParams['giataId'];
	                delete queryParams['hotelName'];
	                delete queryParams['searchField'];
	                delete queryParams['searchValue'];
	            } else {
	                queryParams['hotelName'] = hotelSearch.hotelName;
	                if (hotelSearch.hotelId) {
	                    queryParams['hotelId'] = hotelSearch.hotelId;
	                }
	                queryParams['searchField'] = 'searchmask-search-widget';
	                queryParams['searchValue'] = hotelSearch.hotelName;
	            }
	            return queryParams;
	        } */
	    });
	    new VisibilityControl('[data-searchmask-toggle]', {
	        'targetSelectorAttribute': 'data-searchmask-toggle',
	        'elementTargetIsVisibleClass': 'is-active',
	        'targetIsVisibleClass': 'is-toggled',
	        'targetIsHiddenClass': 'is-not-active'
	    });
	
	    // Add VisibilityControl
	    var visibilityControl = new VisibilityControl('[data-fcse-role="visibility-control"]', {
	        'targetIsVisibleClass': 'is-active',
	        'targetIsHiddenClass': 'is-collapsed'
	    });
	
	    // Update breadcrumbs on successful getting data
	    accordion.on("dataSuccess", function (data) {
	        if (data && data.meta && data.meta.breadcrumbs) {
	            breadcrumbs.update(data.meta.breadcrumbs);
	        }
	    });
	    MapModal.getInstance($('body > [data-fcse-role="map-modal"]'), requestHandler, {});
	
	    if (!_.isUndefined(url.query.showmap) && url.query.showmap == 'true') {
	        var mapOpenButton = $('[data-fcse-role="map-overlay-open-button"]:first', this.element);
	
	        if (mapOpenButton.length) {
	            mapOpenButton.click();
	        }
	    }
	
	    var seasonFallback = new SeasonFallback(requestHandler, 'allt_frontend.hotel_content_season_fallback', ['allt_frontend.package.destination.accordion_offers', 'allt_frontend.package.destination.accordion_content']);
	
	    var searchPrefill = new UserSearchPrefillTracker();
	    searchPrefill.registerScope(rootScope);
	
	    try {
	        var pageType = $('[data-gtm-page-type]').data('gtm-page-type');
	        if (!pageType) {
	            pageType = 'listingPage';
	        }
	
	        GtmManager.setOptions({ scope: rootScope, stateHandler: requestHandler }).initPageTracker('listingPage', {
	            country: $('[data-page-locale]').first().data('page-locale'),
	            pageType: pageType,
	            siteArea: 'hotelDestination'
	        });
	    } catch (e) {
	        console.log(e);
	    }
	
	    stateHandler.applyState();
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(2), __webpack_require__(177)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Object, AbstractWidgetFactory) {
	
	    var WidgetFactory = function WidgetFactory(scopes) {
	        AbstractWidgetFactory.apply(this, arguments);
	    };
	
	    WidgetFactory.prototype = $.extend(Object.create(AbstractWidgetFactory.prototype), {
	        /**
	         * An array of active widget names
	         */
	        _activeWidgets: ['travelPeriod', 'travellers', 'destination', 'priceRange', 'category', 'board', 'globalType', 'room', 'rating',
	        /*'ratingRange',*/
	        'headerSearch', 'searchmaskSearch', 'tourOperatorFilter', 'hotelSearchTagBar']
	    });
	
	    return WidgetFactory;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ })
])
});
;


// WEBPACK FOOTER //
// hotel_destination.591fa33a31e03edcb7d6.bundle.js